// @ts-nocheck
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type Scalars = {
    Any: any,
    Boolean: boolean,
    CalendarDate: string,
    CalendarDateTime: string,
    Decimal: number,
    Float: number,
    ID: string,
    Int: number,
    JSON: any,
    Map: Record<string,any>,
    SecureString: string,
    String: string,
    Time: string,
    Timezone: string,
    ZonedDateTime: string,
}

export interface AcceptCustomerInvitationResult {
    customerOrganizationId: Scalars['ID']
    customerOrganizationName: Scalars['String']
    invitation: CustomerInvitation
    success: Scalars['Boolean']
    __typename: 'AcceptCustomerInvitationResult'
}

export interface AccessURLPayload {
    expiresAt: Scalars['Time']
    url: Scalars['String']
    __typename: 'AccessURLPayload'
}

export interface Account {
    accountManagerIds: (Scalars['ID'][] | null)
    accountManagers: User[]
    addresses: AccountAddress[]
    balances: Money[]
    bills: (Bill[] | null)
    canBeInvited: Scalars['Boolean']
    contacts: Contact[]
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    defaultPurchasePaymentTerm: (PaymentTermConfig | null)
    defaultPurchasePaymentTermId: (Scalars['ID'] | null)
    defaultSalesPaymentTerm: (PaymentTermConfig | null)
    defaultSalesPaymentTermId: (Scalars['ID'] | null)
    dotNumber: (Scalars['String'] | null)
    email: (Scalars['String'] | null)
    id: Scalars['ID']
    individualDetails: (AccountIndividualDetails | null)
    insuranceExpiration: (Scalars['CalendarDate'] | null)
    invoices: (Invoice[] | null)
    linkedOrganizationId: (Scalars['ID'] | null)
    mcNumber: (Scalars['String'] | null)
    name: Scalars['String']
    notes: (Scalars['String'] | null)
    paymentSchedulePreference: (Scalars['String'] | null)
    paymentTypePreference: (Scalars['String'] | null)
    pendingTransactions: Scalars['Int']
    phone: (Scalars['String'] | null)
    primaryContact: (Contact | null)
    purchasesVolume: Money[]
    relationship: AccountRelationship
    salesVolume: Money[]
    scac: (Scalars['String'] | null)
    timestamps: Timestamps
    type: AccountType
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    w9OnFile: (Scalars['Boolean'] | null)
    website: (Scalars['String'] | null)
    __typename: 'Account'
}

export interface AccountAddress {
    account: Account
    accountId: Scalars['ID']
    address: Address
    contacts: Contact[]
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    id: Scalars['ID']
    locationType: AddressLocationType
    name: (Scalars['String'] | null)
    operatingHours: (Scalars['Map'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'AccountAddress'
}

export interface AccountAddressResultPage {
    entries: AccountAddress[]
    page: Page
    __typename: 'AccountAddressResultPage'
}

export type AccountAddressSortOption = 'CityAsc' | 'CityDesc' | 'CountryAsc' | 'CountryDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'IsMailingAsc' | 'IsMailingDesc' | 'LocationTypeAsc' | 'LocationTypeDesc' | 'StateAsc' | 'StateDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface AccountBankDetail {
    accountId: Scalars['ID']
    accountNumber: (Scalars['String'] | null)
    accountType: Scalars['String']
    bankName: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    isPrimary: Scalars['Boolean']
    nickname: (Scalars['String'] | null)
    routingNumber: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'AccountBankDetail'
}

export interface AccountBankDetailResultPage {
    entries: AccountBankDetail[]
    page: Page
    __typename: 'AccountBankDetailResultPage'
}

export type AccountBankDetailSortOption = 'BankNameAsc' | 'BankNameDesc' | 'CreatedAtAsc' | 'CreatedAtDesc'

export interface AccountIdentityDocument {
    accountIndividualDetailsId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    documentNumber: (Scalars['String'] | null)
    documentType: IdentityDocumentType
    expirationDate: (Scalars['CalendarDate'] | null)
    id: Scalars['ID']
    individualDetails: AccountIndividualDetails
    issueDate: (Scalars['CalendarDate'] | null)
    issuingState: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'AccountIdentityDocument'
}

export interface AccountIdentityDocumentResultPage {
    entries: AccountIdentityDocument[]
    page: Page
    __typename: 'AccountIdentityDocumentResultPage'
}

export type AccountIdentityDocumentSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DocumentTypeAsc' | 'DocumentTypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface AccountIndividualDetails {
    account: Account
    accountId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    dateOfBirth: (Scalars['CalendarDate'] | null)
    employer: (Scalars['String'] | null)
    eyeColor: (IndividualEyeColor | null)
    hairColor: (IndividualHairColor | null)
    height: (Scalars['Int'] | null)
    id: Scalars['ID']
    identityDocuments: AccountIdentityDocument[]
    race: (IndividualRace | null)
    sex: (IndividualSex | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    weight: (Scalars['Int'] | null)
    __typename: 'AccountIndividualDetails'
}

export interface AccountIndividualDetailsResultPage {
    entries: AccountIndividualDetails[]
    page: Page
    __typename: 'AccountIndividualDetailsResultPage'
}

export type AccountIndividualDetailsSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface AccountRelationship {
    isCarrier: Scalars['Boolean']
    isCustomer: Scalars['Boolean']
    isSupplier: Scalars['Boolean']
    __typename: 'AccountRelationship'
}

export interface AccountResultPage {
    entries: Account[]
    page: Page
    __typename: 'AccountResultPage'
}

export type AccountSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'EmailAsc' | 'EmailDesc' | 'NameAsc' | 'NameDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type AccountType = 'Commercial' | 'Individual'

export type ActionType = 'Delivery' | 'Maintenance' | 'Pickup' | 'Transfer'

export interface Address {
    addressType: AddressType
    city: Scalars['String']
    coordinates: (Coordinates | null)
    country: Scalars['String']
    isMailingAddress: Scalars['Boolean']
    postalCode: Scalars['String']
    state: Scalars['String']
    streetAddress: Scalars['String']
    streetAddress2: (Scalars['String'] | null)
    __typename: 'Address'
}

export type AddressLocationType = 'Billing' | 'Delivery' | 'Pickup' | 'Shipping' | 'Warehouse'

export type AddressType = 'NonStandard' | 'POBox' | 'Standard'

export interface AffectedLoad {
    documentNumber: Scalars['String']
    id: Scalars['ID']
    status: LoadStatus
    __typename: 'AffectedLoad'
}

export interface Agent {
    agentIdentifier: (Scalars['String'] | null)
    content: Scalars['String']
    createdById: Scalars['ID']
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    model: (Scalars['String'] | null)
    modelProvider: (ModelProvider | null)
    name: Scalars['String']
    organizationId: (Scalars['ID'] | null)
    providerApiKey: (Scalars['String'] | null)
    providerBaseUrl: (Scalars['String'] | null)
    reasoningBudget: (Scalars['Int'] | null)
    reasoningEnabled: (Scalars['Boolean'] | null)
    temperature: (Scalars['Float'] | null)
    timestamps: Timestamps
    tools: Scalars['String'][]
    type: AgentType
    version: Scalars['Int']
    __typename: 'Agent'
}

export interface AgentMetadata {
    id: Scalars['ID']
    name: Scalars['String']
    version: Scalars['Int']
    __typename: 'AgentMetadata'
}

export interface AgentResultPage {
    entries: Agent[]
    page: Page
    __typename: 'AgentResultPage'
}

export type AgentSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'VersionAsc' | 'VersionDesc'

export type AgentType = 'Agent' | 'FileProcessor' | 'SubAgent'

export interface ApprovalNode {
    approvers: ApproverConfig
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    instructions: (Scalars['String'] | null)
    label: Scalars['String']
    position: Position
    timeoutAction: (TimeoutAction | null)
    timeoutDuration: (Scalars['Int'] | null)
    timeoutEnabled: Scalars['Boolean']
    timeoutUnit: (TimeoutUnit | null)
    type: NodeType
    __typename: 'ApprovalNode'
}

export interface ApprovalRequest {
    automation: (Automation | null)
    automationId: Scalars['ID']
    comment: (Scalars['String'] | null)
    executionData: (Scalars['Map'] | null)
    executionRun: (ExecutionRun | null)
    executionRunId: Scalars['ID']
    expiresAt: (Scalars['ZonedDateTime'] | null)
    id: Scalars['ID']
    instructions: (Scalars['String'] | null)
    nodeId: Scalars['String']
    nodeLabel: Scalars['String']
    organization: Organization
    organizationId: Scalars['ID']
    requestedAt: Scalars['ZonedDateTime']
    respondedAt: (Scalars['ZonedDateTime'] | null)
    respondedBy: (Scalars['ID'] | null)
    respondedByUser: (User | null)
    status: ApprovalRequestStatus
    timestamps: Timestamps
    workflowId: Scalars['String']
    __typename: 'ApprovalRequest'
}

export interface ApprovalRequestResultPage {
    entries: ApprovalRequest[]
    page: Page
    __typename: 'ApprovalRequestResultPage'
}

export type ApprovalRequestSortOption = 'ExpiresAtAsc' | 'ExpiresAtDesc' | 'RequestedAtAsc' | 'RequestedAtDesc'

export type ApprovalRequestStatus = 'Approved' | 'Expired' | 'Pending' | 'Rejected'

export interface ApproverConfig {
    roleIds: Scalars['String'][]
    userIds: Scalars['ID'][]
    __typename: 'ApproverConfig'
}

export interface ArchiveDownloadPayload {
    /** Direct download URL for the archive (presigned, temporary) */
    downloadUrl: Scalars['String']
    /** Size of the archive in bytes (estimated) */
    estimatedSize: Scalars['Float']
    /** Expiration timestamp for the download URL */
    expiresAt: Scalars['Time']
    /** Name of the archive file */
    fileName: Scalars['String']
    __typename: 'ArchiveDownloadPayload'
}

export interface Asset {
    account: (Account | null)
    accountAddress: (AccountAddress | null)
    accountAddressId: (Scalars['ID'] | null)
    accountId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currentLocation: (Address | null)
    customAttributes: Scalars['Map']
    description: (Scalars['String'] | null)
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    fillState: AssetFillState
    id: Scalars['ID']
    identifier: Scalars['String']
    lastLocationTime: (Scalars['ZonedDateTime'] | null)
    locationHistory: AssetLocationHistory[]
    notes: (Scalars['String'] | null)
    status: AssetStatus
    tareWeight: (Weight | null)
    timestamps: Timestamps
    type: AssetType
    typeId: Scalars['ID']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Asset'
}

export type AssetFillState = 'Empty' | 'Full' | 'Unknown'

export interface AssetLocationHistory {
    asset: Asset
    assetId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    source: Scalars['String']
    timestamp: Scalars['ZonedDateTime']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'AssetLocationHistory'
}

export interface AssetLocationHistoryResultPage {
    entries: AssetLocationHistory[]
    page: Page
    __typename: 'AssetLocationHistoryResultPage'
}

export type AssetLocationHistorySortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'SourceAsc' | 'SourceDesc' | 'TimestampAsc' | 'TimestampDesc'

export interface AssetResultPage {
    entries: Asset[]
    page: Page
    __typename: 'AssetResultPage'
}

export type AssetSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'FillStateAsc' | 'FillStateDesc' | 'IdentifierAsc' | 'IdentifierDesc' | 'LastLocationTimeAsc' | 'LastLocationTimeDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type AssetStatus = 'Deployed' | 'InTransit' | 'Inventory' | 'OutOfOrder'

export interface AssetType {
    capacity: Scalars['Float']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: Scalars['String']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'AssetType'
}

export interface AssetTypeResultPage {
    entries: AssetType[]
    page: Page
    __typename: 'AssetTypeResultPage'
}

export type AssetTypeSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type AssignmentStatus = 'Accepted' | 'Offered' | 'Rejected' | 'Released' | 'Unassigned'

export interface AssistantAgentStreamEvent {
    chatId: Scalars['ID']
    content: Scalars['String']
    conversationTitle: (Scalars['String'] | null)
    error: (Scalars['String'] | null)
    issuedAt: Scalars['ZonedDateTime']
    metadata: (Scalars['Map'] | null)
    thinkingStep: Scalars['String']
    /** @deprecated Use AssistantChatMessage parts instead */
    toolCall: (ToolCall | null)
    type: AssistantAgentStreamEventType
    __typename: 'AssistantAgentStreamEvent'
}

export type AssistantAgentStreamEventType = 'Complete' | 'ConversationTitle' | 'Error' | 'Message' | 'Thinking' | 'ToolCall' | 'ToolResult'

export type AssistantAggregateType = 'Chat' | 'ChatMessage'

export interface AssistantChat {
    agent: (AgentMetadata | null)
    agentId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    isShared: Scalars['Boolean']
    messages: AssistantChatMessage[]
    organizationId: Scalars['ID']
    shareLink: (AssistantChatShareLink | null)
    status: AssistantChatStatus
    timestamps: Timestamps
    title: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    userId: Scalars['ID']
    __typename: 'AssistantChat'
}

export interface AssistantChatMessage {
    agent: (AgentMetadata | null)
    agentId: (Scalars['ID'] | null)
    chatId: Scalars['ID']
    createdAt: Scalars['ZonedDateTime']
    id: Scalars['ID']
    parts: AssistantChatMessagePart[]
    role: AssistantChatMessageRole
    __typename: 'AssistantChatMessage'
}

export interface AssistantChatMessagePart {
    data: (Scalars['Map'] | null)
    dataType: (Scalars['String'] | null)
    errorText: (Scalars['String'] | null)
    filename: (Scalars['String'] | null)
    id: Scalars['ID']
    input: (Scalars['Map'] | null)
    mediaType: (Scalars['String'] | null)
    output: (Scalars['Map'] | null)
    providerExecuted: (Scalars['Boolean'] | null)
    providerMetadata: (Scalars['Map'] | null)
    sequence: Scalars['Int']
    sourceId: (Scalars['String'] | null)
    state: (Scalars['String'] | null)
    text: (Scalars['String'] | null)
    title: (Scalars['String'] | null)
    toolCallId: (Scalars['String'] | null)
    toolCallState: (AssistantToolCallState | null)
    toolName: (Scalars['String'] | null)
    type: AssistantChatMessagePartType
    url: (Scalars['String'] | null)
    __typename: 'AssistantChatMessagePart'
}

export type AssistantChatMessagePartType = 'Data' | 'DynamicTool' | 'File' | 'Reasoning' | 'SourceDocument' | 'SourceUrl' | 'StepStart' | 'Text' | 'ToolCall'

export type AssistantChatMessageRole = 'Assistant' | 'System' | 'User'

export interface AssistantChatResultPage {
    entries: AssistantChat[]
    page: Page
    __typename: 'AssistantChatResultPage'
}

export interface AssistantChatShareLink {
    chatId: Scalars['ID']
    createdAt: Scalars['ZonedDateTime']
    id: Scalars['ID']
    token: Scalars['String']
    __typename: 'AssistantChatShareLink'
}

export type AssistantChatSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'CreatedByAsc' | 'CreatedByDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'UpdatedByAsc' | 'UpdatedByDesc'

export type AssistantChatStatus = 'Active' | 'Archived'

export interface AssistantOutboxEventCounts {
    chat: Scalars['Int']
    chatMessage: Scalars['Int']
    __typename: 'AssistantOutboxEventCounts'
}

export type AssistantToolCallState = 'InputAvailable' | 'InputStreaming' | 'OutputAvailable' | 'OutputError'

export interface Attachment {
    bookingId: Scalars['ID']
    confirmed: Scalars['Boolean']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    type: AttachmentType
    uploadUrl: Scalars['String']
    url: Scalars['String']
    __typename: 'Attachment'
}

export type AttachmentType = 'Image' | 'Pdf' | 'Text'


/** Information about the user who initiated an impersonation session */
export interface AuthenticationImpersonator {
    email: Scalars['String']
    reason: (Scalars['String'] | null)
    __typename: 'AuthenticationImpersonator'
}


/**
 * Organization details available during the authentication process.
 * Uses WorkOS organization IDs (strings) since this is before full authentication.
 */
export interface AuthenticationOrganization {
    id: Scalars['String']
    name: Scalars['String']
    __typename: 'AuthenticationOrganization'
}


/** Response returned upon successful authentication containing the access token and user information */
export interface AuthenticationResponse {
    accessToken: Scalars['String']
    impersonator: (AuthenticationImpersonator | null)
    organization: Organization
    user: User
    __typename: 'AuthenticationResponse'
}


/** Represents all possible outcomes of an authentication attempt */
export type AuthenticationResult = (AuthenticationResponse | EmailVerificationRequiredError | InvalidCredentialsError | InvalidOneTimeCode | MfaChallengeError | MfaEnrollmentRequiredError | OneTimeCodeExpired | OrganizationSelectionError | SsoRequiredError) & { __isUnion?: true }

export interface Automation {
    createdBy: Scalars['ID']
    createdByUser: User
    description: (Scalars['String'] | null)
    edges: Edge[]
    id: Scalars['ID']
    name: Scalars['String']
    nodes: Node[]
    organization: Organization
    organizationId: Scalars['ID']
    status: AutomationStatus
    timestamps: Timestamps
    triggerConfig: TriggerConfig
    triggerType: TriggerType
    updatedBy: Scalars['ID']
    updatedByUser: User
    webhookEndpoint: (WebhookEndpoint | null)
    workflowId: (Scalars['String'] | null)
    workflowRunId: (Scalars['String'] | null)
    __typename: 'Automation'
}

export interface AutomationBulkOperationResult {
    failedCount: Scalars['Int']
    failedIds: Scalars['ID'][]
    successCount: Scalars['Int']
    __typename: 'AutomationBulkOperationResult'
}

export interface AutomationDeleteResult {
    deleted: Scalars['Boolean']
    __typename: 'AutomationDeleteResult'
}

export interface AutomationResultPage {
    entries: Automation[]
    page: Page
    __typename: 'AutomationResultPage'
}

export type AutomationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type AutomationStatus = 'Active' | 'Archived' | 'Draft' | 'Paused'

export interface AutomationVersion {
    automationId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: (Scalars['String'] | null)
    flowSnapshot: (Scalars['JSON'] | null)
    id: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    versionNumber: Scalars['Int']
    __typename: 'AutomationVersion'
}

export interface AutomationVersionResultPage {
    entries: AutomationVersion[]
    page: Page
    __typename: 'AutomationVersionResultPage'
}

export type AutomationVersionSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'VersionNumberAsc' | 'VersionNumberDesc'

export interface Bill {
    account: Account
    amount: Money
    compliance: BillComplianceRule[]
    documentDate: Scalars['CalendarDate']
    documentNumber: Scalars['String']
    dueDate: (Scalars['CalendarDate'] | null)
    eligibleAt: (Scalars['CalendarDate'] | null)
    facility: Facility
    id: Scalars['ID']
    lineItems: BillLineItem[]
    notes: (Scalars['String'] | null)
    openAmount: Money
    paymentTerm: PaymentTerm
    paymentTermEntity: (PaymentTermConfig | null)
    payments: Payment[]
    preferredPaymentMethod: PaymentMethod
    scaleTicketId: (Scalars['ID'] | null)
    status: BillStatus
    timestamps: Timestamps
    type: BillType
    __typename: 'Bill'
}

export type BillComplianceRule = 'LegalHold' | 'TaxHold'

export interface BillEntityReference {
    entityId: Scalars['ID']
    entityType: BillEntityReferenceType
    __typename: 'BillEntityReference'
}

export type BillEntityReferenceType = 'Booking' | 'InboundLoad' | 'InboundLoadLineItem' | 'TicketFreight'

export interface BillLineItem {
    description: Scalars['String']
    groupName: (Scalars['String'] | null)
    id: Scalars['ID']
    item: (Item | null)
    itemId: (Scalars['ID'] | null)
    quantity: Scalars['Decimal']
    sortOrder: Scalars['Int']
    sourceReference: (BillEntityReference | null)
    timestamps: Timestamps
    totalPrice: Money
    unit: Scalars['String']
    unitPrice: Money
    __typename: 'BillLineItem'
}

export interface BillPaymentApplication {
    appliedAmount: Money
    appliedAt: Scalars['ZonedDateTime']
    bill: Bill
    __typename: 'BillPaymentApplication'
}

export interface BillResultPage {
    entries: Bill[]
    page: Page
    __typename: 'BillResultPage'
}

export type BillSortOption = 'AccountAsc' | 'AccountDesc' | 'AmountAsc' | 'AmountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'DocumentDateAsc' | 'DocumentDateDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type BillStatus = 'Paid' | 'Pending' | 'Voided'

export interface BillStatusCounts {
    paid: Scalars['Int']
    pending: Scalars['Int']
    voided: Scalars['Int']
    __typename: 'BillStatusCounts'
}

export type BillType = 'Accrual' | 'FreightBill' | 'InboundBill' | 'OutboundBill'

export interface Booking {
    containerInstanceCounts: ContainerStatusCounts
    containerInstances: Container[]
    containers: BookingContainer[]
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    cutOffDate: (Scalars['CalendarDate'] | null)
    destinationPort: (Port | null)
    destinationPortId: (Scalars['ID'] | null)
    documentNumber: Scalars['String']
    dropoffTerminal: (Terminal | null)
    dropoffTerminalId: (Scalars['ID'] | null)
    earlyReturnDate: (Scalars['CalendarDate'] | null)
    externalNotes: (Scalars['String'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    files: File[]
    id: Scalars['ID']
    internalNotes: (Scalars['String'] | null)
    loadStatusSummary: BookingLoadStatusSummary
    loadingPort: (Port | null)
    loadingPortId: (Scalars['ID'] | null)
    oceanFreight: (Scalars['String'] | null)
    organization: Organization
    organizationId: Scalars['ID']
    photoRequirements: PhotoRequirement[]
    pickupTerminal: (Terminal | null)
    pickupTerminalId: (Scalars['ID'] | null)
    salesOrders: SalesOrder[]
    status: BookingStatus
    steamshipLine: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    vesselArrivalDate: (Scalars['CalendarDate'] | null)
    vesselDepartureDate: (Scalars['CalendarDate'] | null)
    vesselName: (Scalars['String'] | null)
    __typename: 'Booking'
}

export interface BookingContainer {
    containerType: ContainerType
    quantity: Scalars['Int']
    __typename: 'BookingContainer'
}

export interface BookingFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'BookingFileCreatePayload'
}

export interface BookingLoadStatusSummary {
    allReceived: Scalars['Boolean']
    allReconciled: Scalars['Boolean']
    allShipped: Scalars['Boolean']
    received: Scalars['Int']
    reconciled: Scalars['Int']
    shipped: Scalars['Int']
    total: Scalars['Int']
    __typename: 'BookingLoadStatusSummary'
}

export interface BookingResultPage {
    entries: Booking[]
    page: Page
    __typename: 'BookingResultPage'
}

export type BookingSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'CreatedByAsc' | 'CreatedByDesc' | 'CutOffDateAsc' | 'CutOffDateDesc' | 'DocumentNumberAsc' | 'DocumentNumberDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'UpdatedByAsc' | 'UpdatedByDesc' | 'VesselDepartureDateAsc' | 'VesselDepartureDateDesc'

export type BookingStatus = 'Completed' | 'Draft' | 'Open' | 'Shipped' | 'Voided'

export interface BookingStatusCounts {
    completed: Scalars['Int']
    draft: Scalars['Int']
    open: Scalars['Int']
    shipped: Scalars['Int']
    voided: Scalars['Int']
    __typename: 'BookingStatusCounts'
}

export interface BookingUpdateResult {
    blockingLoads: (AffectedLoad[] | null)
    booking: (Booking | null)
    removedSalesOrderId: (Scalars['ID'] | null)
    requiresConfirmation: Scalars['Boolean']
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'BookingUpdateResult'
}

export interface BrokeredOrder {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customers: Account[]
    id: Scalars['ID']
    lineItems: BrokeredOrderLineItem[]
    margin: (Money | null)
    marginPercent: (Scalars['Decimal'] | null)
    notes: (Scalars['String'] | null)
    orderNumber: Scalars['String']
    purchaseOrders: PurchaseOrder[]
    purchaseTotal: (Money | null)
    salesOrders: SalesOrder[]
    salesTotal: (Money | null)
    status: BrokeredOrderStatus
    suppliers: Account[]
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'BrokeredOrder'
}

export interface BrokeredOrderLineItem {
    brokeredOrder: BrokeredOrder
    brokeredOrderId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    item: (Item | null)
    itemId: Scalars['ID']
    margin: (Money | null)
    marginPercent: (Scalars['Decimal'] | null)
    notes: (Scalars['String'] | null)
    purchaseTotal: (Money | null)
    purchaseUnitPrice: (Money | null)
    quantity: Scalars['Decimal']
    salesTotal: (Money | null)
    salesUnitPrice: (Money | null)
    timestamps: Timestamps
    unit: Unit
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'BrokeredOrderLineItem'
}

export interface BrokeredOrderLineItemResultPage {
    entries: BrokeredOrderLineItem[]
    page: Page
    __typename: 'BrokeredOrderLineItemResultPage'
}

export type BrokeredOrderLineItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface BrokeredOrderResultPage {
    entries: BrokeredOrder[]
    page: Page
    __typename: 'BrokeredOrderResultPage'
}

export type BrokeredOrderSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'OrderNumberAsc' | 'OrderNumberDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type BrokeredOrderStatus = 'Closed' | 'Draft' | 'Fulfilled' | 'InProgress' | 'Open' | 'Voided'

export interface BrokeredOrderValidationError {
    code: Scalars['String']
    itemId: (Scalars['ID'] | null)
    message: Scalars['String']
    __typename: 'BrokeredOrderValidationError'
}

export interface BrokeredOrderValidationResult {
    errors: BrokeredOrderValidationError[]
    valid: Scalars['Boolean']
    __typename: 'BrokeredOrderValidationResult'
}

export interface BulkOperationResult {
    failedCount: Scalars['Int']
    failedIds: Scalars['ID'][]
    successCount: Scalars['Int']
    __typename: 'BulkOperationResult'
}

export interface BulkPaymentResult {
    failedCount: Scalars['Int']
    results: PaymentItemResult[]
    successCount: Scalars['Int']
    __typename: 'BulkPaymentResult'
}

export interface BulkVoidBookingResult {
    failedCount: Scalars['Int']
    results: VoidBookingItemResult[]
    successCount: Scalars['Int']
    __typename: 'BulkVoidBookingResult'
}

export interface BulkVoidLoadResult {
    failedCount: Scalars['Int']
    failedIds: Scalars['ID'][]
    successCount: Scalars['Int']
    __typename: 'BulkVoidLoadResult'
}

export interface BulkVoidSalesOrderResult {
    failedCount: Scalars['Int']
    results: VoidSalesOrderItemResult[]
    successCount: Scalars['Int']
    __typename: 'BulkVoidSalesOrderResult'
}

export interface BusinessEventTriggerConfigOutput {
    entityType: Scalars['String']
    eventCase: Scalars['String']
    filterExpression: (Scalars['String'] | null)
    __typename: 'BusinessEventTriggerConfigOutput'
}

export interface BusinessEventTriggerNode {
    description: (Scalars['String'] | null)
    eventType: Scalars['String']
    filter: (Scalars['Map'] | null)
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    type: NodeType
    __typename: 'BusinessEventTriggerNode'
}

export interface CalculatedRecipeItem {
    isNoCost: Scalars['Boolean']
    isPrimary: Scalars['Boolean']
    item: Item
    itemId: Scalars['ID']
    quantity: Scalars['Decimal']
    quantityUnit: Unit
    __typename: 'CalculatedRecipeItem'
}

export interface CalculatedRecipeResult {
    inputs: CalculatedRecipeItem[]
    outputs: CalculatedRecipeItem[]
    __typename: 'CalculatedRecipeResult'
}

export type CalculationDirection = 'FromInputs' | 'FromOutputs'

export interface Camera {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    driverType: Scalars['String']
    firmwareVersion: (Scalars['String'] | null)
    hasFloodlight: Scalars['Boolean']
    hasPtz: Scalars['Boolean']
    hasSiren: Scalars['Boolean']
    id: Scalars['ID']
    initialized: Scalars['Boolean']
    ipAddress: (Scalars['String'] | null)
    lastSeenAt: (Scalars['ZonedDateTime'] | null)
    manufacturer: (Scalars['String'] | null)
    model: (Scalars['String'] | null)
    name: Scalars['String']
    online: Scalars['Boolean']
    passwordDecrypted: (Scalars['String'] | null)
    sidecar: (Sidecar | null)
    sidecarId: Scalars['ID']
    snapshotUrl: (Scalars['String'] | null)
    status: CameraStatus
    streamProfile: Scalars['String']
    streamUrl: (Scalars['String'] | null)
    timestamps: Timestamps
    uniqueId: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    username: (Scalars['String'] | null)
    __typename: 'Camera'
}

export interface CameraResultPage {
    entries: Camera[]
    page: Page
    __typename: 'CameraResultPage'
}

export type CameraSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DriverTypeAsc' | 'DriverTypeDesc' | 'NameAsc' | 'NameDesc' | 'StatusAsc' | 'StatusDesc'

export type CameraStatus = 'Configured' | 'Discovered'

export interface Category {
    attributes: Scalars['JSON']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: Scalars['String']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Category'
}

export interface CategoryResultPage {
    entries: Category[]
    page: Page
    __typename: 'CategoryResultPage'
}

export type CategorySortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DescriptionAsc' | 'DescriptionDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface CheckTemplate {
    checkFont: (Scalars['String'] | null)
    checkFontSize: (Scalars['Int'] | null)
    checkLayout: Scalars['String']
    checkType: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    displayAccountNumber: Scalars['Boolean']
    displayAmount: Scalars['Boolean']
    displayAmountWords: Scalars['Boolean']
    displayBankInfo: Scalars['Boolean']
    displayCheckNumber: Scalars['Boolean']
    displayCompanyAddress: Scalars['Boolean']
    displayCompanyName: Scalars['Boolean']
    displayCompanyPhone: Scalars['Boolean']
    displayDate: Scalars['Boolean']
    displayMemo: Scalars['Boolean']
    displayMicr: Scalars['Boolean']
    displayPayeeAddress: Scalars['Boolean']
    displayPayeeName: Scalars['Boolean']
    displaySecondSignature: Scalars['Boolean']
    displaySignature: Scalars['Boolean']
    facilityId: Scalars['ID']
    financialAccountId: Scalars['ID']
    id: Scalars['ID']
    maxAmountSecondSignature: (Scalars['Decimal'] | null)
    minAmountSignature: (Scalars['Decimal'] | null)
    secondSignatureId: (Scalars['ID'] | null)
    signatureId: (Scalars['ID'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'CheckTemplate'
}

export interface CheckTemplateResultPage {
    entries: CheckTemplate[]
    page: Page
    __typename: 'CheckTemplateResultPage'
}

export type CheckTemplateSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ComplianceCheck {
    accountId: (Scalars['ID'] | null)
    checkedAt: Scalars['ZonedDateTime']
    checkedByUserId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    notes: (Scalars['String'] | null)
    overriddenAt: (Scalars['ZonedDateTime'] | null)
    overriddenByUserId: (Scalars['ID'] | null)
    overrideReason: (Scalars['String'] | null)
    purchaseLoadId: Scalars['ID']
    results: (Scalars['Map'] | null)
    status: ComplianceCheckStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceCheck'
}

export interface ComplianceCheckResultItem {
    category: Scalars['String']
    enforcementLevel: Scalars['String']
    message: Scalars['String']
    passed: Scalars['Boolean']
    ruleCode: Scalars['String']
    ruleName: Scalars['String']
    __typename: 'ComplianceCheckResultItem'
}

export interface ComplianceCheckResultPage {
    entries: ComplianceCheck[]
    page: Page
    __typename: 'ComplianceCheckResultPage'
}

export type ComplianceCheckSortOption = 'CheckedAtAsc' | 'CheckedAtDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'StatusAsc' | 'StatusDesc'

export type ComplianceCheckStatus = 'Failed' | 'Overridden' | 'Passed' | 'Warning'

export interface ComplianceDispatchImage {
    category: DispatchImageCategory
    complianceDispatchRecord: (ComplianceDispatchRecord | null)
    complianceDispatchRecordId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    externalId: (Scalars['String'] | null)
    fileId: Scalars['ID']
    fileType: Scalars['String']
    id: Scalars['ID']
    status: DispatchImageStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceDispatchImage'
}

export interface ComplianceDispatchImageResultPage {
    entries: ComplianceDispatchImage[]
    page: Page
    __typename: 'ComplianceDispatchImageResultPage'
}

export type ComplianceDispatchImageSortOption = 'CategoryAsc' | 'CategoryDesc' | 'StatusAsc' | 'StatusDesc'

export interface ComplianceDispatchRecord {
    batchId: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    dispatchType: Scalars['String']
    errorMessage: (Scalars['String'] | null)
    errorType: DispatchErrorType
    externalReferenceId: (Scalars['String'] | null)
    facility: (Facility | null)
    facilityId: Scalars['ID']
    governmentReportingConfiguration: (GovernmentReportingConfiguration | null)
    governmentReportingConfigurationId: Scalars['ID']
    id: Scalars['ID']
    isRetriable: Scalars['Boolean']
    maxRetryCount: Scalars['Int']
    nextRetryAt: (Scalars['ZonedDateTime'] | null)
    payload: (Scalars['Map'] | null)
    purchaseLoad: (PurchaseLoad | null)
    purchaseLoadId: Scalars['ID']
    retryCount: Scalars['Int']
    status: DispatchRecordStatus
    submittedAt: (Scalars['ZonedDateTime'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceDispatchRecord'
}

export interface ComplianceDispatchRecordResultPage {
    entries: ComplianceDispatchRecord[]
    page: Page
    __typename: 'ComplianceDispatchRecordResultPage'
}

export type ComplianceDispatchRecordSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'StatusAsc' | 'StatusDesc' | 'SubmittedAtAsc' | 'SubmittedAtDesc'

export type ComplianceEnforcementLevel = 'Informational' | 'Required' | 'Warning'

export interface ComplianceEvaluationResult {
    holdDetails: (ComplianceHoldEvaluation | null)
    holdRequired: Scalars['Boolean']
    results: ComplianceCheckResultItem[]
    status: ComplianceCheckStatus
    __typename: 'ComplianceEvaluationResult'
}

export interface ComplianceFacilityRule {
    applicableCategoryIds: (Scalars['Map'] | null)
    configuredValue: (Scalars['Map'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    effectiveFrom: (Scalars['ZonedDateTime'] | null)
    effectiveTo: (Scalars['ZonedDateTime'] | null)
    facility: (Facility | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    isEnabled: Scalars['Boolean']
    notes: (Scalars['String'] | null)
    ruleDefinition: (ComplianceRuleDefinition | null)
    ruleDefinitionId: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceFacilityRule'
}

export interface ComplianceFacilityRuleResultPage {
    entries: ComplianceFacilityRule[]
    page: Page
    __typename: 'ComplianceFacilityRuleResultPage'
}

export type ComplianceFacilityRuleSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface ComplianceHold {
    accountId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    exemptionReason: HoldExemptionReason
    holdDays: Scalars['Int']
    holdEnd: Scalars['ZonedDateTime']
    holdStart: Scalars['ZonedDateTime']
    id: Scalars['ID']
    jurisdictionCode: (Scalars['String'] | null)
    maxImmediateCash: (Scalars['Decimal'] | null)
    notes: (Scalars['String'] | null)
    purchaseLoadId: Scalars['ID']
    releasedAt: (Scalars['ZonedDateTime'] | null)
    releasedByUserId: (Scalars['ID'] | null)
    status: ComplianceHoldStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceHold'
}

export interface ComplianceHoldEvaluation {
    exemptionReason: ComplianceHoldExemptionReason
    holdDays: Scalars['Int']
    holdEnd: Scalars['ZonedDateTime']
    maxImmediateCash: Scalars['Decimal']
    __typename: 'ComplianceHoldEvaluation'
}

export type ComplianceHoldExemptionReason = 'FrequentSeller' | 'ManuallyChecked' | 'None' | 'SmallTransaction'

export interface ComplianceHoldResultPage {
    entries: ComplianceHold[]
    page: Page
    __typename: 'ComplianceHoldResultPage'
}

export type ComplianceHoldSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'HoldEndAsc' | 'HoldEndDesc' | 'HoldStartAsc' | 'HoldStartDesc' | 'StatusAsc' | 'StatusDesc'

export type ComplianceHoldStatus = 'Active' | 'Extended' | 'PoliceFlagged' | 'Released'

export interface ComplianceItemJurisdictionCode {
    code: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    isReportable: Scalars['Boolean']
    item: (Item | null)
    itemId: Scalars['ID']
    serviceType: GovernmentReportingServiceType
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceItemJurisdictionCode'
}

export interface ComplianceItemJurisdictionCodeResultPage {
    entries: ComplianceItemJurisdictionCode[]
    page: Page
    __typename: 'ComplianceItemJurisdictionCodeResultPage'
}

export type ComplianceItemJurisdictionCodeSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type ComplianceRuleAppliesTo = 'Facility' | 'Item' | 'Supplier' | 'Transaction' | 'Vehicle'

export type ComplianceRuleCategory = 'CatalyticConverterVehicle' | 'CustomForm' | 'EnvironmentalPermit' | 'IDThreshold' | 'ItemRestriction' | 'JurisdictionSpecific' | 'LawEnforcement' | 'PaymentRestriction' | 'PhotoSignature' | 'RecordRetention' | 'SellerIdentification' | 'TransactionLimit' | 'VehicleDocumentation'

export type ComplianceRuleDataType = 'Boolean' | 'Decimal' | 'Duration' | 'Integer' | 'Money' | 'Select' | 'String' | 'Weight'

export interface ComplianceRuleDefinition {
    allowedValues: (Scalars['Map'] | null)
    appliesTo: ComplianceRuleAppliesTo
    category: ComplianceRuleCategory
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    dataType: ComplianceRuleDataType
    defaultValue: (Scalars['Map'] | null)
    description: (Scalars['String'] | null)
    enforcementLevel: ComplianceEnforcementLevel
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    isSystem: Scalars['Boolean']
    jurisdictionCode: (Scalars['String'] | null)
    name: Scalars['String']
    ruleCode: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ComplianceRuleDefinition'
}

export interface ComplianceRuleDefinitionResultPage {
    entries: ComplianceRuleDefinition[]
    page: Page
    __typename: 'ComplianceRuleDefinitionResultPage'
}

export type ComplianceRuleDefinitionSortOption = 'CategoryAsc' | 'CategoryDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'RuleCodeAsc' | 'RuleCodeDesc'

export interface ConditionNode {
    description: (Scalars['String'] | null)
    expression: Scalars['String']
    falseBranchLabel: (Scalars['String'] | null)
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    trueBranchLabel: (Scalars['String'] | null)
    type: NodeType
    __typename: 'ConditionNode'
}

export interface Contact {
    account: (Account | null)
    accountId: Scalars['ID']
    address: (AccountAddress | null)
    addressAs: Scalars['String']
    addressId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    department: (Scalars['String'] | null)
    email: (Scalars['String'] | null)
    fullName: Scalars['String']
    id: Scalars['ID']
    isPrimary: Scalars['Boolean']
    notes: (Scalars['String'] | null)
    owner: (User | null)
    ownerUserId: (Scalars['ID'] | null)
    phone: (Scalars['String'] | null)
    prefix: (Scalars['String'] | null)
    role: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    user: (User | null)
    userId: (Scalars['ID'] | null)
    __typename: 'Contact'
}

export interface ContactResultPage {
    entries: Contact[]
    page: Page
    __typename: 'ContactResultPage'
}

export type ContactSortOption = 'AddressAsAsc' | 'AddressAsDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'EmailAsc' | 'EmailDesc' | 'FullNameAsc' | 'FullNameDesc' | 'IsPrimaryAsc' | 'IsPrimaryDesc' | 'RoleAsc' | 'RoleDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'


/** The type of contact */
export type ContactType = 'external' | 'internal'

export interface Container {
    arrivedAtFacilityAt: (Scalars['ZonedDateTime'] | null)
    booking: Booking
    bookingId: Scalars['ID']
    containerNumber: (Scalars['String'] | null)
    containerType: (ContainerType | null)
    containerTypeId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    departedFacilityAt: (Scalars['ZonedDateTime'] | null)
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    id: Scalars['ID']
    load: (Load | null)
    loadId: (Scalars['ID'] | null)
    loadedAt: (Scalars['ZonedDateTime'] | null)
    organization: Organization
    organizationId: Scalars['ID']
    pickedUpAt: (Scalars['ZonedDateTime'] | null)
    returnedToPortAt: (Scalars['ZonedDateTime'] | null)
    sealNumber: (Scalars['String'] | null)
    shippedAt: (Scalars['ZonedDateTime'] | null)
    status: ContainerStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Container'
}

export interface ContainerResultPage {
    entries: Container[]
    page: Page
    __typename: 'ContainerResultPage'
}

export type ContainerSortOption = 'ArrivedAtFacilityAsc' | 'ArrivedAtFacilityDesc' | 'ContainerNumberAsc' | 'ContainerNumberDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'PickedUpAtAsc' | 'PickedUpAtDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type ContainerStatus = 'AtFacilityEmpty' | 'AtFacilityLoaded' | 'AtPort' | 'AtPortReadyToShip' | 'InTransitToFacility' | 'InTransitToPort' | 'Shipped' | 'Voided'

export interface ContainerStatusCounts {
    atFacilityEmpty: Scalars['Int']
    atFacilityLoaded: Scalars['Int']
    atPort: Scalars['Int']
    atPortReadyToShip: Scalars['Int']
    inTransitToFacility: Scalars['Int']
    inTransitToPort: Scalars['Int']
    shipped: Scalars['Int']
    total: Scalars['Int']
    voided: Scalars['Int']
    __typename: 'ContainerStatusCounts'
}

export interface ContainerType {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ContainerType'
}

export interface ContainerTypeResultPage {
    entries: ContainerType[]
    page: Page
    __typename: 'ContainerTypeResultPage'
}

export type ContainerTypeSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface Coordinates {
    latitude: Scalars['Decimal']
    longitude: Scalars['Decimal']
    __typename: 'Coordinates'
}

export type CoreAggregateType = 'Facility' | 'FacilityGroup' | 'Organization' | 'User'

export interface CoreOutboxEventCounts {
    facility: Scalars['Int']
    facilityGroup: Scalars['Int']
    organization: Scalars['Int']
    user: Scalars['Int']
    __typename: 'CoreOutboxEventCounts'
}

export interface CounterpartyGroup {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    memberCount: Scalars['Int']
    name: Scalars['String']
    operationType: OperationType
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedById: (Scalars['ID'] | null)
    updatedByUser: (User | null)
    __typename: 'CounterpartyGroup'
}

export interface CounterpartyGroupMember {
    accountId: Scalars['ID']
    addedById: Scalars['ID']
    counterpartyGroupId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'CounterpartyGroupMember'
}

export interface CounterpartyGroupMemberResultPage {
    entries: CounterpartyGroupMember[]
    page: Page
    __typename: 'CounterpartyGroupMemberResultPage'
}

export type CounterpartyGroupMemberSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface CounterpartyGroupResultPage {
    entries: CounterpartyGroup[]
    page: Page
    __typename: 'CounterpartyGroupResultPage'
}

export type CounterpartyGroupSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'OperationTypeAsc' | 'OperationTypeDesc'


/** Result of creating a conversation */
export interface CreateConversationResult {
    conversationId: Scalars['String']
    participants: UserContact[]
    __typename: 'CreateConversationResult'
}

export interface CreateFileError {
    message: Scalars['String']
    __typename: 'CreateFileError'
}

export interface CreateFilePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'CreateFilePayload'
}

export type CreateFileResult = (CreateFileError | CreateFileSuccess) & { __isUnion?: true }

export interface CreateFileSuccess {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'CreateFileSuccess'
}

export interface CreateFilesPayload {
    failed: CreateFileError[]
    succeeded: CreateFileSuccess[]
    __typename: 'CreateFilesPayload'
}

export type CreatorPlatform = 'Kiosk' | 'Mobile' | 'Tablet' | 'Unknown' | 'Web'

export type CrmAggregateType = 'Account' | 'AccountAddress' | 'Contact' | 'CustomerInvitation'

export interface CrmOutboxEventCounts {
    account: Scalars['Int']
    accountAddress: Scalars['Int']
    contact: Scalars['Int']
    customerInvitation: Scalars['Int']
    __typename: 'CrmOutboxEventCounts'
}

export type CurrencyCode = 'AED' | 'AFN' | 'ALL' | 'AMD' | 'ANG' | 'AOA' | 'ARS' | 'AUD' | 'AWG' | 'AZN' | 'BAM' | 'BBD' | 'BDT' | 'BGN' | 'BHD' | 'BIF' | 'BMD' | 'BND' | 'BOB' | 'BRL' | 'BSD' | 'BTN' | 'BWP' | 'BYN' | 'BZD' | 'CAD' | 'CDF' | 'CHF' | 'CLP' | 'CNY' | 'COP' | 'CRC' | 'CUC' | 'CUP' | 'CVE' | 'CZK' | 'DJF' | 'DKK' | 'DOP' | 'DZD' | 'EGP' | 'ERN' | 'ETB' | 'EUR' | 'FJD' | 'FKP' | 'GBP' | 'GEL' | 'GHS' | 'GIP' | 'GMD' | 'GNF' | 'GTQ' | 'GYD' | 'HKD' | 'HNL' | 'HRK' | 'HTG' | 'HUF' | 'IDR' | 'ILS' | 'INR' | 'IQD' | 'IRR' | 'ISK' | 'JMD' | 'JOD' | 'JPY' | 'KES' | 'KGS' | 'KHR' | 'KMF' | 'KPW' | 'KRW' | 'KWD' | 'KYD' | 'KZT' | 'LAK' | 'LBP' | 'LKR' | 'LRD' | 'LSL' | 'LYD' | 'MAD' | 'MDL' | 'MGA' | 'MKD' | 'MMK' | 'MNT' | 'MOP' | 'MRU' | 'MUR' | 'MVR' | 'MWK' | 'MXN' | 'MYR' | 'MZN' | 'NAD' | 'NEUTRAL' | 'NGN' | 'NIO' | 'NOK' | 'NPR' | 'NZD' | 'OMR' | 'PAB' | 'PEN' | 'PGK' | 'PHP' | 'PKR' | 'PLN' | 'PYG' | 'QAR' | 'RON' | 'RSD' | 'RUB' | 'RWF' | 'SAR' | 'SBD' | 'SCR' | 'SDG' | 'SEK' | 'SGD' | 'SHP' | 'SLL' | 'SOS' | 'SRD' | 'SSP' | 'STN' | 'SVC' | 'SYP' | 'SZL' | 'THB' | 'TJS' | 'TMT' | 'TND' | 'TOP' | 'TRY' | 'TTD' | 'TWD' | 'TZS' | 'UAH' | 'UGX' | 'USD' | 'UYU' | 'UZS' | 'VES' | 'VND' | 'VUV' | 'WST' | 'XAF' | 'XCD' | 'XOF' | 'XPF' | 'YER' | 'ZAR' | 'ZMW' | 'ZWL'

export interface CustomAttribute {
    constraints: FieldConstraints
    dataType: FieldDataType
    entityType: CustomAttributeEntityType
    id: Scalars['ID']
    isDisabled: Scalars['Boolean']
    name: Scalars['String']
    order: Scalars['Int']
    timestamps: Timestamps
    __typename: 'CustomAttribute'
}

export type CustomAttributeEntityType = 'CRMAccount' | 'CRMAccountAddress' | 'CRMContact' | 'CoreFacility' | 'CoreFacilityGroup' | 'CoreOrganization' | 'CoreUser' | 'FilesFile' | 'FinanceFinancialAccount' | 'InventoryCategory' | 'InventoryItem' | 'InventoryItemGroup' | 'InventoryTag' | 'SalesSalesOrder'

export interface CustomPriceList {
    archivedAt: (Scalars['ZonedDateTime'] | null)
    counterpartyGroupId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currency: Scalars['String']
    endDate: (Scalars['ZonedDateTime'] | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    isPublished: Scalars['Boolean']
    name: Scalars['String']
    notes: (Scalars['String'] | null)
    operationType: OperationType
    pricingMode: PricingMode
    startDate: (Scalars['ZonedDateTime'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'CustomPriceList'
}

export interface CustomPriceListResultPage {
    entries: CustomPriceList[]
    page: Page
    __typename: 'CustomPriceListResultPage'
}

export type CustomPriceListSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'OperationTypeAsc' | 'OperationTypeDesc'

export interface CustomPriceListStatusCounts {
    active: Scalars['Int']
    archived: Scalars['Int']
    draft: Scalars['Int']
    expired: Scalars['Int']
    __typename: 'CustomPriceListStatusCounts'
}

export interface CustomerInvitation {
    acceptedAt: (Scalars['Time'] | null)
    account: Account
    accountId: Scalars['ID']
    email: Scalars['String']
    expiresAt: Scalars['Time']
    id: Scalars['ID']
    invitationStatus: InvitationStatus
    invitedByUserId: Scalars['ID']
    linkedOrganizationId: (Scalars['ID'] | null)
    sentAt: Scalars['Time']
    timestamps: Timestamps
    __typename: 'CustomerInvitation'
}

export interface CustomerInvitationResultPage {
    entries: CustomerInvitation[]
    page: Page
    __typename: 'CustomerInvitationResultPage'
}

export type CustomerInvitationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'EmailAsc' | 'EmailDesc' | 'ExpiresAtAsc' | 'ExpiresAtDesc' | 'SentAtAsc' | 'SentAtDesc' | 'StatusAsc' | 'StatusDesc'

export type CycleCountFrequency = 'Annually' | 'Daily' | 'Monthly' | 'Quarterly' | 'Weekly'

export interface CycleCountLine {
    adjustmentMovement: (InventoryMovement | null)
    adjustmentMovementId: (Scalars['ID'] | null)
    adjustmentStatus: (Scalars['String'] | null)
    countedAt: (Scalars['ZonedDateTime'] | null)
    countedBy: (Scalars['ID'] | null)
    countedByUser: (User | null)
    countedQuantity: (Scalars['Decimal'] | null)
    countedQuantityUnit: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    cycleCountTask: CycleCountTask
    cycleCountTaskId: Scalars['ID']
    expectedQuantity: (Scalars['Decimal'] | null)
    expectedQuantityUnit: Scalars['String']
    facilityId: Scalars['ID']
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    notes: (Scalars['String'] | null)
    recountRequested: Scalars['Boolean']
    stockAccount: InventoryAccount
    stockAccountId: Scalars['ID']
    timestamps: Timestamps
    toleranceThreshold: Scalars['Decimal']
    unitCostOverride: (Scalars['Decimal'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    variancePercentage: (Scalars['Decimal'] | null)
    varianceQuantity: (Scalars['Decimal'] | null)
    withinTolerance: (Scalars['Boolean'] | null)
    zone: (InventoryZone | null)
    zoneId: (Scalars['ID'] | null)
    __typename: 'CycleCountLine'
}

export interface CycleCountLineResultPage {
    entries: CycleCountLine[]
    page: Page
    __typename: 'CycleCountLineResultPage'
}

export type CycleCountLineSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface CycleCountSchedule {
    abcClassification: (Scalars['String'] | null)
    categoryTolerances: (Scalars['Map'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    defaultTolerancePercentage: Scalars['Decimal']
    facility: Facility
    facilityId: Scalars['ID']
    frequency: CycleCountFrequency
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    isBlindCount: Scalars['Boolean']
    lastGeneratedAt: (Scalars['ZonedDateTime'] | null)
    name: Scalars['String']
    nextGenerationAt: (Scalars['ZonedDateTime'] | null)
    scopeCategories: (Scalars['Map'] | null)
    scopeType: CycleCountScopeType
    scopeZones: (Scalars['Map'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    valueThreshold: (Scalars['Decimal'] | null)
    __typename: 'CycleCountSchedule'
}

export interface CycleCountScheduleResultPage {
    entries: CycleCountSchedule[]
    page: Page
    __typename: 'CycleCountScheduleResultPage'
}

export type CycleCountScheduleSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'FrequencyAsc' | 'FrequencyDesc' | 'NameAsc' | 'NameDesc'

export type CycleCountScopeType = 'Abc' | 'Category' | 'Full' | 'Value' | 'Zone'

export interface CycleCountTask {
    abcClassification: (Scalars['String'] | null)
    approvedAt: (Scalars['ZonedDateTime'] | null)
    approvedBy: (Scalars['ID'] | null)
    approvedByUser: (User | null)
    assignedTo: (Scalars['ID'] | null)
    assignedToUser: (User | null)
    completedAt: (Scalars['ZonedDateTime'] | null)
    countType: CycleCountScopeType
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    defaultTolerancePercentage: (Scalars['Decimal'] | null)
    dueDate: (Scalars['CalendarDate'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    isBlindCount: Scalars['Boolean']
    isFrozen: Scalars['Boolean']
    notes: (Scalars['String'] | null)
    schedule: (CycleCountSchedule | null)
    scheduleId: (Scalars['ID'] | null)
    scopeCategories: (Scalars['Map'] | null)
    scopeZones: (Scalars['Map'] | null)
    snapshotMovementId: (Scalars['ID'] | null)
    startedAt: (Scalars['ZonedDateTime'] | null)
    status: Scalars['String']
    taskNumber: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    valueThreshold: (Scalars['Decimal'] | null)
    zone: (InventoryZone | null)
    zoneId: (Scalars['ID'] | null)
    __typename: 'CycleCountTask'
}

export interface CycleCountTaskResultPage {
    entries: CycleCountTask[]
    page: Page
    __typename: 'CycleCountTaskResultPage'
}

export type CycleCountTaskSortOption = 'CountTypeAsc' | 'CountTypeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'DueDateAsc' | 'DueDateDesc' | 'StatusAsc' | 'StatusDesc' | 'TaskNumberAsc' | 'TaskNumberDesc'

export type DeductionApplicationType = 'Price' | 'Weight'

export interface DeductionType {
    applicationType: DeductionApplicationType
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'DeductionType'
}

export interface DeductionTypeResultPage {
    entries: DeductionType[]
    page: Page
    __typename: 'DeductionTypeResultPage'
}

export type DeductionTypeSortOption = 'ApplicationTypeAsc' | 'ApplicationTypeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface DefaultPhotoRequirement {
    createdById: Scalars['ID']
    id: Scalars['ID']
    isRequired: Scalars['Boolean']
    name: Scalars['String']
    order: Scalars['Float']
    timestamps: Timestamps
    __typename: 'DefaultPhotoRequirement'
}

export interface DefaultPriceList {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currency: Scalars['String']
    facilityId: Scalars['ID']
    id: Scalars['ID']
    notes: (Scalars['String'] | null)
    operationType: OperationType
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'DefaultPriceList'
}

export interface DefaultPriceListResultPage {
    entries: DefaultPriceList[]
    page: Page
    __typename: 'DefaultPriceListResultPage'
}

export type DefaultPriceListSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface DelayNode {
    delayType: DelayType
    description: (Scalars['String'] | null)
    duration: (Scalars['Int'] | null)
    durationUnit: (DurationUnit | null)
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    type: NodeType
    untilDateTime: (Scalars['String'] | null)
    untilExpression: (Scalars['String'] | null)
    __typename: 'DelayNode'
}

export type DelayType = 'fixed' | 'until'

export interface DeleteFileError {
    fileId: Scalars['ID']
    message: Scalars['String']
    __typename: 'DeleteFileError'
}

export interface DeleteFilePayload {
    success: Scalars['Boolean']
    __typename: 'DeleteFilePayload'
}

export type DeleteFileResult = (DeleteFileError | DeleteFileSuccess) & { __isUnion?: true }

export interface DeleteFileSuccess {
    fileId: Scalars['ID']
    __typename: 'DeleteFileSuccess'
}

export interface DeleteFilesPayload {
    failed: DeleteFileError[]
    succeeded: DeleteFileSuccess[]
    __typename: 'DeleteFilesPayload'
}

export interface DeleteResult {
    blockingLoads: (AffectedLoad[] | null)
    deleted: Scalars['Boolean']
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'DeleteResult'
}

export interface Detention {
    carrier: (Account | null)
    carrierId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    endDate: (Scalars['CalendarDate'] | null)
    freeMinutes: Scalars['Int']
    id: Scalars['ID']
    location: (Facility | null)
    locationId: Scalars['ID']
    ratePerMinute: Scalars['Decimal']
    startDate: Scalars['CalendarDate']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Detention'
}

export interface DetentionResultPage {
    entries: Detention[]
    page: Page
    __typename: 'DetentionResultPage'
}

export type DetentionSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'StartDateAsc' | 'StartDateDesc'

export type DispatchErrorType = 'Credentials' | 'None' | 'RateLimit' | 'Timeout' | 'Unknown' | 'Validation'

export type DispatchImageCategory = 'IDBack' | 'IDFront' | 'ItemPhoto' | 'ScaleTicket' | 'Signature' | 'SupplierPhoto' | 'VehiclePhoto' | 'VehicleTitle'

export type DispatchImageStatus = 'Failed' | 'Pending' | 'Uploaded'

export type DispatchRecordStatus = 'Failed' | 'NotReported' | 'Processing' | 'Queued' | 'Submitted'

export interface DoNotBuyEntry {
    account: (Account | null)
    accountId: Scalars['ID']
    addedByUser: (User | null)
    addedByUserId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    effectiveFrom: Scalars['ZonedDateTime']
    effectiveTo: (Scalars['ZonedDateTime'] | null)
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    id: Scalars['ID']
    notes: (Scalars['String'] | null)
    originType: DoNotBuyOriginType
    reason: Scalars['String']
    removedByUser: (User | null)
    removedByUserId: (Scalars['ID'] | null)
    status: DoNotBuyStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'DoNotBuyEntry'
}

export interface DoNotBuyEntryResultPage {
    entries: DoNotBuyEntry[]
    page: Page
    __typename: 'DoNotBuyEntryResultPage'
}

export type DoNotBuyEntrySortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'EffectiveFromAsc' | 'EffectiveFromDesc'

export type DoNotBuyOriginType = 'Automated' | 'LawEnforcement' | 'Manual'

export type DoNotBuyStatus = 'Active' | 'Expired' | 'Removed'

export interface DocumentGenerationResult {
    documentType: Scalars['String']
    errorMessage: (Scalars['String'] | null)
    fileId: (Scalars['ID'] | null)
    success: Scalars['Boolean']
    workflowId: (Scalars['String'] | null)
    __typename: 'DocumentGenerationResult'
}

export type DocumentType = 'BillOfLading' | 'BookingInvoice' | 'FullPageScaleTicket' | 'FullPageWeightTicket' | 'Invoice' | 'LoadInvoice' | 'OutboundScaleTicket' | 'PackingList' | 'PurchaseOrder' | 'SalesOrder' | 'ShippingSummary' | 'ThermalScaleTicket' | 'ThermalWeightTicket' | 'WeightTicket'

export interface Driver {
    address: Address
    assignments: Service[]
    certifications: DriverCertification[]
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currentLocation: (Point | null)
    currentService: (Service | null)
    currentTrailer: (Trailer | null)
    currentTruck: (Truck | null)
    defaultTrailer: (Trailer | null)
    defaultTrailerId: (Scalars['ID'] | null)
    defaultTruck: (Truck | null)
    defaultTruckId: (Scalars['ID'] | null)
    displayOrder: (Scalars['String'] | null)
    email: Scalars['String']
    firstName: Scalars['String']
    id: Scalars['ID']
    lastLocationTime: (Scalars['ZonedDateTime'] | null)
    lastName: Scalars['String']
    licenseExpiration: (Scalars['ZonedDateTime'] | null)
    licenseNumber: (Scalars['String'] | null)
    phoneNumber: Scalars['String']
    status: DriverStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    user: (User | null)
    userId: (Scalars['ID'] | null)
    __typename: 'Driver'
}

export interface DriverCertification {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    driver: Driver
    driverId: Scalars['ID']
    expirationDate: Scalars['ZonedDateTime']
    id: Scalars['ID']
    issuedDate: Scalars['ZonedDateTime']
    issuingBody: Scalars['String']
    number: Scalars['String']
    timestamps: Timestamps
    type: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'DriverCertification'
}

export interface DriverCertificationResultPage {
    entries: DriverCertification[]
    page: Page
    __typename: 'DriverCertificationResultPage'
}

export type DriverCertificationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'ExpirationDateAsc' | 'ExpirationDateDesc' | 'TypeAsc' | 'TypeDesc'

export interface DriverDisplayOrder {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    driverId: Scalars['ID']
    id: Scalars['ID']
    rank: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    userId: Scalars['ID']
    __typename: 'DriverDisplayOrder'
}

export interface DriverDisplayOrderResultPage {
    entries: DriverDisplayOrder[]
    page: Page
    __typename: 'DriverDisplayOrderResultPage'
}

export type DriverDisplayOrderSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'RankAsc' | 'RankDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type DriverProgress = 'Completed' | 'EnRoute' | 'Failed' | 'NotStarted' | 'OnSite'

export interface DriverResultPage {
    entries: Driver[]
    page: Page
    __typename: 'DriverResultPage'
}

export type DriverSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'FirstNameAsc' | 'FirstNameDesc' | 'LastLocationTimeAsc' | 'LastLocationTimeDesc' | 'LastNameAsc' | 'LastNameDesc' | 'LicenseExpirationAsc' | 'LicenseExpirationDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type DriverStatus = 'Available' | 'Inactive' | 'OffDuty' | 'OnBreak' | 'OnDuty'

export type DurationUnit = 'days' | 'hours' | 'minutes' | 'seconds'

export interface Edge {
    id: Scalars['ID']
    source: Scalars['ID']
    sourceHandle: (Scalars['String'] | null)
    target: Scalars['ID']
    __typename: 'Edge'
}

export interface EmailActionNode {
    bcc: (Scalars['String'] | null)
    body: Scalars['String']
    bodyType: (Scalars['String'] | null)
    cc: (Scalars['String'] | null)
    continueOnFail: Scalars['Boolean']
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    replyTo: (Scalars['String'] | null)
    subject: Scalars['String']
    to: Scalars['String']
    type: NodeType
    __typename: 'EmailActionNode'
}

export interface EmailSendingResult {
    errorMessage: (Scalars['String'] | null)
    messageId: (Scalars['String'] | null)
    success: Scalars['Boolean']
    workflowId: (Scalars['String'] | null)
    __typename: 'EmailSendingResult'
}


/** Error returned when the user's email address needs to be verified */
export interface EmailVerificationRequiredError {
    pendingAuthenticationToken: Scalars['String']
    __typename: 'EmailVerificationRequiredError'
}

export interface EvaluatedFormula {
    error: (Scalars['String'] | null)
    formula: Scalars['String']
    value: (Scalars['Decimal'] | null)
    __typename: 'EvaluatedFormula'
}

export interface EvaluatedItemPricing {
    evaluatedTiers: EvaluatedTier[]
    itemPricing: ItemPricing
    __typename: 'EvaluatedItemPricing'
}

export interface EvaluatedTier {
    maxPrice: (Scalars['Decimal'] | null)
    minPrice: (Scalars['Decimal'] | null)
    targetPrice: (Scalars['Decimal'] | null)
    tier: ItemPricingTier
    __typename: 'EvaluatedTier'
}

export interface ExecutionRun {
    actionsExecuted: Scalars['Int']
    automation: (Automation | null)
    automationId: Scalars['ID']
    completedAt: (Scalars['ZonedDateTime'] | null)
    durationMs: (Scalars['Int'] | null)
    errorMessage: (Scalars['String'] | null)
    executionDurationMs: (Scalars['Int'] | null)
    id: Scalars['ID']
    isTest: Scalars['Boolean']
    nodeExecutions: NodeExecution[]
    nodesExecuted: Scalars['Int']
    organization: Organization
    organizationId: Scalars['ID']
    startedAt: (Scalars['ZonedDateTime'] | null)
    status: ExecutionStatus
    timestamps: Timestamps
    triggerPayload: (Scalars['Map'] | null)
    triggeredAt: Scalars['ZonedDateTime']
    workflowId: Scalars['String']
    workflowRunId: Scalars['String']
    __typename: 'ExecutionRun'
}

export interface ExecutionRunResultPage {
    entries: ExecutionRun[]
    page: Page
    __typename: 'ExecutionRunResultPage'
}

export type ExecutionRunSortOption = 'CompletedAtAsc' | 'CompletedAtDesc' | 'StartedAtAsc' | 'StartedAtDesc' | 'TriggeredAtAsc' | 'TriggeredAtDesc'

export type ExecutionStatus = 'Cancelled' | 'Completed' | 'Failed' | 'Pending' | 'Running' | 'WaitingApproval'

export interface Facility {
    address: Address
    customAttributes: (Scalars['Map'] | null)
    facilityGroup: (FacilityGroup | null)
    facilityName: Scalars['String']
    facilityType: Scalars['String']
    id: Scalars['ID']
    timestamps: Timestamps
    timezone: Scalars['Timezone']
    __typename: 'Facility'
}

export interface FacilityAtm {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    enabled: Scalars['Boolean']
    facilityId: Scalars['ID']
    id: Scalars['ID']
    name: (Scalars['String'] | null)
    timestamps: Timestamps
    tranactYardId: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FacilityAtm'
}

export interface FacilityAtmResultPage {
    entries: FacilityAtm[]
    page: Page
    __typename: 'FacilityAtmResultPage'
}

export type FacilityAtmSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export interface FacilityGeneralPreferences {
    allowedUnitSystems: UnitSystem[]
    currency: CurrencyCode
    dateFormat: Scalars['String']
    defaultUnitSystem: UnitSystem
    language: Scalars['String']
    timezone: Scalars['String']
    weekStartDay: Scalars['String']
    __typename: 'FacilityGeneralPreferences'
}

export interface FacilityGroup {
    customAttributes: (Scalars['Map'] | null)
    defaultFacility: (Facility | null)
    facilities: (Facility[] | null)
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    __typename: 'FacilityGroup'
}

export interface FacilityGroupResultPage {
    entries: FacilityGroup[]
    page: Page
    __typename: 'FacilityGroupResultPage'
}

export type FacilityGroupSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export interface FacilityResultPage {
    entries: Facility[]
    page: Page
    __typename: 'FacilityResultPage'
}

export interface FacilitySalesPreferences {
    askForDeletionConfirmation: Scalars['Boolean']
    defaultPort: (Scalars['String'] | null)
    defaultWeightDisplayUnit: Scalars['String']
    enableDefaultPrinting: Scalars['Boolean']
    photoInstructions: PhotoInstruction[]
    skipScalePayment: Scalars['Boolean']
    __typename: 'FacilitySalesPreferences'
}

export type FacilitySortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type FieldConstraintObjectType = 'CRMAccount' | 'CRMAccountAddress' | 'CRMContact' | 'CoreFacility' | 'CoreFacilityGroup' | 'CoreUser' | 'FilesFile' | 'FinanceFinancialAccount' | 'InventoryCategory' | 'InventoryItem' | 'InventoryItemGroup' | 'InventoryTag'

export interface FieldConstraints {
    maxLength: (Scalars['Int'] | null)
    maxValue: (Scalars['Float'] | null)
    minLength: (Scalars['Int'] | null)
    minValue: (Scalars['Float'] | null)
    multipleValues: (Scalars['Boolean'] | null)
    objectType: (FieldConstraintObjectType | null)
    required: (Scalars['Boolean'] | null)
    selectOptions: (Scalars['String'][] | null)
    unique: (Scalars['Boolean'] | null)
    validationExpr: (Scalars['String'] | null)
    __typename: 'FieldConstraints'
}

export type FieldDataType = 'Boolean' | 'Date' | 'DateTime' | 'Json' | 'Money' | 'MultilineText' | 'Number' | 'ObjectRef' | 'Select' | 'Text' | 'Time' | 'UUID'

export interface File {
    children: (File[] | null)
    creator: User
    entityId: (Scalars['ID'] | null)
    entityType: (Scalars['String'] | null)
    expiresAt: (Scalars['Time'] | null)
    fileName: Scalars['String']
    fileSize: Scalars['Int']
    fileType: FileType
    id: Scalars['ID']
    metadata: (Scalars['Map'] | null)
    mimeType: Scalars['String']
    parent: (File | null)
    parentId: (Scalars['ID'] | null)
    path: Scalars['String']
    public: Scalars['Boolean']
    status: FileStatus
    subDirectories: (File[] | null)
    template: Scalars['Boolean']
    timestamps: Timestamps
    uploadUrl: (Scalars['String'] | null)
    __typename: 'File'
}

export interface FileAccessURLResult {
    error: (Scalars['String'] | null)
    expiresAt: (Scalars['Time'] | null)
    fileId: Scalars['ID']
    url: (Scalars['String'] | null)
    __typename: 'FileAccessURLResult'
}

export interface FileChangedEvent {
    file: Scalars['ID']
    parent: (Scalars['ID'] | null)
    __typename: 'FileChangedEvent'
}

export interface FileConnection {
    edges: FileEdge[]
    total: Scalars['Int']
    __typename: 'FileConnection'
}

export interface FileEdge {
    cursor: Scalars['String']
    node: File
    __typename: 'FileEdge'
}

export interface FileError {
    fileID: (Scalars['ID'] | null)
    fileName: (Scalars['String'] | null)
    message: Scalars['String']
    __typename: 'FileError'
}

export type FilePermission = 'Delete' | 'Read' | 'Write'

export type FileStatus = 'Active' | 'Deleted' | 'Expired' | 'PendingUpload'

export interface FileTemplate {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: Scalars['String']
    file: File
    fileId: Scalars['ID']
    id: Scalars['ID']
    isDefault: Scalars['Boolean']
    organizationId: Scalars['ID']
    timestamps: Timestamps
    type: (FileTemplateType | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FileTemplate'
}

export interface FileTemplateResultPage {
    entries: FileTemplate[]
    page: Page
    __typename: 'FileTemplateResultPage'
}

export type FileTemplateSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'CreatedByAsc' | 'CreatedByDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'UpdatedByAsc' | 'UpdatedByDesc'

export type FileTemplateType = 'ApSettlementReport' | 'BillAp' | 'BillOfLading' | 'BookingInvoice' | 'CheckAp' | 'FullPageTicket' | 'FullPageWeightTicket' | 'InventoryTag' | 'InvoiceAr' | 'LoadInvoice' | 'OutboundTicket' | 'PackingList' | 'PriceList' | 'PurchaseOrder' | 'SalesOrder' | 'ShippingSummary' | 'ThermalTicket' | 'ThermalWeightTicket'

export type FileType = 'Directory' | 'Regular'

export type FilesAggregateType = 'File'

export interface FilesOutboxEventCounts {
    file: Scalars['Int']
    __typename: 'FilesOutboxEventCounts'
}

export interface FilterNode {
    description: (Scalars['String'] | null)
    expression: Scalars['String']
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    type: NodeType
    __typename: 'FilterNode'
}

export type FinanceAggregateType = 'Bill' | 'Invoice'

export interface FinanceOutboxEventCounts {
    bill: Scalars['Int']
    invoice: Scalars['Int']
    __typename: 'FinanceOutboxEventCounts'
}

export interface FinancialAccount {
    accountNumberMasked: (Scalars['String'] | null)
    allowRepeatedCheckNumbers: Scalars['Boolean']
    bankName: (Scalars['String'] | null)
    checkBusinessName: (Scalars['String'] | null)
    checkLogo: (Scalars['String'] | null)
    checkMailingAddress: (Scalars['String'] | null)
    checkNumberGeneration: Scalars['Boolean']
    checkPhoneNumber: (Scalars['String'] | null)
    checkSignature: (Scalars['String'] | null)
    currency: CurrencyCode
    currentBalance: Money
    customAttributes: (Scalars['Map'] | null)
    disabled: Scalars['Boolean']
    ezcashEndpoint: (Scalars['String'] | null)
    ezcashTimeoutSeconds: (Scalars['Int'] | null)
    facility: Facility
    id: Scalars['ID']
    lastCheckNumber: (Scalars['Int'] | null)
    linked: Scalars['Boolean']
    nachaCompanyIdentification: (Scalars['String'] | null)
    nachaCompanyName: (Scalars['String'] | null)
    nachaDefaultSecCode: (Scalars['String'] | null)
    name: Scalars['String']
    paymentAllocationMethod: PaymentAllocationMethod
    roundingMethod: RoundingMethod
    roundingPrecision: RoundingPrecision
    routingNumber: (Scalars['String'] | null)
    timestamps: Timestamps
    type: FinancialAccountType
    visibleInPayments: Scalars['Boolean']
    warningThreshold: Money
    __typename: 'FinancialAccount'
}

export interface FinancialAccountAdjustment {
    amount: Scalars['Decimal']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    creatorId: (Scalars['ID'] | null)
    currencyCode: Scalars['String']
    date: Scalars['ZonedDateTime']
    facilityId: Scalars['ID']
    financialAccountId: Scalars['ID']
    id: Scalars['ID']
    paymentId: (Scalars['ID'] | null)
    physicalCount: (Scalars['Decimal'] | null)
    reason: (Scalars['String'] | null)
    systemBalanceAtTime: (Scalars['Decimal'] | null)
    timestamps: Timestamps
    type: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FinancialAccountAdjustment'
}

export interface FinancialAccountAdjustmentResultPage {
    entries: FinancialAccountAdjustment[]
    page: Page
    __typename: 'FinancialAccountAdjustmentResultPage'
}

export type FinancialAccountAdjustmentSortOption = 'AmountAsc' | 'AmountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'DateAsc' | 'DateDesc'

export interface FinancialAccountResultPage {
    entries: FinancialAccount[]
    page: Page
    __typename: 'FinancialAccountResultPage'
}

export type FinancialAccountSortOption = 'BalanceAsc' | 'BalanceDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface FinancialAccountTransaction {
    amount: Scalars['Decimal']
    authorizedDate: (Scalars['CalendarDate'] | null)
    channel: FinancialAccountTransactionChannel
    checkNumber: (Scalars['String'] | null)
    counterparties: FinancialAccountTransactionCounterparty[]
    date: Scalars['CalendarDate']
    financialAccountId: Scalars['ID']
    financialAccountOwnerId: (Scalars['String'] | null)
    id: Scalars['ID']
    imageUrl: (Scalars['String'] | null)
    location: (Address | null)
    pendingTransactionId: (Scalars['ID'] | null)
    reference: Scalars['String']
    status: FinancialAccountTransactionStatus
    timestamps: Timestamps
    transferNumber: (Scalars['String'] | null)
    type: FinancialAccountTransactionType
    website: (Scalars['String'] | null)
    __typename: 'FinancialAccountTransaction'
}

export type FinancialAccountTransactionChannel = 'Digital' | 'InStore' | 'Other'

export interface FinancialAccountTransactionCounterparty {
    account: (Account | null)
    id: Scalars['ID']
    imageUrl: (Scalars['String'] | null)
    name: Scalars['String']
    timestamps: Timestamps
    type: FinancialAccountTransactionCounterpartyType
    __typename: 'FinancialAccountTransactionCounterparty'
}

export type FinancialAccountTransactionCounterpartyType = 'FinancialInstitution' | 'IncomeSource' | 'Marketplace' | 'Merchant' | 'Other' | 'PaymentApp' | 'PaymentTerminal'

export interface FinancialAccountTransactionResultPage {
    entries: FinancialAccountTransaction[]
    page: Page
    __typename: 'FinancialAccountTransactionResultPage'
}

export type FinancialAccountTransactionSortOption = 'AmountAsc' | 'AmountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'DateAsc' | 'DateDesc' | 'ReferenceAsc' | 'ReferenceDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type FinancialAccountTransactionStatus = 'Cancelled' | 'Failed' | 'Pending' | 'Posted'

export type FinancialAccountTransactionType = 'ATM' | 'Adjustment' | 'BankCharge' | 'BillPayment' | 'Cash' | 'Cashback' | 'Check' | 'DirectDebit' | 'Interest' | 'Other' | 'Purchase' | 'StandingOrder' | 'Transfer'

export type FinancialAccountType = 'ATM' | 'Cash' | 'Checking' | 'Savings' | 'WriteOff'

export interface FlowValidationResult {
    issues: ValidationIssue[]
    valid: Scalars['Boolean']
    __typename: 'FlowValidationResult'
}

export interface FreightCharge {
    accruedAmount: Money
    chargebackAmount: Money
    deliveryNumber: Scalars['String']
    freightLane: Scalars['String']
    hauler: Scalars['String']
    id: Scalars['ID']
    netAmount: Money
    notes: (Scalars['String'] | null)
    reconciliationId: Scalars['ID']
    timestamps: Timestamps
    __typename: 'FreightCharge'
}

export interface FreightForwarder {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FreightForwarder'
}

export interface FreightForwarderResultPage {
    entries: FreightForwarder[]
    page: Page
    __typename: 'FreightForwarderResultPage'
}

export type FreightForwarderSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface FreightLane {
    active: Scalars['Boolean']
    carrier: Account
    carrierId: Scalars['ID']
    commodityCategory: (Scalars['String'] | null)
    costs: FreightLaneCost[]
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    destinationCity: (Scalars['String'] | null)
    destinationCountry: (Scalars['String'] | null)
    destinationState: (Scalars['String'] | null)
    destinationZipCode: (Scalars['String'] | null)
    equipmentType: (Scalars['String'] | null)
    freightLaneRouteId: (Scalars['ID'] | null)
    freight_lane_route: (FreightLaneRoute | null)
    id: Scalars['ID']
    notes: (Scalars['String'] | null)
    originLocationId: (Scalars['ID'] | null)
    originLocationType: (Scalars['String'] | null)
    origin_location: (Location | null)
    timestamps: Timestamps
    transportationMode: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FreightLane'
}

export interface FreightLaneCost {
    chargebackFormula: (Scalars['String'] | null)
    chargebackVariableIds: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currency: Scalars['String']
    endDate: (Scalars['CalendarDate'] | null)
    freightLaneId: Scalars['ID']
    freight_lane: FreightLane
    fuelSurchargeFormula: (Scalars['String'] | null)
    fuelSurchargeMode: (Scalars['String'] | null)
    fuelSurchargeVariableIds: (Scalars['String'] | null)
    id: Scalars['ID']
    minimumChargeAmount: (Scalars['Decimal'] | null)
    minimumChargeCurrencyCode: (Scalars['String'] | null)
    minimumChargebackAmount: (Scalars['Decimal'] | null)
    minimumChargebackCurrencyCode: (Scalars['String'] | null)
    rateFormula: (Scalars['String'] | null)
    rateVariableIds: (Scalars['String'] | null)
    startDate: Scalars['CalendarDate']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FreightLaneCost'
}

export interface FreightLaneCostResultPage {
    entries: FreightLaneCost[]
    page: Page
    __typename: 'FreightLaneCostResultPage'
}

export type FreightLaneCostSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'StartDateAsc' | 'StartDateDesc'

export interface FreightLaneResultPage {
    entries: FreightLane[]
    page: Page
    __typename: 'FreightLaneResultPage'
}

export interface FreightLaneRoute {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    distance: (Scalars['Decimal'] | null)
    id: Scalars['ID']
    locationAId: Scalars['ID']
    locationAType: LocationType
    locationBId: Scalars['ID']
    locationBType: LocationType
    location_a: Location
    location_b: Location
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FreightLaneRoute'
}

export interface FreightLaneRouteResultPage {
    entries: FreightLaneRoute[]
    page: Page
    __typename: 'FreightLaneRouteResultPage'
}

export type FreightLaneRouteSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type FreightLaneSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'TransportationModeAsc' | 'TransportationModeDesc'

export interface FreightLine {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'FreightLine'
}

export interface FreightLineResultPage {
    entries: FreightLine[]
    page: Page
    __typename: 'FreightLineResultPage'
}

export type FreightLineSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type FreightTerm = 'CIF' | 'CNF' | 'DDP' | 'Delivered' | 'EXW' | 'FAS' | 'FOB' | 'PickedUp'

export type FreightTerms = 'Collect' | 'Prepaid' | 'ThirdParty'

export interface GenerateCheckPdfPayload {
    fileId: Scalars['ID']
    __typename: 'GenerateCheckPdfPayload'
}

export interface GenerateDocumentResult {
    documents: DocumentGenerationResult[]
    __typename: 'GenerateDocumentResult'
}

export interface GenerateDocumentsAndSendEmailResult {
    documents: DocumentGenerationResult[]
    email: EmailSendingResult
    __typename: 'GenerateDocumentsAndSendEmailResult'
}

export interface GenerateFileAccessURLPayload {
    results: FileAccessURLResult[]
    __typename: 'GenerateFileAccessURLPayload'
}

export interface GenerateNachaFilePayload {
    entryCount: Scalars['Int']
    fileContent: Scalars['String']
    totalAmount: Scalars['Decimal']
    __typename: 'GenerateNachaFilePayload'
}

export interface GeneratePriceListDocumentResult {
    fileId: Scalars['ID']
    workflowId: Scalars['String']
    __typename: 'GeneratePriceListDocumentResult'
}

export interface GenerateWOPITokenPayload {
    token: WOPIToken
    __typename: 'GenerateWOPITokenPayload'
}

export interface GovernmentReportingConfiguration {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    daysOfWeek: (Scalars['Map'] | null)
    encryptedCredentials: (Scalars['String'] | null)
    fields: (Scalars['Map'] | null)
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    name: Scalars['String']
    processBatchesAsUnit: Scalars['Boolean']
    recyclerId: (Scalars['String'] | null)
    serviceType: GovernmentReportingServiceType
    timestamps: Timestamps
    toEmailAddress: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    uploadTimezone: (Scalars['String'] | null)
    uploadType: ReportingUploadType
    __typename: 'GovernmentReportingConfiguration'
}

export interface GovernmentReportingConfigurationResultPage {
    entries: GovernmentReportingConfiguration[]
    page: Page
    __typename: 'GovernmentReportingConfigurationResultPage'
}

export type GovernmentReportingConfigurationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'ServiceTypeAsc' | 'ServiceTypeDesc'

export interface GovernmentReportingFacility {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: (Facility | null)
    facilityId: Scalars['ID']
    governmentReportingConfiguration: (GovernmentReportingConfiguration | null)
    governmentReportingConfigurationId: Scalars['ID']
    id: Scalars['ID']
    mlid: (Scalars['String'] | null)
    reportingFacilityId: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'GovernmentReportingFacility'
}

export interface GovernmentReportingFacilityResultPage {
    entries: GovernmentReportingFacility[]
    page: Page
    __typename: 'GovernmentReportingFacilityResultPage'
}

export type GovernmentReportingFacilitySortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type GovernmentReportingServiceType = 'Alabama' | 'BCPolice' | 'CanadaBWI' | 'Kansas' | 'LeadsOnline' | 'LeadsOnlineCanada' | 'NMVTIS' | 'OhioDPS' | 'TexasOnlineMetals' | 'WAPolice'

export type HaulerProgress = 'Completed' | 'Failed' | 'InProgress' | 'NotStarted'

export type HoldExemptionReason = 'FrequentSeller' | 'ManuallyChecked' | 'None' | 'SmallTransaction'

export type HttpMethod = 'DELETE' | 'GET' | 'PATCH' | 'POST' | 'PUT'

export interface HttpRequestActionNode {
    bodyType: (Scalars['String'] | null)
    continueOnFail: Scalars['Boolean']
    description: (Scalars['String'] | null)
    headers: (Scalars['Map'] | null)
    id: Scalars['ID']
    label: Scalars['String']
    method: HttpMethod
    position: Position
    requestBody: (Scalars['String'] | null)
    retryCount: (Scalars['Int'] | null)
    timeout: (Scalars['Int'] | null)
    type: NodeType
    url: Scalars['String']
    __typename: 'HttpRequestActionNode'
}

export interface HttpWebhookTriggerConfigOutput {
    path: (Scalars['String'] | null)
    __typename: 'HttpWebhookTriggerConfigOutput'
}

export interface HttpWebhookTriggerNode {
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    type: NodeType
    __typename: 'HttpWebhookTriggerNode'
}

export type IdentityDocumentType = 'DriverLicense' | 'MexicanMatriculaConsular' | 'Other' | 'Passport' | 'StateID'

export interface InboundTollingAgreement {
    agreementNumber: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customerAccount: (Account | null)
    customerAccountId: Scalars['ID']
    effectiveDate: Scalars['CalendarDate']
    expectedYieldPercentage: (Scalars['Decimal'] | null)
    expirationDate: (Scalars['CalendarDate'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    invoicePricingBasis: InvoicePricingBasis
    isActive: Scalars['Boolean']
    pricePerUnit: (Money | null)
    priceUnit: (Scalars['String'] | null)
    processingType: (ProcessingType | null)
    processingTypeId: Scalars['ID']
    terms: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'InboundTollingAgreement'
}

export interface InboundTollingAgreementResultPage {
    entries: InboundTollingAgreement[]
    page: Page
    __typename: 'InboundTollingAgreementResultPage'
}

export type InboundTollingAgreementSortOption = 'AgreementNumberAsc' | 'AgreementNumberDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'EffectiveDateAsc' | 'EffectiveDateDesc' | 'ExpirationDateAsc' | 'ExpirationDateDesc'

export type IndividualEyeColor = 'Black' | 'Blue' | 'Brown' | 'Gray' | 'Green' | 'Hazel' | 'Maroon' | 'Multicolored' | 'Pink' | 'Unknown'

export type IndividualHairColor = 'Bald' | 'Black' | 'Blond' | 'Brown' | 'Gray' | 'Green' | 'Orange' | 'Pink' | 'Purple' | 'Red' | 'Sandy' | 'Unknown' | 'White'

export type IndividualRace = 'AmericanIndian' | 'Asian' | 'Black' | 'Hispanic' | 'Unknown' | 'White'

export type IndividualSex = 'Female' | 'Male'

export interface Integration {
    category: Scalars['String']
    icon: Scalars['String']
    key: Scalars['String']
    name: Scalars['String']
    operations: Operation[]
    type: Scalars['String']
    __typename: 'Integration'
}


/** Error returned when the provided email/password combination is invalid */
export interface InvalidCredentialsError {
    email: (Scalars['String'] | null)
    __typename: 'InvalidCredentialsError'
}


/** Error returned when one-time provided is invalid */
export interface InvalidOneTimeCode {
    pendingAuthenticationToken: Scalars['String']
    __typename: 'InvalidOneTimeCode'
}


/** Error returned when signup invitation is invalid or expired */
export interface InvalidSignUpInvitationError {
    /** Reason the invitation is invalid */
    reason: Scalars['String']
    __typename: 'InvalidSignUpInvitationError'
}


/** Error returned when user invitation is invalid or expired */
export interface InvalidUserInvitationError {
    /** Reason the invitation is invalid */
    reason: Scalars['String']
    __typename: 'InvalidUserInvitationError'
}

export interface InventoryAccount {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    facilityId: (Scalars['ID'] | null)
    id: Scalars['ID']
    name: Scalars['String']
    taggingType: InventoryTaggingType
    timestamps: Timestamps
    type: InventoryAccountType
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'InventoryAccount'
}

export interface InventoryAccountResultPage {
    entries: InventoryAccount[]
    page: Page
    __typename: 'InventoryAccountResultPage'
}

export type InventoryAccountSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'TaggingTypeAsc' | 'TaggingTypeDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type InventoryAccountType = 'Adjustments' | 'AtExternalProcessor' | 'CustomerOwned' | 'Customers' | 'FinishedGoodsStock' | 'InteryardTransfers' | 'Production' | 'Suppliers' | 'WorkInProgressStock'

export type InventoryAggregateType = 'Category' | 'InventoryTag' | 'Item' | 'ItemGroup'

export interface InventoryFacilitySettings {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    defaultCountTolerancePercentage: Scalars['Decimal']
    enforceLooseStockOnTagging: Scalars['Boolean']
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    wacComponents: (Scalars['Map'] | null)
    __typename: 'InventoryFacilitySettings'
}

export interface InventoryFacilitySettingsResultPage {
    entries: InventoryFacilitySettings[]
    page: Page
    __typename: 'InventoryFacilitySettingsResultPage'
}

export type InventoryFacilitySettingsSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'


/**
 * InventoryLevel represents the aggregated inventory level for an item.
 * For items with movements, this shows the quantity at a specific facility.
 * For items without movements, facility will be null and quantity will be 0.
 */
export interface InventoryLevel {
    /** Value and WAC breakdown by currency */
    currencyValues: InventoryLevelCurrencyValue[]
    /** The facility where this inventory is located (null for items without movements) */
    facility: (Facility | null)
    /** Facility ID (null for items without inventory movements) */
    facilityId: (Scalars['ID'] | null)
    /** The item at this inventory level */
    item: Item
    /** Item ID */
    itemId: Scalars['ID']
    /**
     * For TollingMaterial view: The customer account that owns this material.
     * References a CRM Account entity.
     */
    ownerAccount: (Account | null)
    /**
     * For TollingMaterial view: The ID of the customer account that owns this material.
     * References a CRM Account entity.
     */
    ownerAccountId: (Scalars['ID'] | null)
    /**
     * For OurMaterial view when material is at an external processor: The processor account.
     * References a CRM Account entity.
     */
    processorAccount: (Account | null)
    /**
     * For OurMaterial view when material is at an external processor: The ID of the processor account.
     * References a CRM Account entity.
     */
    processorAccountId: (Scalars['ID'] | null)
    /** Current quantity at this location with unit (0 for items without movements) */
    quantity: Weight
    __typename: 'InventoryLevel'
}


/** InventoryLevelCurrencyValue represents the total value and WAC for a specific currency */
export interface InventoryLevelCurrencyValue {
    /** Currency code for this value */
    currencyCode: CurrencyCode
    /** Total inventory value in this currency */
    totalValue: (Scalars['Decimal'] | null)
    /** Weighted average cost per unit in this currency */
    weightedAverageCost: (Scalars['Decimal'] | null)
    __typename: 'InventoryLevelCurrencyValue'
}


/** Result page for inventory levels */
export interface InventoryLevelResultPage {
    /** List of inventory levels matching the query */
    entries: InventoryLevel[]
    /** Pagination information */
    page: Page
    /** Aggregate statistics for the query results */
    stats: InventoryLevelStats
    __typename: 'InventoryLevelResultPage'
}


/** Sorting options for inventory levels */
export type InventoryLevelSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'FacilityAsc' | 'FacilityDesc' | 'ItemNameAsc' | 'ItemNameDesc' | 'QuantityAsc' | 'QuantityDesc'


/** Statistics about inventory levels */
export interface InventoryLevelStats {
    /** Number of item/facility combinations with positive stock */
    itemsWithStock: Scalars['Int']
    /** Total number of item/facility combinations with inventory */
    totalItems: Scalars['Int']
    /** Total quantity across all inventory levels */
    totalQuantity: Scalars['Decimal']
    __typename: 'InventoryLevelStats'
}

export interface InventoryLot {
    allocations: LotAllocationResultPage
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: (Scalars['String'] | null)
    facility: (Facility | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    isToll: Scalars['Boolean']
    lotNumber: Scalars['String']
    mergedInto: (InventoryLot | null)
    mergedIntoId: (Scalars['ID'] | null)
    quantitySummary: LotQuantitySummary[]
    status: LotStatus
    tags: InventoryTagResultPage
    timestamps: Timestamps
    tollCustomerAccount: (Account | null)
    tollCustomerAccountId: (Scalars['ID'] | null)
    tollReceiptId: (Scalars['ID'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    valuation: LotValuation[]
    zone: (InventoryZone | null)
    zoneId: (Scalars['ID'] | null)
    __typename: 'InventoryLot'
}

export interface InventoryLotAllocateResult {
    allocations: LotAllocation[]
    lot: InventoryLot
    __typename: 'InventoryLotAllocateResult'
}

export interface InventoryLotCreateFromMovementsResult {
    allocationsCreated: Scalars['Int']
    lot: InventoryLot
    __typename: 'InventoryLotCreateFromMovementsResult'
}

export interface InventoryLotMergeResult {
    mergedLots: InventoryLot[]
    targetLot: InventoryLot
    __typename: 'InventoryLotMergeResult'
}

export interface InventoryLotResultPage {
    entries: InventoryLot[]
    page: Page
    __typename: 'InventoryLotResultPage'
}

export type InventoryLotSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'LotNumberAsc' | 'LotNumberDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface InventoryLotSplitResult {
    newLot: InventoryLot
    sourceLot: InventoryLot
    __typename: 'InventoryLotSplitResult'
}

export interface InventoryMovement {
    allocatedQuantity: Weight
    allocatedQuantityToTags: Weight
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    facility: (Facility | null)
    facilityId: Scalars['ID']
    fromAccountId: Scalars['ID']
    fromZoneId: (Scalars['ID'] | null)
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    lotAllocations: LotAllocation[]
    metadata: (Scalars['Map'] | null)
    movementType: InventoryMovementType
    occurredAt: Scalars['ZonedDateTime']
    originTransactionItemId: Scalars['String']
    originTransactionType: InventoryTransactionType
    ownerAccount: (Account | null)
    ownerAccountId: (Scalars['ID'] | null)
    quantity: Weight
    status: InventoryMovementStatus
    tagAllocations: TagAllocation[]
    timestamps: Timestamps
    toAccountId: Scalars['ID']
    toZoneId: (Scalars['ID'] | null)
    totalCost: (Money | null)
    unallocatedQuantity: Weight
    unallocatedQuantityFromTags: Weight
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'InventoryMovement'
}

export interface InventoryMovementHistoryResultPage {
    entries: InventoryMovementWithHistory[]
    page: Page
    __typename: 'InventoryMovementHistoryResultPage'
}

export interface InventoryMovementResultPage {
    entries: InventoryMovement[]
    page: Page
    __typename: 'InventoryMovementResultPage'
}

export type InventoryMovementSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'OccurredAtAsc' | 'OccurredAtDesc' | 'StatusAsc' | 'StatusDesc'

export type InventoryMovementStatus = 'Canceled' | 'Completed' | 'InTransit' | 'Pending'

export type InventoryMovementType = 'In' | 'Internal' | 'Out' | 'Reset'

export interface InventoryMovementWithHistory {
    movement: InventoryMovement
    runningTotals: MovementRunningTotals
    __typename: 'InventoryMovementWithHistory'
}

export interface InventoryOutboxEventCounts {
    category: Scalars['Int']
    inventoryTag: Scalars['Int']
    item: Scalars['Int']
    itemGroup: Scalars['Int']
    __typename: 'InventoryOutboxEventCounts'
}

export interface InventoryPeriod {
    closedAt: (Scalars['ZonedDateTime'] | null)
    closedBy: (Scalars['ID'] | null)
    closedByUser: (User | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    endDate: Scalars['ZonedDateTime']
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    lockedAt: (Scalars['ZonedDateTime'] | null)
    lockedBy: (Scalars['ID'] | null)
    lockedByUser: (User | null)
    name: Scalars['String']
    notes: (Scalars['String'] | null)
    periodType: Scalars['String']
    startDate: Scalars['ZonedDateTime']
    status: Scalars['String']
    timestamps: Timestamps
    unlockExpiresAt: (Scalars['ZonedDateTime'] | null)
    unlockReason: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'InventoryPeriod'
}

export interface InventoryPeriodBalance {
    account: InventoryAccount
    accountId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currencyCode: Scalars['String']
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    inventoryPeriodId: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    quantity: Scalars['Decimal']
    quantityUnit: Unit
    timestamps: Timestamps
    totalValue: Scalars['Decimal']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    wacPerUnit: Scalars['Decimal']
    __typename: 'InventoryPeriodBalance'
}

export interface InventoryPeriodBalanceResultPage {
    entries: InventoryPeriodBalance[]
    page: Page
    __typename: 'InventoryPeriodBalanceResultPage'
}

export type InventoryPeriodBalanceSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface InventoryPeriodConfig {
    allowStraddleCompletion: Scalars['Boolean']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    fiscalYearStartMonth: (Scalars['Int'] | null)
    id: Scalars['ID']
    periodType: Scalars['String']
    requireStraddleApproval: Scalars['Boolean']
    straddleWindowPeriods: Scalars['Int']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'InventoryPeriodConfig'
}

export interface InventoryPeriodConfigResultPage {
    entries: InventoryPeriodConfig[]
    page: Page
    __typename: 'InventoryPeriodConfigResultPage'
}

export type InventoryPeriodConfigSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'FiscalYearStartMonthAsc' | 'FiscalYearStartMonthDesc' | 'PeriodTypeAsc' | 'PeriodTypeDesc' | 'StraddleWindowPeriodsAsc' | 'StraddleWindowPeriodsDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface InventoryPeriodResultPage {
    entries: InventoryPeriod[]
    page: Page
    __typename: 'InventoryPeriodResultPage'
}

export type InventoryPeriodSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'EndDateAsc' | 'EndDateDesc' | 'NameAsc' | 'NameDesc' | 'StartDateAsc' | 'StartDateDesc' | 'StatusAsc' | 'StatusDesc'

export interface InventoryTag {
    allocations: TagAllocationResultPage
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    facilityId: Scalars['ID']
    generatedAt: Scalars['ZonedDateTime']
    grossQuantity: Scalars['Decimal']
    id: Scalars['ID']
    isReconciled: Scalars['Boolean']
    isRevised: Scalars['Boolean']
    item: Item
    itemId: Scalars['ID']
    lot: (InventoryLot | null)
    lotId: (Scalars['ID'] | null)
    netQuantity: Scalars['Float']
    quantityCaptureMethod: QuantityCaptureMethod
    quantityDiscrepancy: Scalars['Decimal']
    quantitySummary: (TagQuantitySummary | null)
    status: InventoryTagStatus
    tagNumber: Scalars['String']
    tagType: TagType
    tare: Scalars['Decimal']
    tareCaptureMethod: QuantityCaptureMethod
    timestamps: Timestamps
    trackedQuantity: Scalars['Decimal']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'InventoryTag'
}

export interface InventoryTagAllocateResult {
    allocations: TagAllocation[]
    tag: InventoryTag
    __typename: 'InventoryTagAllocateResult'
}

export interface InventoryTagResultPage {
    entries: InventoryTag[]
    page: Page
    __typename: 'InventoryTagResultPage'
}

export type InventoryTagSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'GeneratedAtAsc' | 'GeneratedAtDesc' | 'TagNumberAsc' | 'TagNumberDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type InventoryTagStatus = 'Active' | 'Cancelled' | 'Confirmed' | 'Draft' | 'InInventory' | 'InTransfer' | 'Loaded' | 'PendingPurchase' | 'Reserved' | 'Revised' | 'Shipped' | 'Sold' | 'Transferred' | 'Voided'

export type InventoryTaggingType = 'Any' | 'Tagged' | 'Untagged'

export type InventoryTransactionType = 'Accounting' | 'BalanceAdjustment' | 'Downgrade' | 'PhysicalInventory' | 'Processing' | 'Purchase' | 'PurchaseReversion' | 'Sale' | 'SaleReversion' | 'Tagging' | 'Transfer' | 'TransferReversion' | 'Untagging' | 'Upgrade'


/** View mode for inventory levels */
export type InventoryViewMode = 'OurMaterial' | 'TollingMaterial'

export interface InventoryZone {
    capacityUnit: (Scalars['String'] | null)
    capacityValue: (Scalars['Decimal'] | null)
    children: InventoryZone[]
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    description: (Scalars['String'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    name: Scalars['String']
    parentZone: (InventoryZone | null)
    parentZoneId: (Scalars['ID'] | null)
    status: ZoneStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    utilization: (ZoneUtilization | null)
    zoneCode: Scalars['String']
    zoneType: ZoneType
    __typename: 'InventoryZone'
}

export interface InventoryZoneResultPage {
    entries: InventoryZone[]
    page: Page
    __typename: 'InventoryZoneResultPage'
}

export type InventoryZoneSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'ZoneCodeAsc' | 'ZoneCodeDesc' | 'ZoneTypeAsc' | 'ZoneTypeDesc'

export type InvitationStatus = 'ACCEPTED' | 'CANCELLED' | 'EXPIRED' | 'PENDING'

export interface Invoice {
    account: Account
    amount: Money
    documentDate: Scalars['CalendarDate']
    documentNumber: Scalars['String']
    dueDate: Scalars['CalendarDate']
    facility: Facility
    id: Scalars['ID']
    lineItems: InvoiceLineItem[]
    notes: (Scalars['String'] | null)
    openAmount: Money
    paymentTerm: PaymentTerm
    paymentTermEntity: (PaymentTermConfig | null)
    payments: Payment[]
    sourceReferences: InvoiceEntityReference[]
    status: InvoiceStatus
    timestamps: Timestamps
    type: InvoiceType
    __typename: 'Invoice'
}

export interface InvoiceEntityReference {
    entityId: Scalars['ID']
    entityType: InvoiceEntityReferenceType
    __typename: 'InvoiceEntityReference'
}

export type InvoiceEntityReferenceType = 'OutboundLoad' | 'OutboundLoadLineItem'

export interface InvoiceLineItem {
    description: Scalars['String']
    groupName: (Scalars['String'] | null)
    id: Scalars['ID']
    item: (Item | null)
    itemId: (Scalars['ID'] | null)
    quantity: Scalars['Decimal']
    sortOrder: Scalars['Int']
    sourceReference: (InvoiceEntityReference | null)
    timestamps: Timestamps
    totalPrice: Money
    unit: Scalars['String']
    unitPrice: Money
    __typename: 'InvoiceLineItem'
}

export interface InvoicePaymentApplication {
    appliedAmount: Money
    appliedAt: Scalars['ZonedDateTime']
    invoice: Invoice
    __typename: 'InvoicePaymentApplication'
}

export type InvoicePricingBasis = 'Input' | 'Output'

export interface InvoiceResultPage {
    entries: Invoice[]
    page: Page
    __typename: 'InvoiceResultPage'
}

export type InvoiceSortOption = 'AccountAsc' | 'AccountDesc' | 'AmountAsc' | 'AmountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'DocumentDateAsc' | 'DocumentDateDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type InvoiceStatus = 'Paid' | 'Pending' | 'ProForma' | 'Voided'

export interface InvoiceStatusCounts {
    paid: Scalars['Int']
    pending: Scalars['Int']
    proForma: Scalars['Int']
    voided: Scalars['Int']
    __typename: 'InvoiceStatusCounts'
}

export type InvoiceType = 'Accrual' | 'FreightInvoice' | 'InboundInvoice' | 'OutboundInvoice'

export interface Item {
    attributeValues: Scalars['JSON']
    category: (Category | null)
    categoryId: Scalars['ID']
    colorHue: (Scalars['Int'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    description: (Scalars['String'] | null)
    effectivePricingUnit: Scalars['String']
    id: Scalars['ID']
    itemGroup: (ItemGroup | null)
    itemGroupId: Scalars['ID']
    measurementUnit: Scalars['String']
    name: Scalars['String']
    notes: (Scalars['String'] | null)
    pricingUnitOverride: (Scalars['String'] | null)
    skuNumber: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Item'
}

export interface ItemAlias {
    account: Account
    accountId: Scalars['ID']
    aliasCode: (Scalars['String'] | null)
    aliasName: Scalars['String']
    aliasType: ItemAliasType
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    notes: (Scalars['String'] | null)
    organization: Organization
    organizationId: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ItemAlias'
}

export interface ItemAliasResultPage {
    entries: ItemAlias[]
    page: Page
    __typename: 'ItemAliasResultPage'
}

export type ItemAliasSortOption = 'AliasNameAsc' | 'AliasNameDesc' | 'AliasTypeAsc' | 'AliasTypeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type ItemAliasType = 'Buy' | 'Sell'

export interface ItemGroup {
    colorHue: (Scalars['Int'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    defaultPricingUnit: Scalars['String']
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    name: Scalars['String']
    notes: (Scalars['String'] | null)
    number: Scalars['String']
    parentId: (Scalars['ID'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ItemGroup'
}

export interface ItemGroupResultPage {
    entries: ItemGroup[]
    page: Page
    __typename: 'ItemGroupResultPage'
}

export type ItemGroupSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'NumberAsc' | 'NumberDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ItemMarginResult {
    itemId: Scalars['ID']
    margin: (Money | null)
    marginPercent: (Scalars['Decimal'] | null)
    purchaseTotal: (Money | null)
    purchaseUnitPrice: (Money | null)
    quantity: Scalars['Decimal']
    salesTotal: (Money | null)
    salesUnitPrice: (Money | null)
    unit: Unit
    __typename: 'ItemMarginResult'
}

export interface ItemPosition {
    currentInventory: Scalars['Decimal']
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    incoming: Scalars['Decimal']
    item: Item
    itemId: Scalars['ID']
    netPosition: Scalars['Decimal']
    outgoing: Scalars['Decimal']
    unit: Unit
    __typename: 'ItemPosition'
}

export interface ItemPositionResultPage {
    entries: ItemPosition[]
    page: Page
    stats: PositionSummaryStats
    __typename: 'ItemPositionResultPage'
}

export type ItemPositionSortOption = 'IncomingAsc' | 'IncomingDesc' | 'ItemNameAsc' | 'ItemNameDesc' | 'NetPositionAsc' | 'NetPositionDesc' | 'OutgoingAsc' | 'OutgoingDesc'

export interface ItemPrice {
    configuration: (ItemPriceConfiguration | null)
    itemPricings: EvaluatedItemPricing[]
    sourceId: Scalars['ID']
    sourceType: Scalars['String']
    __typename: 'ItemPrice'
}

export interface ItemPriceConfiguration {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currency: Scalars['String']
    facilityId: (Scalars['ID'] | null)
    id: Scalars['ID']
    itemId: Scalars['ID']
    operationType: OperationType
    pricingUnits: (Scalars['Map'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ItemPriceConfiguration'
}

export interface ItemPriceConfigurationResultPage {
    entries: ItemPriceConfiguration[]
    page: Page
    __typename: 'ItemPriceConfigurationResultPage'
}

export type ItemPriceConfigurationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface ItemPricing {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customPriceListId: (Scalars['ID'] | null)
    defaultPriceListId: (Scalars['ID'] | null)
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    position: Scalars['Int']
    pricingUnit: Unit
    tiers: ItemPricingTier[]
    tiersEffectiveAt: (Scalars['ZonedDateTime'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ItemPricing'
}

export interface ItemPricingDirtyAwareResult {
    entries: ItemPricing[]
    preservedDirtyNodes: ItemPricing[]
    visibleDirtyIds: Scalars['ID'][]
    __typename: 'ItemPricingDirtyAwareResult'
}

export interface ItemPricingResultPage {
    entries: ItemPricing[]
    page: Page
    __typename: 'ItemPricingResultPage'
}

export type ItemPricingSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'PositionAsc' | 'PositionDesc' | 'TiersEffectiveAtAsc' | 'TiersEffectiveAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ItemPricingTier {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    itemPricingId: Scalars['ID']
    maxAmount: (Scalars['Decimal'] | null)
    maxPrice: UnitPriceFormula
    minPrice: UnitPriceFormula
    position: Scalars['Int']
    scrapValue: Scalars['Decimal']
    targetPrice: UnitPriceFormula
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ItemPricingTier'
}

export interface ItemPricingTierResultPage {
    entries: ItemPricingTier[]
    page: Page
    __typename: 'ItemPricingTierResultPage'
}

export type ItemPricingTierSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'MaxPriceFormulaAsc' | 'MaxPriceFormulaDesc' | 'MinPriceFormulaAsc' | 'MinPriceFormulaDesc' | 'PositionAsc' | 'PositionDesc' | 'TargetPriceFormulaAsc' | 'TargetPriceFormulaDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ItemResultPage {
    entries: Item[]
    page: Page
    __typename: 'ItemResultPage'
}

export type ItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'SkuAsc' | 'SkuDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface Load {
    billId: (Scalars['ID'] | null)
    bolNumber: (Scalars['String'] | null)
    booking: (Booking | null)
    bookingId: (Scalars['ID'] | null)
    brokeredOrder: (BrokeredOrder | null)
    brokeredOrderId: (Scalars['ID'] | null)
    canBeReconciled: Scalars['Boolean']
    carrierAccount: (Account | null)
    carrierAccountId: (Scalars['ID'] | null)
    container: (Container | null)
    containerAtFacilityAt: (Scalars['ZonedDateTime'] | null)
    containerInTransitAt: (Scalars['ZonedDateTime'] | null)
    containerLoadedAt: (Scalars['ZonedDateTime'] | null)
    containerNumber: (Scalars['String'] | null)
    containerPickedUpAt: (Scalars['ZonedDateTime'] | null)
    containerReadyToShipAt: (Scalars['ZonedDateTime'] | null)
    containerReturningAt: (Scalars['ZonedDateTime'] | null)
    containerType: (ContainerType | null)
    containerTypeId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currencyCode: CurrencyCode
    customerAccount: (Account | null)
    customerAccountAddress: (AccountAddress | null)
    customerAccountAddressId: (Scalars['ID'] | null)
    customerAccountId: (Scalars['ID'] | null)
    customerExternalNotes: (Scalars['String'] | null)
    customerFiles: File[]
    customerInternalNotes: (Scalars['String'] | null)
    deductions: LoadDeduction[]
    deductionsTotal: Money
    deliveryNumber: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    documentNumber: Scalars['String']
    driverName: (Scalars['String'] | null)
    expectedShipDate: (Scalars['CalendarDate'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    freightCost: (Money | null)
    freightForwarder: (Scalars['String'] | null)
    freightTerms: (FreightTerms | null)
    grandTotal: Money
    heavyWeight: (Weight | null)
    id: Scalars['ID']
    isReconciled: Scalars['Boolean']
    lightWeight: (Weight | null)
    lineItems: LoadLineItem[]
    loadReceivedDate: (Scalars['CalendarDate'] | null)
    millReceivedWeightPostDate: (Scalars['CalendarDate'] | null)
    organization: Organization
    organizationId: Scalars['ID']
    outboundTollingAgreement: (OutboundTollingAgreement | null)
    outboundTollingAgreementId: (Scalars['ID'] | null)
    purchaseOrder: (PurchaseOrder | null)
    purchaseOrderId: (Scalars['ID'] | null)
    receivedTicketIssueDate: (Scalars['CalendarDate'] | null)
    receivingFacility: (Facility | null)
    receivingFacilityId: (Scalars['ID'] | null)
    receivingTicketNumber: (Scalars['String'] | null)
    reconciliation: (LoadReconciliation | null)
    recyclerExternalNotes: (Scalars['String'] | null)
    recyclerFiles: File[]
    recyclerInternalNotes: (Scalars['String'] | null)
    releaseNumber: (Scalars['String'] | null)
    reviewed: Scalars['Boolean']
    salesOrder: (SalesOrder | null)
    salesOrderId: (Scalars['ID'] | null)
    scac: (Scalars['String'] | null)
    sealNumber: (Scalars['String'] | null)
    shippedDate: (Scalars['CalendarDate'] | null)
    shippingCarrierName: (Scalars['String'] | null)
    status: LoadStatus
    subtotal: Money
    supplier: (Account | null)
    supplierAddress: (AccountAddress | null)
    supplierAddressId: (Scalars['ID'] | null)
    supplierId: (Scalars['ID'] | null)
    timestamps: Timestamps
    trailerNumber: (Scalars['String'] | null)
    truckFreight: (Scalars['String'] | null)
    truckNumber: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    version: Scalars['Int']
    voidReason: (Scalars['String'] | null)
    weightDisplayUnit: WeightDisplayUnit
    __typename: 'Load'
}

export interface LoadBoard {
    drivers: Driver[]
    services: Service[]
    __typename: 'LoadBoard'
}

export interface LoadCustomerFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'LoadCustomerFileCreatePayload'
}

export interface LoadDeduction {
    applicationType: DeductionApplicationType
    calculatedAmount: (Money | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    deductionType: DeductionType
    deductionTypeId: Scalars['ID']
    facilityId: Scalars['ID']
    id: Scalars['ID']
    lineItem: (LoadLineItem | null)
    load: Load
    loadId: Scalars['ID']
    loadLineItemId: (Scalars['ID'] | null)
    notes: (Scalars['String'] | null)
    percentage: (Scalars['Decimal'] | null)
    priceValue: (Money | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    weightValue: (Weight | null)
    __typename: 'LoadDeduction'
}

export interface LoadDeductionResultPage {
    entries: LoadDeduction[]
    page: Page
    __typename: 'LoadDeductionResultPage'
}

export type LoadDeductionSortOption = 'ApplicationTypeAsc' | 'ApplicationTypeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface LoadLineItem {
    estimatedPrice: (Money | null)
    id: Scalars['ID']
    item: (Item | null)
    itemId: (Scalars['ID'] | null)
    loadId: Scalars['ID']
    notes: (Scalars['String'] | null)
    phase: (SalesLoadLineItemPhase | null)
    pricingUnit: Scalars['String']
    purchaseOrder: (PurchaseOrder | null)
    purchaseOrderId: (Scalars['ID'] | null)
    quantityVariance: Scalars['Decimal']
    receivedLineItems: ReceivedLineItem[]
    salesOrderLine: (SalesOrderLineItem | null)
    /** @deprecated Use itemId matching with Load.salesOrderId instead */
    salesOrderLineId: (Scalars['ID'] | null)
    tagId: (Scalars['ID'] | null)
    totalReceivedQuantity: Scalars['Decimal']
    type: SalesItemLineType
    unitPrice: (Money | null)
    weights: Scalars['Map']
    __typename: 'LoadLineItem'
}

export interface LoadPhotoCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'LoadPhotoCreatePayload'
}

export interface LoadReconciliation {
    deductions: ReconciliationDeduction[]
    externalNotes: (Scalars['String'] | null)
    files: File[]
    freightCharges: FreightCharge[]
    id: Scalars['ID']
    internalNotes: (Scalars['String'] | null)
    invoice: (Invoice | null)
    invoiceId: (Scalars['ID'] | null)
    invoiceType: (Scalars['String'] | null)
    loadId: Scalars['ID']
    loadReceivedDate: (Scalars['CalendarDate'] | null)
    millReceivedWeightPostDate: (Scalars['CalendarDate'] | null)
    netDelta: Scalars['Decimal']
    netReceivedWeight: Scalars['Decimal']
    netShippedWeight: Scalars['Decimal']
    receivedLineItems: ReceivedLineItem[]
    receivedLoadTotal: Money
    shippedLoadTotal: Money
    ticketIssueDate: (Scalars['CalendarDate'] | null)
    ticketNumber: (Scalars['String'] | null)
    timestamps: Timestamps
    totalDeductions: Money
    totalDelta: Money
    __typename: 'LoadReconciliation'
}

export interface LoadReconciliationFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'LoadReconciliationFileCreatePayload'
}

export interface LoadReconciliationSummary {
    expectedShipDate: (Scalars['CalendarDate'] | null)
    isReconciled: Scalars['Boolean']
    loadId: Scalars['ID']
    netDelta: (Scalars['Decimal'] | null)
    netReceivedWeight: (Scalars['Decimal'] | null)
    netShippedWeight: Scalars['Decimal']
    __typename: 'LoadReconciliationSummary'
}

export interface LoadReconciliationSummaryResultPage {
    entries: LoadReconciliationSummary[]
    page: Page
    __typename: 'LoadReconciliationSummaryResultPage'
}

export interface LoadRecyclerFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'LoadRecyclerFileCreatePayload'
}

export interface LoadResultPage {
    entries: Load[]
    page: Page
    __typename: 'LoadResultPage'
}

export type LoadSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'CreatedByAsc' | 'CreatedByDesc' | 'ExpectedShipDateAsc' | 'ExpectedShipDateDesc' | 'ShippedDateAsc' | 'ShippedDateDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'UpdatedByAsc' | 'UpdatedByDesc'

export type LoadStatus = 'ContainerAtFacility' | 'ContainerAtPort' | 'ContainerInTransit' | 'ContainerLoaded' | 'ContainerReadyToShip' | 'ContainerReturning' | 'Pending' | 'Received' | 'Reconciled' | 'Shipped' | 'Unassigned' | 'Voided'

export interface LoadStatusCounts {
    containerAtFacility: Scalars['Int']
    containerAtPort: Scalars['Int']
    containerInTransit: Scalars['Int']
    containerLoaded: Scalars['Int']
    containerReadyToShip: Scalars['Int']
    containerReturning: Scalars['Int']
    pending: Scalars['Int']
    received: Scalars['Int']
    reconciled: Scalars['Int']
    shipped: Scalars['Int']
    unassigned: Scalars['Int']
    voided: Scalars['Int']
    __typename: 'LoadStatusCounts'
}

export interface LoadUpdateResult {
    load: Load
    orphanedLink: (OrphanedBookingSalesOrderLink | null)
    __typename: 'LoadUpdateResult'
}

export interface Location {
    accountAddress: (AccountAddress | null)
    facility: (Facility | null)
    id: Scalars['ID']
    type: LocationType
    __typename: 'Location'
}


/** Location filter type for grouping facilities */
export type LocationFilterType = 'AllLocations' | 'ExternalProcessors' | 'OurFacilities'

export interface LocationFreightPricing {
    consumerChargebackFormula: (Scalars['String'] | null)
    consumerChargebackVariableIds: (Scalars['String'] | null)
    consumerFreightEnabled: Scalars['Boolean']
    consumerFuelSurchargeFormula: (Scalars['String'] | null)
    consumerFuelSurchargeMode: (Scalars['String'] | null)
    consumerFuelSurchargeVariableIds: (Scalars['String'] | null)
    consumerNegativeCharge: Scalars['Boolean']
    consumerRateFormula: (Scalars['String'] | null)
    consumerRateVariableIds: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    location: Location
    locationId: Scalars['ID']
    locationType: LocationType
    supplierChargebackFormula: (Scalars['String'] | null)
    supplierChargebackVariableIds: (Scalars['String'] | null)
    supplierFreightEnabled: Scalars['Boolean']
    supplierFuelSurchargeFormula: (Scalars['String'] | null)
    supplierFuelSurchargeMode: (Scalars['String'] | null)
    supplierFuelSurchargeVariableIds: (Scalars['String'] | null)
    supplierRateFormula: (Scalars['String'] | null)
    supplierRateVariableIds: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'LocationFreightPricing'
}

export interface LocationFreightPricingResultPage {
    entries: LocationFreightPricing[]
    page: Page
    __typename: 'LocationFreightPricingResultPage'
}

export type LocationFreightPricingSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type LocationType = 'AccountAddress' | 'Facility'

export interface LoopNode {
    arrayExpression: Scalars['String']
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    itemVariableName: Scalars['String']
    label: Scalars['String']
    maxIterations: Scalars['Int']
    position: Position
    type: NodeType
    __typename: 'LoopNode'
}

export interface LotAllocation {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    lot: InventoryLot
    lotId: Scalars['ID']
    movement: InventoryMovement
    movementId: Scalars['ID']
    quantity: Weight
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'LotAllocation'
}

export interface LotAllocationResultPage {
    entries: LotAllocation[]
    page: Page
    __typename: 'LotAllocationResultPage'
}

export type LotAllocationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface LotQuantitySummary {
    inQuantity: Weight
    item: Item
    itemId: Scalars['ID']
    outQuantity: Weight
    quantity: Weight
    __typename: 'LotQuantitySummary'
}

export type LotStatus = 'Active' | 'Closed' | 'Merged'

export interface LotTraceBackwardResult {
    lot: InventoryLot
    purchases: LotTracePurchase[]
    __typename: 'LotTraceBackwardResult'
}

export interface LotTraceForwardResult {
    lot: InventoryLot
    sales: LotTraceSale[]
    __typename: 'LotTraceForwardResult'
}

export interface LotTracePurchase {
    allocation: LotAllocation
    cost: (Money | null)
    quantity: Weight
    __typename: 'LotTracePurchase'
}

export interface LotTraceSale {
    allocation: LotAllocation
    quantity: Weight
    __typename: 'LotTraceSale'
}

export interface LotValuation {
    currentWAC: (Money | null)
    item: Item
    itemId: Scalars['ID']
    lotSpecificCost: (Money | null)
    lotSpecificValue: (Money | null)
    quantity: Weight
    wacValue: (Money | null)
    __typename: 'LotValuation'
}


/** Details of an active MFA challenge that needs to be completed */
export interface MfaChallenge {
    expiresAt: Scalars['String']
    id: Scalars['ID']
    __typename: 'MfaChallenge'
}


/** Error returned when multi-factor authentication verification is required */
export interface MfaChallengeError {
    authenticationFactors: MfaFactor[]
    pendingAuthenticationToken: Scalars['String']
    __typename: 'MfaChallengeError'
}


/** Error returned when the user must set up multi-factor authentication */
export interface MfaEnrollmentRequiredError {
    pendingAuthenticationToken: Scalars['String']
    user: User
    __typename: 'MfaEnrollmentRequiredError'
}


/** Configuration for a specific multi-factor authentication method */
export interface MfaFactor {
    id: Scalars['String']
    totp: (TotpConfig | null)
    type: MfaFactorType
    __typename: 'MfaFactor'
}


/** Available types of multi-factor authentication methods */
export type MfaFactorType = 'TOTP'

export type ModelProvider = 'Anthropic' | 'Cerebras' | 'Gemini' | 'OpenAI'

export interface Money {
    amount: Scalars['Decimal']
    currencyCode: CurrencyCode
    __typename: 'Money'
}

export type MonthlyOccurrence = 'Every' | 'First' | 'Fourth' | 'Last' | 'Second' | 'Third'

export interface MoveFilePayload {
    file: File
    __typename: 'MoveFilePayload'
}

export interface MovementRunningTotals {
    calculatedMovementValue: (Money | null)
    runningQuantity: Weight
    runningValue: (Money | null)
    runningWeightedAverageCost: (Money | null)
    __typename: 'MovementRunningTotals'
}

export interface Mutation {
    _placeholder: (Scalars['Boolean'] | null)
    _pricingNoop: (Scalars['Boolean'] | null)
    assistantActivateAgent: Agent
    assistantArchiveChat: AssistantChat
    assistantCreateAgent: Agent
    assistantCreateChat: AssistantChat
    assistantDeactivateAgent: Agent
    assistantSendChatMessage: Scalars['Boolean']
    assistantSetAgentTools: Agent
    assistantShareChat: AssistantChatShareLink
    assistantUnshareChat: AssistantChat
    assistantUpdateAgent: Agent
    assistantUpdateChat: AssistantChat
    /**
     * Accepts a user invitation using a verification token.
     * The token contains the user ID and email.
     * Sets the user's password and activates the account.
     */
    authenticationAcceptUserInvitation: UserInvitationAcceptResult
    /**
     * Authenticates a user using a magic authentication code.
     * Returns either a successful authentication response or an error indicating additional steps required.
     */
    authenticationAuthenticateWithMagicAuth: AuthenticationResult
    /**
     * Completes the signup process using a verification token.
     * The token contains the verified email address.
     * Provisions the organization and user, then returns the created IDs.
     */
    authenticationCompleteSignUp: SignUpCompleteResult
    /**
     * Completes Standalone Connect authentication for device authorization flows.
     * Called by the frontend after the user logs in, to inform WorkOS that auth succeeded.
     */
    authenticationCompleteStandaloneAuth: StandaloneAuthResult
    /**
     * Creates a magic authentication link for the specified email address.
     * Returns true if the magic auth link was created and sent successfully.
     */
    authenticationCreateMagicAuth: Scalars['Boolean']
    /**
     * Refreshes an existing authentication session using the current access token.
     * Returns a new authentication response or an error if the session cannot be refreshed.
     */
    authenticationRefreshSession: AuthenticationResult
    /**
     * Completes the authentication process by selecting an organization when multiple are available.
     * Used in response to an OrganizationSelectionError.
     */
    authenticationSelectOrganization: AuthenticationResult
    /**
     * Triggers sending of a verification code to the specified email address.
     * Returns true if the email was sent successfully.
     */
    authenticationSendEmailVerification: Scalars['Boolean']
    /**
     * Authenticates a user using their email and password.
     * Returns either a successful authentication response or an error indicating additional steps required.
     */
    authenticationSignIn: AuthenticationResult
    /**
     * Signs out the current user by invalidating their session.
     * Returns true if the sign out was successful.
     */
    authenticationSignOut: Scalars['Boolean']
    /**
     * Initiates the signup process for a new user.
     * Sends a verification email with a token. No data is stored in the database.
     */
    authenticationSignUp: SignUpInitiateResult
    /**
     * Verifies an email verification code sent to the user's email address.
     * Used in response to an EmailVerificationRequiredError.
     */
    authenticationVerifyEmail: AuthenticationResult
    /**
     * Verifies a TOTP code during multi-factor authentication.
     * Used in response to a MfaChallengeError.
     */
    authenticationVerifyTotp: AuthenticationResult
    automationsApprovalRespond: ApprovalRequest
    automationsAutomationActivate: Automation
    automationsAutomationBulkActivate: AutomationBulkOperationResult
    automationsAutomationBulkDelete: AutomationBulkOperationResult
    automationsAutomationBulkPause: AutomationBulkOperationResult
    automationsAutomationCreate: Automation
    automationsAutomationDelete: AutomationDeleteResult
    automationsAutomationDuplicate: Automation
    automationsAutomationPause: Automation
    automationsAutomationTest: ExecutionRun
    automationsAutomationUpdate: Automation
    automationsAutomationVersionCreate: AutomationVersion
    automationsAutomationVersionDelete: Scalars['Boolean']
    automationsAutomationVersionUpdate: AutomationVersion
    automationsExecutionRunCancel: ExecutionRun
    automationsWebhookRegenerateSecret: WebhookEndpoint
    complianceComplianceDispatchRecordCreate: ComplianceDispatchRecord
    complianceComplianceDispatchRecordRetry: ComplianceDispatchRecord
    complianceComplianceDispatchRecordUpdate: ComplianceDispatchRecord
    complianceComplianceFacilityRuleApplyJurisdictionPack: ComplianceFacilityRule[]
    complianceComplianceFacilityRuleCreate: ComplianceFacilityRule
    complianceComplianceFacilityRuleDelete: Scalars['Boolean']
    complianceComplianceFacilityRuleUpdate: ComplianceFacilityRule
    complianceComplianceItemJurisdictionCodeCreate: ComplianceItemJurisdictionCode
    complianceComplianceItemJurisdictionCodeDelete: Scalars['Boolean']
    complianceComplianceItemJurisdictionCodeUpdate: ComplianceItemJurisdictionCode
    complianceComplianceRuleDefinitionCreate: ComplianceRuleDefinition
    complianceComplianceRuleDefinitionDelete: Scalars['Boolean']
    complianceComplianceRuleDefinitionUpdate: ComplianceRuleDefinition
    complianceDoNotBuyEntryCreate: DoNotBuyEntry
    complianceDoNotBuyEntryDelete: Scalars['Boolean']
    complianceDoNotBuyEntryUpdate: DoNotBuyEntry
    complianceGovernmentReportingConfigurationCreate: GovernmentReportingConfiguration
    complianceGovernmentReportingConfigurationDelete: Scalars['Boolean']
    complianceGovernmentReportingConfigurationUpdate: GovernmentReportingConfiguration
    complianceGovernmentReportingFacilityCreate: GovernmentReportingFacility
    complianceGovernmentReportingFacilityDelete: Scalars['Boolean']
    complianceGovernmentReportingFacilityUpdate: GovernmentReportingFacility
    confirmAttachmentUpload: Attachment
    coreCustomAttributeCreate: CustomAttribute
    coreCustomAttributeDelete: Scalars['Boolean']
    coreCustomAttributeDisable: CustomAttribute
    coreCustomAttributeUpdate: CustomAttribute
    coreFacilityCreate: Facility
    coreFacilityDelete: Scalars['Boolean']
    coreFacilityGroupCreate: FacilityGroup
    coreFacilityGroupDelete: Scalars['Boolean']
    coreFacilityGroupUpdate: FacilityGroup
    coreFacilityUpdate: Facility
    coreOrganizationAddUser: Scalars['Boolean']
    coreOrganizationCreate: Organization
    coreOrganizationGrantEntitlement: Scalars['Boolean']
    coreOrganizationGrantUserAdmin: User
    coreOrganizationRemoveUser: Scalars['Boolean']
    coreOrganizationReset: OrganizationResetResult
    coreOrganizationRevokeEntitlement: Scalars['Boolean']
    coreOrganizationRevokeUserAdmin: User
    coreOrganizationUpdate: Organization
    corePatchScopedSettingValues: (Scalars['Boolean'] | null)
    coreRoleAddUsers: BulkOperationResult
    coreRoleCreate: Role
    coreRoleDelete: Scalars['Boolean']
    coreRoleRemoveUsers: BulkOperationResult
    coreRoleUpdate: Role
    coreRolesArchive: BulkOperationResult
    coreRolesRestore: BulkOperationResult
    coreSettingCreate: Setting
    coreSettingDelete: Scalars['Boolean']
    coreSettingUpdate: Setting
    coreSettingsGroupCreate: SettingsGroup
    coreSettingsGroupDelete: Scalars['Boolean']
    coreSettingsGroupUpdate: SettingsGroup
    coreUpdateUserPreferences: UserPreferences
    coreUserCreate: User
    coreUserDisable: Scalars['Boolean']
    coreUserEnable: Scalars['Boolean']
    coreUserRoleAssign: UserRoleAssignment
    coreUserRoleChange: UserRoleAssignment
    coreUserRoleRevoke: Scalars['Boolean']
    coreUserRoleRevokeAll: Scalars['Boolean']
    coreUserUpdate: User
    coreUsersDelete: BulkOperationResult
    coreUsersDisable: BulkOperationResult
    coreUsersEnable: BulkOperationResult
    createConversation: CreateConversationResult
    crmAccountAddressCreate: AccountAddress
    crmAccountAddressDelete: Scalars['Boolean']
    crmAccountAddressUpdate: AccountAddress
    crmAccountCreate: Account
    crmAccountDelete: Scalars['Boolean']
    crmAccountUpdate: Account
    crmContactCreate: Contact
    crmContactDelete: Scalars['Boolean']
    crmContactUpdate: Contact
    crmCustomerInvitationAccept: AcceptCustomerInvitationResult
    crmCustomerInvitationCancel: CustomerInvitation
    crmCustomerInvite: CustomerInvitation
    cycleCountLineApproveAdjustment: CycleCountLine
    cycleCountLineRecordCount: CycleCountLine
    cycleCountLineRejectAdjustment: CycleCountLine
    cycleCountLineRequestRecount: CycleCountLine
    filesCancelPendingUpload: DeleteFilePayload
    filesConfirmFileUpload: File
    filesCreateFile: CreateFilePayload
    filesCreateFiles: CreateFilesPayload
    /**
     * Create a zip archive of multiple files for download.
     * Returns a temporary download URL that expires after 1 hour.
     * The archive itself is stored temporarily and auto-deleted after 7 days.
     * For single files, consider using filesGenerateFileAccessURL instead.
     */
    filesCreateZipArchive: ArchiveDownloadPayload
    filesDeleteFile: DeleteFilePayload
    filesDeleteFiles: DeleteFilesPayload
    filesGenerateFileAccessURL: GenerateFileAccessURLPayload
    filesGenerateWOPIToken: GenerateWOPITokenPayload
    filesMoveFile: MoveFilePayload
    filesRemoveFileFromTemplate: RemoveFileFromTemplatePayload
    filesRenameFile: File
    filesSetFileAsTemplate: SetFileAsTemplatePayload
    filesSetTemplateAsDefault: SetTemplateAsDefaultPayload
    filesShareFile: ShareFilePayload
    filesStartWOPIEditingSession: StartWOPIEditingSessionPayload
    filesUnshareFile: UnshareFilePayload
    filesUpdateFileMetadata: File
    financeAccountBankDetailCreate: AccountBankDetail
    financeAccountBankDetailDelete: Scalars['Boolean']
    financeAccountBankDetailUpdate: AccountBankDetail
    financeAdvanceApply: Payment
    financeAdvanceRemoveApplication: Payment
    financeBillCreate: Bill
    financeBillMarkAsPaid: Bill
    financeBillUpdate: Bill
    financeBillVoid: Bill
    financeCheckTemplateCreate: CheckTemplate
    financeCheckTemplateDelete: Scalars['Boolean']
    financeCheckTemplateUpdate: CheckTemplate
    financeFacilityAtmCreate: FacilityAtm
    financeFacilityAtmDelete: Scalars['Boolean']
    financeFacilityAtmUpdate: FacilityAtm
    financeFinancialAccountAdjustmentCreate: FinancialAccountAdjustment
    financeFinancialAccountAdjustmentDelete: Scalars['Boolean']
    financeFinancialAccountAdjustmentUpdate: FinancialAccountAdjustment
    financeFinancialAccountCreate: FinancialAccount
    financeFinancialAccountDisable: FinancialAccount
    financeFinancialAccountSync: Scalars['Boolean']
    financeFinancialAccountSyncTransactions: Scalars['Boolean']
    financeFinancialAccountTransactionCreate: FinancialAccountTransaction
    financeFinancialAccountTransactionUpdate: FinancialAccountTransaction
    financeFinancialAccountUpdate: FinancialAccount
    financeGenerateCheckPdf: GenerateCheckPdfPayload
    financeGenerateNachaFile: GenerateNachaFilePayload
    financeInvoiceCreate: Invoice
    financeInvoiceMarkAsPaid: Invoice
    financeInvoiceUpdate: Invoice
    financeInvoiceVoid: Invoice
    financeInvoiceWriteOff: Payment
    financeNetPay: NetPayResult
    financeNextBillDocumentNumber: Scalars['String']
    financeNextInvoiceDocumentNumber: Scalars['String']
    financeNextPaymentDocumentNumber: Scalars['String']
    financePayBill: PayBillResult
    /** Apply a payment to a bill (for any payment type, not just advances) */
    financePaymentApplyToBill: Payment
    /** Apply a payment to an invoice (for any payment type, not just advances) */
    financePaymentApplyToInvoice: Payment
    financePaymentCreate: Payment
    financePaymentPost: Payment
    /** Remove a payment application from a bill */
    financePaymentRemoveFromBill: Payment
    /** Remove a payment application from an invoice */
    financePaymentRemoveFromInvoice: Payment
    financePaymentTermConfigCreate: PaymentTermConfig
    financePaymentTermConfigDelete: Scalars['Boolean']
    financePaymentTermConfigUpdate: PaymentTermConfig
    financePaymentUpdate: Payment
    financePaymentVoid: Payment
    financePaymentsConfirm: BulkPaymentResult
    financePaymentsUnconfirm: BulkPaymentResult
    financePositivePayTemplateCreate: PositivePayTemplate
    financePositivePayTemplateDelete: Scalars['Boolean']
    financePositivePayTemplateUpdate: PositivePayTemplate
    financeReceiveInvoice: ReceiveInvoiceResult
    financeReconcileCashDrawer: ReconcileCashDrawerPayload
    financeVoucherTemplateCreate: VoucherTemplate
    financeVoucherTemplateDelete: Scalars['Boolean']
    financeVoucherTemplateUpdate: VoucherTemplate
    integrationsPlaidCreateLinkToken: PlaidLinkToken
    integrationsPlaidExchangePublicToken: PlaidExchangeTokenResponse
    integrationsSemaphorGenerateToken: SemaphorToken
    integrationsWarehouseCredentialCreate: WarehouseCredential
    integrationsWarehouseCredentialDelete: Scalars['Boolean']
    integrationsWarehouseCredentialUpdate: WarehouseCredential
    inventoryCategoryCreate: Category
    inventoryCategoryDelete: Scalars['Boolean']
    inventoryCategoryUpdate: Category
    inventoryCycleCountScheduleActivate: CycleCountSchedule
    inventoryCycleCountScheduleCreate: CycleCountSchedule
    inventoryCycleCountScheduleDeactivate: CycleCountSchedule
    inventoryCycleCountScheduleDelete: Scalars['Boolean']
    inventoryCycleCountScheduleUpdate: CycleCountSchedule
    inventoryCycleCountTaskApprove: CycleCountTask
    inventoryCycleCountTaskCancel: CycleCountTask
    inventoryCycleCountTaskComplete: CycleCountTask
    inventoryCycleCountTaskCreate: CycleCountTask
    inventoryCycleCountTaskDelete: Scalars['Boolean']
    inventoryCycleCountTaskFreeze: CycleCountTask
    inventoryCycleCountTaskReopen: CycleCountTask
    inventoryCycleCountTaskStart: CycleCountTask
    inventoryCycleCountTaskUnfreeze: CycleCountTask
    inventoryCycleCountTaskUpdate: CycleCountTask
    inventoryFacilitySettingsUpdate: InventoryFacilitySettings
    inventoryInventoryAccountProvisionFacilityAccounts: ProvisionFacilityAccountsResult
    inventoryInventoryPeriodArchive: InventoryPeriod
    inventoryInventoryPeriodConfigCreate: InventoryPeriodConfig
    inventoryInventoryPeriodConfigUpdate: InventoryPeriodConfig
    inventoryInventoryPeriodCreate: InventoryPeriod
    inventoryInventoryPeriodDelete: Scalars['Boolean']
    inventoryInventoryPeriodLock: InventoryPeriod
    inventoryInventoryPeriodUnlock: InventoryPeriod
    inventoryInventoryPeriodUpdate: InventoryPeriod
    inventoryInventoryTagCreate: InventoryTag
    inventoryInventoryTagDelete: Scalars['Boolean']
    inventoryInventoryTagUpdate: InventoryTag
    inventoryInventoryZoneArchive: InventoryZone
    inventoryInventoryZoneClose: InventoryZone
    inventoryInventoryZoneCreate: InventoryZone
    inventoryInventoryZoneDelete: Scalars['Boolean']
    inventoryInventoryZoneUpdate: InventoryZone
    inventoryItemCreate: Item
    inventoryItemDelete: Scalars['Boolean']
    inventoryItemGroupCreate: ItemGroup
    inventoryItemGroupDelete: Scalars['Boolean']
    inventoryItemGroupUpdate: ItemGroup
    inventoryItemUpdate: Item
    inventoryLotAllocate: InventoryLotAllocateResult
    inventoryLotCreate: InventoryLot
    inventoryLotCreateFromMovements: InventoryLotCreateFromMovementsResult
    inventoryLotDeallocate: Scalars['Int']
    inventoryLotMerge: InventoryLotMergeResult
    inventoryLotSplit: InventoryLotSplitResult
    inventoryLotUpdate: InventoryLot
    inventoryTagAllocate: InventoryTagAllocateResult
    inventoryTagDeallocate: Scalars['Int']
    inventoryTagNumberFormatUpdate: Scalars['Boolean']
    inventoryTagNumberReset: Scalars['Boolean']
    inventoryTagUntag: InventoryTag
    iotCameraCreate: Camera
    iotCameraDelete: Scalars['Boolean']
    iotCameraSetCredentials: Camera
    iotCameraUpdate: Camera
    iotPrinterCreate: Printer
    iotPrinterDelete: Scalars['Boolean']
    iotPrinterUpdate: Printer
    iotScaleCreate: Scale
    iotScaleDelete: Scalars['Boolean']
    iotScaleUpdate: Scale
    iotScannerCreate: Scanner
    iotScannerDelete: Scalars['Boolean']
    iotScannerUpdate: Scanner
    iotSidecarAssignFacility: Sidecar
    iotSidecarCreate: Sidecar
    iotSidecarDelete: Scalars['Boolean']
    iotSidecarRegister: Sidecar
    iotSidecarTriggerUpdateCheck: Scalars['Boolean']
    iotSidecarUpdate: Sidecar
    notificationArchive: Scalars['Boolean']
    notificationDeviceRegister: NotificationDevice
    notificationMarkAllAsRead: Scalars['Boolean']
    notificationMarkAsRead: Scalars['Boolean']
    notificationMarkAsSeen: Scalars['Boolean']
    notificationPreferencesUpdate: NotificationPreference[]
    presenceAnnounce: Scalars['Boolean']
    pricingCounterpartyGroupAddAccounts: Scalars['Boolean']
    pricingCounterpartyGroupBulkDelete: Scalars['Int']
    pricingCounterpartyGroupCreate: CounterpartyGroup
    pricingCounterpartyGroupDelete: Scalars['Boolean']
    pricingCounterpartyGroupRemoveAccounts: Scalars['Boolean']
    pricingCounterpartyGroupUpdate: CounterpartyGroup
    pricingCustomPriceListAddItemPricing: ItemPricing
    pricingCustomPriceListArchive: Scalars['Boolean']
    pricingCustomPriceListBatchUpdateItemPricings: ItemPricing[]
    pricingCustomPriceListCopyFrom: ItemPricing[]
    pricingCustomPriceListDelete: Scalars['Boolean']
    pricingCustomPriceListDeleteItemPricing: Scalars['Boolean']
    pricingCustomPriceListDraft: CustomPriceList
    pricingCustomPriceListDuplicate: CustomPriceList
    pricingCustomPriceListImportFrom: ItemPricing[]
    pricingCustomPriceListPublish: CustomPriceList
    pricingCustomPriceListReorderItemPricings: Scalars['Boolean']
    pricingCustomPriceListUnarchive: Scalars['Boolean']
    pricingCustomPriceListUpdate: CustomPriceList
    pricingCustomPriceListUpdateItemPricing: ItemPricing
    pricingDefaultPriceListAddItemPricing: ItemPricing
    pricingDefaultPriceListBatchUpdateItemPricings: ItemPricing[]
    pricingDefaultPriceListCopyFrom: ItemPricing[]
    pricingDefaultPriceListDeleteItemPricing: Scalars['Boolean']
    pricingDefaultPriceListGetOrCreate: DefaultPriceList
    pricingDefaultPriceListImportFrom: ItemPricing[]
    pricingDefaultPriceListReorderItemPricings: Scalars['Boolean']
    pricingDefaultPriceListUpdate: DefaultPriceList
    pricingDefaultPriceListUpdateItemPricing: ItemPricing
    pricingDefaultPriceListUpdateNotes: DefaultPriceList
    pricingGeneratePriceListDocument: GeneratePriceListDocumentResult
    pricingItemPriceConfigurationSet: ItemPriceConfiguration
    pricingItemPriceConfigurationUpdate: ItemPriceConfiguration
    pricingNotifyPriceList: SendPriceListNotificationResult
    pricingVariableCreate: Variable
    pricingVariableDelete: Scalars['Boolean']
    pricingVariableUpdate: VariableUpdateResult
    productionInboundTollingAgreementCreate: InboundTollingAgreement
    productionInboundTollingAgreementDelete: Scalars['Boolean']
    productionInboundTollingAgreementUpdate: InboundTollingAgreement
    productionOutboundTollingAgreementCreate: OutboundTollingAgreement
    productionOutboundTollingAgreementDelete: Scalars['Boolean']
    productionOutboundTollingAgreementUpdate: OutboundTollingAgreement
    productionProcessingTypeCreate: ProcessingType
    productionProcessingTypeDelete: Scalars['Boolean']
    productionProcessingTypeUpdate: ProcessingType
    productionTollReceiptCreate: TollReceipt
    productionTollReceiptUpdate: TollReceipt
    productionTollShipmentCreate: TollShipment
    productionTollShipmentUpdate: TollShipment
    productionWorkOrderAllocateCosts: WorkOrder
    productionWorkOrderCalculateQuantities: WorkOrder
    productionWorkOrderCancel: WorkOrder
    productionWorkOrderComplete: WorkOrder
    productionWorkOrderCompleteWithActuals: WorkOrder
    productionWorkOrderCreate: WorkOrder
    productionWorkOrderDelete: Scalars['Boolean']
    productionWorkOrderOpen: WorkOrder
    productionWorkOrderStart: WorkOrder
    productionWorkOrderUpdate: WorkOrder
    setDefaultPhotoRequirements: DefaultPhotoRequirement[]
    tradeBookingBulkVoid: BulkVoidBookingResult
    tradeBookingComplete: Booking
    tradeBookingCreate: Booking
    tradeBookingCreateDraft: Booking
    tradeBookingDelete: DeleteResult
    tradeBookingFileCreate: BookingFileCreatePayload
    tradeBookingLoadsReceive: Load[]
    tradeBookingLoadsReconcile: Load[]
    tradeBookingNextDocumentNumber: Scalars['String']
    tradeBookingOpen: Booking
    /**
     * Delete a booking-salesorder relationship. Only allowed if no loads reference this combination.
     * Returns true if deleted successfully.
     */
    tradeBookingSalesOrderDelete: Scalars['Boolean']
    tradeBookingShip: Booking
    tradeBookingUpdate: BookingUpdateResult
    tradeBookingUpdateDraft: Booking
    tradeBookingVoid: VoidBookingResult
    tradeBrokeredOrderClose: BrokeredOrder
    tradeBrokeredOrderCreate: BrokeredOrder
    tradeBrokeredOrderDelete: Scalars['Boolean']
    tradeBrokeredOrderFulfill: BrokeredOrder
    tradeBrokeredOrderInProgress: BrokeredOrder
    tradeBrokeredOrderLinkOrders: BrokeredOrder
    tradeBrokeredOrderOpen: BrokeredOrder
    tradeBrokeredOrderUpdate: BrokeredOrder
    tradeBrokeredOrderVoid: BrokeredOrder
    tradeComplianceCheckOverride: ComplianceCheck
    tradeComplianceCheckUpdate: ComplianceCheck
    tradeComplianceHoldExtend: ComplianceHold
    tradeComplianceHoldFlagPolice: ComplianceHold
    tradeComplianceHoldRelease: ComplianceHold
    tradeComplianceHoldUpdate: ComplianceHold
    tradeContainerArriveAtFacility: Container
    tradeContainerBatchCreate: Container[]
    tradeContainerCreate: Container
    tradeContainerDelete: Scalars['Boolean']
    tradeContainerDepartFacility: Container
    tradeContainerLoad: Container
    tradeContainerPickup: Container
    tradeContainerReturnToPort: Container
    tradeContainerRevertStatus: Container
    tradeContainerRoll: Container
    tradeContainerShip: Container
    tradeContainerUnload: Container
    tradeContainerUpdate: Container
    tradeContainerVoid: Scalars['Boolean']
    tradeDeductionTypeCreate: DeductionType
    tradeDeductionTypeDelete: Scalars['Boolean']
    tradeDeductionTypeUpdate: DeductionType
    tradeFileConfirmUpload: File
    tradeFileDelete: Scalars['Boolean']
    tradeFileGenerateDownloadUrl: Scalars['String']
    tradeGenerateDocument: GenerateDocumentResult
    tradeGenerateDocumentsAndSendEmail: GenerateDocumentsAndSendEmailResult
    tradeItemAliasCreate: ItemAlias
    tradeItemAliasDelete: DeleteResult
    tradeItemAliasUpdate: ItemAlias
    tradeLoadAssign: Load
    tradeLoadBulkVoid: BulkVoidLoadResult
    tradeLoadContainerAtFacility: Load
    tradeLoadContainerAtPort: Load
    tradeLoadContainerInTransit: Load
    tradeLoadContainerLoaded: Load
    tradeLoadContainerReadyToShip: Load
    tradeLoadContainerReturning: Load
    tradeLoadCreate: Load
    tradeLoadCustomerFileCreate: LoadCustomerFileCreatePayload
    tradeLoadDeductionCreate: LoadDeduction
    tradeLoadDeductionDelete: Scalars['Boolean']
    tradeLoadDeductionUpdate: LoadDeduction
    tradeLoadDelete: Scalars['Boolean']
    tradeLoadNextDocumentNumber: Scalars['String']
    tradeLoadPhotoCreate: LoadPhotoCreatePayload
    tradeLoadPhotoUpdate: File
    tradeLoadReceive: Load
    tradeLoadReconcile: Load
    tradeLoadReconciliationFileCreate: LoadReconciliationFileCreatePayload
    tradeLoadRecyclerFileCreate: LoadRecyclerFileCreatePayload
    tradeLoadRevertStatus: Load
    tradeLoadReview: Load
    tradeLoadShip: Load
    tradeLoadUpdate: LoadUpdateResult
    tradeLoadVoid: Scalars['Boolean']
    tradeLocationFreightPricingCreate: LocationFreightPricing
    tradeLocationFreightPricingDelete: Scalars['Boolean']
    tradeLocationFreightPricingUpdate: LocationFreightPricing
    tradePurchaseLoadCompleteInventory: PurchaseLoad
    tradePurchaseLoadCompletePrice: PurchaseLoad
    tradePurchaseLoadCreate: PurchaseLoad
    tradePurchaseLoadDelete: Scalars['Boolean']
    tradePurchaseLoadFileCreate: PurchaseLoadFileCreatePayload
    tradePurchaseLoadHold: PurchaseLoad
    tradePurchaseLoadPay: PurchaseLoad
    tradePurchaseLoadRelease: PurchaseLoad
    tradePurchaseLoadRevertStatus: PurchaseLoad
    tradePurchaseLoadUpdate: PurchaseLoad
    tradePurchaseLoadVoid: Scalars['Boolean']
    tradePurchaseOrderClose: PurchaseOrder
    tradePurchaseOrderCreate: PurchaseOrder
    tradePurchaseOrderDelete: Scalars['Boolean']
    tradePurchaseOrderFileCreate: PurchaseOrderFileCreatePayload
    tradePurchaseOrderFreightCreate: PurchaseOrderFreight
    tradePurchaseOrderFreightDelete: Scalars['Boolean']
    tradePurchaseOrderFreightUpdate: PurchaseOrderFreight
    tradePurchaseOrderNextDocumentNumber: Scalars['String']
    tradePurchaseOrderOpen: PurchaseOrder
    tradePurchaseOrderReopen: PurchaseOrder
    tradePurchaseOrderUpdate: PurchaseOrder
    tradePurchaseOrderVoid: PurchaseOrder
    tradeQuoteAccept: Quote
    tradeQuoteClone: Quote[]
    tradeQuoteConvert: Quote
    tradeQuoteCreate: Quote
    tradeQuoteDelete: Scalars['Boolean']
    tradeQuoteNextDocumentNumber: Scalars['String']
    tradeQuoteReject: Quote
    tradeQuoteRestore: Quote
    tradeQuoteRevertToOpen: Quote
    tradeQuoteSend: Quote
    tradeQuoteUpdate: Quote
    tradeQuoteVoid: Quote
    tradeReconciliationBatchUpdate: LoadReconciliation
    tradeSalesOrderBulkVoid: BulkVoidSalesOrderResult
    tradeSalesOrderClone: SalesOrder
    tradeSalesOrderCreate: SalesOrder
    tradeSalesOrderCustomerFileCreate: SalesOrderCustomerFileCreatePayload
    tradeSalesOrderDelete: DeleteResult
    tradeSalesOrderFileCreate: SalesOrderFileCreatePayload
    tradeSalesOrderFreightCreate: SalesOrderFreight
    tradeSalesOrderFreightDelete: Scalars['Boolean']
    tradeSalesOrderFreightUpdate: SalesOrderFreight
    tradeSalesOrderNextDocumentNumber: Scalars['String']
    tradeSalesOrderRecyclerFileCreate: SalesOrderRecyclerFileCreatePayload
    tradeSalesOrderUpdate: SalesOrderUpdateResult
    tradeSalesOrderVoid: VoidSalesOrderResult
    tradeTicketFreightCreate: TicketFreight
    tradeTicketFreightDelete: Scalars['Boolean']
    tradeTicketFreightUpdate: TicketFreight
    transportationAddHaulers: Scalars['Boolean']
    transportationAssetCreate: Asset
    transportationAssetDelete: Scalars['Boolean']
    transportationAssetLocationHistoryCreate: AssetLocationHistory
    transportationAssetLocationHistoryDelete: Scalars['Boolean']
    transportationAssetTypeCreate: AssetType
    transportationAssetTypeDelete: Scalars['Boolean']
    transportationAssetTypeUpdate: AssetType
    transportationAssetUpdate: Asset
    transportationAssetUpdateFacility: Asset
    transportationContainerTypeCreate: ContainerType
    transportationContainerTypeDelete: Scalars['Boolean']
    transportationContainerTypeUpdate: ContainerType
    transportationDetentionCreate: Detention
    transportationDetentionDelete: Scalars['Boolean']
    transportationDetentionUpdate: Detention
    transportationDriverCertificationCreate: DriverCertification
    transportationDriverCertificationDelete: Scalars['Boolean']
    transportationDriverCertificationUpdate: DriverCertification
    transportationDriverCreate: Driver
    transportationDriverDelete: Scalars['Boolean']
    transportationDriverUpdate: Driver
    transportationFileConfirmUpload: File
    transportationFileDelete: Scalars['Boolean']
    transportationFreightForwarderCreate: FreightForwarder
    transportationFreightForwarderDelete: Scalars['Boolean']
    transportationFreightForwarderUpdate: FreightForwarder
    transportationFreightLaneCostCreate: FreightLaneCost
    transportationFreightLaneCostDelete: Scalars['Boolean']
    transportationFreightLaneCostUpdate: FreightLaneCost
    transportationFreightLaneCreate: FreightLane
    transportationFreightLaneDelete: Scalars['Boolean']
    transportationFreightLaneRouteCreate: FreightLaneRoute
    transportationFreightLaneRouteDelete: Scalars['Boolean']
    transportationFreightLaneRouteUpdate: FreightLaneRoute
    transportationFreightLaneUpdate: FreightLane
    transportationFreightLineCreate: FreightLine
    transportationFreightLineDelete: Scalars['Boolean']
    transportationFreightLineUpdate: FreightLine
    transportationRemoveHaulers: Scalars['Boolean']
    transportationRouteAssign: Route
    transportationRouteCreate: Route
    transportationRouteDelete: Scalars['Boolean']
    transportationRouteFreightCreate: RouteFreight
    transportationRouteFreightDelete: Scalars['Boolean']
    transportationRouteFreightUpdate: RouteFreight
    transportationRouteTransition: Route
    transportationRouteUnassign: Route
    transportationRouteUpdate: Route
    transportationRouteValidationOverrideCreate: RouteValidationOverride
    transportationRouteValidationOverrideDelete: Scalars['Boolean']
    transportationRouteValidationOverrideUpdate: RouteValidationOverride
    transportationServiceAssign: Service
    transportationServiceCreate: Service
    transportationServiceDelete: Scalars['Boolean']
    transportationServiceTransition: Service
    transportationServiceTypeCreateWithDefinitions: ServiceType
    transportationServiceTypeTaskDefinitionCreate: ServiceTypeTaskDefinition
    transportationServiceTypeTaskDefinitionDelete: Scalars['Boolean']
    transportationServiceTypeTaskDefinitionUpdate: ServiceTypeTaskDefinition
    transportationServiceTypeUpdate: ServiceType
    transportationServiceUnassign: Service
    transportationServiceUpdate: Service
    transportationSetDriverDisplayOrder: DriverDisplayOrder
    transportationShippingCarrierCreate: ShippingCarrier
    transportationShippingCarrierDelete: Scalars['Boolean']
    transportationShippingCarrierUpdate: ShippingCarrier
    transportationTaskCancel: Task
    transportationTaskPhotoCreate: TaskPhotoCreatePayload
    transportationTaskTransition: Task
    transportationTrailerCreate: Trailer
    transportationTrailerDelete: Scalars['Boolean']
    transportationTrailerUpdate: Trailer
    transportationTransportationTypeCreate: TransportationType
    transportationTransportationTypeDelete: Scalars['Boolean']
    transportationTransportationTypeUpdate: TransportationType
    transportationTruckCreate: Truck
    transportationTruckDelete: Scalars['Boolean']
    transportationTruckUpdate: Truck
    updateFacilityGeneralPreferences: (FacilityGeneralPreferences | null)
    updateFacilitySalesPreferences: (FacilitySalesPreferences | null)
    __typename: 'Mutation'
}

export interface NetPayResult {
    belowWarningThreshold: Scalars['Boolean']
    netAmount: Money
    payableTotal: Money
    payment: Payment
    receivableTotal: Money
    __typename: 'NetPayResult'
}

export type Node = (ApprovalNode | BusinessEventTriggerNode | ConditionNode | DelayNode | EmailActionNode | FilterNode | HttpRequestActionNode | HttpWebhookTriggerNode | LoopNode | ScheduleTriggerNode | SwitchNode) & { __isUnion?: true }

export interface NodeExecution {
    completedAt: Scalars['ZonedDateTime']
    durationMs: Scalars['Int']
    errorMessage: (Scalars['String'] | null)
    input: (Scalars['Map'] | null)
    nodeId: Scalars['String']
    nodeType: Scalars['String']
    output: (Scalars['Map'] | null)
    startedAt: Scalars['ZonedDateTime']
    status: NodeExecutionStatus
    __typename: 'NodeExecution'
}

export type NodeExecutionStatus = 'Failed' | 'Skipped' | 'Success'

export type NodeType = 'Approval' | 'BusinessEventTrigger' | 'Condition' | 'Delay' | 'EmailAction' | 'Filter' | 'HttpRequestAction' | 'HttpWebhookTrigger' | 'Loop' | 'ScheduleTrigger' | 'Switch'

export interface Notification {
    actionLink: (Scalars['String'] | null)
    actorId: (Scalars['ID'] | null)
    body: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    eventId: Scalars['String']
    id: Scalars['ID']
    notificationTypeKey: Scalars['String']
    resourceId: Scalars['String']
    resourceType: Scalars['String']
    timestamps: Timestamps
    title: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Notification'
}

export interface NotificationDevice {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    deviceToken: Scalars['String']
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    platform: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    userId: Scalars['ID']
    __typename: 'NotificationDevice'
}

export interface NotificationDeviceResultPage {
    entries: NotificationDevice[]
    page: Page
    __typename: 'NotificationDeviceResultPage'
}

export type NotificationDeviceSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DeviceTokenAsc' | 'DeviceTokenDesc' | 'PlatformAsc' | 'PlatformDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface NotificationFeedEntry {
    channel: Scalars['String']
    id: Scalars['ID']
    isArchived: Scalars['Boolean']
    isRead: Scalars['Boolean']
    isSeen: Scalars['Boolean']
    notification: Notification
    readAt: (Scalars['ZonedDateTime'] | null)
    seenAt: (Scalars['ZonedDateTime'] | null)
    timestamps: Timestamps
    __typename: 'NotificationFeedEntry'
}

export interface NotificationFeedPage {
    entries: NotificationFeedEntry[]
    hasMore: Scalars['Boolean']
    __typename: 'NotificationFeedPage'
}

export interface NotificationPreference {
    channel: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    enabled: Scalars['Boolean']
    id: Scalars['ID']
    notificationTypeKey: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    userId: Scalars['ID']
    __typename: 'NotificationPreference'
}

export interface NotificationPreferenceResultPage {
    entries: NotificationPreference[]
    page: Page
    __typename: 'NotificationPreferenceResultPage'
}

export type NotificationPreferenceSortOption = 'ChannelAsc' | 'ChannelDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotificationTypeKeyAsc' | 'NotificationTypeKeyDesc'

export interface NotificationRecipient {
    channel: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    isArchived: Scalars['Boolean']
    isRead: Scalars['Boolean']
    isSeen: Scalars['Boolean']
    notificationId: Scalars['ID']
    readAt: (Scalars['ZonedDateTime'] | null)
    recipientId: Scalars['ID']
    seenAt: (Scalars['ZonedDateTime'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'NotificationRecipient'
}

export interface NotificationRecipientResultPage {
    entries: NotificationRecipient[]
    page: Page
    __typename: 'NotificationRecipientResultPage'
}

export type NotificationRecipientSortOption = 'ChannelAsc' | 'ChannelDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'ReadAtAsc' | 'ReadAtDesc' | 'SeenAtAsc' | 'SeenAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface NotificationResultPage {
    entries: Notification[]
    page: Page
    __typename: 'NotificationResultPage'
}

export type NotificationSortOption = 'ActionLinkAsc' | 'ActionLinkDesc' | 'BodyAsc' | 'BodyDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'EventIDAsc' | 'EventIDDesc' | 'NotificationTypeKeyAsc' | 'NotificationTypeKeyDesc' | 'ResourceIDAsc' | 'ResourceIDDesc' | 'ResourceTypeAsc' | 'ResourceTypeDesc' | 'TitleAsc' | 'TitleDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface NotificationType {
    bodyTemplate: Scalars['String']
    category: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    defaultChannels: (Scalars['Map'] | null)
    icon: (Scalars['String'] | null)
    id: Scalars['ID']
    isCritical: Scalars['Boolean']
    key: Scalars['String']
    requiredPermission: (Scalars['String'] | null)
    timestamps: Timestamps
    titleTemplate: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'NotificationType'
}

export interface NotificationTypeResultPage {
    entries: NotificationType[]
    page: Page
    __typename: 'NotificationTypeResultPage'
}

export type NotificationTypeSortOption = 'CategoryAsc' | 'CategoryDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'KeyAsc' | 'KeyDesc'


/** Error returned when one-time code has expired */
export interface OneTimeCodeExpired {
    pendingAuthenticationToken: Scalars['String']
    __typename: 'OneTimeCodeExpired'
}

export interface Operation {
    description: Scalars['String']
    inputSchema: Scalars['Map']
    key: Scalars['String']
    name: Scalars['String']
    __typename: 'Operation'
}

export type OperationType = 'Brokerage' | 'Purchase' | 'Sale'

export interface Organization {
    createdAt: Scalars['ZonedDateTime']
    customAttributes: (Scalars['Map'] | null)
    domain: Scalars['String']
    entitlements: Scalars['String'][]
    facilities: Facility[]
    facilityGroups: FacilityGroup[]
    id: Scalars['ID']
    idpId: (Scalars['String'] | null)
    name: Scalars['String']
    onboardedAt: (Scalars['ZonedDateTime'] | null)
    timezone: (Scalars['Timezone'] | null)
    updatedAt: Scalars['ZonedDateTime']
    users: User[]
    __typename: 'Organization'
}

export interface OrganizationResetResult {
    newFacilityId: Scalars['ID']
    newOrganizationId: Scalars['ID']
    success: Scalars['Boolean']
    __typename: 'OrganizationResetResult'
}

export interface OrganizationResultPage {
    entries: Organization[]
    page: Page
    __typename: 'OrganizationResultPage'
}


/** Error returned when the user must select an organization to complete authentication */
export interface OrganizationSelectionError {
    organizations: (AuthenticationOrganization[] | null)
    pendingAuthenticationToken: Scalars['String']
    __typename: 'OrganizationSelectionError'
}

export type OrganizationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface OrphanedBookingSalesOrderLink {
    bookingId: Scalars['ID']
    documentNumber: Scalars['String']
    salesOrderId: Scalars['ID']
    salesOrderNumber: Scalars['String']
    __typename: 'OrphanedBookingSalesOrderLink'
}

export interface OutboundTollingAgreement {
    agreementNumber: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    effectiveDate: Scalars['CalendarDate']
    expectedYieldPercentage: (Scalars['Decimal'] | null)
    expirationDate: (Scalars['CalendarDate'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    pricePerUnit: (Money | null)
    priceUnit: (Scalars['String'] | null)
    processingType: (ProcessingType | null)
    processingTypeId: Scalars['ID']
    processorAccount: (Account | null)
    processorAccountId: Scalars['ID']
    terms: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'OutboundTollingAgreement'
}

export interface OutboundTollingAgreementResultPage {
    entries: OutboundTollingAgreement[]
    page: Page
    __typename: 'OutboundTollingAgreementResultPage'
}

export type OutboundTollingAgreementSortOption = 'AgreementNumberAsc' | 'AgreementNumberDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'EffectiveDateAsc' | 'EffectiveDateDesc' | 'ExpirationDateAsc' | 'ExpirationDateDesc'

export interface OutboxEvent {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    eventName: Scalars['String']
    id: Scalars['ID']
    lastRetry: (Scalars['ZonedDateTime'] | null)
    metadata: OutboxEventMetadata
    payload: Scalars['JSON']
    retryCount: Scalars['Int']
    status: OutboxEventStatus
    timestamps: Timestamps
    topic: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    version: Scalars['Int']
    __typename: 'OutboxEvent'
}

export interface OutboxEventMetadata {
    aggregateId: (Scalars['String'] | null)
    eventName: Scalars['String']
    id: Scalars['ID']
    occurredOn: Scalars['ZonedDateTime']
    organizationId: Scalars['ID']
    topic: Scalars['String']
    version: Scalars['Int']
    __typename: 'OutboxEventMetadata'
}

export interface OutboxEventResultPage {
    entries: OutboxEvent[]
    page: Page
    __typename: 'OutboxEventResultPage'
}

export type OutboxEventStatus = 'DeadLetter' | 'Failed' | 'Pending' | 'Processed'

export interface P2PRelayInfo {
    multiaddrs: Scalars['String'][]
    peerId: Scalars['String']
    __typename: 'P2PRelayInfo'
}

export interface Page {
    limit: Scalars['Int']
    offset: Scalars['Int']
    total: (Scalars['Int'] | null)
    __typename: 'Page'
}

export interface PayBillResult {
    belowWarningThreshold: Scalars['Boolean']
    payment: Payment
    totalDiscount: Money
    __typename: 'PayBillResult'
}

export interface Payment {
    account: (Account | null)
    achNumber: (Scalars['String'] | null)
    amount: Money
    atmId: (Scalars['String'] | null)
    atmPaymentNumber: (Scalars['String'] | null)
    barcode: (Scalars['String'] | null)
    barcodeRowId: (Scalars['Int'] | null)
    bills: BillPaymentApplication[]
    checkAttn: (Scalars['String'] | null)
    checkFacilityId: (Scalars['ID'] | null)
    checkMemo: (Scalars['String'] | null)
    checkNumber: (Scalars['String'] | null)
    creatorId: (Scalars['ID'] | null)
    creatorPlatform: (CreatorPlatform | null)
    documentNumber: Scalars['String']
    financialAccount: (FinancialAccount | null)
    financialAccountId: Scalars['ID']
    financialAccountTransaction: (FinancialAccountTransaction | null)
    financialAccountTransactionId: (Scalars['ID'] | null)
    id: Scalars['ID']
    invoices: InvoicePaymentApplication[]
    paymentMethod: PaymentMethod
    paymentType: PaymentType
    status: PaymentStatus
    supplierPhotoId: (Scalars['ID'] | null)
    timestamps: Timestamps
    transactionDate: Scalars['CalendarDate']
    unappliedAmount: Money
    wireNumber: (Scalars['String'] | null)
    __typename: 'Payment'
}

export type PaymentAllocationMethod = 'FIFO' | 'LIFO' | 'WeightedDistribution'

export type PaymentApplicationType = 'Bill' | 'Invoice'

export interface PaymentItemResult {
    error: (Scalars['String'] | null)
    paymentId: Scalars['ID']
    success: Scalars['Boolean']
    __typename: 'PaymentItemResult'
}

export type PaymentMethod = 'ACH' | 'ATM' | 'Cash' | 'Check' | 'Wire' | 'WriteOff'

export interface PaymentResultPage {
    entries: Payment[]
    page: Page
    __typename: 'PaymentResultPage'
}

export type PaymentSortOption = 'AmountAsc' | 'AmountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'DateAsc' | 'DateDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type PaymentStatus = 'Issued' | 'Posted' | 'Voided' | 'VoidedWriteOff'

export type PaymentTerm = 'CAD' | 'CIA' | 'CND' | 'COD' | 'DueUponReceipt' | 'EOM' | 'LOC' | 'Net5' | 'Net10' | 'Net15' | 'Net20' | 'Net30' | 'Net45' | 'Net60' | 'Net90' | 'PIA'

export interface PaymentTermConfig {
    code: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    dateDrivenDiscountPercentage: (Scalars['Decimal'] | null)
    discountDueBeforeDayOfMonth: (Scalars['Int'] | null)
    discountIfPaidWithinDays: (Scalars['Int'] | null)
    discountPercentage: (Scalars['Decimal'] | null)
    id: Scalars['ID']
    isDateDriven: Scalars['Boolean']
    isSystem: Scalars['Boolean']
    name: Scalars['String']
    netDueBeforeDayOfMonth: (Scalars['Int'] | null)
    netDueInDays: (Scalars['Int'] | null)
    nextMonthDueIfIssuedWithinDays: (Scalars['Int'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'PaymentTermConfig'
}

export interface PaymentTermConfigResultPage {
    entries: PaymentTermConfig[]
    page: Page
    __typename: 'PaymentTermConfigResultPage'
}

export type PaymentTermConfigSortOption = 'CodeAsc' | 'CodeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export type PaymentType = 'Adjustment' | 'AdvanceIn' | 'AdvanceOut' | 'Bill' | 'Invoice' | 'Netting' | 'WriteOff'


/** Base interface for errors that occur when additional authentication steps are required */
export type PendingAuthenticationError = (EmailVerificationRequiredError | InvalidOneTimeCode | MfaChallengeError | MfaEnrollmentRequiredError | OneTimeCodeExpired | OrganizationSelectionError | SsoRequiredError) & { __isUnion?: true }

export interface PeriodTrialCloseResult {
    checklistItems: TrialCloseChecklistItem[]
    __typename: 'PeriodTrialCloseResult'
}

export interface Permission {
    action: Scalars['String']
    allowed: Scalars['Boolean']
    resource: Scalars['String']
    __typename: 'Permission'
}

export interface Permissions {
    primaryFacilityGroup: (Scalars['ID'] | null)
    privilegedFacilities: Scalars['ID'][]
    privilegedFacilityGroups: Scalars['ID'][]
    __typename: 'Permissions'
}

export interface PhotoInstruction {
    id: Scalars['String']
    instruction: Scalars['String']
    isRequired: Scalars['Boolean']
    __typename: 'PhotoInstruction'
}

export interface PhotoRequirement {
    description: Scalars['String']
    id: Scalars['ID']
    required: Scalars['Boolean']
    __typename: 'PhotoRequirement'
}

export interface PlaidExchangeTokenResponse {
    itemId: Scalars['String']
    __typename: 'PlaidExchangeTokenResponse'
}

export interface PlaidItem {
    id: Scalars['String']
    institution: Scalars['String']
    __typename: 'PlaidItem'
}

export interface PlaidLinkToken {
    expiresAt: Scalars['Int']
    token: Scalars['String']
    __typename: 'PlaidLinkToken'
}

export interface Point {
    latitude: Scalars['Decimal']
    longitude: Scalars['Decimal']
    __typename: 'Point'
}

export interface Polygon {
    Points: Point[]
    __typename: 'Polygon'
}

export interface Port {
    countryCode: Scalars['String']
    id: Scalars['ID']
    latitude: (Scalars['Decimal'] | null)
    locationCode: Scalars['String']
    longitude: (Scalars['Decimal'] | null)
    name: Scalars['String']
    terminals: Terminal[]
    timestamps: Timestamps
    unLocode: Scalars['String']
    __typename: 'Port'
}

export interface PortResultPage {
    entries: Port[]
    page: Page
    __typename: 'PortResultPage'
}

export type PortSortOption = 'CountryCodeAsc' | 'CountryCodeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'LocationCodeAsc' | 'LocationCodeDesc' | 'NameAsc' | 'NameDesc' | 'UnLocodeAsc' | 'UnLocodeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface Position {
    x: Scalars['Float']
    y: Scalars['Float']
    __typename: 'Position'
}

export interface PositionSummaryStats {
    negativePositions: Scalars['Int']
    totalIncoming: Scalars['Decimal']
    totalItems: Scalars['Int']
    totalOutgoing: Scalars['Decimal']
    __typename: 'PositionSummaryStats'
}

export interface PositivePayTemplate {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    definition: Scalars['String']
    fileType: Scalars['String']
    id: Scalars['ID']
    templateName: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'PositivePayTemplate'
}

export interface PositivePayTemplateResultPage {
    entries: PositivePayTemplate[]
    page: Page
    __typename: 'PositivePayTemplateResultPage'
}

export type PositivePayTemplateSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'TemplateNameAsc' | 'TemplateNameDesc'

export interface PresenceEvent {
    members: PresenceMember[]
    room: Scalars['String']
    type: PresenceEventType
    __typename: 'PresenceEvent'
}

export type PresenceEventType = 'JOIN' | 'LEAVE' | 'SNAPSHOT' | 'UPDATE'

export interface PresenceMember {
    id: Scalars['String']
    kind: Scalars['String']
    metadata: (Scalars['Map'] | null)
    name: (Scalars['String'] | null)
    __typename: 'PresenceMember'
}

export type PriceListType = 'Custom' | 'Default'

export type PricingMode = 'CRV' | 'Standard'

export interface Printer {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    driverType: Scalars['String']
    firmwareVersion: (Scalars['String'] | null)
    id: Scalars['ID']
    lastSeenAt: (Scalars['ZonedDateTime'] | null)
    manufacturer: (Scalars['String'] | null)
    model: (Scalars['String'] | null)
    name: Scalars['String']
    online: Scalars['Boolean']
    pageSize: (PrinterPageSize | null)
    printerType: PrinterType
    rollWidth: (PrinterRollWidth | null)
    sidecar: (Sidecar | null)
    sidecarId: Scalars['ID']
    status: PrinterStatus
    timestamps: Timestamps
    uniqueId: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Printer'
}

export type PrinterPageSize = 'A4' | 'Legal' | 'Letter'

export interface PrinterResultPage {
    entries: Printer[]
    page: Page
    __typename: 'PrinterResultPage'
}

export type PrinterRollWidth = 'Roll58mm' | 'Roll80mm'

export type PrinterSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DriverTypeAsc' | 'DriverTypeDesc' | 'NameAsc' | 'NameDesc' | 'PrinterTypeAsc' | 'PrinterTypeDesc' | 'StatusAsc' | 'StatusDesc'

export type PrinterStatus = 'Discovered'

export type PrinterType = 'Standard' | 'Thermal'

export interface ProcessingType {
    code: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: (Scalars['String'] | null)
    hasRecipe: Scalars['Boolean']
    id: Scalars['ID']
    inputItems: ProcessingTypeInputItem[]
    isActive: Scalars['Boolean']
    name: Scalars['String']
    outputItems: ProcessingTypeOutputItem[]
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ProcessingType'
}

export interface ProcessingTypeInputItem {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    isPrimary: Scalars['Boolean']
    item: Item
    itemId: Scalars['ID']
    notes: (Scalars['String'] | null)
    processingTypeId: Scalars['ID']
    sortOrder: Scalars['Int']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ProcessingTypeInputItem'
}

export interface ProcessingTypeInputItemResultPage {
    entries: ProcessingTypeInputItem[]
    page: Page
    __typename: 'ProcessingTypeInputItemResultPage'
}

export type ProcessingTypeInputItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'SortOrderAsc' | 'SortOrderDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ProcessingTypeOutputItem {
    costAllocationPercentage: (Scalars['Decimal'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    isNoCost: Scalars['Boolean']
    isPrimary: Scalars['Boolean']
    item: Item
    itemId: Scalars['ID']
    notes: (Scalars['String'] | null)
    outputUnit: Unit
    processingTypeId: Scalars['ID']
    sortOrder: Scalars['Int']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    yieldPercentage: Scalars['Decimal']
    __typename: 'ProcessingTypeOutputItem'
}

export interface ProcessingTypeOutputItemResultPage {
    entries: ProcessingTypeOutputItem[]
    page: Page
    __typename: 'ProcessingTypeOutputItemResultPage'
}

export type ProcessingTypeOutputItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'SortOrderAsc' | 'SortOrderDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ProcessingTypeResultPage {
    entries: ProcessingType[]
    page: Page
    __typename: 'ProcessingTypeResultPage'
}

export type ProcessingTypeSortOption = 'CodeAsc' | 'CodeDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export interface ProvisionFacilityAccountsResult {
    created_accounts: InventoryAccount[]
    existing_accounts: InventoryAccount[]
    __typename: 'ProvisionFacilityAccountsResult'
}

export type PurchaseLineItemType = 'CatalyticConverter' | 'Freight' | 'Mixed' | 'Raw' | 'Tagged' | 'Vehicle'

export interface PurchaseLoad {
    bill: (Bill | null)
    billId: (Scalars['ID'] | null)
    bolNumber: (Scalars['String'] | null)
    carrierAccount: (Account | null)
    carrierAccountId: (Scalars['ID'] | null)
    complianceChecks: ComplianceCheck[]
    complianceHold: (ComplianceHold | null)
    containerNumber: (Scalars['String'] | null)
    containerType: (ContainerType | null)
    containerTypeId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currencyCode: Scalars['String']
    deductions: PurchaseLoadDeduction[]
    deductionsTotal: Money
    description: (Scalars['String'] | null)
    documentNumber: Scalars['String']
    driverName: (Scalars['String'] | null)
    externalNotes: (Scalars['String'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    files: File[]
    freightCost: (Money | null)
    freightTerms: (Scalars['String'] | null)
    grandTotal: Money
    heavyWeight: (Weight | null)
    id: Scalars['ID']
    internalNotes: (Scalars['String'] | null)
    lightWeight: (Weight | null)
    lineItems: PurchaseLoadLineItem[]
    payments: PurchaseLoadPayment[]
    purchaseOrder: (PurchaseOrder | null)
    purchaseOrderId: (Scalars['ID'] | null)
    receivedById: (Scalars['ID'] | null)
    receivedByUser: (User | null)
    receivedDate: Scalars['ZonedDateTime']
    receivedTicketIssueDate: (Scalars['CalendarDate'] | null)
    receivingTicketNumber: (Scalars['String'] | null)
    scac: (Scalars['String'] | null)
    sealNumber: (Scalars['String'] | null)
    service: (Service | null)
    serviceId: (Scalars['ID'] | null)
    shippingCarrierName: (Scalars['String'] | null)
    sourceFacility: (Facility | null)
    sourceFacilityId: (Scalars['ID'] | null)
    sourceLoad: (Load | null)
    sourceLoadId: (Scalars['ID'] | null)
    status: PurchaseLoadStatus
    subtotal: Money
    supplierAccount: (Account | null)
    supplierAccountId: (Scalars['ID'] | null)
    supplierAddress: (AccountAddress | null)
    supplierAddressId: (Scalars['ID'] | null)
    timestamps: Timestamps
    trailerNumber: (Scalars['String'] | null)
    truckNumber: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    vehicleColor: (Scalars['String'] | null)
    vehicleLicensePlate: (Scalars['String'] | null)
    vehicleMake: (Scalars['String'] | null)
    vehicleModel: (Scalars['String'] | null)
    vehiclePlateState: (Scalars['String'] | null)
    vehicleVin: (Scalars['String'] | null)
    vehicleYear: (Scalars['String'] | null)
    version: Scalars['Int']
    voidReason: (Scalars['String'] | null)
    weightDisplayUnit: WeightDisplayUnit
    __typename: 'PurchaseLoad'
}

export interface PurchaseLoadDeduction {
    applicationType: DeductionApplicationType
    calculatedAmount: (Money | null)
    deductionType: DeductionType
    deductionTypeId: Scalars['ID']
    facilityId: Scalars['ID']
    id: Scalars['ID']
    lineItem: (PurchaseLoadLineItem | null)
    notes: (Scalars['String'] | null)
    percentage: (Scalars['Decimal'] | null)
    priceValue: (Money | null)
    purchaseLoadId: Scalars['ID']
    purchaseLoadLineItemId: (Scalars['ID'] | null)
    weightValue: (Weight | null)
    __typename: 'PurchaseLoadDeduction'
}

export interface PurchaseLoadDeductionResultPage {
    entries: PurchaseLoadDeduction[]
    page: Page
    __typename: 'PurchaseLoadDeductionResultPage'
}

export type PurchaseLoadDeductionSortOption = 'ApplicationTypeAsc' | 'ApplicationTypeDesc' | 'NotesAsc' | 'NotesDesc'

export interface PurchaseLoadFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'PurchaseLoadFileCreatePayload'
}

export interface PurchaseLoadLineItem {
    catComplianceStatus: (Scalars['String'] | null)
    catOemCode: (Scalars['String'] | null)
    catSerialNumber: (Scalars['String'] | null)
    childLineItems: PurchaseLoadLineItem[]
    estimatedPrice: (Money | null)
    facilityId: Scalars['ID']
    grossWeight: (Weight | null)
    id: Scalars['ID']
    item: (Item | null)
    itemId: (Scalars['ID'] | null)
    netWeight: (Weight | null)
    notes: (Scalars['String'] | null)
    parentLineItem: (PurchaseLoadLineItem | null)
    parentLineItemId: (Scalars['ID'] | null)
    pricingUnit: (Unit | null)
    purchaseLoadId: Scalars['ID']
    purchaseOrderLine: (PurchaseOrderLineItem | null)
    purchaseOrderLineId: (Scalars['ID'] | null)
    requiresSorting: Scalars['Boolean']
    settlementBasis: SettlementBasis
    sortingWorkOrder: (WorkOrder | null)
    tagId: (Scalars['ID'] | null)
    tareWeight: (Weight | null)
    type: PurchaseLineItemType
    unitPrice: (Money | null)
    vehicleMake: (Scalars['String'] | null)
    vehicleModel: (Scalars['String'] | null)
    vehicleTitleStatus: (Scalars['String'] | null)
    vehicleVin: (Scalars['String'] | null)
    vehicleYear: (Scalars['Int'] | null)
    __typename: 'PurchaseLoadLineItem'
}

export interface PurchaseLoadLineItemResultPage {
    entries: PurchaseLoadLineItem[]
    page: Page
    __typename: 'PurchaseLoadLineItemResultPage'
}

export type PurchaseLoadLineItemSortOption = 'CatComplianceStatusAsc' | 'CatComplianceStatusDesc' | 'CatOemCodeAsc' | 'CatOemCodeDesc' | 'CatSerialNumberAsc' | 'CatSerialNumberDesc' | 'NotesAsc' | 'NotesDesc' | 'SettlementBasisAsc' | 'SettlementBasisDesc' | 'TypeAsc' | 'TypeDesc' | 'VehicleMakeAsc' | 'VehicleMakeDesc' | 'VehicleModelAsc' | 'VehicleModelDesc' | 'VehicleTitleStatusAsc' | 'VehicleTitleStatusDesc' | 'VehicleVinAsc' | 'VehicleVinDesc' | 'VehicleYearAsc' | 'VehicleYearDesc'

export interface PurchaseLoadPayment {
    amount: Money
    checkMemo: (Scalars['String'] | null)
    checkNumber: (Scalars['String'] | null)
    creatorId: (Scalars['ID'] | null)
    facilityId: Scalars['ID']
    financialAccountId: (Scalars['ID'] | null)
    id: Scalars['ID']
    legalHold: Scalars['Boolean']
    paymentMethod: Scalars['String']
    paymentTerm: Scalars['String']
    percentage: (Scalars['Decimal'] | null)
    purchaseLoadId: Scalars['ID']
    roundingMethod: (Scalars['String'] | null)
    roundingPrecision: (Scalars['String'] | null)
    __typename: 'PurchaseLoadPayment'
}

export interface PurchaseLoadPaymentResultPage {
    entries: PurchaseLoadPayment[]
    page: Page
    __typename: 'PurchaseLoadPaymentResultPage'
}

export type PurchaseLoadPaymentSortOption = 'CheckMemoAsc' | 'CheckMemoDesc' | 'CheckNumberAsc' | 'CheckNumberDesc' | 'PaymentMethodAsc' | 'PaymentMethodDesc' | 'PaymentTermAsc' | 'PaymentTermDesc' | 'RoundingMethodAsc' | 'RoundingMethodDesc' | 'RoundingPrecisionAsc' | 'RoundingPrecisionDesc'

export interface PurchaseLoadResultPage {
    entries: PurchaseLoad[]
    page: Page
    __typename: 'PurchaseLoadResultPage'
}

export type PurchaseLoadSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DocumentNumberAsc' | 'DocumentNumberDesc' | 'ReceivedDateAsc' | 'ReceivedDateDesc'

export type PurchaseLoadStatus = 'Held' | 'InventoryComplete' | 'Open' | 'Paid' | 'PriceComplete' | 'Voided'

export interface PurchaseOrder {
    account: Account
    accountAddressId: Scalars['ID']
    accountContactId: (Scalars['ID'] | null)
    accountId: Scalars['ID']
    accountRepresentativeId: (Scalars['ID'] | null)
    allocatedPercentage: (Scalars['Decimal'] | null)
    completionNotes: (Scalars['String'] | null)
    contact: (Contact | null)
    counterpartyReferenceNumber: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    documentNumber: Scalars['String']
    endDate: (Scalars['CalendarDate'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    files: File[]
    freightTerm: FreightTerm
    fulfilledPercentage: (Scalars['Decimal'] | null)
    id: Scalars['ID']
    lineItems: PurchaseOrderLineItem[]
    notes: (Scalars['String'] | null)
    paymentCurrency: Scalars['String']
    paymentTerm: PaymentTerm
    startDate: (Scalars['CalendarDate'] | null)
    status: PurchaseOrderStatus
    timestamps: Timestamps
    totalAllocated: Scalars['Decimal']
    totalFulfilled: Scalars['Decimal']
    totalQuantity: (Scalars['Decimal'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'PurchaseOrder'
}

export interface PurchaseOrderFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'PurchaseOrderFileCreatePayload'
}

export interface PurchaseOrderFreight {
    carrierId: (Scalars['ID'] | null)
    chargebackFormula: (Scalars['String'] | null)
    chargebackVariableIds: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    freightLaneId: (Scalars['String'] | null)
    fuelSurchargeFormula: (Scalars['String'] | null)
    fuelSurchargeMode: (Scalars['String'] | null)
    fuelSurchargeVariableIds: (Scalars['String'] | null)
    id: Scalars['ID']
    notes: (Scalars['String'] | null)
    purchaseOrderId: Scalars['ID']
    rateFormula: (Scalars['String'] | null)
    rateVariableIds: (Scalars['String'] | null)
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'PurchaseOrderFreight'
}

export interface PurchaseOrderFreightResultPage {
    entries: PurchaseOrderFreight[]
    page: Page
    __typename: 'PurchaseOrderFreightResultPage'
}

export type PurchaseOrderFreightSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface PurchaseOrderLineItem {
    allocatedPercentage: (Scalars['Decimal'] | null)
    allocatedQuantity: Scalars['Decimal']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    fulfilledPercentage: (Scalars['Decimal'] | null)
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    purchaseOrderId: Scalars['ID']
    quantity: (Scalars['Decimal'] | null)
    receivedQuantity: Scalars['Decimal']
    timestamps: Timestamps
    totalPrice: Money
    unit: (Unit | null)
    unitPrice: Money
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'PurchaseOrderLineItem'
}

export interface PurchaseOrderLineItemResultPage {
    entries: PurchaseOrderLineItem[]
    page: Page
    __typename: 'PurchaseOrderLineItemResultPage'
}

export type PurchaseOrderLineItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface PurchaseOrderResultPage {
    entries: PurchaseOrder[]
    page: Page
    __typename: 'PurchaseOrderResultPage'
}

export type PurchaseOrderSortOption = 'AccountAsc' | 'AccountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'EndDateAsc' | 'EndDateDesc' | 'NumberAsc' | 'NumberDesc' | 'PaymentCurrencyAsc' | 'PaymentCurrencyDesc' | 'StartDateAsc' | 'StartDateDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type PurchaseOrderStatus = 'Closed' | 'Draft' | 'Open' | 'Voided'

export interface PurchaseOrderStatusCounts {
    closed: Scalars['Int']
    draft: Scalars['Int']
    open: Scalars['Int']
    total: Scalars['Int']
    voided: Scalars['Int']
    __typename: 'PurchaseOrderStatusCounts'
}

export type QuantityCaptureMethod = 'Automatic' | 'Manual'

export interface Query {
    _complianceServiceStatus: Scalars['String']
    _notificationServiceStatus: (Scalars['Boolean'] | null)
    _pricingServiceStatus: Scalars['String']
    account: (Account | null)
    accountAddress: (AccountAddress | null)
    accountAddresses: AccountAddressResultPage
    accountAddressesByAccountId: AccountAddress[]
    accountBankDetail: (AccountBankDetail | null)
    accountBankDetails: AccountBankDetailResultPage
    accounts: AccountResultPage
    agent: (Agent | null)
    agents: AgentResultPage
    asset: (Asset | null)
    assetLocationHistories: AssetLocationHistoryResultPage
    assetLocationHistory: (AssetLocationHistory | null)
    assetType: (AssetType | null)
    assetTypes: AssetTypeResultPage
    assets: AssetResultPage
    assetsInRegion: AssetResultPage
    assistantChat: (AssistantChat | null)
    assistantChatByShareToken: (AssistantChat | null)
    assistantChatMessages: AssistantChatMessage[]
    assistantChats: AssistantChatResultPage
    assistantOrganizationUsageMetrics: UsageMetricsResultPage
    assistantOutboxEventCounts: AssistantOutboxEventCounts
    assistantOutboxEvents: OutboxEventResultPage
    assistantSystemUsageMetrics: UsageMetricsResultPage
    /** Checks if the authentication service is currently available */
    authenticationAvailable: (Scalars['Boolean'] | null)
    automation: (Automation | null)
    automationValidate: FlowValidationResult
    automationVersion: (AutomationVersion | null)
    automationVersions: AutomationVersionResultPage
    automations: AutomationResultPage
    automationsApprovalRequest: (ApprovalRequest | null)
    automationsPendingApprovals: ApprovalRequestResultPage
    billStatusCounts: BillStatusCounts
    bills: BillResultPage
    bookingStatusCounts: BookingStatusCounts
    bookings: BookingResultPage
    brokeredOrder: (BrokeredOrder | null)
    brokeredOrders: BrokeredOrderResultPage
    camera: (Camera | null)
    cameras: CameraResultPage
    categories: CategoryResultPage
    checkSupplierPriceListAffectsMaterials: SupplierPriceListAffectsMaterialsResult
    checkTemplate: (CheckTemplate | null)
    checkTemplates: CheckTemplateResultPage
    checkUserPermission: Permission
    checkUserPermissions: Permission[]
    collabUserConversations: TalkJSConversationListResult
    complianceCheck: (ComplianceCheck | null)
    complianceChecks: ComplianceCheckResultPage
    complianceDispatchRecord: (ComplianceDispatchRecord | null)
    complianceDispatchRecords: ComplianceDispatchRecordResultPage
    complianceEvaluateTransaction: ComplianceEvaluationResult
    complianceFacilityRule: (ComplianceFacilityRule | null)
    complianceFacilityRules: ComplianceFacilityRuleResultPage
    complianceHold: (ComplianceHold | null)
    complianceHolds: ComplianceHoldResultPage
    complianceItemJurisdictionCode: (ComplianceItemJurisdictionCode | null)
    complianceItemJurisdictionCodes: ComplianceItemJurisdictionCodeResultPage
    complianceRuleDefinition: (ComplianceRuleDefinition | null)
    complianceRuleDefinitions: ComplianceRuleDefinitionResultPage
    contact: (Contact | null)
    contacts: ContactResultPage
    contactsByAccount: Contact[]
    container: (Container | null)
    containerStatusCounts: ContainerStatusCounts
    containerType: (ContainerType | null)
    containerTypes: ContainerTypeResultPage
    containers: ContainerResultPage
    coreOutboxEventCounts: CoreOutboxEventCounts
    coreOutboxEvents: OutboxEventResultPage
    coreRole: (Role | null)
    coreRoles: RoleResultPage
    coreUserRoleAssignment: (UserRoleAssignment | null)
    coreUserRoleAssignments: UserRoleAssignmentResultPage
    coreUsersByOrganization: UserResultPage
    counterpartyGroup: (CounterpartyGroup | null)
    counterpartyGroupMemberDetails: CounterpartyGroupMember[]
    counterpartyGroupMembers: Scalars['ID'][]
    counterpartyGroups: CounterpartyGroupResultPage
    counterpartyGroupsByAccount: CounterpartyGroup[]
    crmOutboxEventCounts: CrmOutboxEventCounts
    crmOutboxEvents: OutboxEventResultPage
    customAttributeDefinitions: CustomAttribute[]
    customPriceList: (CustomPriceList | null)
    customPriceListStatusCounts: CustomPriceListStatusCounts
    customPriceLists: CustomPriceListResultPage
    customerBookings: BookingResultPage
    customerInvitationByToken: (CustomerInvitation | null)
    customerInvitations: CustomerInvitationResultPage
    customerLoads: LoadResultPage
    customerSalesOrders: SalesOrderResultPage
    cycleCountLine: (CycleCountLine | null)
    cycleCountLines: CycleCountLineResultPage
    cycleCountSchedule: (CycleCountSchedule | null)
    cycleCountSchedules: CycleCountScheduleResultPage
    cycleCountTask: (CycleCountTask | null)
    cycleCountTasks: CycleCountTaskResultPage
    deductionType: (DeductionType | null)
    deductionTypes: DeductionTypeResultPage
    defaultPhotoRequirements: DefaultPhotoRequirement[]
    defaultPriceList: (DefaultPriceList | null)
    detention: (Detention | null)
    detentions: DetentionResultPage
    directories: (File[] | null)
    doNotBuyEntries: DoNotBuyEntryResultPage
    doNotBuyEntry: (DoNotBuyEntry | null)
    driver: (Driver | null)
    driverCertification: (DriverCertification | null)
    driverCertifications: DriverCertificationResultPage
    driverTotalServicesCompleted: Scalars['Int']
    drivers: DriverResultPage
    evaluateAdHocFormulas: EvaluatedFormula[]
    evaluateFormulas: EvaluatedItemPricing[]
    executionRun: (ExecutionRun | null)
    executionRuns: ExecutionRunResultPage
    facilities: FacilityResultPage
    facilitiesNearby: Facility[]
    facility: (Facility | null)
    facilityAtm: (FacilityAtm | null)
    facilityAtms: FacilityAtmResultPage
    facilityGeneralPreferences: (FacilityGeneralPreferences | null)
    facilityGroup: (FacilityGroup | null)
    facilityGroups: FacilityGroupResultPage
    facilitySalesPreferences: (FacilitySalesPreferences | null)
    facilityServiceTypes: ServiceType[]
    file: (File | null)
    fileTemplate: (FileTemplate | null)
    fileTemplates: FileTemplateResultPage
    files: FileConnection
    filesOutboxEventCounts: FilesOutboxEventCounts
    filesOutboxEvents: OutboxEventResultPage
    filesWOPICanEdit: Scalars['Boolean']
    filesWOPIDiscovery: WOPIDiscoveryInfo
    financeAccountsWithBalance: Account[]
    financeAtmPaymentsRequiringVoidConfirmation: Payment[]
    financeGeneratePositivePayFile: Scalars['String']
    financeNextBillDocumentNumber: Scalars['String']
    financeNextCheckNumber: Scalars['String']
    financeNextInvoiceDocumentNumber: Scalars['String']
    financeNextPaymentDocumentNumber: Scalars['String']
    financeOutboxEventCounts: FinanceOutboxEventCounts
    financeOutboxEvents: OutboxEventResultPage
    financeUnappliedAdvanceBalance: (UnappliedAdvanceBalance | null)
    financeUnappliedAdvances: Payment[]
    financialAccountAdjustment: (FinancialAccountAdjustment | null)
    financialAccountAdjustments: FinancialAccountAdjustmentResultPage
    financialAccountTransactions: FinancialAccountTransactionResultPage
    financialAccounts: FinancialAccountResultPage
    freightForwarder: (FreightForwarder | null)
    freightForwarders: FreightForwarderResultPage
    freightLane: (FreightLane | null)
    freightLaneCost: (FreightLaneCost | null)
    freightLaneCosts: FreightLaneCostResultPage
    freightLaneRoute: (FreightLaneRoute | null)
    freightLaneRoutes: FreightLaneRouteResultPage
    freightLanes: FreightLaneResultPage
    freightLine: (FreightLine | null)
    freightLines: FreightLineResultPage
    getPersonalContact: UserContact
    governmentReportingConfiguration: (GovernmentReportingConfiguration | null)
    governmentReportingConfigurations: GovernmentReportingConfigurationResultPage
    governmentReportingFacilities: GovernmentReportingFacilityResultPage
    governmentReportingFacility: (GovernmentReportingFacility | null)
    haulers: Organization[]
    inboundTollingAgreement: (InboundTollingAgreement | null)
    inboundTollingAgreements: InboundTollingAgreementResultPage
    integrations: Integration[]
    inventoryFacilitySettings: (InventoryFacilitySettings | null)
    /**
     * List inventory levels with filtering and pagination.
     * Returns aggregated inventory levels calculated from completed movements.
     */
    inventoryLevels: InventoryLevelResultPage
    inventoryLot: (InventoryLot | null)
    inventoryLotTraceBackward: LotTraceBackwardResult
    inventoryLotTraceForward: LotTraceForwardResult
    inventoryLots: InventoryLotResultPage
    inventoryMovement: (InventoryMovement | null)
    inventoryMovementHistory: InventoryMovementHistoryResultPage
    inventoryMovements: InventoryMovementResultPage
    inventoryOutboxEventCounts: InventoryOutboxEventCounts
    inventoryOutboxEvents: OutboxEventResultPage
    inventoryPeriod: (InventoryPeriod | null)
    inventoryPeriodBalance: (InventoryPeriodBalance | null)
    inventoryPeriodBalances: InventoryPeriodBalanceResultPage
    inventoryPeriodConfig: (InventoryPeriodConfig | null)
    inventoryPeriodConfigByOrganization: (InventoryPeriodConfig | null)
    inventoryPeriodTrialClose: PeriodTrialCloseResult
    inventoryPeriods: InventoryPeriodResultPage
    inventoryTag: (InventoryTag | null)
    inventoryTagByTagNumber: (InventoryTag | null)
    inventoryTagReconciliationReport: TagReconciliationReport
    inventoryTags: InventoryTagResultPage
    inventoryTagsByCustomAttribute: InventoryTag[]
    inventoryZone: (InventoryZone | null)
    inventoryZoneHierarchy: InventoryZone[]
    inventoryZones: InventoryZoneResultPage
    invoiceStatusCounts: InvoiceStatusCounts
    invoices: InvoiceResultPage
    iotP2PRelayInfo: P2PRelayInfo
    itemAliases: ItemAliasResultPage
    itemGroups: ItemGroupResultPage
    itemPriceConfiguration: (ItemPriceConfiguration | null)
    itemPriceConfigurations: ItemPriceConfigurationResultPage
    itemPricings: ItemPricing[]
    items: ItemResultPage
    load: (Load | null)
    loadBoard: LoadBoard
    loadReconciliation: (LoadReconciliation | null)
    loadReconciliationSummary: LoadReconciliationSummaryResultPage
    loadStatusCounts: LoadStatusCounts
    loads: LoadResultPage
    locationFreightPricing: (LocationFreightPricing | null)
    locationFreightPricings: LocationFreightPricingResultPage
    notificationFeed: NotificationFeedPage
    notificationPreference: (NotificationPreference | null)
    notificationPreferences: NotificationPreferenceResultPage
    notificationType: (NotificationType | null)
    notificationTypes: NotificationTypeResultPage
    notificationUnreadCount: Scalars['Int']
    organizationByName: (Organization | null)
    organizations: OrganizationResultPage
    outboundTollingAgreement: (OutboundTollingAgreement | null)
    outboundTollingAgreements: OutboundTollingAgreementResultPage
    paymentTermConfig: (PaymentTermConfig | null)
    paymentTermConfigs: PaymentTermConfigResultPage
    payments: PaymentResultPage
    plaidItems: ((PlaidItem | null)[] | null)
    port: (Port | null)
    portByUnLocode: (Port | null)
    ports: PortResultPage
    positivePayTemplate: (PositivePayTemplate | null)
    positivePayTemplates: PositivePayTemplateResultPage
    pricingCheckCounterpartiesInGroups: Scalars['ID'][]
    pricingCustomPriceListHistory: OutboxEvent[]
    pricingDefaultPriceListHistory: OutboxEvent[]
    pricingItemPricingsWithDirtyTracking: ItemPricingDirtyAwareResult
    pricingVariableHistory: OutboxEvent[]
    printer: (Printer | null)
    printers: PrinterResultPage
    processingType: (ProcessingType | null)
    processingTypes: ProcessingTypeResultPage
    purchaseLoad: (PurchaseLoad | null)
    purchaseLoads: PurchaseLoadResultPage
    purchaseOrderCountByStatus: PurchaseOrderStatusCounts
    purchaseOrderFreight: (PurchaseOrderFreight | null)
    purchaseOrderFreights: PurchaseOrderFreightResultPage
    purchaseOrders: PurchaseOrderResultPage
    quote: (Quote | null)
    quotes: QuoteResultPage
    resolveItemPrice: (ItemPrice | null)
    route: (Route | null)
    routeFreight: (RouteFreight | null)
    routeFreights: RouteFreightResultPage
    routeLegs: RouteLeg[]
    routeValidationOverride: (RouteValidationOverride | null)
    routeValidationOverrides: RouteValidationOverrideResultPage
    routes: RouteResultPage
    salesOrderFreight: (SalesOrderFreight | null)
    salesOrderFreights: SalesOrderFreightResultPage
    salesOrders: SalesOrderResultPage
    scale: (Scale | null)
    scales: ScaleResultPage
    scanner: (Scanner | null)
    scanners: ScannerResultPage
    service: (Service | null)
    serviceType: (ServiceType | null)
    serviceTypeTaskDefinition: (ServiceTypeTaskDefinition | null)
    serviceTypeTaskDefinitions: ServiceTypeTaskDefinitionResultPage
    serviceTypes: ServiceTypeResultPage
    services: ServiceResultPage
    setting: (Setting | null)
    settings: SettingResultPage
    settingsGroup: (SettingsGroup | null)
    settingsGroups: SettingsGroupResultPage
    shippingCarrier: (ShippingCarrier | null)
    shippingCarriers: ShippingCarrierResultPage
    sidecar: (Sidecar | null)
    sidecars: SidecarResultPage
    storageQuota: StorageQuota
    task: (Task | null)
    taskService: (TaskService | null)
    taskServices: TaskServiceResultPage
    tasks: TaskResultPage
    ticketFreight: (TicketFreight | null)
    ticketFreights: TicketFreightResultPage
    tollReceipt: (TollReceipt | null)
    tollReceipts: TollReceiptResultPage
    tollShipment: (TollShipment | null)
    tollShipments: TollShipmentResultPage
    tradeBrokeredOrderCalculateMargins: ItemMarginResult[]
    tradeBrokeredOrderValidate: BrokeredOrderValidationResult
    tradeItemPositions: ItemPositionResultPage
    tradeOutboxEventCounts: TradeOutboxEventCounts
    tradeOutboxEvents: OutboxEventResultPage
    trailer: (Trailer | null)
    trailers: TrailerResultPage
    transportationAccounts: Account[]
    transportationFacilities: Facility[]
    transportationOutboxEventCounts: TransportationOutboxEventCounts
    transportationOutboxEvents: OutboxEventResultPage
    transportationRouteValidate: RouteValidationResult
    transportationServiceValidate: RouteValidationResult
    transportationType: (TransportationType | null)
    transportationTypes: TransportationTypeResultPage
    truck: (Truck | null)
    trucks: TruckResultPage
    userContactsList: UserContactsListResult
    userPreferences: UserPreferences
    users: UserResultPage
    variable: (Variable | null)
    variables: VariableResultPage
    voucherTemplate: (VoucherTemplate | null)
    voucherTemplates: VoucherTemplateResultPage
    warehouseCredential: (WarehouseCredential | null)
    warehouseCredentials: WarehouseCredentialResultPage
    workOrder: (WorkOrder | null)
    workOrders: WorkOrderResultPage
    __typename: 'Query'
}

export interface Quote {
    account: Account
    accountId: Scalars['ID']
    convertedToOrder: (SalesOrder | null)
    convertedToOrderId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    documentNumber: Scalars['String']
    expectedShipDate: (Scalars['ZonedDateTime'] | null)
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    freightCoveredByCustomer: (Scalars['Boolean'] | null)
    freightTerm: (FreightTerm | null)
    id: Scalars['ID']
    lineItems: QuoteLineItem[]
    notes: (Scalars['String'] | null)
    paymentCurrency: (CurrencyCode | null)
    paymentTerm: (PaymentTerm | null)
    quoteDeadline: (Scalars['ZonedDateTime'] | null)
    status: QuoteStatus
    subtotal: Money
    terms: (Scalars['String'] | null)
    timestamps: Timestamps
    type: QuoteType
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    validUntil: (Scalars['ZonedDateTime'] | null)
    __typename: 'Quote'
}

export interface QuoteLineItem {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    item: (Item | null)
    itemId: Scalars['ID']
    notes: (Scalars['String'] | null)
    packageFormat: (Scalars['String'] | null)
    quantity: Scalars['Decimal']
    quote: Quote
    quoteId: Scalars['ID']
    timestamps: Timestamps
    totalPrice: Money
    unit: Unit
    unitPrice: Money
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'QuoteLineItem'
}

export interface QuoteLineItemResultPage {
    entries: QuoteLineItem[]
    page: Page
    __typename: 'QuoteLineItemResultPage'
}

export type QuoteLineItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'PackageFormatAsc' | 'PackageFormatDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface QuoteResultPage {
    entries: Quote[]
    page: Page
    __typename: 'QuoteResultPage'
}

export type QuoteSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DocumentNumberAsc' | 'DocumentNumberDesc' | 'StatusAsc' | 'StatusDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'ValidUntilAsc' | 'ValidUntilDesc'

export type QuoteStatus = 'Accepted' | 'Converted' | 'Draft' | 'Expired' | 'Rejected' | 'Sent' | 'Voided'

export type QuoteType = 'Purchase' | 'Sales'

export interface ReceiveInvoiceResult {
    belowWarningThreshold: Scalars['Boolean']
    payment: Payment
    __typename: 'ReceiveInvoiceResult'
}

export interface ReceivedLineItem {
    customerGrossWeight: (Weight | null)
    customerTareWeight: (Weight | null)
    customerUnitPrice: (Money | null)
    grossWeight: (Weight | null)
    id: Scalars['ID']
    itemId: (Scalars['ID'] | null)
    loadLineItemId: Scalars['ID']
    materialType: Scalars['String']
    netWeight: Weight
    notes: (Scalars['String'] | null)
    pricingUnit: Scalars['String']
    tareWeight: (Weight | null)
    timestamps: Timestamps
    totalValue: Money
    unitPrice: (Money | null)
    __typename: 'ReceivedLineItem'
}

export interface ReconcileCashDrawerPayload {
    adjustment: FinancialAccountAdjustment
    discrepancy: Scalars['Decimal']
    systemBalance: Scalars['Decimal']
    __typename: 'ReconcileCashDrawerPayload'
}

export interface ReconciliationDeduction {
    deductionType: DeductionType
    deductionTypeId: Scalars['ID']
    id: Scalars['ID']
    loadLineItemId: (Scalars['ID'] | null)
    priceQuantity: (Money | null)
    receivedLineItemId: (Scalars['ID'] | null)
    reconciliationId: Scalars['ID']
    timestamps: Timestamps
    totalDeduction: Money
    weightQuantity: (Weight | null)
    __typename: 'ReconciliationDeduction'
}

export type RecurrenceType = 'Daily' | 'Monthly' | 'Weekly'

export interface RecurringSchedule {
    dayOfMonth: (Scalars['Int'] | null)
    duration: Scalars['Int']
    firstOccurrenceAt: (Scalars['ZonedDateTime'] | null)
    interval: Scalars['Int']
    monthlyOccurrence: (MonthlyOccurrence | null)
    monthlyWeekday: (Weekday | null)
    repeatUntil: (Scalars['ZonedDateTime'] | null)
    type: RecurrenceType
    weekdays: (Weekday[] | null)
    __typename: 'RecurringSchedule'
}

export type RelationshipType = 'HAULER' | 'OWNER'

export interface RemoveFileFromTemplatePayload {
    success: Scalars['Boolean']
    __typename: 'RemoveFileFromTemplatePayload'
}

export type ReportingUploadType = 'Automatic' | 'Manual'

export interface Role {
    archived: Scalars['Boolean']
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    name: Scalars['String']
    organizationId: Scalars['ID']
    permissions: Scalars['String'][]
    timestamps: Timestamps
    type: RoleType
    __typename: 'Role'
}

export interface RoleResultPage {
    entries: Role[]
    page: Page
    __typename: 'RoleResultPage'
}

export type RoleSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export type RoleType = 'EXTERNAL' | 'INTERNAL'

export type RoundingMethod = 'Down' | 'Nearest' | 'Up'

export type RoundingPrecision = 'Hundred' | 'Tenth' | 'Whole'

export interface Route {
    assignedAt: (Scalars['ZonedDateTime'] | null)
    assignmentStatus: AssignmentStatus
    completedAt: (Scalars['ZonedDateTime'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: Scalars['String']
    documentNumber: Scalars['String']
    driver: (Driver | null)
    driverId: (Scalars['ID'] | null)
    driverProgress: DriverProgress
    estimatedArrival: (Scalars['ZonedDateTime'] | null)
    facilityGroupId: Scalars['ID']
    haulerId: (Scalars['ID'] | null)
    haulerProgress: HaulerProgress
    id: Scalars['ID']
    isTemplate: Scalars['Boolean']
    legs: RouteLeg[]
    notes: Scalars['String']
    priority: Scalars['Int']
    rank: Scalars['String']
    routeDate: (Scalars['ZonedDateTime'] | null)
    services: Service[]
    startedAt: (Scalars['ZonedDateTime'] | null)
    status: RouteStatus
    tasks: Task[]
    timestamps: Timestamps
    trailerId: (Scalars['ID'] | null)
    truckId: (Scalars['ID'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Route'
}

export interface RouteFreight {
    baseCostAmount: Scalars['Decimal']
    baseCostCurrencyCode: Scalars['String']
    carrierId: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    destinationLocationId: (Scalars['ID'] | null)
    detentionCostAmount: Scalars['Decimal']
    detentionCostCurrencyCode: Scalars['String']
    distance: (Scalars['Decimal'] | null)
    freightLaneId: (Scalars['ID'] | null)
    fuelSurchargeAmount: Scalars['Decimal']
    fuelSurchargeCurrencyCode: Scalars['String']
    id: Scalars['ID']
    originLocationId: (Scalars['ID'] | null)
    routeId: (Scalars['ID'] | null)
    timestamps: Timestamps
    totalCost: Money
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'RouteFreight'
}

export interface RouteFreightResultPage {
    entries: RouteFreight[]
    page: Page
    __typename: 'RouteFreightResultPage'
}

export type RouteFreightSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface RouteLeg {
    distance: Scalars['Float']
    duration: Scalars['Int']
    end: Service
    start: Service
    __typename: 'RouteLeg'
}

export interface RouteResultPage {
    entries: Route[]
    page: Page
    __typename: 'RouteResultPage'
}

export type RouteSortOption = 'CompletedAtAsc' | 'CompletedAtDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'StartedAtAsc' | 'StartedAtDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type RouteStatus = 'Active' | 'Completed' | 'Failed' | 'InProgress' | 'Paused' | 'Planned' | 'Voided'

export interface RouteValidationOverride {
    approvedBy: Scalars['ID']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityGroup: FacilityGroup
    facilityGroupId: Scalars['ID']
    id: Scalars['ID']
    justification: Scalars['String']
    routeId: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    violationKey: Scalars['String']
    __typename: 'RouteValidationOverride'
}

export interface RouteValidationOverrideResultPage {
    entries: RouteValidationOverride[]
    page: Page
    __typename: 'RouteValidationOverrideResultPage'
}

export type RouteValidationOverrideSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface RouteValidationResult {
    canOverride: Scalars['Boolean']
    isValid: Scalars['Boolean']
    requiredOverrides: Scalars['String'][]
    violations: RouteValidationViolation[]
    __typename: 'RouteValidationResult'
}

export interface RouteValidationViolation {
    assetId: (Scalars['ID'] | null)
    message: Scalars['String']
    overrideKey: Scalars['String']
    routePosition: (Scalars['Float'] | null)
    serviceId: (Scalars['ID'] | null)
    severity: ViolationSeverity
    taskId: (Scalars['ID'] | null)
    type: ViolationType
    __typename: 'RouteValidationViolation'
}

export type SalesItemLineType = 'Raw' | 'Tagged'

export type SalesLoadLineItemPhase = 'CustomerReceived' | 'Received' | 'Requested' | 'Shipped' | 'Staged'

export interface SalesOrder {
    account: Account
    accountId: Scalars['ID']
    accountRepresentative: (User | null)
    accountRepresentativeId: (Scalars['ID'] | null)
    billingAddress: (Address | null)
    billingAddressId: (Scalars['ID'] | null)
    bookings: Booking[]
    completionNotes: (Scalars['String'] | null)
    contact: (Contact | null)
    contactId: (Scalars['ID'] | null)
    counterpartyReferenceNumber: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customAttributes: (Scalars['Map'] | null)
    customerExternalNotes: (Scalars['String'] | null)
    customerFiles: File[]
    customerInternalNotes: (Scalars['String'] | null)
    doNotShip: (Scalars['Boolean'] | null)
    documentNumber: Scalars['String']
    endDate: (Scalars['CalendarDate'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    freightTerm: (FreightTerm | null)
    fulfilledPercentage: Scalars['Decimal']
    id: Scalars['ID']
    lineItems: SalesOrderLineItem[]
    netWeight: Weight
    organization: Organization
    organizationId: Scalars['ID']
    paymentCurrency: (Scalars['String'] | null)
    paymentTerm: (PaymentTerm | null)
    recyclerExternalNotes: (Scalars['String'] | null)
    recyclerFiles: File[]
    recyclerInternalNotes: (Scalars['String'] | null)
    shippedLoadsCount: Scalars['Int']
    shippingAddress: (Address | null)
    shippingAddressId: (Scalars['ID'] | null)
    startDate: (Scalars['CalendarDate'] | null)
    status: SalesOrderStatus
    timestamps: Timestamps
    totalPrice: Money
    type: SalesOrderType
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    weightDisplayUnit: WeightDisplayUnit
    __typename: 'SalesOrder'
}

export interface SalesOrderCustomerFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'SalesOrderCustomerFileCreatePayload'
}

export interface SalesOrderFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'SalesOrderFileCreatePayload'
}

export interface SalesOrderFreight {
    carrierId: (Scalars['ID'] | null)
    chargebackFormula: (Scalars['String'] | null)
    chargebackVariableIds: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    freightLaneId: (Scalars['String'] | null)
    fuelSurchargeFormula: (Scalars['String'] | null)
    fuelSurchargeMode: (Scalars['String'] | null)
    fuelSurchargeVariableIds: (Scalars['String'] | null)
    id: Scalars['ID']
    notes: (Scalars['String'] | null)
    rateFormula: (Scalars['String'] | null)
    rateVariableIds: (Scalars['String'] | null)
    salesOrderId: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'SalesOrderFreight'
}

export interface SalesOrderFreightResultPage {
    entries: SalesOrderFreight[]
    page: Page
    __typename: 'SalesOrderFreightResultPage'
}

export type SalesOrderFreightSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface SalesOrderLineItem {
    id: Scalars['ID']
    item: Item
    quantity: Scalars['Decimal']
    timestamps: Timestamps
    totalPrice: Money
    unit: Unit
    unitPrice: Money
    __typename: 'SalesOrderLineItem'
}

export interface SalesOrderRecyclerFileCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'SalesOrderRecyclerFileCreatePayload'
}

export interface SalesOrderResultPage {
    entries: SalesOrder[]
    page: Page
    __typename: 'SalesOrderResultPage'
}

export type SalesOrderSortOption = 'AccountAsc' | 'AccountDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'CreatedByAsc' | 'CreatedByDesc' | 'DocumentNumberAsc' | 'DocumentNumberDesc' | 'EndDateAsc' | 'EndDateDesc' | 'PaymentCurrencyAsc' | 'PaymentCurrencyDesc' | 'StartDateAsc' | 'StartDateDesc' | 'StatusAsc' | 'StatusDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc' | 'UpdatedByAsc' | 'UpdatedByDesc'

export type SalesOrderStatus = 'Draft' | 'Finished' | 'Open' | 'Voided'

export type SalesOrderType = 'Domestic' | 'International'

export interface SalesOrderUpdateResult {
    blockingLoads: (AffectedLoad[] | null)
    removedBookingId: (Scalars['ID'] | null)
    requiresConfirmation: Scalars['Boolean']
    salesOrder: (SalesOrder | null)
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'SalesOrderUpdateResult'
}

export interface Scale {
    baudRate: (Scalars['Int'] | null)
    camera: (Camera | null)
    cameraId: (Scalars['ID'] | null)
    connectionType: ScaleConnectionType
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    dataBits: (Scalars['Int'] | null)
    driverType: (Scalars['String'] | null)
    id: Scalars['ID']
    lastSeenAt: (Scalars['ZonedDateTime'] | null)
    measurementIncrement: (Scalars['Decimal'] | null)
    measurementMode: ScaleMeasurementMode
    name: Scalars['String']
    onDemandString: (Scalars['String'] | null)
    online: Scalars['Boolean']
    parity: (Scalars['String'] | null)
    scaleFormatType: ScaleFormatType
    serialPortPath: (Scalars['String'] | null)
    sidecar: (Sidecar | null)
    sidecarId: Scalars['ID']
    status: ScaleStatus
    stopBits: (Scalars['String'] | null)
    tcpHost: (Scalars['String'] | null)
    tcpPort: (Scalars['Int'] | null)
    timestamps: Timestamps
    uniqueId: (Scalars['String'] | null)
    unitOfMeasurement: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Scale'
}

export type ScaleConnectionType = 'Demo' | 'Serial' | 'TCP'

export type ScaleFormatType = 'Cardinal' | 'Condec' | 'Fairbanks' | 'MettlerToledo' | 'Other' | 'PEC' | 'RiceLake' | 'SMA' | 'Weightronix'

export type ScaleMeasurementMode = 'Continuous' | 'OnDemand'

export interface ScaleResultPage {
    entries: Scale[]
    page: Page
    __typename: 'ScaleResultPage'
}

export type ScaleSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'ScaleFormatTypeAsc' | 'ScaleFormatTypeDesc' | 'StatusAsc' | 'StatusDesc'

export type ScaleStatus = 'Active' | 'Configured' | 'Discovered'

export interface Scanner {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    driverType: Scalars['String']
    firmwareVersion: (Scalars['String'] | null)
    id: Scalars['ID']
    lastSeenAt: (Scalars['ZonedDateTime'] | null)
    manufacturer: (Scalars['String'] | null)
    model: (Scalars['String'] | null)
    name: Scalars['String']
    online: Scalars['Boolean']
    sidecar: (Sidecar | null)
    sidecarId: Scalars['ID']
    status: ScannerStatus
    timestamps: Timestamps
    uniqueId: Scalars['String']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Scanner'
}

export interface ScannerResultPage {
    entries: Scanner[]
    page: Page
    __typename: 'ScannerResultPage'
}

export type ScannerSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'DriverTypeAsc' | 'DriverTypeDesc' | 'NameAsc' | 'NameDesc' | 'StatusAsc' | 'StatusDesc'

export type ScannerStatus = 'Discovered'

export interface ScheduleTriggerConfigOutput {
    cron: Scalars['String']
    __typename: 'ScheduleTriggerConfigOutput'
}

export interface ScheduleTriggerNode {
    cronExpression: Scalars['String']
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    timezone: (Scalars['String'] | null)
    type: NodeType
    __typename: 'ScheduleTriggerNode'
}

export interface SemaphorToken {
    accessToken: Scalars['String']
    dashboardId: Scalars['String']
    refreshToken: Scalars['String']
    __typename: 'SemaphorToken'
}

export interface SendPriceListNotificationResult {
    fileId: Scalars['ID']
    messageId: Scalars['String']
    success: Scalars['Boolean']
    workflowId: Scalars['String']
    __typename: 'SendPriceListNotificationResult'
}

export interface Service {
    account: (Account | null)
    accountAddress: (AccountAddress | null)
    accountAddressId: (Scalars['ID'] | null)
    accountId: (Scalars['ID'] | null)
    actions: ServiceAction[]
    address: (Address | null)
    assetRequirements: ServiceAction[]
    assignedAt: (Scalars['ZonedDateTime'] | null)
    assignmentStatus: AssignmentStatus
    completedAt: (Scalars['ZonedDateTime'] | null)
    contactId: (Scalars['ID'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    deadline: (Scalars['ZonedDateTime'] | null)
    destinationFacilityId: (Scalars['ID'] | null)
    documentNumber: Scalars['String']
    driver: (Driver | null)
    driverId: (Scalars['ID'] | null)
    driverNotes: (Scalars['String'] | null)
    driverProgress: DriverProgress
    estimatedArrival: (Scalars['ZonedDateTime'] | null)
    externalNotes: (Scalars['String'] | null)
    facility: (Facility | null)
    facilityGroupId: Scalars['ID']
    facilityId: (Scalars['ID'] | null)
    haulerId: (Scalars['ID'] | null)
    haulerProgress: HaulerProgress
    id: Scalars['ID']
    internalNotes: (Scalars['String'] | null)
    isRequest: Scalars['Boolean']
    isTemplate: Scalars['Boolean']
    nonDefaultTrailer: (Scalars['Boolean'] | null)
    nonDefaultTruck: (Scalars['Boolean'] | null)
    priority: Scalars['Int']
    rank: Scalars['String']
    recurringSchedule: (RecurringSchedule | null)
    recurringTaskId: (Scalars['ID'] | null)
    relationshipType: (RelationshipType | null)
    requirements: (ServiceRequirement[] | null)
    routeId: (Scalars['ID'] | null)
    routePosition: (Scalars['Decimal'] | null)
    scheduledWindowEnd: Scalars['ZonedDateTime']
    scheduledWindowStart: Scalars['ZonedDateTime']
    serviceType: (ServiceType | null)
    serviceTypeId: (Scalars['ID'] | null)
    startedAt: (Scalars['ZonedDateTime'] | null)
    status: ServiceStatus
    tasks: Task[]
    timestamps: Timestamps
    trailer: (Trailer | null)
    trailerId: (Scalars['ID'] | null)
    truck: (Truck | null)
    truckId: (Scalars['ID'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Service'
}

export interface ServiceAction {
    actionType: (ActionType | null)
    asset: (Asset | null)
    assetGroup: (Scalars['Int'] | null)
    assetId: (Scalars['ID'] | null)
    assetType: (AssetType | null)
    assetTypeId: (Scalars['ID'] | null)
    quantity: (Scalars['Int'] | null)
    __typename: 'ServiceAction'
}

export type ServiceRequirement = 'CustomerSignature' | 'Photos' | 'WeigthReceipt'

export interface ServiceResultPage {
    entries: Service[]
    page: Page
    __typename: 'ServiceResultPage'
}

export type ServiceSortOption = 'CompletedAtAsc' | 'CompletedAtDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'PriorityAsc' | 'PriorityDesc' | 'ScheduledWindowEndAsc' | 'ScheduledWindowEndDesc' | 'ScheduledWindowStartAsc' | 'ScheduledWindowStartDesc' | 'StatusAsc' | 'StatusDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type ServiceStatus = 'Active' | 'Completed' | 'Draft' | 'Failed' | 'InProgress' | 'Paused' | 'Planned' | 'Voided'

export interface ServiceType {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    isSystemDefault: Scalars['Boolean']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ServiceType'
}

export interface ServiceTypeResultPage {
    entries: ServiceType[]
    page: Page
    __typename: 'ServiceTypeResultPage'
}

export type ServiceTypeSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface ServiceTypeTaskDefinition {
    allowLocationOverride: Scalars['Boolean']
    assetGroup: (Scalars['Int'] | null)
    assetRole: (Scalars['String'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    fillStateCondition: (Scalars['String'] | null)
    id: Scalars['ID']
    locationRef: (Scalars['String'] | null)
    sequence: Scalars['Int']
    serviceTypeId: Scalars['ID']
    taskType: TaskType
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ServiceTypeTaskDefinition'
}

export interface ServiceTypeTaskDefinitionResultPage {
    entries: ServiceTypeTaskDefinition[]
    page: Page
    __typename: 'ServiceTypeTaskDefinitionResultPage'
}

export type ServiceTypeTaskDefinitionSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'SequenceAsc' | 'SequenceDesc'

export interface SetFileAsTemplatePayload {
    template: FileTemplate
    __typename: 'SetFileAsTemplatePayload'
}

export interface SetTemplateAsDefaultPayload {
    template: FileTemplate
    __typename: 'SetTemplateAsDefaultPayload'
}

export interface Setting {
    constraints: FieldConstraints
    dataType: FieldDataType
    defaultValue: (Scalars['Any'] | null)
    description: Scalars['String']
    id: Scalars['String']
    name: Scalars['String']
    scope: SettingScope[]
    settingsGroup: SettingsGroup
    settingsGroupId: Scalars['ID']
    timestamps: Timestamps
    values: ((SettingValue | null)[] | null)
    __typename: 'Setting'
}

export interface SettingResultPage {
    entries: Setting[]
    page: Page
    __typename: 'SettingResultPage'
}

export type SettingScope = 'Facility' | 'FacilityGroup' | 'Organization' | 'User'

export type SettingSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export interface SettingValue {
    objectId: Scalars['ID']
    scope: SettingScope
    value: Scalars['Any']
    __typename: 'SettingValue'
}

export interface SettingsGroup {
    createdAt: Scalars['ZonedDateTime']
    description: Scalars['String']
    icon: (Scalars['String'] | null)
    id: Scalars['ID']
    name: Scalars['String']
    settings: Setting[]
    updatedAt: Scalars['ZonedDateTime']
    __typename: 'SettingsGroup'
}

export interface SettingsGroupResultPage {
    entries: SettingsGroup[]
    page: Page
    __typename: 'SettingsGroupResultPage'
}

export type SettingsGroupSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export type SettlementBasis = 'PostSort' | 'PreSort'

export interface ShareFilePayload {
    file: File
    sharedWithCount: Scalars['Int']
    __typename: 'ShareFilePayload'
}

export interface ShippingCarrier {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'ShippingCarrier'
}

export interface ShippingCarrierResultPage {
    entries: ShippingCarrier[]
    page: Page
    __typename: 'ShippingCarrierResultPage'
}

export type ShippingCarrierSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface Sidecar {
    connectedAt: (Scalars['ZonedDateTime'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    id: Scalars['ID']
    jitterMs: (Scalars['Decimal'] | null)
    lastHeartbeatAt: (Scalars['ZonedDateTime'] | null)
    latencyMs: (Scalars['Decimal'] | null)
    linkSpeedDownstream: (Scalars['Int'] | null)
    linkSpeedUpstream: (Scalars['Int'] | null)
    localIpAddress: (Scalars['String'] | null)
    multiaddrs: (Scalars['String'][] | null)
    name: Scalars['String']
    online: Scalars['Boolean']
    operatingSystem: SidecarOperatingSystem
    operatingSystemVersion: Scalars['String']
    peerId: (Scalars['String'] | null)
    publicKey: (Scalars['String'] | null)
    remoteIpAddressV4: (Scalars['String'] | null)
    remoteIpAddressV6: (Scalars['String'] | null)
    settings: SidecarSettings
    status: SidecarStatus
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    version: (Scalars['String'] | null)
    __typename: 'Sidecar'
}

export type SidecarOperatingSystem = 'Linux' | 'MacOS' | 'Other' | 'Windows'

export interface SidecarResultPage {
    entries: Sidecar[]
    page: Page
    __typename: 'SidecarResultPage'
}

export interface SidecarSettings {
    discoveryEnabled: Scalars['Boolean']
    __typename: 'SidecarSettings'
}

export type SidecarSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'OperatingSystemAsc' | 'OperatingSystemDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type SidecarStatus = 'Pending' | 'Provisioned'


/** Represents possible outcomes of a signup completion attempt */
export type SignUpCompleteResult = (InvalidSignUpInvitationError | SignUpCompletedResult) & { __isUnion?: true }


/** Result returned when a signup invitation is successfully accepted */
export interface SignUpCompletedResult {
    /** The email address of the user */
    email: Scalars['String']
    /** The newly created organization ID */
    organizationId: Scalars['ID']
    /** Whether the signup was successfully completed */
    success: Scalars['Boolean']
    /** The newly created user ID */
    userId: Scalars['ID']
    __typename: 'SignUpCompletedResult'
}


/** Represents possible outcomes of a signup initiation attempt */
export type SignUpInitiateResult = (InvalidCredentialsError | SignUpInitiatedResult) & { __isUnion?: true }


/** Result returned when a signup invitation is successfully created */
export interface SignUpInitiatedResult {
    /** The email address associated with the invitation */
    email: Scalars['String']
    /** Whether the invitation was successfully created */
    success: Scalars['Boolean']
    /** The invitation token to be used for completing signup */
    token: Scalars['String']
    __typename: 'SignUpInitiatedResult'
}


/** Sort order */
export type SortOrder = 'ASC' | 'DESC'


/** Error returned when SSO authentication is required for the organization */
export interface SsoRequiredError {
    pendingAuthenticationToken: Scalars['String']
    __typename: 'SsoRequiredError'
}

export interface StandaloneAuthResult {
    redirectUri: Scalars['String']
    __typename: 'StandaloneAuthResult'
}

export interface StartWOPIEditingSessionPayload {
    session: WOPIEditingSession
    __typename: 'StartWOPIEditingSessionPayload'
}

export interface StorageQuota {
    availableBytes: Scalars['Int']
    fileCount: Scalars['Int']
    quotaBytes: Scalars['Int']
    usagePercentage: Scalars['Float']
    usedBytes: Scalars['Int']
    __typename: 'StorageQuota'
}

export interface Subscription {
    assistantChatEvents: AssistantAgentStreamEvent
    crmAccountAddressChanges: AccountAddress
    crmAccountChanges: Account
    crmContactChanges: Contact
    crmCustomerInvitationChanges: CustomerInvitation
    filesFilesystemChanged: FileChangedEvent
    iotCameraEvents: Camera
    iotPrinterEvents: Printer
    iotScaleEvents: Scale
    iotScannerEvents: Scanner
    iotSidecarEvents: Sidecar
    notificationReceived: NotificationFeedEntry
    presenceEvents: PresenceEvent
    tradeLoadChanges: Load
    tradePurchaseLoadChanges: PurchaseLoad
    transportationRouteChanges: Route
    transportationServiceChanges: Service
    __typename: 'Subscription'
}

export interface SupplierPriceListAffectsMaterialsResult {
    affectedItemIds: Scalars['ID'][]
    hasAffectingPriceList: Scalars['Boolean']
    __typename: 'SupplierPriceListAffectsMaterialsResult'
}

export interface SwitchCase {
    label: (Scalars['String'] | null)
    value: Scalars['String']
    __typename: 'SwitchCase'
}

export interface SwitchNode {
    cases: SwitchCase[]
    defaultLabel: (Scalars['String'] | null)
    description: (Scalars['String'] | null)
    expression: Scalars['String']
    id: Scalars['ID']
    label: Scalars['String']
    position: Position
    type: NodeType
    __typename: 'SwitchNode'
}

export interface TagAllocation {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    movement: InventoryMovement
    movementId: Scalars['ID']
    quantity: Weight
    tag: InventoryTag
    tagId: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TagAllocation'
}

export interface TagAllocationResultPage {
    entries: TagAllocation[]
    page: Page
    __typename: 'TagAllocationResultPage'
}

export type TagAllocationSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface TagQuantitySummary {
    inQuantity: Weight
    netQuantity: Weight
    outQuantity: Weight
    tagId: Scalars['ID']
    __typename: 'TagQuantitySummary'
}

export interface TagReconciliationReport {
    quantityMismatchCount: Scalars['Int']
    tagsWithMovements: Scalars['Int']
    tagsWithoutMovements: Scalars['Int']
    totalTags: Scalars['Int']
    __typename: 'TagReconciliationReport'
}

export type TagType = 'FinishedGood' | 'WorkInProgress'


/** Tagging type for inventory accounts */
export type TaggingType = 'Any' | 'Tagged' | 'Untagged'

export interface TalkJSConversation {
    createdAt: Scalars['ZonedDateTime']
    custom: (Scalars['Map'] | null)
    id: Scalars['String']
    isUnread: Scalars['Boolean']
    lastMessage: (TalkJSMessage | null)
    participants: TalkJSParticipant[]
    photoUrl: (Scalars['String'] | null)
    subject: (Scalars['String'] | null)
    topicId: (Scalars['String'] | null)
    unreadMessageCount: Scalars['Int']
    welcomeMessages: (Scalars['String'][] | null)
    __typename: 'TalkJSConversation'
}

export interface TalkJSConversationListResult {
    data: TalkJSConversation[]
    hasMore: Scalars['Boolean']
    nextCursor: (Scalars['String'] | null)
    __typename: 'TalkJSConversationListResult'
}

export interface TalkJSMessage {
    conversationId: Scalars['String']
    createdAt: Scalars['ZonedDateTime']
    custom: (Scalars['Map'] | null)
    id: Scalars['String']
    readBy: TalkJSMessageRead[]
    senderId: Scalars['String']
    text: Scalars['String']
    type: Scalars['String']
    __typename: 'TalkJSMessage'
}

export interface TalkJSMessageRead {
    readAt: Scalars['ZonedDateTime']
    userId: Scalars['String']
    __typename: 'TalkJSMessageRead'
}

export interface TalkJSParticipant {
    access: Scalars['String']
    name: (Scalars['String'] | null)
    notify: Scalars['Boolean']
    participantId: Scalars['String']
    userId: (Scalars['String'] | null)
    __typename: 'TalkJSParticipant'
}

export type TalkJSPeopleType = 'external' | 'internal'

export interface Task {
    accountAddressId: (Scalars['ID'] | null)
    accountId: (Scalars['ID'] | null)
    asset: (Asset | null)
    assetGroup: (Scalars['Int'] | null)
    assetId: (Scalars['ID'] | null)
    assetTypeId: (Scalars['ID'] | null)
    completedAt: (Scalars['ZonedDateTime'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: (Facility | null)
    facilityId: (Scalars['ID'] | null)
    failureReason: (Scalars['String'] | null)
    fillStateCondition: (Scalars['String'] | null)
    fulfillmentServiceId: Scalars['ID']
    id: Scalars['ID']
    routeId: (Scalars['ID'] | null)
    routePosition: (Scalars['Decimal'] | null)
    sourceServiceId: (Scalars['ID'] | null)
    startedAt: (Scalars['ZonedDateTime'] | null)
    status: TaskStatus
    timestamps: Timestamps
    type: TaskType
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'Task'
}

export interface TaskPhotoCreatePayload {
    file: File
    uploadUrl: Scalars['String']
    __typename: 'TaskPhotoCreatePayload'
}

export interface TaskResultPage {
    entries: Task[]
    page: Page
    __typename: 'TaskResultPage'
}

export interface TaskService {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    id: Scalars['ID']
    relationshipType: Scalars['String']
    serviceId: Scalars['ID']
    taskId: Scalars['ID']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TaskService'
}

export interface TaskServiceResultPage {
    entries: TaskService[]
    page: Page
    __typename: 'TaskServiceResultPage'
}

export type TaskServiceSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type TaskSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'RoutePositionAsc' | 'RoutePositionDesc' | 'StatusAsc' | 'StatusDesc' | 'TypeAsc' | 'TypeDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type TaskStatus = 'Active' | 'Cancelled' | 'Completed' | 'Failed' | 'Planned' | 'Postponed'

export type TaskType = 'Delivery' | 'Empty' | 'Fill' | 'Pickup' | 'Reposition'

export interface Terminal {
    id: Scalars['ID']
    latitude: (Scalars['Decimal'] | null)
    longitude: (Scalars['Decimal'] | null)
    name: Scalars['String']
    port: Port
    portId: Scalars['ID']
    terminalCode: Scalars['String']
    timestamps: Timestamps
    __typename: 'Terminal'
}

export interface TicketFreight {
    carrier: (Account | null)
    carrierId: (Scalars['ID'] | null)
    chargebackAmountAmount: Scalars['Decimal']
    chargebackAmountCurrencyCode: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    deliveryNumber: (Scalars['String'] | null)
    destinationLocationId: (Scalars['ID'] | null)
    formulaVariableIds: (Scalars['String'] | null)
    freightLaneCostId: (Scalars['String'] | null)
    id: Scalars['ID']
    invoiceDate: (Scalars['CalendarDate'] | null)
    invoiceNumber: (Scalars['String'] | null)
    load: (Load | null)
    loadId: (Scalars['ID'] | null)
    notes: (Scalars['String'] | null)
    originLocationId: (Scalars['ID'] | null)
    purchaseLoadId: (Scalars['ID'] | null)
    purchase_load: (PurchaseLoad | null)
    route: (FreightLaneRoute | null)
    routeId: (Scalars['ID'] | null)
    sourceId: (Scalars['String'] | null)
    sourceType: (Scalars['String'] | null)
    timestamps: Timestamps
    totalCostAmount: Scalars['Decimal']
    totalCostCurrencyCode: Scalars['String']
    transportationType: (Scalars['String'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    userSet: Scalars['Boolean']
    __typename: 'TicketFreight'
}

export interface TicketFreightResultPage {
    entries: TicketFreight[]
    page: Page
    __typename: 'TicketFreightResultPage'
}

export type TicketFreightSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type TimeoutAction = 'approve' | 'reject'

export type TimeoutUnit = 'days' | 'hours'

export interface Timestamps {
    createdAt: Scalars['ZonedDateTime']
    updatedAt: Scalars['ZonedDateTime']
    __typename: 'Timestamps'
}

export interface TollReceipt {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customerAccount: (Account | null)
    customerAccountId: Scalars['ID']
    facility: (Facility | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    inboundTollingAgreement: (InboundTollingAgreement | null)
    items: TollReceiptItem[]
    notes: (Scalars['String'] | null)
    receiptNumber: Scalars['String']
    receivedAt: (Scalars['ZonedDateTime'] | null)
    status: TollReceiptStatus
    timestamps: Timestamps
    tollProcessingAgreementId: (Scalars['ID'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TollReceipt'
}

export interface TollReceiptItem {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    lot: (InventoryLot | null)
    lotId: (Scalars['ID'] | null)
    notes: (Scalars['String'] | null)
    quantity: Scalars['Decimal']
    quantityUnit: Unit
    timestamps: Timestamps
    tollReceipt: (TollReceipt | null)
    tollReceiptId: Scalars['ID']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TollReceiptItem'
}

export interface TollReceiptItemResultPage {
    entries: TollReceiptItem[]
    page: Page
    __typename: 'TollReceiptItemResultPage'
}

export type TollReceiptItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface TollReceiptResultPage {
    entries: TollReceipt[]
    page: Page
    __typename: 'TollReceiptResultPage'
}

export type TollReceiptSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'ReceiptNumberAsc' | 'ReceiptNumberDesc' | 'ReceivedAtAsc' | 'ReceivedAtDesc'

export type TollReceiptStatus = 'Cancelled' | 'Completed' | 'Draft' | 'Processing' | 'Received'

export interface TollShipment {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    customerAccount: (Account | null)
    customerAccountId: Scalars['ID']
    facility: (Facility | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    inboundTollingAgreement: (InboundTollingAgreement | null)
    items: TollShipmentItem[]
    notes: (Scalars['String'] | null)
    processingFee: (Money | null)
    shipmentNumber: Scalars['String']
    shippedAt: (Scalars['ZonedDateTime'] | null)
    status: TollShipmentStatus
    timestamps: Timestamps
    tollProcessingAgreementId: (Scalars['ID'] | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TollShipment'
}

export interface TollShipmentItem {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    lot: (InventoryLot | null)
    lotId: (Scalars['ID'] | null)
    notes: (Scalars['String'] | null)
    processingFee: (Money | null)
    quantity: Scalars['Decimal']
    quantityUnit: Unit
    timestamps: Timestamps
    tollShipment: (TollShipment | null)
    tollShipmentId: Scalars['ID']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TollShipmentItem'
}

export interface TollShipmentItemResultPage {
    entries: TollShipmentItem[]
    page: Page
    __typename: 'TollShipmentItemResultPage'
}

export type TollShipmentItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface TollShipmentResultPage {
    entries: TollShipment[]
    page: Page
    __typename: 'TollShipmentResultPage'
}

export type TollShipmentSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'ShipmentNumberAsc' | 'ShipmentNumberDesc' | 'ShippedAtAsc' | 'ShippedAtDesc'

export type TollShipmentStatus = 'Cancelled' | 'Delivered' | 'Draft' | 'Shipped'

export type TollingType = 'Inbound' | 'None' | 'Outbound'

export interface ToolCall {
    arguments: Scalars['Map']
    id: Scalars['String']
    name: Scalars['String']
    result: (Scalars['Map'] | null)
    __typename: 'ToolCall'
}


/** Configuration details for Time-based One-Time Password authentication */
export interface TotpConfig {
    qrCode: Scalars['String']
    __typename: 'TotpConfig'
}

export type TradeAggregateType = 'Booking' | 'Load' | 'PurchaseOrder' | 'SalesOrder'

export interface TradeOutboxEventCounts {
    booking: Scalars['Int']
    load: Scalars['Int']
    purchaseOrder: Scalars['Int']
    salesOrder: Scalars['Int']
    __typename: 'TradeOutboxEventCounts'
}

export interface Trailer {
    capacity: Scalars['Float']
    country: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currentLocation: (Point | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    lastLocationTime: (Scalars['ZonedDateTime'] | null)
    licensePlate: Scalars['String']
    licensePlateExpiration: (Scalars['ZonedDateTime'] | null)
    notes: (Scalars['String'] | null)
    state: Scalars['String']
    status: TrailerStatus
    taskCount: Scalars['Int']
    timestamps: Timestamps
    transportationType: TransportationType
    transportationTypeId: Scalars['ID']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    vin: (Scalars['String'] | null)
    __typename: 'Trailer'
}

export interface TrailerResultPage {
    entries: Trailer[]
    page: Page
    __typename: 'TrailerResultPage'
}

export type TrailerSortOption = 'CapacityAsc' | 'CapacityDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'LastLocationTimeAsc' | 'LastLocationTimeDesc' | 'LicensePlateAsc' | 'LicensePlateDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type TrailerStatus = 'Available' | 'InUse' | 'Inactive' | 'OutOfService'

export type TransportationAggregateType = 'Asset' | 'ContainerType' | 'Driver' | 'FreightForwarder' | 'FreightLine' | 'Route' | 'Service' | 'ShippingCarrier' | 'Trailer' | 'TransportationType' | 'Truck'

export interface TransportationOutboxEventCounts {
    asset: Scalars['Int']
    containerType: Scalars['Int']
    driver: Scalars['Int']
    freightForwarder: Scalars['Int']
    freightLine: Scalars['Int']
    route: Scalars['Int']
    service: Scalars['Int']
    shippingCarrier: Scalars['Int']
    trailer: Scalars['Int']
    transportationType: Scalars['Int']
    truck: Scalars['Int']
    __typename: 'TransportationOutboxEventCounts'
}

export interface TransportationType {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: Scalars['String']
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'TransportationType'
}

export interface TransportationTypeResultPage {
    entries: TransportationType[]
    page: Page
    __typename: 'TransportationTypeResultPage'
}

export type TransportationTypeSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface TrialCloseChecklistItem {
    blocking: Scalars['Boolean']
    count: Scalars['Int']
    description: Scalars['String']
    details: Scalars['String'][]
    __typename: 'TrialCloseChecklistItem'
}

export type TriggerConfig = (BusinessEventTriggerConfigOutput | HttpWebhookTriggerConfigOutput | ScheduleTriggerConfigOutput) & { __isUnion?: true }

export type TriggerType = 'BusinessEvent' | 'HttpWebhook' | 'Schedule'

export interface Truck {
    capacity: (Scalars['Float'] | null)
    country: Scalars['String']
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    currentLocation: (Point | null)
    defaultTrailer: (Trailer | null)
    defaultTrailerId: (Scalars['ID'] | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    lastLocationTime: (Scalars['ZonedDateTime'] | null)
    licensePlate: Scalars['String']
    licensePlateExpiration: (Scalars['ZonedDateTime'] | null)
    locationHistory: TruckLocationHistory[]
    model: Scalars['String']
    notes: (Scalars['String'] | null)
    state: Scalars['String']
    status: TruckStatus
    taskCount: Scalars['Int']
    timestamps: Timestamps
    transportationType: TransportationType
    transportationTypeId: Scalars['ID']
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    vin: (Scalars['String'] | null)
    year: (Scalars['Int'] | null)
    __typename: 'Truck'
}

export interface TruckLocationHistory {
    id: Scalars['ID']
    location: Point
    source: Scalars['String']
    timestamp: Scalars['ZonedDateTime']
    timestamps: Timestamps
    truck: Truck
    truckId: Scalars['ID']
    __typename: 'TruckLocationHistory'
}

export interface TruckResultPage {
    entries: Truck[]
    page: Page
    __typename: 'TruckResultPage'
}

export type TruckSortOption = 'CapacityAsc' | 'CapacityDesc' | 'CreatedAtAsc' | 'CreatedAtDesc' | 'LastLocationTimeAsc' | 'LastLocationTimeDesc' | 'LicensePlateAsc' | 'LicensePlateDesc' | 'ModelAsc' | 'ModelDesc' | 'StatusAsc' | 'StatusDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export type TruckStatus = 'Available' | 'InUse' | 'Inactive' | 'OutOfService'

export interface UnappliedAdvanceBalance {
    accountId: Scalars['ID']
    balances: Money[]
    __typename: 'UnappliedAdvanceBalance'
}

export type Unit = 'Each' | 'Grams' | 'GrossTons' | 'Kilograms' | 'LongHundredweight' | 'LongTons' | 'Meter' | 'MetricTons' | 'NetTons' | 'Ounces' | 'Pounds' | 'ShortHundredweight' | 'ShortTons' | 'Yard'

export type UnitFamily = 'Count' | 'Length' | 'Weight'

export interface UnitPriceFormula {
    formula: Scalars['String']
    variableIds: Scalars['ID'][]
    __typename: 'UnitPriceFormula'
}

export type UnitSystem = 'Imperial' | 'Metric'

export interface UnshareFilePayload {
    file: File
    removedCount: Scalars['Int']
    __typename: 'UnshareFilePayload'
}

export interface UsageMetricsAggregation {
    model: Scalars['String']
    modelProvider: Scalars['String']
    organization: Organization
    periodEnd: Scalars['CalendarDate']
    periodStart: Scalars['CalendarDate']
    recordCount: Scalars['Int']
    totalCacheReadTokens: Scalars['Int']
    totalCost: Money
    totalInputTokens: Scalars['Int']
    totalOutputTokens: Scalars['Int']
    totalReasoningTokens: Scalars['Int']
    totalTokens: Scalars['Int']
    __typename: 'UsageMetricsAggregation'
}

export interface UsageMetricsResultPage {
    entries: UsageMetricsAggregation[]
    page: Page
    __typename: 'UsageMetricsResultPage'
}

export type UsageMetricsSortOption = 'ModelProviderAsc' | 'ModelProviderDesc' | 'PeriodStartAsc' | 'PeriodStartDesc' | 'TotalCostAsc' | 'TotalCostDesc' | 'TotalTokensAsc' | 'TotalTokensDesc'

export interface User {
    createdAt: Scalars['ZonedDateTime']
    email: Scalars['String']
    facilities: Facility[]
    facilityGroups: FacilityGroup[]
    firstName: Scalars['String']
    id: Scalars['ID']
    idpId: (Scalars['String'] | null)
    lastName: Scalars['String']
    organizations: Organization[]
    phoneNumber: (Scalars['String'] | null)
    status: UserStatus
    timezone: Scalars['Timezone']
    updatedAt: Scalars['ZonedDateTime']
    __typename: 'User'
}


/** A contact that a user can chat with */
export interface UserContact {
    contactType: ContactType
    email: Scalars['String']
    id: Scalars['ID']
    isOnline: Scalars['Boolean']
    name: Scalars['String']
    organizationName: (Scalars['String'] | null)
    phone: (Scalars['String'] | null)
    userId: Scalars['ID']
    __typename: 'UserContact'
}


/** Result set for user contacts list */
export interface UserContactsListResult {
    data: UserContact[]
    totalCount: Scalars['Int']
    __typename: 'UserContactsListResult'
}


/** Sort options for user contacts */
export type UserContactsSortBy = 'EMAIL' | 'FIRST_NAME' | 'LAST_NAME' | 'ORGANIZATION_NAME'


/** Represents possible outcomes of a user invitation acceptance attempt */
export type UserInvitationAcceptResult = (InvalidUserInvitationError | UserInvitationAcceptedResult) & { __isUnion?: true }


/** Result returned when a user invitation is successfully accepted */
export interface UserInvitationAcceptedResult {
    /** The email address of the user */
    email: Scalars['String']
    /** Whether the invitation was successfully accepted */
    success: Scalars['Boolean']
    /** The user ID */
    userId: Scalars['ID']
    __typename: 'UserInvitationAcceptedResult'
}

export interface UserPreferences {
    defaultCashDrawerId: (Scalars['ID'] | null)
    enableDefaultPrinting: Scalars['Boolean']
    primaryFacilityId: (Scalars['ID'] | null)
    primaryScaleId: (Scalars['ID'] | null)
    primarySidecarId: (Scalars['ID'] | null)
    skipScalePayment: Scalars['Boolean']
    ustudioBrightness: Scalars['Int']
    ustudioEnabled: Scalars['Boolean']
    __typename: 'UserPreferences'
}

export interface UserResultPage {
    entries: User[]
    page: Page
    __typename: 'UserResultPage'
}

export interface UserRoleAssignment {
    facility: (Facility | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    organizationId: Scalars['ID']
    role: (Role | null)
    roleId: Scalars['ID']
    timestamps: Timestamps
    user: (User | null)
    userId: Scalars['ID']
    __typename: 'UserRoleAssignment'
}

export interface UserRoleAssignmentResultPage {
    entries: UserRoleAssignment[]
    page: Page
    __typename: 'UserRoleAssignmentResultPage'
}

export type UserRoleAssignmentSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export type UserSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'EmailAsc' | 'EmailDesc' | 'FirstNameAsc' | 'FirstNameDesc' | 'LastNameAsc' | 'LastNameDesc'

export type UserStatus = 'ACTIVE' | 'ARCHIVED'

export interface ValidationIssue {
    code: Scalars['String']
    field: (Scalars['String'] | null)
    message: Scalars['String']
    nodeId: Scalars['String']
    severity: ValidationSeverity
    __typename: 'ValidationIssue'
}

export type ValidationSeverity = 'error' | 'warning'

export interface Variable {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    description: (Scalars['String'] | null)
    id: Scalars['ID']
    name: Scalars['String']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedById: (Scalars['ID'] | null)
    updatedByUser: (User | null)
    value: (Scalars['Decimal'] | null)
    __typename: 'Variable'
}

export interface VariableResultPage {
    entries: Variable[]
    page: Page
    __typename: 'VariableResultPage'
}

export type VariableSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NameAsc' | 'NameDesc'

export interface VariableUpdateResult {
    affectedTierCount: Scalars['Int']
    validationErrors: VariableValidationError[]
    variable: Variable
    __typename: 'VariableUpdateResult'
}

export interface VariableValidationError {
    calculatedValues: Scalars['Map']
    formulaType: Scalars['String']
    itemId: Scalars['ID']
    itemPricingId: Scalars['ID']
    priceListName: Scalars['String']
    priceListType: Scalars['String']
    tierIndex: Scalars['Int']
    __typename: 'VariableValidationError'
}

export type ViolationSeverity = 'Error' | 'Warning'

export type ViolationType = 'AssetState' | 'CapacityExceeded' | 'LocationConstraint' | 'ServiceIncomplete' | 'TaskPrecedence'

export interface VoidBookingItemResult {
    blockingLoads: (AffectedLoad[] | null)
    booking: (Booking | null)
    requiresConfirmation: Scalars['Boolean']
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'VoidBookingItemResult'
}

export interface VoidBookingResult {
    blockingLoads: (AffectedLoad[] | null)
    booking: (Booking | null)
    requiresConfirmation: Scalars['Boolean']
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'VoidBookingResult'
}

export interface VoidSalesOrderItemResult {
    blockingLoads: (AffectedLoad[] | null)
    requiresConfirmation: Scalars['Boolean']
    salesOrder: (SalesOrder | null)
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'VoidSalesOrderItemResult'
}

export interface VoidSalesOrderResult {
    blockingLoads: (AffectedLoad[] | null)
    requiresConfirmation: Scalars['Boolean']
    salesOrder: (SalesOrder | null)
    unlinkableLoads: (AffectedLoad[] | null)
    __typename: 'VoidSalesOrderResult'
}

export interface VoucherTemplate {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    financialAccountId: Scalars['ID']
    id: Scalars['ID']
    showAccountNumber: Scalars['Boolean']
    showDiscountAmount: Scalars['Boolean']
    showInvoiceAmount: Scalars['Boolean']
    showInvoiceDate: Scalars['Boolean']
    showInvoiceNumber: Scalars['Boolean']
    showMemo: Scalars['Boolean']
    showNetAmount: Scalars['Boolean']
    showPayeeAddress: Scalars['Boolean']
    showPayeeName: Scalars['Boolean']
    showPaymentDate: Scalars['Boolean']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    __typename: 'VoucherTemplate'
}

export interface VoucherTemplateResultPage {
    entries: VoucherTemplate[]
    page: Page
    __typename: 'VoucherTemplateResultPage'
}

export type VoucherTemplateSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface WOPIDiscoveryInfo {
    collaboraUrl: Scalars['String']
    discoveryUrl: Scalars['String']
    maxFileSize: Scalars['Int']
    supportedFileTypes: WOPISupportedFileType[]
    wopiSrc: Scalars['String']
    __typename: 'WOPIDiscoveryInfo'
}

export interface WOPIEditingSession {
    collaboraUrl: Scalars['String']
    editUrl: Scalars['String']
    fileId: Scalars['ID']
    token: WOPIToken
    __typename: 'WOPIEditingSession'
}

export type WOPIFileAction = 'Convert' | 'Edit' | 'EditNew' | 'EmbedView' | 'GetInfo' | 'Present' | 'PresentEmbed' | 'View'

export type WOPIPermission = 'Read' | 'Write'

export interface WOPISupportedFileType {
    actions: WOPIFileAction[]
    defaultAction: WOPIFileAction
    extension: Scalars['String']
    mimeType: Scalars['String']
    name: Scalars['String']
    __typename: 'WOPISupportedFileType'
}

export interface WOPIToken {
    expiresAt: Scalars['Time']
    fileId: Scalars['ID']
    permission: WOPIPermission
    token: Scalars['String']
    tokenId: Scalars['String']
    userEmail: Scalars['String']
    userId: Scalars['ID']
    userName: Scalars['String']
    __typename: 'WOPIToken'
}

export interface WarehouseCredential {
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    databaseName: Scalars['String']
    enabled: Scalars['Boolean']
    host: Scalars['String']
    id: Scalars['ID']
    port: Scalars['Int']
    ssl: Scalars['Boolean']
    timestamps: Timestamps
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    username: Scalars['String']
    __typename: 'WarehouseCredential'
}

export interface WarehouseCredentialResultPage {
    entries: WarehouseCredential[]
    page: Page
    __typename: 'WarehouseCredentialResultPage'
}

export type WarehouseCredentialSortOption = 'CreatedAtAsc' | 'CreatedAtDesc'

export interface WebhookEndpoint {
    automationId: Scalars['ID']
    id: Scalars['ID']
    isActive: Scalars['Boolean']
    lastUsedAt: (Scalars['ZonedDateTime'] | null)
    path: Scalars['String']
    secret: Scalars['String']
    timestamps: Timestamps
    __typename: 'WebhookEndpoint'
}

export type Weekday = 'Friday' | 'Monday' | 'Saturday' | 'Sunday' | 'Thursday' | 'Tuesday' | 'Wednesday'

export interface Weight {
    unit: Unit
    value: Scalars['Decimal']
    __typename: 'Weight'
}

export type WeightDisplayUnit = 'PriceUnit' | 'ScaleUnit'

export interface WorkOrder {
    actualEndDate: (Scalars['ZonedDateTime'] | null)
    actualStartDate: (Scalars['ZonedDateTime'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facility: Facility
    facilityId: Scalars['ID']
    id: Scalars['ID']
    inboundTollingAgreement: (InboundTollingAgreement | null)
    inboundTollingAgreementId: (Scalars['ID'] | null)
    inputItems: WorkOrderInputItem[]
    notes: (Scalars['String'] | null)
    outboundTollingAgreementId: (Scalars['ID'] | null)
    outputItems: WorkOrderOutputItem[]
    processingType: ProcessingType
    processingTypeId: Scalars['ID']
    scheduledEndDate: (Scalars['ZonedDateTime'] | null)
    scheduledStartDate: (Scalars['ZonedDateTime'] | null)
    sourcePurchaseLoadLineItem: (PurchaseLoadLineItem | null)
    sourcePurchaseLoadLineItemId: (Scalars['ID'] | null)
    status: WorkOrderStatus
    timestamps: Timestamps
    tollCustomerAccount: (Account | null)
    tollCustomerAccountId: (Scalars['ID'] | null)
    tollingType: TollingType
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    workOrderNumber: Scalars['String']
    __typename: 'WorkOrder'
}

export interface WorkOrderInputItem {
    actualQuantity: (Scalars['Decimal'] | null)
    actualQuantityUnit: (Unit | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    facilityId: Scalars['ID']
    id: Scalars['ID']
    item: Item
    itemId: Scalars['ID']
    lot: (InventoryLot | null)
    lotId: (Scalars['ID'] | null)
    notes: (Scalars['String'] | null)
    plannedQuantity: Scalars['Decimal']
    plannedQuantityUnit: Unit
    tag: (InventoryTag | null)
    tagId: (Scalars['ID'] | null)
    timestamps: Timestamps
    unitCost: (Money | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    workOrderId: Scalars['ID']
    __typename: 'WorkOrderInputItem'
}

export interface WorkOrderInputItemResultPage {
    entries: WorkOrderInputItem[]
    page: Page
    __typename: 'WorkOrderInputItemResultPage'
}

export type WorkOrderInputItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface WorkOrderOutputItem {
    actualQuantity: (Scalars['Decimal'] | null)
    actualQuantityUnit: (Unit | null)
    allocatedCost: (Money | null)
    costAllocationPercentage: (Scalars['Decimal'] | null)
    createdBy: Scalars['ID']
    createdByUser: (User | null)
    expectedQuantity: Scalars['Decimal']
    expectedQuantityUnit: Unit
    facilityId: Scalars['ID']
    id: Scalars['ID']
    isNoCost: Scalars['Boolean']
    item: Item
    itemId: Scalars['ID']
    notes: (Scalars['String'] | null)
    targetLot: (InventoryLot | null)
    targetLotId: (Scalars['ID'] | null)
    targetTag: (InventoryTag | null)
    targetTagId: (Scalars['ID'] | null)
    timestamps: Timestamps
    unitCost: (Money | null)
    updatedBy: Scalars['ID']
    updatedByUser: (User | null)
    workOrderId: Scalars['ID']
    yieldPercentage: (Scalars['Decimal'] | null)
    __typename: 'WorkOrderOutputItem'
}

export interface WorkOrderOutputItemResultPage {
    entries: WorkOrderOutputItem[]
    page: Page
    __typename: 'WorkOrderOutputItemResultPage'
}

export type WorkOrderOutputItemSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'NotesAsc' | 'NotesDesc' | 'UpdatedAtAsc' | 'UpdatedAtDesc'

export interface WorkOrderResultPage {
    entries: WorkOrder[]
    page: Page
    __typename: 'WorkOrderResultPage'
}

export type WorkOrderSortOption = 'CreatedAtAsc' | 'CreatedAtDesc' | 'ScheduledStartDateAsc' | 'ScheduledStartDateDesc' | 'StatusAsc' | 'StatusDesc' | 'WorkOrderNumberAsc' | 'WorkOrderNumberDesc'

export type WorkOrderStatus = 'Cancelled' | 'Completed' | 'Draft' | 'InProgress' | 'Open'

export type ZoneStatus = 'Active' | 'Archived' | 'Closed'

export type ZoneType = 'Aisle' | 'Bin' | 'Other' | 'Shelf' | 'Zone'

export interface ZoneUtilization {
    availableCapacity: (Scalars['Decimal'] | null)
    totalCapacity: (Scalars['Decimal'] | null)
    usedCapacity: (Scalars['Decimal'] | null)
    utilizationPercentage: (Scalars['Decimal'] | null)
    __typename: 'ZoneUtilization'
}

export interface AcceptCustomerInvitationInput {token: Scalars['String'],userData: UserRegistrationInput}

export interface AcceptCustomerInvitationResultGenqlSelection{
    customerOrganizationId?: boolean | number
    customerOrganizationName?: boolean | number
    invitation?: CustomerInvitationGenqlSelection
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccessURLPayloadGenqlSelection{
    expiresAt?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountGenqlSelection{
    accountManagerIds?: boolean | number
    accountManagers?: UserGenqlSelection
    addresses?: AccountAddressGenqlSelection
    balances?: MoneyGenqlSelection
    bills?: BillGenqlSelection
    canBeInvited?: boolean | number
    contacts?: ContactGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    defaultPurchasePaymentTerm?: PaymentTermConfigGenqlSelection
    defaultPurchasePaymentTermId?: boolean | number
    defaultSalesPaymentTerm?: PaymentTermConfigGenqlSelection
    defaultSalesPaymentTermId?: boolean | number
    dotNumber?: boolean | number
    email?: boolean | number
    id?: boolean | number
    individualDetails?: AccountIndividualDetailsGenqlSelection
    insuranceExpiration?: boolean | number
    invoices?: InvoiceGenqlSelection
    linkedOrganizationId?: boolean | number
    mcNumber?: boolean | number
    name?: boolean | number
    notes?: boolean | number
    paymentSchedulePreference?: boolean | number
    paymentTypePreference?: boolean | number
    pendingTransactions?: boolean | number
    phone?: boolean | number
    primaryContact?: ContactGenqlSelection
    purchasesVolume?: MoneyGenqlSelection
    relationship?: AccountRelationshipGenqlSelection
    salesVolume?: MoneyGenqlSelection
    scac?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    w9OnFile?: boolean | number
    website?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountAddressGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    address?: AddressGenqlSelection
    contacts?: ContactGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    id?: boolean | number
    locationType?: boolean | number
    name?: boolean | number
    operatingHours?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountAddressFilter {accountId?: (Scalars['ID'] | null),accountIds?: (Scalars['ID'][] | null),addressType?: (Scalars['String'] | null),city?: (Scalars['String'] | null),country?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),isCustomer?: (Scalars['Boolean'] | null),isSupplier?: (Scalars['Boolean'] | null),locationType?: (AddressLocationType[] | null),locationTypes?: (AddressLocationType[] | null),name?: (Scalars['String'] | null),postalCode?: (Scalars['String'] | null),searchByAccountName?: (Scalars['Boolean'] | null),searchTerm?: (Scalars['String'] | null),state?: (Scalars['String'] | null),streetAddress?: (Scalars['String'] | null),streetAddress2?: (Scalars['String'] | null)}

export interface AccountAddressResultPageGenqlSelection{
    entries?: AccountAddressGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountBankDetailGenqlSelection{
    accountId?: boolean | number
    accountNumber?: boolean | number
    accountType?: boolean | number
    bankName?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    isPrimary?: boolean | number
    nickname?: boolean | number
    routingNumber?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountBankDetailFilter {accountId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface AccountBankDetailInput {accountId: Scalars['ID'],accountNumber?: (Scalars['String'] | null),accountType: Scalars['String'],bankName?: (Scalars['String'] | null),isPrimary: Scalars['Boolean'],nickname?: (Scalars['String'] | null),routingNumber?: (Scalars['String'] | null)}

export interface AccountBankDetailResultPageGenqlSelection{
    entries?: AccountBankDetailGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountBankDetailUpdateInput {accountId?: (Scalars['ID'] | null),accountNumber?: (Scalars['String'] | null),accountType?: (Scalars['String'] | null),bankName?: (Scalars['String'] | null),isPrimary?: (Scalars['Boolean'] | null),nickname?: (Scalars['String'] | null),routingNumber?: (Scalars['String'] | null)}

export interface AccountFilter {accountManagerIds?: (Scalars['ID'][] | null),accountType?: (AccountType[] | null),defaultPurchasePaymentTermId?: (Scalars['ID'] | null),defaultPurchasePaymentTermIds?: (Scalars['ID'][] | null),defaultSalesPaymentTermId?: (Scalars['ID'] | null),defaultSalesPaymentTermIds?: (Scalars['ID'][] | null),dotNumber?: (Scalars['String'] | null),email?: (Scalars['String'] | null),fromInsuranceExpiration?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),includeContacts?: (Scalars['Boolean'] | null),isCarrier?: (Scalars['Boolean'] | null),isCustomer?: (Scalars['Boolean'] | null),isSupplier?: (Scalars['Boolean'] | null),linkedOrganizationId?: (Scalars['ID'] | null),linkedOrganizationIds?: (Scalars['ID'][] | null),mcNumber?: (Scalars['String'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),paymentSchedulePreference?: (Scalars['String'] | null),paymentTypePreference?: (Scalars['String'] | null),phone?: (Scalars['String'] | null),scac?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),toInsuranceExpiration?: (Scalars['CalendarDate'] | null),website?: (Scalars['String'] | null)}

export interface AccountIdentityDocumentGenqlSelection{
    accountIndividualDetailsId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    documentNumber?: boolean | number
    documentType?: boolean | number
    expirationDate?: boolean | number
    id?: boolean | number
    individualDetails?: AccountIndividualDetailsGenqlSelection
    issueDate?: boolean | number
    issuingState?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountIdentityDocumentFilter {accountIndividualDetailsIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null)}

export interface AccountIdentityDocumentResultPageGenqlSelection{
    entries?: AccountIdentityDocumentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountIndividualDetailsGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    dateOfBirth?: boolean | number
    employer?: boolean | number
    eyeColor?: boolean | number
    hairColor?: boolean | number
    height?: boolean | number
    id?: boolean | number
    identityDocuments?: AccountIdentityDocumentGenqlSelection
    race?: boolean | number
    sex?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    weight?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountIndividualDetailsFilter {accountIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null)}

export interface AccountIndividualDetailsResultPageGenqlSelection{
    entries?: AccountIndividualDetailsGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountRelationshipGenqlSelection{
    isCarrier?: boolean | number
    isCustomer?: boolean | number
    isSupplier?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AccountRelationshipInput {isCarrier: Scalars['Boolean'],isCustomer: Scalars['Boolean'],isSupplier: Scalars['Boolean']}

export interface AccountResultPageGenqlSelection{
    entries?: AccountGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddUsersToRoleInput {facilityId: Scalars['ID'],roleId: Scalars['ID'],userIds: Scalars['ID'][]}

export interface AddressGenqlSelection{
    addressType?: boolean | number
    city?: boolean | number
    coordinates?: CoordinatesGenqlSelection
    country?: boolean | number
    isMailingAddress?: boolean | number
    postalCode?: boolean | number
    state?: boolean | number
    streetAddress?: boolean | number
    streetAddress2?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AddressInput {addressType: AddressType,city: Scalars['String'],coordinates?: (CoordinatesInput | null),country: Scalars['String'],isMailingAddress: Scalars['Boolean'],postalCode: Scalars['String'],state: Scalars['String'],streetAddress: Scalars['String'],streetAddress2?: (Scalars['String'] | null)}

export interface AffectedLoadGenqlSelection{
    documentNumber?: boolean | number
    id?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AgentGenqlSelection{
    agentIdentifier?: boolean | number
    content?: boolean | number
    createdById?: boolean | number
    description?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    model?: boolean | number
    modelProvider?: boolean | number
    name?: boolean | number
    organizationId?: boolean | number
    providerApiKey?: boolean | number
    providerBaseUrl?: boolean | number
    reasoningBudget?: boolean | number
    reasoningEnabled?: boolean | number
    temperature?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tools?: boolean | number
    type?: boolean | number
    version?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AgentFilter {agentIdentifier?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),isActive?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),organizationId?: (Scalars['ID'] | null),searchTerm?: (Scalars['String'] | null),type?: (AgentType | null)}

export interface AgentMetadataGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    version?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AgentResultPageGenqlSelection{
    entries?: AgentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ApplyAdvanceInput {appliedAmount: MoneyInput,documentId: Scalars['ID'],documentType: PaymentApplicationType,paymentId: Scalars['ID']}

export interface ApplyPaymentToBillInput {appliedAmount: MoneyInput,billId: Scalars['ID'],paymentId: Scalars['ID']}

export interface ApplyPaymentToInvoiceInput {appliedAmount: MoneyInput,invoiceId: Scalars['ID'],paymentId: Scalars['ID']}

export interface ApprovalNodeGenqlSelection{
    approvers?: ApproverConfigGenqlSelection
    description?: boolean | number
    id?: boolean | number
    instructions?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    timeoutAction?: boolean | number
    timeoutDuration?: boolean | number
    timeoutEnabled?: boolean | number
    timeoutUnit?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ApprovalRequestGenqlSelection{
    automation?: AutomationGenqlSelection
    automationId?: boolean | number
    comment?: boolean | number
    executionData?: boolean | number
    executionRun?: ExecutionRunGenqlSelection
    executionRunId?: boolean | number
    expiresAt?: boolean | number
    id?: boolean | number
    instructions?: boolean | number
    nodeId?: boolean | number
    nodeLabel?: boolean | number
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    requestedAt?: boolean | number
    respondedAt?: boolean | number
    respondedBy?: boolean | number
    respondedByUser?: UserGenqlSelection
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    workflowId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ApprovalRequestFilter {automationId?: (Scalars['ID'] | null),executionRunId?: (Scalars['ID'] | null),status?: (ApprovalRequestStatus[] | null)}

export interface ApprovalRequestResultPageGenqlSelection{
    entries?: ApprovalRequestGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ApproverConfigGenqlSelection{
    roleIds?: boolean | number
    userIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ApproverConfigInput {roleIds: Scalars['String'][],userIds: Scalars['ID'][]}

export interface ArchiveDownloadPayloadGenqlSelection{
    /** Direct download URL for the archive (presigned, temporary) */
    downloadUrl?: boolean | number
    /** Size of the archive in bytes (estimated) */
    estimatedSize?: boolean | number
    /** Expiration timestamp for the download URL */
    expiresAt?: boolean | number
    /** Name of the archive file */
    fileName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetGenqlSelection{
    account?: AccountGenqlSelection
    accountAddress?: AccountAddressGenqlSelection
    accountAddressId?: boolean | number
    accountId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currentLocation?: AddressGenqlSelection
    customAttributes?: boolean | number
    description?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    fillState?: boolean | number
    id?: boolean | number
    identifier?: boolean | number
    lastLocationTime?: boolean | number
    locationHistory?: AssetLocationHistoryGenqlSelection
    notes?: boolean | number
    status?: boolean | number
    tareWeight?: WeightGenqlSelection
    timestamps?: TimestampsGenqlSelection
    type?: AssetTypeGenqlSelection
    typeId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetFilter {accountAddressIds?: (Scalars['ID'][] | null),accountIds?: (Scalars['ID'][] | null),facilityIds?: (Scalars['ID'][] | null),identifier?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),searchTerm?: (Scalars['String'] | null),status?: (AssetStatus[] | null),typeIds?: (Scalars['ID'][] | null)}

export interface AssetLocationHistoryGenqlSelection{
    asset?: AssetGenqlSelection
    assetId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    source?: boolean | number
    timestamp?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetLocationHistoryFilter {assetId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface AssetLocationHistoryInput {assetId: Scalars['ID'],location: PointInput,source: Scalars['String'],timestamp: Scalars['ZonedDateTime']}

export interface AssetLocationHistoryResultPageGenqlSelection{
    entries?: AssetLocationHistoryGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetLocationHistoryUpdateInput {assetId?: (Scalars['ID'] | null),location?: (PointInput | null),source?: (Scalars['String'] | null),timestamp?: (Scalars['ZonedDateTime'] | null)}

export interface AssetResultPageGenqlSelection{
    entries?: AssetGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetTypeGenqlSelection{
    capacity?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssetTypeFilter {accountAddressIds?: (Scalars['ID'][] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface AssetTypeResultPageGenqlSelection{
    entries?: AssetTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssignUserRoleInput {facilityId: Scalars['ID'],roleId: Scalars['ID'],userId: Scalars['ID']}

export interface AssistantAgentStreamEventGenqlSelection{
    chatId?: boolean | number
    content?: boolean | number
    conversationTitle?: boolean | number
    error?: boolean | number
    issuedAt?: boolean | number
    metadata?: boolean | number
    thinkingStep?: boolean | number
    /** @deprecated Use AssistantChatMessage parts instead */
    toolCall?: ToolCallGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantChatGenqlSelection{
    agent?: AgentMetadataGenqlSelection
    agentId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    isShared?: boolean | number
    messages?: AssistantChatMessageGenqlSelection
    organizationId?: boolean | number
    shareLink?: AssistantChatShareLinkGenqlSelection
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    title?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantChatFilter {createdBy?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),status?: (AssistantChatStatus | null),updatedBy?: (Scalars['ID'][] | null),userId?: (Scalars['ID'] | null)}

export interface AssistantChatMessageGenqlSelection{
    agent?: AgentMetadataGenqlSelection
    agentId?: boolean | number
    chatId?: boolean | number
    createdAt?: boolean | number
    id?: boolean | number
    parts?: AssistantChatMessagePartGenqlSelection
    role?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantChatMessagePartGenqlSelection{
    data?: boolean | number
    dataType?: boolean | number
    errorText?: boolean | number
    filename?: boolean | number
    id?: boolean | number
    input?: boolean | number
    mediaType?: boolean | number
    output?: boolean | number
    providerExecuted?: boolean | number
    providerMetadata?: boolean | number
    sequence?: boolean | number
    sourceId?: boolean | number
    state?: boolean | number
    text?: boolean | number
    title?: boolean | number
    toolCallId?: boolean | number
    toolCallState?: boolean | number
    toolName?: boolean | number
    type?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantChatResultPageGenqlSelection{
    entries?: AssistantChatGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantChatShareLinkGenqlSelection{
    chatId?: boolean | number
    createdAt?: boolean | number
    id?: boolean | number
    token?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantOutboxEventCountsGenqlSelection{
    chat?: boolean | number
    chatMessage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AssistantOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (AssistantAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface AttachmentGenqlSelection{
    bookingId?: boolean | number
    confirmed?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    uploadUrl?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Information about the user who initiated an impersonation session */
export interface AuthenticationImpersonatorGenqlSelection{
    email?: boolean | number
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/**
 * Organization details available during the authentication process.
 * Uses WorkOS organization IDs (strings) since this is before full authentication.
 */
export interface AuthenticationOrganizationGenqlSelection{
    id?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Response returned upon successful authentication containing the access token and user information */
export interface AuthenticationResponseGenqlSelection{
    accessToken?: boolean | number
    impersonator?: AuthenticationImpersonatorGenqlSelection
    organization?: OrganizationGenqlSelection
    user?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Represents all possible outcomes of an authentication attempt */
export interface AuthenticationResultGenqlSelection{
    on_AuthenticationResponse?:AuthenticationResponseGenqlSelection,
    on_EmailVerificationRequiredError?:EmailVerificationRequiredErrorGenqlSelection,
    on_InvalidCredentialsError?:InvalidCredentialsErrorGenqlSelection,
    on_InvalidOneTimeCode?:InvalidOneTimeCodeGenqlSelection,
    on_MfaChallengeError?:MfaChallengeErrorGenqlSelection,
    on_MfaEnrollmentRequiredError?:MfaEnrollmentRequiredErrorGenqlSelection,
    on_OneTimeCodeExpired?:OneTimeCodeExpiredGenqlSelection,
    on_OrganizationSelectionError?:OrganizationSelectionErrorGenqlSelection,
    on_SsoRequiredError?:SsoRequiredErrorGenqlSelection,
    on_PendingAuthenticationError?: PendingAuthenticationErrorGenqlSelection,
    __typename?: boolean | number
}

export interface AutomationGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    edges?: EdgeGenqlSelection
    id?: boolean | number
    name?: boolean | number
    nodes?: NodeGenqlSelection
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    triggerConfig?: TriggerConfigGenqlSelection
    triggerType?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    webhookEndpoint?: WebhookEndpointGenqlSelection
    workflowId?: boolean | number
    workflowRunId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AutomationBulkInput {ids: Scalars['ID'][]}

export interface AutomationBulkOperationResultGenqlSelection{
    failedCount?: boolean | number
    failedIds?: boolean | number
    successCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AutomationDeleteResultGenqlSelection{
    deleted?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AutomationFilter {ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),status?: (AutomationStatus[] | null),triggerType?: (TriggerType[] | null)}

export interface AutomationResultPageGenqlSelection{
    entries?: AutomationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AutomationVersionGenqlSelection{
    automationId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    flowSnapshot?: boolean | number
    id?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    versionNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AutomationVersionFilter {automationId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface AutomationVersionInput {automationId: Scalars['ID'],description?: (Scalars['String'] | null),flowSnapshot?: (Scalars['JSON'] | null),versionNumber: Scalars['Int']}

export interface AutomationVersionResultPageGenqlSelection{
    entries?: AutomationVersionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface AutomationVersionUpdateInput {automationId?: (Scalars['ID'] | null),description?: (Scalars['String'] | null),flowSnapshot?: (Scalars['JSON'] | null),versionNumber?: (Scalars['Int'] | null)}

export interface BatchCreateInventoryTagInput {customAttributes?: (Scalars['Map'] | null),facilityId: Scalars['ID'],generatedAt: Scalars['ZonedDateTime'],grossQuantity: Scalars['Decimal'],isRevised: Scalars['Boolean'],itemId: Scalars['ID'],lotId?: (Scalars['ID'] | null),quantityCaptureMethod: QuantityCaptureMethod,status: InventoryTagStatus,tagNumber?: (Scalars['String'] | null),tagType: TagType,tare: Scalars['Decimal'],tareCaptureMethod: QuantityCaptureMethod}

export interface BatchItemPricingUpdateItem {input: ItemPricingUpdateInput,itemPricingId: Scalars['ID'],tiers?: (CreateItemPricingTierInput[] | null)}

export interface BillGenqlSelection{
    account?: AccountGenqlSelection
    amount?: MoneyGenqlSelection
    compliance?: boolean | number
    documentDate?: boolean | number
    documentNumber?: boolean | number
    dueDate?: boolean | number
    eligibleAt?: boolean | number
    facility?: FacilityGenqlSelection
    id?: boolean | number
    lineItems?: BillLineItemGenqlSelection
    notes?: boolean | number
    openAmount?: MoneyGenqlSelection
    paymentTerm?: boolean | number
    paymentTermEntity?: PaymentTermConfigGenqlSelection
    payments?: PaymentGenqlSelection
    preferredPaymentMethod?: boolean | number
    scaleTicketId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillEntityReferenceGenqlSelection{
    entityId?: boolean | number
    entityType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillFilter {accountIDs?: (Scalars['ID'][] | null),compliance?: (BillComplianceRule[] | null),currencyCode?: (CurrencyCode | null),facilityIDs?: (Scalars['ID'][] | null),fromDueDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),maxOpenBalance?: (Scalars['Decimal'] | null),minOpenBalance?: (Scalars['Decimal'] | null),searchTerm?: (Scalars['String'] | null),statuses?: (BillStatus[] | null),toDueDate?: (Scalars['CalendarDate'] | null),types?: (BillType[] | null)}

export interface BillLineItemGenqlSelection{
    description?: boolean | number
    groupName?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    quantity?: boolean | number
    sortOrder?: boolean | number
    sourceReference?: BillEntityReferenceGenqlSelection
    timestamps?: TimestampsGenqlSelection
    totalPrice?: MoneyGenqlSelection
    unit?: boolean | number
    unitPrice?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillLineItemInput {description: Scalars['String'],groupName?: (Scalars['String'] | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),quantity: Scalars['Decimal'],sortOrder?: (Scalars['Int'] | null),totalPrice: MoneyInput,unit: Scalars['String'],unitPrice: MoneyInput}

export interface BillPaymentApplicationGenqlSelection{
    appliedAmount?: MoneyGenqlSelection
    appliedAt?: boolean | number
    bill?: BillGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillResultPageGenqlSelection{
    entries?: BillGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BillStatusCountsGenqlSelection{
    paid?: boolean | number
    pending?: boolean | number
    voided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingGenqlSelection{
    containerInstanceCounts?: ContainerStatusCountsGenqlSelection
    containerInstances?: ContainerGenqlSelection
    containers?: BookingContainerGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    cutOffDate?: boolean | number
    destinationPort?: PortGenqlSelection
    destinationPortId?: boolean | number
    documentNumber?: boolean | number
    dropoffTerminal?: TerminalGenqlSelection
    dropoffTerminalId?: boolean | number
    earlyReturnDate?: boolean | number
    externalNotes?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    files?: FileGenqlSelection
    id?: boolean | number
    internalNotes?: boolean | number
    loadStatusSummary?: BookingLoadStatusSummaryGenqlSelection
    loadingPort?: PortGenqlSelection
    loadingPortId?: boolean | number
    oceanFreight?: boolean | number
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    photoRequirements?: PhotoRequirementGenqlSelection
    pickupTerminal?: TerminalGenqlSelection
    pickupTerminalId?: boolean | number
    salesOrders?: SalesOrderGenqlSelection
    status?: boolean | number
    steamshipLine?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    vesselArrivalDate?: boolean | number
    vesselDepartureDate?: boolean | number
    vesselName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingContainerGenqlSelection{
    containerType?: ContainerTypeGenqlSelection
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingContainerInput {containerTypeId: Scalars['ID'],quantity: Scalars['Int']}

export interface BookingFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface BookingFilter {createdBy?: (Scalars['ID'][] | null),documentNumber?: (Scalars['String'] | null),facilityIds?: (Scalars['ID'][] | null),fromCutOffDate?: (Scalars['CalendarDate'] | null),fromDepartureDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),status?: (BookingStatus[] | null),toCutOffDate?: (Scalars['CalendarDate'] | null),toDepartureDate?: (Scalars['CalendarDate'] | null),updatedBy?: (Scalars['ID'][] | null)}

export interface BookingInput {containers: BookingContainerInput[],cutOffDate?: (Scalars['CalendarDate'] | null),destinationPortId?: (Scalars['ID'] | null),documentNumber: Scalars['String'],dropoffTerminalId?: (Scalars['ID'] | null),earlyReturnDate?: (Scalars['CalendarDate'] | null),externalNotes?: (Scalars['String'] | null),facilityId: Scalars['ID'],internalNotes?: (Scalars['String'] | null),loadingPortId?: (Scalars['ID'] | null),oceanFreight?: (Scalars['String'] | null),photoRequirements?: (PhotoRequirementInput[] | null),pickupTerminalId?: (Scalars['ID'] | null),salesOrderIds?: (Scalars['ID'][] | null),status: BookingStatus,steamshipLine?: (Scalars['String'] | null),vesselArrivalDate?: (Scalars['CalendarDate'] | null),vesselDepartureDate?: (Scalars['CalendarDate'] | null),vesselName?: (Scalars['String'] | null)}

export interface BookingLoadStatusSummaryGenqlSelection{
    allReceived?: boolean | number
    allReconciled?: boolean | number
    allShipped?: boolean | number
    received?: boolean | number
    reconciled?: boolean | number
    shipped?: boolean | number
    total?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingResultPageGenqlSelection{
    entries?: BookingGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingStatusCountsGenqlSelection{
    completed?: boolean | number
    draft?: boolean | number
    open?: boolean | number
    shipped?: boolean | number
    voided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BookingUpdateInput {containers?: (BookingContainerInput[] | null),cutOffDate?: (Scalars['CalendarDate'] | null),destinationPortId?: (Scalars['ID'] | null),documentNumber?: (Scalars['String'] | null),dropoffTerminalId?: (Scalars['ID'] | null),earlyReturnDate?: (Scalars['CalendarDate'] | null),externalNotes?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),internalNotes?: (Scalars['String'] | null),loadingPortId?: (Scalars['ID'] | null),oceanFreight?: (Scalars['String'] | null),photoRequirements?: (PhotoRequirementInput[] | null),pickupTerminalId?: (Scalars['ID'] | null),salesOrderIds?: (Scalars['ID'][] | null),status?: (BookingStatus | null),steamshipLine?: (Scalars['String'] | null),vesselArrivalDate?: (Scalars['CalendarDate'] | null),vesselDepartureDate?: (Scalars['CalendarDate'] | null),vesselName?: (Scalars['String'] | null)}

export interface BookingUpdateResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    booking?: BookingGenqlSelection
    removedSalesOrderId?: boolean | number
    requiresConfirmation?: boolean | number
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BrokeredOrderGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customers?: AccountGenqlSelection
    id?: boolean | number
    lineItems?: BrokeredOrderLineItemGenqlSelection
    margin?: MoneyGenqlSelection
    marginPercent?: boolean | number
    notes?: boolean | number
    orderNumber?: boolean | number
    purchaseOrders?: PurchaseOrderGenqlSelection
    purchaseTotal?: MoneyGenqlSelection
    salesOrders?: SalesOrderGenqlSelection
    salesTotal?: MoneyGenqlSelection
    status?: boolean | number
    suppliers?: AccountGenqlSelection
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BrokeredOrderFilter {customerIds?: (Scalars['ID'][] | null),fromCreatedAt?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),includeLineItems?: (Scalars['Boolean'] | null),orderNumber?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),statuses?: (BrokeredOrderStatus[] | null),supplierIds?: (Scalars['ID'][] | null),toCreatedAt?: (Scalars['ZonedDateTime'] | null)}

export interface BrokeredOrderInput {lineItems?: (CreateBrokeredOrderLineItemInput[] | null),notes?: (Scalars['String'] | null),orderNumber: Scalars['String']}

export interface BrokeredOrderLineItemGenqlSelection{
    brokeredOrder?: BrokeredOrderGenqlSelection
    brokeredOrderId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    margin?: MoneyGenqlSelection
    marginPercent?: boolean | number
    notes?: boolean | number
    purchaseTotal?: MoneyGenqlSelection
    purchaseUnitPrice?: MoneyGenqlSelection
    quantity?: boolean | number
    salesTotal?: MoneyGenqlSelection
    salesUnitPrice?: MoneyGenqlSelection
    timestamps?: TimestampsGenqlSelection
    unit?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BrokeredOrderLineItemFilter {brokeredOrderId?: (Scalars['ID'] | null),brokeredOrderIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface BrokeredOrderLineItemResultPageGenqlSelection{
    entries?: BrokeredOrderLineItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BrokeredOrderResultPageGenqlSelection{
    entries?: BrokeredOrderGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BrokeredOrderUpdateInput {lineItems?: (UpdateBrokeredOrderLineItemInput[] | null),notes?: (Scalars['String'] | null),orderNumber?: (Scalars['String'] | null)}

export interface BrokeredOrderValidationErrorGenqlSelection{
    code?: boolean | number
    itemId?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BrokeredOrderValidationResultGenqlSelection{
    errors?: BrokeredOrderValidationErrorGenqlSelection
    valid?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkOperationResultGenqlSelection{
    failedCount?: boolean | number
    failedIds?: boolean | number
    successCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkPaymentResultGenqlSelection{
    failedCount?: boolean | number
    results?: PaymentItemResultGenqlSelection
    successCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkRoleInput {roleIds: Scalars['ID'][]}

export interface BulkUserInput {userIds: Scalars['ID'][]}

export interface BulkVoidBookingInput {forceUnlink?: (Scalars['Boolean'] | null),ids: Scalars['ID'][]}

export interface BulkVoidBookingResultGenqlSelection{
    failedCount?: boolean | number
    results?: VoidBookingItemResultGenqlSelection
    successCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkVoidLoadInput {ids: Scalars['ID'][],voidReason?: (Scalars['String'] | null)}

export interface BulkVoidLoadResultGenqlSelection{
    failedCount?: boolean | number
    failedIds?: boolean | number
    successCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BulkVoidSalesOrderInput {forceUnlink?: (Scalars['Boolean'] | null),ids: Scalars['ID'][]}

export interface BulkVoidSalesOrderResultGenqlSelection{
    failedCount?: boolean | number
    results?: VoidSalesOrderItemResultGenqlSelection
    successCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventTriggerConfigOutputGenqlSelection{
    entityType?: boolean | number
    eventCase?: boolean | number
    filterExpression?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface BusinessEventTriggerNodeGenqlSelection{
    description?: boolean | number
    eventType?: boolean | number
    filter?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CalculateBrokeredMarginsInput {method: Scalars['String'],purchaseOrderIds: Scalars['ID'][],salesOrderIds: Scalars['ID'][]}

export interface CalculateWorkOrderQuantitiesInput {direction: CalculationDirection,
/** Required when direction is FromOutputs - specifies which output item to calculate from */
outputItemId?: (Scalars['ID'] | null),referenceQuantity: Scalars['Decimal'],referenceUnit: Unit,workOrderId: Scalars['ID']}

export interface CalculatedRecipeItemGenqlSelection{
    isNoCost?: boolean | number
    isPrimary?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    quantity?: boolean | number
    quantityUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CalculatedRecipeResultGenqlSelection{
    inputs?: CalculatedRecipeItemGenqlSelection
    outputs?: CalculatedRecipeItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CameraGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    driverType?: boolean | number
    firmwareVersion?: boolean | number
    hasFloodlight?: boolean | number
    hasPtz?: boolean | number
    hasSiren?: boolean | number
    id?: boolean | number
    initialized?: boolean | number
    ipAddress?: boolean | number
    lastSeenAt?: boolean | number
    manufacturer?: boolean | number
    model?: boolean | number
    name?: boolean | number
    online?: boolean | number
    passwordDecrypted?: boolean | number
    sidecar?: SidecarGenqlSelection
    sidecarId?: boolean | number
    snapshotUrl?: boolean | number
    status?: boolean | number
    streamProfile?: boolean | number
    streamUrl?: boolean | number
    timestamps?: TimestampsGenqlSelection
    uniqueId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    username?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CameraFilter {facilityId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),sidecarId?: (Scalars['ID'] | null),status?: (CameraStatus[] | null)}

export interface CameraResultPageGenqlSelection{
    entries?: CameraGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryGenqlSelection{
    attributes?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryFilter {description?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface CategoryInput {attributes: Scalars['JSON'],customAttributes?: (Scalars['Map'] | null),description: Scalars['String'],name: Scalars['String']}

export interface CategoryResultPageGenqlSelection{
    entries?: CategoryGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CategoryUpdateInput {attributes?: (Scalars['JSON'] | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),name?: (Scalars['String'] | null)}

export interface ChangeUserRoleInput {facilityId: Scalars['ID'],newRoleId: Scalars['ID'],oldRoleId: Scalars['ID'],userId: Scalars['ID']}

export interface ChatMetadataInput {firstName?: (Scalars['String'] | null),lastName?: (Scalars['String'] | null),timezone?: (Scalars['String'] | null)}

export interface CheckTemplateGenqlSelection{
    checkFont?: boolean | number
    checkFontSize?: boolean | number
    checkLayout?: boolean | number
    checkType?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    displayAccountNumber?: boolean | number
    displayAmount?: boolean | number
    displayAmountWords?: boolean | number
    displayBankInfo?: boolean | number
    displayCheckNumber?: boolean | number
    displayCompanyAddress?: boolean | number
    displayCompanyName?: boolean | number
    displayCompanyPhone?: boolean | number
    displayDate?: boolean | number
    displayMemo?: boolean | number
    displayMicr?: boolean | number
    displayPayeeAddress?: boolean | number
    displayPayeeName?: boolean | number
    displaySecondSignature?: boolean | number
    displaySignature?: boolean | number
    facilityId?: boolean | number
    financialAccountId?: boolean | number
    id?: boolean | number
    maxAmountSecondSignature?: boolean | number
    minAmountSignature?: boolean | number
    secondSignatureId?: boolean | number
    signatureId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CheckTemplateFilter {facilityIds?: (Scalars['ID'][] | null),financialAccountId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface CheckTemplateInput {checkFont?: (Scalars['String'] | null),checkFontSize?: (Scalars['Int'] | null),checkLayout: Scalars['String'],checkType: Scalars['String'],displayAccountNumber: Scalars['Boolean'],displayAmount: Scalars['Boolean'],displayAmountWords: Scalars['Boolean'],displayBankInfo: Scalars['Boolean'],displayCheckNumber: Scalars['Boolean'],displayCompanyAddress: Scalars['Boolean'],displayCompanyName: Scalars['Boolean'],displayCompanyPhone: Scalars['Boolean'],displayDate: Scalars['Boolean'],displayMemo: Scalars['Boolean'],displayMicr: Scalars['Boolean'],displayPayeeAddress: Scalars['Boolean'],displayPayeeName: Scalars['Boolean'],displaySecondSignature: Scalars['Boolean'],displaySignature: Scalars['Boolean'],facilityId: Scalars['ID'],financialAccountId: Scalars['ID'],maxAmountSecondSignature?: (Scalars['Decimal'] | null),minAmountSignature?: (Scalars['Decimal'] | null),secondSignatureId?: (Scalars['ID'] | null),signatureId?: (Scalars['ID'] | null)}

export interface CheckTemplateResultPageGenqlSelection{
    entries?: CheckTemplateGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CheckTemplateUpdateInput {checkFont?: (Scalars['String'] | null),checkFontSize?: (Scalars['Int'] | null),checkLayout?: (Scalars['String'] | null),checkType?: (Scalars['String'] | null),displayAccountNumber?: (Scalars['Boolean'] | null),displayAmount?: (Scalars['Boolean'] | null),displayAmountWords?: (Scalars['Boolean'] | null),displayBankInfo?: (Scalars['Boolean'] | null),displayCheckNumber?: (Scalars['Boolean'] | null),displayCompanyAddress?: (Scalars['Boolean'] | null),displayCompanyName?: (Scalars['Boolean'] | null),displayCompanyPhone?: (Scalars['Boolean'] | null),displayDate?: (Scalars['Boolean'] | null),displayMemo?: (Scalars['Boolean'] | null),displayMicr?: (Scalars['Boolean'] | null),displayPayeeAddress?: (Scalars['Boolean'] | null),displayPayeeName?: (Scalars['Boolean'] | null),displaySecondSignature?: (Scalars['Boolean'] | null),displaySignature?: (Scalars['Boolean'] | null),facilityId?: (Scalars['ID'] | null),financialAccountId?: (Scalars['ID'] | null),maxAmountSecondSignature?: (Scalars['Decimal'] | null),minAmountSignature?: (Scalars['Decimal'] | null),secondSignatureId?: (Scalars['ID'] | null),signatureId?: (Scalars['ID'] | null)}

export interface CompleteWorkOrderInputItemInput {actualQuantity: Scalars['Decimal'],actualQuantityUnit: Unit,inputItemId: Scalars['ID'],
/** Optional lot ID - if not specified, a new lot will be created for tracking loose/untracked material */
lotId?: (Scalars['ID'] | null),
/** Optional tag ID for discrete item tracking */
tagId?: (Scalars['ID'] | null)}

export interface CompleteWorkOrderOutputItemInput {actualQuantity: Scalars['Decimal'],actualQuantityUnit: Unit,outputItemId: Scalars['ID'],
/** Optional target lot ID - if not specified, a new lot will be created for the output */
targetLotId?: (Scalars['ID'] | null),
/** Optional target tag ID for discrete item tracking */
targetTagId?: (Scalars['ID'] | null)}

export interface CompleteWorkOrderWithActualsInput {actualInputs: CompleteWorkOrderInputItemInput[],actualOutputs: CompleteWorkOrderOutputItemInput[]}

export interface ComplianceCheckGenqlSelection{
    accountId?: boolean | number
    checkedAt?: boolean | number
    checkedByUserId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    notes?: boolean | number
    overriddenAt?: boolean | number
    overriddenByUserId?: boolean | number
    overrideReason?: boolean | number
    purchaseLoadId?: boolean | number
    results?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceCheckFilter {accountId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),purchaseLoadId?: (Scalars['ID'] | null),status?: (ComplianceCheckStatus[] | null)}

export interface ComplianceCheckInput {accountId?: (Scalars['ID'] | null),checkedAt: Scalars['ZonedDateTime'],checkedByUserId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),overriddenAt?: (Scalars['ZonedDateTime'] | null),overriddenByUserId?: (Scalars['ID'] | null),overrideReason?: (Scalars['String'] | null),purchaseLoadId: Scalars['ID'],results?: (Scalars['Map'] | null),status: ComplianceCheckStatus}

export interface ComplianceCheckOverrideInput {notes: Scalars['String'],overrideReason: Scalars['String']}

export interface ComplianceCheckResultItemGenqlSelection{
    category?: boolean | number
    enforcementLevel?: boolean | number
    message?: boolean | number
    passed?: boolean | number
    ruleCode?: boolean | number
    ruleName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceCheckResultPageGenqlSelection{
    entries?: ComplianceCheckGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceCheckUpdateInput {accountId?: (Scalars['ID'] | null),checkedAt?: (Scalars['ZonedDateTime'] | null),checkedByUserId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),overriddenAt?: (Scalars['ZonedDateTime'] | null),overriddenByUserId?: (Scalars['ID'] | null),overrideReason?: (Scalars['String'] | null),purchaseLoadId?: (Scalars['ID'] | null),results?: (Scalars['Map'] | null),status?: (ComplianceCheckStatus | null)}

export interface ComplianceDailyTotalsInput {totalPrice: Scalars['Decimal'],totalWeight: Scalars['Decimal']}

export interface ComplianceDispatchImageGenqlSelection{
    category?: boolean | number
    complianceDispatchRecord?: ComplianceDispatchRecordGenqlSelection
    complianceDispatchRecordId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    externalId?: boolean | number
    fileId?: boolean | number
    fileType?: boolean | number
    id?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceDispatchImageFilter {ids?: (Scalars['ID'][] | null)}

export interface ComplianceDispatchImageInput {category: DispatchImageCategory,complianceDispatchRecordId: Scalars['ID'],externalId?: (Scalars['String'] | null),fileId: Scalars['ID'],fileType: Scalars['String'],status: DispatchImageStatus}

export interface ComplianceDispatchImageResultPageGenqlSelection{
    entries?: ComplianceDispatchImageGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceDispatchImageUpdateInput {category?: (DispatchImageCategory | null),complianceDispatchRecordId?: (Scalars['ID'] | null),externalId?: (Scalars['String'] | null),fileId?: (Scalars['ID'] | null),fileType?: (Scalars['String'] | null),status?: (DispatchImageStatus | null)}

export interface ComplianceDispatchRecordGenqlSelection{
    batchId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    dispatchType?: boolean | number
    errorMessage?: boolean | number
    errorType?: boolean | number
    externalReferenceId?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    governmentReportingConfiguration?: GovernmentReportingConfigurationGenqlSelection
    governmentReportingConfigurationId?: boolean | number
    id?: boolean | number
    isRetriable?: boolean | number
    maxRetryCount?: boolean | number
    nextRetryAt?: boolean | number
    payload?: boolean | number
    purchaseLoad?: PurchaseLoadGenqlSelection
    purchaseLoadId?: boolean | number
    retryCount?: boolean | number
    status?: boolean | number
    submittedAt?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceDispatchRecordFilter {batchId?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),fromSubmittedAt?: (Scalars['ZonedDateTime'] | null),governmentReportingConfigurationId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),status?: (DispatchRecordStatus[] | null),toSubmittedAt?: (Scalars['ZonedDateTime'] | null)}

export interface ComplianceDispatchRecordInput {batchId?: (Scalars['String'] | null),dispatchType: Scalars['String'],errorMessage?: (Scalars['String'] | null),errorType: DispatchErrorType,externalReferenceId?: (Scalars['String'] | null),facilityId: Scalars['ID'],governmentReportingConfigurationId: Scalars['ID'],isRetriable: Scalars['Boolean'],maxRetryCount: Scalars['Int'],nextRetryAt?: (Scalars['ZonedDateTime'] | null),payload?: (Scalars['Map'] | null),purchaseLoadId: Scalars['ID'],retryCount: Scalars['Int'],status: DispatchRecordStatus,submittedAt?: (Scalars['ZonedDateTime'] | null)}

export interface ComplianceDispatchRecordResultPageGenqlSelection{
    entries?: ComplianceDispatchRecordGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceDispatchRecordUpdateInput {batchId?: (Scalars['String'] | null),dispatchType?: (Scalars['String'] | null),errorMessage?: (Scalars['String'] | null),errorType?: (DispatchErrorType | null),externalReferenceId?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),governmentReportingConfigurationId?: (Scalars['ID'] | null),isRetriable?: (Scalars['Boolean'] | null),maxRetryCount?: (Scalars['Int'] | null),nextRetryAt?: (Scalars['ZonedDateTime'] | null),payload?: (Scalars['Map'] | null),purchaseLoadId?: (Scalars['ID'] | null),retryCount?: (Scalars['Int'] | null),status?: (DispatchRecordStatus | null),submittedAt?: (Scalars['ZonedDateTime'] | null)}

export interface ComplianceEvaluateTransactionInput {accountId: Scalars['ID'],dailyTotals?: (ComplianceDailyTotalsInput | null),facilityId: Scalars['ID'],isFrequentSeller: Scalars['Boolean'],items: ComplianceItemInput[],paymentMethod?: (Scalars['String'] | null),purchaseLoadId: Scalars['ID'],supplier?: (ComplianceSupplierInput | null),transactionDate: Scalars['ZonedDateTime'],transactionTotal: Scalars['Decimal'],vehicle?: (ComplianceVehicleInput | null)}

export interface ComplianceEvaluationResultGenqlSelection{
    holdDetails?: ComplianceHoldEvaluationGenqlSelection
    holdRequired?: boolean | number
    results?: ComplianceCheckResultItemGenqlSelection
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceFacilityRuleGenqlSelection{
    applicableCategoryIds?: boolean | number
    configuredValue?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    effectiveFrom?: boolean | number
    effectiveTo?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    isEnabled?: boolean | number
    notes?: boolean | number
    ruleDefinition?: ComplianceRuleDefinitionGenqlSelection
    ruleDefinitionId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceFacilityRuleFilter {ids?: (Scalars['ID'][] | null)}

export interface ComplianceFacilityRuleInput {applicableCategoryIds?: (Scalars['Map'] | null),configuredValue?: (Scalars['Map'] | null),effectiveFrom?: (Scalars['ZonedDateTime'] | null),effectiveTo?: (Scalars['ZonedDateTime'] | null),facilityId: Scalars['ID'],isEnabled: Scalars['Boolean'],notes?: (Scalars['String'] | null),ruleDefinitionId: Scalars['ID']}

export interface ComplianceFacilityRuleResultPageGenqlSelection{
    entries?: ComplianceFacilityRuleGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceFacilityRuleUpdateInput {applicableCategoryIds?: (Scalars['Map'] | null),configuredValue?: (Scalars['Map'] | null),effectiveFrom?: (Scalars['ZonedDateTime'] | null),effectiveTo?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),isEnabled?: (Scalars['Boolean'] | null),notes?: (Scalars['String'] | null),ruleDefinitionId?: (Scalars['ID'] | null)}

export interface ComplianceHoldGenqlSelection{
    accountId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    exemptionReason?: boolean | number
    holdDays?: boolean | number
    holdEnd?: boolean | number
    holdStart?: boolean | number
    id?: boolean | number
    jurisdictionCode?: boolean | number
    maxImmediateCash?: boolean | number
    notes?: boolean | number
    purchaseLoadId?: boolean | number
    releasedAt?: boolean | number
    releasedByUserId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceHoldEvaluationGenqlSelection{
    exemptionReason?: boolean | number
    holdDays?: boolean | number
    holdEnd?: boolean | number
    maxImmediateCash?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceHoldExtendInput {holdDays: Scalars['Int'],holdEnd: Scalars['ZonedDateTime'],notes: Scalars['String']}

export interface ComplianceHoldFilter {accountId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),purchaseLoadId?: (Scalars['ID'] | null),status?: (ComplianceHoldStatus[] | null)}

export interface ComplianceHoldFlagPoliceInput {notes: Scalars['String']}

export interface ComplianceHoldInput {accountId: Scalars['ID'],exemptionReason: HoldExemptionReason,holdDays: Scalars['Int'],holdEnd: Scalars['ZonedDateTime'],holdStart: Scalars['ZonedDateTime'],jurisdictionCode?: (Scalars['String'] | null),maxImmediateCash?: (Scalars['Decimal'] | null),notes?: (Scalars['String'] | null),purchaseLoadId: Scalars['ID'],releasedAt?: (Scalars['ZonedDateTime'] | null),releasedByUserId?: (Scalars['ID'] | null),status: ComplianceHoldStatus}

export interface ComplianceHoldReleaseInput {notes: Scalars['String']}

export interface ComplianceHoldResultPageGenqlSelection{
    entries?: ComplianceHoldGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceHoldUpdateInput {accountId?: (Scalars['ID'] | null),exemptionReason?: (HoldExemptionReason | null),holdDays?: (Scalars['Int'] | null),holdEnd?: (Scalars['ZonedDateTime'] | null),holdStart?: (Scalars['ZonedDateTime'] | null),jurisdictionCode?: (Scalars['String'] | null),maxImmediateCash?: (Scalars['Decimal'] | null),notes?: (Scalars['String'] | null),purchaseLoadId?: (Scalars['ID'] | null),releasedAt?: (Scalars['ZonedDateTime'] | null),releasedByUserId?: (Scalars['ID'] | null),status?: (ComplianceHoldStatus | null)}

export interface ComplianceItemInput {categoryId: Scalars['ID'],deductions: Scalars['Decimal'],itemId: Scalars['ID'],quantity: Scalars['Decimal'],tax: Scalars['Decimal'],totalAmount: Scalars['Decimal'],weight: Scalars['Decimal']}

export interface ComplianceItemJurisdictionCodeGenqlSelection{
    code?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    id?: boolean | number
    isReportable?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    serviceType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceItemJurisdictionCodeFilter {ids?: (Scalars['ID'][] | null)}

export interface ComplianceItemJurisdictionCodeInput {code: Scalars['String'],description?: (Scalars['String'] | null),isReportable: Scalars['Boolean'],itemId: Scalars['ID'],serviceType: GovernmentReportingServiceType}

export interface ComplianceItemJurisdictionCodeResultPageGenqlSelection{
    entries?: ComplianceItemJurisdictionCodeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceItemJurisdictionCodeUpdateInput {code?: (Scalars['String'] | null),description?: (Scalars['String'] | null),isReportable?: (Scalars['Boolean'] | null),itemId?: (Scalars['ID'] | null),serviceType?: (GovernmentReportingServiceType | null)}

export interface ComplianceRuleDefinitionGenqlSelection{
    allowedValues?: boolean | number
    appliesTo?: boolean | number
    category?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    dataType?: boolean | number
    defaultValue?: boolean | number
    description?: boolean | number
    enforcementLevel?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    isSystem?: boolean | number
    jurisdictionCode?: boolean | number
    name?: boolean | number
    ruleCode?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceRuleDefinitionFilter {ids?: (Scalars['ID'][] | null)}

export interface ComplianceRuleDefinitionInput {allowedValues?: (Scalars['Map'] | null),appliesTo: ComplianceRuleAppliesTo,category: ComplianceRuleCategory,dataType: ComplianceRuleDataType,defaultValue?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),enforcementLevel: ComplianceEnforcementLevel,isActive: Scalars['Boolean'],isSystem: Scalars['Boolean'],jurisdictionCode?: (Scalars['String'] | null),name: Scalars['String'],ruleCode: Scalars['String']}

export interface ComplianceRuleDefinitionResultPageGenqlSelection{
    entries?: ComplianceRuleDefinitionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ComplianceRuleDefinitionUpdateInput {allowedValues?: (Scalars['Map'] | null),appliesTo?: (ComplianceRuleAppliesTo | null),category?: (ComplianceRuleCategory | null),dataType?: (ComplianceRuleDataType | null),defaultValue?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),enforcementLevel?: (ComplianceEnforcementLevel | null),isActive?: (Scalars['Boolean'] | null),isSystem?: (Scalars['Boolean'] | null),jurisdictionCode?: (Scalars['String'] | null),name?: (Scalars['String'] | null),ruleCode?: (Scalars['String'] | null)}

export interface ComplianceSupplierInput {address?: (Scalars['String'] | null),contactId: Scalars['ID'],dateOfBirth?: (Scalars['ZonedDateTime'] | null),employer?: (Scalars['String'] | null),firstName?: (Scalars['String'] | null),hasDlBack: Scalars['Boolean'],hasDlFront: Scalars['Boolean'],hasPhoto: Scalars['Boolean'],hasSignature: Scalars['Boolean'],hasThumbprint: Scalars['Boolean'],height?: (Scalars['String'] | null),idExpiration?: (Scalars['ZonedDateTime'] | null),idNumber?: (Scalars['String'] | null),idState?: (Scalars['String'] | null),idType?: (Scalars['String'] | null),lastName?: (Scalars['String'] | null),sex?: (Scalars['String'] | null),weight?: (Scalars['String'] | null)}

export interface ComplianceVehicleInput {color?: (Scalars['String'] | null),licensePlate?: (Scalars['String'] | null),make?: (Scalars['String'] | null),model?: (Scalars['String'] | null),state?: (Scalars['String'] | null),vin?: (Scalars['String'] | null),year?: (Scalars['String'] | null)}

export interface ConditionNodeGenqlSelection{
    description?: boolean | number
    expression?: boolean | number
    falseBranchLabel?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    trueBranchLabel?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ConfirmPaymentsInput {ids: Scalars['ID'][]}

export interface ContactGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    address?: AccountAddressGenqlSelection
    addressAs?: boolean | number
    addressId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    department?: boolean | number
    email?: boolean | number
    fullName?: boolean | number
    id?: boolean | number
    isPrimary?: boolean | number
    notes?: boolean | number
    owner?: UserGenqlSelection
    ownerUserId?: boolean | number
    phone?: boolean | number
    prefix?: boolean | number
    role?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    user?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContactFilter {accountId?: (Scalars['ID'] | null),accountIds?: (Scalars['ID'][] | null),addressAs?: (Scalars['String'] | null),addressId?: (Scalars['ID'] | null),addressIds?: (Scalars['ID'][] | null),department?: (Scalars['String'] | null),email?: (Scalars['String'] | null),fullName?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),ownerUserId?: (Scalars['ID'] | null),ownerUserIds?: (Scalars['ID'][] | null),phone?: (Scalars['String'] | null),prefix?: (Scalars['String'] | null),role?: (Scalars['String'] | null),roles?: (Scalars['String'][] | null),searchTerm?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null),userIds?: (Scalars['ID'][] | null)}

export interface ContactResultPageGenqlSelection{
    entries?: ContactGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContainerGenqlSelection{
    arrivedAtFacilityAt?: boolean | number
    booking?: BookingGenqlSelection
    bookingId?: boolean | number
    containerNumber?: boolean | number
    containerType?: ContainerTypeGenqlSelection
    containerTypeId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    departedFacilityAt?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    load?: LoadGenqlSelection
    loadId?: boolean | number
    loadedAt?: boolean | number
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    pickedUpAt?: boolean | number
    returnedToPortAt?: boolean | number
    sealNumber?: boolean | number
    shippedAt?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContainerBatchCreateInput {bookingId: Scalars['ID'],containerTypeId: Scalars['ID'],facilityId?: (Scalars['ID'] | null),quantity: Scalars['Int']}

export interface ContainerFilter {bookingIds?: (Scalars['ID'][] | null),containerNumber?: (Scalars['String'] | null),containerTypeIds?: (Scalars['ID'][] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),loadIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),status?: (ContainerStatus[] | null)}

export interface ContainerInput {bookingId: Scalars['ID'],containerNumber?: (Scalars['String'] | null),containerTypeId: Scalars['ID'],facilityId?: (Scalars['ID'] | null),sealNumber?: (Scalars['String'] | null)}

export interface ContainerResultPageGenqlSelection{
    entries?: ContainerGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContainerStatusCountsGenqlSelection{
    atFacilityEmpty?: boolean | number
    atFacilityLoaded?: boolean | number
    atPort?: boolean | number
    atPortReadyToShip?: boolean | number
    inTransitToFacility?: boolean | number
    inTransitToPort?: boolean | number
    shipped?: boolean | number
    total?: boolean | number
    voided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContainerTypeGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContainerTypeFilter {ids?: (Scalars['ID'][] | null),includeDeleted?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface ContainerTypeResultPageGenqlSelection{
    entries?: ContainerTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ContainerUpdateInput {containerNumber?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),sealNumber?: (Scalars['String'] | null)}


/** Input for conversation participants */
export interface ConversationParticipantInput {contactType: ContactType,email: Scalars['String'],fullName: Scalars['String'],organizationName: Scalars['String'],participantId?: (Scalars['ID'] | null),phone?: (Scalars['String'] | null),role?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null)}

export interface CoordinatesGenqlSelection{
    latitude?: boolean | number
    longitude?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CoordinatesInput {latitude: Scalars['Decimal'],longitude: Scalars['Decimal']}

export interface CoreOutboxEventCountsGenqlSelection{
    facility?: boolean | number
    facilityGroup?: boolean | number
    organization?: boolean | number
    user?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CoreOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (CoreAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface CounterpartyGroupGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    memberCount?: boolean | number
    name?: boolean | number
    operationType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedById?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CounterpartyGroupFilter {ids?: (Scalars['ID'][] | null),operationTypes?: (OperationType[] | null),searchTerm?: (Scalars['String'] | null)}

export interface CounterpartyGroupInput {name: Scalars['String'],operationType: OperationType,updatedById?: (Scalars['ID'] | null)}

export interface CounterpartyGroupMemberGenqlSelection{
    accountId?: boolean | number
    addedById?: boolean | number
    counterpartyGroupId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CounterpartyGroupMemberFilter {accountId?: (Scalars['ID'] | null),accountIds?: (Scalars['ID'][] | null),addedById?: (Scalars['ID'] | null),addedByIds?: (Scalars['ID'][] | null),counterpartyGroupId?: (Scalars['ID'] | null),counterpartyGroupIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface CounterpartyGroupMemberInput {accountId: Scalars['ID'],addedById: Scalars['ID'],counterpartyGroupId?: (Scalars['ID'] | null)}

export interface CounterpartyGroupMemberResultPageGenqlSelection{
    entries?: CounterpartyGroupMemberGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CounterpartyGroupMemberUpdateInput {accountId?: (Scalars['ID'] | null),addedById?: (Scalars['ID'] | null),counterpartyGroupId?: (Scalars['ID'] | null),id?: (Scalars['ID'] | null)}

export interface CounterpartyGroupResultPageGenqlSelection{
    entries?: CounterpartyGroupGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CounterpartyGroupUpdateInput {name?: (Scalars['String'] | null),operationType?: (OperationType | null),updatedById?: (Scalars['ID'] | null)}

export interface CreateAccountAddressInput {accountId?: (Scalars['ID'] | null),address: AddressInput,contacts?: (CreateContactInput[] | null),customAttributes?: (Scalars['Map'] | null),locationType: AddressLocationType,name?: (Scalars['String'] | null),operatingHours?: (Scalars['Map'] | null)}

export interface CreateAccountIdentityDocumentInput {accountIndividualDetailsId?: (Scalars['ID'] | null),documentNumber?: (Scalars['String'] | null),documentType: IdentityDocumentType,expirationDate?: (Scalars['CalendarDate'] | null),issueDate?: (Scalars['CalendarDate'] | null),issuingState?: (Scalars['String'] | null)}

export interface CreateAccountIndividualDetailsInput {accountId?: (Scalars['ID'] | null),dateOfBirth?: (Scalars['CalendarDate'] | null),employer?: (Scalars['String'] | null),eyeColor?: (IndividualEyeColor | null),hairColor?: (IndividualHairColor | null),height?: (Scalars['Int'] | null),identityDocuments?: (CreateAccountIdentityDocumentInput[] | null),race?: (IndividualRace | null),sex?: (IndividualSex | null),weight?: (Scalars['Int'] | null)}

export interface CreateAccountInput {accountManagerIds?: (Scalars['ID'][] | null),addresses?: (CreateAccountAddressInput[] | null),customAttributes?: (Scalars['Map'] | null),defaultPurchasePaymentTermId?: (Scalars['ID'] | null),defaultSalesPaymentTermId?: (Scalars['ID'] | null),dotNumber?: (Scalars['String'] | null),email?: (Scalars['String'] | null),individualDetails?: (CreateAccountIndividualDetailsInput | null),insuranceExpiration?: (Scalars['CalendarDate'] | null),linkedOrganizationId?: (Scalars['ID'] | null),mcNumber?: (Scalars['String'] | null),name: Scalars['String'],notes?: (Scalars['String'] | null),paymentSchedulePreference?: (Scalars['String'] | null),paymentTypePreference?: (Scalars['String'] | null),phone?: (Scalars['String'] | null),relationship: AccountRelationshipInput,scac?: (Scalars['String'] | null),type: AccountType,w9OnFile?: (Scalars['Boolean'] | null),website?: (Scalars['String'] | null)}

export interface CreateAgentInput {agentIdentifier?: (Scalars['String'] | null),content: Scalars['String'],description?: (Scalars['String'] | null),model?: (Scalars['String'] | null),modelProvider?: (ModelProvider | null),name: Scalars['String'],organizationId?: (Scalars['ID'] | null),providerApiKey?: (Scalars['String'] | null),providerBaseUrl?: (Scalars['String'] | null),reasoningBudget?: (Scalars['Int'] | null),reasoningEnabled?: (Scalars['Boolean'] | null),temperature?: (Scalars['Float'] | null),type: AgentType}

export interface CreateAssetInput {accountAddressId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),currentLocation?: (AddressInput | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),fillState: AssetFillState,identifier: Scalars['String'],lastLocationTime?: (Scalars['ZonedDateTime'] | null),notes?: (Scalars['String'] | null),status: AssetStatus,tareWeight?: (WeightInput | null),typeId: Scalars['ID']}

export interface CreateAssetTypeInput {capacity: Scalars['Float'],description: Scalars['String'],name: Scalars['String']}

export interface CreateAssistantChatInput {title?: (Scalars['String'] | null)}

export interface CreateAutomationInput {description?: (Scalars['String'] | null),edges: EdgeInput[],name: Scalars['String'],nodes: NodeInput[],triggerConfig: TriggerConfigInput,triggerType: TriggerType}

export interface CreateBillInput {accountID: Scalars['ID'],amount: MoneyInput,compliance: BillComplianceRule[],documentDate: Scalars['CalendarDate'],documentNumber?: (Scalars['String'] | null),dueDate?: (Scalars['CalendarDate'] | null),eligibleAt?: (Scalars['CalendarDate'] | null),facilityID: Scalars['ID'],lineItems?: (BillLineItemInput[] | null),notes?: (Scalars['String'] | null),outboundScaleTicketID?: (Scalars['ID'] | null),paymentTerm?: (PaymentTerm | null),paymentTermId?: (Scalars['ID'] | null),preferredPaymentMethod: PaymentMethod,scaleTicketID?: (Scalars['ID'] | null),type: BillType}

export interface CreateBrokeredOrderLineItemInput {brokeredOrderId?: (Scalars['ID'] | null),itemId: Scalars['ID'],notes?: (Scalars['String'] | null),quantity: Scalars['Decimal'],unit: Unit}

export interface CreateCameraInput {driverType: Scalars['String'],name: Scalars['String'],sidecarId: Scalars['ID'],snapshotUrl?: (Scalars['String'] | null),streamProfile: Scalars['String'],streamUrl?: (Scalars['String'] | null),uniqueId: Scalars['String'],username?: (Scalars['String'] | null)}

export interface CreateContactInput {accountId: Scalars['ID'],addressAs: Scalars['String'],addressId?: (Scalars['ID'] | null),customAttributes?: (Scalars['Map'] | null),department?: (Scalars['String'] | null),email?: (Scalars['String'] | null),fullName: Scalars['String'],isPrimary: Scalars['Boolean'],notes?: (Scalars['String'] | null),ownerUserId?: (Scalars['ID'] | null),phone?: (Scalars['String'] | null),prefix?: (Scalars['String'] | null),role?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null)}

export interface CreateContainerTypeInput {name: Scalars['String']}


/** Input for creating a conversation */
export interface CreateConversationInput {conversationId?: (Scalars['String'] | null),custom?: (Scalars['Any'] | null),participants: ConversationParticipantInput[],subject: Scalars['String']}


/** Result of creating a conversation */
export interface CreateConversationResultGenqlSelection{
    conversationId?: boolean | number
    participants?: UserContactGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateCustomAttributeInput {constraints: FieldConstraintsInput,dataType: FieldDataType,entityType: CustomAttributeEntityType,name: Scalars['String'],order?: (Scalars['Int'] | null)}

export interface CreateCustomerInvitationInput {accountId: Scalars['ID'],email?: (Scalars['String'] | null)}

export interface CreateDriverCertificationInput {driverId: Scalars['ID'],expirationDate: Scalars['ZonedDateTime'],issuedDate: Scalars['ZonedDateTime'],issuingBody: Scalars['String'],number: Scalars['String'],type: Scalars['String']}

export interface CreateDriverInput {address: AddressInput,currentLocation?: (PointInput | null),defaultTrailerId?: (Scalars['ID'] | null),defaultTruckId?: (Scalars['ID'] | null),email: Scalars['String'],firstName: Scalars['String'],lastLocationTime?: (Scalars['ZonedDateTime'] | null),lastName: Scalars['String'],licenseExpiration?: (Scalars['ZonedDateTime'] | null),licenseNumber?: (Scalars['String'] | null),phoneNumber: Scalars['String'],status: DriverStatus,userId?: (Scalars['ID'] | null)}

export interface CreateFileErrorGenqlSelection{
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateFileInput {entityId?: (Scalars['ID'] | null),entityType?: (Scalars['String'] | null),expiresAt?: (Scalars['Time'] | null),fileName: Scalars['String'],fileSize: Scalars['Int'],fileType?: (FileType | null),metadata?: (Scalars['Map'] | null),mimeType: Scalars['String'],parentId?: (Scalars['ID'] | null),public: Scalars['Boolean']}

export interface CreateFilePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateFileResultGenqlSelection{
    on_CreateFileError?:CreateFileErrorGenqlSelection,
    on_CreateFileSuccess?:CreateFileSuccessGenqlSelection,
    __typename?: boolean | number
}

export interface CreateFileSuccessGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateFilesPayloadGenqlSelection{
    failed?: CreateFileErrorGenqlSelection
    succeeded?: CreateFileSuccessGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CreateFinancialAccountInput {accountNumber?: (Scalars['String'] | null),bankName?: (Scalars['String'] | null),checkBusinessName?: (Scalars['String'] | null),checkLogo?: (Scalars['String'] | null),checkMailingAddress?: (Scalars['String'] | null),checkNumberGeneration?: (Scalars['Boolean'] | null),checkPhoneNumber?: (Scalars['String'] | null),checkSignature?: (Scalars['String'] | null),currency: CurrencyCode,customAttributes?: (Scalars['Map'] | null),ezcashEndpoint?: (Scalars['String'] | null),ezcashTimeoutSeconds?: (Scalars['Int'] | null),ezcashToken?: (Scalars['String'] | null),facilityID: Scalars['ID'],initialBalance: Scalars['Decimal'],lastCheckNumber?: (Scalars['Int'] | null),nachaCompanyIdentification?: (Scalars['String'] | null),nachaCompanyName?: (Scalars['String'] | null),nachaDefaultSecCode?: (Scalars['String'] | null),name: Scalars['String'],paymentAllocationMethod?: (PaymentAllocationMethod | null),roundingMethod: RoundingMethod,roundingPrecision: RoundingPrecision,routingNumber?: (Scalars['String'] | null),type: FinancialAccountType,visibleInPayments: Scalars['Boolean'],warningThreshold: Scalars['Decimal']}

export interface CreateFinancialAccountTransactionInput {amount: Scalars['Decimal'],authorizedDate?: (Scalars['CalendarDate'] | null),channel: FinancialAccountTransactionChannel,checkNumber?: (Scalars['String'] | null),counterpartyIds?: (Scalars['ID'][] | null),date: Scalars['CalendarDate'],financialAccountId: Scalars['ID'],financialAccountOwnerId?: (Scalars['String'] | null),imageUrl?: (Scalars['String'] | null),location?: (AddressInput | null),pendingTransactionId?: (Scalars['ID'] | null),reference: Scalars['String'],status: FinancialAccountTransactionStatus,transferNumber?: (Scalars['String'] | null),type: FinancialAccountTransactionType,website?: (Scalars['String'] | null)}

export interface CreateInvoiceInput {accountID: Scalars['ID'],amount: MoneyInput,documentDate: Scalars['CalendarDate'],documentNumber?: (Scalars['String'] | null),facilityID: Scalars['ID'],lineItems?: (InvoiceLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentTerm?: (PaymentTerm | null),paymentTermId?: (Scalars['ID'] | null),sourceReferences?: (InvoiceEntityReferenceInput[] | null),status?: (InvoiceStatus | null),type: InvoiceType}

export interface CreateItemPricingTierInput {itemPricingId?: (Scalars['ID'] | null),maxAmount?: (Scalars['Decimal'] | null),maxPrice?: (UnitPriceFormulaInput | null),minPrice?: (UnitPriceFormulaInput | null),position: Scalars['Int'],scrapValue: Scalars['Decimal'],targetPrice?: (UnitPriceFormulaInput | null)}

export interface CreateLoadDeductionInput {applicationType: DeductionApplicationType,deductionTypeId: Scalars['ID'],facilityId: Scalars['ID'],loadId?: (Scalars['ID'] | null),loadLineItemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),percentage?: (Scalars['Decimal'] | null),priceValue?: (MoneyInput | null),weightValue?: (WeightInput | null)}

export interface CreateOrganizationInput {domain: Scalars['String'],idpId?: (Scalars['String'] | null),name: Scalars['String'],onboardAt?: (Scalars['ZonedDateTime'] | null),timezone?: (Scalars['Timezone'] | null)}

export interface CreatePaymentInput {accountId?: (Scalars['ID'] | null),achNumber?: (Scalars['String'] | null),amount: MoneyInput,atmId?: (Scalars['String'] | null),atmPaymentNumber?: (Scalars['String'] | null),barcode?: (Scalars['String'] | null),barcodeRowId?: (Scalars['Int'] | null),billIds?: (Scalars['ID'][] | null),checkAttn?: (Scalars['String'] | null),checkFacilityId?: (Scalars['ID'] | null),checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),documentNumber?: (Scalars['String'] | null),financialAccountId: Scalars['ID'],financialAccountTransactionId?: (Scalars['ID'] | null),invoiceIds?: (Scalars['ID'][] | null),paymentMethod: PaymentMethod,paymentType: PaymentType,supplierPhotoId?: (Scalars['ID'] | null),transactionDate: Scalars['CalendarDate'],wireNumber?: (Scalars['String'] | null)}

export interface CreatePrinterInput {driverType: Scalars['String'],name: Scalars['String'],pageSize?: (PrinterPageSize | null),printerType: PrinterType,rollWidth?: (PrinterRollWidth | null),sidecarId: Scalars['ID'],uniqueId: Scalars['String']}

export interface CreateProcessingTypeInputItemInput {isPrimary: Scalars['Boolean'],itemId: Scalars['ID'],notes?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),sortOrder: Scalars['Int']}

export interface CreateProcessingTypeOutputItemInput {costAllocationPercentage?: (Scalars['Decimal'] | null),isNoCost: Scalars['Boolean'],isPrimary: Scalars['Boolean'],itemId: Scalars['ID'],notes?: (Scalars['String'] | null),outputUnit: Unit,processingTypeId?: (Scalars['ID'] | null),sortOrder: Scalars['Int'],yieldPercentage: Scalars['Decimal']}

export interface CreatePurchaseLoadDeductionInput {applicationType: DeductionApplicationType,deductionTypeId: Scalars['ID'],notes?: (Scalars['String'] | null),percentage?: (Scalars['Decimal'] | null),priceValue?: (MoneyInput | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseLoadLineItemId?: (Scalars['ID'] | null),weightValue?: (WeightInput | null)}

export interface CreatePurchaseLoadLineItemInput {catComplianceStatus?: (Scalars['String'] | null),catOemCode?: (Scalars['String'] | null),catSerialNumber?: (Scalars['String'] | null),estimatedPrice?: (MoneyInput | null),grossWeight?: (WeightInput | null),itemId?: (Scalars['ID'] | null),netWeight?: (WeightInput | null),notes?: (Scalars['String'] | null),parentLineItemId?: (Scalars['ID'] | null),pricingUnit?: (Unit | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseOrderLineId?: (Scalars['ID'] | null),requiresSorting: Scalars['Boolean'],settlementBasis: SettlementBasis,tagId?: (Scalars['ID'] | null),tareWeight?: (WeightInput | null),type: PurchaseLineItemType,unitPrice?: (MoneyInput | null),vehicleMake?: (Scalars['String'] | null),vehicleModel?: (Scalars['String'] | null),vehicleTitleStatus?: (Scalars['String'] | null),vehicleVin?: (Scalars['String'] | null),vehicleYear?: (Scalars['Int'] | null)}

export interface CreatePurchaseLoadPaymentInput {amount: MoneyInput,checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),creatorId?: (Scalars['ID'] | null),financialAccountId?: (Scalars['ID'] | null),legalHold: Scalars['Boolean'],paymentMethod: Scalars['String'],paymentTerm: Scalars['String'],percentage?: (Scalars['Decimal'] | null),purchaseLoadId: Scalars['ID'],roundingMethod?: (Scalars['String'] | null),roundingPrecision?: (Scalars['String'] | null)}

export interface CreatePurchaseOrderInput {accountAddressId: Scalars['ID'],accountContactId?: (Scalars['ID'] | null),accountId: Scalars['ID'],accountRepresentativeId?: (Scalars['ID'] | null),completionNotes?: (Scalars['String'] | null),counterpartyReferenceNumber?: (Scalars['String'] | null),customAttributes?: (Scalars['Map'] | null),documentNumber?: (Scalars['String'] | null),endDate?: (Scalars['CalendarDate'] | null),facilityId: Scalars['ID'],freightTerm: FreightTerm,lineItems?: (CreatePurchaseOrderLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentCurrency: Scalars['String'],paymentTerm: PaymentTerm,startDate?: (Scalars['CalendarDate'] | null),status: PurchaseOrderStatus}

export interface CreatePurchaseOrderLineItemInput {itemId: Scalars['ID'],purchaseOrderId?: (Scalars['ID'] | null),quantity?: (Scalars['Decimal'] | null),totalPrice: MoneyInput,unit?: (Unit | null),unitPrice: MoneyInput}

export interface CreateQuoteLineItemInput {itemId: Scalars['ID'],notes?: (Scalars['String'] | null),packageFormat?: (Scalars['String'] | null),quantity: Scalars['Decimal'],quoteId?: (Scalars['ID'] | null),unit: Unit,unitPrice: MoneyInput}

export interface CreateRoleInput {description?: (Scalars['String'] | null),name: Scalars['String'],permissions?: (Scalars['String'][] | null),type?: (RoleType | null)}

export interface CreateRouteInput {driverId?: (Scalars['ID'] | null),facilityGroupId: Scalars['ID'],haulerId?: (Scalars['ID'] | null),routeDate?: (Scalars['ZonedDateTime'] | null),status: RouteStatus,trailerId?: (Scalars['ID'] | null),truckId?: (Scalars['ID'] | null)}

export interface CreateScaleInput {baudRate?: (Scalars['Int'] | null),cameraId?: (Scalars['ID'] | null),connectionType: ScaleConnectionType,dataBits?: (Scalars['Int'] | null),measurementIncrement?: (Scalars['Decimal'] | null),measurementMode: ScaleMeasurementMode,name: Scalars['String'],onDemandString?: (Scalars['String'] | null),parity?: (Scalars['String'] | null),scaleFormatType: ScaleFormatType,serialPortPath?: (Scalars['String'] | null),sidecarId: Scalars['ID'],stopBits?: (Scalars['String'] | null),tcpHost?: (Scalars['String'] | null),tcpPort?: (Scalars['Int'] | null),unitOfMeasurement?: (Scalars['String'] | null)}

export interface CreateScannerInput {driverType: Scalars['String'],name: Scalars['String'],sidecarId: Scalars['ID'],uniqueId: Scalars['String']}

export interface CreateServiceInput {accountAddressId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),actions?: (ServiceActionInput[] | null),address?: (AddressInput | null),assetTypes?: (ServiceAssetTypeInput[] | null),assets?: (ServiceAssetInput[] | null),assignmentStatus?: (AssignmentStatus | null),contactId?: (Scalars['ID'] | null),deadline?: (Scalars['ZonedDateTime'] | null),destinationFacilityId?: (Scalars['ID'] | null),driverId?: (Scalars['ID'] | null),driverNotes?: (Scalars['String'] | null),estimatedArrival?: (Scalars['ZonedDateTime'] | null),externalNotes?: (Scalars['String'] | null),facilityGroupId?: (Scalars['ID'] | null),facilityId?: (Scalars['ID'] | null),haulerId?: (Scalars['ID'] | null),internalNotes?: (Scalars['String'] | null),isRequest: Scalars['Boolean'],isTemplate: Scalars['Boolean'],priority: Scalars['Int'],rank?: (Scalars['String'] | null),recurringSchedule?: (RecurringScheduleInput | null),recurringTaskId?: (Scalars['ID'] | null),routeId?: (Scalars['ID'] | null),routePosition?: (Scalars['Decimal'] | null),scheduledWindowEnd: Scalars['ZonedDateTime'],scheduledWindowStart?: (Scalars['ZonedDateTime'] | null),serviceTypeId?: (Scalars['ID'] | null),status?: (ServiceStatus | null),trailerId?: (Scalars['ID'] | null),truckId?: (Scalars['ID'] | null)}

export interface CreateServiceTypeWithDefinitionsInput {description?: (Scalars['String'] | null),isActive: Scalars['Boolean'],isSystemDefault: Scalars['Boolean'],name: Scalars['String'],taskDefinitions?: (ServiceTypeTaskDefinitionInlineInput[] | null)}

export interface CreateSettingInput {constraints: FieldConstraintsInput,dataType: FieldDataType,defaultValue?: (Scalars['Any'] | null),description: Scalars['String'],id: Scalars['String'],name: Scalars['String'],scope: SettingScope[],settingsGroupId: Scalars['ID']}

export interface CreateSettingsGroupInput {description: Scalars['String'],icon?: (Scalars['String'] | null),name: Scalars['String']}

export interface CreateSidecarInput {facilityId?: (Scalars['ID'] | null),name: Scalars['String'],operatingSystem: SidecarOperatingSystem,operatingSystemVersion: Scalars['String']}

export interface CreateTollReceiptItemInput {itemId: Scalars['ID'],lotId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),quantity: Scalars['Decimal'],quantityUnit: Unit,tollReceiptId?: (Scalars['ID'] | null)}

export interface CreateTollShipmentItemInput {itemId: Scalars['ID'],lotId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),processingFee?: (MoneyInput | null),quantity: Scalars['Decimal'],quantityUnit: Unit,tollShipmentId?: (Scalars['ID'] | null)}

export interface CreateTrailerInput {capacity: Scalars['Float'],country: Scalars['String'],currentLocation?: (PointInput | null),facilityId: Scalars['ID'],lastLocationTime?: (Scalars['ZonedDateTime'] | null),licensePlate: Scalars['String'],licensePlateExpiration?: (Scalars['ZonedDateTime'] | null),notes?: (Scalars['String'] | null),state: Scalars['String'],status: TrailerStatus,transportationTypeId: Scalars['ID'],vin?: (Scalars['String'] | null)}

export interface CreateTransportationTypeInput {description: Scalars['String'],name: Scalars['String']}

export interface CreateTruckInput {capacity?: (Scalars['Float'] | null),country: Scalars['String'],currentLocation?: (PointInput | null),defaultTrailerId?: (Scalars['ID'] | null),facilityId: Scalars['ID'],lastLocationTime?: (Scalars['ZonedDateTime'] | null),licensePlate: Scalars['String'],licensePlateExpiration?: (Scalars['ZonedDateTime'] | null),model: Scalars['String'],notes?: (Scalars['String'] | null),state: Scalars['String'],status: TruckStatus,transportationTypeId: Scalars['ID'],vin?: (Scalars['String'] | null),year?: (Scalars['Int'] | null)}

export interface CreateUserInput {email: Scalars['String'],firstName: Scalars['String'],idpId?: (Scalars['String'] | null),lastName: Scalars['String'],organizationId?: (Scalars['ID'] | null),phoneNumber?: (Scalars['String'] | null),roleAssignments?: (UserRoleAssignmentInput[] | null),timezone: Scalars['Timezone']}

export interface CreateWarehouseCredentialInput {databaseName: Scalars['String'],enabled: Scalars['Boolean'],host: Scalars['String'],port: Scalars['Int'],ssl: Scalars['Boolean'],username: Scalars['String']}

export interface CreateWorkOrderInputItemInput {actualQuantity?: (Scalars['Decimal'] | null),actualQuantityUnit?: (Unit | null),itemId: Scalars['ID'],lotId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),plannedQuantity: Scalars['Decimal'],plannedQuantityUnit: Unit,tagId?: (Scalars['ID'] | null),unitCost?: (MoneyInput | null),workOrderId?: (Scalars['ID'] | null)}

export interface CreateWorkOrderOutputItemInput {actualQuantity?: (Scalars['Decimal'] | null),actualQuantityUnit?: (Unit | null),allocatedCost?: (MoneyInput | null),costAllocationPercentage?: (Scalars['Decimal'] | null),expectedQuantity: Scalars['Decimal'],expectedQuantityUnit: Unit,isNoCost: Scalars['Boolean'],itemId: Scalars['ID'],notes?: (Scalars['String'] | null),targetLotId?: (Scalars['ID'] | null),targetTagId?: (Scalars['ID'] | null),unitCost?: (MoneyInput | null),workOrderId?: (Scalars['ID'] | null),yieldPercentage?: (Scalars['Decimal'] | null)}

export interface CrmOutboxEventCountsGenqlSelection{
    account?: boolean | number
    accountAddress?: boolean | number
    contact?: boolean | number
    customerInvitation?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CrmOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (CrmAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface CustomAttributeGenqlSelection{
    constraints?: FieldConstraintsGenqlSelection
    dataType?: boolean | number
    entityType?: boolean | number
    id?: boolean | number
    isDisabled?: boolean | number
    name?: boolean | number
    order?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomAttributeFilter {entityTypes?: (CustomAttributeEntityType[] | null)}

export interface CustomPriceListGenqlSelection{
    archivedAt?: boolean | number
    counterpartyGroupId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currency?: boolean | number
    endDate?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    isPublished?: boolean | number
    name?: boolean | number
    notes?: boolean | number
    operationType?: boolean | number
    pricingMode?: boolean | number
    startDate?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomPriceListDraftInput {counterpartyGroupId: Scalars['ID'],currency: Scalars['String'],endDate?: (Scalars['ZonedDateTime'] | null),facilityId: Scalars['ID'],name: Scalars['String'],notes?: (Scalars['String'] | null),operationType: OperationType,pricingMode?: (PricingMode | null),startDate?: (Scalars['ZonedDateTime'] | null)}

export interface CustomPriceListFilter {ids?: (Scalars['ID'][] | null),isArchived?: (Scalars['Boolean'] | null),isPublished?: (Scalars['Boolean'] | null)}

export interface CustomPriceListInput {archivedAt?: (Scalars['ZonedDateTime'] | null),counterpartyGroupId: Scalars['ID'],currency: Scalars['String'],endDate?: (Scalars['ZonedDateTime'] | null),facilityId: Scalars['ID'],isPublished: Scalars['Boolean'],name: Scalars['String'],notes?: (Scalars['String'] | null),operationType: OperationType,pricingMode: PricingMode,startDate?: (Scalars['ZonedDateTime'] | null)}

export interface CustomPriceListResultPageGenqlSelection{
    entries?: CustomPriceListGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomPriceListStatusCountsGenqlSelection{
    active?: boolean | number
    archived?: boolean | number
    draft?: boolean | number
    expired?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomPriceListUpdateInput {archivedAt?: (Scalars['ZonedDateTime'] | null),counterpartyGroupId?: (Scalars['ID'] | null),currency?: (Scalars['String'] | null),endDate?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),isPublished?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),operationType?: (OperationType | null),pricingMode?: (PricingMode | null),startDate?: (Scalars['ZonedDateTime'] | null)}

export interface CustomerInvitationGenqlSelection{
    acceptedAt?: boolean | number
    account?: AccountGenqlSelection
    accountId?: boolean | number
    email?: boolean | number
    expiresAt?: boolean | number
    id?: boolean | number
    invitationStatus?: boolean | number
    invitedByUserId?: boolean | number
    linkedOrganizationId?: boolean | number
    sentAt?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CustomerInvitationFilter {accountIds?: (Scalars['ID'][] | null),email?: (Scalars['String'] | null),includeAccount?: (Scalars['Boolean'] | null),invitationIds?: (Scalars['ID'][] | null),invitationStatuses?: (InvitationStatus[] | null),invitedByUserId?: (Scalars['ID'] | null),linkedOrganizationId?: (Scalars['ID'] | null)}

export interface CustomerInvitationResultPageGenqlSelection{
    entries?: CustomerInvitationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountLineGenqlSelection{
    adjustmentMovement?: InventoryMovementGenqlSelection
    adjustmentMovementId?: boolean | number
    adjustmentStatus?: boolean | number
    countedAt?: boolean | number
    countedBy?: boolean | number
    countedByUser?: UserGenqlSelection
    countedQuantity?: boolean | number
    countedQuantityUnit?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    cycleCountTask?: CycleCountTaskGenqlSelection
    cycleCountTaskId?: boolean | number
    expectedQuantity?: boolean | number
    expectedQuantityUnit?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    notes?: boolean | number
    recountRequested?: boolean | number
    stockAccount?: InventoryAccountGenqlSelection
    stockAccountId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    toleranceThreshold?: boolean | number
    unitCostOverride?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    variancePercentage?: boolean | number
    varianceQuantity?: boolean | number
    withinTolerance?: boolean | number
    zone?: InventoryZoneGenqlSelection
    zoneId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountLineFilter {adjustmentStatus?: (Scalars['String'] | null),cycleCountTaskIds?: (Scalars['ID'][] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemIds?: (Scalars['ID'][] | null),stockAccountIds?: (Scalars['ID'][] | null)}

export interface CycleCountLineInput {adjustmentMovementId?: (Scalars['ID'] | null),adjustmentStatus?: (Scalars['String'] | null),countedAt?: (Scalars['ZonedDateTime'] | null),countedBy?: (Scalars['ID'] | null),countedQuantity?: (Scalars['Decimal'] | null),countedQuantityUnit?: (Scalars['String'] | null),cycleCountTaskId: Scalars['ID'],expectedQuantity?: (Scalars['Decimal'] | null),expectedQuantityUnit: Scalars['String'],facilityId: Scalars['ID'],itemId: Scalars['ID'],notes?: (Scalars['String'] | null),recountRequested: Scalars['Boolean'],stockAccountId: Scalars['ID'],toleranceThreshold: Scalars['Decimal'],unitCostOverride?: (Scalars['Decimal'] | null),variancePercentage?: (Scalars['Decimal'] | null),varianceQuantity?: (Scalars['Decimal'] | null),withinTolerance?: (Scalars['Boolean'] | null),zoneId?: (Scalars['ID'] | null)}

export interface CycleCountLineResultPageGenqlSelection{
    entries?: CycleCountLineGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountLineUpdateInput {adjustmentMovementId?: (Scalars['ID'] | null),adjustmentStatus?: (Scalars['String'] | null),countedAt?: (Scalars['ZonedDateTime'] | null),countedBy?: (Scalars['ID'] | null),countedQuantity?: (Scalars['Decimal'] | null),countedQuantityUnit?: (Scalars['String'] | null),cycleCountTaskId?: (Scalars['ID'] | null),expectedQuantity?: (Scalars['Decimal'] | null),expectedQuantityUnit?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),recountRequested?: (Scalars['Boolean'] | null),stockAccountId?: (Scalars['ID'] | null),toleranceThreshold?: (Scalars['Decimal'] | null),unitCostOverride?: (Scalars['Decimal'] | null),variancePercentage?: (Scalars['Decimal'] | null),varianceQuantity?: (Scalars['Decimal'] | null),withinTolerance?: (Scalars['Boolean'] | null),zoneId?: (Scalars['ID'] | null)}

export interface CycleCountScheduleGenqlSelection{
    abcClassification?: boolean | number
    categoryTolerances?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    defaultTolerancePercentage?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    frequency?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    isBlindCount?: boolean | number
    lastGeneratedAt?: boolean | number
    name?: boolean | number
    nextGenerationAt?: boolean | number
    scopeCategories?: boolean | number
    scopeType?: boolean | number
    scopeZones?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    valueThreshold?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountScheduleFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null)}

export interface CycleCountScheduleInput {abcClassification?: (Scalars['String'] | null),categoryTolerances?: (Scalars['Map'] | null),defaultTolerancePercentage: Scalars['Decimal'],facilityId: Scalars['ID'],frequency: CycleCountFrequency,isBlindCount: Scalars['Boolean'],name: Scalars['String'],scopeCategories?: (Scalars['Map'] | null),scopeType: CycleCountScopeType,scopeZones?: (Scalars['Map'] | null),valueThreshold?: (Scalars['Decimal'] | null)}

export interface CycleCountScheduleResultPageGenqlSelection{
    entries?: CycleCountScheduleGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountScheduleUpdateInput {abcClassification?: (Scalars['String'] | null),categoryTolerances?: (Scalars['Map'] | null),defaultTolerancePercentage?: (Scalars['Decimal'] | null),frequency?: (CycleCountFrequency | null),isBlindCount?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),scopeCategories?: (Scalars['Map'] | null),scopeType?: (CycleCountScopeType | null),scopeZones?: (Scalars['Map'] | null),valueThreshold?: (Scalars['Decimal'] | null)}

export interface CycleCountTaskGenqlSelection{
    abcClassification?: boolean | number
    approvedAt?: boolean | number
    approvedBy?: boolean | number
    approvedByUser?: UserGenqlSelection
    assignedTo?: boolean | number
    assignedToUser?: UserGenqlSelection
    completedAt?: boolean | number
    countType?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    defaultTolerancePercentage?: boolean | number
    dueDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    isBlindCount?: boolean | number
    isFrozen?: boolean | number
    notes?: boolean | number
    schedule?: CycleCountScheduleGenqlSelection
    scheduleId?: boolean | number
    scopeCategories?: boolean | number
    scopeZones?: boolean | number
    snapshotMovementId?: boolean | number
    startedAt?: boolean | number
    status?: boolean | number
    taskNumber?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    valueThreshold?: boolean | number
    zone?: InventoryZoneGenqlSelection
    zoneId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountTaskFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),status?: (Scalars['String'] | null),statuses?: (Scalars['String'][] | null)}

export interface CycleCountTaskInput {abcClassification?: (Scalars['String'] | null),assignedTo?: (Scalars['ID'] | null),countType: CycleCountScopeType,defaultTolerancePercentage?: (Scalars['Decimal'] | null),dueDate?: (Scalars['CalendarDate'] | null),facilityId: Scalars['ID'],isBlindCount: Scalars['Boolean'],notes?: (Scalars['String'] | null),scheduleId?: (Scalars['ID'] | null),scopeCategories?: (Scalars['Map'] | null),scopeZones?: (Scalars['Map'] | null),taskNumber: Scalars['String'],valueThreshold?: (Scalars['Decimal'] | null),zoneId?: (Scalars['ID'] | null)}

export interface CycleCountTaskResultPageGenqlSelection{
    entries?: CycleCountTaskGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface CycleCountTaskUpdateInput {abcClassification?: (Scalars['String'] | null),assignedTo?: (Scalars['ID'] | null),countType?: (CycleCountScopeType | null),defaultTolerancePercentage?: (Scalars['Decimal'] | null),dueDate?: (Scalars['CalendarDate'] | null),isBlindCount?: (Scalars['Boolean'] | null),notes?: (Scalars['String'] | null),scheduleId?: (Scalars['ID'] | null),scopeCategories?: (Scalars['Map'] | null),scopeZones?: (Scalars['Map'] | null),taskNumber?: (Scalars['String'] | null),valueThreshold?: (Scalars['Decimal'] | null),zoneId?: (Scalars['ID'] | null)}

export interface DateRangeInput {end?: (Scalars['CalendarDate'] | null),start?: (Scalars['CalendarDate'] | null)}

export interface DateTimeRangeInput {end?: (Scalars['CalendarDateTime'] | null),start?: (Scalars['CalendarDateTime'] | null)}

export interface DeductionTypeGenqlSelection{
    applicationType?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeductionTypeFilter {applicationType?: (DeductionApplicationType[] | null),ids?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface DeductionTypeInput {applicationType: DeductionApplicationType,name: Scalars['String']}

export interface DeductionTypeResultPageGenqlSelection{
    entries?: DeductionTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeductionTypeUpdateInput {applicationType?: (DeductionApplicationType | null),name?: (Scalars['String'] | null)}

export interface DefaultPhotoRequirementGenqlSelection{
    createdById?: boolean | number
    id?: boolean | number
    isRequired?: boolean | number
    name?: boolean | number
    order?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DefaultPhotoRequirementInput {isRequired: Scalars['Boolean'],name: Scalars['String'],order: Scalars['Float']}

export interface DefaultPriceListGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currency?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    notes?: boolean | number
    operationType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DefaultPriceListFilter {ids?: (Scalars['ID'][] | null)}

export interface DefaultPriceListInput {currency: Scalars['String'],facilityId: Scalars['ID'],notes?: (Scalars['String'] | null),operationType: OperationType}

export interface DefaultPriceListResultPageGenqlSelection{
    entries?: DefaultPriceListGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DefaultPriceListUpdateInput {currency?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),operationType?: (OperationType | null)}

export interface DelayNodeGenqlSelection{
    delayType?: boolean | number
    description?: boolean | number
    duration?: boolean | number
    durationUnit?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    untilDateTime?: boolean | number
    untilExpression?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteFileErrorGenqlSelection{
    fileId?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteFilePayloadGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteFileResultGenqlSelection{
    on_DeleteFileError?:DeleteFileErrorGenqlSelection,
    on_DeleteFileSuccess?:DeleteFileSuccessGenqlSelection,
    __typename?: boolean | number
}

export interface DeleteFileSuccessGenqlSelection{
    fileId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteFilesPayloadGenqlSelection{
    failed?: DeleteFileErrorGenqlSelection
    succeeded?: DeleteFileSuccessGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DeleteResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    deleted?: boolean | number
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DetentionGenqlSelection{
    carrier?: AccountGenqlSelection
    carrierId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    endDate?: boolean | number
    freeMinutes?: boolean | number
    id?: boolean | number
    location?: FacilityGenqlSelection
    locationId?: boolean | number
    ratePerMinute?: boolean | number
    startDate?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DetentionFilter {carrierId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),locationId?: (Scalars['ID'] | null)}

export interface DetentionInput {carrierId: Scalars['ID'],endDate?: (Scalars['CalendarDate'] | null),freeMinutes: Scalars['Int'],locationId: Scalars['ID'],ratePerMinute: Scalars['Decimal'],startDate: Scalars['CalendarDate']}

export interface DetentionResultPageGenqlSelection{
    entries?: DetentionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DetentionUpdateInput {carrierId?: (Scalars['ID'] | null),endDate?: (Scalars['CalendarDate'] | null),freeMinutes?: (Scalars['Int'] | null),locationId?: (Scalars['ID'] | null),ratePerMinute?: (Scalars['Decimal'] | null),startDate?: (Scalars['CalendarDate'] | null)}

export interface DoNotBuyEntryGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    addedByUser?: UserGenqlSelection
    addedByUserId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    effectiveFrom?: boolean | number
    effectiveTo?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    notes?: boolean | number
    originType?: boolean | number
    reason?: boolean | number
    removedByUser?: UserGenqlSelection
    removedByUserId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DoNotBuyEntryFilter {ids?: (Scalars['ID'][] | null)}

export interface DoNotBuyEntryInput {accountId: Scalars['ID'],addedByUserId: Scalars['ID'],effectiveFrom: Scalars['ZonedDateTime'],effectiveTo?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),originType: DoNotBuyOriginType,reason: Scalars['String'],removedByUserId?: (Scalars['ID'] | null),status: DoNotBuyStatus}

export interface DoNotBuyEntryResultPageGenqlSelection{
    entries?: DoNotBuyEntryGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DoNotBuyEntryUpdateInput {accountId?: (Scalars['ID'] | null),addedByUserId?: (Scalars['ID'] | null),effectiveFrom?: (Scalars['ZonedDateTime'] | null),effectiveTo?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),originType?: (DoNotBuyOriginType | null),reason?: (Scalars['String'] | null),removedByUserId?: (Scalars['ID'] | null),status?: (DoNotBuyStatus | null)}

export interface DocumentGenerationResultGenqlSelection{
    documentType?: boolean | number
    errorMessage?: boolean | number
    fileId?: boolean | number
    success?: boolean | number
    workflowId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DraftBookingInput {containers: BookingContainerInput[],cutOffDate?: (Scalars['CalendarDate'] | null),destinationPortId?: (Scalars['ID'] | null),documentNumber: Scalars['String'],dropoffTerminalId?: (Scalars['ID'] | null),earlyReturnDate?: (Scalars['CalendarDate'] | null),externalNotes?: (Scalars['String'] | null),facilityId: Scalars['ID'],internalNotes?: (Scalars['String'] | null),loadingPortId?: (Scalars['ID'] | null),oceanFreight?: (Scalars['String'] | null),photoRequirements?: (PhotoRequirementInput[] | null),pickupTerminalId?: (Scalars['ID'] | null),salesOrderIds?: (Scalars['ID'][] | null),steamshipLine?: (Scalars['String'] | null),vesselArrivalDate?: (Scalars['CalendarDate'] | null),vesselDepartureDate?: (Scalars['CalendarDate'] | null),vesselName?: (Scalars['String'] | null)}

export interface DraftBookingUpdateInput {containers?: (BookingContainerInput[] | null),cutOffDate?: (Scalars['CalendarDate'] | null),destinationPortId?: (Scalars['ID'] | null),documentNumber?: (Scalars['String'] | null),dropoffTerminalId?: (Scalars['ID'] | null),earlyReturnDate?: (Scalars['CalendarDate'] | null),externalNotes?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),internalNotes?: (Scalars['String'] | null),loadingPortId?: (Scalars['ID'] | null),oceanFreight?: (Scalars['String'] | null),photoRequirements?: (PhotoRequirementInput[] | null),pickupTerminalId?: (Scalars['ID'] | null),salesOrderIds?: (Scalars['ID'][] | null),steamshipLine?: (Scalars['String'] | null),vesselArrivalDate?: (Scalars['CalendarDate'] | null),vesselDepartureDate?: (Scalars['CalendarDate'] | null),vesselName?: (Scalars['String'] | null)}

export interface DriverGenqlSelection{
    address?: AddressGenqlSelection
    assignments?: ServiceGenqlSelection
    certifications?: DriverCertificationGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currentLocation?: PointGenqlSelection
    currentService?: ServiceGenqlSelection
    currentTrailer?: TrailerGenqlSelection
    currentTruck?: TruckGenqlSelection
    defaultTrailer?: TrailerGenqlSelection
    defaultTrailerId?: boolean | number
    defaultTruck?: TruckGenqlSelection
    defaultTruckId?: boolean | number
    displayOrder?: boolean | number
    email?: boolean | number
    firstName?: boolean | number
    id?: boolean | number
    lastLocationTime?: boolean | number
    lastName?: boolean | number
    licenseExpiration?: boolean | number
    licenseNumber?: boolean | number
    phoneNumber?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    user?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DriverCertificationGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    driver?: DriverGenqlSelection
    driverId?: boolean | number
    expirationDate?: boolean | number
    id?: boolean | number
    issuedDate?: boolean | number
    issuingBody?: boolean | number
    number?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DriverCertificationFilter {driverId?: (Scalars['ID'] | null),fromExpirationDate?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),toExpirationDate?: (Scalars['ZonedDateTime'] | null)}

export interface DriverCertificationResultPageGenqlSelection{
    entries?: DriverCertificationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DriverDisplayOrderGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    driverId?: boolean | number
    id?: boolean | number
    rank?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DriverDisplayOrderFilter {driverId?: (Scalars['ID'] | null),driverIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),rank?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null),userIds?: (Scalars['ID'][] | null)}

export interface DriverDisplayOrderInput {driverId: Scalars['ID'],rank: Scalars['String'],userId: Scalars['ID']}

export interface DriverDisplayOrderResultPageGenqlSelection{
    entries?: DriverDisplayOrderGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface DriverDisplayOrderUpdateInput {driverId?: (Scalars['ID'] | null),rank?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null)}

export interface DriverFilter {email?: (Scalars['String'] | null),firstName?: (Scalars['String'] | null),fromLicenseExpiration?: (Scalars['ZonedDateTime'] | null),hasActiveTasks?: (Scalars['Boolean'] | null),haulerId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),lastName?: (Scalars['String'] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),licenseNumber?: (Scalars['String'] | null),phoneNumber?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),status?: (DriverStatus[] | null),toLicenseExpiration?: (Scalars['ZonedDateTime'] | null)}

export interface DriverResultPageGenqlSelection{
    entries?: DriverGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EdgeGenqlSelection{
    id?: boolean | number
    source?: boolean | number
    sourceHandle?: boolean | number
    target?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EdgeInput {id: Scalars['ID'],source: Scalars['ID'],sourceHandle?: (Scalars['String'] | null),target: Scalars['ID']}

export interface EmailActionNodeGenqlSelection{
    bcc?: boolean | number
    body?: boolean | number
    bodyType?: boolean | number
    cc?: boolean | number
    continueOnFail?: boolean | number
    description?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    replyTo?: boolean | number
    subject?: boolean | number
    to?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EmailRecipientInput {bcc?: (Scalars['String'][] | null),cc?: (Scalars['String'][] | null),htmlBody?: (Scalars['String'] | null),replyTo?: (Scalars['String'] | null),subject: Scalars['String'],templateData?: (TemplateDataInput[] | null),templateId?: (Scalars['String'] | null),textBody?: (Scalars['String'] | null),to: Scalars['String'][]}

export interface EmailSendingResultGenqlSelection{
    errorMessage?: boolean | number
    messageId?: boolean | number
    success?: boolean | number
    workflowId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when the user's email address needs to be verified */
export interface EmailVerificationRequiredErrorGenqlSelection{
    pendingAuthenticationToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EvaluatedFormulaGenqlSelection{
    error?: boolean | number
    formula?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EvaluatedItemPricingGenqlSelection{
    evaluatedTiers?: EvaluatedTierGenqlSelection
    itemPricing?: ItemPricingGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface EvaluatedTierGenqlSelection{
    maxPrice?: boolean | number
    minPrice?: boolean | number
    targetPrice?: boolean | number
    tier?: ItemPricingTierGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExecutionRunGenqlSelection{
    actionsExecuted?: boolean | number
    automation?: AutomationGenqlSelection
    automationId?: boolean | number
    completedAt?: boolean | number
    durationMs?: boolean | number
    errorMessage?: boolean | number
    executionDurationMs?: boolean | number
    id?: boolean | number
    isTest?: boolean | number
    nodeExecutions?: NodeExecutionGenqlSelection
    nodesExecuted?: boolean | number
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    startedAt?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    triggerPayload?: boolean | number
    triggeredAt?: boolean | number
    workflowId?: boolean | number
    workflowRunId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ExecutionRunFilter {automationId?: (Scalars['ID'] | null),fromDate?: (Scalars['ZonedDateTime'] | null),isTest?: (Scalars['Boolean'] | null),status?: (ExecutionStatus[] | null),toDate?: (Scalars['ZonedDateTime'] | null)}

export interface ExecutionRunResultPageGenqlSelection{
    entries?: ExecutionRunGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityGenqlSelection{
    address?: AddressGenqlSelection
    customAttributes?: boolean | number
    facilityGroup?: FacilityGroupGenqlSelection
    facilityName?: boolean | number
    facilityType?: boolean | number
    id?: boolean | number
    timestamps?: TimestampsGenqlSelection
    timezone?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityAtmGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    enabled?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tranactYardId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityAtmFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null)}

export interface FacilityAtmInput {enabled: Scalars['Boolean'],facilityId: Scalars['ID'],name?: (Scalars['String'] | null),tranactYardId: Scalars['String']}

export interface FacilityAtmResultPageGenqlSelection{
    entries?: FacilityAtmGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityAtmUpdateInput {enabled?: (Scalars['Boolean'] | null),facilityId?: (Scalars['ID'] | null),name?: (Scalars['String'] | null),tranactYardId?: (Scalars['String'] | null)}

export interface FacilityCreateInput {address: AddressInput,customAttributes?: (Scalars['Map'] | null),facilityGroupId?: (Scalars['ID'] | null),facilityName: Scalars['String'],facilityType: Scalars['String'],timezone: Scalars['Timezone']}

export interface FacilityFilter {facilityGroupId?: (Scalars['ID'] | null),facilityTypes?: (Scalars['String'][] | null),latitude?: (Scalars['Float'] | null),longitude?: (Scalars['Float'] | null),radiusInMeters?: (Scalars['Float'] | null),searchTerm?: (Scalars['String'] | null)}

export interface FacilityGeneralPreferencesGenqlSelection{
    allowedUnitSystems?: boolean | number
    currency?: boolean | number
    dateFormat?: boolean | number
    defaultUnitSystem?: boolean | number
    language?: boolean | number
    timezone?: boolean | number
    weekStartDay?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityGroupGenqlSelection{
    customAttributes?: boolean | number
    defaultFacility?: FacilityGenqlSelection
    facilities?: FacilityGenqlSelection
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityGroupFilter {lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),searchTerm?: (Scalars['String'] | null)}

export interface FacilityGroupInput {customAttributes?: (Scalars['Map'] | null),defaultFacilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),name: Scalars['String']}

export interface FacilityGroupResultPageGenqlSelection{
    entries?: FacilityGroupGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityGroupUpdateInput {customAttributes?: (Scalars['Map'] | null),defaultFacilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null)}

export interface FacilityResultPageGenqlSelection{
    entries?: FacilityGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilitySalesPreferencesGenqlSelection{
    askForDeletionConfirmation?: boolean | number
    defaultPort?: boolean | number
    defaultWeightDisplayUnit?: boolean | number
    enableDefaultPrinting?: boolean | number
    photoInstructions?: PhotoInstructionGenqlSelection
    skipScalePayment?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FacilityUpdateInput {address?: (AddressInput | null),customAttributes?: (Scalars['Map'] | null),facilityGroupId?: (Scalars['ID'] | null),facilityName?: (Scalars['String'] | null),facilityType?: (Scalars['String'] | null),timezone?: (Scalars['Timezone'] | null)}

export interface FieldConstraintsGenqlSelection{
    maxLength?: boolean | number
    maxValue?: boolean | number
    minLength?: boolean | number
    minValue?: boolean | number
    multipleValues?: boolean | number
    objectType?: boolean | number
    required?: boolean | number
    selectOptions?: boolean | number
    unique?: boolean | number
    validationExpr?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FieldConstraintsInput {maxLength?: (Scalars['Int'] | null),maxValue?: (Scalars['Float'] | null),minLength?: (Scalars['Int'] | null),minValue?: (Scalars['Float'] | null),multipleValues?: (Scalars['Boolean'] | null),objectType?: (FieldConstraintObjectType | null),required?: (Scalars['Boolean'] | null),selectOptions?: (Scalars['String'][] | null),unique?: (Scalars['Boolean'] | null),validationExpr?: (Scalars['String'] | null)}

export interface FileGenqlSelection{
    children?: FileGenqlSelection
    creator?: UserGenqlSelection
    entityId?: boolean | number
    entityType?: boolean | number
    expiresAt?: boolean | number
    fileName?: boolean | number
    fileSize?: boolean | number
    fileType?: boolean | number
    id?: boolean | number
    metadata?: boolean | number
    mimeType?: boolean | number
    parent?: FileGenqlSelection
    parentId?: boolean | number
    path?: boolean | number
    public?: boolean | number
    status?: boolean | number
    subDirectories?: FileGenqlSelection
    template?: boolean | number
    timestamps?: TimestampsGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileAccessURLResultGenqlSelection{
    error?: boolean | number
    expiresAt?: boolean | number
    fileId?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileChangedEventGenqlSelection{
    file?: boolean | number
    parent?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileConnectionGenqlSelection{
    edges?: FileEdgeGenqlSelection
    total?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileCursor {limit: Scalars['Int'],offset: Scalars['Int']}

export interface FileEdgeGenqlSelection{
    cursor?: boolean | number
    node?: FileGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileErrorGenqlSelection{
    fileID?: boolean | number
    fileName?: boolean | number
    message?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileFilter {entityId?: (Scalars['ID'] | null),entityType?: (Scalars['String'] | null),fileType?: (FileType | null),parentIds?: (Scalars['ID'][] | null),public?: (Scalars['Boolean'] | null),searchTerm?: (Scalars['String'] | null),status?: (FileStatus | null)}

export interface FileTemplateGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    file?: FileGenqlSelection
    fileId?: boolean | number
    id?: boolean | number
    isDefault?: boolean | number
    organizationId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FileTemplateFilter {createdBy?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),types?: (FileTemplateType[] | null),updatedBy?: (Scalars['ID'][] | null)}

export interface FileTemplateResultPageGenqlSelection{
    entries?: FileTemplateGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FilesOutboxEventCountsGenqlSelection{
    file?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FilesOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (FilesAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface FilterNodeGenqlSelection{
    description?: boolean | number
    expression?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinanceAccountBalanceFilter {currencies?: (CurrencyCode[] | null),maxBalance?: (Scalars['Decimal'] | null),minBalance?: (Scalars['Decimal'] | null)}

export interface FinanceOutboxEventCountsGenqlSelection{
    bill?: boolean | number
    invoice?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinanceOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (FinanceAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface FinancialAccountGenqlSelection{
    accountNumberMasked?: boolean | number
    allowRepeatedCheckNumbers?: boolean | number
    bankName?: boolean | number
    checkBusinessName?: boolean | number
    checkLogo?: boolean | number
    checkMailingAddress?: boolean | number
    checkNumberGeneration?: boolean | number
    checkPhoneNumber?: boolean | number
    checkSignature?: boolean | number
    currency?: boolean | number
    currentBalance?: MoneyGenqlSelection
    customAttributes?: boolean | number
    disabled?: boolean | number
    ezcashEndpoint?: boolean | number
    ezcashTimeoutSeconds?: boolean | number
    facility?: FacilityGenqlSelection
    id?: boolean | number
    lastCheckNumber?: boolean | number
    linked?: boolean | number
    nachaCompanyIdentification?: boolean | number
    nachaCompanyName?: boolean | number
    nachaDefaultSecCode?: boolean | number
    name?: boolean | number
    paymentAllocationMethod?: boolean | number
    roundingMethod?: boolean | number
    roundingPrecision?: boolean | number
    routingNumber?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    visibleInPayments?: boolean | number
    warningThreshold?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinancialAccountAdjustmentGenqlSelection{
    amount?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    creatorId?: boolean | number
    currencyCode?: boolean | number
    date?: boolean | number
    facilityId?: boolean | number
    financialAccountId?: boolean | number
    id?: boolean | number
    paymentId?: boolean | number
    physicalCount?: boolean | number
    reason?: boolean | number
    systemBalanceAtTime?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinancialAccountAdjustmentFilter {facilityIds?: (Scalars['ID'][] | null),financialAccountId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface FinancialAccountAdjustmentInput {amount: Scalars['Decimal'],creatorId?: (Scalars['ID'] | null),currencyCode: Scalars['String'],date: Scalars['ZonedDateTime'],facilityId: Scalars['ID'],financialAccountId: Scalars['ID'],paymentId?: (Scalars['ID'] | null),physicalCount?: (Scalars['Decimal'] | null),reason?: (Scalars['String'] | null),systemBalanceAtTime?: (Scalars['Decimal'] | null),type: Scalars['String']}

export interface FinancialAccountAdjustmentResultPageGenqlSelection{
    entries?: FinancialAccountAdjustmentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinancialAccountAdjustmentUpdateInput {amount?: (Scalars['Decimal'] | null),creatorId?: (Scalars['ID'] | null),currencyCode?: (Scalars['String'] | null),date?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),financialAccountId?: (Scalars['ID'] | null),paymentId?: (Scalars['ID'] | null),physicalCount?: (Scalars['Decimal'] | null),reason?: (Scalars['String'] | null),systemBalanceAtTime?: (Scalars['Decimal'] | null),type?: (Scalars['String'] | null)}

export interface FinancialAccountFilter {currencies?: (Scalars['String'][] | null),facilityIDs?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),includeDisabled?: (Scalars['Boolean'] | null),maxBalance?: (MoneyInput | null),minBalance?: (MoneyInput | null),searchTerm?: (Scalars['String'] | null),types?: (FinancialAccountType[] | null),visibleInPayments?: (Scalars['Boolean'] | null)}

export interface FinancialAccountResultPageGenqlSelection{
    entries?: FinancialAccountGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinancialAccountTransactionGenqlSelection{
    amount?: boolean | number
    authorizedDate?: boolean | number
    channel?: boolean | number
    checkNumber?: boolean | number
    counterparties?: FinancialAccountTransactionCounterpartyGenqlSelection
    date?: boolean | number
    financialAccountId?: boolean | number
    financialAccountOwnerId?: boolean | number
    id?: boolean | number
    imageUrl?: boolean | number
    location?: AddressGenqlSelection
    pendingTransactionId?: boolean | number
    reference?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    transferNumber?: boolean | number
    type?: boolean | number
    website?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinancialAccountTransactionCounterpartyGenqlSelection{
    account?: AccountGenqlSelection
    id?: boolean | number
    imageUrl?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FinancialAccountTransactionFilter {authorizedDateFrom?: (Scalars['CalendarDate'] | null),authorizedDateTo?: (Scalars['CalendarDate'] | null),channels?: (FinancialAccountTransactionChannel[] | null),counterpartyIds?: (Scalars['ID'][] | null),dateFrom?: (Scalars['CalendarDate'] | null),dateTo?: (Scalars['CalendarDate'] | null),financialAccountIds?: (Scalars['ID'][] | null),hasCounterparty?: (Scalars['Boolean'] | null),hasLocation?: (Scalars['Boolean'] | null),isPending?: (Scalars['Boolean'] | null),maxAmount?: (Scalars['Decimal'] | null),minAmount?: (Scalars['Decimal'] | null),searchTerm?: (Scalars['String'] | null),statuses?: (FinancialAccountTransactionStatus[] | null),types?: (FinancialAccountTransactionType[] | null)}

export interface FinancialAccountTransactionResultPageGenqlSelection{
    entries?: FinancialAccountTransactionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FlowValidationResultGenqlSelection{
    issues?: ValidationIssueGenqlSelection
    valid?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightChargeGenqlSelection{
    accruedAmount?: MoneyGenqlSelection
    chargebackAmount?: MoneyGenqlSelection
    deliveryNumber?: boolean | number
    freightLane?: boolean | number
    hauler?: boolean | number
    id?: boolean | number
    netAmount?: MoneyGenqlSelection
    notes?: boolean | number
    reconciliationId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightChargeInput {accruedAmount: MoneyInput,chargebackAmount: MoneyInput,deliveryNumber: Scalars['String'],freightLane: Scalars['String'],hauler: Scalars['String'],id?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null)}

export interface FreightForwarderGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightForwarderFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface FreightForwarderInput {facilityId: Scalars['ID'],name: Scalars['String']}

export interface FreightForwarderResultPageGenqlSelection{
    entries?: FreightForwarderGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightForwarderUpdateInput {facilityId?: (Scalars['ID'] | null),name?: (Scalars['String'] | null)}

export interface FreightLaneGenqlSelection{
    active?: boolean | number
    carrier?: AccountGenqlSelection
    carrierId?: boolean | number
    commodityCategory?: boolean | number
    costs?: FreightLaneCostGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    destinationCity?: boolean | number
    destinationCountry?: boolean | number
    destinationState?: boolean | number
    destinationZipCode?: boolean | number
    equipmentType?: boolean | number
    freightLaneRouteId?: boolean | number
    freight_lane_route?: FreightLaneRouteGenqlSelection
    id?: boolean | number
    notes?: boolean | number
    originLocationId?: boolean | number
    originLocationType?: boolean | number
    origin_location?: LocationGenqlSelection
    timestamps?: TimestampsGenqlSelection
    transportationMode?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLaneCostGenqlSelection{
    chargebackFormula?: boolean | number
    chargebackVariableIds?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currency?: boolean | number
    endDate?: boolean | number
    freightLaneId?: boolean | number
    freight_lane?: FreightLaneGenqlSelection
    fuelSurchargeFormula?: boolean | number
    fuelSurchargeMode?: boolean | number
    fuelSurchargeVariableIds?: boolean | number
    id?: boolean | number
    minimumChargeAmount?: boolean | number
    minimumChargeCurrencyCode?: boolean | number
    minimumChargebackAmount?: boolean | number
    minimumChargebackCurrencyCode?: boolean | number
    rateFormula?: boolean | number
    rateVariableIds?: boolean | number
    startDate?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLaneCostFilter {freightLaneId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface FreightLaneCostInput {chargebackFormula?: (Scalars['String'] | null),chargebackVariableIds?: (Scalars['String'] | null),currency: Scalars['String'],endDate?: (Scalars['CalendarDate'] | null),freightLaneId: Scalars['ID'],fuelSurchargeFormula?: (Scalars['String'] | null),fuelSurchargeMode?: (Scalars['String'] | null),fuelSurchargeVariableIds?: (Scalars['String'] | null),minimumChargeAmount?: (Scalars['Decimal'] | null),minimumChargeCurrencyCode?: (Scalars['String'] | null),minimumChargebackAmount?: (Scalars['Decimal'] | null),minimumChargebackCurrencyCode?: (Scalars['String'] | null),rateFormula?: (Scalars['String'] | null),rateVariableIds?: (Scalars['String'] | null),startDate: Scalars['CalendarDate']}

export interface FreightLaneCostResultPageGenqlSelection{
    entries?: FreightLaneCostGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLaneCostUpdateInput {chargebackFormula?: (Scalars['String'] | null),chargebackVariableIds?: (Scalars['String'] | null),currency?: (Scalars['String'] | null),endDate?: (Scalars['CalendarDate'] | null),freightLaneId?: (Scalars['ID'] | null),fuelSurchargeFormula?: (Scalars['String'] | null),fuelSurchargeMode?: (Scalars['String'] | null),fuelSurchargeVariableIds?: (Scalars['String'] | null),minimumChargeAmount?: (Scalars['Decimal'] | null),minimumChargeCurrencyCode?: (Scalars['String'] | null),minimumChargebackAmount?: (Scalars['Decimal'] | null),minimumChargebackCurrencyCode?: (Scalars['String'] | null),rateFormula?: (Scalars['String'] | null),rateVariableIds?: (Scalars['String'] | null),startDate?: (Scalars['CalendarDate'] | null)}

export interface FreightLaneFilter {carrierId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface FreightLaneInput {active: Scalars['Boolean'],carrierId: Scalars['ID'],commodityCategory?: (Scalars['String'] | null),destinationCity?: (Scalars['String'] | null),destinationCountry?: (Scalars['String'] | null),destinationState?: (Scalars['String'] | null),destinationZipCode?: (Scalars['String'] | null),equipmentType?: (Scalars['String'] | null),freightLaneRouteId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),originLocationId?: (Scalars['ID'] | null),originLocationType?: (Scalars['String'] | null),transportationMode: Scalars['String']}

export interface FreightLaneResultPageGenqlSelection{
    entries?: FreightLaneGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLaneRouteGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    distance?: boolean | number
    id?: boolean | number
    locationAId?: boolean | number
    locationAType?: boolean | number
    locationBId?: boolean | number
    locationBType?: boolean | number
    location_a?: LocationGenqlSelection
    location_b?: LocationGenqlSelection
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLaneRouteFilter {ids?: (Scalars['ID'][] | null)}

export interface FreightLaneRouteInput {distance?: (Scalars['Decimal'] | null),locationAId: Scalars['ID'],locationAType: LocationType,locationBId: Scalars['ID'],locationBType: LocationType}

export interface FreightLaneRouteResultPageGenqlSelection{
    entries?: FreightLaneRouteGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLaneRouteUpdateInput {distance?: (Scalars['Decimal'] | null),locationAId?: (Scalars['ID'] | null),locationAType?: (LocationType | null),locationBId?: (Scalars['ID'] | null),locationBType?: (LocationType | null)}

export interface FreightLaneUpdateInput {active?: (Scalars['Boolean'] | null),carrierId?: (Scalars['ID'] | null),commodityCategory?: (Scalars['String'] | null),destinationCity?: (Scalars['String'] | null),destinationCountry?: (Scalars['String'] | null),destinationState?: (Scalars['String'] | null),destinationZipCode?: (Scalars['String'] | null),equipmentType?: (Scalars['String'] | null),freightLaneRouteId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),originLocationId?: (Scalars['ID'] | null),originLocationType?: (Scalars['String'] | null),transportationMode?: (Scalars['String'] | null)}

export interface FreightLineGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLineFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface FreightLineInput {facilityId: Scalars['ID'],name: Scalars['String']}

export interface FreightLineResultPageGenqlSelection{
    entries?: FreightLineGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface FreightLineUpdateInput {facilityId?: (Scalars['ID'] | null),name?: (Scalars['String'] | null)}

export interface GenerateCheckPdfPayloadGenqlSelection{
    fileId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateDocumentInput {documents: GenerateDocumentRequestInput[]}

export interface GenerateDocumentRequestInput {bookingId?: (Scalars['ID'] | null),documentType: DocumentType,dueDate?: (Scalars['String'] | null),invoiceAmount?: (Scalars['String'] | null),invoiceDate?: (Scalars['String'] | null),invoiceNumber?: (Scalars['String'] | null),loadId?: (Scalars['ID'] | null),purchaseOrderId?: (Scalars['ID'] | null),salesOrderId?: (Scalars['ID'] | null)}

export interface GenerateDocumentResultGenqlSelection{
    documents?: DocumentGenerationResultGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateDocumentsAndSendEmailInput {documents: GenerateDocumentRequestInput[],email: EmailRecipientInput}

export interface GenerateDocumentsAndSendEmailResultGenqlSelection{
    documents?: DocumentGenerationResultGenqlSelection
    email?: EmailSendingResultGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateFileAccessURLPayloadGenqlSelection{
    results?: FileAccessURLResultGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateNachaFileInput {effectiveEntryDate: Scalars['CalendarDate'],financialAccountId: Scalars['ID'],paymentIds: Scalars['ID'][]}

export interface GenerateNachaFilePayloadGenqlSelection{
    entryCount?: boolean | number
    fileContent?: boolean | number
    totalAmount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GeneratePositivePayFileInput {dateFrom: Scalars['CalendarDate'],dateTo: Scalars['CalendarDate'],financialAccountId: Scalars['ID'],templateId: Scalars['ID']}

export interface GeneratePriceListDocumentInput {priceListId: Scalars['ID'],priceListType: Scalars['String'],templateFileId?: (Scalars['String'] | null)}

export interface GeneratePriceListDocumentResultGenqlSelection{
    fileId?: boolean | number
    workflowId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GenerateWOPITokenInput {expiresInSeconds?: (Scalars['Int'] | null),fileId: Scalars['ID'],permission: WOPIPermission}

export interface GenerateWOPITokenPayloadGenqlSelection{
    token?: WOPITokenGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GovernmentReportingConfigurationGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    daysOfWeek?: boolean | number
    encryptedCredentials?: boolean | number
    fields?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    name?: boolean | number
    processBatchesAsUnit?: boolean | number
    recyclerId?: boolean | number
    serviceType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    toEmailAddress?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    uploadTimezone?: boolean | number
    uploadType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GovernmentReportingConfigurationFilter {ids?: (Scalars['ID'][] | null),serviceType?: (GovernmentReportingServiceType[] | null)}

export interface GovernmentReportingConfigurationInput {daysOfWeek?: (Scalars['Map'] | null),encryptedCredentials?: (Scalars['String'] | null),fields?: (Scalars['Map'] | null),isActive: Scalars['Boolean'],name: Scalars['String'],processBatchesAsUnit: Scalars['Boolean'],recyclerId?: (Scalars['String'] | null),serviceType: GovernmentReportingServiceType,toEmailAddress?: (Scalars['String'] | null),uploadTimezone?: (Scalars['String'] | null),uploadType: ReportingUploadType}

export interface GovernmentReportingConfigurationResultPageGenqlSelection{
    entries?: GovernmentReportingConfigurationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GovernmentReportingConfigurationUpdateInput {daysOfWeek?: (Scalars['Map'] | null),encryptedCredentials?: (Scalars['String'] | null),fields?: (Scalars['Map'] | null),isActive?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),processBatchesAsUnit?: (Scalars['Boolean'] | null),recyclerId?: (Scalars['String'] | null),serviceType?: (GovernmentReportingServiceType | null),toEmailAddress?: (Scalars['String'] | null),uploadTimezone?: (Scalars['String'] | null),uploadType?: (ReportingUploadType | null)}

export interface GovernmentReportingFacilityGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    governmentReportingConfiguration?: GovernmentReportingConfigurationGenqlSelection
    governmentReportingConfigurationId?: boolean | number
    id?: boolean | number
    mlid?: boolean | number
    reportingFacilityId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GovernmentReportingFacilityFilter {facilityId?: (Scalars['ID'] | null),governmentReportingConfigurationId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null)}

export interface GovernmentReportingFacilityInput {facilityId: Scalars['ID'],governmentReportingConfigurationId: Scalars['ID'],mlid?: (Scalars['String'] | null),reportingFacilityId?: (Scalars['String'] | null)}

export interface GovernmentReportingFacilityResultPageGenqlSelection{
    entries?: GovernmentReportingFacilityGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface GovernmentReportingFacilityUpdateInput {facilityId?: (Scalars['ID'] | null),governmentReportingConfigurationId?: (Scalars['ID'] | null),mlid?: (Scalars['String'] | null),reportingFacilityId?: (Scalars['String'] | null)}

export interface HttpRequestActionNodeGenqlSelection{
    bodyType?: boolean | number
    continueOnFail?: boolean | number
    description?: boolean | number
    headers?: boolean | number
    id?: boolean | number
    label?: boolean | number
    method?: boolean | number
    position?: PositionGenqlSelection
    requestBody?: boolean | number
    retryCount?: boolean | number
    timeout?: boolean | number
    type?: boolean | number
    url?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HttpWebhookTriggerConfigOutputGenqlSelection{
    path?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface HttpWebhookTriggerNodeGenqlSelection{
    description?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InboundTollingAgreementGenqlSelection{
    agreementNumber?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customerAccount?: AccountGenqlSelection
    customerAccountId?: boolean | number
    effectiveDate?: boolean | number
    expectedYieldPercentage?: boolean | number
    expirationDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    invoicePricingBasis?: boolean | number
    isActive?: boolean | number
    pricePerUnit?: MoneyGenqlSelection
    priceUnit?: boolean | number
    processingType?: ProcessingTypeGenqlSelection
    processingTypeId?: boolean | number
    terms?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InboundTollingAgreementFilter {agreementNumber?: (Scalars['String'] | null),customerAccountId?: (Scalars['ID'] | null),customerAccountIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromEffectiveDate?: (Scalars['CalendarDate'] | null),fromExpirationDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),invoicePricingBasis?: (InvoicePricingBasis[] | null),isActive?: (Scalars['Boolean'] | null),priceUnit?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),processingTypeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),terms?: (Scalars['String'] | null),toEffectiveDate?: (Scalars['CalendarDate'] | null),toExpirationDate?: (Scalars['CalendarDate'] | null)}

export interface InboundTollingAgreementInput {agreementNumber: Scalars['String'],customerAccountId: Scalars['ID'],effectiveDate: Scalars['CalendarDate'],expectedYieldPercentage?: (Scalars['Decimal'] | null),expirationDate?: (Scalars['CalendarDate'] | null),facilityId: Scalars['ID'],invoicePricingBasis: InvoicePricingBasis,isActive: Scalars['Boolean'],pricePerUnit?: (MoneyInput | null),priceUnit?: (Scalars['String'] | null),processingTypeId: Scalars['ID'],terms?: (Scalars['String'] | null)}

export interface InboundTollingAgreementResultPageGenqlSelection{
    entries?: InboundTollingAgreementGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InboundTollingAgreementUpdateInput {agreementNumber?: (Scalars['String'] | null),customerAccountId?: (Scalars['ID'] | null),effectiveDate?: (Scalars['CalendarDate'] | null),expectedYieldPercentage?: (Scalars['Decimal'] | null),expirationDate?: (Scalars['CalendarDate'] | null),facilityId?: (Scalars['ID'] | null),invoicePricingBasis?: (InvoicePricingBasis | null),isActive?: (Scalars['Boolean'] | null),pricePerUnit?: (MoneyInput | null),priceUnit?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),terms?: (Scalars['String'] | null)}

export interface IntegrationGenqlSelection{
    category?: boolean | number
    icon?: boolean | number
    key?: boolean | number
    name?: boolean | number
    operations?: OperationGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when the provided email/password combination is invalid */
export interface InvalidCredentialsErrorGenqlSelection{
    email?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when one-time provided is invalid */
export interface InvalidOneTimeCodeGenqlSelection{
    pendingAuthenticationToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when signup invitation is invalid or expired */
export interface InvalidSignUpInvitationErrorGenqlSelection{
    /** Reason the invitation is invalid */
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when user invitation is invalid or expired */
export interface InvalidUserInvitationErrorGenqlSelection{
    /** Reason the invitation is invalid */
    reason?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryAccountGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    name?: boolean | number
    taggingType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryAccountFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),taggingType?: (InventoryTaggingType[] | null),type?: (InventoryAccountType[] | null)}

export interface InventoryAccountInput {customAttributes?: (Scalars['Map'] | null),facilityId?: (Scalars['ID'] | null),name: Scalars['String'],taggingType: InventoryTaggingType,type: InventoryAccountType}

export interface InventoryAccountResultPageGenqlSelection{
    entries?: InventoryAccountGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryAccountUpdateInput {customAttributes?: (Scalars['Map'] | null),facilityId?: (Scalars['ID'] | null),name?: (Scalars['String'] | null),taggingType?: (InventoryTaggingType | null),type?: (InventoryAccountType | null)}

export interface InventoryFacilitySettingsGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    defaultCountTolerancePercentage?: boolean | number
    enforceLooseStockOnTagging?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    wacComponents?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryFacilitySettingsFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface InventoryFacilitySettingsInput {defaultCountTolerancePercentage: Scalars['Decimal'],enforceLooseStockOnTagging: Scalars['Boolean'],facilityId: Scalars['ID'],wacComponents?: (Scalars['Map'] | null)}

export interface InventoryFacilitySettingsResultPageGenqlSelection{
    entries?: InventoryFacilitySettingsGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryFacilitySettingsUpdateInput {defaultCountTolerancePercentage?: (Scalars['Decimal'] | null),enforceLooseStockOnTagging?: (Scalars['Boolean'] | null),facilityId?: (Scalars['ID'] | null),wacComponents?: (Scalars['Map'] | null)}


/**
 * InventoryLevel represents the aggregated inventory level for an item.
 * For items with movements, this shows the quantity at a specific facility.
 * For items without movements, facility will be null and quantity will be 0.
 */
export interface InventoryLevelGenqlSelection{
    /** Value and WAC breakdown by currency */
    currencyValues?: InventoryLevelCurrencyValueGenqlSelection
    /** The facility where this inventory is located (null for items without movements) */
    facility?: FacilityGenqlSelection
    /** Facility ID (null for items without inventory movements) */
    facilityId?: boolean | number
    /** The item at this inventory level */
    item?: ItemGenqlSelection
    /** Item ID */
    itemId?: boolean | number
    /**
     * For TollingMaterial view: The customer account that owns this material.
     * References a CRM Account entity.
     */
    ownerAccount?: AccountGenqlSelection
    /**
     * For TollingMaterial view: The ID of the customer account that owns this material.
     * References a CRM Account entity.
     */
    ownerAccountId?: boolean | number
    /**
     * For OurMaterial view when material is at an external processor: The processor account.
     * References a CRM Account entity.
     */
    processorAccount?: AccountGenqlSelection
    /**
     * For OurMaterial view when material is at an external processor: The ID of the processor account.
     * References a CRM Account entity.
     */
    processorAccountId?: boolean | number
    /** Current quantity at this location with unit (0 for items without movements) */
    quantity?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** InventoryLevelCurrencyValue represents the total value and WAC for a specific currency */
export interface InventoryLevelCurrencyValueGenqlSelection{
    /** Currency code for this value */
    currencyCode?: boolean | number
    /** Total inventory value in this currency */
    totalValue?: boolean | number
    /** Weighted average cost per unit in this currency */
    weightedAverageCost?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Filter options for inventory levels */
export interface InventoryLevelFilter {
/** Filter by facility IDs (for specific facility selection) */
facilityIds?: (Scalars['ID'][] | null),
/** Hide items with zero or negative quantity (defaults to false) */
hideZeroQuantity?: (Scalars['Boolean'] | null),
/** Filter by item IDs */
itemIds?: (Scalars['ID'][] | null),
/** Filter by location type (for virtual location groups in OurMaterial view) */
locationFilterType?: (LocationFilterType | null),
/** Search term for searching by item name or SKU */
searchTerm?: (Scalars['String'] | null),
/** Filter by tagging types (Tagged, Untagged, or both) */
taggingTypes?: (TaggingType[] | null),
/** View mode: OurMaterial or TollingMaterial (defaults to OurMaterial) */
viewMode?: (InventoryViewMode | null),
/** Filter by zone IDs (for specific zone selection within a facility) */
zoneIds?: (Scalars['ID'][] | null)}


/** Result page for inventory levels */
export interface InventoryLevelResultPageGenqlSelection{
    /** List of inventory levels matching the query */
    entries?: InventoryLevelGenqlSelection
    /** Pagination information */
    page?: PageGenqlSelection
    /** Aggregate statistics for the query results */
    stats?: InventoryLevelStatsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Statistics about inventory levels */
export interface InventoryLevelStatsGenqlSelection{
    /** Number of item/facility combinations with positive stock */
    itemsWithStock?: boolean | number
    /** Total number of item/facility combinations with inventory */
    totalItems?: boolean | number
    /** Total quantity across all inventory levels */
    totalQuantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotGenqlSelection{
    allocations?: (LotAllocationResultPageGenqlSelection & { __args?: {filter?: (LotAllocationFilterInput | null), pagination?: (PaginationInput | null)} })
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    isToll?: boolean | number
    lotNumber?: boolean | number
    mergedInto?: InventoryLotGenqlSelection
    mergedIntoId?: boolean | number
    quantitySummary?: LotQuantitySummaryGenqlSelection
    status?: boolean | number
    tags?: InventoryTagResultPageGenqlSelection
    timestamps?: TimestampsGenqlSelection
    tollCustomerAccount?: AccountGenqlSelection
    tollCustomerAccountId?: boolean | number
    tollReceiptId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    valuation?: LotValuationGenqlSelection
    zone?: InventoryZoneGenqlSelection
    zoneId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotAllocateInput {allocations: InventoryLotAllocationItemInput[],lotId: Scalars['ID']}

export interface InventoryLotAllocateResultGenqlSelection{
    allocations?: LotAllocationGenqlSelection
    lot?: InventoryLotGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotAllocationItemInput {movementId: Scalars['ID'],quantity: WeightInput}

export interface InventoryLotCreateFromMovementsInput {description?: (Scalars['String'] | null),facilityId: Scalars['ID'],filter: LotMovementFilterInput,lotNumber: Scalars['String']}

export interface InventoryLotCreateFromMovementsResultGenqlSelection{
    allocationsCreated?: boolean | number
    lot?: InventoryLotGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotCreateInput {description?: (Scalars['String'] | null),facilityId: Scalars['ID'],isToll?: (Scalars['Boolean'] | null),lotNumber: Scalars['String'],status?: (LotStatus | null),tollCustomerAccountId?: (Scalars['ID'] | null),tollReceiptId?: (Scalars['ID'] | null),zoneId?: (Scalars['ID'] | null)}

export interface InventoryLotDeallocateInput {allocationIds: Scalars['ID'][]}

export interface InventoryLotFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),lotNumber?: (Scalars['String'] | null),status?: (LotStatus[] | null)}

export interface InventoryLotInput {description?: (Scalars['String'] | null),facilityId: Scalars['ID'],isToll: Scalars['Boolean'],lotNumber: Scalars['String'],mergedIntoId?: (Scalars['ID'] | null),status: LotStatus,tollCustomerAccountId?: (Scalars['ID'] | null),tollReceiptId?: (Scalars['ID'] | null),zoneId?: (Scalars['ID'] | null)}

export interface InventoryLotMergeInput {sourceLotIds: Scalars['ID'][],targetLotId: Scalars['ID']}

export interface InventoryLotMergeResultGenqlSelection{
    mergedLots?: InventoryLotGenqlSelection
    targetLot?: InventoryLotGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotResultPageGenqlSelection{
    entries?: InventoryLotGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotSplitInput {newDescription?: (Scalars['String'] | null),newLotNumber: Scalars['String'],sourceLotId: Scalars['ID'],transfers: LotSplitTransferInput[]}

export interface InventoryLotSplitResultGenqlSelection{
    newLot?: InventoryLotGenqlSelection
    sourceLot?: InventoryLotGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryLotUpdateInput {description?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),isToll?: (Scalars['Boolean'] | null),lotNumber?: (Scalars['String'] | null),mergedIntoId?: (Scalars['ID'] | null),status?: (LotStatus | null),tollCustomerAccountId?: (Scalars['ID'] | null),tollReceiptId?: (Scalars['ID'] | null),zoneId?: (Scalars['ID'] | null)}

export interface InventoryMovementGenqlSelection{
    allocatedQuantity?: WeightGenqlSelection
    allocatedQuantityToTags?: WeightGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    fromAccountId?: boolean | number
    fromZoneId?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    lotAllocations?: LotAllocationGenqlSelection
    metadata?: boolean | number
    movementType?: boolean | number
    occurredAt?: boolean | number
    originTransactionItemId?: boolean | number
    originTransactionType?: boolean | number
    ownerAccount?: AccountGenqlSelection
    ownerAccountId?: boolean | number
    quantity?: WeightGenqlSelection
    status?: boolean | number
    tagAllocations?: TagAllocationGenqlSelection
    timestamps?: TimestampsGenqlSelection
    toAccountId?: boolean | number
    toZoneId?: boolean | number
    totalCost?: MoneyGenqlSelection
    unallocatedQuantity?: WeightGenqlSelection
    unallocatedQuantityFromTags?: WeightGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryMovementFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromOccurredAt?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),movementType?: (InventoryMovementType[] | null),originTransactionType?: (InventoryTransactionType[] | null),status?: (InventoryMovementStatus[] | null),toOccurredAt?: (Scalars['ZonedDateTime'] | null)}

export interface InventoryMovementHistoryFilter {currencyCode?: (CurrencyCode | null),facilityId?: (Scalars['ID'] | null),itemId: Scalars['ID']}

export interface InventoryMovementHistoryResultPageGenqlSelection{
    entries?: InventoryMovementWithHistoryGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryMovementInput {customAttributes?: (Scalars['Map'] | null),facilityId: Scalars['ID'],fromAccountId: Scalars['ID'],fromZoneId?: (Scalars['ID'] | null),itemId: Scalars['ID'],metadata?: (Scalars['Map'] | null),movementType: InventoryMovementType,occurredAt: Scalars['ZonedDateTime'],originTransactionItemId: Scalars['String'],originTransactionType: InventoryTransactionType,quantity: WeightInput,status: InventoryMovementStatus,toAccountId: Scalars['ID'],toZoneId?: (Scalars['ID'] | null),totalCost?: (MoneyInput | null)}

export interface InventoryMovementResultPageGenqlSelection{
    entries?: InventoryMovementGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryMovementUpdateInput {customAttributes?: (Scalars['Map'] | null),facilityId?: (Scalars['ID'] | null),fromAccountId?: (Scalars['ID'] | null),fromZoneId?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),metadata?: (Scalars['Map'] | null),movementType?: (InventoryMovementType | null),occurredAt?: (Scalars['ZonedDateTime'] | null),originTransactionItemId?: (Scalars['String'] | null),originTransactionType?: (InventoryTransactionType | null),quantity?: (WeightInput | null),status?: (InventoryMovementStatus | null),toAccountId?: (Scalars['ID'] | null),toZoneId?: (Scalars['ID'] | null),totalCost?: (MoneyInput | null)}

export interface InventoryMovementWithHistoryGenqlSelection{
    movement?: InventoryMovementGenqlSelection
    runningTotals?: MovementRunningTotalsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryOutboxEventCountsGenqlSelection{
    category?: boolean | number
    inventoryTag?: boolean | number
    item?: boolean | number
    itemGroup?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (InventoryAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface InventoryPeriodGenqlSelection{
    closedAt?: boolean | number
    closedBy?: boolean | number
    closedByUser?: UserGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    endDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    lockedAt?: boolean | number
    lockedBy?: boolean | number
    lockedByUser?: UserGenqlSelection
    name?: boolean | number
    notes?: boolean | number
    periodType?: boolean | number
    startDate?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    unlockExpiresAt?: boolean | number
    unlockReason?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPeriodBalanceGenqlSelection{
    account?: InventoryAccountGenqlSelection
    accountId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currencyCode?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    inventoryPeriodId?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    quantity?: boolean | number
    quantityUnit?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalValue?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    wacPerUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPeriodBalanceFilter {accountIds?: (Scalars['ID'][] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),inventoryPeriodIds?: (Scalars['ID'][] | null),itemIds?: (Scalars['ID'][] | null)}

export interface InventoryPeriodBalanceInput {accountId: Scalars['ID'],currencyCode: Scalars['String'],facilityId: Scalars['ID'],inventoryPeriodId: Scalars['ID'],itemId: Scalars['ID'],quantity: Scalars['Decimal'],quantityUnit: Unit,totalValue: Scalars['Decimal'],wacPerUnit: Scalars['Decimal']}

export interface InventoryPeriodBalanceResultPageGenqlSelection{
    entries?: InventoryPeriodBalanceGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPeriodBalanceUpdateInput {accountId?: (Scalars['ID'] | null),currencyCode?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),inventoryPeriodId?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),quantity?: (Scalars['Decimal'] | null),quantityUnit?: (Unit | null),totalValue?: (Scalars['Decimal'] | null),wacPerUnit?: (Scalars['Decimal'] | null)}

export interface InventoryPeriodConfigGenqlSelection{
    allowStraddleCompletion?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    fiscalYearStartMonth?: boolean | number
    id?: boolean | number
    periodType?: boolean | number
    requireStraddleApproval?: boolean | number
    straddleWindowPeriods?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPeriodConfigFilter {ids?: (Scalars['ID'][] | null)}

export interface InventoryPeriodConfigInput {allowStraddleCompletion: Scalars['Boolean'],fiscalYearStartMonth?: (Scalars['Int'] | null),periodType: Scalars['String'],requireStraddleApproval: Scalars['Boolean'],straddleWindowPeriods: Scalars['Int']}

export interface InventoryPeriodConfigResultPageGenqlSelection{
    entries?: InventoryPeriodConfigGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPeriodConfigUpdateInput {allowStraddleCompletion?: (Scalars['Boolean'] | null),fiscalYearStartMonth?: (Scalars['Int'] | null),periodType?: (Scalars['String'] | null),requireStraddleApproval?: (Scalars['Boolean'] | null),straddleWindowPeriods?: (Scalars['Int'] | null)}

export interface InventoryPeriodFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),status?: (Scalars['String'] | null)}

export interface InventoryPeriodInput {endDate: Scalars['ZonedDateTime'],facilityId: Scalars['ID'],name: Scalars['String'],notes?: (Scalars['String'] | null),periodType: Scalars['String'],startDate: Scalars['ZonedDateTime']}

export interface InventoryPeriodResultPageGenqlSelection{
    entries?: InventoryPeriodGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryPeriodUpdateInput {endDate?: (Scalars['ZonedDateTime'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),periodType?: (Scalars['String'] | null),startDate?: (Scalars['ZonedDateTime'] | null)}

export interface InventoryTagGenqlSelection{
    allocations?: (TagAllocationResultPageGenqlSelection & { __args?: {pagination?: (PaginationInput | null)} })
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    facilityId?: boolean | number
    generatedAt?: boolean | number
    grossQuantity?: boolean | number
    id?: boolean | number
    isReconciled?: boolean | number
    isRevised?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    lot?: InventoryLotGenqlSelection
    lotId?: boolean | number
    netQuantity?: boolean | number
    quantityCaptureMethod?: boolean | number
    quantityDiscrepancy?: boolean | number
    quantitySummary?: TagQuantitySummaryGenqlSelection
    status?: boolean | number
    tagNumber?: boolean | number
    tagType?: boolean | number
    tare?: boolean | number
    tareCaptureMethod?: boolean | number
    timestamps?: TimestampsGenqlSelection
    trackedQuantity?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryTagAllocateInput {allocations: TagMovementAllocationInput[],tagId: Scalars['ID']}

export interface InventoryTagAllocateResultGenqlSelection{
    allocations?: TagAllocationGenqlSelection
    tag?: InventoryTagGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryTagDeallocateInput {allocationIds: Scalars['ID'][]}

export interface InventoryTagFilter {facilityIds?: (Scalars['ID'][] | null),generatedAtFrom?: (Scalars['ZonedDateTime'] | null),generatedAtTo?: (Scalars['ZonedDateTime'] | null),hasLot?: (Scalars['Boolean'] | null),ids?: (Scalars['ID'][] | null),itemIds?: (Scalars['ID'][] | null),lotIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),statuses?: (InventoryTagStatus[] | null),tagNumbers?: (Scalars['String'][] | null),tagTypes?: (TagType[] | null)}

export interface InventoryTagInput {customAttributes?: (Scalars['Map'] | null),facilityId: Scalars['ID'],generatedAt: Scalars['ZonedDateTime'],grossQuantity: Scalars['Decimal'],isRevised: Scalars['Boolean'],itemId: Scalars['ID'],lotId?: (Scalars['ID'] | null),quantityCaptureMethod: QuantityCaptureMethod,status: InventoryTagStatus,tagNumber: Scalars['String'],tagType: TagType,tare: Scalars['Decimal'],tareCaptureMethod: QuantityCaptureMethod}

export interface InventoryTagResultPageGenqlSelection{
    entries?: InventoryTagGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryTagUpdateInput {customAttributes?: (Scalars['Map'] | null),facilityId?: (Scalars['ID'] | null),generatedAt?: (Scalars['ZonedDateTime'] | null),grossQuantity?: (Scalars['Decimal'] | null),isRevised?: (Scalars['Boolean'] | null),itemId?: (Scalars['ID'] | null),lotId?: (Scalars['ID'] | null),quantityCaptureMethod?: (QuantityCaptureMethod | null),status?: (InventoryTagStatus | null),tagNumber?: (Scalars['String'] | null),tagType?: (TagType | null),tare?: (Scalars['Decimal'] | null),tareCaptureMethod?: (QuantityCaptureMethod | null)}

export interface InventoryZoneGenqlSelection{
    capacityUnit?: boolean | number
    capacityValue?: boolean | number
    children?: InventoryZoneGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    description?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    name?: boolean | number
    parentZone?: InventoryZoneGenqlSelection
    parentZoneId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    utilization?: ZoneUtilizationGenqlSelection
    zoneCode?: boolean | number
    zoneType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryZoneFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),parentZoneIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),status?: (ZoneStatus[] | null),zoneType?: (ZoneType[] | null)}

export interface InventoryZoneInput {capacityUnit?: (Scalars['String'] | null),capacityValue?: (Scalars['Decimal'] | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),facilityId: Scalars['ID'],name: Scalars['String'],parentZoneId?: (Scalars['ID'] | null),status: ZoneStatus,zoneCode: Scalars['String'],zoneType: ZoneType}

export interface InventoryZoneResultPageGenqlSelection{
    entries?: InventoryZoneGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InventoryZoneUpdateInput {capacityUnit?: (Scalars['String'] | null),capacityValue?: (Scalars['Decimal'] | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),name?: (Scalars['String'] | null),parentZoneId?: (Scalars['ID'] | null),zoneCode?: (Scalars['String'] | null),zoneType?: (ZoneType | null)}

export interface InvoiceGenqlSelection{
    account?: AccountGenqlSelection
    amount?: MoneyGenqlSelection
    documentDate?: boolean | number
    documentNumber?: boolean | number
    dueDate?: boolean | number
    facility?: FacilityGenqlSelection
    id?: boolean | number
    lineItems?: InvoiceLineItemGenqlSelection
    notes?: boolean | number
    openAmount?: MoneyGenqlSelection
    paymentTerm?: boolean | number
    paymentTermEntity?: PaymentTermConfigGenqlSelection
    payments?: PaymentGenqlSelection
    sourceReferences?: InvoiceEntityReferenceGenqlSelection
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceEntityReferenceGenqlSelection{
    entityId?: boolean | number
    entityType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceEntityReferenceInput {entityId: Scalars['ID'],entityType: InvoiceEntityReferenceType}

export interface InvoiceFilter {accountIDs?: (Scalars['ID'][] | null),currencyCode?: (CurrencyCode | null),facilityIDs?: (Scalars['ID'][] | null),fromDueDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),maxOpenBalance?: (Scalars['Decimal'] | null),minOpenBalance?: (Scalars['Decimal'] | null),searchTerm?: (Scalars['String'] | null),statuses?: (InvoiceStatus[] | null),toDueDate?: (Scalars['CalendarDate'] | null),types?: (InvoiceType[] | null)}

export interface InvoiceLineItemGenqlSelection{
    description?: boolean | number
    groupName?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    quantity?: boolean | number
    sortOrder?: boolean | number
    sourceReference?: InvoiceEntityReferenceGenqlSelection
    timestamps?: TimestampsGenqlSelection
    totalPrice?: MoneyGenqlSelection
    unit?: boolean | number
    unitPrice?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceLineItemInput {description: Scalars['String'],groupName?: (Scalars['String'] | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),quantity: Scalars['Decimal'],sortOrder?: (Scalars['Int'] | null),sourceReference?: (InvoiceEntityReferenceInput | null),totalPrice: MoneyInput,unit: Scalars['String'],unitPrice: MoneyInput}

export interface InvoicePaymentApplicationGenqlSelection{
    appliedAmount?: MoneyGenqlSelection
    appliedAt?: boolean | number
    invoice?: InvoiceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceResultPageGenqlSelection{
    entries?: InvoiceGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface InvoiceStatusCountsGenqlSelection{
    paid?: boolean | number
    pending?: boolean | number
    proForma?: boolean | number
    voided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemGenqlSelection{
    attributeValues?: boolean | number
    category?: CategoryGenqlSelection
    categoryId?: boolean | number
    colorHue?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    description?: boolean | number
    effectivePricingUnit?: boolean | number
    id?: boolean | number
    itemGroup?: ItemGroupGenqlSelection
    itemGroupId?: boolean | number
    measurementUnit?: boolean | number
    name?: boolean | number
    notes?: boolean | number
    pricingUnitOverride?: boolean | number
    skuNumber?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemAliasGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    aliasCode?: boolean | number
    aliasName?: boolean | number
    aliasType?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    notes?: boolean | number
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemAliasFilter {accountIds?: (Scalars['ID'][] | null),aliasTypes?: (ItemAliasType[] | null),ids?: (Scalars['ID'][] | null),itemIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface ItemAliasInput {accountId: Scalars['ID'],aliasCode?: (Scalars['String'] | null),aliasName: Scalars['String'],aliasType: ItemAliasType,itemId: Scalars['ID'],notes?: (Scalars['String'] | null)}

export interface ItemAliasResultPageGenqlSelection{
    entries?: ItemAliasGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemAliasUpdateInput {aliasCode?: (Scalars['String'] | null),aliasName?: (Scalars['String'] | null),aliasType?: (ItemAliasType | null),notes?: (Scalars['String'] | null)}

export interface ItemFilter {categoryId?: (Scalars['ID'] | null),categoryIds?: (Scalars['ID'][] | null),description?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),includeDeleted?: (Scalars['Boolean'] | null),itemGroupId?: (Scalars['ID'] | null),itemGroupIds?: (Scalars['ID'][] | null),measurementUnit?: (Scalars['String'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),pricingUnitOverride?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),skuNumber?: (Scalars['String'] | null)}

export interface ItemGroupGenqlSelection{
    colorHue?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    defaultPricingUnit?: boolean | number
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    notes?: boolean | number
    number?: boolean | number
    parentId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemGroupFilter {defaultPricingUnit?: (Scalars['String'] | null),description?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),number?: (Scalars['String'] | null),parentId?: (Scalars['ID'] | null),parentIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface ItemGroupInput {colorHue?: (Scalars['Int'] | null),customAttributes?: (Scalars['Map'] | null),defaultPricingUnit: Scalars['String'],description?: (Scalars['String'] | null),name: Scalars['String'],notes?: (Scalars['String'] | null),number: Scalars['String'],parentId?: (Scalars['ID'] | null)}

export interface ItemGroupResultPageGenqlSelection{
    entries?: ItemGroupGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemGroupUpdateInput {colorHue?: (Scalars['Int'] | null),customAttributes?: (Scalars['Map'] | null),defaultPricingUnit?: (Scalars['String'] | null),description?: (Scalars['String'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),number?: (Scalars['String'] | null),parentId?: (Scalars['ID'] | null)}

export interface ItemInput {attributeValues: Scalars['JSON'],categoryId: Scalars['ID'],colorHue?: (Scalars['Int'] | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),itemGroupId: Scalars['ID'],measurementUnit: Scalars['String'],name: Scalars['String'],notes?: (Scalars['String'] | null),pricingUnitOverride?: (Scalars['String'] | null),skuNumber: Scalars['String']}

export interface ItemMarginResultGenqlSelection{
    itemId?: boolean | number
    margin?: MoneyGenqlSelection
    marginPercent?: boolean | number
    purchaseTotal?: MoneyGenqlSelection
    purchaseUnitPrice?: MoneyGenqlSelection
    quantity?: boolean | number
    salesTotal?: MoneyGenqlSelection
    salesUnitPrice?: MoneyGenqlSelection
    unit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPositionGenqlSelection{
    currentInventory?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    incoming?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    netPosition?: boolean | number
    outgoing?: boolean | number
    unit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPositionFilter {facilityIds?: (Scalars['ID'][] | null),itemIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),showOnlyNegative?: (Scalars['Boolean'] | null)}

export interface ItemPositionResultPageGenqlSelection{
    entries?: ItemPositionGenqlSelection
    page?: PageGenqlSelection
    stats?: PositionSummaryStatsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPriceGenqlSelection{
    configuration?: ItemPriceConfigurationGenqlSelection
    itemPricings?: EvaluatedItemPricingGenqlSelection
    sourceId?: boolean | number
    sourceType?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPriceConfigurationGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currency?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    itemId?: boolean | number
    operationType?: boolean | number
    pricingUnits?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPriceConfigurationFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemIds?: (Scalars['ID'][] | null),operationType?: (OperationType[] | null)}

export interface ItemPriceConfigurationInput {currency: Scalars['String'],facilityId?: (Scalars['ID'] | null),itemId: Scalars['ID'],operationType: OperationType,pricingUnits?: (Scalars['Map'] | null)}

export interface ItemPriceConfigurationResultPageGenqlSelection{
    entries?: ItemPriceConfigurationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPriceConfigurationUpdateInput {currency?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),operationType?: (OperationType | null),pricingUnits?: (Scalars['Map'] | null)}

export interface ItemPricingGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customPriceListId?: boolean | number
    defaultPriceListId?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    position?: boolean | number
    pricingUnit?: boolean | number
    tiers?: ItemPricingTierGenqlSelection
    tiersEffectiveAt?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPricingDirtyAwareResultGenqlSelection{
    entries?: ItemPricingGenqlSelection
    preservedDirtyNodes?: ItemPricingGenqlSelection
    visibleDirtyIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPricingFilter {customPriceListId?: (Scalars['ID'] | null),customPriceListIds?: (Scalars['ID'][] | null),defaultPriceListId?: (Scalars['ID'] | null),defaultPriceListIds?: (Scalars['ID'][] | null),fromTiersEffectiveAt?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),toTiersEffectiveAt?: (Scalars['ZonedDateTime'] | null)}

export interface ItemPricingInput {customPriceListId?: (Scalars['ID'] | null),defaultPriceListId?: (Scalars['ID'] | null),itemId: Scalars['ID'],position: Scalars['Int'],pricingUnit: Unit,tiers?: (CreateItemPricingTierInput[] | null),tiersEffectiveAt?: (Scalars['ZonedDateTime'] | null)}

export interface ItemPricingResultPageGenqlSelection{
    entries?: ItemPricingGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPricingTierGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    itemPricingId?: boolean | number
    maxAmount?: boolean | number
    maxPrice?: UnitPriceFormulaGenqlSelection
    minPrice?: UnitPriceFormulaGenqlSelection
    position?: boolean | number
    scrapValue?: boolean | number
    targetPrice?: UnitPriceFormulaGenqlSelection
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPricingTierFilter {ids?: (Scalars['ID'][] | null),itemPricingId?: (Scalars['ID'] | null),itemPricingIds?: (Scalars['ID'][] | null),maxPriceFormula?: (Scalars['String'] | null),minPriceFormula?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),targetPriceFormula?: (Scalars['String'] | null)}

export interface ItemPricingTierResultPageGenqlSelection{
    entries?: ItemPricingTierGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemPricingTierUpdateInput {itemPricingId?: (Scalars['ID'] | null),maxAmount?: (Scalars['Decimal'] | null),maxPrice?: (UnitPriceFormulaInput | null),minPrice?: (UnitPriceFormulaInput | null),position?: (Scalars['Int'] | null),scrapValue?: (Scalars['Decimal'] | null),targetPrice?: (UnitPriceFormulaInput | null)}

export interface ItemPricingUpdateInput {customPriceListId?: (Scalars['ID'] | null),defaultPriceListId?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),position?: (Scalars['Int'] | null),pricingUnit?: (Unit | null),tiersEffectiveAt?: (Scalars['ZonedDateTime'] | null)}

export interface ItemResultPageGenqlSelection{
    entries?: ItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ItemUpdateInput {attributeValues?: (Scalars['JSON'] | null),categoryId?: (Scalars['ID'] | null),colorHue?: (Scalars['Int'] | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),itemGroupId?: (Scalars['ID'] | null),measurementUnit?: (Scalars['String'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),pricingUnitOverride?: (Scalars['String'] | null),skuNumber?: (Scalars['String'] | null)}

export interface LinkBrokeredOrdersInput {addPurchaseOrderIds?: (Scalars['ID'][] | null),addSalesOrderIds?: (Scalars['ID'][] | null),removePurchaseOrderIds?: (Scalars['ID'][] | null),removeSalesOrderIds?: (Scalars['ID'][] | null)}

export interface LoadGenqlSelection{
    billId?: boolean | number
    bolNumber?: boolean | number
    booking?: BookingGenqlSelection
    bookingId?: boolean | number
    brokeredOrder?: BrokeredOrderGenqlSelection
    brokeredOrderId?: boolean | number
    canBeReconciled?: boolean | number
    carrierAccount?: AccountGenqlSelection
    carrierAccountId?: boolean | number
    container?: ContainerGenqlSelection
    containerAtFacilityAt?: boolean | number
    containerInTransitAt?: boolean | number
    containerLoadedAt?: boolean | number
    containerNumber?: boolean | number
    containerPickedUpAt?: boolean | number
    containerReadyToShipAt?: boolean | number
    containerReturningAt?: boolean | number
    containerType?: ContainerTypeGenqlSelection
    containerTypeId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currencyCode?: boolean | number
    customerAccount?: AccountGenqlSelection
    customerAccountAddress?: AccountAddressGenqlSelection
    customerAccountAddressId?: boolean | number
    customerAccountId?: boolean | number
    customerExternalNotes?: boolean | number
    customerFiles?: FileGenqlSelection
    customerInternalNotes?: boolean | number
    deductions?: LoadDeductionGenqlSelection
    deductionsTotal?: MoneyGenqlSelection
    deliveryNumber?: boolean | number
    description?: boolean | number
    documentNumber?: boolean | number
    driverName?: boolean | number
    expectedShipDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    freightCost?: MoneyGenqlSelection
    freightForwarder?: boolean | number
    freightTerms?: boolean | number
    grandTotal?: MoneyGenqlSelection
    heavyWeight?: WeightGenqlSelection
    id?: boolean | number
    isReconciled?: boolean | number
    lightWeight?: WeightGenqlSelection
    lineItems?: LoadLineItemGenqlSelection
    loadReceivedDate?: boolean | number
    millReceivedWeightPostDate?: boolean | number
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    outboundTollingAgreement?: OutboundTollingAgreementGenqlSelection
    outboundTollingAgreementId?: boolean | number
    purchaseOrder?: PurchaseOrderGenqlSelection
    purchaseOrderId?: boolean | number
    receivedTicketIssueDate?: boolean | number
    receivingFacility?: FacilityGenqlSelection
    receivingFacilityId?: boolean | number
    receivingTicketNumber?: boolean | number
    reconciliation?: LoadReconciliationGenqlSelection
    recyclerExternalNotes?: boolean | number
    recyclerFiles?: FileGenqlSelection
    recyclerInternalNotes?: boolean | number
    releaseNumber?: boolean | number
    reviewed?: boolean | number
    salesOrder?: SalesOrderGenqlSelection
    salesOrderId?: boolean | number
    scac?: boolean | number
    sealNumber?: boolean | number
    shippedDate?: boolean | number
    shippingCarrierName?: boolean | number
    status?: boolean | number
    subtotal?: MoneyGenqlSelection
    supplier?: AccountGenqlSelection
    supplierAddress?: AccountAddressGenqlSelection
    supplierAddressId?: boolean | number
    supplierId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    trailerNumber?: boolean | number
    truckFreight?: boolean | number
    truckNumber?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    version?: boolean | number
    voidReason?: boolean | number
    weightDisplayUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadBoardGenqlSelection{
    drivers?: DriverGenqlSelection
    services?: ServiceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadCustomerFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadCustomerFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface LoadDeductionGenqlSelection{
    applicationType?: boolean | number
    calculatedAmount?: MoneyGenqlSelection
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    deductionType?: DeductionTypeGenqlSelection
    deductionTypeId?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    lineItem?: LoadLineItemGenqlSelection
    load?: LoadGenqlSelection
    loadId?: boolean | number
    loadLineItemId?: boolean | number
    notes?: boolean | number
    percentage?: boolean | number
    priceValue?: MoneyGenqlSelection
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    weightValue?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadDeductionFilter {applicationType?: (DeductionApplicationType[] | null),deductionTypeId?: (Scalars['ID'] | null),deductionTypeIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),loadId?: (Scalars['ID'] | null),loadIds?: (Scalars['ID'][] | null),loadLineItemId?: (Scalars['ID'] | null),loadLineItemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface LoadDeductionResultPageGenqlSelection{
    entries?: LoadDeductionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadFilter {accountIds?: (Scalars['ID'][] | null),bookingIds?: (Scalars['ID'][] | null),brokeredOrderIds?: (Scalars['ID'][] | null),carrierAccountIds?: (Scalars['ID'][] | null),createdBy?: (Scalars['ID'][] | null),customerAccountIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),freightTerms?: (FreightTerms[] | null),fromExpectedShipDate?: (Scalars['CalendarDate'] | null),fromShippedDate?: (Scalars['CalendarDate'] | null),hasSupplier?: (Scalars['Boolean'] | null),ids?: (Scalars['ID'][] | null),phases?: (SalesLoadLineItemPhase[] | null),purchaseOrderIds?: (Scalars['ID'][] | null),receivingFacilityIds?: (Scalars['ID'][] | null),salesOrderId?: (Scalars['ID'] | null),salesOrderIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),status?: (LoadStatus[] | null),supplierIds?: (Scalars['ID'][] | null),toExpectedShipDate?: (Scalars['CalendarDate'] | null),toShippedDate?: (Scalars['CalendarDate'] | null),updatedBy?: (Scalars['ID'][] | null)}

export interface LoadInput {bolNumber?: (Scalars['String'] | null),bookingId?: (Scalars['ID'] | null),brokeredOrderId?: (Scalars['ID'] | null),carrierAccountId?: (Scalars['ID'] | null),containerNumber?: (Scalars['String'] | null),containerTypeId?: (Scalars['ID'] | null),currencyCode?: (CurrencyCode | null),customerAccountAddressId?: (Scalars['ID'] | null),customerAccountId?: (Scalars['ID'] | null),customerExternalNotes?: (Scalars['String'] | null),customerInternalNotes?: (Scalars['String'] | null),deliveryNumber?: (Scalars['String'] | null),description?: (Scalars['String'] | null),documentNumber?: (Scalars['String'] | null),driverName?: (Scalars['String'] | null),expectedShipDate?: (Scalars['CalendarDate'] | null),facilityId: Scalars['ID'],freightCost?: (MoneyInput | null),freightForwarder?: (Scalars['String'] | null),freightTerms?: (FreightTerms | null),heavyWeight?: (WeightInput | null),lightWeight?: (WeightInput | null),lineItems?: (LoadLineItemInput[] | null),outboundTollingAgreementId?: (Scalars['ID'] | null),purchaseOrderId?: (Scalars['ID'] | null),receivingFacilityId?: (Scalars['ID'] | null),recyclerExternalNotes?: (Scalars['String'] | null),recyclerInternalNotes?: (Scalars['String'] | null),releaseNumber?: (Scalars['String'] | null),salesOrderId?: (Scalars['ID'] | null),scac?: (Scalars['String'] | null),sealNumber?: (Scalars['String'] | null),shippingCarrierName?: (Scalars['String'] | null),supplierAddressId?: (Scalars['ID'] | null),supplierId?: (Scalars['ID'] | null),trailerNumber?: (Scalars['String'] | null),truckFreight?: (Scalars['String'] | null),truckNumber?: (Scalars['String'] | null),weightDisplayUnit?: (WeightDisplayUnit | null)}

export interface LoadLineItemGenqlSelection{
    estimatedPrice?: MoneyGenqlSelection
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    loadId?: boolean | number
    notes?: boolean | number
    phase?: boolean | number
    pricingUnit?: boolean | number
    purchaseOrder?: PurchaseOrderGenqlSelection
    purchaseOrderId?: boolean | number
    quantityVariance?: boolean | number
    receivedLineItems?: ReceivedLineItemGenqlSelection
    salesOrderLine?: SalesOrderLineItemGenqlSelection
    /** @deprecated Use itemId matching with Load.salesOrderId instead */
    salesOrderLineId?: boolean | number
    tagId?: boolean | number
    totalReceivedQuantity?: boolean | number
    type?: boolean | number
    unitPrice?: MoneyGenqlSelection
    weights?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadLineItemInput {estimatedPrice?: (MoneyInput | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),phase?: (SalesLoadLineItemPhase | null),pricingUnit: Scalars['String'],purchaseOrderId?: (Scalars['ID'] | null),salesOrderLineId?: (Scalars['ID'] | null),tagId?: (Scalars['ID'] | null),type: SalesItemLineType,unitPrice?: (MoneyInput | null),weights?: (Scalars['Map'] | null)}

export interface LoadLineItemReconcileInput {id: Scalars['ID'],shippedQuantity: Scalars['Decimal'],shippedWeight: WeightInput}

export interface LoadPhotoCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadPhotoInput {fileName: Scalars['String'],fileSize: Scalars['Int'],isPhotoRequirement?: Scalars['Boolean'],mimeType: Scalars['String'],notes?: (Scalars['String'] | null),photoRequirementId?: (Scalars['ID'] | null),public?: Scalars['Boolean']}

export interface LoadPhotoUpdateInput {notes?: (Scalars['String'] | null),photoRequirementId?: (Scalars['ID'] | null)}

export interface LoadReconciliationGenqlSelection{
    deductions?: ReconciliationDeductionGenqlSelection
    externalNotes?: boolean | number
    files?: FileGenqlSelection
    freightCharges?: FreightChargeGenqlSelection
    id?: boolean | number
    internalNotes?: boolean | number
    invoice?: InvoiceGenqlSelection
    invoiceId?: boolean | number
    invoiceType?: boolean | number
    loadId?: boolean | number
    loadReceivedDate?: boolean | number
    millReceivedWeightPostDate?: boolean | number
    netDelta?: boolean | number
    netReceivedWeight?: boolean | number
    netShippedWeight?: boolean | number
    receivedLineItems?: ReceivedLineItemGenqlSelection
    receivedLoadTotal?: MoneyGenqlSelection
    shippedLoadTotal?: MoneyGenqlSelection
    ticketIssueDate?: boolean | number
    ticketNumber?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalDeductions?: MoneyGenqlSelection
    totalDelta?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadReconciliationFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadReconciliationFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface LoadReconciliationSummaryGenqlSelection{
    expectedShipDate?: boolean | number
    isReconciled?: boolean | number
    loadId?: boolean | number
    netDelta?: boolean | number
    netReceivedWeight?: boolean | number
    netShippedWeight?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadReconciliationSummaryResultPageGenqlSelection{
    entries?: LoadReconciliationSummaryGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadRecyclerFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadRecyclerFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface LoadResultPageGenqlSelection{
    entries?: LoadGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadReviewInput {id: Scalars['ID'],millReceivedWeightPostDate?: (Scalars['CalendarDate'] | null),receivedTicketIssueDate?: (Scalars['CalendarDate'] | null),receivingTicketNumber?: (Scalars['String'] | null)}

export interface LoadStatusCountsGenqlSelection{
    containerAtFacility?: boolean | number
    containerAtPort?: boolean | number
    containerInTransit?: boolean | number
    containerLoaded?: boolean | number
    containerReadyToShip?: boolean | number
    containerReturning?: boolean | number
    pending?: boolean | number
    received?: boolean | number
    reconciled?: boolean | number
    shipped?: boolean | number
    unassigned?: boolean | number
    voided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LoadUpdateInput {bolNumber?: (Scalars['String'] | null),bookingId?: (Scalars['ID'] | null),brokeredOrderId?: (Scalars['ID'] | null),carrierAccountId?: (Scalars['ID'] | null),containerNumber?: (Scalars['String'] | null),containerTypeId?: (Scalars['ID'] | null),currencyCode?: (CurrencyCode | null),customerAccountAddressId?: (Scalars['ID'] | null),customerAccountId?: (Scalars['ID'] | null),customerExternalNotes?: (Scalars['String'] | null),customerInternalNotes?: (Scalars['String'] | null),deductions?: (UpdateLoadDeductionInput[] | null),deliveryNumber?: (Scalars['String'] | null),description?: (Scalars['String'] | null),driverName?: (Scalars['String'] | null),expectedShipDate?: (Scalars['CalendarDate'] | null),expectedVersion?: (Scalars['Int'] | null),facilityId?: (Scalars['ID'] | null),freightCost?: (MoneyInput | null),freightForwarder?: (Scalars['String'] | null),freightTerms?: (FreightTerms | null),heavyWeight?: (WeightInput | null),lightWeight?: (WeightInput | null),lineItems?: (LoadLineItemInput[] | null),outboundTollingAgreementId?: (Scalars['ID'] | null),purchaseOrderId?: (Scalars['ID'] | null),receivingFacilityId?: (Scalars['ID'] | null),recyclerExternalNotes?: (Scalars['String'] | null),recyclerInternalNotes?: (Scalars['String'] | null),releaseNumber?: (Scalars['String'] | null),salesOrderId?: (Scalars['ID'] | null),scac?: (Scalars['String'] | null),sealNumber?: (Scalars['String'] | null),shippingCarrierName?: (Scalars['String'] | null),supplierAddressId?: (Scalars['ID'] | null),supplierId?: (Scalars['ID'] | null),trailerNumber?: (Scalars['String'] | null),truckFreight?: (Scalars['String'] | null),truckNumber?: (Scalars['String'] | null),weightDisplayUnit?: (WeightDisplayUnit | null)}

export interface LoadUpdateResultGenqlSelection{
    load?: LoadGenqlSelection
    orphanedLink?: OrphanedBookingSalesOrderLinkGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LocationGenqlSelection{
    accountAddress?: AccountAddressGenqlSelection
    facility?: FacilityGenqlSelection
    id?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LocationFreightPricingGenqlSelection{
    consumerChargebackFormula?: boolean | number
    consumerChargebackVariableIds?: boolean | number
    consumerFreightEnabled?: boolean | number
    consumerFuelSurchargeFormula?: boolean | number
    consumerFuelSurchargeMode?: boolean | number
    consumerFuelSurchargeVariableIds?: boolean | number
    consumerNegativeCharge?: boolean | number
    consumerRateFormula?: boolean | number
    consumerRateVariableIds?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    location?: LocationGenqlSelection
    locationId?: boolean | number
    locationType?: boolean | number
    supplierChargebackFormula?: boolean | number
    supplierChargebackVariableIds?: boolean | number
    supplierFreightEnabled?: boolean | number
    supplierFuelSurchargeFormula?: boolean | number
    supplierFuelSurchargeMode?: boolean | number
    supplierFuelSurchargeVariableIds?: boolean | number
    supplierRateFormula?: boolean | number
    supplierRateVariableIds?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LocationFreightPricingFilter {ids?: (Scalars['ID'][] | null),locationId?: (Scalars['ID'] | null)}

export interface LocationFreightPricingInput {consumerChargebackFormula?: (Scalars['String'] | null),consumerChargebackVariableIds?: (Scalars['String'] | null),consumerFreightEnabled: Scalars['Boolean'],consumerFuelSurchargeFormula?: (Scalars['String'] | null),consumerFuelSurchargeMode?: (Scalars['String'] | null),consumerFuelSurchargeVariableIds?: (Scalars['String'] | null),consumerNegativeCharge: Scalars['Boolean'],consumerRateFormula?: (Scalars['String'] | null),consumerRateVariableIds?: (Scalars['String'] | null),locationId: Scalars['ID'],locationType: LocationType,supplierChargebackFormula?: (Scalars['String'] | null),supplierChargebackVariableIds?: (Scalars['String'] | null),supplierFreightEnabled: Scalars['Boolean'],supplierFuelSurchargeFormula?: (Scalars['String'] | null),supplierFuelSurchargeMode?: (Scalars['String'] | null),supplierFuelSurchargeVariableIds?: (Scalars['String'] | null),supplierRateFormula?: (Scalars['String'] | null),supplierRateVariableIds?: (Scalars['String'] | null)}

export interface LocationFreightPricingResultPageGenqlSelection{
    entries?: LocationFreightPricingGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LocationFreightPricingUpdateInput {consumerChargebackFormula?: (Scalars['String'] | null),consumerChargebackVariableIds?: (Scalars['String'] | null),consumerFreightEnabled?: (Scalars['Boolean'] | null),consumerFuelSurchargeFormula?: (Scalars['String'] | null),consumerFuelSurchargeMode?: (Scalars['String'] | null),consumerFuelSurchargeVariableIds?: (Scalars['String'] | null),consumerNegativeCharge?: (Scalars['Boolean'] | null),consumerRateFormula?: (Scalars['String'] | null),consumerRateVariableIds?: (Scalars['String'] | null),locationId?: (Scalars['ID'] | null),locationType?: (LocationType | null),supplierChargebackFormula?: (Scalars['String'] | null),supplierChargebackVariableIds?: (Scalars['String'] | null),supplierFreightEnabled?: (Scalars['Boolean'] | null),supplierFuelSurchargeFormula?: (Scalars['String'] | null),supplierFuelSurchargeMode?: (Scalars['String'] | null),supplierFuelSurchargeVariableIds?: (Scalars['String'] | null),supplierRateFormula?: (Scalars['String'] | null),supplierRateVariableIds?: (Scalars['String'] | null)}

export interface LoopNodeGenqlSelection{
    arrayExpression?: boolean | number
    description?: boolean | number
    id?: boolean | number
    itemVariableName?: boolean | number
    label?: boolean | number
    maxIterations?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotAllocationGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    lot?: InventoryLotGenqlSelection
    lotId?: boolean | number
    movement?: InventoryMovementGenqlSelection
    movementId?: boolean | number
    quantity?: WeightGenqlSelection
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotAllocationFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),lotId?: (Scalars['ID'] | null),lotIds?: (Scalars['ID'][] | null),movementId?: (Scalars['ID'] | null),movementIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface LotAllocationFilterInput {excludeTransactionTypes?: (InventoryTransactionType[] | null),includeTransactionTypes?: (InventoryTransactionType[] | null)}

export interface LotAllocationInput {lotId: Scalars['ID'],movementId: Scalars['ID'],quantity: WeightInput}

export interface LotAllocationResultPageGenqlSelection{
    entries?: LotAllocationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotAllocationUpdateInput {lotId?: (Scalars['ID'] | null),movementId?: (Scalars['ID'] | null),quantity?: (WeightInput | null)}

export interface LotMovementFilterInput {itemId?: (Scalars['ID'] | null),occurredAtFrom?: (Scalars['ZonedDateTime'] | null),occurredAtTo?: (Scalars['ZonedDateTime'] | null),originTransactionTypes?: (InventoryTransactionType[] | null),supplierIds?: (Scalars['ID'][] | null),unallocatedOnly?: (Scalars['Boolean'] | null)}

export interface LotQuantitySummaryGenqlSelection{
    inQuantity?: WeightGenqlSelection
    item?: ItemGenqlSelection
    itemId?: boolean | number
    outQuantity?: WeightGenqlSelection
    quantity?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotSplitTransferInput {allocationId: Scalars['ID'],quantity?: (WeightInput | null)}

export interface LotTraceBackwardResultGenqlSelection{
    lot?: InventoryLotGenqlSelection
    purchases?: LotTracePurchaseGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotTraceForwardResultGenqlSelection{
    lot?: InventoryLotGenqlSelection
    sales?: LotTraceSaleGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotTracePurchaseGenqlSelection{
    allocation?: LotAllocationGenqlSelection
    cost?: MoneyGenqlSelection
    quantity?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotTraceSaleGenqlSelection{
    allocation?: LotAllocationGenqlSelection
    quantity?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface LotValuationGenqlSelection{
    currentWAC?: MoneyGenqlSelection
    item?: ItemGenqlSelection
    itemId?: boolean | number
    lotSpecificCost?: MoneyGenqlSelection
    lotSpecificValue?: MoneyGenqlSelection
    quantity?: WeightGenqlSelection
    wacValue?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Details of an active MFA challenge that needs to be completed */
export interface MfaChallengeGenqlSelection{
    expiresAt?: boolean | number
    id?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when multi-factor authentication verification is required */
export interface MfaChallengeErrorGenqlSelection{
    authenticationFactors?: MfaFactorGenqlSelection
    pendingAuthenticationToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when the user must set up multi-factor authentication */
export interface MfaEnrollmentRequiredErrorGenqlSelection{
    pendingAuthenticationToken?: boolean | number
    user?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Configuration for a specific multi-factor authentication method */
export interface MfaFactorGenqlSelection{
    id?: boolean | number
    totp?: TotpConfigGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MoneyGenqlSelection{
    amount?: boolean | number
    currencyCode?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MoneyInput {amount: Scalars['Decimal'],currencyCode: CurrencyCode}

export interface MoveFileInput {fileId: Scalars['ID'],newParentId?: (Scalars['ID'] | null)}

export interface MoveFilePayloadGenqlSelection{
    file?: FileGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MovementRunningTotalsGenqlSelection{
    calculatedMovementValue?: MoneyGenqlSelection
    runningQuantity?: WeightGenqlSelection
    runningValue?: MoneyGenqlSelection
    runningWeightedAverageCost?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface MutationGenqlSelection{
    _placeholder?: boolean | number
    _pricingNoop?: boolean | number
    assistantActivateAgent?: (AgentGenqlSelection & { __args: {id: Scalars['ID']} })
    assistantArchiveChat?: (AssistantChatGenqlSelection & { __args: {id: Scalars['ID']} })
    assistantCreateAgent?: (AgentGenqlSelection & { __args: {input: CreateAgentInput} })
    assistantCreateChat?: (AssistantChatGenqlSelection & { __args: {input: CreateAssistantChatInput} })
    assistantDeactivateAgent?: (AgentGenqlSelection & { __args: {id: Scalars['ID']} })
    assistantSendChatMessage?: { __args: {chatId: Scalars['ID'], input: SendAssistantChatMessageInput} }
    assistantSetAgentTools?: (AgentGenqlSelection & { __args: {id: Scalars['ID'], input: SetAgentToolsInput} })
    assistantShareChat?: (AssistantChatShareLinkGenqlSelection & { __args: {chatId: Scalars['ID']} })
    assistantUnshareChat?: (AssistantChatGenqlSelection & { __args: {chatId: Scalars['ID']} })
    assistantUpdateAgent?: (AgentGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAgentInput} })
    assistantUpdateChat?: (AssistantChatGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAssistantChatInput} })
    /**
     * Accepts a user invitation using a verification token.
     * The token contains the user ID and email.
     * Sets the user's password and activates the account.
     */
    authenticationAcceptUserInvitation?: (UserInvitationAcceptResultGenqlSelection & { __args: {password: Scalars['String'], token: Scalars['String']} })
    /**
     * Authenticates a user using a magic authentication code.
     * Returns either a successful authentication response or an error indicating additional steps required.
     */
    authenticationAuthenticateWithMagicAuth?: (AuthenticationResultGenqlSelection & { __args: {clientId: Scalars['String'], code: Scalars['String'], email: Scalars['String']} })
    /**
     * Completes the signup process using a verification token.
     * The token contains the verified email address.
     * Provisions the organization and user, then returns the created IDs.
     */
    authenticationCompleteSignUp?: (SignUpCompleteResultGenqlSelection & { __args: {firstName: Scalars['String'], lastName: Scalars['String'], organizationName: Scalars['String'], password: Scalars['String'], timezone: Scalars['String'], token: Scalars['String']} })
    /**
     * Completes Standalone Connect authentication for device authorization flows.
     * Called by the frontend after the user logs in, to inform WorkOS that auth succeeded.
     */
    authenticationCompleteStandaloneAuth?: (StandaloneAuthResultGenqlSelection & { __args: {externalAuthId: Scalars['String']} })
    /**
     * Creates a magic authentication link for the specified email address.
     * Returns true if the magic auth link was created and sent successfully.
     */
    authenticationCreateMagicAuth?: { __args: {email: Scalars['String']} }
    /**
     * Refreshes an existing authentication session using the current access token.
     * Returns a new authentication response or an error if the session cannot be refreshed.
     */
    authenticationRefreshSession?: (AuthenticationResultGenqlSelection & { __args: {clientId: Scalars['String']} })
    /**
     * Completes the authentication process by selecting an organization when multiple are available.
     * Used in response to an OrganizationSelectionError.
     */
    authenticationSelectOrganization?: (AuthenticationResultGenqlSelection & { __args: {clientId: Scalars['String'], organizationId: Scalars['String'], pendingAuthenticationToken: Scalars['String']} })
    /**
     * Triggers sending of a verification code to the specified email address.
     * Returns true if the email was sent successfully.
     */
    authenticationSendEmailVerification?: { __args: {email: Scalars['String']} }
    /**
     * Authenticates a user using their email and password.
     * Returns either a successful authentication response or an error indicating additional steps required.
     */
    authenticationSignIn?: (AuthenticationResultGenqlSelection & { __args: {clientId: Scalars['String'], email: Scalars['String'], password: Scalars['String']} })
    /**
     * Signs out the current user by invalidating their session.
     * Returns true if the sign out was successful.
     */
    authenticationSignOut?: boolean | number
    /**
     * Initiates the signup process for a new user.
     * Sends a verification email with a token. No data is stored in the database.
     */
    authenticationSignUp?: (SignUpInitiateResultGenqlSelection & { __args: {email: Scalars['String']} })
    /**
     * Verifies an email verification code sent to the user's email address.
     * Used in response to an EmailVerificationRequiredError.
     */
    authenticationVerifyEmail?: (AuthenticationResultGenqlSelection & { __args: {clientId: Scalars['String'], code: Scalars['String'], pendingAuthenticationToken: Scalars['String']} })
    /**
     * Verifies a TOTP code during multi-factor authentication.
     * Used in response to a MfaChallengeError.
     */
    authenticationVerifyTotp?: (AuthenticationResultGenqlSelection & { __args: {authenticationChallengeId: Scalars['String'], clientId: Scalars['String'], code: Scalars['String'], pendingAuthenticationToken: Scalars['String']} })
    automationsApprovalRespond?: (ApprovalRequestGenqlSelection & { __args: {id: Scalars['ID'], input: RespondApprovalInput} })
    automationsAutomationActivate?: (AutomationGenqlSelection & { __args: {id: Scalars['ID']} })
    automationsAutomationBulkActivate?: (AutomationBulkOperationResultGenqlSelection & { __args: {input: AutomationBulkInput} })
    automationsAutomationBulkDelete?: (AutomationBulkOperationResultGenqlSelection & { __args: {input: AutomationBulkInput} })
    automationsAutomationBulkPause?: (AutomationBulkOperationResultGenqlSelection & { __args: {input: AutomationBulkInput} })
    automationsAutomationCreate?: (AutomationGenqlSelection & { __args: {input: CreateAutomationInput} })
    automationsAutomationDelete?: (AutomationDeleteResultGenqlSelection & { __args: {id: Scalars['ID']} })
    automationsAutomationDuplicate?: (AutomationGenqlSelection & { __args: {id: Scalars['ID']} })
    automationsAutomationPause?: (AutomationGenqlSelection & { __args: {id: Scalars['ID']} })
    automationsAutomationTest?: (ExecutionRunGenqlSelection & { __args: {id: Scalars['ID'], testPayload?: (Scalars['Map'] | null)} })
    automationsAutomationUpdate?: (AutomationGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAutomationInput} })
    automationsAutomationVersionCreate?: (AutomationVersionGenqlSelection & { __args: {input: AutomationVersionInput} })
    automationsAutomationVersionDelete?: { __args: {id: Scalars['ID']} }
    automationsAutomationVersionUpdate?: (AutomationVersionGenqlSelection & { __args: {id: Scalars['ID'], input: AutomationVersionUpdateInput} })
    automationsExecutionRunCancel?: (ExecutionRunGenqlSelection & { __args: {id: Scalars['ID']} })
    automationsWebhookRegenerateSecret?: (WebhookEndpointGenqlSelection & { __args: {automationId: Scalars['ID']} })
    complianceComplianceDispatchRecordCreate?: (ComplianceDispatchRecordGenqlSelection & { __args: {input: ComplianceDispatchRecordInput} })
    complianceComplianceDispatchRecordRetry?: (ComplianceDispatchRecordGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceComplianceDispatchRecordUpdate?: (ComplianceDispatchRecordGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceDispatchRecordUpdateInput} })
    complianceComplianceFacilityRuleApplyJurisdictionPack?: (ComplianceFacilityRuleGenqlSelection & { __args: {facilityId: Scalars['ID'], jurisdictionCode: Scalars['String']} })
    complianceComplianceFacilityRuleCreate?: (ComplianceFacilityRuleGenqlSelection & { __args: {input: ComplianceFacilityRuleInput} })
    complianceComplianceFacilityRuleDelete?: { __args: {id: Scalars['ID']} }
    complianceComplianceFacilityRuleUpdate?: (ComplianceFacilityRuleGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceFacilityRuleUpdateInput} })
    complianceComplianceItemJurisdictionCodeCreate?: (ComplianceItemJurisdictionCodeGenqlSelection & { __args: {input: ComplianceItemJurisdictionCodeInput} })
    complianceComplianceItemJurisdictionCodeDelete?: { __args: {id: Scalars['ID']} }
    complianceComplianceItemJurisdictionCodeUpdate?: (ComplianceItemJurisdictionCodeGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceItemJurisdictionCodeUpdateInput} })
    complianceComplianceRuleDefinitionCreate?: (ComplianceRuleDefinitionGenqlSelection & { __args: {input: ComplianceRuleDefinitionInput} })
    complianceComplianceRuleDefinitionDelete?: { __args: {id: Scalars['ID']} }
    complianceComplianceRuleDefinitionUpdate?: (ComplianceRuleDefinitionGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceRuleDefinitionUpdateInput} })
    complianceDoNotBuyEntryCreate?: (DoNotBuyEntryGenqlSelection & { __args: {input: DoNotBuyEntryInput} })
    complianceDoNotBuyEntryDelete?: { __args: {id: Scalars['ID']} }
    complianceDoNotBuyEntryUpdate?: (DoNotBuyEntryGenqlSelection & { __args: {id: Scalars['ID'], input: DoNotBuyEntryUpdateInput} })
    complianceGovernmentReportingConfigurationCreate?: (GovernmentReportingConfigurationGenqlSelection & { __args: {input: GovernmentReportingConfigurationInput} })
    complianceGovernmentReportingConfigurationDelete?: { __args: {id: Scalars['ID']} }
    complianceGovernmentReportingConfigurationUpdate?: (GovernmentReportingConfigurationGenqlSelection & { __args: {id: Scalars['ID'], input: GovernmentReportingConfigurationUpdateInput} })
    complianceGovernmentReportingFacilityCreate?: (GovernmentReportingFacilityGenqlSelection & { __args: {input: GovernmentReportingFacilityInput} })
    complianceGovernmentReportingFacilityDelete?: { __args: {id: Scalars['ID']} }
    complianceGovernmentReportingFacilityUpdate?: (GovernmentReportingFacilityGenqlSelection & { __args: {id: Scalars['ID'], input: GovernmentReportingFacilityUpdateInput} })
    confirmAttachmentUpload?: (AttachmentGenqlSelection & { __args: {id: Scalars['ID']} })
    coreCustomAttributeCreate?: (CustomAttributeGenqlSelection & { __args: {input: CreateCustomAttributeInput} })
    coreCustomAttributeDelete?: { __args: {id: Scalars['ID']} }
    coreCustomAttributeDisable?: (CustomAttributeGenqlSelection & { __args: {id: Scalars['ID']} })
    coreCustomAttributeUpdate?: (CustomAttributeGenqlSelection & { __args: {input: UpdateCustomAttributeInput} })
    coreFacilityCreate?: (FacilityGenqlSelection & { __args: {input: FacilityCreateInput} })
    coreFacilityDelete?: { __args: {id: Scalars['ID']} }
    coreFacilityGroupCreate?: (FacilityGroupGenqlSelection & { __args: {input: FacilityGroupInput} })
    coreFacilityGroupDelete?: { __args: {id: Scalars['ID']} }
    coreFacilityGroupUpdate?: (FacilityGroupGenqlSelection & { __args: {id: Scalars['ID'], input: FacilityGroupUpdateInput} })
    coreFacilityUpdate?: (FacilityGenqlSelection & { __args: {id: Scalars['ID'], input: FacilityUpdateInput} })
    coreOrganizationAddUser?: { __args: {organizationId: Scalars['ID'], userId: Scalars['ID']} }
    coreOrganizationCreate?: (OrganizationGenqlSelection & { __args: {input: CreateOrganizationInput} })
    coreOrganizationGrantEntitlement?: { __args: {entitlement: Scalars['String'], organizationId: Scalars['ID']} }
    coreOrganizationGrantUserAdmin?: (UserGenqlSelection & { __args: {organizationId: Scalars['ID'], userId: Scalars['ID']} })
    coreOrganizationRemoveUser?: { __args: {organizationId: Scalars['ID'], userId: Scalars['ID']} }
    coreOrganizationReset?: (OrganizationResetResultGenqlSelection & { __args?: {organizationId?: (Scalars['ID'] | null)} })
    coreOrganizationRevokeEntitlement?: { __args: {entitlement: Scalars['String'], organizationId: Scalars['ID']} }
    coreOrganizationRevokeUserAdmin?: (UserGenqlSelection & { __args: {organizationId: Scalars['ID'], userId: Scalars['ID']} })
    coreOrganizationUpdate?: (OrganizationGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateOrganizationInput} })
    corePatchScopedSettingValues?: { __args: {input: PatchScopedSettingValuesInput} }
    coreRoleAddUsers?: (BulkOperationResultGenqlSelection & { __args: {input: AddUsersToRoleInput} })
    coreRoleCreate?: (RoleGenqlSelection & { __args: {input: CreateRoleInput} })
    coreRoleDelete?: { __args: {id: Scalars['ID']} }
    coreRoleRemoveUsers?: (BulkOperationResultGenqlSelection & { __args: {input: RemoveUsersFromRoleInput} })
    coreRoleUpdate?: (RoleGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateRoleInput} })
    coreRolesArchive?: (BulkOperationResultGenqlSelection & { __args: {input: BulkRoleInput} })
    coreRolesRestore?: (BulkOperationResultGenqlSelection & { __args: {input: BulkRoleInput} })
    coreSettingCreate?: (SettingGenqlSelection & { __args: {input: CreateSettingInput} })
    coreSettingDelete?: { __args: {id: Scalars['String']} }
    coreSettingUpdate?: (SettingGenqlSelection & { __args: {id: Scalars['String'], input: UpdateSettingInput} })
    coreSettingsGroupCreate?: (SettingsGroupGenqlSelection & { __args: {input: CreateSettingsGroupInput} })
    coreSettingsGroupDelete?: { __args: {id: Scalars['ID']} }
    coreSettingsGroupUpdate?: (SettingsGroupGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateSettingsGroupInput} })
    coreUpdateUserPreferences?: (UserPreferencesGenqlSelection & { __args: {input: UpdateUserPreferencesInput} })
    coreUserCreate?: (UserGenqlSelection & { __args: {input: CreateUserInput} })
    coreUserDisable?: { __args: {id: Scalars['ID']} }
    coreUserEnable?: { __args: {id: Scalars['ID']} }
    coreUserRoleAssign?: (UserRoleAssignmentGenqlSelection & { __args: {input: AssignUserRoleInput} })
    coreUserRoleChange?: (UserRoleAssignmentGenqlSelection & { __args: {input: ChangeUserRoleInput} })
    coreUserRoleRevoke?: { __args: {id: Scalars['ID']} }
    coreUserRoleRevokeAll?: { __args: {userId: Scalars['ID']} }
    coreUserUpdate?: (UserGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateUserInput} })
    coreUsersDelete?: (BulkOperationResultGenqlSelection & { __args: {input: BulkUserInput} })
    coreUsersDisable?: (BulkOperationResultGenqlSelection & { __args: {input: BulkUserInput} })
    coreUsersEnable?: (BulkOperationResultGenqlSelection & { __args: {input: BulkUserInput} })
    createConversation?: (CreateConversationResultGenqlSelection & { __args: {input: CreateConversationInput} })
    crmAccountAddressCreate?: (AccountAddressGenqlSelection & { __args: {input: CreateAccountAddressInput} })
    crmAccountAddressDelete?: { __args: {id: Scalars['ID']} }
    crmAccountAddressUpdate?: (AccountAddressGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAccountAddressInput} })
    crmAccountCreate?: (AccountGenqlSelection & { __args: {input: CreateAccountInput} })
    crmAccountDelete?: { __args: {id: Scalars['ID']} }
    crmAccountUpdate?: (AccountGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAccountInput} })
    crmContactCreate?: (ContactGenqlSelection & { __args: {input: CreateContactInput} })
    crmContactDelete?: { __args: {id: Scalars['ID']} }
    crmContactUpdate?: (ContactGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateContactInput} })
    crmCustomerInvitationAccept?: (AcceptCustomerInvitationResultGenqlSelection & { __args: {input: AcceptCustomerInvitationInput} })
    crmCustomerInvitationCancel?: (CustomerInvitationGenqlSelection & { __args: {id: Scalars['ID']} })
    crmCustomerInvite?: (CustomerInvitationGenqlSelection & { __args: {input: CreateCustomerInvitationInput} })
    cycleCountLineApproveAdjustment?: (CycleCountLineGenqlSelection & { __args: {id: Scalars['ID'], unitCostOverride?: (Scalars['Decimal'] | null)} })
    cycleCountLineRecordCount?: (CycleCountLineGenqlSelection & { __args: {countedQuantity: Scalars['Decimal'], countedQuantityUnit?: (Scalars['String'] | null), id: Scalars['ID']} })
    cycleCountLineRejectAdjustment?: (CycleCountLineGenqlSelection & { __args: {id: Scalars['ID']} })
    cycleCountLineRequestRecount?: (CycleCountLineGenqlSelection & { __args: {id: Scalars['ID']} })
    filesCancelPendingUpload?: (DeleteFilePayloadGenqlSelection & { __args: {fileID: Scalars['ID']} })
    filesConfirmFileUpload?: (FileGenqlSelection & { __args: {checksum?: (Scalars['String'] | null), fileID: Scalars['ID']} })
    filesCreateFile?: (CreateFilePayloadGenqlSelection & { __args: {input: CreateFileInput} })
    filesCreateFiles?: (CreateFilesPayloadGenqlSelection & { __args: {inputs: CreateFileInput[]} })
    /**
     * Create a zip archive of multiple files for download.
     * Returns a temporary download URL that expires after 1 hour.
     * The archive itself is stored temporarily and auto-deleted after 7 days.
     * For single files, consider using filesGenerateFileAccessURL instead.
     */
    filesCreateZipArchive?: (ArchiveDownloadPayloadGenqlSelection & { __args: {archiveName: Scalars['String'], fileIds: Scalars['ID'][]} })
    filesDeleteFile?: (DeleteFilePayloadGenqlSelection & { __args: {fileID: Scalars['ID']} })
    filesDeleteFiles?: (DeleteFilesPayloadGenqlSelection & { __args: {fileIDs: Scalars['ID'][]} })
    filesGenerateFileAccessURL?: (GenerateFileAccessURLPayloadGenqlSelection & { __args: {expirySeconds?: (Scalars['Int'] | null), fileIds: Scalars['ID'][]} })
    filesGenerateWOPIToken?: (GenerateWOPITokenPayloadGenqlSelection & { __args: {input: GenerateWOPITokenInput} })
    filesMoveFile?: (MoveFilePayloadGenqlSelection & { __args: {input: MoveFileInput} })
    filesRemoveFileFromTemplate?: (RemoveFileFromTemplatePayloadGenqlSelection & { __args: {fileId: Scalars['ID']} })
    filesRenameFile?: (FileGenqlSelection & { __args: {fileID: Scalars['ID'], newName: Scalars['String']} })
    filesSetFileAsTemplate?: (SetFileAsTemplatePayloadGenqlSelection & { __args: {input: SetFileAsTemplateInput} })
    filesSetTemplateAsDefault?: (SetTemplateAsDefaultPayloadGenqlSelection & { __args: {templateId: Scalars['ID']} })
    filesShareFile?: (ShareFilePayloadGenqlSelection & { __args: {input: ShareFileInput} })
    filesStartWOPIEditingSession?: (StartWOPIEditingSessionPayloadGenqlSelection & { __args: {input: StartWOPIEditingSessionInput} })
    filesUnshareFile?: (UnshareFilePayloadGenqlSelection & { __args: {input: UnshareFileInput} })
    filesUpdateFileMetadata?: (FileGenqlSelection & { __args: {fileID: Scalars['ID'], input: UpdateFileMetadataInput} })
    financeAccountBankDetailCreate?: (AccountBankDetailGenqlSelection & { __args: {input: AccountBankDetailInput} })
    financeAccountBankDetailDelete?: { __args: {id: Scalars['ID']} }
    financeAccountBankDetailUpdate?: (AccountBankDetailGenqlSelection & { __args: {id: Scalars['ID'], input: AccountBankDetailUpdateInput} })
    financeAdvanceApply?: (PaymentGenqlSelection & { __args: {input: ApplyAdvanceInput} })
    financeAdvanceRemoveApplication?: (PaymentGenqlSelection & { __args: {input: RemoveAdvanceApplicationInput} })
    financeBillCreate?: (BillGenqlSelection & { __args: {input: CreateBillInput} })
    financeBillMarkAsPaid?: (BillGenqlSelection & { __args: {id: Scalars['ID']} })
    financeBillUpdate?: (BillGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateBillInput} })
    financeBillVoid?: (BillGenqlSelection & { __args: {id: Scalars['ID']} })
    financeCheckTemplateCreate?: (CheckTemplateGenqlSelection & { __args: {input: CheckTemplateInput} })
    financeCheckTemplateDelete?: { __args: {id: Scalars['ID']} }
    financeCheckTemplateUpdate?: (CheckTemplateGenqlSelection & { __args: {id: Scalars['ID'], input: CheckTemplateUpdateInput} })
    financeFacilityAtmCreate?: (FacilityAtmGenqlSelection & { __args: {input: FacilityAtmInput} })
    financeFacilityAtmDelete?: { __args: {id: Scalars['ID']} }
    financeFacilityAtmUpdate?: (FacilityAtmGenqlSelection & { __args: {id: Scalars['ID'], input: FacilityAtmUpdateInput} })
    financeFinancialAccountAdjustmentCreate?: (FinancialAccountAdjustmentGenqlSelection & { __args: {input: FinancialAccountAdjustmentInput} })
    financeFinancialAccountAdjustmentDelete?: { __args: {id: Scalars['ID']} }
    financeFinancialAccountAdjustmentUpdate?: (FinancialAccountAdjustmentGenqlSelection & { __args: {id: Scalars['ID'], input: FinancialAccountAdjustmentUpdateInput} })
    financeFinancialAccountCreate?: (FinancialAccountGenqlSelection & { __args: {input: CreateFinancialAccountInput} })
    financeFinancialAccountDisable?: (FinancialAccountGenqlSelection & { __args: {id: Scalars['ID']} })
    financeFinancialAccountSync?: { __args: {facilityMappings?: (PlaidAccountFacilityMapping[] | null)} } | boolean | number
    financeFinancialAccountSyncTransactions?: boolean | number
    financeFinancialAccountTransactionCreate?: (FinancialAccountTransactionGenqlSelection & { __args: {input: CreateFinancialAccountTransactionInput} })
    financeFinancialAccountTransactionUpdate?: (FinancialAccountTransactionGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateFinancialAccountTransactionInput} })
    financeFinancialAccountUpdate?: (FinancialAccountGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateFinancialAccountInput} })
    financeGenerateCheckPdf?: (GenerateCheckPdfPayloadGenqlSelection & { __args: {paymentIds: Scalars['ID'][]} })
    financeGenerateNachaFile?: (GenerateNachaFilePayloadGenqlSelection & { __args: {input: GenerateNachaFileInput} })
    financeInvoiceCreate?: (InvoiceGenqlSelection & { __args: {input: CreateInvoiceInput} })
    financeInvoiceMarkAsPaid?: (InvoiceGenqlSelection & { __args: {id: Scalars['ID']} })
    financeInvoiceUpdate?: (InvoiceGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateInvoiceInput} })
    financeInvoiceVoid?: (InvoiceGenqlSelection & { __args: {id: Scalars['ID']} })
    financeInvoiceWriteOff?: (PaymentGenqlSelection & { __args: {input: WriteOffInvoiceInput} })
    financeNetPay?: (NetPayResultGenqlSelection & { __args: {input: NetPayForAccountInput} })
    financeNextBillDocumentNumber?: boolean | number
    financeNextInvoiceDocumentNumber?: boolean | number
    financeNextPaymentDocumentNumber?: boolean | number
    financePayBill?: (PayBillResultGenqlSelection & { __args: {input: PayBillInput} })
    /** Apply a payment to a bill (for any payment type, not just advances) */
    financePaymentApplyToBill?: (PaymentGenqlSelection & { __args: {input: ApplyPaymentToBillInput} })
    /** Apply a payment to an invoice (for any payment type, not just advances) */
    financePaymentApplyToInvoice?: (PaymentGenqlSelection & { __args: {input: ApplyPaymentToInvoiceInput} })
    financePaymentCreate?: (PaymentGenqlSelection & { __args: {input: CreatePaymentInput} })
    financePaymentPost?: (PaymentGenqlSelection & { __args: {id: Scalars['ID']} })
    /** Remove a payment application from a bill */
    financePaymentRemoveFromBill?: (PaymentGenqlSelection & { __args: {billId: Scalars['ID'], paymentId: Scalars['ID']} })
    /** Remove a payment application from an invoice */
    financePaymentRemoveFromInvoice?: (PaymentGenqlSelection & { __args: {invoiceId: Scalars['ID'], paymentId: Scalars['ID']} })
    financePaymentTermConfigCreate?: (PaymentTermConfigGenqlSelection & { __args: {input: PaymentTermConfigInput} })
    financePaymentTermConfigDelete?: { __args: {id: Scalars['ID']} }
    financePaymentTermConfigUpdate?: (PaymentTermConfigGenqlSelection & { __args: {id: Scalars['ID'], input: PaymentTermConfigUpdateInput} })
    financePaymentUpdate?: (PaymentGenqlSelection & { __args: {id: Scalars['ID'], input: UpdatePaymentInput} })
    financePaymentVoid?: (PaymentGenqlSelection & { __args: {id: Scalars['ID']} })
    financePaymentsConfirm?: (BulkPaymentResultGenqlSelection & { __args: {input: ConfirmPaymentsInput} })
    financePaymentsUnconfirm?: (BulkPaymentResultGenqlSelection & { __args: {input: UnconfirmPaymentsInput} })
    financePositivePayTemplateCreate?: (PositivePayTemplateGenqlSelection & { __args: {input: PositivePayTemplateInput} })
    financePositivePayTemplateDelete?: { __args: {id: Scalars['ID']} }
    financePositivePayTemplateUpdate?: (PositivePayTemplateGenqlSelection & { __args: {id: Scalars['ID'], input: PositivePayTemplateUpdateInput} })
    financeReceiveInvoice?: (ReceiveInvoiceResultGenqlSelection & { __args: {input: ReceiveInvoiceInput} })
    financeReconcileCashDrawer?: (ReconcileCashDrawerPayloadGenqlSelection & { __args: {input: ReconcileCashDrawerInput} })
    financeVoucherTemplateCreate?: (VoucherTemplateGenqlSelection & { __args: {input: VoucherTemplateInput} })
    financeVoucherTemplateDelete?: { __args: {id: Scalars['ID']} }
    financeVoucherTemplateUpdate?: (VoucherTemplateGenqlSelection & { __args: {id: Scalars['ID'], input: VoucherTemplateUpdateInput} })
    integrationsPlaidCreateLinkToken?: PlaidLinkTokenGenqlSelection
    integrationsPlaidExchangePublicToken?: (PlaidExchangeTokenResponseGenqlSelection & { __args: {publicToken: Scalars['String']} })
    integrationsSemaphorGenerateToken?: SemaphorTokenGenqlSelection
    integrationsWarehouseCredentialCreate?: (WarehouseCredentialGenqlSelection & { __args: {input: CreateWarehouseCredentialInput, password: Scalars['String']} })
    integrationsWarehouseCredentialDelete?: { __args: {id: Scalars['ID']} }
    integrationsWarehouseCredentialUpdate?: (WarehouseCredentialGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateWarehouseCredentialInput, password?: (Scalars['String'] | null)} })
    inventoryCategoryCreate?: (CategoryGenqlSelection & { __args: {input: CategoryInput} })
    inventoryCategoryDelete?: { __args: {id: Scalars['ID']} }
    inventoryCategoryUpdate?: (CategoryGenqlSelection & { __args: {id: Scalars['ID'], input: CategoryUpdateInput} })
    inventoryCycleCountScheduleActivate?: (CycleCountScheduleGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountScheduleCreate?: (CycleCountScheduleGenqlSelection & { __args: {input: CycleCountScheduleInput} })
    inventoryCycleCountScheduleDeactivate?: (CycleCountScheduleGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountScheduleDelete?: { __args: {id: Scalars['ID']} }
    inventoryCycleCountScheduleUpdate?: (CycleCountScheduleGenqlSelection & { __args: {id: Scalars['ID'], input: CycleCountScheduleUpdateInput} })
    inventoryCycleCountTaskApprove?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountTaskCancel?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID'], reason?: (Scalars['String'] | null)} })
    inventoryCycleCountTaskComplete?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountTaskCreate?: (CycleCountTaskGenqlSelection & { __args: {input: CycleCountTaskInput} })
    inventoryCycleCountTaskDelete?: { __args: {id: Scalars['ID']} }
    inventoryCycleCountTaskFreeze?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountTaskReopen?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountTaskStart?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountTaskUnfreeze?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryCycleCountTaskUpdate?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID'], input: CycleCountTaskUpdateInput} })
    inventoryFacilitySettingsUpdate?: (InventoryFacilitySettingsGenqlSelection & { __args: {facilityId: Scalars['ID'], input: InventoryFacilitySettingsUpdateInput} })
    inventoryInventoryAccountProvisionFacilityAccounts?: (ProvisionFacilityAccountsResultGenqlSelection & { __args: {facilityId: Scalars['ID']} })
    inventoryInventoryPeriodArchive?: (InventoryPeriodGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryInventoryPeriodConfigCreate?: (InventoryPeriodConfigGenqlSelection & { __args: {input: InventoryPeriodConfigInput} })
    inventoryInventoryPeriodConfigUpdate?: (InventoryPeriodConfigGenqlSelection & { __args: {id: Scalars['ID'], input: InventoryPeriodConfigUpdateInput} })
    inventoryInventoryPeriodCreate?: (InventoryPeriodGenqlSelection & { __args: {input: InventoryPeriodInput} })
    inventoryInventoryPeriodDelete?: { __args: {id: Scalars['ID']} }
    inventoryInventoryPeriodLock?: (InventoryPeriodGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryInventoryPeriodUnlock?: (InventoryPeriodGenqlSelection & { __args: {expiresAt?: (Scalars['ZonedDateTime'] | null), id: Scalars['ID'], reason: Scalars['String']} })
    inventoryInventoryPeriodUpdate?: (InventoryPeriodGenqlSelection & { __args: {id: Scalars['ID'], input: InventoryPeriodUpdateInput} })
    inventoryInventoryTagCreate?: (InventoryTagGenqlSelection & { __args: {input: InventoryTagInput} })
    inventoryInventoryTagDelete?: { __args: {id: Scalars['ID']} }
    inventoryInventoryTagUpdate?: (InventoryTagGenqlSelection & { __args: {id: Scalars['ID'], input: InventoryTagUpdateInput} })
    inventoryInventoryZoneArchive?: (InventoryZoneGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryInventoryZoneClose?: (InventoryZoneGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryInventoryZoneCreate?: (InventoryZoneGenqlSelection & { __args: {input: InventoryZoneInput} })
    inventoryInventoryZoneDelete?: { __args: {id: Scalars['ID']} }
    inventoryInventoryZoneUpdate?: (InventoryZoneGenqlSelection & { __args: {id: Scalars['ID'], input: InventoryZoneUpdateInput} })
    inventoryItemCreate?: (ItemGenqlSelection & { __args: {input: ItemInput} })
    inventoryItemDelete?: { __args: {id: Scalars['ID']} }
    inventoryItemGroupCreate?: (ItemGroupGenqlSelection & { __args: {input: ItemGroupInput} })
    inventoryItemGroupDelete?: { __args: {id: Scalars['ID']} }
    inventoryItemGroupUpdate?: (ItemGroupGenqlSelection & { __args: {id: Scalars['ID'], input: ItemGroupUpdateInput} })
    inventoryItemUpdate?: (ItemGenqlSelection & { __args: {id: Scalars['ID'], input: ItemUpdateInput} })
    inventoryLotAllocate?: (InventoryLotAllocateResultGenqlSelection & { __args: {input: InventoryLotAllocateInput} })
    inventoryLotCreate?: (InventoryLotGenqlSelection & { __args: {input: InventoryLotCreateInput} })
    inventoryLotCreateFromMovements?: (InventoryLotCreateFromMovementsResultGenqlSelection & { __args: {input: InventoryLotCreateFromMovementsInput} })
    inventoryLotDeallocate?: { __args: {input: InventoryLotDeallocateInput} }
    inventoryLotMerge?: (InventoryLotMergeResultGenqlSelection & { __args: {input: InventoryLotMergeInput} })
    inventoryLotSplit?: (InventoryLotSplitResultGenqlSelection & { __args: {input: InventoryLotSplitInput} })
    inventoryLotUpdate?: (InventoryLotGenqlSelection & { __args: {id: Scalars['ID'], input: InventoryLotUpdateInput} })
    inventoryTagAllocate?: (InventoryTagAllocateResultGenqlSelection & { __args: {input: InventoryTagAllocateInput} })
    inventoryTagDeallocate?: { __args: {input: InventoryTagDeallocateInput} }
    inventoryTagNumberFormatUpdate?: { __args: {format: Scalars['String']} }
    inventoryTagNumberReset?: { __args: {nextNumber: Scalars['Int']} }
    inventoryTagUntag?: (InventoryTagGenqlSelection & { __args: {input: UntagInventoryTagInput} })
    iotCameraCreate?: (CameraGenqlSelection & { __args: {input: CreateCameraInput} })
    iotCameraDelete?: { __args: {id: Scalars['ID']} }
    iotCameraSetCredentials?: (CameraGenqlSelection & { __args: {id: Scalars['ID'], password: Scalars['String'], username: Scalars['String']} })
    iotCameraUpdate?: (CameraGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateCameraInput} })
    iotPrinterCreate?: (PrinterGenqlSelection & { __args: {input: CreatePrinterInput} })
    iotPrinterDelete?: { __args: {id: Scalars['ID']} }
    iotPrinterUpdate?: (PrinterGenqlSelection & { __args: {id: Scalars['ID'], input: UpdatePrinterInput} })
    iotScaleCreate?: (ScaleGenqlSelection & { __args: {input: CreateScaleInput} })
    iotScaleDelete?: { __args: {id: Scalars['ID']} }
    iotScaleUpdate?: (ScaleGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateScaleInput} })
    iotScannerCreate?: (ScannerGenqlSelection & { __args: {input: CreateScannerInput} })
    iotScannerDelete?: { __args: {id: Scalars['ID']} }
    iotScannerUpdate?: (ScannerGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateScannerInput} })
    iotSidecarAssignFacility?: (SidecarGenqlSelection & { __args: {facilityId: Scalars['ID'], id: Scalars['ID']} })
    iotSidecarCreate?: (SidecarGenqlSelection & { __args: {input: CreateSidecarInput} })
    iotSidecarDelete?: { __args: {id: Scalars['ID']} }
    iotSidecarRegister?: (SidecarGenqlSelection & { __args: {facilityId: Scalars['ID'], name?: (Scalars['String'] | null), operatingSystem?: (SidecarOperatingSystem | null), operatingSystemVersion?: (Scalars['String'] | null), publicKey: Scalars['String'], sidecarId: Scalars['ID']} })
    iotSidecarTriggerUpdateCheck?: { __args: {id: Scalars['ID']} }
    iotSidecarUpdate?: (SidecarGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateSidecarInput} })
    notificationArchive?: { __args: {ids: Scalars['ID'][]} }
    notificationDeviceRegister?: (NotificationDeviceGenqlSelection & { __args: {input: NotificationDeviceRegisterInput} })
    notificationMarkAllAsRead?: { __args: {channel?: (Scalars['String'] | null)} } | boolean | number
    notificationMarkAsRead?: { __args: {ids: Scalars['ID'][]} }
    notificationMarkAsSeen?: { __args: {ids: Scalars['ID'][]} }
    notificationPreferencesUpdate?: (NotificationPreferenceGenqlSelection & { __args: {input: NotificationPreferenceBulkInput[]} })
    presenceAnnounce?: { __args: {metadata: Scalars['Map'], room: Scalars['String'], sessionId?: (Scalars['String'] | null)} }
    pricingCounterpartyGroupAddAccounts?: { __args: {accountIds: Scalars['ID'][], groupId: Scalars['ID']} }
    pricingCounterpartyGroupBulkDelete?: { __args: {ids: Scalars['ID'][]} }
    pricingCounterpartyGroupCreate?: (CounterpartyGroupGenqlSelection & { __args: {input: CounterpartyGroupInput} })
    pricingCounterpartyGroupDelete?: { __args: {id: Scalars['ID']} }
    pricingCounterpartyGroupRemoveAccounts?: { __args: {accountIds: Scalars['ID'][], groupId: Scalars['ID']} }
    pricingCounterpartyGroupUpdate?: (CounterpartyGroupGenqlSelection & { __args: {id: Scalars['ID'], input: CounterpartyGroupUpdateInput} })
    pricingCustomPriceListAddItemPricing?: (ItemPricingGenqlSelection & { __args: {customPriceListId: Scalars['ID'], input: ItemPricingInput} })
    pricingCustomPriceListArchive?: { __args: {id: Scalars['ID']} }
    pricingCustomPriceListBatchUpdateItemPricings?: (ItemPricingGenqlSelection & { __args: {customPriceListId: Scalars['ID'], items: BatchItemPricingUpdateItem[]} })
    pricingCustomPriceListCopyFrom?: (ItemPricingGenqlSelection & { __args: {sourceCustomPriceListId?: (Scalars['ID'] | null), sourceDefaultPriceListId?: (Scalars['ID'] | null), targetCustomPriceListId: Scalars['ID']} })
    pricingCustomPriceListDelete?: { __args: {id: Scalars['ID']} }
    pricingCustomPriceListDeleteItemPricing?: { __args: {itemPricingId: Scalars['ID']} }
    pricingCustomPriceListDraft?: (CustomPriceListGenqlSelection & { __args: {input: CustomPriceListDraftInput} })
    pricingCustomPriceListDuplicate?: (CustomPriceListGenqlSelection & { __args: {id: Scalars['ID'], name?: (Scalars['String'] | null)} })
    pricingCustomPriceListImportFrom?: (ItemPricingGenqlSelection & { __args: {itemPricingIds: Scalars['ID'][], targetCustomPriceListId: Scalars['ID']} })
    pricingCustomPriceListPublish?: (CustomPriceListGenqlSelection & { __args: {id: Scalars['ID']} })
    pricingCustomPriceListReorderItemPricings?: { __args: {customPriceListId: Scalars['ID'], itemPricingIds: Scalars['ID'][]} }
    pricingCustomPriceListUnarchive?: { __args: {id: Scalars['ID']} }
    pricingCustomPriceListUpdate?: (CustomPriceListGenqlSelection & { __args: {id: Scalars['ID'], input: CustomPriceListUpdateInput} })
    pricingCustomPriceListUpdateItemPricing?: (ItemPricingGenqlSelection & { __args: {input: ItemPricingUpdateInput, itemPricingId: Scalars['ID']} })
    pricingDefaultPriceListAddItemPricing?: (ItemPricingGenqlSelection & { __args: {input: ItemPricingInput, priceListId: Scalars['ID']} })
    pricingDefaultPriceListBatchUpdateItemPricings?: (ItemPricingGenqlSelection & { __args: {items: BatchItemPricingUpdateItem[], priceListId: Scalars['ID']} })
    pricingDefaultPriceListCopyFrom?: (ItemPricingGenqlSelection & { __args: {sourceCustomPriceListId?: (Scalars['ID'] | null), sourceDefaultPriceListId?: (Scalars['ID'] | null), targetDefaultPriceListId: Scalars['ID']} })
    pricingDefaultPriceListDeleteItemPricing?: { __args: {itemPricingId: Scalars['ID']} }
    pricingDefaultPriceListGetOrCreate?: (DefaultPriceListGenqlSelection & { __args: {currency: Scalars['String'], facilityId: Scalars['ID'], operationType: OperationType} })
    pricingDefaultPriceListImportFrom?: (ItemPricingGenqlSelection & { __args: {itemPricingIds: Scalars['ID'][], targetDefaultPriceListId: Scalars['ID']} })
    pricingDefaultPriceListReorderItemPricings?: { __args: {itemPricingIds: Scalars['ID'][], priceListId: Scalars['ID']} }
    pricingDefaultPriceListUpdate?: (DefaultPriceListGenqlSelection & { __args: {id: Scalars['ID'], input: DefaultPriceListUpdateInput} })
    pricingDefaultPriceListUpdateItemPricing?: (ItemPricingGenqlSelection & { __args: {input: ItemPricingUpdateInput, itemPricingId: Scalars['ID']} })
    pricingDefaultPriceListUpdateNotes?: (DefaultPriceListGenqlSelection & { __args: {notes?: (Scalars['String'] | null), priceListId: Scalars['ID']} })
    pricingGeneratePriceListDocument?: (GeneratePriceListDocumentResultGenqlSelection & { __args: {input: GeneratePriceListDocumentInput} })
    pricingItemPriceConfigurationSet?: (ItemPriceConfigurationGenqlSelection & { __args: {input: ItemPriceConfigurationInput} })
    pricingItemPriceConfigurationUpdate?: (ItemPriceConfigurationGenqlSelection & { __args: {id: Scalars['ID'], input: ItemPriceConfigurationUpdateInput} })
    pricingNotifyPriceList?: (SendPriceListNotificationResultGenqlSelection & { __args: {input: SendPriceListNotificationInput} })
    pricingVariableCreate?: (VariableGenqlSelection & { __args: {input: VariableInput} })
    pricingVariableDelete?: { __args: {id: Scalars['ID']} }
    pricingVariableUpdate?: (VariableUpdateResultGenqlSelection & { __args: {effectiveAt?: (Scalars['ZonedDateTime'] | null), id: Scalars['ID'], input: VariableUpdateInput} })
    productionInboundTollingAgreementCreate?: (InboundTollingAgreementGenqlSelection & { __args: {input: InboundTollingAgreementInput} })
    productionInboundTollingAgreementDelete?: { __args: {id: Scalars['ID']} }
    productionInboundTollingAgreementUpdate?: (InboundTollingAgreementGenqlSelection & { __args: {id: Scalars['ID'], input: InboundTollingAgreementUpdateInput} })
    productionOutboundTollingAgreementCreate?: (OutboundTollingAgreementGenqlSelection & { __args: {input: OutboundTollingAgreementInput} })
    productionOutboundTollingAgreementDelete?: { __args: {id: Scalars['ID']} }
    productionOutboundTollingAgreementUpdate?: (OutboundTollingAgreementGenqlSelection & { __args: {id: Scalars['ID'], input: OutboundTollingAgreementUpdateInput} })
    productionProcessingTypeCreate?: (ProcessingTypeGenqlSelection & { __args: {input: ProcessingTypeInput} })
    productionProcessingTypeDelete?: { __args: {id: Scalars['ID']} }
    productionProcessingTypeUpdate?: (ProcessingTypeGenqlSelection & { __args: {id: Scalars['ID'], input: ProcessingTypeUpdateInput} })
    productionTollReceiptCreate?: (TollReceiptGenqlSelection & { __args: {input: TollReceiptInput} })
    productionTollReceiptUpdate?: (TollReceiptGenqlSelection & { __args: {id: Scalars['ID'], input: TollReceiptUpdateInput} })
    productionTollShipmentCreate?: (TollShipmentGenqlSelection & { __args: {input: TollShipmentInput} })
    productionTollShipmentUpdate?: (TollShipmentGenqlSelection & { __args: {id: Scalars['ID'], input: TollShipmentUpdateInput} })
    productionWorkOrderAllocateCosts?: (WorkOrderGenqlSelection & { __args: {workOrderId: Scalars['ID']} })
    productionWorkOrderCalculateQuantities?: (WorkOrderGenqlSelection & { __args: {input: CalculateWorkOrderQuantitiesInput} })
    productionWorkOrderCancel?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID'], reason?: (Scalars['String'] | null)} })
    productionWorkOrderComplete?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    productionWorkOrderCompleteWithActuals?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID'], input: CompleteWorkOrderWithActualsInput} })
    productionWorkOrderCreate?: (WorkOrderGenqlSelection & { __args: {input: WorkOrderInput} })
    productionWorkOrderDelete?: { __args: {id: Scalars['ID']} }
    productionWorkOrderOpen?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    productionWorkOrderStart?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    productionWorkOrderUpdate?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID'], input: WorkOrderUpdateInput} })
    setDefaultPhotoRequirements?: (DefaultPhotoRequirementGenqlSelection & { __args: {photoRequirements: DefaultPhotoRequirementInput[]} })
    tradeBookingBulkVoid?: (BulkVoidBookingResultGenqlSelection & { __args: {input: BulkVoidBookingInput} })
    tradeBookingComplete?: (BookingGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeBookingCreate?: (BookingGenqlSelection & { __args: {input: BookingInput} })
    tradeBookingCreateDraft?: (BookingGenqlSelection & { __args: {input: DraftBookingInput} })
    tradeBookingDelete?: (DeleteResultGenqlSelection & { __args: {forceUnlink?: (Scalars['Boolean'] | null), id: Scalars['ID']} })
    tradeBookingFileCreate?: (BookingFileCreatePayloadGenqlSelection & { __args: {bookingId: Scalars['ID'], input: BookingFileInput} })
    tradeBookingLoadsReceive?: (LoadGenqlSelection & { __args: {bookingId: Scalars['ID']} })
    tradeBookingLoadsReconcile?: (LoadGenqlSelection & { __args: {bookingId: Scalars['ID']} })
    tradeBookingNextDocumentNumber?: { __args: {facilityId: Scalars['ID']} }
    tradeBookingOpen?: (BookingGenqlSelection & { __args: {id: Scalars['ID']} })
    /**
     * Delete a booking-salesorder relationship. Only allowed if no loads reference this combination.
     * Returns true if deleted successfully.
     */
    tradeBookingSalesOrderDelete?: { __args: {bookingId: Scalars['ID'], salesOrderId: Scalars['ID']} }
    tradeBookingShip?: (BookingGenqlSelection & { __args: {input: TradeBookingShipInput} })
    tradeBookingUpdate?: (BookingUpdateResultGenqlSelection & { __args: {forceUnlink?: (Scalars['Boolean'] | null), id: Scalars['ID'], input: BookingUpdateInput} })
    tradeBookingUpdateDraft?: (BookingGenqlSelection & { __args: {id: Scalars['ID'], input: DraftBookingUpdateInput} })
    tradeBookingVoid?: (VoidBookingResultGenqlSelection & { __args: {forceUnlink?: (Scalars['Boolean'] | null), id: Scalars['ID']} })
    tradeBrokeredOrderClose?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeBrokeredOrderCreate?: (BrokeredOrderGenqlSelection & { __args: {input: BrokeredOrderInput} })
    tradeBrokeredOrderDelete?: { __args: {id: Scalars['ID']} }
    tradeBrokeredOrderFulfill?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeBrokeredOrderInProgress?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeBrokeredOrderLinkOrders?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID'], input: LinkBrokeredOrdersInput} })
    tradeBrokeredOrderOpen?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeBrokeredOrderUpdate?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID'], input: BrokeredOrderUpdateInput} })
    tradeBrokeredOrderVoid?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeComplianceCheckOverride?: (ComplianceCheckGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceCheckOverrideInput} })
    tradeComplianceCheckUpdate?: (ComplianceCheckGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceCheckUpdateInput} })
    tradeComplianceHoldExtend?: (ComplianceHoldGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceHoldExtendInput} })
    tradeComplianceHoldFlagPolice?: (ComplianceHoldGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceHoldFlagPoliceInput} })
    tradeComplianceHoldRelease?: (ComplianceHoldGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceHoldReleaseInput} })
    tradeComplianceHoldUpdate?: (ComplianceHoldGenqlSelection & { __args: {id: Scalars['ID'], input: ComplianceHoldUpdateInput} })
    tradeContainerArriveAtFacility?: (ContainerGenqlSelection & { __args: {containerNumber?: (Scalars['String'] | null), facilityId: Scalars['ID'], id: Scalars['ID']} })
    tradeContainerBatchCreate?: (ContainerGenqlSelection & { __args: {input: ContainerBatchCreateInput} })
    tradeContainerCreate?: (ContainerGenqlSelection & { __args: {input: ContainerInput} })
    tradeContainerDelete?: { __args: {id: Scalars['ID']} }
    tradeContainerDepartFacility?: (ContainerGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeContainerLoad?: (ContainerGenqlSelection & { __args: {id: Scalars['ID'], loadId: Scalars['ID'], sealNumber?: (Scalars['String'] | null)} })
    tradeContainerPickup?: (ContainerGenqlSelection & { __args: {containerNumber?: (Scalars['String'] | null), id: Scalars['ID']} })
    tradeContainerReturnToPort?: (ContainerGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeContainerRevertStatus?: (ContainerGenqlSelection & { __args: {id: Scalars['ID'], targetStatus: ContainerStatus} })
    tradeContainerRoll?: (ContainerGenqlSelection & { __args: {id: Scalars['ID'], newBookingId: Scalars['ID']} })
    tradeContainerShip?: (ContainerGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeContainerUnload?: (ContainerGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeContainerUpdate?: (ContainerGenqlSelection & { __args: {id: Scalars['ID'], input: ContainerUpdateInput} })
    tradeContainerVoid?: { __args: {id: Scalars['ID']} }
    tradeDeductionTypeCreate?: (DeductionTypeGenqlSelection & { __args: {input: DeductionTypeInput} })
    tradeDeductionTypeDelete?: { __args: {id: Scalars['ID']} }
    tradeDeductionTypeUpdate?: (DeductionTypeGenqlSelection & { __args: {id: Scalars['ID'], input: DeductionTypeUpdateInput} })
    tradeFileConfirmUpload?: (FileGenqlSelection & { __args: {fileId: Scalars['ID']} })
    tradeFileDelete?: { __args: {fileId: Scalars['ID']} }
    tradeFileGenerateDownloadUrl?: { __args: {expirySeconds?: (Scalars['Int'] | null), fileId: Scalars['ID']} }
    tradeGenerateDocument?: (GenerateDocumentResultGenqlSelection & { __args: {input: GenerateDocumentInput} })
    tradeGenerateDocumentsAndSendEmail?: (GenerateDocumentsAndSendEmailResultGenqlSelection & { __args: {input: GenerateDocumentsAndSendEmailInput} })
    tradeItemAliasCreate?: (ItemAliasGenqlSelection & { __args: {input: ItemAliasInput} })
    tradeItemAliasDelete?: (DeleteResultGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeItemAliasUpdate?: (ItemAliasGenqlSelection & { __args: {id: Scalars['ID'], input: ItemAliasUpdateInput} })
    tradeLoadAssign?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadBulkVoid?: (BulkVoidLoadResultGenqlSelection & { __args: {input: BulkVoidLoadInput} })
    tradeLoadContainerAtFacility?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadContainerAtPort?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadContainerInTransit?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadContainerLoaded?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadContainerReadyToShip?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadContainerReturning?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeLoadCreate?: (LoadGenqlSelection & { __args: {input: LoadInput} })
    tradeLoadCustomerFileCreate?: (LoadCustomerFileCreatePayloadGenqlSelection & { __args: {input: LoadCustomerFileInput, loadId: Scalars['ID']} })
    tradeLoadDeductionCreate?: (LoadDeductionGenqlSelection & { __args: {input: CreateLoadDeductionInput} })
    tradeLoadDeductionDelete?: { __args: {id: Scalars['ID']} }
    tradeLoadDeductionUpdate?: (LoadDeductionGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateLoadDeductionInput} })
    tradeLoadDelete?: { __args: {id: Scalars['ID']} }
    tradeLoadNextDocumentNumber?: boolean | number
    tradeLoadPhotoCreate?: (LoadPhotoCreatePayloadGenqlSelection & { __args: {input: LoadPhotoInput, loadId: Scalars['ID']} })
    tradeLoadPhotoUpdate?: (FileGenqlSelection & { __args: {fileId: Scalars['ID'], input: LoadPhotoUpdateInput} })
    tradeLoadReceive?: (LoadGenqlSelection & { __args: {id: Scalars['ID'], receivedDate?: (Scalars['CalendarDate'] | null), receivedLineItems?: (ReceivedLineItemInput[] | null), reviewed?: (Scalars['Boolean'] | null)} })
    tradeLoadReconcile?: (LoadGenqlSelection & { __args: {id: Scalars['ID'], invoiceId?: (Scalars['ID'] | null), items?: (LoadLineItemReconcileInput[] | null)} })
    tradeLoadReconciliationFileCreate?: (LoadReconciliationFileCreatePayloadGenqlSelection & { __args: {input: LoadReconciliationFileInput, reconciliationId: Scalars['ID']} })
    tradeLoadRecyclerFileCreate?: (LoadRecyclerFileCreatePayloadGenqlSelection & { __args: {input: LoadRecyclerFileInput, loadId: Scalars['ID']} })
    tradeLoadRevertStatus?: (LoadGenqlSelection & { __args: {id: Scalars['ID'], targetStatus: LoadStatus} })
    tradeLoadReview?: (LoadGenqlSelection & { __args: {input: LoadReviewInput} })
    tradeLoadShip?: (LoadGenqlSelection & { __args: {heavyWeight?: (WeightInput | null), id: Scalars['ID'], lightWeight?: (WeightInput | null), shippedDate?: (Scalars['ZonedDateTime'] | null)} })
    tradeLoadUpdate?: (LoadUpdateResultGenqlSelection & { __args: {id: Scalars['ID'], input: LoadUpdateInput} })
    tradeLoadVoid?: { __args: {id: Scalars['ID'], voidReason?: (Scalars['String'] | null)} }
    tradeLocationFreightPricingCreate?: (LocationFreightPricingGenqlSelection & { __args: {input: LocationFreightPricingInput} })
    tradeLocationFreightPricingDelete?: { __args: {id: Scalars['ID']} }
    tradeLocationFreightPricingUpdate?: (LocationFreightPricingGenqlSelection & { __args: {id: Scalars['ID'], input: LocationFreightPricingUpdateInput} })
    tradePurchaseLoadCompleteInventory?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseLoadCompletePrice?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseLoadCreate?: (PurchaseLoadGenqlSelection & { __args: {input: PurchaseLoadInput} })
    tradePurchaseLoadDelete?: { __args: {id: Scalars['ID']} }
    tradePurchaseLoadFileCreate?: (PurchaseLoadFileCreatePayloadGenqlSelection & { __args: {id: Scalars['ID'], input: PurchaseLoadFileInput} })
    tradePurchaseLoadHold?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseLoadPay?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseLoadRelease?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseLoadRevertStatus?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID'], targetStatus: PurchaseLoadStatus} })
    tradePurchaseLoadUpdate?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID'], input: PurchaseLoadUpdateInput} })
    tradePurchaseLoadVoid?: { __args: {id: Scalars['ID'], voidReason?: (Scalars['String'] | null)} }
    tradePurchaseOrderClose?: (PurchaseOrderGenqlSelection & { __args: {id: Scalars['ID'], notes?: (Scalars['String'] | null)} })
    tradePurchaseOrderCreate?: (PurchaseOrderGenqlSelection & { __args: {input: CreatePurchaseOrderInput} })
    tradePurchaseOrderDelete?: { __args: {id: Scalars['ID']} }
    tradePurchaseOrderFileCreate?: (PurchaseOrderFileCreatePayloadGenqlSelection & { __args: {id: Scalars['ID'], input: PurchaseOrderFileInput} })
    tradePurchaseOrderFreightCreate?: (PurchaseOrderFreightGenqlSelection & { __args: {input: PurchaseOrderFreightInput} })
    tradePurchaseOrderFreightDelete?: { __args: {id: Scalars['ID']} }
    tradePurchaseOrderFreightUpdate?: (PurchaseOrderFreightGenqlSelection & { __args: {id: Scalars['ID'], input: PurchaseOrderFreightUpdateInput} })
    tradePurchaseOrderNextDocumentNumber?: boolean | number
    tradePurchaseOrderOpen?: (PurchaseOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseOrderReopen?: (PurchaseOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradePurchaseOrderUpdate?: (PurchaseOrderGenqlSelection & { __args: {id: Scalars['ID'], input: UpdatePurchaseOrderInput} })
    tradePurchaseOrderVoid?: (PurchaseOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeQuoteAccept?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeQuoteClone?: (QuoteGenqlSelection & { __args: {accountIds: Scalars['ID'][], id: Scalars['ID']} })
    tradeQuoteConvert?: (QuoteGenqlSelection & { __args: {id: Scalars['ID'], orderId?: (Scalars['ID'] | null)} })
    tradeQuoteCreate?: (QuoteGenqlSelection & { __args: {input: QuoteInput} })
    tradeQuoteDelete?: { __args: {id: Scalars['ID']} }
    tradeQuoteNextDocumentNumber?: boolean | number
    tradeQuoteReject?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeQuoteRestore?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeQuoteRevertToOpen?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeQuoteSend?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeQuoteUpdate?: (QuoteGenqlSelection & { __args: {id: Scalars['ID'], input: QuoteUpdateInput} })
    tradeQuoteVoid?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeReconciliationBatchUpdate?: (LoadReconciliationGenqlSelection & { __args: {deductions?: (ReconciliationDeductionInput[] | null), externalNotes?: (Scalars['String'] | null), freightCharges?: (FreightChargeInput[] | null), internalNotes?: (Scalars['String'] | null), invoiceId?: (Scalars['ID'] | null), invoiceType?: (Scalars['String'] | null), loadId: Scalars['ID'], loadReceivedDate?: (Scalars['CalendarDate'] | null), millReceivedWeightPostDate?: (Scalars['CalendarDate'] | null), receivedLineItems?: (ReceivedLineItemInput[] | null), ticketIssueDate?: (Scalars['CalendarDate'] | null), ticketNumber?: (Scalars['String'] | null)} })
    tradeSalesOrderBulkVoid?: (BulkVoidSalesOrderResultGenqlSelection & { __args: {input: BulkVoidSalesOrderInput} })
    tradeSalesOrderClone?: (SalesOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeSalesOrderCreate?: (SalesOrderGenqlSelection & { __args: {input: SalesOrderCreateInput} })
    tradeSalesOrderCustomerFileCreate?: (SalesOrderCustomerFileCreatePayloadGenqlSelection & { __args: {input: SalesOrderCustomerFileInput, salesOrderId: Scalars['ID']} })
    tradeSalesOrderDelete?: (DeleteResultGenqlSelection & { __args: {forceUnlink?: (Scalars['Boolean'] | null), id: Scalars['ID']} })
    tradeSalesOrderFileCreate?: (SalesOrderFileCreatePayloadGenqlSelection & { __args: {input: SalesOrderFileInput, salesOrderId: Scalars['ID']} })
    tradeSalesOrderFreightCreate?: (SalesOrderFreightGenqlSelection & { __args: {input: SalesOrderFreightInput} })
    tradeSalesOrderFreightDelete?: { __args: {id: Scalars['ID']} }
    tradeSalesOrderFreightUpdate?: (SalesOrderFreightGenqlSelection & { __args: {id: Scalars['ID'], input: SalesOrderFreightUpdateInput} })
    tradeSalesOrderNextDocumentNumber?: boolean | number
    tradeSalesOrderRecyclerFileCreate?: (SalesOrderRecyclerFileCreatePayloadGenqlSelection & { __args: {input: SalesOrderRecyclerFileInput, salesOrderId: Scalars['ID']} })
    tradeSalesOrderUpdate?: (SalesOrderUpdateResultGenqlSelection & { __args: {forceUnlink?: (Scalars['Boolean'] | null), id: Scalars['ID'], input: SalesOrderUpdateInput} })
    tradeSalesOrderVoid?: (VoidSalesOrderResultGenqlSelection & { __args: {forceUnlink?: (Scalars['Boolean'] | null), id: Scalars['ID']} })
    tradeTicketFreightCreate?: (TicketFreightGenqlSelection & { __args: {input: TicketFreightInput} })
    tradeTicketFreightDelete?: { __args: {id: Scalars['ID']} }
    tradeTicketFreightUpdate?: (TicketFreightGenqlSelection & { __args: {id: Scalars['ID'], input: TicketFreightUpdateInput} })
    transportationAddHaulers?: { __args: {haulerIds: Scalars['ID'][]} }
    transportationAssetCreate?: (AssetGenqlSelection & { __args: {input: CreateAssetInput} })
    transportationAssetDelete?: { __args: {id: Scalars['ID']} }
    transportationAssetLocationHistoryCreate?: (AssetLocationHistoryGenqlSelection & { __args: {input: AssetLocationHistoryInput} })
    transportationAssetLocationHistoryDelete?: { __args: {id: Scalars['ID']} }
    transportationAssetTypeCreate?: (AssetTypeGenqlSelection & { __args: {input: CreateAssetTypeInput} })
    transportationAssetTypeDelete?: { __args: {id: Scalars['ID']} }
    transportationAssetTypeUpdate?: (AssetTypeGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAssetTypeInput} })
    transportationAssetUpdate?: (AssetGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateAssetInput} })
    transportationAssetUpdateFacility?: (AssetGenqlSelection & { __args: {facilityId?: (Scalars['ID'] | null), ids: Scalars['ID'][], movementDate: Scalars['ZonedDateTime'], status: AssetStatus} })
    transportationContainerTypeCreate?: (ContainerTypeGenqlSelection & { __args: {input: CreateContainerTypeInput} })
    transportationContainerTypeDelete?: { __args: {id: Scalars['ID']} }
    transportationContainerTypeUpdate?: (ContainerTypeGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateContainerTypeInput} })
    transportationDetentionCreate?: (DetentionGenqlSelection & { __args: {input: DetentionInput} })
    transportationDetentionDelete?: { __args: {id: Scalars['ID']} }
    transportationDetentionUpdate?: (DetentionGenqlSelection & { __args: {id: Scalars['ID'], input: DetentionUpdateInput} })
    transportationDriverCertificationCreate?: (DriverCertificationGenqlSelection & { __args: {input: CreateDriverCertificationInput} })
    transportationDriverCertificationDelete?: { __args: {id: Scalars['ID']} }
    transportationDriverCertificationUpdate?: (DriverCertificationGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateDriverCertificationInput} })
    transportationDriverCreate?: (DriverGenqlSelection & { __args: {input: CreateDriverInput} })
    transportationDriverDelete?: { __args: {id: Scalars['ID']} }
    transportationDriverUpdate?: (DriverGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateDriverInput} })
    transportationFileConfirmUpload?: (FileGenqlSelection & { __args: {fileId: Scalars['ID']} })
    transportationFileDelete?: { __args: {fileId: Scalars['ID']} }
    transportationFreightForwarderCreate?: (FreightForwarderGenqlSelection & { __args: {input: FreightForwarderInput} })
    transportationFreightForwarderDelete?: { __args: {id: Scalars['ID']} }
    transportationFreightForwarderUpdate?: (FreightForwarderGenqlSelection & { __args: {id: Scalars['ID'], input: FreightForwarderUpdateInput} })
    transportationFreightLaneCostCreate?: (FreightLaneCostGenqlSelection & { __args: {input: FreightLaneCostInput} })
    transportationFreightLaneCostDelete?: { __args: {id: Scalars['ID']} }
    transportationFreightLaneCostUpdate?: (FreightLaneCostGenqlSelection & { __args: {id: Scalars['ID'], input: FreightLaneCostUpdateInput} })
    transportationFreightLaneCreate?: (FreightLaneGenqlSelection & { __args: {input: FreightLaneInput} })
    transportationFreightLaneDelete?: { __args: {id: Scalars['ID']} }
    transportationFreightLaneRouteCreate?: (FreightLaneRouteGenqlSelection & { __args: {input: FreightLaneRouteInput} })
    transportationFreightLaneRouteDelete?: { __args: {id: Scalars['ID']} }
    transportationFreightLaneRouteUpdate?: (FreightLaneRouteGenqlSelection & { __args: {id: Scalars['ID'], input: FreightLaneRouteUpdateInput} })
    transportationFreightLaneUpdate?: (FreightLaneGenqlSelection & { __args: {id: Scalars['ID'], input: FreightLaneUpdateInput} })
    transportationFreightLineCreate?: (FreightLineGenqlSelection & { __args: {input: FreightLineInput} })
    transportationFreightLineDelete?: { __args: {id: Scalars['ID']} }
    transportationFreightLineUpdate?: (FreightLineGenqlSelection & { __args: {id: Scalars['ID'], input: FreightLineUpdateInput} })
    transportationRemoveHaulers?: { __args: {haulerIds: Scalars['ID'][]} }
    transportationRouteAssign?: (RouteGenqlSelection & { __args: {assignmentStatus: AssignmentStatus, driverId?: (Scalars['ID'] | null), estimatedArrival?: (Scalars['ZonedDateTime'] | null), haulerId?: (Scalars['ID'] | null), id: Scalars['ID'], trailerId?: (Scalars['ID'] | null), truckId?: (Scalars['ID'] | null)} })
    transportationRouteCreate?: (RouteGenqlSelection & { __args: {input: CreateRouteInput, isTemplate: Scalars['Boolean'], serviceIds?: (Scalars['ID'][] | null)} })
    transportationRouteDelete?: { __args: {id: Scalars['ID']} }
    transportationRouteFreightCreate?: (RouteFreightGenqlSelection & { __args: {input: RouteFreightInput} })
    transportationRouteFreightDelete?: { __args: {id: Scalars['ID']} }
    transportationRouteFreightUpdate?: (RouteFreightGenqlSelection & { __args: {id: Scalars['ID'], input: RouteFreightUpdateInput} })
    transportationRouteTransition?: (RouteGenqlSelection & { __args: {id: Scalars['ID'], notes?: (Scalars['String'] | null), status: RouteStatus} })
    transportationRouteUnassign?: (RouteGenqlSelection & { __args: {id: Scalars['ID']} })
    transportationRouteUpdate?: (RouteGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateRouteInput, serviceIds?: (Scalars['ID'][] | null)} })
    transportationRouteValidationOverrideCreate?: (RouteValidationOverrideGenqlSelection & { __args: {input: RouteValidationOverrideInput} })
    transportationRouteValidationOverrideDelete?: { __args: {id: Scalars['ID']} }
    transportationRouteValidationOverrideUpdate?: (RouteValidationOverrideGenqlSelection & { __args: {id: Scalars['ID'], input: RouteValidationOverrideUpdateInput} })
    transportationServiceAssign?: (ServiceGenqlSelection & { __args: {input: ServiceAssignInput} })
    transportationServiceCreate?: (ServiceGenqlSelection & { __args: {input: CreateServiceInput} })
    transportationServiceDelete?: { __args: {id: Scalars['ID']} }
    transportationServiceTransition?: (ServiceGenqlSelection & { __args: {input: ServiceTransitionInput} })
    transportationServiceTypeCreateWithDefinitions?: (ServiceTypeGenqlSelection & { __args: {input: CreateServiceTypeWithDefinitionsInput} })
    transportationServiceTypeTaskDefinitionCreate?: (ServiceTypeTaskDefinitionGenqlSelection & { __args: {input: ServiceTypeTaskDefinitionInput} })
    transportationServiceTypeTaskDefinitionDelete?: { __args: {id: Scalars['ID']} }
    transportationServiceTypeTaskDefinitionUpdate?: (ServiceTypeTaskDefinitionGenqlSelection & { __args: {id: Scalars['ID'], input: ServiceTypeTaskDefinitionUpdateInput} })
    transportationServiceTypeUpdate?: (ServiceTypeGenqlSelection & { __args: {id: Scalars['ID'], input: ServiceTypeUpdateInput} })
    transportationServiceUnassign?: (ServiceGenqlSelection & { __args: {id: Scalars['ID']} })
    transportationServiceUpdate?: (ServiceGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateServiceInput} })
    transportationSetDriverDisplayOrder?: (DriverDisplayOrderGenqlSelection & { __args: {driverId: Scalars['ID'], rank: Scalars['String']} })
    transportationShippingCarrierCreate?: (ShippingCarrierGenqlSelection & { __args: {input: ShippingCarrierInput} })
    transportationShippingCarrierDelete?: { __args: {id: Scalars['ID']} }
    transportationShippingCarrierUpdate?: (ShippingCarrierGenqlSelection & { __args: {id: Scalars['ID'], input: ShippingCarrierUpdateInput} })
    transportationTaskCancel?: (TaskGenqlSelection & { __args: {id: Scalars['ID']} })
    transportationTaskPhotoCreate?: (TaskPhotoCreatePayloadGenqlSelection & { __args: {input: TaskPhotoInput, taskId: Scalars['ID']} })
    transportationTaskTransition?: (TaskGenqlSelection & { __args: {id: Scalars['ID'], reason?: (Scalars['String'] | null), status: TaskStatus} })
    transportationTrailerCreate?: (TrailerGenqlSelection & { __args: {input: CreateTrailerInput} })
    transportationTrailerDelete?: { __args: {id: Scalars['ID']} }
    transportationTrailerUpdate?: (TrailerGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateTrailerInput} })
    transportationTransportationTypeCreate?: (TransportationTypeGenqlSelection & { __args: {input: CreateTransportationTypeInput} })
    transportationTransportationTypeDelete?: { __args: {id: Scalars['ID']} }
    transportationTransportationTypeUpdate?: (TransportationTypeGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateTransportationTypeInput} })
    transportationTruckCreate?: (TruckGenqlSelection & { __args: {input: CreateTruckInput} })
    transportationTruckDelete?: { __args: {id: Scalars['ID']} }
    transportationTruckUpdate?: (TruckGenqlSelection & { __args: {id: Scalars['ID'], input: UpdateTruckInput} })
    updateFacilityGeneralPreferences?: (FacilityGeneralPreferencesGenqlSelection & { __args: {input: UpdateFacilityGeneralPreferencesInput} })
    updateFacilitySalesPreferences?: (FacilitySalesPreferencesGenqlSelection & { __args: {input: UpdateFacilitySalesPreferencesInput} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NetPayForAccountInput {accountId: Scalars['ID'],achNumber?: (Scalars['String'] | null),billIds?: (Scalars['ID'][] | null),checkAttn?: (Scalars['String'] | null),checkFacilityId?: (Scalars['ID'] | null),checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),creatorId?: (Scalars['ID'] | null),creatorPlatform?: (CreatorPlatform | null),financialAccountId: Scalars['ID'],invoiceIds?: (Scalars['ID'][] | null),paymentMethod: PaymentMethod,transactionDate: Scalars['CalendarDate'],wireNumber?: (Scalars['String'] | null)}

export interface NetPayResultGenqlSelection{
    belowWarningThreshold?: boolean | number
    netAmount?: MoneyGenqlSelection
    payableTotal?: MoneyGenqlSelection
    payment?: PaymentGenqlSelection
    receivableTotal?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NodeGenqlSelection{
    description?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    on_ApprovalNode?: ApprovalNodeGenqlSelection
    on_BusinessEventTriggerNode?: BusinessEventTriggerNodeGenqlSelection
    on_ConditionNode?: ConditionNodeGenqlSelection
    on_DelayNode?: DelayNodeGenqlSelection
    on_EmailActionNode?: EmailActionNodeGenqlSelection
    on_FilterNode?: FilterNodeGenqlSelection
    on_HttpRequestActionNode?: HttpRequestActionNodeGenqlSelection
    on_HttpWebhookTriggerNode?: HttpWebhookTriggerNodeGenqlSelection
    on_LoopNode?: LoopNodeGenqlSelection
    on_ScheduleTriggerNode?: ScheduleTriggerNodeGenqlSelection
    on_SwitchNode?: SwitchNodeGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NodeExecutionGenqlSelection{
    completedAt?: boolean | number
    durationMs?: boolean | number
    errorMessage?: boolean | number
    input?: boolean | number
    nodeId?: boolean | number
    nodeType?: boolean | number
    output?: boolean | number
    startedAt?: boolean | number
    status?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NodeInput {approvers?: (ApproverConfigInput | null),bcc?: (Scalars['String'] | null),body?: (Scalars['String'] | null),bodyType?: (Scalars['String'] | null),cases?: (SwitchCaseInput[] | null),cc?: (Scalars['String'] | null),continueOnFail?: (Scalars['Boolean'] | null),cronExpression?: (Scalars['String'] | null),defaultLabel?: (Scalars['String'] | null),delayType?: (DelayType | null),description?: (Scalars['String'] | null),duration?: (Scalars['Int'] | null),durationUnit?: (DurationUnit | null),eventType?: (Scalars['String'] | null),expression?: (Scalars['String'] | null),falseBranchLabel?: (Scalars['String'] | null),filter?: (Scalars['Map'] | null),headers?: (Scalars['Map'] | null),id: Scalars['ID'],instructions?: (Scalars['String'] | null),label: Scalars['String'],loopArrayExpression?: (Scalars['String'] | null),loopItemVariableName?: (Scalars['String'] | null),loopMaxIterations?: (Scalars['Int'] | null),method?: (HttpMethod | null),position: PositionInput,replyTo?: (Scalars['String'] | null),requestBody?: (Scalars['String'] | null),retryCount?: (Scalars['Int'] | null),subject?: (Scalars['String'] | null),timeout?: (Scalars['Int'] | null),timeoutAction?: (TimeoutAction | null),timeoutDuration?: (Scalars['Int'] | null),timeoutEnabled?: (Scalars['Boolean'] | null),timeoutUnit?: (TimeoutUnit | null),timezone?: (Scalars['String'] | null),to?: (Scalars['String'] | null),trueBranchLabel?: (Scalars['String'] | null),type: NodeType,untilDateTime?: (Scalars['String'] | null),untilExpression?: (Scalars['String'] | null),url?: (Scalars['String'] | null)}

export interface NotificationGenqlSelection{
    actionLink?: boolean | number
    actorId?: boolean | number
    body?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    eventId?: boolean | number
    id?: boolean | number
    notificationTypeKey?: boolean | number
    resourceId?: boolean | number
    resourceType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    title?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationDeviceGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    deviceToken?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    platform?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationDeviceFilter {ids?: (Scalars['ID'][] | null)}

export interface NotificationDeviceInput {deviceToken: Scalars['String'],isActive: Scalars['Boolean'],platform: Scalars['String'],userId: Scalars['ID']}

export interface NotificationDeviceRegisterInput {deviceToken: Scalars['String'],platform: Scalars['String']}

export interface NotificationDeviceResultPageGenqlSelection{
    entries?: NotificationDeviceGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationDeviceUpdateInput {deviceToken?: (Scalars['String'] | null),isActive?: (Scalars['Boolean'] | null),platform?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null)}

export interface NotificationFeedCursor {afterId: Scalars['ID']}

export interface NotificationFeedEntryGenqlSelection{
    channel?: boolean | number
    id?: boolean | number
    isArchived?: boolean | number
    isRead?: boolean | number
    isSeen?: boolean | number
    notification?: NotificationGenqlSelection
    readAt?: boolean | number
    seenAt?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationFeedPageGenqlSelection{
    entries?: NotificationFeedEntryGenqlSelection
    hasMore?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationFilter {ids?: (Scalars['ID'][] | null)}

export interface NotificationInput {actionLink?: (Scalars['String'] | null),actorId?: (Scalars['ID'] | null),body: Scalars['String'],eventId: Scalars['String'],notificationTypeKey: Scalars['String'],resourceId: Scalars['String'],resourceType: Scalars['String'],title: Scalars['String']}

export interface NotificationPreferenceGenqlSelection{
    channel?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    enabled?: boolean | number
    id?: boolean | number
    notificationTypeKey?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationPreferenceBulkInput {channel: Scalars['String'],enabled: Scalars['Boolean'],notificationTypeKey: Scalars['String']}

export interface NotificationPreferenceFilter {channel?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),notificationTypeKey?: (Scalars['String'] | null)}

export interface NotificationPreferenceInput {channel: Scalars['String'],enabled: Scalars['Boolean'],notificationTypeKey: Scalars['String'],userId: Scalars['ID']}

export interface NotificationPreferenceResultPageGenqlSelection{
    entries?: NotificationPreferenceGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationPreferenceUpdateInput {channel?: (Scalars['String'] | null),enabled?: (Scalars['Boolean'] | null),notificationTypeKey?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null)}

export interface NotificationRecipientGenqlSelection{
    channel?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    isArchived?: boolean | number
    isRead?: boolean | number
    isSeen?: boolean | number
    notificationId?: boolean | number
    readAt?: boolean | number
    recipientId?: boolean | number
    seenAt?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationRecipientFilter {ids?: (Scalars['ID'][] | null)}

export interface NotificationRecipientInput {channel: Scalars['String'],isArchived: Scalars['Boolean'],isRead: Scalars['Boolean'],isSeen: Scalars['Boolean'],notificationId: Scalars['ID'],readAt?: (Scalars['ZonedDateTime'] | null),recipientId: Scalars['ID'],seenAt?: (Scalars['ZonedDateTime'] | null)}

export interface NotificationRecipientResultPageGenqlSelection{
    entries?: NotificationRecipientGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationRecipientUpdateInput {channel?: (Scalars['String'] | null),isArchived?: (Scalars['Boolean'] | null),isRead?: (Scalars['Boolean'] | null),isSeen?: (Scalars['Boolean'] | null),notificationId?: (Scalars['ID'] | null),readAt?: (Scalars['ZonedDateTime'] | null),recipientId?: (Scalars['ID'] | null),seenAt?: (Scalars['ZonedDateTime'] | null)}

export interface NotificationResultPageGenqlSelection{
    entries?: NotificationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationTypeGenqlSelection{
    bodyTemplate?: boolean | number
    category?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    defaultChannels?: boolean | number
    icon?: boolean | number
    id?: boolean | number
    isCritical?: boolean | number
    key?: boolean | number
    requiredPermission?: boolean | number
    timestamps?: TimestampsGenqlSelection
    titleTemplate?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationTypeFilter {category?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),isCritical?: (Scalars['Boolean'] | null),searchTerm?: (Scalars['String'] | null)}

export interface NotificationTypeInput {bodyTemplate: Scalars['String'],category: Scalars['String'],defaultChannels?: (Scalars['Map'] | null),icon?: (Scalars['String'] | null),isCritical: Scalars['Boolean'],key: Scalars['String'],requiredPermission?: (Scalars['String'] | null),titleTemplate: Scalars['String']}

export interface NotificationTypeResultPageGenqlSelection{
    entries?: NotificationTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface NotificationTypeUpdateInput {bodyTemplate?: (Scalars['String'] | null),category?: (Scalars['String'] | null),defaultChannels?: (Scalars['Map'] | null),icon?: (Scalars['String'] | null),isCritical?: (Scalars['Boolean'] | null),key?: (Scalars['String'] | null),requiredPermission?: (Scalars['String'] | null),titleTemplate?: (Scalars['String'] | null)}

export interface NotificationUpdateInput {actionLink?: (Scalars['String'] | null),actorId?: (Scalars['ID'] | null),body?: (Scalars['String'] | null),eventId?: (Scalars['String'] | null),notificationTypeKey?: (Scalars['String'] | null),resourceId?: (Scalars['String'] | null),resourceType?: (Scalars['String'] | null),title?: (Scalars['String'] | null)}


/** Error returned when one-time code has expired */
export interface OneTimeCodeExpiredGenqlSelection{
    pendingAuthenticationToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OperationGenqlSelection{
    description?: boolean | number
    inputSchema?: boolean | number
    key?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrganizationGenqlSelection{
    createdAt?: boolean | number
    customAttributes?: boolean | number
    domain?: boolean | number
    entitlements?: boolean | number
    facilities?: FacilityGenqlSelection
    facilityGroups?: FacilityGroupGenqlSelection
    id?: boolean | number
    idpId?: boolean | number
    name?: boolean | number
    onboardedAt?: boolean | number
    timezone?: boolean | number
    updatedAt?: boolean | number
    users?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrganizationFilter {ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface OrganizationResetResultGenqlSelection{
    newFacilityId?: boolean | number
    newOrganizationId?: boolean | number
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrganizationResultPageGenqlSelection{
    entries?: OrganizationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when the user must select an organization to complete authentication */
export interface OrganizationSelectionErrorGenqlSelection{
    organizations?: AuthenticationOrganizationGenqlSelection
    pendingAuthenticationToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OrphanedBookingSalesOrderLinkGenqlSelection{
    bookingId?: boolean | number
    documentNumber?: boolean | number
    salesOrderId?: boolean | number
    salesOrderNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OutboundTollingAgreementGenqlSelection{
    agreementNumber?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    effectiveDate?: boolean | number
    expectedYieldPercentage?: boolean | number
    expirationDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    pricePerUnit?: MoneyGenqlSelection
    priceUnit?: boolean | number
    processingType?: ProcessingTypeGenqlSelection
    processingTypeId?: boolean | number
    processorAccount?: AccountGenqlSelection
    processorAccountId?: boolean | number
    terms?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OutboundTollingAgreementFilter {agreementNumber?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromEffectiveDate?: (Scalars['CalendarDate'] | null),fromExpirationDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),isActive?: (Scalars['Boolean'] | null),priceUnit?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),processingTypeIds?: (Scalars['ID'][] | null),processorAccountId?: (Scalars['ID'] | null),processorAccountIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),terms?: (Scalars['String'] | null),toEffectiveDate?: (Scalars['CalendarDate'] | null),toExpirationDate?: (Scalars['CalendarDate'] | null)}

export interface OutboundTollingAgreementInput {agreementNumber: Scalars['String'],effectiveDate: Scalars['CalendarDate'],expectedYieldPercentage?: (Scalars['Decimal'] | null),expirationDate?: (Scalars['CalendarDate'] | null),facilityId: Scalars['ID'],isActive: Scalars['Boolean'],pricePerUnit?: (MoneyInput | null),priceUnit?: (Scalars['String'] | null),processingTypeId: Scalars['ID'],processorAccountId: Scalars['ID'],terms?: (Scalars['String'] | null)}

export interface OutboundTollingAgreementResultPageGenqlSelection{
    entries?: OutboundTollingAgreementGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OutboundTollingAgreementUpdateInput {agreementNumber?: (Scalars['String'] | null),effectiveDate?: (Scalars['CalendarDate'] | null),expectedYieldPercentage?: (Scalars['Decimal'] | null),expirationDate?: (Scalars['CalendarDate'] | null),facilityId?: (Scalars['ID'] | null),isActive?: (Scalars['Boolean'] | null),pricePerUnit?: (MoneyInput | null),priceUnit?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),processorAccountId?: (Scalars['ID'] | null),terms?: (Scalars['String'] | null)}

export interface OutboxEventGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    eventName?: boolean | number
    id?: boolean | number
    lastRetry?: boolean | number
    metadata?: OutboxEventMetadataGenqlSelection
    payload?: boolean | number
    retryCount?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    topic?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    version?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OutboxEventMetadataGenqlSelection{
    aggregateId?: boolean | number
    eventName?: boolean | number
    id?: boolean | number
    occurredOn?: boolean | number
    organizationId?: boolean | number
    topic?: boolean | number
    version?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface OutboxEventResultPageGenqlSelection{
    entries?: OutboxEventGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface P2PRelayInfoGenqlSelection{
    multiaddrs?: boolean | number
    peerId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PageGenqlSelection{
    limit?: boolean | number
    offset?: boolean | number
    total?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaginationInput {limit: Scalars['Int'],offset: Scalars['Int']}

export interface PatchScopedSettingValuesInput {objectId: Scalars['ID'],scope: SettingScope,values: Scalars['Any']}

export interface PayBillInput {accountId?: (Scalars['ID'] | null),achNumber?: (Scalars['String'] | null),bills: PayBillItemInput[],checkAttn?: (Scalars['String'] | null),checkFacilityId?: (Scalars['ID'] | null),checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),creatorId?: (Scalars['ID'] | null),creatorPlatform?: (CreatorPlatform | null),financialAccountId: Scalars['ID'],paymentMethod: PaymentMethod,transactionDate: Scalars['CalendarDate'],wireNumber?: (Scalars['String'] | null)}

export interface PayBillItemInput {appliedAmount: MoneyInput,billId: Scalars['ID']}

export interface PayBillResultGenqlSelection{
    belowWarningThreshold?: boolean | number
    payment?: PaymentGenqlSelection
    totalDiscount?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentGenqlSelection{
    account?: AccountGenqlSelection
    achNumber?: boolean | number
    amount?: MoneyGenqlSelection
    atmId?: boolean | number
    atmPaymentNumber?: boolean | number
    barcode?: boolean | number
    barcodeRowId?: boolean | number
    bills?: BillPaymentApplicationGenqlSelection
    checkAttn?: boolean | number
    checkFacilityId?: boolean | number
    checkMemo?: boolean | number
    checkNumber?: boolean | number
    creatorId?: boolean | number
    creatorPlatform?: boolean | number
    documentNumber?: boolean | number
    financialAccount?: FinancialAccountGenqlSelection
    financialAccountId?: boolean | number
    financialAccountTransaction?: FinancialAccountTransactionGenqlSelection
    financialAccountTransactionId?: boolean | number
    id?: boolean | number
    invoices?: InvoicePaymentApplicationGenqlSelection
    paymentMethod?: boolean | number
    paymentType?: boolean | number
    status?: boolean | number
    supplierPhotoId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    transactionDate?: boolean | number
    unappliedAmount?: MoneyGenqlSelection
    wireNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentFilter {accountIDs?: (Scalars['ID'][] | null),
/** Filter by payment currency */
currencyCode?: (CurrencyCode | null),dateRange?: (DateRangeInput | null),
/** Filter by financial account's facility */
facilityIDs?: (Scalars['ID'][] | null),financialAccountIDs?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),
/** Only include payments with unapplied balance >= this value */
minUnappliedBalance?: (Scalars['Decimal'] | null),paymentType?: (PaymentMethod[] | null),searchTerm?: (Scalars['String'] | null),status?: (PaymentStatus[] | null),type?: (PaymentType[] | null)}

export interface PaymentItemResultGenqlSelection{
    error?: boolean | number
    paymentId?: boolean | number
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentResultPageGenqlSelection{
    entries?: PaymentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentTermConfigGenqlSelection{
    code?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    dateDrivenDiscountPercentage?: boolean | number
    discountDueBeforeDayOfMonth?: boolean | number
    discountIfPaidWithinDays?: boolean | number
    discountPercentage?: boolean | number
    id?: boolean | number
    isDateDriven?: boolean | number
    isSystem?: boolean | number
    name?: boolean | number
    netDueBeforeDayOfMonth?: boolean | number
    netDueInDays?: boolean | number
    nextMonthDueIfIssuedWithinDays?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentTermConfigFilter {ids?: (Scalars['ID'][] | null)}

export interface PaymentTermConfigInput {code: Scalars['String'],dateDrivenDiscountPercentage?: (Scalars['Decimal'] | null),discountDueBeforeDayOfMonth?: (Scalars['Int'] | null),discountIfPaidWithinDays?: (Scalars['Int'] | null),discountPercentage?: (Scalars['Decimal'] | null),isDateDriven: Scalars['Boolean'],isSystem: Scalars['Boolean'],name: Scalars['String'],netDueBeforeDayOfMonth?: (Scalars['Int'] | null),netDueInDays?: (Scalars['Int'] | null),nextMonthDueIfIssuedWithinDays?: (Scalars['Int'] | null)}

export interface PaymentTermConfigResultPageGenqlSelection{
    entries?: PaymentTermConfigGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PaymentTermConfigUpdateInput {code?: (Scalars['String'] | null),dateDrivenDiscountPercentage?: (Scalars['Decimal'] | null),discountDueBeforeDayOfMonth?: (Scalars['Int'] | null),discountIfPaidWithinDays?: (Scalars['Int'] | null),discountPercentage?: (Scalars['Decimal'] | null),isDateDriven?: (Scalars['Boolean'] | null),isSystem?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),netDueBeforeDayOfMonth?: (Scalars['Int'] | null),netDueInDays?: (Scalars['Int'] | null),nextMonthDueIfIssuedWithinDays?: (Scalars['Int'] | null)}


/** Base interface for errors that occur when additional authentication steps are required */
export interface PendingAuthenticationErrorGenqlSelection{
    pendingAuthenticationToken?: boolean | number
    on_EmailVerificationRequiredError?: EmailVerificationRequiredErrorGenqlSelection
    on_InvalidOneTimeCode?: InvalidOneTimeCodeGenqlSelection
    on_MfaChallengeError?: MfaChallengeErrorGenqlSelection
    on_MfaEnrollmentRequiredError?: MfaEnrollmentRequiredErrorGenqlSelection
    on_OneTimeCodeExpired?: OneTimeCodeExpiredGenqlSelection
    on_OrganizationSelectionError?: OrganizationSelectionErrorGenqlSelection
    on_SsoRequiredError?: SsoRequiredErrorGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PeriodTrialCloseResultGenqlSelection{
    checklistItems?: TrialCloseChecklistItemGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PermissionGenqlSelection{
    action?: boolean | number
    allowed?: boolean | number
    resource?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PermissionCheckInput {action: Scalars['String'],resource?: (Scalars['String'] | null),resourceId?: (Scalars['ID'] | null)}

export interface PermissionsGenqlSelection{
    primaryFacilityGroup?: boolean | number
    privilegedFacilities?: boolean | number
    privilegedFacilityGroups?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PermissionsInput {primaryFacilityGroup?: (Scalars['ID'] | null),privilegedFacilities: Scalars['ID'][],privilegedFacilityGroups: Scalars['ID'][]}

export interface PhotoInstructionGenqlSelection{
    id?: boolean | number
    instruction?: boolean | number
    isRequired?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PhotoInstructionInput {id: Scalars['String'],instruction: Scalars['String'],isRequired: Scalars['Boolean']}

export interface PhotoRequirementGenqlSelection{
    description?: boolean | number
    id?: boolean | number
    required?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PhotoRequirementInput {description: Scalars['String'],required: Scalars['Boolean']}

export interface PlaidAccountFacilityMapping {facilityID: Scalars['ID'],plaidAccountId: Scalars['String']}

export interface PlaidExchangeTokenResponseGenqlSelection{
    itemId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PlaidItemGenqlSelection{
    id?: boolean | number
    institution?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PlaidLinkTokenGenqlSelection{
    expiresAt?: boolean | number
    token?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PointGenqlSelection{
    latitude?: boolean | number
    longitude?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PointInput {latitude: Scalars['Decimal'],longitude: Scalars['Decimal']}

export interface PolygonGenqlSelection{
    Points?: PointGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PortGenqlSelection{
    countryCode?: boolean | number
    id?: boolean | number
    latitude?: boolean | number
    locationCode?: boolean | number
    longitude?: boolean | number
    name?: boolean | number
    terminals?: TerminalGenqlSelection
    timestamps?: TimestampsGenqlSelection
    unLocode?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PortFilter {countryCode?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),locationCode?: (Scalars['String'] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),unLocode?: (Scalars['String'] | null)}

export interface PortResultPageGenqlSelection{
    entries?: PortGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PositionGenqlSelection{
    x?: boolean | number
    y?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PositionInput {x: Scalars['Float'],y: Scalars['Float']}

export interface PositionSummaryStatsGenqlSelection{
    negativePositions?: boolean | number
    totalIncoming?: boolean | number
    totalItems?: boolean | number
    totalOutgoing?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PositivePayTemplateGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    definition?: boolean | number
    fileType?: boolean | number
    id?: boolean | number
    templateName?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PositivePayTemplateFilter {ids?: (Scalars['ID'][] | null)}

export interface PositivePayTemplateInput {definition: Scalars['String'],fileType: Scalars['String'],templateName: Scalars['String']}

export interface PositivePayTemplateResultPageGenqlSelection{
    entries?: PositivePayTemplateGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PositivePayTemplateUpdateInput {definition?: (Scalars['String'] | null),fileType?: (Scalars['String'] | null),templateName?: (Scalars['String'] | null)}

export interface PresenceEventGenqlSelection{
    members?: PresenceMemberGenqlSelection
    room?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PresenceMemberGenqlSelection{
    id?: boolean | number
    kind?: boolean | number
    metadata?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PrinterGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    driverType?: boolean | number
    firmwareVersion?: boolean | number
    id?: boolean | number
    lastSeenAt?: boolean | number
    manufacturer?: boolean | number
    model?: boolean | number
    name?: boolean | number
    online?: boolean | number
    pageSize?: boolean | number
    printerType?: boolean | number
    rollWidth?: boolean | number
    sidecar?: SidecarGenqlSelection
    sidecarId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    uniqueId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PrinterFilter {facilityId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),printerType?: (PrinterType[] | null),sidecarId?: (Scalars['ID'] | null),status?: (PrinterStatus[] | null)}

export interface PrinterResultPageGenqlSelection{
    entries?: PrinterGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeGenqlSelection{
    code?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    hasRecipe?: boolean | number
    id?: boolean | number
    inputItems?: ProcessingTypeInputItemGenqlSelection
    isActive?: boolean | number
    name?: boolean | number
    outputItems?: ProcessingTypeOutputItemGenqlSelection
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeFilter {code?: (Scalars['String'] | null),description?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),isActive?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface ProcessingTypeInput {code: Scalars['String'],description?: (Scalars['String'] | null),inputItems?: (CreateProcessingTypeInputItemInput[] | null),isActive: Scalars['Boolean'],name: Scalars['String'],outputItems?: (CreateProcessingTypeOutputItemInput[] | null)}

export interface ProcessingTypeInputItemGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    isPrimary?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    notes?: boolean | number
    processingTypeId?: boolean | number
    sortOrder?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeInputItemFilter {ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),processingTypeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface ProcessingTypeInputItemResultPageGenqlSelection{
    entries?: ProcessingTypeInputItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeOutputItemGenqlSelection{
    costAllocationPercentage?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    isNoCost?: boolean | number
    isPrimary?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    notes?: boolean | number
    outputUnit?: boolean | number
    processingTypeId?: boolean | number
    sortOrder?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    yieldPercentage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeOutputItemFilter {ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),processingTypeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface ProcessingTypeOutputItemResultPageGenqlSelection{
    entries?: ProcessingTypeOutputItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeResultPageGenqlSelection{
    entries?: ProcessingTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ProcessingTypeUpdateInput {code?: (Scalars['String'] | null),description?: (Scalars['String'] | null),inputItems?: (UpdateProcessingTypeInputItemInput[] | null),isActive?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),outputItems?: (UpdateProcessingTypeOutputItemInput[] | null)}

export interface ProvisionFacilityAccountsResultGenqlSelection{
    created_accounts?: InventoryAccountGenqlSelection
    existing_accounts?: InventoryAccountGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadGenqlSelection{
    bill?: BillGenqlSelection
    billId?: boolean | number
    bolNumber?: boolean | number
    carrierAccount?: AccountGenqlSelection
    carrierAccountId?: boolean | number
    complianceChecks?: ComplianceCheckGenqlSelection
    complianceHold?: ComplianceHoldGenqlSelection
    containerNumber?: boolean | number
    containerType?: ContainerTypeGenqlSelection
    containerTypeId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currencyCode?: boolean | number
    deductions?: PurchaseLoadDeductionGenqlSelection
    deductionsTotal?: MoneyGenqlSelection
    description?: boolean | number
    documentNumber?: boolean | number
    driverName?: boolean | number
    externalNotes?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    files?: FileGenqlSelection
    freightCost?: MoneyGenqlSelection
    freightTerms?: boolean | number
    grandTotal?: MoneyGenqlSelection
    heavyWeight?: WeightGenqlSelection
    id?: boolean | number
    internalNotes?: boolean | number
    lightWeight?: WeightGenqlSelection
    lineItems?: PurchaseLoadLineItemGenqlSelection
    payments?: PurchaseLoadPaymentGenqlSelection
    purchaseOrder?: PurchaseOrderGenqlSelection
    purchaseOrderId?: boolean | number
    receivedById?: boolean | number
    receivedByUser?: UserGenqlSelection
    receivedDate?: boolean | number
    receivedTicketIssueDate?: boolean | number
    receivingTicketNumber?: boolean | number
    scac?: boolean | number
    sealNumber?: boolean | number
    service?: ServiceGenqlSelection
    serviceId?: boolean | number
    shippingCarrierName?: boolean | number
    sourceFacility?: FacilityGenqlSelection
    sourceFacilityId?: boolean | number
    sourceLoad?: LoadGenqlSelection
    sourceLoadId?: boolean | number
    status?: boolean | number
    subtotal?: MoneyGenqlSelection
    supplierAccount?: AccountGenqlSelection
    supplierAccountId?: boolean | number
    supplierAddress?: AccountAddressGenqlSelection
    supplierAddressId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    trailerNumber?: boolean | number
    truckNumber?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    vehicleColor?: boolean | number
    vehicleLicensePlate?: boolean | number
    vehicleMake?: boolean | number
    vehicleModel?: boolean | number
    vehiclePlateState?: boolean | number
    vehicleVin?: boolean | number
    vehicleYear?: boolean | number
    version?: boolean | number
    voidReason?: boolean | number
    weightDisplayUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadDeductionGenqlSelection{
    applicationType?: boolean | number
    calculatedAmount?: MoneyGenqlSelection
    deductionType?: DeductionTypeGenqlSelection
    deductionTypeId?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    lineItem?: PurchaseLoadLineItemGenqlSelection
    notes?: boolean | number
    percentage?: boolean | number
    priceValue?: MoneyGenqlSelection
    purchaseLoadId?: boolean | number
    purchaseLoadLineItemId?: boolean | number
    weightValue?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadDeductionFilter {applicationType?: (DeductionApplicationType[] | null),deductionTypeId?: (Scalars['ID'] | null),deductionTypeIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseLoadIds?: (Scalars['ID'][] | null),purchaseLoadLineItemId?: (Scalars['ID'] | null),purchaseLoadLineItemIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface PurchaseLoadDeductionResultPageGenqlSelection{
    entries?: PurchaseLoadDeductionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public: Scalars['Boolean']}

export interface PurchaseLoadFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromReceivedDate?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),includeLineItems?: (Scalars['Boolean'] | null),purchaseOrderId?: (Scalars['ID'] | null),purchaseOrderIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),sourceFacilityIds?: (Scalars['ID'][] | null),sourceLoadId?: (Scalars['ID'] | null),status?: (PurchaseLoadStatus[] | null),supplierAccountIds?: (Scalars['ID'][] | null),toReceivedDate?: (Scalars['ZonedDateTime'] | null)}

export interface PurchaseLoadInput {billId?: (Scalars['ID'] | null),bolNumber?: (Scalars['String'] | null),carrierAccountId?: (Scalars['ID'] | null),containerNumber?: (Scalars['String'] | null),containerTypeId?: (Scalars['ID'] | null),currencyCode: Scalars['String'],deductions?: (CreatePurchaseLoadDeductionInput[] | null),description?: (Scalars['String'] | null),driverName?: (Scalars['String'] | null),externalNotes?: (Scalars['String'] | null),facilityId: Scalars['ID'],freightCost?: (MoneyInput | null),freightTerms?: (Scalars['String'] | null),heavyWeight?: (WeightInput | null),internalNotes?: (Scalars['String'] | null),lightWeight?: (WeightInput | null),lineItems?: (CreatePurchaseLoadLineItemInput[] | null),payments?: (CreatePurchaseLoadPaymentInput[] | null),purchaseOrderId?: (Scalars['ID'] | null),receivedDate: Scalars['ZonedDateTime'],receivedTicketIssueDate?: (Scalars['CalendarDate'] | null),receivingTicketNumber?: (Scalars['String'] | null),scac?: (Scalars['String'] | null),sealNumber?: (Scalars['String'] | null),serviceId?: (Scalars['ID'] | null),shippingCarrierName?: (Scalars['String'] | null),sourceFacilityId?: (Scalars['ID'] | null),sourceLoadId?: (Scalars['ID'] | null),supplierAccountId?: (Scalars['ID'] | null),supplierAddressId?: (Scalars['ID'] | null),trailerNumber?: (Scalars['String'] | null),truckNumber?: (Scalars['String'] | null),vehicleColor?: (Scalars['String'] | null),vehicleLicensePlate?: (Scalars['String'] | null),vehicleMake?: (Scalars['String'] | null),vehicleModel?: (Scalars['String'] | null),vehiclePlateState?: (Scalars['String'] | null),vehicleVin?: (Scalars['String'] | null),vehicleYear?: (Scalars['String'] | null),weightDisplayUnit: WeightDisplayUnit}

export interface PurchaseLoadLineItemGenqlSelection{
    catComplianceStatus?: boolean | number
    catOemCode?: boolean | number
    catSerialNumber?: boolean | number
    childLineItems?: PurchaseLoadLineItemGenqlSelection
    estimatedPrice?: MoneyGenqlSelection
    facilityId?: boolean | number
    grossWeight?: WeightGenqlSelection
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    netWeight?: WeightGenqlSelection
    notes?: boolean | number
    parentLineItem?: PurchaseLoadLineItemGenqlSelection
    parentLineItemId?: boolean | number
    pricingUnit?: boolean | number
    purchaseLoadId?: boolean | number
    purchaseOrderLine?: PurchaseOrderLineItemGenqlSelection
    purchaseOrderLineId?: boolean | number
    requiresSorting?: boolean | number
    settlementBasis?: boolean | number
    sortingWorkOrder?: WorkOrderGenqlSelection
    tagId?: boolean | number
    tareWeight?: WeightGenqlSelection
    type?: boolean | number
    unitPrice?: MoneyGenqlSelection
    vehicleMake?: boolean | number
    vehicleModel?: boolean | number
    vehicleTitleStatus?: boolean | number
    vehicleVin?: boolean | number
    vehicleYear?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadLineItemFilter {catComplianceStatus?: (Scalars['String'] | null),catOemCode?: (Scalars['String'] | null),catSerialNumber?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),parentLineItemId?: (Scalars['ID'] | null),parentLineItemIds?: (Scalars['ID'][] | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseLoadIds?: (Scalars['ID'][] | null),purchaseOrderLineId?: (Scalars['ID'] | null),purchaseOrderLineIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),settlementBasis?: (SettlementBasis[] | null),tagId?: (Scalars['ID'] | null),tagIds?: (Scalars['ID'][] | null),type?: (PurchaseLineItemType[] | null),vehicleMake?: (Scalars['String'] | null),vehicleModel?: (Scalars['String'] | null),vehicleTitleStatus?: (Scalars['String'] | null),vehicleVin?: (Scalars['String'] | null)}

export interface PurchaseLoadLineItemResultPageGenqlSelection{
    entries?: PurchaseLoadLineItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadPaymentGenqlSelection{
    amount?: MoneyGenqlSelection
    checkMemo?: boolean | number
    checkNumber?: boolean | number
    creatorId?: boolean | number
    facilityId?: boolean | number
    financialAccountId?: boolean | number
    id?: boolean | number
    legalHold?: boolean | number
    paymentMethod?: boolean | number
    paymentTerm?: boolean | number
    percentage?: boolean | number
    purchaseLoadId?: boolean | number
    roundingMethod?: boolean | number
    roundingPrecision?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadPaymentFilter {checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),creatorId?: (Scalars['ID'] | null),creatorIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),financialAccountId?: (Scalars['ID'] | null),financialAccountIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),paymentMethod?: (Scalars['String'] | null),paymentTerm?: (Scalars['String'] | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseLoadIds?: (Scalars['ID'][] | null),roundingMethod?: (Scalars['String'] | null),roundingPrecision?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface PurchaseLoadPaymentResultPageGenqlSelection{
    entries?: PurchaseLoadPaymentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadResultPageGenqlSelection{
    entries?: PurchaseLoadGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseLoadUpdateInput {billId?: (Scalars['ID'] | null),bolNumber?: (Scalars['String'] | null),carrierAccountId?: (Scalars['ID'] | null),containerNumber?: (Scalars['String'] | null),containerTypeId?: (Scalars['ID'] | null),currencyCode?: (Scalars['String'] | null),deductions?: (UpdatePurchaseLoadDeductionInput[] | null),description?: (Scalars['String'] | null),driverName?: (Scalars['String'] | null),expectedVersion?: (Scalars['Int'] | null),externalNotes?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),freightCost?: (MoneyInput | null),freightTerms?: (Scalars['String'] | null),heavyWeight?: (WeightInput | null),internalNotes?: (Scalars['String'] | null),lightWeight?: (WeightInput | null),lineItems?: (UpdatePurchaseLoadLineItemInput[] | null),payments?: (UpdatePurchaseLoadPaymentInput[] | null),purchaseOrderId?: (Scalars['ID'] | null),receivedDate?: (Scalars['ZonedDateTime'] | null),receivedTicketIssueDate?: (Scalars['CalendarDate'] | null),receivingTicketNumber?: (Scalars['String'] | null),scac?: (Scalars['String'] | null),sealNumber?: (Scalars['String'] | null),serviceId?: (Scalars['ID'] | null),shippingCarrierName?: (Scalars['String'] | null),sourceFacilityId?: (Scalars['ID'] | null),sourceLoadId?: (Scalars['ID'] | null),supplierAccountId?: (Scalars['ID'] | null),supplierAddressId?: (Scalars['ID'] | null),trailerNumber?: (Scalars['String'] | null),truckNumber?: (Scalars['String'] | null),vehicleColor?: (Scalars['String'] | null),vehicleLicensePlate?: (Scalars['String'] | null),vehicleMake?: (Scalars['String'] | null),vehicleModel?: (Scalars['String'] | null),vehiclePlateState?: (Scalars['String'] | null),vehicleVin?: (Scalars['String'] | null),vehicleYear?: (Scalars['String'] | null),weightDisplayUnit?: (WeightDisplayUnit | null)}

export interface PurchaseOrderGenqlSelection{
    account?: AccountGenqlSelection
    accountAddressId?: boolean | number
    accountContactId?: boolean | number
    accountId?: boolean | number
    accountRepresentativeId?: boolean | number
    allocatedPercentage?: boolean | number
    completionNotes?: boolean | number
    contact?: ContactGenqlSelection
    counterpartyReferenceNumber?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    documentNumber?: boolean | number
    endDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    files?: FileGenqlSelection
    freightTerm?: boolean | number
    fulfilledPercentage?: boolean | number
    id?: boolean | number
    lineItems?: PurchaseOrderLineItemGenqlSelection
    notes?: boolean | number
    paymentCurrency?: boolean | number
    paymentTerm?: boolean | number
    startDate?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalAllocated?: boolean | number
    totalFulfilled?: boolean | number
    totalQuantity?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public: Scalars['Boolean']}

export interface PurchaseOrderFilter {accountAddressIds?: (Scalars['ID'][] | null),accountIds?: (Scalars['ID'][] | null),counterpartyReferenceNumber?: (Scalars['String'] | null),documentNumber?: (Scalars['String'] | null),facilityIds?: (Scalars['ID'][] | null),freightTerms?: (FreightTerm[] | null),fromEndDate?: (Scalars['CalendarDate'] | null),fromStartDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),includeLineItems?: (Scalars['Boolean'] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),paymentCurrencies?: (Scalars['String'][] | null),paymentTerms?: (PaymentTerm[] | null),searchTerm?: (Scalars['String'] | null),status?: (PurchaseOrderStatus[] | null),toEndDate?: (Scalars['CalendarDate'] | null),toStartDate?: (Scalars['CalendarDate'] | null)}

export interface PurchaseOrderFreightGenqlSelection{
    carrierId?: boolean | number
    chargebackFormula?: boolean | number
    chargebackVariableIds?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    freightLaneId?: boolean | number
    fuelSurchargeFormula?: boolean | number
    fuelSurchargeMode?: boolean | number
    fuelSurchargeVariableIds?: boolean | number
    id?: boolean | number
    notes?: boolean | number
    purchaseOrderId?: boolean | number
    rateFormula?: boolean | number
    rateVariableIds?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderFreightFilter {ids?: (Scalars['ID'][] | null),purchaseOrderId?: (Scalars['ID'] | null),purchaseOrderIds?: (Scalars['ID'][] | null)}

export interface PurchaseOrderFreightInput {carrierId?: (Scalars['ID'] | null),chargebackFormula?: (Scalars['String'] | null),chargebackVariableIds?: (Scalars['String'] | null),freightLaneId?: (Scalars['String'] | null),fuelSurchargeFormula?: (Scalars['String'] | null),fuelSurchargeMode?: (Scalars['String'] | null),fuelSurchargeVariableIds?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),purchaseOrderId: Scalars['ID'],rateFormula?: (Scalars['String'] | null),rateVariableIds?: (Scalars['String'] | null)}

export interface PurchaseOrderFreightResultPageGenqlSelection{
    entries?: PurchaseOrderFreightGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderFreightUpdateInput {carrierId?: (Scalars['ID'] | null),chargebackFormula?: (Scalars['String'] | null),chargebackVariableIds?: (Scalars['String'] | null),freightLaneId?: (Scalars['String'] | null),fuelSurchargeFormula?: (Scalars['String'] | null),fuelSurchargeMode?: (Scalars['String'] | null),fuelSurchargeVariableIds?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),purchaseOrderId?: (Scalars['ID'] | null),rateFormula?: (Scalars['String'] | null),rateVariableIds?: (Scalars['String'] | null)}

export interface PurchaseOrderLineItemGenqlSelection{
    allocatedPercentage?: boolean | number
    allocatedQuantity?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    fulfilledPercentage?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    purchaseOrderId?: boolean | number
    quantity?: boolean | number
    receivedQuantity?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalPrice?: MoneyGenqlSelection
    unit?: boolean | number
    unitPrice?: MoneyGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderLineItemFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),purchaseOrderId?: (Scalars['ID'] | null),purchaseOrderIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface PurchaseOrderLineItemResultPageGenqlSelection{
    entries?: PurchaseOrderLineItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderResultPageGenqlSelection{
    entries?: PurchaseOrderGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface PurchaseOrderStatusCountsGenqlSelection{
    closed?: boolean | number
    draft?: boolean | number
    open?: boolean | number
    total?: boolean | number
    voided?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QueryGenqlSelection{
    _complianceServiceStatus?: boolean | number
    _notificationServiceStatus?: boolean | number
    _pricingServiceStatus?: boolean | number
    account?: (AccountGenqlSelection & { __args: {id: Scalars['ID']} })
    accountAddress?: (AccountAddressGenqlSelection & { __args: {id: Scalars['ID']} })
    accountAddresses?: (AccountAddressResultPageGenqlSelection & { __args?: {filter?: (AccountAddressFilter | null), pagination?: (PaginationInput | null), sorting?: (AccountAddressSortOption[] | null)} })
    accountAddressesByAccountId?: (AccountAddressGenqlSelection & { __args: {accountId: Scalars['ID']} })
    accountBankDetail?: (AccountBankDetailGenqlSelection & { __args: {id: Scalars['ID']} })
    accountBankDetails?: (AccountBankDetailResultPageGenqlSelection & { __args?: {filter?: (AccountBankDetailFilter | null), pagination?: (PaginationInput | null), sorting?: (AccountBankDetailSortOption[] | null)} })
    accounts?: (AccountResultPageGenqlSelection & { __args?: {filter?: (AccountFilter | null), pagination?: (PaginationInput | null), sorting?: (AccountSortOption[] | null)} })
    agent?: (AgentGenqlSelection & { __args: {id: Scalars['ID']} })
    agents?: (AgentResultPageGenqlSelection & { __args?: {filter?: (AgentFilter | null), pagination?: (PaginationInput | null), sorting?: (AgentSortOption[] | null)} })
    asset?: (AssetGenqlSelection & { __args: {id: Scalars['ID']} })
    assetLocationHistories?: (AssetLocationHistoryResultPageGenqlSelection & { __args?: {filter?: (AssetLocationHistoryFilter | null), pagination?: (PaginationInput | null), sorting?: (AssetLocationHistorySortOption[] | null)} })
    assetLocationHistory?: (AssetLocationHistoryGenqlSelection & { __args: {id: Scalars['ID']} })
    assetType?: (AssetTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    assetTypes?: (AssetTypeResultPageGenqlSelection & { __args?: {filter?: (AssetTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (AssetTypeSortOption[] | null)} })
    assets?: (AssetResultPageGenqlSelection & { __args?: {filter?: (AssetFilter | null), pagination?: (PaginationInput | null), sorting?: (AssetSortOption[] | null)} })
    assetsInRegion?: (AssetResultPageGenqlSelection & { __args: {centroid: PointInput, filter?: (AssetFilter | null), radius: Scalars['Float']} })
    assistantChat?: (AssistantChatGenqlSelection & { __args: {id: Scalars['ID']} })
    assistantChatByShareToken?: (AssistantChatGenqlSelection & { __args: {token: Scalars['String']} })
    assistantChatMessages?: (AssistantChatMessageGenqlSelection & { __args: {chatId: Scalars['ID']} })
    assistantChats?: (AssistantChatResultPageGenqlSelection & { __args?: {filter?: (AssistantChatFilter | null), pagination?: (PaginationInput | null), sorting?: (AssistantChatSortOption[] | null)} })
    assistantOrganizationUsageMetrics?: (UsageMetricsResultPageGenqlSelection & { __args?: {filter?: (UsageMetricsFilterInput | null), pagination?: (PaginationInput | null), sorting?: (UsageMetricsSortOption[] | null)} })
    assistantOutboxEventCounts?: AssistantOutboxEventCountsGenqlSelection
    assistantOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (AssistantOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    assistantSystemUsageMetrics?: (UsageMetricsResultPageGenqlSelection & { __args?: {filter?: (UsageMetricsFilterInput | null), pagination?: (PaginationInput | null), sorting?: (UsageMetricsSortOption[] | null)} })
    /** Checks if the authentication service is currently available */
    authenticationAvailable?: boolean | number
    automation?: (AutomationGenqlSelection & { __args: {id: Scalars['ID']} })
    automationValidate?: (FlowValidationResultGenqlSelection & { __args: {edges: EdgeInput[], nodes: NodeInput[]} })
    automationVersion?: (AutomationVersionGenqlSelection & { __args: {id: Scalars['ID']} })
    automationVersions?: (AutomationVersionResultPageGenqlSelection & { __args?: {filter?: (AutomationVersionFilter | null), pagination?: (PaginationInput | null), sorting?: (AutomationVersionSortOption[] | null)} })
    automations?: (AutomationResultPageGenqlSelection & { __args?: {filter?: (AutomationFilter | null), pagination?: (PaginationInput | null), sorting?: (AutomationSortOption[] | null)} })
    automationsApprovalRequest?: (ApprovalRequestGenqlSelection & { __args: {id: Scalars['ID']} })
    automationsPendingApprovals?: (ApprovalRequestResultPageGenqlSelection & { __args?: {filter?: (ApprovalRequestFilter | null), pagination?: (PaginationInput | null), sorting?: (ApprovalRequestSortOption[] | null)} })
    billStatusCounts?: (BillStatusCountsGenqlSelection & { __args?: {filter?: (BillFilter | null)} })
    bills?: (BillResultPageGenqlSelection & { __args?: {filter?: (BillFilter | null), pagination?: (PaginationInput | null), sorting?: (BillSortOption[] | null)} })
    bookingStatusCounts?: (BookingStatusCountsGenqlSelection & { __args?: {filter?: (BookingFilter | null)} })
    bookings?: (BookingResultPageGenqlSelection & { __args?: {filter?: (BookingFilter | null), pagination?: (PaginationInput | null), sorting?: (BookingSortOption[] | null)} })
    brokeredOrder?: (BrokeredOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    brokeredOrders?: (BrokeredOrderResultPageGenqlSelection & { __args?: {filter?: (BrokeredOrderFilter | null), pagination?: (PaginationInput | null), sorting?: (BrokeredOrderSortOption[] | null)} })
    camera?: (CameraGenqlSelection & { __args: {id: Scalars['ID']} })
    cameras?: (CameraResultPageGenqlSelection & { __args?: {filter?: (CameraFilter | null), pagination?: (PaginationInput | null), sorting?: (CameraSortOption[] | null)} })
    categories?: (CategoryResultPageGenqlSelection & { __args?: {filter?: (CategoryFilter | null), pagination?: (PaginationInput | null), sorting?: (CategorySortOption[] | null)} })
    checkSupplierPriceListAffectsMaterials?: (SupplierPriceListAffectsMaterialsResultGenqlSelection & { __args: {accountId: Scalars['ID']} })
    checkTemplate?: (CheckTemplateGenqlSelection & { __args: {id: Scalars['ID']} })
    checkTemplates?: (CheckTemplateResultPageGenqlSelection & { __args?: {filter?: (CheckTemplateFilter | null), pagination?: (PaginationInput | null), sorting?: (CheckTemplateSortOption[] | null)} })
    checkUserPermission?: (PermissionGenqlSelection & { __args: {input: PermissionCheckInput} })
    checkUserPermissions?: (PermissionGenqlSelection & { __args: {inputs: PermissionCheckInput[]} })
    collabUserConversations?: (TalkJSConversationListResultGenqlSelection & { __args: {filter: TalkJSConversationFilter} })
    complianceCheck?: (ComplianceCheckGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceChecks?: (ComplianceCheckResultPageGenqlSelection & { __args?: {filter?: (ComplianceCheckFilter | null), pagination?: (PaginationInput | null), sorting?: (ComplianceCheckSortOption[] | null)} })
    complianceDispatchRecord?: (ComplianceDispatchRecordGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceDispatchRecords?: (ComplianceDispatchRecordResultPageGenqlSelection & { __args?: {filter?: (ComplianceDispatchRecordFilter | null), pagination?: (PaginationInput | null), sorting?: (ComplianceDispatchRecordSortOption[] | null)} })
    complianceEvaluateTransaction?: (ComplianceEvaluationResultGenqlSelection & { __args: {input: ComplianceEvaluateTransactionInput} })
    complianceFacilityRule?: (ComplianceFacilityRuleGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceFacilityRules?: (ComplianceFacilityRuleResultPageGenqlSelection & { __args?: {filter?: (ComplianceFacilityRuleFilter | null), pagination?: (PaginationInput | null), sorting?: (ComplianceFacilityRuleSortOption[] | null)} })
    complianceHold?: (ComplianceHoldGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceHolds?: (ComplianceHoldResultPageGenqlSelection & { __args?: {filter?: (ComplianceHoldFilter | null), pagination?: (PaginationInput | null), sorting?: (ComplianceHoldSortOption[] | null)} })
    complianceItemJurisdictionCode?: (ComplianceItemJurisdictionCodeGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceItemJurisdictionCodes?: (ComplianceItemJurisdictionCodeResultPageGenqlSelection & { __args?: {filter?: (ComplianceItemJurisdictionCodeFilter | null), pagination?: (PaginationInput | null), sorting?: (ComplianceItemJurisdictionCodeSortOption[] | null)} })
    complianceRuleDefinition?: (ComplianceRuleDefinitionGenqlSelection & { __args: {id: Scalars['ID']} })
    complianceRuleDefinitions?: (ComplianceRuleDefinitionResultPageGenqlSelection & { __args?: {filter?: (ComplianceRuleDefinitionFilter | null), pagination?: (PaginationInput | null), sorting?: (ComplianceRuleDefinitionSortOption[] | null)} })
    contact?: (ContactGenqlSelection & { __args: {id: Scalars['ID']} })
    contacts?: (ContactResultPageGenqlSelection & { __args?: {filter?: (ContactFilter | null), pagination?: (PaginationInput | null), sorting?: (ContactSortOption[] | null)} })
    contactsByAccount?: (ContactGenqlSelection & { __args: {accountId: Scalars['ID']} })
    container?: (ContainerGenqlSelection & { __args: {id: Scalars['ID']} })
    containerStatusCounts?: (ContainerStatusCountsGenqlSelection & { __args?: {filter?: (ContainerFilter | null)} })
    containerType?: (ContainerTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    containerTypes?: (ContainerTypeResultPageGenqlSelection & { __args?: {filter?: (ContainerTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (ContainerTypeSortOption[] | null)} })
    containers?: (ContainerResultPageGenqlSelection & { __args?: {filter?: (ContainerFilter | null), pagination?: (PaginationInput | null), sorting?: (ContainerSortOption[] | null)} })
    coreOutboxEventCounts?: CoreOutboxEventCountsGenqlSelection
    coreOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (CoreOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    coreRole?: (RoleGenqlSelection & { __args: {id: Scalars['ID']} })
    coreRoles?: (RoleResultPageGenqlSelection & { __args: {filter: RoleFilter} })
    coreUserRoleAssignment?: (UserRoleAssignmentGenqlSelection & { __args: {id: Scalars['ID']} })
    coreUserRoleAssignments?: (UserRoleAssignmentResultPageGenqlSelection & { __args?: {filter?: (UserRoleAssignmentFilter | null)} })
    coreUsersByOrganization?: (UserResultPageGenqlSelection & { __args?: {filter?: (UserFilter | null), pagination?: (PaginationInput | null), sorting?: (UserSortOption[] | null)} })
    counterpartyGroup?: (CounterpartyGroupGenqlSelection & { __args: {id: Scalars['ID']} })
    counterpartyGroupMemberDetails?: (CounterpartyGroupMemberGenqlSelection & { __args: {groupId: Scalars['ID']} })
    counterpartyGroupMembers?: { __args: {groupId: Scalars['ID']} }
    counterpartyGroups?: (CounterpartyGroupResultPageGenqlSelection & { __args?: {filter?: (CounterpartyGroupFilter | null), pagination?: (PaginationInput | null), sorting?: (CounterpartyGroupSortOption[] | null)} })
    counterpartyGroupsByAccount?: (CounterpartyGroupGenqlSelection & { __args: {accountId: Scalars['ID']} })
    crmOutboxEventCounts?: CrmOutboxEventCountsGenqlSelection
    crmOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (CrmOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    customAttributeDefinitions?: (CustomAttributeGenqlSelection & { __args?: {filter?: (CustomAttributeFilter | null)} })
    customPriceList?: (CustomPriceListGenqlSelection & { __args: {id: Scalars['ID']} })
    customPriceListStatusCounts?: CustomPriceListStatusCountsGenqlSelection
    customPriceLists?: (CustomPriceListResultPageGenqlSelection & { __args?: {filter?: (CustomPriceListFilter | null), pagination?: (PaginationInput | null), sorting?: (CustomPriceListSortOption[] | null)} })
    customerBookings?: (BookingResultPageGenqlSelection & { __args?: {filter?: (BookingFilter | null), pagination?: (PaginationInput | null), sorting?: (BookingSortOption[] | null)} })
    customerInvitationByToken?: (CustomerInvitationGenqlSelection & { __args: {token: Scalars['String']} })
    customerInvitations?: (CustomerInvitationResultPageGenqlSelection & { __args?: {filter?: (CustomerInvitationFilter | null), pagination?: (PaginationInput | null), sorting?: (CustomerInvitationSortOption[] | null)} })
    customerLoads?: (LoadResultPageGenqlSelection & { __args?: {filter?: (LoadFilter | null), pagination?: (PaginationInput | null), sorting?: (LoadSortOption[] | null)} })
    customerSalesOrders?: (SalesOrderResultPageGenqlSelection & { __args?: {filter?: (SalesOrderFilter | null), pagination?: (PaginationInput | null), sorting?: (SalesOrderSortOption[] | null)} })
    cycleCountLine?: (CycleCountLineGenqlSelection & { __args: {id: Scalars['ID']} })
    cycleCountLines?: (CycleCountLineResultPageGenqlSelection & { __args?: {filter?: (CycleCountLineFilter | null), pagination?: (PaginationInput | null), sorting?: (CycleCountLineSortOption[] | null)} })
    cycleCountSchedule?: (CycleCountScheduleGenqlSelection & { __args: {id: Scalars['ID']} })
    cycleCountSchedules?: (CycleCountScheduleResultPageGenqlSelection & { __args?: {filter?: (CycleCountScheduleFilter | null), pagination?: (PaginationInput | null), sorting?: (CycleCountScheduleSortOption[] | null)} })
    cycleCountTask?: (CycleCountTaskGenqlSelection & { __args: {id: Scalars['ID']} })
    cycleCountTasks?: (CycleCountTaskResultPageGenqlSelection & { __args?: {filter?: (CycleCountTaskFilter | null), pagination?: (PaginationInput | null), sorting?: (CycleCountTaskSortOption[] | null)} })
    deductionType?: (DeductionTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    deductionTypes?: (DeductionTypeResultPageGenqlSelection & { __args?: {filter?: (DeductionTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (DeductionTypeSortOption[] | null)} })
    defaultPhotoRequirements?: DefaultPhotoRequirementGenqlSelection
    defaultPriceList?: (DefaultPriceListGenqlSelection & { __args: {id: Scalars['ID']} })
    detention?: (DetentionGenqlSelection & { __args: {id: Scalars['ID']} })
    detentions?: (DetentionResultPageGenqlSelection & { __args?: {filter?: (DetentionFilter | null), pagination?: (PaginationInput | null), sorting?: (DetentionSortOption[] | null)} })
    directories?: FileGenqlSelection
    doNotBuyEntries?: (DoNotBuyEntryResultPageGenqlSelection & { __args?: {filter?: (DoNotBuyEntryFilter | null), pagination?: (PaginationInput | null), sorting?: (DoNotBuyEntrySortOption[] | null)} })
    doNotBuyEntry?: (DoNotBuyEntryGenqlSelection & { __args: {id: Scalars['ID']} })
    driver?: (DriverGenqlSelection & { __args: {id: Scalars['ID']} })
    driverCertification?: (DriverCertificationGenqlSelection & { __args: {id: Scalars['ID']} })
    driverCertifications?: (DriverCertificationResultPageGenqlSelection & { __args?: {filter?: (DriverCertificationFilter | null), pagination?: (PaginationInput | null), sorting?: (DriverCertificationSortOption[] | null)} })
    driverTotalServicesCompleted?: { __args: {dateRange?: (DateRangeInput | null), driverId: Scalars['ID']} }
    drivers?: (DriverResultPageGenqlSelection & { __args?: {filter?: (DriverFilter | null), pagination?: (PaginationInput | null), sorting?: (DriverSortOption[] | null)} })
    evaluateAdHocFormulas?: (EvaluatedFormulaGenqlSelection & { __args: {formulas: Scalars['String'][]} })
    evaluateFormulas?: (EvaluatedItemPricingGenqlSelection & { __args: {asOf?: (Scalars['ZonedDateTime'] | null), priceListId: Scalars['ID'], priceListType: PriceListType} })
    executionRun?: (ExecutionRunGenqlSelection & { __args: {id: Scalars['ID']} })
    executionRuns?: (ExecutionRunResultPageGenqlSelection & { __args?: {filter?: (ExecutionRunFilter | null), pagination?: (PaginationInput | null), sorting?: (ExecutionRunSortOption[] | null)} })
    facilities?: (FacilityResultPageGenqlSelection & { __args?: {filter?: (FacilityFilter | null), pagination?: (PaginationInput | null), sorting?: (FacilitySortOption[] | null)} })
    facilitiesNearby?: (FacilityGenqlSelection & { __args: {latitude: Scalars['Float'], longitude: Scalars['Float'], radiusMeters: Scalars['Float']} })
    facility?: (FacilityGenqlSelection & { __args: {id: Scalars['ID']} })
    facilityAtm?: (FacilityAtmGenqlSelection & { __args: {id: Scalars['ID']} })
    facilityAtms?: (FacilityAtmResultPageGenqlSelection & { __args?: {filter?: (FacilityAtmFilter | null), pagination?: (PaginationInput | null), sorting?: (FacilityAtmSortOption[] | null)} })
    facilityGeneralPreferences?: (FacilityGeneralPreferencesGenqlSelection & { __args: {facilityId: Scalars['ID']} })
    facilityGroup?: (FacilityGroupGenqlSelection & { __args: {id: Scalars['ID']} })
    facilityGroups?: (FacilityGroupResultPageGenqlSelection & { __args?: {filter?: (FacilityGroupFilter | null), pagination?: (PaginationInput | null), sorting?: (FacilityGroupSortOption[] | null)} })
    facilitySalesPreferences?: (FacilitySalesPreferencesGenqlSelection & { __args: {facilityId: Scalars['ID']} })
    facilityServiceTypes?: (ServiceTypeGenqlSelection & { __args: {facilityIDs: Scalars['ID'][]} })
    file?: (FileGenqlSelection & { __args: {id: Scalars['ID']} })
    fileTemplate?: (FileTemplateGenqlSelection & { __args: {id: Scalars['ID']} })
    fileTemplates?: (FileTemplateResultPageGenqlSelection & { __args?: {filter?: (FileTemplateFilter | null), pagination?: (PaginationInput | null), sorting?: (FileTemplateSortOption[] | null)} })
    files?: (FileConnectionGenqlSelection & { __args?: {cursor?: (FileCursor | null), filter?: (FileFilter | null)} })
    filesOutboxEventCounts?: FilesOutboxEventCountsGenqlSelection
    filesOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (FilesOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    filesWOPICanEdit?: { __args: {fileId: Scalars['ID']} }
    filesWOPIDiscovery?: WOPIDiscoveryInfoGenqlSelection
    financeAccountsWithBalance?: (AccountGenqlSelection & { __args?: {filter?: (FinanceAccountBalanceFilter | null), pagination?: (PaginationInput | null)} })
    financeAtmPaymentsRequiringVoidConfirmation?: (PaymentGenqlSelection & { __args: {paymentIds: Scalars['ID'][]} })
    financeGeneratePositivePayFile?: { __args: {input: GeneratePositivePayFileInput} }
    financeNextBillDocumentNumber?: boolean | number
    financeNextCheckNumber?: { __args: {financialAccountId: Scalars['ID']} }
    financeNextInvoiceDocumentNumber?: boolean | number
    financeNextPaymentDocumentNumber?: boolean | number
    financeOutboxEventCounts?: FinanceOutboxEventCountsGenqlSelection
    financeOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (FinanceOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    financeUnappliedAdvanceBalance?: (UnappliedAdvanceBalanceGenqlSelection & { __args: {accountId: Scalars['ID']} })
    financeUnappliedAdvances?: (PaymentGenqlSelection & { __args: {accountId: Scalars['ID']} })
    financialAccountAdjustment?: (FinancialAccountAdjustmentGenqlSelection & { __args: {id: Scalars['ID']} })
    financialAccountAdjustments?: (FinancialAccountAdjustmentResultPageGenqlSelection & { __args?: {filter?: (FinancialAccountAdjustmentFilter | null), pagination?: (PaginationInput | null), sorting?: (FinancialAccountAdjustmentSortOption[] | null)} })
    financialAccountTransactions?: (FinancialAccountTransactionResultPageGenqlSelection & { __args?: {filter?: (FinancialAccountTransactionFilter | null), pagination?: (PaginationInput | null), sorting?: (FinancialAccountTransactionSortOption[] | null)} })
    financialAccounts?: (FinancialAccountResultPageGenqlSelection & { __args?: {filter?: (FinancialAccountFilter | null), pagination?: (PaginationInput | null), sorting?: (FinancialAccountSortOption[] | null)} })
    freightForwarder?: (FreightForwarderGenqlSelection & { __args: {id: Scalars['ID']} })
    freightForwarders?: (FreightForwarderResultPageGenqlSelection & { __args?: {filter?: (FreightForwarderFilter | null), pagination?: (PaginationInput | null), sorting?: (FreightForwarderSortOption[] | null)} })
    freightLane?: (FreightLaneGenqlSelection & { __args: {id: Scalars['ID']} })
    freightLaneCost?: (FreightLaneCostGenqlSelection & { __args: {id: Scalars['ID']} })
    freightLaneCosts?: (FreightLaneCostResultPageGenqlSelection & { __args?: {filter?: (FreightLaneCostFilter | null), pagination?: (PaginationInput | null), sorting?: (FreightLaneCostSortOption[] | null)} })
    freightLaneRoute?: (FreightLaneRouteGenqlSelection & { __args: {id: Scalars['ID']} })
    freightLaneRoutes?: (FreightLaneRouteResultPageGenqlSelection & { __args?: {filter?: (FreightLaneRouteFilter | null), pagination?: (PaginationInput | null), sorting?: (FreightLaneRouteSortOption[] | null)} })
    freightLanes?: (FreightLaneResultPageGenqlSelection & { __args?: {filter?: (FreightLaneFilter | null), pagination?: (PaginationInput | null), sorting?: (FreightLaneSortOption[] | null)} })
    freightLine?: (FreightLineGenqlSelection & { __args: {id: Scalars['ID']} })
    freightLines?: (FreightLineResultPageGenqlSelection & { __args?: {filter?: (FreightLineFilter | null), pagination?: (PaginationInput | null), sorting?: (FreightLineSortOption[] | null)} })
    getPersonalContact?: (UserContactGenqlSelection & { __args?: {userId?: (Scalars['ID'] | null)} })
    governmentReportingConfiguration?: (GovernmentReportingConfigurationGenqlSelection & { __args: {id: Scalars['ID']} })
    governmentReportingConfigurations?: (GovernmentReportingConfigurationResultPageGenqlSelection & { __args?: {filter?: (GovernmentReportingConfigurationFilter | null), pagination?: (PaginationInput | null), sorting?: (GovernmentReportingConfigurationSortOption[] | null)} })
    governmentReportingFacilities?: (GovernmentReportingFacilityResultPageGenqlSelection & { __args?: {filter?: (GovernmentReportingFacilityFilter | null), pagination?: (PaginationInput | null), sorting?: (GovernmentReportingFacilitySortOption[] | null)} })
    governmentReportingFacility?: (GovernmentReportingFacilityGenqlSelection & { __args: {id: Scalars['ID']} })
    haulers?: OrganizationGenqlSelection
    inboundTollingAgreement?: (InboundTollingAgreementGenqlSelection & { __args: {id: Scalars['ID']} })
    inboundTollingAgreements?: (InboundTollingAgreementResultPageGenqlSelection & { __args?: {filter?: (InboundTollingAgreementFilter | null), pagination?: (PaginationInput | null), sorting?: (InboundTollingAgreementSortOption[] | null)} })
    integrations?: IntegrationGenqlSelection
    inventoryFacilitySettings?: (InventoryFacilitySettingsGenqlSelection & { __args: {facilityId: Scalars['ID']} })
    /**
     * List inventory levels with filtering and pagination.
     * Returns aggregated inventory levels calculated from completed movements.
     */
    inventoryLevels?: (InventoryLevelResultPageGenqlSelection & { __args?: {filter?: (InventoryLevelFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryLevelSortOption[] | null)} })
    inventoryLot?: (InventoryLotGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryLotTraceBackward?: (LotTraceBackwardResultGenqlSelection & { __args: {lotId: Scalars['ID']} })
    inventoryLotTraceForward?: (LotTraceForwardResultGenqlSelection & { __args: {lotId: Scalars['ID']} })
    inventoryLots?: (InventoryLotResultPageGenqlSelection & { __args?: {filter?: (InventoryLotFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryLotSortOption[] | null)} })
    inventoryMovement?: (InventoryMovementGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryMovementHistory?: (InventoryMovementHistoryResultPageGenqlSelection & { __args: {filter: InventoryMovementHistoryFilter, pagination?: (PaginationInput | null)} })
    inventoryMovements?: (InventoryMovementResultPageGenqlSelection & { __args?: {filter?: (InventoryMovementFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryMovementSortOption[] | null)} })
    inventoryOutboxEventCounts?: InventoryOutboxEventCountsGenqlSelection
    inventoryOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (InventoryOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    inventoryPeriod?: (InventoryPeriodGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryPeriodBalance?: (InventoryPeriodBalanceGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryPeriodBalances?: (InventoryPeriodBalanceResultPageGenqlSelection & { __args?: {filter?: (InventoryPeriodBalanceFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryPeriodBalanceSortOption[] | null)} })
    inventoryPeriodConfig?: (InventoryPeriodConfigGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryPeriodConfigByOrganization?: InventoryPeriodConfigGenqlSelection
    inventoryPeriodTrialClose?: (PeriodTrialCloseResultGenqlSelection & { __args: {periodId: Scalars['ID']} })
    inventoryPeriods?: (InventoryPeriodResultPageGenqlSelection & { __args?: {filter?: (InventoryPeriodFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryPeriodSortOption[] | null)} })
    inventoryTag?: (InventoryTagGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryTagByTagNumber?: (InventoryTagGenqlSelection & { __args: {tagNumber: Scalars['String']} })
    inventoryTagReconciliationReport?: (TagReconciliationReportGenqlSelection & { __args?: {facilityId?: (Scalars['ID'] | null)} })
    inventoryTags?: (InventoryTagResultPageGenqlSelection & { __args?: {filter?: (InventoryTagFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryTagSortOption[] | null)} })
    inventoryTagsByCustomAttribute?: (InventoryTagGenqlSelection & { __args: {attributeName: Scalars['String'], attributeValue: Scalars['String']} })
    inventoryZone?: (InventoryZoneGenqlSelection & { __args: {id: Scalars['ID']} })
    inventoryZoneHierarchy?: (InventoryZoneGenqlSelection & { __args: {facilityId: Scalars['ID']} })
    inventoryZones?: (InventoryZoneResultPageGenqlSelection & { __args?: {filter?: (InventoryZoneFilter | null), pagination?: (PaginationInput | null), sorting?: (InventoryZoneSortOption[] | null)} })
    invoiceStatusCounts?: (InvoiceStatusCountsGenqlSelection & { __args?: {filter?: (InvoiceFilter | null)} })
    invoices?: (InvoiceResultPageGenqlSelection & { __args?: {filter?: (InvoiceFilter | null), pagination?: (PaginationInput | null), sorting?: (InvoiceSortOption[] | null)} })
    iotP2PRelayInfo?: P2PRelayInfoGenqlSelection
    itemAliases?: (ItemAliasResultPageGenqlSelection & { __args?: {filter?: (ItemAliasFilter | null), pagination?: (PaginationInput | null), sorting?: (ItemAliasSortOption[] | null)} })
    itemGroups?: (ItemGroupResultPageGenqlSelection & { __args?: {filter?: (ItemGroupFilter | null), pagination?: (PaginationInput | null), sorting?: (ItemGroupSortOption[] | null)} })
    itemPriceConfiguration?: (ItemPriceConfigurationGenqlSelection & { __args: {id: Scalars['ID']} })
    itemPriceConfigurations?: (ItemPriceConfigurationResultPageGenqlSelection & { __args?: {filter?: (ItemPriceConfigurationFilter | null), pagination?: (PaginationInput | null), sorting?: (ItemPriceConfigurationSortOption[] | null)} })
    itemPricings?: (ItemPricingGenqlSelection & { __args: {asOf?: (Scalars['ZonedDateTime'] | null), priceListId: Scalars['ID'], priceListType: PriceListType} })
    items?: (ItemResultPageGenqlSelection & { __args?: {filter?: (ItemFilter | null), pagination?: (PaginationInput | null), sorting?: (ItemSortOption[] | null)} })
    load?: (LoadGenqlSelection & { __args: {id: Scalars['ID']} })
    loadBoard?: (LoadBoardGenqlSelection & { __args?: {facilityIDs?: (Scalars['ID'][] | null), filter?: (ServiceFilter | null)} })
    loadReconciliation?: (LoadReconciliationGenqlSelection & { __args: {loadId: Scalars['ID']} })
    loadReconciliationSummary?: (LoadReconciliationSummaryResultPageGenqlSelection & { __args?: {filter?: (LoadFilter | null), pagination?: (PaginationInput | null)} })
    loadStatusCounts?: (LoadStatusCountsGenqlSelection & { __args?: {filter?: (LoadFilter | null)} })
    loads?: (LoadResultPageGenqlSelection & { __args?: {filter?: (LoadFilter | null), pagination?: (PaginationInput | null), sorting?: (LoadSortOption[] | null)} })
    locationFreightPricing?: (LocationFreightPricingGenqlSelection & { __args: {id: Scalars['ID']} })
    locationFreightPricings?: (LocationFreightPricingResultPageGenqlSelection & { __args?: {filter?: (LocationFreightPricingFilter | null), pagination?: (PaginationInput | null), sorting?: (LocationFreightPricingSortOption[] | null)} })
    notificationFeed?: (NotificationFeedPageGenqlSelection & { __args?: {channel?: (Scalars['String'] | null), cursor?: (NotificationFeedCursor | null), limit?: (Scalars['Int'] | null)} })
    notificationPreference?: (NotificationPreferenceGenqlSelection & { __args: {id: Scalars['ID']} })
    notificationPreferences?: (NotificationPreferenceResultPageGenqlSelection & { __args?: {filter?: (NotificationPreferenceFilter | null), pagination?: (PaginationInput | null), sorting?: (NotificationPreferenceSortOption[] | null)} })
    notificationType?: (NotificationTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    notificationTypes?: (NotificationTypeResultPageGenqlSelection & { __args?: {filter?: (NotificationTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (NotificationTypeSortOption[] | null)} })
    notificationUnreadCount?: { __args: {channel?: (Scalars['String'] | null)} } | boolean | number
    organizationByName?: (OrganizationGenqlSelection & { __args: {name: Scalars['String']} })
    organizations?: (OrganizationResultPageGenqlSelection & { __args?: {filter?: (OrganizationFilter | null), pagination?: (PaginationInput | null), sorting?: (OrganizationSortOption[] | null)} })
    outboundTollingAgreement?: (OutboundTollingAgreementGenqlSelection & { __args: {id: Scalars['ID']} })
    outboundTollingAgreements?: (OutboundTollingAgreementResultPageGenqlSelection & { __args?: {filter?: (OutboundTollingAgreementFilter | null), pagination?: (PaginationInput | null), sorting?: (OutboundTollingAgreementSortOption[] | null)} })
    paymentTermConfig?: (PaymentTermConfigGenqlSelection & { __args: {id: Scalars['ID']} })
    paymentTermConfigs?: (PaymentTermConfigResultPageGenqlSelection & { __args?: {filter?: (PaymentTermConfigFilter | null), pagination?: (PaginationInput | null), sorting?: (PaymentTermConfigSortOption[] | null)} })
    payments?: (PaymentResultPageGenqlSelection & { __args?: {filter?: (PaymentFilter | null), pagination?: (PaginationInput | null), sorting?: (PaymentSortOption[] | null)} })
    plaidItems?: PlaidItemGenqlSelection
    port?: (PortGenqlSelection & { __args: {id: Scalars['ID']} })
    portByUnLocode?: (PortGenqlSelection & { __args: {unLocode: Scalars['String']} })
    ports?: (PortResultPageGenqlSelection & { __args?: {filter?: (PortFilter | null), pagination?: (PaginationInput | null), sorting?: (PortSortOption[] | null)} })
    positivePayTemplate?: (PositivePayTemplateGenqlSelection & { __args: {id: Scalars['ID']} })
    positivePayTemplates?: (PositivePayTemplateResultPageGenqlSelection & { __args?: {filter?: (PositivePayTemplateFilter | null), pagination?: (PaginationInput | null), sorting?: (PositivePayTemplateSortOption[] | null)} })
    pricingCheckCounterpartiesInGroups?: { __args: {counterpartyIds: Scalars['ID'][], operationType?: (OperationType | null)} }
    pricingCustomPriceListHistory?: (OutboxEventGenqlSelection & { __args: {id: Scalars['ID']} })
    pricingDefaultPriceListHistory?: (OutboxEventGenqlSelection & { __args: {id: Scalars['ID']} })
    pricingItemPricingsWithDirtyTracking?: (ItemPricingDirtyAwareResultGenqlSelection & { __args: {asOf?: (Scalars['ZonedDateTime'] | null), dirtyProductPricingIds?: (Scalars['ID'][] | null), priceListId: Scalars['ID'], priceListType: PriceListType} })
    pricingVariableHistory?: (OutboxEventGenqlSelection & { __args: {id: Scalars['ID']} })
    printer?: (PrinterGenqlSelection & { __args: {id: Scalars['ID']} })
    printers?: (PrinterResultPageGenqlSelection & { __args?: {filter?: (PrinterFilter | null), pagination?: (PaginationInput | null), sorting?: (PrinterSortOption[] | null)} })
    processingType?: (ProcessingTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    processingTypes?: (ProcessingTypeResultPageGenqlSelection & { __args?: {filter?: (ProcessingTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (ProcessingTypeSortOption[] | null)} })
    purchaseLoad?: (PurchaseLoadGenqlSelection & { __args: {id: Scalars['ID']} })
    purchaseLoads?: (PurchaseLoadResultPageGenqlSelection & { __args?: {filter?: (PurchaseLoadFilter | null), pagination?: (PaginationInput | null), sorting?: (PurchaseLoadSortOption[] | null)} })
    purchaseOrderCountByStatus?: (PurchaseOrderStatusCountsGenqlSelection & { __args?: {accountIds?: (Scalars['ID'][] | null), facilityIds?: (Scalars['ID'][] | null)} })
    purchaseOrderFreight?: (PurchaseOrderFreightGenqlSelection & { __args: {id: Scalars['ID']} })
    purchaseOrderFreights?: (PurchaseOrderFreightResultPageGenqlSelection & { __args?: {filter?: (PurchaseOrderFreightFilter | null), pagination?: (PaginationInput | null), sorting?: (PurchaseOrderFreightSortOption[] | null)} })
    purchaseOrders?: (PurchaseOrderResultPageGenqlSelection & { __args?: {filter?: (PurchaseOrderFilter | null), pagination?: (PaginationInput | null), sorting?: (PurchaseOrderSortOption[] | null)} })
    quote?: (QuoteGenqlSelection & { __args: {id: Scalars['ID']} })
    quotes?: (QuoteResultPageGenqlSelection & { __args?: {filter?: (QuoteFilter | null), pagination?: (PaginationInput | null), sorting?: (QuoteSortOption[] | null)} })
    resolveItemPrice?: (ItemPriceGenqlSelection & { __args: {input: ResolveItemPriceInput} })
    route?: (RouteGenqlSelection & { __args: {id: Scalars['ID']} })
    routeFreight?: (RouteFreightGenqlSelection & { __args: {id: Scalars['ID']} })
    routeFreights?: (RouteFreightResultPageGenqlSelection & { __args?: {filter?: (RouteFreightFilter | null), pagination?: (PaginationInput | null), sorting?: (RouteFreightSortOption[] | null)} })
    routeLegs?: (RouteLegGenqlSelection & { __args: {serviceIds: Scalars['ID'][]} })
    routeValidationOverride?: (RouteValidationOverrideGenqlSelection & { __args: {id: Scalars['ID']} })
    routeValidationOverrides?: (RouteValidationOverrideResultPageGenqlSelection & { __args?: {filter?: (RouteValidationOverrideFilter | null), pagination?: (PaginationInput | null), sorting?: (RouteValidationOverrideSortOption[] | null)} })
    routes?: (RouteResultPageGenqlSelection & { __args?: {filter?: (RouteFilter | null), pagination?: (PaginationInput | null), sorting?: (RouteSortOption[] | null)} })
    salesOrderFreight?: (SalesOrderFreightGenqlSelection & { __args: {id: Scalars['ID']} })
    salesOrderFreights?: (SalesOrderFreightResultPageGenqlSelection & { __args?: {filter?: (SalesOrderFreightFilter | null), pagination?: (PaginationInput | null), sorting?: (SalesOrderFreightSortOption[] | null)} })
    salesOrders?: (SalesOrderResultPageGenqlSelection & { __args?: {filter?: (SalesOrderFilter | null), pagination?: (PaginationInput | null), sorting?: (SalesOrderSortOption[] | null)} })
    scale?: (ScaleGenqlSelection & { __args: {id: Scalars['ID']} })
    scales?: (ScaleResultPageGenqlSelection & { __args?: {filter?: (ScaleFilter | null), pagination?: (PaginationInput | null), sorting?: (ScaleSortOption[] | null)} })
    scanner?: (ScannerGenqlSelection & { __args: {id: Scalars['ID']} })
    scanners?: (ScannerResultPageGenqlSelection & { __args?: {filter?: (ScannerFilter | null), pagination?: (PaginationInput | null), sorting?: (ScannerSortOption[] | null)} })
    service?: (ServiceGenqlSelection & { __args: {id: Scalars['ID']} })
    serviceType?: (ServiceTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    serviceTypeTaskDefinition?: (ServiceTypeTaskDefinitionGenqlSelection & { __args: {id: Scalars['ID']} })
    serviceTypeTaskDefinitions?: (ServiceTypeTaskDefinitionResultPageGenqlSelection & { __args?: {filter?: (ServiceTypeTaskDefinitionFilter | null), pagination?: (PaginationInput | null), sorting?: (ServiceTypeTaskDefinitionSortOption[] | null)} })
    serviceTypes?: (ServiceTypeResultPageGenqlSelection & { __args?: {filter?: (ServiceTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (ServiceTypeSortOption[] | null)} })
    services?: (ServiceResultPageGenqlSelection & { __args?: {filter?: (ServiceFilter | null), pagination?: (PaginationInput | null), sorting?: (ServiceSortOption[] | null)} })
    setting?: (SettingGenqlSelection & { __args: {id: Scalars['String']} })
    settings?: (SettingResultPageGenqlSelection & { __args?: {filter?: (SettingFilter | null), pagination?: (PaginationInput | null), sorting?: (SettingSortOption[] | null)} })
    settingsGroup?: (SettingsGroupGenqlSelection & { __args: {id: Scalars['ID']} })
    settingsGroups?: (SettingsGroupResultPageGenqlSelection & { __args?: {filter?: (SettingsGroupFilter | null), pagination?: (PaginationInput | null), sorting?: (SettingsGroupSortOption[] | null)} })
    shippingCarrier?: (ShippingCarrierGenqlSelection & { __args: {id: Scalars['ID']} })
    shippingCarriers?: (ShippingCarrierResultPageGenqlSelection & { __args?: {filter?: (ShippingCarrierFilter | null), pagination?: (PaginationInput | null), sorting?: (ShippingCarrierSortOption[] | null)} })
    sidecar?: (SidecarGenqlSelection & { __args: {id: Scalars['ID']} })
    sidecars?: (SidecarResultPageGenqlSelection & { __args?: {filter?: (SidecarFilter | null), pagination?: (PaginationInput | null), sorting?: (SidecarSortOption[] | null)} })
    storageQuota?: StorageQuotaGenqlSelection
    task?: (TaskGenqlSelection & { __args: {id: Scalars['ID']} })
    taskService?: (TaskServiceGenqlSelection & { __args: {id: Scalars['ID']} })
    taskServices?: (TaskServiceResultPageGenqlSelection & { __args?: {filter?: (TaskServiceFilter | null), pagination?: (PaginationInput | null), sorting?: (TaskServiceSortOption[] | null)} })
    tasks?: (TaskResultPageGenqlSelection & { __args?: {filter?: (TaskFilter | null), pagination?: (PaginationInput | null), sorting?: (TaskSortOption[] | null)} })
    ticketFreight?: (TicketFreightGenqlSelection & { __args: {id: Scalars['ID']} })
    ticketFreights?: (TicketFreightResultPageGenqlSelection & { __args?: {filter?: (TicketFreightFilter | null), pagination?: (PaginationInput | null), sorting?: (TicketFreightSortOption[] | null)} })
    tollReceipt?: (TollReceiptGenqlSelection & { __args: {id: Scalars['ID']} })
    tollReceipts?: (TollReceiptResultPageGenqlSelection & { __args?: {filter?: (TollReceiptFilter | null), pagination?: (PaginationInput | null), sorting?: (TollReceiptSortOption[] | null)} })
    tollShipment?: (TollShipmentGenqlSelection & { __args: {id: Scalars['ID']} })
    tollShipments?: (TollShipmentResultPageGenqlSelection & { __args?: {filter?: (TollShipmentFilter | null), pagination?: (PaginationInput | null), sorting?: (TollShipmentSortOption[] | null)} })
    tradeBrokeredOrderCalculateMargins?: (ItemMarginResultGenqlSelection & { __args: {input: CalculateBrokeredMarginsInput} })
    tradeBrokeredOrderValidate?: (BrokeredOrderValidationResultGenqlSelection & { __args: {id: Scalars['ID']} })
    tradeItemPositions?: (ItemPositionResultPageGenqlSelection & { __args?: {filter?: (ItemPositionFilter | null), pagination?: (PaginationInput | null), sorting?: (ItemPositionSortOption[] | null)} })
    tradeOutboxEventCounts?: TradeOutboxEventCountsGenqlSelection
    tradeOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (TradeOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    trailer?: (TrailerGenqlSelection & { __args: {id: Scalars['ID']} })
    trailers?: (TrailerResultPageGenqlSelection & { __args?: {filter?: (TrailerFilter | null), pagination?: (PaginationInput | null), sorting?: (TrailerSortOption[] | null)} })
    transportationAccounts?: (AccountGenqlSelection & { __args?: {filter?: (TransportationAccountsFilterInput | null), pagination?: (PaginationInput | null)} })
    transportationFacilities?: (FacilityGenqlSelection & { __args?: {filter?: (TransportationFacilitiesFilterInput | null), pagination?: (PaginationInput | null)} })
    transportationOutboxEventCounts?: TransportationOutboxEventCountsGenqlSelection
    transportationOutboxEvents?: (OutboxEventResultPageGenqlSelection & { __args?: {filter?: (TransportationOutboxEventFilter | null), pagination?: (PaginationInput | null)} })
    transportationRouteValidate?: (RouteValidationResultGenqlSelection & { __args: {id: Scalars['ID']} })
    transportationServiceValidate?: (RouteValidationResultGenqlSelection & { __args: {id: Scalars['ID']} })
    transportationType?: (TransportationTypeGenqlSelection & { __args: {id: Scalars['ID']} })
    transportationTypes?: (TransportationTypeResultPageGenqlSelection & { __args?: {filter?: (TransportationTypeFilter | null), pagination?: (PaginationInput | null), sorting?: (TransportationTypeSortOption[] | null)} })
    truck?: (TruckGenqlSelection & { __args: {id: Scalars['ID']} })
    trucks?: (TruckResultPageGenqlSelection & { __args?: {filter?: (TruckFilter | null), pagination?: (PaginationInput | null), sorting?: (TruckSortOption[] | null)} })
    userContactsList?: (UserContactsListResultGenqlSelection & { __args: {filter: UserContactsFilter} })
    userPreferences?: (UserPreferencesGenqlSelection & { __args: {userId: Scalars['ID']} })
    users?: (UserResultPageGenqlSelection & { __args?: {filter?: (UserFilter | null), pagination?: (PaginationInput | null), sorting?: (UserSortOption[] | null)} })
    variable?: (VariableGenqlSelection & { __args: {id: Scalars['ID']} })
    variables?: (VariableResultPageGenqlSelection & { __args?: {filter?: (VariableFilter | null), pagination?: (PaginationInput | null), sorting?: (VariableSortOption[] | null)} })
    voucherTemplate?: (VoucherTemplateGenqlSelection & { __args: {id: Scalars['ID']} })
    voucherTemplates?: (VoucherTemplateResultPageGenqlSelection & { __args?: {filter?: (VoucherTemplateFilter | null), pagination?: (PaginationInput | null), sorting?: (VoucherTemplateSortOption[] | null)} })
    warehouseCredential?: (WarehouseCredentialGenqlSelection & { __args: {id: Scalars['ID']} })
    warehouseCredentials?: (WarehouseCredentialResultPageGenqlSelection & { __args?: {filter?: (WarehouseCredentialFilter | null), pagination?: (PaginationInput | null), sorting?: (WarehouseCredentialSortOption[] | null)} })
    workOrder?: (WorkOrderGenqlSelection & { __args: {id: Scalars['ID']} })
    workOrders?: (WorkOrderResultPageGenqlSelection & { __args?: {filter?: (WorkOrderFilter | null), pagination?: (PaginationInput | null), sorting?: (WorkOrderSortOption[] | null)} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QuoteGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    convertedToOrder?: SalesOrderGenqlSelection
    convertedToOrderId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    documentNumber?: boolean | number
    expectedShipDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    freightCoveredByCustomer?: boolean | number
    freightTerm?: boolean | number
    id?: boolean | number
    lineItems?: QuoteLineItemGenqlSelection
    notes?: boolean | number
    paymentCurrency?: boolean | number
    paymentTerm?: boolean | number
    quoteDeadline?: boolean | number
    status?: boolean | number
    subtotal?: MoneyGenqlSelection
    terms?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    validUntil?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QuoteFilter {accountIds?: (Scalars['ID'][] | null),documentNumber?: (Scalars['String'] | null),facilityIds?: (Scalars['ID'][] | null),fromCreatedAt?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),includeLineItems?: (Scalars['Boolean'] | null),searchTerm?: (Scalars['String'] | null),statuses?: (QuoteStatus[] | null),toCreatedAt?: (Scalars['ZonedDateTime'] | null),types?: (QuoteType[] | null)}

export interface QuoteInput {accountId: Scalars['ID'],documentNumber?: (Scalars['String'] | null),expectedShipDate?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),freightCoveredByCustomer?: (Scalars['Boolean'] | null),freightTerm?: (FreightTerm | null),lineItems?: (CreateQuoteLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentCurrency?: (CurrencyCode | null),paymentTerm?: (PaymentTerm | null),quoteDeadline?: (Scalars['ZonedDateTime'] | null),terms?: (Scalars['String'] | null),type: QuoteType,validUntil?: (Scalars['ZonedDateTime'] | null)}

export interface QuoteLineItemGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    notes?: boolean | number
    packageFormat?: boolean | number
    quantity?: boolean | number
    quote?: QuoteGenqlSelection
    quoteId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalPrice?: MoneyGenqlSelection
    unit?: boolean | number
    unitPrice?: MoneyGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QuoteLineItemFilter {ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),packageFormat?: (Scalars['String'] | null),quoteId?: (Scalars['ID'] | null),quoteIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface QuoteLineItemResultPageGenqlSelection{
    entries?: QuoteLineItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QuoteResultPageGenqlSelection{
    entries?: QuoteGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface QuoteUpdateInput {accountId?: (Scalars['ID'] | null),documentNumber?: (Scalars['String'] | null),expectedShipDate?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),freightCoveredByCustomer?: (Scalars['Boolean'] | null),freightTerm?: (FreightTerm | null),lineItems?: (UpdateQuoteLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentCurrency?: (CurrencyCode | null),paymentTerm?: (PaymentTerm | null),quoteDeadline?: (Scalars['ZonedDateTime'] | null),terms?: (Scalars['String'] | null),type?: (QuoteType | null),validUntil?: (Scalars['ZonedDateTime'] | null)}

export interface ReceiveInvoiceInput {accountId?: (Scalars['ID'] | null),achNumber?: (Scalars['String'] | null),checkAttn?: (Scalars['String'] | null),checkFacilityId?: (Scalars['ID'] | null),checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),creatorId?: (Scalars['ID'] | null),creatorPlatform?: (CreatorPlatform | null),financialAccountId: Scalars['ID'],invoices: ReceiveInvoiceItemInput[],paymentMethod: PaymentMethod,transactionDate: Scalars['CalendarDate'],wireNumber?: (Scalars['String'] | null)}

export interface ReceiveInvoiceItemInput {appliedAmount: MoneyInput,invoiceId: Scalars['ID']}

export interface ReceiveInvoiceResultGenqlSelection{
    belowWarningThreshold?: boolean | number
    payment?: PaymentGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReceivedLineItemGenqlSelection{
    customerGrossWeight?: WeightGenqlSelection
    customerTareWeight?: WeightGenqlSelection
    customerUnitPrice?: MoneyGenqlSelection
    grossWeight?: WeightGenqlSelection
    id?: boolean | number
    itemId?: boolean | number
    loadLineItemId?: boolean | number
    materialType?: boolean | number
    netWeight?: WeightGenqlSelection
    notes?: boolean | number
    pricingUnit?: boolean | number
    tareWeight?: WeightGenqlSelection
    timestamps?: TimestampsGenqlSelection
    totalValue?: MoneyGenqlSelection
    unitPrice?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReceivedLineItemInput {customerGrossWeight?: (WeightInput | null),customerTareWeight?: (WeightInput | null),customerUnitPrice?: (MoneyInput | null),grossWeight?: (WeightInput | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),loadLineItemId: Scalars['ID'],materialType: Scalars['String'],notes?: (Scalars['String'] | null),pricingUnit: Scalars['String'],tareWeight?: (WeightInput | null),unitPrice?: (MoneyInput | null)}

export interface ReconcileCashDrawerInput {financialAccountId: Scalars['ID'],notes?: (Scalars['String'] | null),physicalCount: Scalars['Decimal']}

export interface ReconcileCashDrawerPayloadGenqlSelection{
    adjustment?: FinancialAccountAdjustmentGenqlSelection
    discrepancy?: boolean | number
    systemBalance?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReconciliationDeductionGenqlSelection{
    deductionType?: DeductionTypeGenqlSelection
    deductionTypeId?: boolean | number
    id?: boolean | number
    loadLineItemId?: boolean | number
    priceQuantity?: MoneyGenqlSelection
    receivedLineItemId?: boolean | number
    reconciliationId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalDeduction?: MoneyGenqlSelection
    weightQuantity?: WeightGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ReconciliationDeductionInput {deductionTypeId: Scalars['ID'],id?: (Scalars['ID'] | null),loadLineItemId?: (Scalars['ID'] | null),priceQuantity?: (MoneyInput | null),receivedLineItemId?: (Scalars['ID'] | null),weightQuantity?: (WeightInput | null)}

export interface RecurringScheduleGenqlSelection{
    dayOfMonth?: boolean | number
    duration?: boolean | number
    firstOccurrenceAt?: boolean | number
    interval?: boolean | number
    monthlyOccurrence?: boolean | number
    monthlyWeekday?: boolean | number
    repeatUntil?: boolean | number
    type?: boolean | number
    weekdays?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RecurringScheduleInput {dayOfMonth?: (Scalars['Int'] | null),interval: Scalars['Int'],monthlyOccurrence?: (MonthlyOccurrence | null),monthlyWeekday?: (Weekday | null),type: RecurrenceType,weekdays?: (Weekday[] | null)}

export interface RemoveAdvanceApplicationInput {documentId: Scalars['ID'],documentType: PaymentApplicationType,paymentId: Scalars['ID']}

export interface RemoveFileFromTemplatePayloadGenqlSelection{
    success?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RemoveUsersFromRoleInput {facilityId: Scalars['ID'],roleId: Scalars['ID'],userIds: Scalars['ID'][]}

export interface ResolveItemPriceInput {counterpartyAccountId?: (Scalars['ID'] | null),currency: Scalars['String'],displayPricingUnit?: (Unit | null),facilityId?: (Scalars['ID'] | null),itemId: Scalars['ID'],operationType: OperationType}

export interface RespondApprovalInput {approved: Scalars['Boolean'],comment?: (Scalars['String'] | null)}

export interface RoleGenqlSelection{
    archived?: boolean | number
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    organizationId?: boolean | number
    permissions?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RoleFilter {ids?: (Scalars['ID'][] | null),includeArchived?: (Scalars['Boolean'] | null),pagination?: (PaginationInput | null),searchTerm?: (Scalars['String'] | null),sorting?: (RoleSortOption[] | null),type?: (RoleType | null)}

export interface RoleResultPageGenqlSelection{
    entries?: RoleGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteGenqlSelection{
    assignedAt?: boolean | number
    assignmentStatus?: boolean | number
    completedAt?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    documentNumber?: boolean | number
    driver?: DriverGenqlSelection
    driverId?: boolean | number
    driverProgress?: boolean | number
    estimatedArrival?: boolean | number
    facilityGroupId?: boolean | number
    haulerId?: boolean | number
    haulerProgress?: boolean | number
    id?: boolean | number
    isTemplate?: boolean | number
    legs?: RouteLegGenqlSelection
    notes?: boolean | number
    priority?: boolean | number
    rank?: boolean | number
    routeDate?: boolean | number
    services?: ServiceGenqlSelection
    startedAt?: boolean | number
    status?: boolean | number
    tasks?: TaskGenqlSelection
    timestamps?: TimestampsGenqlSelection
    trailerId?: boolean | number
    truckId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteAssignInput {assignmentStatus: AssignmentStatus,driverId?: (Scalars['ID'] | null),estimatedArrival?: (Scalars['ZonedDateTime'] | null),haulerId?: (Scalars['ID'] | null),id: Scalars['ID'],trailerId?: (Scalars['ID'] | null),truckId?: (Scalars['ID'] | null)}

export interface RouteFilter {completedAfter?: (Scalars['ZonedDateTime'] | null),completedBefore?: (Scalars['ZonedDateTime'] | null),driverIds?: (Scalars['ID'][] | null),haulerIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),routeDateAfter?: (Scalars['ZonedDateTime'] | null),routeDateBefore?: (Scalars['ZonedDateTime'] | null),routeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),serviceIds?: (Scalars['ID'][] | null),startedAfter?: (Scalars['ZonedDateTime'] | null),startedBefore?: (Scalars['ZonedDateTime'] | null),status?: (RouteStatus[] | null),trailerIds?: (Scalars['ID'][] | null),truckIds?: (Scalars['ID'][] | null)}

export interface RouteFreightGenqlSelection{
    baseCostAmount?: boolean | number
    baseCostCurrencyCode?: boolean | number
    carrierId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    destinationLocationId?: boolean | number
    detentionCostAmount?: boolean | number
    detentionCostCurrencyCode?: boolean | number
    distance?: boolean | number
    freightLaneId?: boolean | number
    fuelSurchargeAmount?: boolean | number
    fuelSurchargeCurrencyCode?: boolean | number
    id?: boolean | number
    originLocationId?: boolean | number
    routeId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalCost?: MoneyGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteFreightFilter {carrierId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),routeId?: (Scalars['ID'] | null)}

export interface RouteFreightInput {baseCostAmount: Scalars['Decimal'],baseCostCurrencyCode: Scalars['String'],carrierId: Scalars['ID'],destinationLocationId?: (Scalars['ID'] | null),detentionCostAmount: Scalars['Decimal'],detentionCostCurrencyCode: Scalars['String'],distance?: (Scalars['Decimal'] | null),freightLaneId?: (Scalars['ID'] | null),fuelSurchargeAmount: Scalars['Decimal'],fuelSurchargeCurrencyCode: Scalars['String'],originLocationId?: (Scalars['ID'] | null),routeId?: (Scalars['ID'] | null)}

export interface RouteFreightResultPageGenqlSelection{
    entries?: RouteFreightGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteFreightUpdateInput {baseCostAmount?: (Scalars['Decimal'] | null),baseCostCurrencyCode?: (Scalars['String'] | null),carrierId?: (Scalars['ID'] | null),destinationLocationId?: (Scalars['ID'] | null),detentionCostAmount?: (Scalars['Decimal'] | null),detentionCostCurrencyCode?: (Scalars['String'] | null),distance?: (Scalars['Decimal'] | null),freightLaneId?: (Scalars['ID'] | null),fuelSurchargeAmount?: (Scalars['Decimal'] | null),fuelSurchargeCurrencyCode?: (Scalars['String'] | null),originLocationId?: (Scalars['ID'] | null),routeId?: (Scalars['ID'] | null)}

export interface RouteLegGenqlSelection{
    distance?: boolean | number
    duration?: boolean | number
    end?: ServiceGenqlSelection
    start?: ServiceGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteResultPageGenqlSelection{
    entries?: RouteGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteTransitionInput {id: Scalars['ID'],notes?: (Scalars['String'] | null),status: RouteStatus}

export interface RouteValidationOverrideGenqlSelection{
    approvedBy?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityGroup?: FacilityGroupGenqlSelection
    facilityGroupId?: boolean | number
    id?: boolean | number
    justification?: boolean | number
    routeId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    violationKey?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteValidationOverrideFilter {facilityGroupId?: (Scalars['ID'] | null),facilityGroupIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),justification?: (Scalars['String'] | null),routeId?: (Scalars['ID'] | null),routeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),violationKey?: (Scalars['String'] | null)}

export interface RouteValidationOverrideInput {approvedBy: Scalars['ID'],facilityGroupId: Scalars['ID'],justification: Scalars['String'],routeId: Scalars['ID'],violationKey: Scalars['String']}

export interface RouteValidationOverrideResultPageGenqlSelection{
    entries?: RouteValidationOverrideGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteValidationOverrideUpdateInput {approvedBy?: (Scalars['ID'] | null),facilityGroupId?: (Scalars['ID'] | null),justification?: (Scalars['String'] | null),routeId?: (Scalars['ID'] | null),violationKey?: (Scalars['String'] | null)}

export interface RouteValidationResultGenqlSelection{
    canOverride?: boolean | number
    isValid?: boolean | number
    requiredOverrides?: boolean | number
    violations?: RouteValidationViolationGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface RouteValidationViolationGenqlSelection{
    assetId?: boolean | number
    message?: boolean | number
    overrideKey?: boolean | number
    routePosition?: boolean | number
    serviceId?: boolean | number
    severity?: boolean | number
    taskId?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderGenqlSelection{
    account?: AccountGenqlSelection
    accountId?: boolean | number
    accountRepresentative?: UserGenqlSelection
    accountRepresentativeId?: boolean | number
    billingAddress?: AddressGenqlSelection
    billingAddressId?: boolean | number
    bookings?: BookingGenqlSelection
    completionNotes?: boolean | number
    contact?: ContactGenqlSelection
    contactId?: boolean | number
    counterpartyReferenceNumber?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customAttributes?: boolean | number
    customerExternalNotes?: boolean | number
    customerFiles?: FileGenqlSelection
    customerInternalNotes?: boolean | number
    doNotShip?: boolean | number
    documentNumber?: boolean | number
    endDate?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    freightTerm?: boolean | number
    fulfilledPercentage?: boolean | number
    id?: boolean | number
    lineItems?: SalesOrderLineItemGenqlSelection
    netWeight?: WeightGenqlSelection
    organization?: OrganizationGenqlSelection
    organizationId?: boolean | number
    paymentCurrency?: boolean | number
    paymentTerm?: boolean | number
    recyclerExternalNotes?: boolean | number
    recyclerFiles?: FileGenqlSelection
    recyclerInternalNotes?: boolean | number
    shippedLoadsCount?: boolean | number
    shippingAddress?: AddressGenqlSelection
    shippingAddressId?: boolean | number
    startDate?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalPrice?: MoneyGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    weightDisplayUnit?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderCreateInput {accountId: Scalars['ID'],accountRepresentativeId?: (Scalars['ID'] | null),billingAddress?: (AddressInput | null),billingAddressId?: (Scalars['ID'] | null),bookingIds?: (Scalars['ID'][] | null),completionNotes?: (Scalars['String'] | null),contactId?: (Scalars['ID'] | null),counterpartyReferenceNumber?: (Scalars['String'] | null),customAttributes?: (Scalars['Map'] | null),customerExternalNotes?: (Scalars['String'] | null),customerInternalNotes?: (Scalars['String'] | null),doNotShip?: (Scalars['Boolean'] | null),documentNumber?: (Scalars['String'] | null),endDate?: (Scalars['CalendarDate'] | null),facilityId: Scalars['ID'],freightTerm?: (FreightTerm | null),lineItems?: (SalesOrderLineItemInput[] | null),paymentCurrency?: (Scalars['String'] | null),paymentTerm?: (PaymentTerm | null),recyclerExternalNotes?: (Scalars['String'] | null),recyclerInternalNotes?: (Scalars['String'] | null),shippingAddress?: (AddressInput | null),shippingAddressId?: (Scalars['ID'] | null),startDate?: (Scalars['CalendarDate'] | null),status: SalesOrderStatus,type: SalesOrderType,weightDisplayUnit?: (WeightDisplayUnit | null)}

export interface SalesOrderCustomerFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderCustomerFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface SalesOrderFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface SalesOrderFilter {accountIds?: (Scalars['ID'][] | null),accountRepresentativeIds?: (Scalars['ID'][] | null),contactIds?: (Scalars['ID'][] | null),counterpartyReferenceNumber?: (Scalars['String'] | null),createdBy?: (Scalars['ID'][] | null),documentNumber?: (Scalars['String'] | null),facilityIds?: (Scalars['ID'][] | null),freightTerms?: (FreightTerm[] | null),fromCreatedAt?: (Scalars['CalendarDate'] | null),fromEndDate?: (Scalars['CalendarDate'] | null),fromStartDate?: (Scalars['CalendarDate'] | null),ids?: (Scalars['ID'][] | null),includeLineItems?: (Scalars['Boolean'] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),paymentCurrencies?: (Scalars['String'][] | null),paymentTerms?: (PaymentTerm[] | null),searchTerm?: (Scalars['String'] | null),status?: (SalesOrderStatus[] | null),toCreatedAt?: (Scalars['CalendarDate'] | null),toEndDate?: (Scalars['CalendarDate'] | null),toStartDate?: (Scalars['CalendarDate'] | null),type?: (SalesOrderType[] | null),updatedBy?: (Scalars['ID'][] | null)}

export interface SalesOrderFreightGenqlSelection{
    carrierId?: boolean | number
    chargebackFormula?: boolean | number
    chargebackVariableIds?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    freightLaneId?: boolean | number
    fuelSurchargeFormula?: boolean | number
    fuelSurchargeMode?: boolean | number
    fuelSurchargeVariableIds?: boolean | number
    id?: boolean | number
    notes?: boolean | number
    rateFormula?: boolean | number
    rateVariableIds?: boolean | number
    salesOrderId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderFreightFilter {ids?: (Scalars['ID'][] | null),salesOrderId?: (Scalars['ID'] | null),salesOrderIds?: (Scalars['ID'][] | null)}

export interface SalesOrderFreightInput {carrierId?: (Scalars['ID'] | null),chargebackFormula?: (Scalars['String'] | null),chargebackVariableIds?: (Scalars['String'] | null),freightLaneId?: (Scalars['String'] | null),fuelSurchargeFormula?: (Scalars['String'] | null),fuelSurchargeMode?: (Scalars['String'] | null),fuelSurchargeVariableIds?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),rateFormula?: (Scalars['String'] | null),rateVariableIds?: (Scalars['String'] | null),salesOrderId: Scalars['ID']}

export interface SalesOrderFreightResultPageGenqlSelection{
    entries?: SalesOrderFreightGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderFreightUpdateInput {carrierId?: (Scalars['ID'] | null),chargebackFormula?: (Scalars['String'] | null),chargebackVariableIds?: (Scalars['String'] | null),freightLaneId?: (Scalars['String'] | null),fuelSurchargeFormula?: (Scalars['String'] | null),fuelSurchargeMode?: (Scalars['String'] | null),fuelSurchargeVariableIds?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),rateFormula?: (Scalars['String'] | null),rateVariableIds?: (Scalars['String'] | null),salesOrderId?: (Scalars['ID'] | null)}

export interface SalesOrderLineItemGenqlSelection{
    id?: boolean | number
    item?: ItemGenqlSelection
    quantity?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalPrice?: MoneyGenqlSelection
    unit?: boolean | number
    unitPrice?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderLineItemInput {id?: (Scalars['ID'] | null),itemId: Scalars['ID'],quantity: Scalars['Decimal'],totalPrice: MoneyInput,unit: Unit,unitPrice: MoneyInput}

export interface SalesOrderRecyclerFileCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderRecyclerFileInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface SalesOrderResultPageGenqlSelection{
    entries?: SalesOrderGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SalesOrderUpdateInput {accountId?: (Scalars['ID'] | null),accountRepresentativeId?: (Scalars['ID'] | null),billingAddress?: (AddressInput | null),billingAddressId?: (Scalars['ID'] | null),bookingIds?: (Scalars['ID'][] | null),completionNotes?: (Scalars['String'] | null),contactId?: (Scalars['ID'] | null),counterpartyReferenceNumber?: (Scalars['String'] | null),customAttributes?: (Scalars['Map'] | null),customerExternalNotes?: (Scalars['String'] | null),customerInternalNotes?: (Scalars['String'] | null),doNotShip?: (Scalars['Boolean'] | null),documentNumber?: (Scalars['String'] | null),endDate?: (Scalars['CalendarDate'] | null),facilityId?: (Scalars['ID'] | null),freightTerm?: (FreightTerm | null),lineItems?: (SalesOrderLineItemInput[] | null),paymentCurrency?: (Scalars['String'] | null),paymentTerm?: (PaymentTerm | null),recyclerExternalNotes?: (Scalars['String'] | null),recyclerInternalNotes?: (Scalars['String'] | null),shippingAddress?: (AddressInput | null),shippingAddressId?: (Scalars['ID'] | null),startDate?: (Scalars['CalendarDate'] | null),status?: (SalesOrderStatus | null),type?: (SalesOrderType | null),weightDisplayUnit?: (WeightDisplayUnit | null)}

export interface SalesOrderUpdateResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    removedBookingId?: boolean | number
    requiresConfirmation?: boolean | number
    salesOrder?: SalesOrderGenqlSelection
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScaleGenqlSelection{
    baudRate?: boolean | number
    camera?: CameraGenqlSelection
    cameraId?: boolean | number
    connectionType?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    dataBits?: boolean | number
    driverType?: boolean | number
    id?: boolean | number
    lastSeenAt?: boolean | number
    measurementIncrement?: boolean | number
    measurementMode?: boolean | number
    name?: boolean | number
    onDemandString?: boolean | number
    online?: boolean | number
    parity?: boolean | number
    scaleFormatType?: boolean | number
    serialPortPath?: boolean | number
    sidecar?: SidecarGenqlSelection
    sidecarId?: boolean | number
    status?: boolean | number
    stopBits?: boolean | number
    tcpHost?: boolean | number
    tcpPort?: boolean | number
    timestamps?: TimestampsGenqlSelection
    uniqueId?: boolean | number
    unitOfMeasurement?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScaleFilter {facilityId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),sidecarId?: (Scalars['ID'] | null),status?: (ScaleStatus[] | null)}

export interface ScaleResultPageGenqlSelection{
    entries?: ScaleGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScannerGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    driverType?: boolean | number
    firmwareVersion?: boolean | number
    id?: boolean | number
    lastSeenAt?: boolean | number
    manufacturer?: boolean | number
    model?: boolean | number
    name?: boolean | number
    online?: boolean | number
    sidecar?: SidecarGenqlSelection
    sidecarId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    uniqueId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScannerFilter {facilityId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),sidecarId?: (Scalars['ID'] | null),status?: (ScannerStatus[] | null)}

export interface ScannerResultPageGenqlSelection{
    entries?: ScannerGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScheduleTriggerConfigOutputGenqlSelection{
    cron?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ScheduleTriggerNodeGenqlSelection{
    cronExpression?: boolean | number
    description?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    timezone?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SemaphorTokenGenqlSelection{
    accessToken?: boolean | number
    dashboardId?: boolean | number
    refreshToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SendAssistantChatMessageInput {content: Scalars['String'],fileIds?: (Scalars['ID'][] | null),metadata?: (ChatMetadataInput | null)}

export interface SendPriceListNotificationInput {bcc?: (Scalars['String'][] | null),body?: (Scalars['String'] | null),cc?: (Scalars['String'][] | null),priceListId: Scalars['ID'],priceListType: Scalars['String'],subject?: (Scalars['String'] | null),templateFileId?: (Scalars['String'] | null),to: Scalars['String'][]}

export interface SendPriceListNotificationResultGenqlSelection{
    fileId?: boolean | number
    messageId?: boolean | number
    success?: boolean | number
    workflowId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceGenqlSelection{
    account?: AccountGenqlSelection
    accountAddress?: AccountAddressGenqlSelection
    accountAddressId?: boolean | number
    accountId?: boolean | number
    actions?: ServiceActionGenqlSelection
    address?: AddressGenqlSelection
    assetRequirements?: ServiceActionGenqlSelection
    assignedAt?: boolean | number
    assignmentStatus?: boolean | number
    completedAt?: boolean | number
    contactId?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    deadline?: boolean | number
    destinationFacilityId?: boolean | number
    documentNumber?: boolean | number
    driver?: DriverGenqlSelection
    driverId?: boolean | number
    driverNotes?: boolean | number
    driverProgress?: boolean | number
    estimatedArrival?: boolean | number
    externalNotes?: boolean | number
    facility?: FacilityGenqlSelection
    facilityGroupId?: boolean | number
    facilityId?: boolean | number
    haulerId?: boolean | number
    haulerProgress?: boolean | number
    id?: boolean | number
    internalNotes?: boolean | number
    isRequest?: boolean | number
    isTemplate?: boolean | number
    nonDefaultTrailer?: boolean | number
    nonDefaultTruck?: boolean | number
    priority?: boolean | number
    rank?: boolean | number
    recurringSchedule?: RecurringScheduleGenqlSelection
    recurringTaskId?: boolean | number
    relationshipType?: boolean | number
    requirements?: boolean | number
    routeId?: boolean | number
    routePosition?: boolean | number
    scheduledWindowEnd?: boolean | number
    scheduledWindowStart?: boolean | number
    serviceType?: ServiceTypeGenqlSelection
    serviceTypeId?: boolean | number
    startedAt?: boolean | number
    status?: boolean | number
    tasks?: TaskGenqlSelection
    timestamps?: TimestampsGenqlSelection
    trailer?: TrailerGenqlSelection
    trailerId?: boolean | number
    truck?: TruckGenqlSelection
    truckId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceActionGenqlSelection{
    actionType?: boolean | number
    asset?: AssetGenqlSelection
    assetGroup?: boolean | number
    assetId?: boolean | number
    assetType?: AssetTypeGenqlSelection
    assetTypeId?: boolean | number
    quantity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceActionInput {actionType?: (ActionType | null),assetGroup?: (Scalars['Int'] | null),assetId?: (Scalars['ID'] | null),assetTypeId?: (Scalars['ID'] | null),quantity?: (Scalars['Int'] | null)}

export interface ServiceAssetInput {assetId: Scalars['ID']}

export interface ServiceAssetTypeInput {assetGroup?: (Scalars['Int'] | null),assetTypeId: Scalars['ID'],quantity: Scalars['Float']}

export interface ServiceAssignInput {assignmentStatus: AssignmentStatus,driverId?: (Scalars['ID'] | null),estimatedArrival?: (Scalars['ZonedDateTime'] | null),haulerId?: (Scalars['ID'] | null),id: Scalars['ID'],trailerId?: (Scalars['ID'] | null),truckId?: (Scalars['ID'] | null)}

export interface ServiceFilter {accountAddressIds?: (Scalars['ID'][] | null),accountIds?: (Scalars['ID'][] | null),completedAfter?: (Scalars['ZonedDateTime'] | null),completedBefore?: (Scalars['ZonedDateTime'] | null),driverIds?: (Scalars['ID'][] | null),haulerIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),isStandalone?: (Scalars['Boolean'] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),maxPriority?: (Scalars['Int'] | null),minPriority?: (Scalars['Int'] | null),routeIds?: (Scalars['ID'][] | null),scheduledEndAfter?: (Scalars['ZonedDateTime'] | null),scheduledEndBefore?: (Scalars['ZonedDateTime'] | null),scheduledStartAfter?: (Scalars['ZonedDateTime'] | null),scheduledStartBefore?: (Scalars['ZonedDateTime'] | null),searchTerm?: (Scalars['String'] | null),serviceTypeId?: (Scalars['ID'] | null),status?: (ServiceStatus[] | null),trailerIds?: (Scalars['ID'][] | null),truckIds?: (Scalars['ID'][] | null)}

export interface ServiceResultPageGenqlSelection{
    entries?: ServiceGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceTransitionInput {id: Scalars['ID'],notes?: (Scalars['String'] | null),status: ServiceStatus}

export interface ServiceTypeGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    isSystemDefault?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceTypeFilter {description?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),isActive?: (Scalars['Boolean'] | null),isSystemDefault?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface ServiceTypeInput {description?: (Scalars['String'] | null),isActive: Scalars['Boolean'],isSystemDefault: Scalars['Boolean'],name: Scalars['String']}

export interface ServiceTypeResultPageGenqlSelection{
    entries?: ServiceTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceTypeTaskDefinitionGenqlSelection{
    allowLocationOverride?: boolean | number
    assetGroup?: boolean | number
    assetRole?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    fillStateCondition?: boolean | number
    id?: boolean | number
    locationRef?: boolean | number
    sequence?: boolean | number
    serviceTypeId?: boolean | number
    taskType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceTypeTaskDefinitionFilter {assetRole?: (Scalars['String'] | null),fillStateCondition?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),locationRef?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),serviceTypeId?: (Scalars['ID'] | null),serviceTypeIds?: (Scalars['ID'][] | null),taskType?: (TaskType[] | null)}

export interface ServiceTypeTaskDefinitionInlineInput {sequence: Scalars['Int'],taskType: TaskType}

export interface ServiceTypeTaskDefinitionInput {allowLocationOverride: Scalars['Boolean'],assetGroup?: (Scalars['Int'] | null),assetRole?: (Scalars['String'] | null),fillStateCondition?: (Scalars['String'] | null),locationRef?: (Scalars['String'] | null),sequence: Scalars['Int'],serviceTypeId: Scalars['ID'],taskType: TaskType}

export interface ServiceTypeTaskDefinitionResultPageGenqlSelection{
    entries?: ServiceTypeTaskDefinitionGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ServiceTypeTaskDefinitionUpdateInput {allowLocationOverride?: (Scalars['Boolean'] | null),assetGroup?: (Scalars['Int'] | null),assetRole?: (Scalars['String'] | null),fillStateCondition?: (Scalars['String'] | null),locationRef?: (Scalars['String'] | null),sequence?: (Scalars['Int'] | null),serviceTypeId?: (Scalars['ID'] | null),taskType?: (TaskType | null)}

export interface ServiceTypeUpdateInput {description?: (Scalars['String'] | null),isActive?: (Scalars['Boolean'] | null),isSystemDefault?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null)}

export interface SetAgentToolsInput {toolIds: Scalars['String'][]}

export interface SetFileAsTemplateInput {description: Scalars['String'],fileId: Scalars['ID'],isDefault?: (Scalars['Boolean'] | null),type: FileTemplateType}

export interface SetFileAsTemplatePayloadGenqlSelection{
    template?: FileTemplateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SetTemplateAsDefaultPayloadGenqlSelection{
    template?: FileTemplateGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SettingGenqlSelection{
    constraints?: FieldConstraintsGenqlSelection
    dataType?: boolean | number
    defaultValue?: boolean | number
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    scope?: boolean | number
    settingsGroup?: SettingsGroupGenqlSelection
    settingsGroupId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    values?: SettingValueGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SettingFilter {dataType?: (FieldDataType | null),scope?: (SettingScope | null),searchTerm?: (Scalars['String'] | null),settingsGroupId?: (Scalars['ID'] | null)}

export interface SettingResultPageGenqlSelection{
    entries?: SettingGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SettingValueGenqlSelection{
    objectId?: boolean | number
    scope?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SettingsGroupGenqlSelection{
    createdAt?: boolean | number
    description?: boolean | number
    icon?: boolean | number
    id?: boolean | number
    name?: boolean | number
    settings?: SettingGenqlSelection
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SettingsGroupFilter {searchTerm?: (Scalars['String'] | null)}

export interface SettingsGroupResultPageGenqlSelection{
    entries?: SettingsGroupGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShareFileInput {fileId: Scalars['ID'],permission: FilePermission,userIds: Scalars['ID'][]}

export interface ShareFilePayloadGenqlSelection{
    file?: FileGenqlSelection
    sharedWithCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingCarrierGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingCarrierFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface ShippingCarrierInput {facilityId: Scalars['ID'],name: Scalars['String']}

export interface ShippingCarrierResultPageGenqlSelection{
    entries?: ShippingCarrierGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ShippingCarrierUpdateInput {facilityId?: (Scalars['ID'] | null),name?: (Scalars['String'] | null)}

export interface SidecarGenqlSelection{
    connectedAt?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    jitterMs?: boolean | number
    lastHeartbeatAt?: boolean | number
    latencyMs?: boolean | number
    linkSpeedDownstream?: boolean | number
    linkSpeedUpstream?: boolean | number
    localIpAddress?: boolean | number
    multiaddrs?: boolean | number
    name?: boolean | number
    online?: boolean | number
    operatingSystem?: boolean | number
    operatingSystemVersion?: boolean | number
    peerId?: boolean | number
    publicKey?: boolean | number
    remoteIpAddressV4?: boolean | number
    remoteIpAddressV6?: boolean | number
    settings?: SidecarSettingsGenqlSelection
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    version?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SidecarFilter {facilityId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),operatingSystem?: (SidecarOperatingSystem[] | null),status?: (SidecarStatus[] | null)}

export interface SidecarResultPageGenqlSelection{
    entries?: SidecarGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SidecarSettingsGenqlSelection{
    discoveryEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SidecarSettingsInput {discoveryEnabled?: (Scalars['Boolean'] | null)}


/** Represents possible outcomes of a signup completion attempt */
export interface SignUpCompleteResultGenqlSelection{
    on_InvalidSignUpInvitationError?:InvalidSignUpInvitationErrorGenqlSelection,
    on_SignUpCompletedResult?:SignUpCompletedResultGenqlSelection,
    __typename?: boolean | number
}


/** Result returned when a signup invitation is successfully accepted */
export interface SignUpCompletedResultGenqlSelection{
    /** The email address of the user */
    email?: boolean | number
    /** The newly created organization ID */
    organizationId?: boolean | number
    /** Whether the signup was successfully completed */
    success?: boolean | number
    /** The newly created user ID */
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Represents possible outcomes of a signup initiation attempt */
export interface SignUpInitiateResultGenqlSelection{
    on_InvalidCredentialsError?:InvalidCredentialsErrorGenqlSelection,
    on_SignUpInitiatedResult?:SignUpInitiatedResultGenqlSelection,
    __typename?: boolean | number
}


/** Result returned when a signup invitation is successfully created */
export interface SignUpInitiatedResultGenqlSelection{
    /** The email address associated with the invitation */
    email?: boolean | number
    /** Whether the invitation was successfully created */
    success?: boolean | number
    /** The invitation token to be used for completing signup */
    token?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Error returned when SSO authentication is required for the organization */
export interface SsoRequiredErrorGenqlSelection{
    pendingAuthenticationToken?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StandaloneAuthResultGenqlSelection{
    redirectUri?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StartWOPIEditingSessionInput {fileId: Scalars['ID'],permission: WOPIPermission}

export interface StartWOPIEditingSessionPayloadGenqlSelection{
    session?: WOPIEditingSessionGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface StorageQuotaGenqlSelection{
    availableBytes?: boolean | number
    fileCount?: boolean | number
    quotaBytes?: boolean | number
    usagePercentage?: boolean | number
    usedBytes?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SubscriptionGenqlSelection{
    assistantChatEvents?: (AssistantAgentStreamEventGenqlSelection & { __args: {beginningAt?: (Scalars['ID'] | null), chatId: Scalars['ID']} })
    crmAccountAddressChanges?: (AccountAddressGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    crmAccountChanges?: (AccountGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    crmContactChanges?: (ContactGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    crmCustomerInvitationChanges?: (CustomerInvitationGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    filesFilesystemChanged?: FileChangedEventGenqlSelection
    iotCameraEvents?: CameraGenqlSelection
    iotPrinterEvents?: PrinterGenqlSelection
    iotScaleEvents?: ScaleGenqlSelection
    iotScannerEvents?: ScannerGenqlSelection
    iotSidecarEvents?: SidecarGenqlSelection
    notificationReceived?: NotificationFeedEntryGenqlSelection
    presenceEvents?: (PresenceEventGenqlSelection & { __args: {join?: (Scalars['Boolean'] | null), room: Scalars['String'], sessionId?: (Scalars['String'] | null)} })
    tradeLoadChanges?: (LoadGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    tradePurchaseLoadChanges?: (PurchaseLoadGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    transportationRouteChanges?: (RouteGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    transportationServiceChanges?: (ServiceGenqlSelection & { __args: {ids: Scalars['ID'][]} })
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SupplierPriceListAffectsMaterialsResultGenqlSelection{
    affectedItemIds?: boolean | number
    hasAffectingPriceList?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SwitchCaseGenqlSelection{
    label?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface SwitchCaseInput {label?: (Scalars['String'] | null),value: Scalars['String']}

export interface SwitchNodeGenqlSelection{
    cases?: SwitchCaseGenqlSelection
    defaultLabel?: boolean | number
    description?: boolean | number
    expression?: boolean | number
    id?: boolean | number
    label?: boolean | number
    position?: PositionGenqlSelection
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TagAllocationGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    movement?: InventoryMovementGenqlSelection
    movementId?: boolean | number
    quantity?: WeightGenqlSelection
    tag?: InventoryTagGenqlSelection
    tagId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TagAllocationFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),movementId?: (Scalars['ID'] | null),movementIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),tagId?: (Scalars['ID'] | null),tagIds?: (Scalars['ID'][] | null)}

export interface TagAllocationInput {movementId: Scalars['ID'],quantity: WeightInput,tagId: Scalars['ID']}

export interface TagAllocationResultPageGenqlSelection{
    entries?: TagAllocationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TagAllocationUpdateInput {movementId?: (Scalars['ID'] | null),quantity?: (WeightInput | null),tagId?: (Scalars['ID'] | null)}

export interface TagMovementAllocationInput {movementId: Scalars['ID'],quantity: WeightInput}

export interface TagQuantitySummaryGenqlSelection{
    inQuantity?: WeightGenqlSelection
    netQuantity?: WeightGenqlSelection
    outQuantity?: WeightGenqlSelection
    tagId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TagReconciliationReportGenqlSelection{
    quantityMismatchCount?: boolean | number
    tagsWithMovements?: boolean | number
    tagsWithoutMovements?: boolean | number
    totalTags?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TalkJSConversationGenqlSelection{
    createdAt?: boolean | number
    custom?: boolean | number
    id?: boolean | number
    isUnread?: boolean | number
    lastMessage?: TalkJSMessageGenqlSelection
    participants?: TalkJSParticipantGenqlSelection
    photoUrl?: boolean | number
    subject?: boolean | number
    topicId?: boolean | number
    unreadMessageCount?: boolean | number
    welcomeMessages?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TalkJSConversationFilter {limit?: (Scalars['Int'] | null),onlyUnread?: (Scalars['Boolean'] | null),peopleType?: (TalkJSPeopleType | null),startingAfter?: (Scalars['String'] | null),subject?: (Scalars['String'] | null),userId: Scalars['ID']}

export interface TalkJSConversationListResultGenqlSelection{
    data?: TalkJSConversationGenqlSelection
    hasMore?: boolean | number
    nextCursor?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TalkJSMessageGenqlSelection{
    conversationId?: boolean | number
    createdAt?: boolean | number
    custom?: boolean | number
    id?: boolean | number
    readBy?: TalkJSMessageReadGenqlSelection
    senderId?: boolean | number
    text?: boolean | number
    type?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TalkJSMessageReadGenqlSelection{
    readAt?: boolean | number
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TalkJSParticipantGenqlSelection{
    access?: boolean | number
    name?: boolean | number
    notify?: boolean | number
    participantId?: boolean | number
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaskGenqlSelection{
    accountAddressId?: boolean | number
    accountId?: boolean | number
    asset?: AssetGenqlSelection
    assetGroup?: boolean | number
    assetId?: boolean | number
    assetTypeId?: boolean | number
    completedAt?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    failureReason?: boolean | number
    fillStateCondition?: boolean | number
    fulfillmentServiceId?: boolean | number
    id?: boolean | number
    routeId?: boolean | number
    routePosition?: boolean | number
    sourceServiceId?: boolean | number
    startedAt?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    type?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaskFilter {accountAddressId?: (Scalars['ID'] | null),accountAddressIds?: (Scalars['ID'][] | null),accountId?: (Scalars['ID'] | null),accountIds?: (Scalars['ID'][] | null),assetId?: (Scalars['ID'] | null),assetIds?: (Scalars['ID'][] | null),assetTypeId?: (Scalars['ID'] | null),assetTypeIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),failureReason?: (Scalars['String'] | null),fillStateCondition?: (Scalars['String'] | null),fromCompletedAt?: (Scalars['ZonedDateTime'] | null),fromStartedAt?: (Scalars['ZonedDateTime'] | null),fulfillmentServiceId?: (Scalars['ID'] | null),fulfillmentServiceIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),routeId?: (Scalars['ID'] | null),routeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),sourceServiceId?: (Scalars['ID'] | null),sourceServiceIds?: (Scalars['ID'][] | null),status?: (TaskStatus[] | null),toCompletedAt?: (Scalars['ZonedDateTime'] | null),toStartedAt?: (Scalars['ZonedDateTime'] | null),type?: (TaskType[] | null)}

export interface TaskInput {accountAddressId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),assetGroup?: (Scalars['Int'] | null),assetId?: (Scalars['ID'] | null),assetTypeId?: (Scalars['ID'] | null),completedAt?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),failureReason?: (Scalars['String'] | null),fillStateCondition?: (Scalars['String'] | null),fulfillmentServiceId: Scalars['ID'],routeId?: (Scalars['ID'] | null),routePosition?: (Scalars['Decimal'] | null),sourceServiceId?: (Scalars['ID'] | null),startedAt?: (Scalars['ZonedDateTime'] | null),status: TaskStatus,type: TaskType}

export interface TaskPhotoCreatePayloadGenqlSelection{
    file?: FileGenqlSelection
    uploadUrl?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaskPhotoInput {fileName: Scalars['String'],fileSize: Scalars['Int'],mimeType: Scalars['String'],public?: Scalars['Boolean']}

export interface TaskResultPageGenqlSelection{
    entries?: TaskGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaskServiceGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    id?: boolean | number
    relationshipType?: boolean | number
    serviceId?: boolean | number
    taskId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaskServiceFilter {ids?: (Scalars['ID'][] | null),relationshipType?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),serviceId?: (Scalars['ID'] | null),serviceIds?: (Scalars['ID'][] | null),taskId?: (Scalars['ID'] | null),taskIds?: (Scalars['ID'][] | null)}

export interface TaskServiceInput {relationshipType: Scalars['String'],serviceId: Scalars['ID'],taskId: Scalars['ID']}

export interface TaskServiceResultPageGenqlSelection{
    entries?: TaskServiceGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TaskServiceUpdateInput {relationshipType?: (Scalars['String'] | null),serviceId?: (Scalars['ID'] | null),taskId?: (Scalars['ID'] | null)}

export interface TaskUpdateInput {accountAddressId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),assetGroup?: (Scalars['Int'] | null),assetId?: (Scalars['ID'] | null),assetTypeId?: (Scalars['ID'] | null),completedAt?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),failureReason?: (Scalars['String'] | null),fillStateCondition?: (Scalars['String'] | null),fulfillmentServiceId?: (Scalars['ID'] | null),routeId?: (Scalars['ID'] | null),routePosition?: (Scalars['Decimal'] | null),sourceServiceId?: (Scalars['ID'] | null),startedAt?: (Scalars['ZonedDateTime'] | null),status?: (TaskStatus | null),type?: (TaskType | null)}

export interface TemplateDataInput {key: Scalars['String'],value: Scalars['String']}

export interface TerminalGenqlSelection{
    id?: boolean | number
    latitude?: boolean | number
    longitude?: boolean | number
    name?: boolean | number
    port?: PortGenqlSelection
    portId?: boolean | number
    terminalCode?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TicketFreightGenqlSelection{
    carrier?: AccountGenqlSelection
    carrierId?: boolean | number
    chargebackAmountAmount?: boolean | number
    chargebackAmountCurrencyCode?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    deliveryNumber?: boolean | number
    destinationLocationId?: boolean | number
    formulaVariableIds?: boolean | number
    freightLaneCostId?: boolean | number
    id?: boolean | number
    invoiceDate?: boolean | number
    invoiceNumber?: boolean | number
    load?: LoadGenqlSelection
    loadId?: boolean | number
    notes?: boolean | number
    originLocationId?: boolean | number
    purchaseLoadId?: boolean | number
    purchase_load?: PurchaseLoadGenqlSelection
    route?: FreightLaneRouteGenqlSelection
    routeId?: boolean | number
    sourceId?: boolean | number
    sourceType?: boolean | number
    timestamps?: TimestampsGenqlSelection
    totalCostAmount?: boolean | number
    totalCostCurrencyCode?: boolean | number
    transportationType?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    userSet?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TicketFreightFilter {carrierId?: (Scalars['ID'] | null),ids?: (Scalars['ID'][] | null),loadId?: (Scalars['ID'] | null),purchaseLoadId?: (Scalars['ID'] | null),sourceType?: (Scalars['String'] | null)}

export interface TicketFreightInput {carrierId?: (Scalars['ID'] | null),chargebackAmountAmount: Scalars['Decimal'],chargebackAmountCurrencyCode: Scalars['String'],deliveryNumber?: (Scalars['String'] | null),destinationLocationId?: (Scalars['ID'] | null),formulaVariableIds?: (Scalars['String'] | null),freightLaneCostId?: (Scalars['String'] | null),invoiceDate?: (Scalars['CalendarDate'] | null),invoiceNumber?: (Scalars['String'] | null),loadId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),originLocationId?: (Scalars['ID'] | null),purchaseLoadId?: (Scalars['ID'] | null),routeId?: (Scalars['ID'] | null),sourceId?: (Scalars['String'] | null),sourceType?: (Scalars['String'] | null),totalCostAmount: Scalars['Decimal'],totalCostCurrencyCode: Scalars['String'],transportationType?: (Scalars['String'] | null),userSet: Scalars['Boolean']}

export interface TicketFreightResultPageGenqlSelection{
    entries?: TicketFreightGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TicketFreightUpdateInput {carrierId?: (Scalars['ID'] | null),chargebackAmountAmount?: (Scalars['Decimal'] | null),chargebackAmountCurrencyCode?: (Scalars['String'] | null),deliveryNumber?: (Scalars['String'] | null),destinationLocationId?: (Scalars['ID'] | null),formulaVariableIds?: (Scalars['String'] | null),freightLaneCostId?: (Scalars['String'] | null),invoiceDate?: (Scalars['CalendarDate'] | null),invoiceNumber?: (Scalars['String'] | null),loadId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),originLocationId?: (Scalars['ID'] | null),purchaseLoadId?: (Scalars['ID'] | null),routeId?: (Scalars['ID'] | null),sourceId?: (Scalars['String'] | null),sourceType?: (Scalars['String'] | null),totalCostAmount?: (Scalars['Decimal'] | null),totalCostCurrencyCode?: (Scalars['String'] | null),transportationType?: (Scalars['String'] | null),userSet?: (Scalars['Boolean'] | null)}

export interface TimestampsGenqlSelection{
    createdAt?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollReceiptGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customerAccount?: AccountGenqlSelection
    customerAccountId?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    inboundTollingAgreement?: InboundTollingAgreementGenqlSelection
    items?: TollReceiptItemGenqlSelection
    notes?: boolean | number
    receiptNumber?: boolean | number
    receivedAt?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tollProcessingAgreementId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollReceiptFilter {customerAccountId?: (Scalars['ID'] | null),customerAccountIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromReceivedAt?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),receiptNumber?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),status?: (TollReceiptStatus[] | null),toReceivedAt?: (Scalars['ZonedDateTime'] | null),tollProcessingAgreementId?: (Scalars['ID'] | null),tollProcessingAgreementIds?: (Scalars['ID'][] | null)}

export interface TollReceiptInput {customerAccountId: Scalars['ID'],facilityId: Scalars['ID'],items?: (CreateTollReceiptItemInput[] | null),notes?: (Scalars['String'] | null),receiptNumber: Scalars['String'],receivedAt?: (Scalars['ZonedDateTime'] | null),status: TollReceiptStatus,tollProcessingAgreementId?: (Scalars['ID'] | null)}

export interface TollReceiptItemGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    lot?: InventoryLotGenqlSelection
    lotId?: boolean | number
    notes?: boolean | number
    quantity?: boolean | number
    quantityUnit?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tollReceipt?: TollReceiptGenqlSelection
    tollReceiptId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollReceiptItemFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),lotId?: (Scalars['ID'] | null),lotIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),tollReceiptId?: (Scalars['ID'] | null),tollReceiptIds?: (Scalars['ID'][] | null)}

export interface TollReceiptItemResultPageGenqlSelection{
    entries?: TollReceiptItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollReceiptResultPageGenqlSelection{
    entries?: TollReceiptGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollReceiptUpdateInput {customerAccountId?: (Scalars['ID'] | null),facilityId?: (Scalars['ID'] | null),items?: (UpdateTollReceiptItemInput[] | null),notes?: (Scalars['String'] | null),receiptNumber?: (Scalars['String'] | null),receivedAt?: (Scalars['ZonedDateTime'] | null),status?: (TollReceiptStatus | null),tollProcessingAgreementId?: (Scalars['ID'] | null)}

export interface TollShipmentGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    customerAccount?: AccountGenqlSelection
    customerAccountId?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    inboundTollingAgreement?: InboundTollingAgreementGenqlSelection
    items?: TollShipmentItemGenqlSelection
    notes?: boolean | number
    processingFee?: MoneyGenqlSelection
    shipmentNumber?: boolean | number
    shippedAt?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tollProcessingAgreementId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollShipmentFilter {customerAccountId?: (Scalars['ID'] | null),customerAccountIds?: (Scalars['ID'][] | null),facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromShippedAt?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),shipmentNumber?: (Scalars['String'] | null),status?: (TollShipmentStatus[] | null),toShippedAt?: (Scalars['ZonedDateTime'] | null),tollProcessingAgreementId?: (Scalars['ID'] | null),tollProcessingAgreementIds?: (Scalars['ID'][] | null)}

export interface TollShipmentInput {customerAccountId: Scalars['ID'],facilityId: Scalars['ID'],items?: (CreateTollShipmentItemInput[] | null),notes?: (Scalars['String'] | null),processingFee?: (MoneyInput | null),shipmentNumber: Scalars['String'],shippedAt?: (Scalars['ZonedDateTime'] | null),status: TollShipmentStatus,tollProcessingAgreementId?: (Scalars['ID'] | null)}

export interface TollShipmentItemGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    lot?: InventoryLotGenqlSelection
    lotId?: boolean | number
    notes?: boolean | number
    processingFee?: MoneyGenqlSelection
    quantity?: boolean | number
    quantityUnit?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tollShipment?: TollShipmentGenqlSelection
    tollShipmentId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollShipmentItemFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),lotId?: (Scalars['ID'] | null),lotIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),tollShipmentId?: (Scalars['ID'] | null),tollShipmentIds?: (Scalars['ID'][] | null)}

export interface TollShipmentItemResultPageGenqlSelection{
    entries?: TollShipmentItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollShipmentResultPageGenqlSelection{
    entries?: TollShipmentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TollShipmentUpdateInput {customerAccountId?: (Scalars['ID'] | null),facilityId?: (Scalars['ID'] | null),items?: (UpdateTollShipmentItemInput[] | null),notes?: (Scalars['String'] | null),processingFee?: (MoneyInput | null),shipmentNumber?: (Scalars['String'] | null),shippedAt?: (Scalars['ZonedDateTime'] | null),status?: (TollShipmentStatus | null),tollProcessingAgreementId?: (Scalars['ID'] | null)}

export interface ToolCallGenqlSelection{
    arguments?: boolean | number
    id?: boolean | number
    name?: boolean | number
    result?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Configuration details for Time-based One-Time Password authentication */
export interface TotpConfigGenqlSelection{
    qrCode?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TradeBookingShipInput {id: Scalars['ID'],shippedDate?: (Scalars['CalendarDate'] | null)}

export interface TradeOutboxEventCountsGenqlSelection{
    booking?: boolean | number
    load?: boolean | number
    purchaseOrder?: boolean | number
    salesOrder?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TradeOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (TradeAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface TrailerGenqlSelection{
    capacity?: boolean | number
    country?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currentLocation?: PointGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    lastLocationTime?: boolean | number
    licensePlate?: boolean | number
    licensePlateExpiration?: boolean | number
    notes?: boolean | number
    state?: boolean | number
    status?: boolean | number
    taskCount?: boolean | number
    timestamps?: TimestampsGenqlSelection
    transportationType?: TransportationTypeGenqlSelection
    transportationTypeId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    vin?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TrailerFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),licensePlate?: (Scalars['String'] | null),maxCapacity?: (Scalars['Float'] | null),minCapacity?: (Scalars['Float'] | null),searchTerm?: (Scalars['String'] | null),status?: (TrailerStatus[] | null),transportationTypeId?: (Scalars['ID'] | null),vin?: (Scalars['String'] | null)}

export interface TrailerResultPageGenqlSelection{
    entries?: TrailerGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransportationAccountsFilterInput {hasActiveTask?: (Scalars['Boolean'] | null),hasAsset?: (Scalars['Boolean'] | null)}

export interface TransportationFacilitiesFilterInput {hasActiveTask?: (Scalars['Boolean'] | null),hasAsset?: (Scalars['Boolean'] | null)}

export interface TransportationOutboxEventCountsGenqlSelection{
    asset?: boolean | number
    containerType?: boolean | number
    driver?: boolean | number
    freightForwarder?: boolean | number
    freightLine?: boolean | number
    route?: boolean | number
    service?: boolean | number
    shippingCarrier?: boolean | number
    trailer?: boolean | number
    transportationType?: boolean | number
    truck?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransportationOutboxEventFilter {aggregateId?: (Scalars['ID'] | null),aggregateTypes?: (TransportationAggregateType[] | null),createdAtRange?: (ZonedDateTimeRangeInput | null),statuses?: (OutboxEventStatus[] | null)}

export interface TransportationTypeGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TransportationTypeFilter {description?: (Scalars['String'] | null),ids?: (Scalars['ID'][] | null),name?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null)}

export interface TransportationTypeResultPageGenqlSelection{
    entries?: TransportationTypeGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TrialCloseChecklistItemGenqlSelection{
    blocking?: boolean | number
    count?: boolean | number
    description?: boolean | number
    details?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TriggerConfigGenqlSelection{
    on_BusinessEventTriggerConfigOutput?:BusinessEventTriggerConfigOutputGenqlSelection,
    on_HttpWebhookTriggerConfigOutput?:HttpWebhookTriggerConfigOutputGenqlSelection,
    on_ScheduleTriggerConfigOutput?:ScheduleTriggerConfigOutputGenqlSelection,
    __typename?: boolean | number
}

export interface TriggerConfigInput {cron?: (Scalars['String'] | null),entityType?: (Scalars['String'] | null),eventCase?: (Scalars['String'] | null),filterExpression?: (Scalars['String'] | null)}

export interface TruckGenqlSelection{
    capacity?: boolean | number
    country?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    currentLocation?: PointGenqlSelection
    defaultTrailer?: TrailerGenqlSelection
    defaultTrailerId?: boolean | number
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    lastLocationTime?: boolean | number
    licensePlate?: boolean | number
    licensePlateExpiration?: boolean | number
    locationHistory?: TruckLocationHistoryGenqlSelection
    model?: boolean | number
    notes?: boolean | number
    state?: boolean | number
    status?: boolean | number
    taskCount?: boolean | number
    timestamps?: TimestampsGenqlSelection
    transportationType?: TransportationTypeGenqlSelection
    transportationTypeId?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    vin?: boolean | number
    year?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TruckFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),lastUpdatedAt?: (Scalars['ZonedDateTime'] | null),licensePlate?: (Scalars['String'] | null),maxCapacity?: (Scalars['Float'] | null),minCapacity?: (Scalars['Float'] | null),model?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),status?: (TruckStatus[] | null),transportationTypeId?: (Scalars['ID'] | null),vin?: (Scalars['String'] | null)}

export interface TruckLocationHistoryGenqlSelection{
    id?: boolean | number
    location?: PointGenqlSelection
    source?: boolean | number
    timestamp?: boolean | number
    timestamps?: TimestampsGenqlSelection
    truck?: TruckGenqlSelection
    truckId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface TruckResultPageGenqlSelection{
    entries?: TruckGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnappliedAdvanceBalanceGenqlSelection{
    accountId?: boolean | number
    balances?: MoneyGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnconfirmPaymentsInput {ids: Scalars['ID'][]}

export interface UnitPriceFormulaGenqlSelection{
    formula?: boolean | number
    variableIds?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UnitPriceFormulaInput {formula: Scalars['String'],variableIds: Scalars['ID'][]}

export interface UnshareFileInput {fileId: Scalars['ID'],permission: Scalars['String'],userIds: Scalars['ID'][]}

export interface UnshareFilePayloadGenqlSelection{
    file?: FileGenqlSelection
    removedCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UntagInventoryTagInput {reason?: (Scalars['String'] | null),tagId: Scalars['ID']}

export interface UpdateAccountAddressInput {address?: (AddressInput | null),contacts?: (UpdateContactInput[] | null),customAttributes?: (Scalars['Map'] | null),id?: (Scalars['ID'] | null),locationType?: (AddressLocationType | null),name?: (Scalars['String'] | null),operatingHours?: (Scalars['Map'] | null)}

export interface UpdateAccountIdentityDocumentInput {documentNumber?: (Scalars['String'] | null),documentType?: (IdentityDocumentType | null),expirationDate?: (Scalars['CalendarDate'] | null),id?: (Scalars['ID'] | null),issueDate?: (Scalars['CalendarDate'] | null),issuingState?: (Scalars['String'] | null)}

export interface UpdateAccountIndividualDetailsInput {dateOfBirth?: (Scalars['CalendarDate'] | null),employer?: (Scalars['String'] | null),eyeColor?: (IndividualEyeColor | null),hairColor?: (IndividualHairColor | null),height?: (Scalars['Int'] | null),id?: (Scalars['ID'] | null),identityDocuments?: (UpdateAccountIdentityDocumentInput[] | null),race?: (IndividualRace | null),sex?: (IndividualSex | null),weight?: (Scalars['Int'] | null)}

export interface UpdateAccountInput {accountManagerIds?: (Scalars['ID'][] | null),addresses?: (UpdateAccountAddressInput[] | null),customAttributes?: (Scalars['Map'] | null),defaultPurchasePaymentTermId?: (Scalars['ID'] | null),defaultSalesPaymentTermId?: (Scalars['ID'] | null),dotNumber?: (Scalars['String'] | null),email?: (Scalars['String'] | null),individualDetails?: (UpdateAccountIndividualDetailsInput | null),insuranceExpiration?: (Scalars['CalendarDate'] | null),linkedOrganizationId?: (Scalars['ID'] | null),mcNumber?: (Scalars['String'] | null),name?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),paymentSchedulePreference?: (Scalars['String'] | null),paymentTypePreference?: (Scalars['String'] | null),phone?: (Scalars['String'] | null),relationship?: (AccountRelationshipInput | null),scac?: (Scalars['String'] | null),type?: (AccountType | null),w9OnFile?: (Scalars['Boolean'] | null),website?: (Scalars['String'] | null)}

export interface UpdateAgentInput {agentIdentifier?: (Scalars['String'] | null),content?: (Scalars['String'] | null),description?: (Scalars['String'] | null),model?: (Scalars['String'] | null),modelProvider?: (ModelProvider | null),name?: (Scalars['String'] | null),organizationId?: (Scalars['ID'] | null),providerApiKey?: (Scalars['String'] | null),providerBaseUrl?: (Scalars['String'] | null),reasoningBudget?: (Scalars['Int'] | null),reasoningEnabled?: (Scalars['Boolean'] | null),temperature?: (Scalars['Float'] | null),type?: (AgentType | null)}

export interface UpdateAssetInput {accountAddressId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),currentLocation?: (AddressInput | null),customAttributes?: (Scalars['Map'] | null),description?: (Scalars['String'] | null),facilityId?: (Scalars['ID'] | null),fillState?: (AssetFillState | null),identifier?: (Scalars['String'] | null),lastLocationTime?: (Scalars['ZonedDateTime'] | null),notes?: (Scalars['String'] | null),status?: (AssetStatus | null),tareWeight?: (WeightInput | null),typeId?: (Scalars['ID'] | null)}

export interface UpdateAssetTypeInput {capacity?: (Scalars['Float'] | null),description?: (Scalars['String'] | null),name?: (Scalars['String'] | null)}

export interface UpdateAssistantChatInput {title: Scalars['String']}

export interface UpdateAutomationInput {description?: (Scalars['String'] | null),edges?: (EdgeInput[] | null),name?: (Scalars['String'] | null),nodes?: (NodeInput[] | null),triggerConfig?: (TriggerConfigInput | null)}

export interface UpdateBillInput {amount?: (MoneyInput | null),compliance?: (BillComplianceRule[] | null),documentDate?: (Scalars['CalendarDate'] | null),documentNumber?: (Scalars['String'] | null),dueDate?: (Scalars['CalendarDate'] | null),eligibleAt?: (Scalars['CalendarDate'] | null),facilityID?: (Scalars['ID'] | null),lineItems?: (BillLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentTerm?: (PaymentTerm | null),paymentTermId?: (Scalars['ID'] | null),preferredPaymentMethod?: (PaymentMethod | null)}

export interface UpdateBrokeredOrderLineItemInput {brokeredOrderId?: (Scalars['ID'] | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),quantity?: (Scalars['Decimal'] | null),unit?: (Unit | null)}

export interface UpdateCameraInput {driverType?: (Scalars['String'] | null),name?: (Scalars['String'] | null),sidecarId?: (Scalars['ID'] | null),snapshotUrl?: (Scalars['String'] | null),streamProfile?: (Scalars['String'] | null),streamUrl?: (Scalars['String'] | null),uniqueId?: (Scalars['String'] | null),username?: (Scalars['String'] | null)}

export interface UpdateContactInput {accountId?: (Scalars['ID'] | null),addressAs?: (Scalars['String'] | null),addressId?: (Scalars['ID'] | null),customAttributes?: (Scalars['Map'] | null),department?: (Scalars['String'] | null),email?: (Scalars['String'] | null),fullName?: (Scalars['String'] | null),id?: (Scalars['ID'] | null),isPrimary?: (Scalars['Boolean'] | null),notes?: (Scalars['String'] | null),ownerUserId?: (Scalars['ID'] | null),phone?: (Scalars['String'] | null),prefix?: (Scalars['String'] | null),role?: (Scalars['String'] | null),userId?: (Scalars['ID'] | null)}

export interface UpdateContainerTypeInput {name?: (Scalars['String'] | null)}

export interface UpdateCustomAttributeInput {constraints?: (FieldConstraintsInput | null),id: Scalars['ID'],isDisabled?: (Scalars['Boolean'] | null),name?: (Scalars['String'] | null),order?: (Scalars['Int'] | null)}

export interface UpdateDriverCertificationInput {driverId?: (Scalars['ID'] | null),expirationDate?: (Scalars['ZonedDateTime'] | null),issuedDate?: (Scalars['ZonedDateTime'] | null),issuingBody?: (Scalars['String'] | null),number?: (Scalars['String'] | null),type?: (Scalars['String'] | null)}

export interface UpdateDriverInput {address?: (AddressInput | null),currentLocation?: (PointInput | null),defaultTrailerId?: (Scalars['ID'] | null),defaultTruckId?: (Scalars['ID'] | null),email?: (Scalars['String'] | null),firstName?: (Scalars['String'] | null),lastLocationTime?: (Scalars['ZonedDateTime'] | null),lastName?: (Scalars['String'] | null),licenseExpiration?: (Scalars['ZonedDateTime'] | null),licenseNumber?: (Scalars['String'] | null),phoneNumber?: (Scalars['String'] | null),status?: (DriverStatus | null),userId?: (Scalars['ID'] | null)}

export interface UpdateFacilityGeneralPreferencesInput {currency?: (CurrencyCode | null),dateFormat?: (Scalars['String'] | null),defaultUnitSystem?: (UnitSystem | null),facilityId: Scalars['ID'],imperialEnabled?: (Scalars['Boolean'] | null),language?: (Scalars['String'] | null),metricEnabled?: (Scalars['Boolean'] | null),timezone?: (Scalars['String'] | null),weekStartDay?: (Scalars['String'] | null)}

export interface UpdateFacilitySalesPreferencesInput {askForDeletionConfirmation?: (Scalars['Boolean'] | null),defaultPort?: (Scalars['String'] | null),defaultWeightDisplayUnit?: (Scalars['String'] | null),enableDefaultPrinting?: (Scalars['Boolean'] | null),facilityId: Scalars['ID'],photoInstructions?: (PhotoInstructionInput[] | null),skipScalePayment?: (Scalars['Boolean'] | null)}

export interface UpdateFileMetadataInput {metadata: Scalars['Map']}

export interface UpdateFinancialAccountInput {accountNumber?: (Scalars['String'] | null),bankName?: (Scalars['String'] | null),checkBusinessName?: (Scalars['String'] | null),checkLogo?: (Scalars['String'] | null),checkMailingAddress?: (Scalars['String'] | null),checkNumberGeneration?: (Scalars['Boolean'] | null),checkPhoneNumber?: (Scalars['String'] | null),checkSignature?: (Scalars['String'] | null),customAttributes?: (Scalars['Map'] | null),ezcashEndpoint?: (Scalars['String'] | null),ezcashTimeoutSeconds?: (Scalars['Int'] | null),ezcashToken?: (Scalars['String'] | null),facilityID?: (Scalars['ID'] | null),lastCheckNumber?: (Scalars['Int'] | null),nachaCompanyIdentification?: (Scalars['String'] | null),nachaCompanyName?: (Scalars['String'] | null),nachaDefaultSecCode?: (Scalars['String'] | null),name?: (Scalars['String'] | null),paymentAllocationMethod?: (PaymentAllocationMethod | null),roundingMethod?: (RoundingMethod | null),roundingPrecision?: (RoundingPrecision | null),routingNumber?: (Scalars['String'] | null),type?: (FinancialAccountType | null),visibleInPayments?: (Scalars['Boolean'] | null),warningThreshold: Scalars['Decimal']}

export interface UpdateFinancialAccountTransactionInput {amount?: (Scalars['Decimal'] | null),authorizedDate?: (Scalars['CalendarDate'] | null),channel?: (FinancialAccountTransactionChannel | null),checkNumber?: (Scalars['String'] | null),counterpartyIds?: (Scalars['ID'][] | null),date?: (Scalars['CalendarDate'] | null),financialAccountOwnerId?: (Scalars['String'] | null),imageUrl?: (Scalars['String'] | null),location?: (AddressInput | null),pendingTransactionId?: (Scalars['ID'] | null),reference?: (Scalars['String'] | null),status?: (FinancialAccountTransactionStatus | null),transferNumber?: (Scalars['String'] | null),type?: (FinancialAccountTransactionType | null),website?: (Scalars['String'] | null)}

export interface UpdateInvoiceInput {amount?: (MoneyInput | null),documentDate?: (Scalars['CalendarDate'] | null),documentNumber?: (Scalars['String'] | null),dueDate?: (Scalars['CalendarDate'] | null),facilityID?: (Scalars['ID'] | null),lineItems?: (InvoiceLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentTerm?: (PaymentTerm | null),paymentTermId?: (Scalars['ID'] | null),status?: (InvoiceStatus | null)}

export interface UpdateLoadDeductionInput {applicationType?: (DeductionApplicationType | null),deductionTypeId?: (Scalars['ID'] | null),facilityId?: (Scalars['ID'] | null),id?: (Scalars['ID'] | null),loadId?: (Scalars['ID'] | null),loadLineItemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),percentage?: (Scalars['Decimal'] | null),priceValue?: (MoneyInput | null),weightValue?: (WeightInput | null)}

export interface UpdateOrganizationInput {domain?: (Scalars['String'] | null),idpId?: (Scalars['String'] | null),name?: (Scalars['String'] | null),onboardAt?: (Scalars['ZonedDateTime'] | null),timezone?: (Scalars['Timezone'] | null)}

export interface UpdatePaymentInput {achNumber?: (Scalars['String'] | null),amount?: (MoneyInput | null),atmId?: (Scalars['String'] | null),atmPaymentNumber?: (Scalars['String'] | null),barcode?: (Scalars['String'] | null),barcodeRowId?: (Scalars['Int'] | null),checkAttn?: (Scalars['String'] | null),checkFacilityId?: (Scalars['ID'] | null),checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),documentNumber?: (Scalars['String'] | null),financialAccountId?: (Scalars['ID'] | null),financialAccountTransactionId?: (Scalars['ID'] | null),paymentMethod?: (PaymentMethod | null),supplierPhotoId?: (Scalars['ID'] | null),transactionDate?: (Scalars['CalendarDate'] | null),wireNumber?: (Scalars['String'] | null)}

export interface UpdatePrinterInput {driverType?: (Scalars['String'] | null),name?: (Scalars['String'] | null),pageSize?: (PrinterPageSize | null),printerType?: (PrinterType | null),rollWidth?: (PrinterRollWidth | null),sidecarId?: (Scalars['ID'] | null),uniqueId?: (Scalars['String'] | null)}

export interface UpdateProcessingTypeInputItemInput {id?: (Scalars['ID'] | null),isPrimary?: (Scalars['Boolean'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),processingTypeId?: (Scalars['ID'] | null),sortOrder?: (Scalars['Int'] | null)}

export interface UpdateProcessingTypeOutputItemInput {costAllocationPercentage?: (Scalars['Decimal'] | null),id?: (Scalars['ID'] | null),isNoCost?: (Scalars['Boolean'] | null),isPrimary?: (Scalars['Boolean'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),outputUnit?: (Unit | null),processingTypeId?: (Scalars['ID'] | null),sortOrder?: (Scalars['Int'] | null),yieldPercentage?: (Scalars['Decimal'] | null)}

export interface UpdatePurchaseLoadDeductionInput {applicationType?: (DeductionApplicationType | null),deductionTypeId?: (Scalars['ID'] | null),id?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),percentage?: (Scalars['Decimal'] | null),priceValue?: (MoneyInput | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseLoadLineItemId?: (Scalars['ID'] | null),weightValue?: (WeightInput | null)}

export interface UpdatePurchaseLoadLineItemInput {catComplianceStatus?: (Scalars['String'] | null),catOemCode?: (Scalars['String'] | null),catSerialNumber?: (Scalars['String'] | null),estimatedPrice?: (MoneyInput | null),grossWeight?: (WeightInput | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),netWeight?: (WeightInput | null),notes?: (Scalars['String'] | null),parentLineItemId?: (Scalars['ID'] | null),pricingUnit?: (Unit | null),purchaseLoadId?: (Scalars['ID'] | null),purchaseOrderLineId?: (Scalars['ID'] | null),requiresSorting?: (Scalars['Boolean'] | null),settlementBasis?: (SettlementBasis | null),tagId?: (Scalars['ID'] | null),tareWeight?: (WeightInput | null),type?: (PurchaseLineItemType | null),unitPrice?: (MoneyInput | null),vehicleMake?: (Scalars['String'] | null),vehicleModel?: (Scalars['String'] | null),vehicleTitleStatus?: (Scalars['String'] | null),vehicleVin?: (Scalars['String'] | null),vehicleYear?: (Scalars['Int'] | null)}

export interface UpdatePurchaseLoadPaymentInput {amount?: (MoneyInput | null),checkMemo?: (Scalars['String'] | null),checkNumber?: (Scalars['String'] | null),creatorId?: (Scalars['ID'] | null),financialAccountId?: (Scalars['ID'] | null),id?: (Scalars['ID'] | null),legalHold?: (Scalars['Boolean'] | null),paymentMethod?: (Scalars['String'] | null),paymentTerm?: (Scalars['String'] | null),percentage?: (Scalars['Decimal'] | null),purchaseLoadId?: (Scalars['ID'] | null),roundingMethod?: (Scalars['String'] | null),roundingPrecision?: (Scalars['String'] | null)}

export interface UpdatePurchaseOrderInput {accountAddressId?: (Scalars['ID'] | null),accountContactId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),accountRepresentativeId?: (Scalars['ID'] | null),completionNotes?: (Scalars['String'] | null),counterpartyReferenceNumber?: (Scalars['String'] | null),customAttributes?: (Scalars['Map'] | null),documentNumber?: (Scalars['String'] | null),endDate?: (Scalars['CalendarDate'] | null),facilityId?: (Scalars['ID'] | null),freightTerm?: (FreightTerm | null),lineItems?: (UpdatePurchaseOrderLineItemInput[] | null),notes?: (Scalars['String'] | null),paymentCurrency?: (Scalars['String'] | null),paymentTerm?: (PaymentTerm | null),startDate?: (Scalars['CalendarDate'] | null)}

export interface UpdatePurchaseOrderLineItemInput {id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),purchaseOrderId?: (Scalars['ID'] | null),quantity?: (Scalars['Decimal'] | null),totalPrice?: (MoneyInput | null),unit?: (Unit | null),unitPrice?: (MoneyInput | null)}

export interface UpdateQuoteLineItemInput {id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),packageFormat?: (Scalars['String'] | null),quantity?: (Scalars['Decimal'] | null),quoteId?: (Scalars['ID'] | null),unit?: (Unit | null),unitPrice?: (MoneyInput | null)}

export interface UpdateRoleInput {description?: (Scalars['String'] | null),name?: (Scalars['String'] | null),permissions?: (Scalars['String'][] | null),type?: (RoleType | null)}

export interface UpdateRouteInput {driverId?: (Scalars['ID'] | null),facilityGroupId?: (Scalars['ID'] | null),haulerId?: (Scalars['ID'] | null),routeDate?: (Scalars['ZonedDateTime'] | null),status?: (RouteStatus | null),trailerId?: (Scalars['ID'] | null),truckId?: (Scalars['ID'] | null)}

export interface UpdateScaleInput {baudRate?: (Scalars['Int'] | null),cameraId?: (Scalars['ID'] | null),connectionType?: (ScaleConnectionType | null),dataBits?: (Scalars['Int'] | null),measurementIncrement?: (Scalars['Decimal'] | null),measurementMode?: (ScaleMeasurementMode | null),name?: (Scalars['String'] | null),onDemandString?: (Scalars['String'] | null),parity?: (Scalars['String'] | null),scaleFormatType?: (ScaleFormatType | null),serialPortPath?: (Scalars['String'] | null),sidecarId?: (Scalars['ID'] | null),stopBits?: (Scalars['String'] | null),tcpHost?: (Scalars['String'] | null),tcpPort?: (Scalars['Int'] | null),unitOfMeasurement?: (Scalars['String'] | null)}

export interface UpdateScannerInput {driverType?: (Scalars['String'] | null),name?: (Scalars['String'] | null),sidecarId?: (Scalars['ID'] | null),uniqueId?: (Scalars['String'] | null)}

export interface UpdateServiceInput {accountAddressId?: (Scalars['ID'] | null),accountId?: (Scalars['ID'] | null),actions?: (ServiceActionInput[] | null),address?: (AddressInput | null),assetTypes?: (ServiceAssetTypeInput[] | null),assets?: (ServiceAssetInput[] | null),assignmentStatus?: (AssignmentStatus | null),contactId?: (Scalars['ID'] | null),deadline?: (Scalars['ZonedDateTime'] | null),destinationFacilityId?: (Scalars['ID'] | null),driverId?: (Scalars['ID'] | null),driverNotes?: (Scalars['String'] | null),estimatedArrival?: (Scalars['ZonedDateTime'] | null),externalNotes?: (Scalars['String'] | null),facilityGroupId?: (Scalars['ID'] | null),facilityId?: (Scalars['ID'] | null),haulerId?: (Scalars['ID'] | null),internalNotes?: (Scalars['String'] | null),priority?: (Scalars['Int'] | null),rank?: (Scalars['String'] | null),recurringSchedule?: (RecurringScheduleInput | null),routeId?: (Scalars['ID'] | null),routePosition?: (Scalars['Decimal'] | null),scheduledWindowEnd?: (Scalars['ZonedDateTime'] | null),scheduledWindowStart?: (Scalars['ZonedDateTime'] | null),serviceTypeId?: (Scalars['ID'] | null),status?: (ServiceStatus | null),trailerId?: (Scalars['ID'] | null),truckId?: (Scalars['ID'] | null)}

export interface UpdateSettingInput {constraints?: (FieldConstraintsInput | null),dataType?: (FieldDataType | null),defaultValue?: (Scalars['Any'] | null),description?: (Scalars['String'] | null),name?: (Scalars['String'] | null),scope?: (SettingScope[] | null)}

export interface UpdateSettingsGroupInput {description?: (Scalars['String'] | null),icon?: (Scalars['String'] | null),name?: (Scalars['String'] | null)}

export interface UpdateSidecarInput {facilityId?: (Scalars['ID'] | null),name?: (Scalars['String'] | null),operatingSystem?: (SidecarOperatingSystem | null),operatingSystemVersion?: (Scalars['String'] | null),settings?: (SidecarSettingsInput | null)}

export interface UpdateTollReceiptItemInput {id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),lotId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),quantity?: (Scalars['Decimal'] | null),quantityUnit?: (Unit | null),tollReceiptId?: (Scalars['ID'] | null)}

export interface UpdateTollShipmentItemInput {id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),lotId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),processingFee?: (MoneyInput | null),quantity?: (Scalars['Decimal'] | null),quantityUnit?: (Unit | null),tollShipmentId?: (Scalars['ID'] | null)}

export interface UpdateTrailerInput {capacity?: (Scalars['Float'] | null),country?: (Scalars['String'] | null),currentLocation?: (PointInput | null),facilityId?: (Scalars['ID'] | null),lastLocationTime?: (Scalars['ZonedDateTime'] | null),licensePlate?: (Scalars['String'] | null),licensePlateExpiration?: (Scalars['ZonedDateTime'] | null),notes?: (Scalars['String'] | null),state?: (Scalars['String'] | null),status?: (TrailerStatus | null),transportationTypeId?: (Scalars['ID'] | null),vin?: (Scalars['String'] | null)}

export interface UpdateTransportationTypeInput {description?: (Scalars['String'] | null),name?: (Scalars['String'] | null)}

export interface UpdateTruckInput {capacity?: (Scalars['Float'] | null),country?: (Scalars['String'] | null),currentLocation?: (PointInput | null),defaultTrailerId?: (Scalars['ID'] | null),facilityId?: (Scalars['ID'] | null),lastLocationTime?: (Scalars['ZonedDateTime'] | null),licensePlate?: (Scalars['String'] | null),licensePlateExpiration?: (Scalars['ZonedDateTime'] | null),model?: (Scalars['String'] | null),notes?: (Scalars['String'] | null),state?: (Scalars['String'] | null),status?: (TruckStatus | null),transportationTypeId?: (Scalars['ID'] | null),vin?: (Scalars['String'] | null),year?: (Scalars['Int'] | null)}

export interface UpdateUserInput {email?: (Scalars['String'] | null),firstName?: (Scalars['String'] | null),idpId?: (Scalars['String'] | null),lastName?: (Scalars['String'] | null),phoneNumber?: (Scalars['String'] | null),timezone?: (Scalars['Timezone'] | null)}

export interface UpdateUserPreferencesInput {defaultCashDrawerId?: (Scalars['ID'] | null),enableDefaultPrinting?: (Scalars['Boolean'] | null),primaryFacilityId?: (Scalars['ID'] | null),primaryScaleId?: (Scalars['ID'] | null),primarySidecarId?: (Scalars['ID'] | null),skipScalePayment?: (Scalars['Boolean'] | null),userId: Scalars['ID'],ustudioBrightness?: (Scalars['Int'] | null),ustudioEnabled?: (Scalars['Boolean'] | null)}

export interface UpdateWarehouseCredentialInput {databaseName?: (Scalars['String'] | null),enabled?: (Scalars['Boolean'] | null),host?: (Scalars['String'] | null),port?: (Scalars['Int'] | null),ssl?: (Scalars['Boolean'] | null),username?: (Scalars['String'] | null)}

export interface UpdateWorkOrderInputItemInput {actualQuantity?: (Scalars['Decimal'] | null),actualQuantityUnit?: (Unit | null),id?: (Scalars['ID'] | null),itemId?: (Scalars['ID'] | null),lotId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),plannedQuantity?: (Scalars['Decimal'] | null),plannedQuantityUnit?: (Unit | null),tagId?: (Scalars['ID'] | null),unitCost?: (MoneyInput | null),workOrderId?: (Scalars['ID'] | null)}

export interface UpdateWorkOrderOutputItemInput {actualQuantity?: (Scalars['Decimal'] | null),actualQuantityUnit?: (Unit | null),allocatedCost?: (MoneyInput | null),costAllocationPercentage?: (Scalars['Decimal'] | null),expectedQuantity?: (Scalars['Decimal'] | null),expectedQuantityUnit?: (Unit | null),id?: (Scalars['ID'] | null),isNoCost?: (Scalars['Boolean'] | null),itemId?: (Scalars['ID'] | null),notes?: (Scalars['String'] | null),targetLotId?: (Scalars['ID'] | null),targetTagId?: (Scalars['ID'] | null),unitCost?: (MoneyInput | null),workOrderId?: (Scalars['ID'] | null),yieldPercentage?: (Scalars['Decimal'] | null)}

export interface UsageMetricsAggregationGenqlSelection{
    model?: boolean | number
    modelProvider?: boolean | number
    organization?: OrganizationGenqlSelection
    periodEnd?: boolean | number
    periodStart?: boolean | number
    recordCount?: boolean | number
    totalCacheReadTokens?: boolean | number
    totalCost?: MoneyGenqlSelection
    totalInputTokens?: boolean | number
    totalOutputTokens?: boolean | number
    totalReasoningTokens?: boolean | number
    totalTokens?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UsageMetricsFilterInput {dateFrom?: (Scalars['CalendarDate'] | null),dateTo?: (Scalars['CalendarDate'] | null),model?: (Scalars['String'] | null),modelProvider?: (Scalars['String'] | null),organizationIds?: (Scalars['ID'][] | null)}

export interface UsageMetricsResultPageGenqlSelection{
    entries?: UsageMetricsAggregationGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserGenqlSelection{
    createdAt?: boolean | number
    email?: boolean | number
    facilities?: FacilityGenqlSelection
    facilityGroups?: FacilityGroupGenqlSelection
    firstName?: boolean | number
    id?: boolean | number
    idpId?: boolean | number
    lastName?: boolean | number
    organizations?: OrganizationGenqlSelection
    phoneNumber?: boolean | number
    status?: boolean | number
    timezone?: boolean | number
    updatedAt?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** A contact that a user can chat with */
export interface UserContactGenqlSelection{
    contactType?: boolean | number
    email?: boolean | number
    id?: boolean | number
    isOnline?: boolean | number
    name?: boolean | number
    organizationName?: boolean | number
    phone?: boolean | number
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}


/** Filter options for user contacts */
export interface UserContactsFilter {contactType?: (ContactType | null),limit?: (Scalars['Int'] | null),offset?: (Scalars['Int'] | null),searchTerm?: (Scalars['String'] | null),sortBy?: (UserContactsSortBy | null),sortOrder?: (SortOrder | null)}


/** Result set for user contacts list */
export interface UserContactsListResultGenqlSelection{
    data?: UserContactGenqlSelection
    totalCount?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserFilter {ids?: (Scalars['ID'][] | null),organizationId?: (Scalars['ID'] | null),searchTerm?: (Scalars['String'] | null),status?: (UserStatus | null)}


/** Represents possible outcomes of a user invitation acceptance attempt */
export interface UserInvitationAcceptResultGenqlSelection{
    on_InvalidUserInvitationError?:InvalidUserInvitationErrorGenqlSelection,
    on_UserInvitationAcceptedResult?:UserInvitationAcceptedResultGenqlSelection,
    __typename?: boolean | number
}


/** Result returned when a user invitation is successfully accepted */
export interface UserInvitationAcceptedResultGenqlSelection{
    /** The email address of the user */
    email?: boolean | number
    /** Whether the invitation was successfully accepted */
    success?: boolean | number
    /** The user ID */
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserPreferencesGenqlSelection{
    defaultCashDrawerId?: boolean | number
    enableDefaultPrinting?: boolean | number
    primaryFacilityId?: boolean | number
    primaryScaleId?: boolean | number
    primarySidecarId?: boolean | number
    skipScalePayment?: boolean | number
    ustudioBrightness?: boolean | number
    ustudioEnabled?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserRegistrationInput {firstName: Scalars['String'],lastName: Scalars['String'],password: Scalars['String']}

export interface UserResultPageGenqlSelection{
    entries?: UserGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserRoleAssignmentGenqlSelection{
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    organizationId?: boolean | number
    role?: RoleGenqlSelection
    roleId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    user?: UserGenqlSelection
    userId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface UserRoleAssignmentFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),pagination?: (PaginationInput | null),roleId?: (Scalars['ID'] | null),sorting?: (UserRoleAssignmentSortOption[] | null),userId?: (Scalars['ID'] | null)}

export interface UserRoleAssignmentInput {facilityId: Scalars['ID'],roleId: Scalars['ID']}

export interface UserRoleAssignmentResultPageGenqlSelection{
    entries?: UserRoleAssignmentGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ValidationIssueGenqlSelection{
    code?: boolean | number
    field?: boolean | number
    message?: boolean | number
    nodeId?: boolean | number
    severity?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VariableGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    description?: boolean | number
    id?: boolean | number
    name?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedById?: boolean | number
    updatedByUser?: UserGenqlSelection
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VariableFilter {ids?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null)}

export interface VariableInput {description?: (Scalars['String'] | null),name: Scalars['String'],updatedById?: (Scalars['ID'] | null),value?: (Scalars['Decimal'] | null)}

export interface VariableResultPageGenqlSelection{
    entries?: VariableGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VariableUpdateInput {description?: (Scalars['String'] | null),name?: (Scalars['String'] | null),updatedById?: (Scalars['ID'] | null),value?: (Scalars['Decimal'] | null)}

export interface VariableUpdateResultGenqlSelection{
    affectedTierCount?: boolean | number
    validationErrors?: VariableValidationErrorGenqlSelection
    variable?: VariableGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VariableValidationErrorGenqlSelection{
    calculatedValues?: boolean | number
    formulaType?: boolean | number
    itemId?: boolean | number
    itemPricingId?: boolean | number
    priceListName?: boolean | number
    priceListType?: boolean | number
    tierIndex?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoidBookingItemResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    booking?: BookingGenqlSelection
    requiresConfirmation?: boolean | number
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoidBookingResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    booking?: BookingGenqlSelection
    requiresConfirmation?: boolean | number
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoidSalesOrderItemResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    requiresConfirmation?: boolean | number
    salesOrder?: SalesOrderGenqlSelection
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoidSalesOrderResultGenqlSelection{
    blockingLoads?: AffectedLoadGenqlSelection
    requiresConfirmation?: boolean | number
    salesOrder?: SalesOrderGenqlSelection
    unlinkableLoads?: AffectedLoadGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoucherTemplateGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    financialAccountId?: boolean | number
    id?: boolean | number
    showAccountNumber?: boolean | number
    showDiscountAmount?: boolean | number
    showInvoiceAmount?: boolean | number
    showInvoiceDate?: boolean | number
    showInvoiceNumber?: boolean | number
    showMemo?: boolean | number
    showNetAmount?: boolean | number
    showPayeeAddress?: boolean | number
    showPayeeName?: boolean | number
    showPaymentDate?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoucherTemplateFilter {facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null)}

export interface VoucherTemplateInput {facilityId: Scalars['ID'],financialAccountId: Scalars['ID'],showAccountNumber: Scalars['Boolean'],showDiscountAmount: Scalars['Boolean'],showInvoiceAmount: Scalars['Boolean'],showInvoiceDate: Scalars['Boolean'],showInvoiceNumber: Scalars['Boolean'],showMemo: Scalars['Boolean'],showNetAmount: Scalars['Boolean'],showPayeeAddress: Scalars['Boolean'],showPayeeName: Scalars['Boolean'],showPaymentDate: Scalars['Boolean']}

export interface VoucherTemplateResultPageGenqlSelection{
    entries?: VoucherTemplateGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface VoucherTemplateUpdateInput {facilityId?: (Scalars['ID'] | null),financialAccountId?: (Scalars['ID'] | null),showAccountNumber?: (Scalars['Boolean'] | null),showDiscountAmount?: (Scalars['Boolean'] | null),showInvoiceAmount?: (Scalars['Boolean'] | null),showInvoiceDate?: (Scalars['Boolean'] | null),showInvoiceNumber?: (Scalars['Boolean'] | null),showMemo?: (Scalars['Boolean'] | null),showNetAmount?: (Scalars['Boolean'] | null),showPayeeAddress?: (Scalars['Boolean'] | null),showPayeeName?: (Scalars['Boolean'] | null),showPaymentDate?: (Scalars['Boolean'] | null)}

export interface WOPIDiscoveryInfoGenqlSelection{
    collaboraUrl?: boolean | number
    discoveryUrl?: boolean | number
    maxFileSize?: boolean | number
    supportedFileTypes?: WOPISupportedFileTypeGenqlSelection
    wopiSrc?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WOPIEditingSessionGenqlSelection{
    collaboraUrl?: boolean | number
    editUrl?: boolean | number
    fileId?: boolean | number
    token?: WOPITokenGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WOPISupportedFileTypeGenqlSelection{
    actions?: boolean | number
    defaultAction?: boolean | number
    extension?: boolean | number
    mimeType?: boolean | number
    name?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WOPITokenGenqlSelection{
    expiresAt?: boolean | number
    fileId?: boolean | number
    permission?: boolean | number
    token?: boolean | number
    tokenId?: boolean | number
    userEmail?: boolean | number
    userId?: boolean | number
    userName?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseCredentialGenqlSelection{
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    databaseName?: boolean | number
    enabled?: boolean | number
    host?: boolean | number
    id?: boolean | number
    port?: boolean | number
    ssl?: boolean | number
    timestamps?: TimestampsGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    username?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WarehouseCredentialFilter {ids?: (Scalars['ID'][] | null)}

export interface WarehouseCredentialResultPageGenqlSelection{
    entries?: WarehouseCredentialGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WebhookEndpointGenqlSelection{
    automationId?: boolean | number
    id?: boolean | number
    isActive?: boolean | number
    lastUsedAt?: boolean | number
    path?: boolean | number
    secret?: boolean | number
    timestamps?: TimestampsGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WeightGenqlSelection{
    unit?: boolean | number
    value?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WeightInput {unit: Unit,value: Scalars['Decimal']}

export interface WorkOrderGenqlSelection{
    actualEndDate?: boolean | number
    actualStartDate?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facility?: FacilityGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    inboundTollingAgreement?: InboundTollingAgreementGenqlSelection
    inboundTollingAgreementId?: boolean | number
    inputItems?: WorkOrderInputItemGenqlSelection
    notes?: boolean | number
    outboundTollingAgreementId?: boolean | number
    outputItems?: WorkOrderOutputItemGenqlSelection
    processingType?: ProcessingTypeGenqlSelection
    processingTypeId?: boolean | number
    scheduledEndDate?: boolean | number
    scheduledStartDate?: boolean | number
    sourcePurchaseLoadLineItem?: PurchaseLoadLineItemGenqlSelection
    sourcePurchaseLoadLineItemId?: boolean | number
    status?: boolean | number
    timestamps?: TimestampsGenqlSelection
    tollCustomerAccount?: AccountGenqlSelection
    tollCustomerAccountId?: boolean | number
    tollingType?: boolean | number
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    workOrderNumber?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorkOrderFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),fromActualEndDate?: (Scalars['ZonedDateTime'] | null),fromActualStartDate?: (Scalars['ZonedDateTime'] | null),fromScheduledEndDate?: (Scalars['ZonedDateTime'] | null),fromScheduledStartDate?: (Scalars['ZonedDateTime'] | null),ids?: (Scalars['ID'][] | null),inboundTollingAgreementId?: (Scalars['ID'] | null),inboundTollingAgreementIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),outboundTollingAgreementId?: (Scalars['ID'] | null),outboundTollingAgreementIds?: (Scalars['ID'][] | null),processingTypeId?: (Scalars['ID'] | null),processingTypeIds?: (Scalars['ID'][] | null),searchTerm?: (Scalars['String'] | null),sourcePurchaseLoadLineItemId?: (Scalars['ID'] | null),sourcePurchaseLoadLineItemIds?: (Scalars['ID'][] | null),status?: (WorkOrderStatus[] | null),toActualEndDate?: (Scalars['ZonedDateTime'] | null),toActualStartDate?: (Scalars['ZonedDateTime'] | null),toScheduledEndDate?: (Scalars['ZonedDateTime'] | null),toScheduledStartDate?: (Scalars['ZonedDateTime'] | null),tollCustomerAccountId?: (Scalars['ID'] | null),tollCustomerAccountIds?: (Scalars['ID'][] | null),tollingType?: (TollingType[] | null),workOrderNumber?: (Scalars['String'] | null)}

export interface WorkOrderInput {actualEndDate?: (Scalars['ZonedDateTime'] | null),actualStartDate?: (Scalars['ZonedDateTime'] | null),facilityId: Scalars['ID'],inboundTollingAgreementId?: (Scalars['ID'] | null),inputItems?: (CreateWorkOrderInputItemInput[] | null),notes?: (Scalars['String'] | null),outboundTollingAgreementId?: (Scalars['ID'] | null),outputItems?: (CreateWorkOrderOutputItemInput[] | null),processingTypeId: Scalars['ID'],scheduledEndDate?: (Scalars['ZonedDateTime'] | null),scheduledStartDate?: (Scalars['ZonedDateTime'] | null),sourcePurchaseLoadLineItemId?: (Scalars['ID'] | null),status: WorkOrderStatus,tollCustomerAccountId?: (Scalars['ID'] | null),tollingType: TollingType,workOrderNumber?: (Scalars['String'] | null)}

export interface WorkOrderInputItemGenqlSelection{
    actualQuantity?: boolean | number
    actualQuantityUnit?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    facilityId?: boolean | number
    id?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    lot?: InventoryLotGenqlSelection
    lotId?: boolean | number
    notes?: boolean | number
    plannedQuantity?: boolean | number
    plannedQuantityUnit?: boolean | number
    tag?: InventoryTagGenqlSelection
    tagId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    unitCost?: MoneyGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    workOrderId?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorkOrderInputItemFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),lotId?: (Scalars['ID'] | null),lotIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),tagId?: (Scalars['ID'] | null),tagIds?: (Scalars['ID'][] | null),workOrderId?: (Scalars['ID'] | null),workOrderIds?: (Scalars['ID'][] | null)}

export interface WorkOrderInputItemResultPageGenqlSelection{
    entries?: WorkOrderInputItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorkOrderOutputItemGenqlSelection{
    actualQuantity?: boolean | number
    actualQuantityUnit?: boolean | number
    allocatedCost?: MoneyGenqlSelection
    costAllocationPercentage?: boolean | number
    createdBy?: boolean | number
    createdByUser?: UserGenqlSelection
    expectedQuantity?: boolean | number
    expectedQuantityUnit?: boolean | number
    facilityId?: boolean | number
    id?: boolean | number
    isNoCost?: boolean | number
    item?: ItemGenqlSelection
    itemId?: boolean | number
    notes?: boolean | number
    targetLot?: InventoryLotGenqlSelection
    targetLotId?: boolean | number
    targetTag?: InventoryTagGenqlSelection
    targetTagId?: boolean | number
    timestamps?: TimestampsGenqlSelection
    unitCost?: MoneyGenqlSelection
    updatedBy?: boolean | number
    updatedByUser?: UserGenqlSelection
    workOrderId?: boolean | number
    yieldPercentage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorkOrderOutputItemFilter {facilityId?: (Scalars['ID'] | null),facilityIds?: (Scalars['ID'][] | null),ids?: (Scalars['ID'][] | null),itemId?: (Scalars['ID'] | null),itemIds?: (Scalars['ID'][] | null),notes?: (Scalars['String'] | null),searchTerm?: (Scalars['String'] | null),targetLotId?: (Scalars['ID'] | null),targetLotIds?: (Scalars['ID'][] | null),targetTagId?: (Scalars['ID'] | null),targetTagIds?: (Scalars['ID'][] | null),workOrderId?: (Scalars['ID'] | null),workOrderIds?: (Scalars['ID'][] | null)}

export interface WorkOrderOutputItemResultPageGenqlSelection{
    entries?: WorkOrderOutputItemGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorkOrderResultPageGenqlSelection{
    entries?: WorkOrderGenqlSelection
    page?: PageGenqlSelection
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface WorkOrderUpdateInput {actualEndDate?: (Scalars['ZonedDateTime'] | null),actualStartDate?: (Scalars['ZonedDateTime'] | null),facilityId?: (Scalars['ID'] | null),inboundTollingAgreementId?: (Scalars['ID'] | null),inputItems?: (UpdateWorkOrderInputItemInput[] | null),notes?: (Scalars['String'] | null),outboundTollingAgreementId?: (Scalars['ID'] | null),outputItems?: (UpdateWorkOrderOutputItemInput[] | null),processingTypeId?: (Scalars['ID'] | null),scheduledEndDate?: (Scalars['ZonedDateTime'] | null),scheduledStartDate?: (Scalars['ZonedDateTime'] | null),sourcePurchaseLoadLineItemId?: (Scalars['ID'] | null),tollCustomerAccountId?: (Scalars['ID'] | null),tollingType?: (TollingType | null),workOrderNumber?: (Scalars['String'] | null)}

export interface WriteOffInvoiceInput {amount: MoneyInput,invoiceId: Scalars['ID'],notes?: (Scalars['String'] | null)}

export interface ZoneUtilizationGenqlSelection{
    availableCapacity?: boolean | number
    totalCapacity?: boolean | number
    usedCapacity?: boolean | number
    utilizationPercentage?: boolean | number
    __typename?: boolean | number
    __scalar?: boolean | number
}

export interface ZonedDateTimeRangeInput {end?: (Scalars['ZonedDateTime'] | null),start?: (Scalars['ZonedDateTime'] | null)}


    const AcceptCustomerInvitationResult_possibleTypes: string[] = ['AcceptCustomerInvitationResult']
    export const isAcceptCustomerInvitationResult = (obj?: { __typename?: any } | null): obj is AcceptCustomerInvitationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAcceptCustomerInvitationResult"')
      return AcceptCustomerInvitationResult_possibleTypes.includes(obj.__typename)
    }
    


    const AccessURLPayload_possibleTypes: string[] = ['AccessURLPayload']
    export const isAccessURLPayload = (obj?: { __typename?: any } | null): obj is AccessURLPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccessURLPayload"')
      return AccessURLPayload_possibleTypes.includes(obj.__typename)
    }
    


    const Account_possibleTypes: string[] = ['Account']
    export const isAccount = (obj?: { __typename?: any } | null): obj is Account => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccount"')
      return Account_possibleTypes.includes(obj.__typename)
    }
    


    const AccountAddress_possibleTypes: string[] = ['AccountAddress']
    export const isAccountAddress = (obj?: { __typename?: any } | null): obj is AccountAddress => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountAddress"')
      return AccountAddress_possibleTypes.includes(obj.__typename)
    }
    


    const AccountAddressResultPage_possibleTypes: string[] = ['AccountAddressResultPage']
    export const isAccountAddressResultPage = (obj?: { __typename?: any } | null): obj is AccountAddressResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountAddressResultPage"')
      return AccountAddressResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AccountBankDetail_possibleTypes: string[] = ['AccountBankDetail']
    export const isAccountBankDetail = (obj?: { __typename?: any } | null): obj is AccountBankDetail => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountBankDetail"')
      return AccountBankDetail_possibleTypes.includes(obj.__typename)
    }
    


    const AccountBankDetailResultPage_possibleTypes: string[] = ['AccountBankDetailResultPage']
    export const isAccountBankDetailResultPage = (obj?: { __typename?: any } | null): obj is AccountBankDetailResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountBankDetailResultPage"')
      return AccountBankDetailResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AccountIdentityDocument_possibleTypes: string[] = ['AccountIdentityDocument']
    export const isAccountIdentityDocument = (obj?: { __typename?: any } | null): obj is AccountIdentityDocument => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountIdentityDocument"')
      return AccountIdentityDocument_possibleTypes.includes(obj.__typename)
    }
    


    const AccountIdentityDocumentResultPage_possibleTypes: string[] = ['AccountIdentityDocumentResultPage']
    export const isAccountIdentityDocumentResultPage = (obj?: { __typename?: any } | null): obj is AccountIdentityDocumentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountIdentityDocumentResultPage"')
      return AccountIdentityDocumentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AccountIndividualDetails_possibleTypes: string[] = ['AccountIndividualDetails']
    export const isAccountIndividualDetails = (obj?: { __typename?: any } | null): obj is AccountIndividualDetails => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountIndividualDetails"')
      return AccountIndividualDetails_possibleTypes.includes(obj.__typename)
    }
    


    const AccountIndividualDetailsResultPage_possibleTypes: string[] = ['AccountIndividualDetailsResultPage']
    export const isAccountIndividualDetailsResultPage = (obj?: { __typename?: any } | null): obj is AccountIndividualDetailsResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountIndividualDetailsResultPage"')
      return AccountIndividualDetailsResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AccountRelationship_possibleTypes: string[] = ['AccountRelationship']
    export const isAccountRelationship = (obj?: { __typename?: any } | null): obj is AccountRelationship => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountRelationship"')
      return AccountRelationship_possibleTypes.includes(obj.__typename)
    }
    


    const AccountResultPage_possibleTypes: string[] = ['AccountResultPage']
    export const isAccountResultPage = (obj?: { __typename?: any } | null): obj is AccountResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAccountResultPage"')
      return AccountResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Address_possibleTypes: string[] = ['Address']
    export const isAddress = (obj?: { __typename?: any } | null): obj is Address => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAddress"')
      return Address_possibleTypes.includes(obj.__typename)
    }
    


    const AffectedLoad_possibleTypes: string[] = ['AffectedLoad']
    export const isAffectedLoad = (obj?: { __typename?: any } | null): obj is AffectedLoad => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAffectedLoad"')
      return AffectedLoad_possibleTypes.includes(obj.__typename)
    }
    


    const Agent_possibleTypes: string[] = ['Agent']
    export const isAgent = (obj?: { __typename?: any } | null): obj is Agent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAgent"')
      return Agent_possibleTypes.includes(obj.__typename)
    }
    


    const AgentMetadata_possibleTypes: string[] = ['AgentMetadata']
    export const isAgentMetadata = (obj?: { __typename?: any } | null): obj is AgentMetadata => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAgentMetadata"')
      return AgentMetadata_possibleTypes.includes(obj.__typename)
    }
    


    const AgentResultPage_possibleTypes: string[] = ['AgentResultPage']
    export const isAgentResultPage = (obj?: { __typename?: any } | null): obj is AgentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAgentResultPage"')
      return AgentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ApprovalNode_possibleTypes: string[] = ['ApprovalNode']
    export const isApprovalNode = (obj?: { __typename?: any } | null): obj is ApprovalNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isApprovalNode"')
      return ApprovalNode_possibleTypes.includes(obj.__typename)
    }
    


    const ApprovalRequest_possibleTypes: string[] = ['ApprovalRequest']
    export const isApprovalRequest = (obj?: { __typename?: any } | null): obj is ApprovalRequest => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isApprovalRequest"')
      return ApprovalRequest_possibleTypes.includes(obj.__typename)
    }
    


    const ApprovalRequestResultPage_possibleTypes: string[] = ['ApprovalRequestResultPage']
    export const isApprovalRequestResultPage = (obj?: { __typename?: any } | null): obj is ApprovalRequestResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isApprovalRequestResultPage"')
      return ApprovalRequestResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ApproverConfig_possibleTypes: string[] = ['ApproverConfig']
    export const isApproverConfig = (obj?: { __typename?: any } | null): obj is ApproverConfig => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isApproverConfig"')
      return ApproverConfig_possibleTypes.includes(obj.__typename)
    }
    


    const ArchiveDownloadPayload_possibleTypes: string[] = ['ArchiveDownloadPayload']
    export const isArchiveDownloadPayload = (obj?: { __typename?: any } | null): obj is ArchiveDownloadPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isArchiveDownloadPayload"')
      return ArchiveDownloadPayload_possibleTypes.includes(obj.__typename)
    }
    


    const Asset_possibleTypes: string[] = ['Asset']
    export const isAsset = (obj?: { __typename?: any } | null): obj is Asset => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAsset"')
      return Asset_possibleTypes.includes(obj.__typename)
    }
    


    const AssetLocationHistory_possibleTypes: string[] = ['AssetLocationHistory']
    export const isAssetLocationHistory = (obj?: { __typename?: any } | null): obj is AssetLocationHistory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssetLocationHistory"')
      return AssetLocationHistory_possibleTypes.includes(obj.__typename)
    }
    


    const AssetLocationHistoryResultPage_possibleTypes: string[] = ['AssetLocationHistoryResultPage']
    export const isAssetLocationHistoryResultPage = (obj?: { __typename?: any } | null): obj is AssetLocationHistoryResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssetLocationHistoryResultPage"')
      return AssetLocationHistoryResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AssetResultPage_possibleTypes: string[] = ['AssetResultPage']
    export const isAssetResultPage = (obj?: { __typename?: any } | null): obj is AssetResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssetResultPage"')
      return AssetResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AssetType_possibleTypes: string[] = ['AssetType']
    export const isAssetType = (obj?: { __typename?: any } | null): obj is AssetType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssetType"')
      return AssetType_possibleTypes.includes(obj.__typename)
    }
    


    const AssetTypeResultPage_possibleTypes: string[] = ['AssetTypeResultPage']
    export const isAssetTypeResultPage = (obj?: { __typename?: any } | null): obj is AssetTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssetTypeResultPage"')
      return AssetTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantAgentStreamEvent_possibleTypes: string[] = ['AssistantAgentStreamEvent']
    export const isAssistantAgentStreamEvent = (obj?: { __typename?: any } | null): obj is AssistantAgentStreamEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantAgentStreamEvent"')
      return AssistantAgentStreamEvent_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantChat_possibleTypes: string[] = ['AssistantChat']
    export const isAssistantChat = (obj?: { __typename?: any } | null): obj is AssistantChat => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantChat"')
      return AssistantChat_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantChatMessage_possibleTypes: string[] = ['AssistantChatMessage']
    export const isAssistantChatMessage = (obj?: { __typename?: any } | null): obj is AssistantChatMessage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantChatMessage"')
      return AssistantChatMessage_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantChatMessagePart_possibleTypes: string[] = ['AssistantChatMessagePart']
    export const isAssistantChatMessagePart = (obj?: { __typename?: any } | null): obj is AssistantChatMessagePart => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantChatMessagePart"')
      return AssistantChatMessagePart_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantChatResultPage_possibleTypes: string[] = ['AssistantChatResultPage']
    export const isAssistantChatResultPage = (obj?: { __typename?: any } | null): obj is AssistantChatResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantChatResultPage"')
      return AssistantChatResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantChatShareLink_possibleTypes: string[] = ['AssistantChatShareLink']
    export const isAssistantChatShareLink = (obj?: { __typename?: any } | null): obj is AssistantChatShareLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantChatShareLink"')
      return AssistantChatShareLink_possibleTypes.includes(obj.__typename)
    }
    


    const AssistantOutboxEventCounts_possibleTypes: string[] = ['AssistantOutboxEventCounts']
    export const isAssistantOutboxEventCounts = (obj?: { __typename?: any } | null): obj is AssistantOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAssistantOutboxEventCounts"')
      return AssistantOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const Attachment_possibleTypes: string[] = ['Attachment']
    export const isAttachment = (obj?: { __typename?: any } | null): obj is Attachment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAttachment"')
      return Attachment_possibleTypes.includes(obj.__typename)
    }
    


    const AuthenticationImpersonator_possibleTypes: string[] = ['AuthenticationImpersonator']
    export const isAuthenticationImpersonator = (obj?: { __typename?: any } | null): obj is AuthenticationImpersonator => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAuthenticationImpersonator"')
      return AuthenticationImpersonator_possibleTypes.includes(obj.__typename)
    }
    


    const AuthenticationOrganization_possibleTypes: string[] = ['AuthenticationOrganization']
    export const isAuthenticationOrganization = (obj?: { __typename?: any } | null): obj is AuthenticationOrganization => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAuthenticationOrganization"')
      return AuthenticationOrganization_possibleTypes.includes(obj.__typename)
    }
    


    const AuthenticationResponse_possibleTypes: string[] = ['AuthenticationResponse']
    export const isAuthenticationResponse = (obj?: { __typename?: any } | null): obj is AuthenticationResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAuthenticationResponse"')
      return AuthenticationResponse_possibleTypes.includes(obj.__typename)
    }
    


    const AuthenticationResult_possibleTypes: string[] = ['AuthenticationResponse','EmailVerificationRequiredError','InvalidCredentialsError','InvalidOneTimeCode','MfaChallengeError','MfaEnrollmentRequiredError','OneTimeCodeExpired','OrganizationSelectionError','SsoRequiredError']
    export const isAuthenticationResult = (obj?: { __typename?: any } | null): obj is AuthenticationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAuthenticationResult"')
      return AuthenticationResult_possibleTypes.includes(obj.__typename)
    }
    


    const Automation_possibleTypes: string[] = ['Automation']
    export const isAutomation = (obj?: { __typename?: any } | null): obj is Automation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAutomation"')
      return Automation_possibleTypes.includes(obj.__typename)
    }
    


    const AutomationBulkOperationResult_possibleTypes: string[] = ['AutomationBulkOperationResult']
    export const isAutomationBulkOperationResult = (obj?: { __typename?: any } | null): obj is AutomationBulkOperationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAutomationBulkOperationResult"')
      return AutomationBulkOperationResult_possibleTypes.includes(obj.__typename)
    }
    


    const AutomationDeleteResult_possibleTypes: string[] = ['AutomationDeleteResult']
    export const isAutomationDeleteResult = (obj?: { __typename?: any } | null): obj is AutomationDeleteResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAutomationDeleteResult"')
      return AutomationDeleteResult_possibleTypes.includes(obj.__typename)
    }
    


    const AutomationResultPage_possibleTypes: string[] = ['AutomationResultPage']
    export const isAutomationResultPage = (obj?: { __typename?: any } | null): obj is AutomationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAutomationResultPage"')
      return AutomationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const AutomationVersion_possibleTypes: string[] = ['AutomationVersion']
    export const isAutomationVersion = (obj?: { __typename?: any } | null): obj is AutomationVersion => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAutomationVersion"')
      return AutomationVersion_possibleTypes.includes(obj.__typename)
    }
    


    const AutomationVersionResultPage_possibleTypes: string[] = ['AutomationVersionResultPage']
    export const isAutomationVersionResultPage = (obj?: { __typename?: any } | null): obj is AutomationVersionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isAutomationVersionResultPage"')
      return AutomationVersionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Bill_possibleTypes: string[] = ['Bill']
    export const isBill = (obj?: { __typename?: any } | null): obj is Bill => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBill"')
      return Bill_possibleTypes.includes(obj.__typename)
    }
    


    const BillEntityReference_possibleTypes: string[] = ['BillEntityReference']
    export const isBillEntityReference = (obj?: { __typename?: any } | null): obj is BillEntityReference => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillEntityReference"')
      return BillEntityReference_possibleTypes.includes(obj.__typename)
    }
    


    const BillLineItem_possibleTypes: string[] = ['BillLineItem']
    export const isBillLineItem = (obj?: { __typename?: any } | null): obj is BillLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillLineItem"')
      return BillLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const BillPaymentApplication_possibleTypes: string[] = ['BillPaymentApplication']
    export const isBillPaymentApplication = (obj?: { __typename?: any } | null): obj is BillPaymentApplication => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillPaymentApplication"')
      return BillPaymentApplication_possibleTypes.includes(obj.__typename)
    }
    


    const BillResultPage_possibleTypes: string[] = ['BillResultPage']
    export const isBillResultPage = (obj?: { __typename?: any } | null): obj is BillResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillResultPage"')
      return BillResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const BillStatusCounts_possibleTypes: string[] = ['BillStatusCounts']
    export const isBillStatusCounts = (obj?: { __typename?: any } | null): obj is BillStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBillStatusCounts"')
      return BillStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const Booking_possibleTypes: string[] = ['Booking']
    export const isBooking = (obj?: { __typename?: any } | null): obj is Booking => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBooking"')
      return Booking_possibleTypes.includes(obj.__typename)
    }
    


    const BookingContainer_possibleTypes: string[] = ['BookingContainer']
    export const isBookingContainer = (obj?: { __typename?: any } | null): obj is BookingContainer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBookingContainer"')
      return BookingContainer_possibleTypes.includes(obj.__typename)
    }
    


    const BookingFileCreatePayload_possibleTypes: string[] = ['BookingFileCreatePayload']
    export const isBookingFileCreatePayload = (obj?: { __typename?: any } | null): obj is BookingFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBookingFileCreatePayload"')
      return BookingFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const BookingLoadStatusSummary_possibleTypes: string[] = ['BookingLoadStatusSummary']
    export const isBookingLoadStatusSummary = (obj?: { __typename?: any } | null): obj is BookingLoadStatusSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBookingLoadStatusSummary"')
      return BookingLoadStatusSummary_possibleTypes.includes(obj.__typename)
    }
    


    const BookingResultPage_possibleTypes: string[] = ['BookingResultPage']
    export const isBookingResultPage = (obj?: { __typename?: any } | null): obj is BookingResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBookingResultPage"')
      return BookingResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const BookingStatusCounts_possibleTypes: string[] = ['BookingStatusCounts']
    export const isBookingStatusCounts = (obj?: { __typename?: any } | null): obj is BookingStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBookingStatusCounts"')
      return BookingStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const BookingUpdateResult_possibleTypes: string[] = ['BookingUpdateResult']
    export const isBookingUpdateResult = (obj?: { __typename?: any } | null): obj is BookingUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBookingUpdateResult"')
      return BookingUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const BrokeredOrder_possibleTypes: string[] = ['BrokeredOrder']
    export const isBrokeredOrder = (obj?: { __typename?: any } | null): obj is BrokeredOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBrokeredOrder"')
      return BrokeredOrder_possibleTypes.includes(obj.__typename)
    }
    


    const BrokeredOrderLineItem_possibleTypes: string[] = ['BrokeredOrderLineItem']
    export const isBrokeredOrderLineItem = (obj?: { __typename?: any } | null): obj is BrokeredOrderLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBrokeredOrderLineItem"')
      return BrokeredOrderLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const BrokeredOrderLineItemResultPage_possibleTypes: string[] = ['BrokeredOrderLineItemResultPage']
    export const isBrokeredOrderLineItemResultPage = (obj?: { __typename?: any } | null): obj is BrokeredOrderLineItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBrokeredOrderLineItemResultPage"')
      return BrokeredOrderLineItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const BrokeredOrderResultPage_possibleTypes: string[] = ['BrokeredOrderResultPage']
    export const isBrokeredOrderResultPage = (obj?: { __typename?: any } | null): obj is BrokeredOrderResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBrokeredOrderResultPage"')
      return BrokeredOrderResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const BrokeredOrderValidationError_possibleTypes: string[] = ['BrokeredOrderValidationError']
    export const isBrokeredOrderValidationError = (obj?: { __typename?: any } | null): obj is BrokeredOrderValidationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBrokeredOrderValidationError"')
      return BrokeredOrderValidationError_possibleTypes.includes(obj.__typename)
    }
    


    const BrokeredOrderValidationResult_possibleTypes: string[] = ['BrokeredOrderValidationResult']
    export const isBrokeredOrderValidationResult = (obj?: { __typename?: any } | null): obj is BrokeredOrderValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBrokeredOrderValidationResult"')
      return BrokeredOrderValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkOperationResult_possibleTypes: string[] = ['BulkOperationResult']
    export const isBulkOperationResult = (obj?: { __typename?: any } | null): obj is BulkOperationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkOperationResult"')
      return BulkOperationResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkPaymentResult_possibleTypes: string[] = ['BulkPaymentResult']
    export const isBulkPaymentResult = (obj?: { __typename?: any } | null): obj is BulkPaymentResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkPaymentResult"')
      return BulkPaymentResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkVoidBookingResult_possibleTypes: string[] = ['BulkVoidBookingResult']
    export const isBulkVoidBookingResult = (obj?: { __typename?: any } | null): obj is BulkVoidBookingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkVoidBookingResult"')
      return BulkVoidBookingResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkVoidLoadResult_possibleTypes: string[] = ['BulkVoidLoadResult']
    export const isBulkVoidLoadResult = (obj?: { __typename?: any } | null): obj is BulkVoidLoadResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkVoidLoadResult"')
      return BulkVoidLoadResult_possibleTypes.includes(obj.__typename)
    }
    


    const BulkVoidSalesOrderResult_possibleTypes: string[] = ['BulkVoidSalesOrderResult']
    export const isBulkVoidSalesOrderResult = (obj?: { __typename?: any } | null): obj is BulkVoidSalesOrderResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBulkVoidSalesOrderResult"')
      return BulkVoidSalesOrderResult_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventTriggerConfigOutput_possibleTypes: string[] = ['BusinessEventTriggerConfigOutput']
    export const isBusinessEventTriggerConfigOutput = (obj?: { __typename?: any } | null): obj is BusinessEventTriggerConfigOutput => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventTriggerConfigOutput"')
      return BusinessEventTriggerConfigOutput_possibleTypes.includes(obj.__typename)
    }
    


    const BusinessEventTriggerNode_possibleTypes: string[] = ['BusinessEventTriggerNode']
    export const isBusinessEventTriggerNode = (obj?: { __typename?: any } | null): obj is BusinessEventTriggerNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isBusinessEventTriggerNode"')
      return BusinessEventTriggerNode_possibleTypes.includes(obj.__typename)
    }
    


    const CalculatedRecipeItem_possibleTypes: string[] = ['CalculatedRecipeItem']
    export const isCalculatedRecipeItem = (obj?: { __typename?: any } | null): obj is CalculatedRecipeItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCalculatedRecipeItem"')
      return CalculatedRecipeItem_possibleTypes.includes(obj.__typename)
    }
    


    const CalculatedRecipeResult_possibleTypes: string[] = ['CalculatedRecipeResult']
    export const isCalculatedRecipeResult = (obj?: { __typename?: any } | null): obj is CalculatedRecipeResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCalculatedRecipeResult"')
      return CalculatedRecipeResult_possibleTypes.includes(obj.__typename)
    }
    


    const Camera_possibleTypes: string[] = ['Camera']
    export const isCamera = (obj?: { __typename?: any } | null): obj is Camera => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCamera"')
      return Camera_possibleTypes.includes(obj.__typename)
    }
    


    const CameraResultPage_possibleTypes: string[] = ['CameraResultPage']
    export const isCameraResultPage = (obj?: { __typename?: any } | null): obj is CameraResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCameraResultPage"')
      return CameraResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Category_possibleTypes: string[] = ['Category']
    export const isCategory = (obj?: { __typename?: any } | null): obj is Category => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategory"')
      return Category_possibleTypes.includes(obj.__typename)
    }
    


    const CategoryResultPage_possibleTypes: string[] = ['CategoryResultPage']
    export const isCategoryResultPage = (obj?: { __typename?: any } | null): obj is CategoryResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCategoryResultPage"')
      return CategoryResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CheckTemplate_possibleTypes: string[] = ['CheckTemplate']
    export const isCheckTemplate = (obj?: { __typename?: any } | null): obj is CheckTemplate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCheckTemplate"')
      return CheckTemplate_possibleTypes.includes(obj.__typename)
    }
    


    const CheckTemplateResultPage_possibleTypes: string[] = ['CheckTemplateResultPage']
    export const isCheckTemplateResultPage = (obj?: { __typename?: any } | null): obj is CheckTemplateResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCheckTemplateResultPage"')
      return CheckTemplateResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceCheck_possibleTypes: string[] = ['ComplianceCheck']
    export const isComplianceCheck = (obj?: { __typename?: any } | null): obj is ComplianceCheck => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceCheck"')
      return ComplianceCheck_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceCheckResultItem_possibleTypes: string[] = ['ComplianceCheckResultItem']
    export const isComplianceCheckResultItem = (obj?: { __typename?: any } | null): obj is ComplianceCheckResultItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceCheckResultItem"')
      return ComplianceCheckResultItem_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceCheckResultPage_possibleTypes: string[] = ['ComplianceCheckResultPage']
    export const isComplianceCheckResultPage = (obj?: { __typename?: any } | null): obj is ComplianceCheckResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceCheckResultPage"')
      return ComplianceCheckResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceDispatchImage_possibleTypes: string[] = ['ComplianceDispatchImage']
    export const isComplianceDispatchImage = (obj?: { __typename?: any } | null): obj is ComplianceDispatchImage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceDispatchImage"')
      return ComplianceDispatchImage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceDispatchImageResultPage_possibleTypes: string[] = ['ComplianceDispatchImageResultPage']
    export const isComplianceDispatchImageResultPage = (obj?: { __typename?: any } | null): obj is ComplianceDispatchImageResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceDispatchImageResultPage"')
      return ComplianceDispatchImageResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceDispatchRecord_possibleTypes: string[] = ['ComplianceDispatchRecord']
    export const isComplianceDispatchRecord = (obj?: { __typename?: any } | null): obj is ComplianceDispatchRecord => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceDispatchRecord"')
      return ComplianceDispatchRecord_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceDispatchRecordResultPage_possibleTypes: string[] = ['ComplianceDispatchRecordResultPage']
    export const isComplianceDispatchRecordResultPage = (obj?: { __typename?: any } | null): obj is ComplianceDispatchRecordResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceDispatchRecordResultPage"')
      return ComplianceDispatchRecordResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceEvaluationResult_possibleTypes: string[] = ['ComplianceEvaluationResult']
    export const isComplianceEvaluationResult = (obj?: { __typename?: any } | null): obj is ComplianceEvaluationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceEvaluationResult"')
      return ComplianceEvaluationResult_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceFacilityRule_possibleTypes: string[] = ['ComplianceFacilityRule']
    export const isComplianceFacilityRule = (obj?: { __typename?: any } | null): obj is ComplianceFacilityRule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceFacilityRule"')
      return ComplianceFacilityRule_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceFacilityRuleResultPage_possibleTypes: string[] = ['ComplianceFacilityRuleResultPage']
    export const isComplianceFacilityRuleResultPage = (obj?: { __typename?: any } | null): obj is ComplianceFacilityRuleResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceFacilityRuleResultPage"')
      return ComplianceFacilityRuleResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceHold_possibleTypes: string[] = ['ComplianceHold']
    export const isComplianceHold = (obj?: { __typename?: any } | null): obj is ComplianceHold => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceHold"')
      return ComplianceHold_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceHoldEvaluation_possibleTypes: string[] = ['ComplianceHoldEvaluation']
    export const isComplianceHoldEvaluation = (obj?: { __typename?: any } | null): obj is ComplianceHoldEvaluation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceHoldEvaluation"')
      return ComplianceHoldEvaluation_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceHoldResultPage_possibleTypes: string[] = ['ComplianceHoldResultPage']
    export const isComplianceHoldResultPage = (obj?: { __typename?: any } | null): obj is ComplianceHoldResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceHoldResultPage"')
      return ComplianceHoldResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceItemJurisdictionCode_possibleTypes: string[] = ['ComplianceItemJurisdictionCode']
    export const isComplianceItemJurisdictionCode = (obj?: { __typename?: any } | null): obj is ComplianceItemJurisdictionCode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceItemJurisdictionCode"')
      return ComplianceItemJurisdictionCode_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceItemJurisdictionCodeResultPage_possibleTypes: string[] = ['ComplianceItemJurisdictionCodeResultPage']
    export const isComplianceItemJurisdictionCodeResultPage = (obj?: { __typename?: any } | null): obj is ComplianceItemJurisdictionCodeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceItemJurisdictionCodeResultPage"')
      return ComplianceItemJurisdictionCodeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceRuleDefinition_possibleTypes: string[] = ['ComplianceRuleDefinition']
    export const isComplianceRuleDefinition = (obj?: { __typename?: any } | null): obj is ComplianceRuleDefinition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceRuleDefinition"')
      return ComplianceRuleDefinition_possibleTypes.includes(obj.__typename)
    }
    


    const ComplianceRuleDefinitionResultPage_possibleTypes: string[] = ['ComplianceRuleDefinitionResultPage']
    export const isComplianceRuleDefinitionResultPage = (obj?: { __typename?: any } | null): obj is ComplianceRuleDefinitionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isComplianceRuleDefinitionResultPage"')
      return ComplianceRuleDefinitionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ConditionNode_possibleTypes: string[] = ['ConditionNode']
    export const isConditionNode = (obj?: { __typename?: any } | null): obj is ConditionNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isConditionNode"')
      return ConditionNode_possibleTypes.includes(obj.__typename)
    }
    


    const Contact_possibleTypes: string[] = ['Contact']
    export const isContact = (obj?: { __typename?: any } | null): obj is Contact => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContact"')
      return Contact_possibleTypes.includes(obj.__typename)
    }
    


    const ContactResultPage_possibleTypes: string[] = ['ContactResultPage']
    export const isContactResultPage = (obj?: { __typename?: any } | null): obj is ContactResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContactResultPage"')
      return ContactResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Container_possibleTypes: string[] = ['Container']
    export const isContainer = (obj?: { __typename?: any } | null): obj is Container => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContainer"')
      return Container_possibleTypes.includes(obj.__typename)
    }
    


    const ContainerResultPage_possibleTypes: string[] = ['ContainerResultPage']
    export const isContainerResultPage = (obj?: { __typename?: any } | null): obj is ContainerResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContainerResultPage"')
      return ContainerResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ContainerStatusCounts_possibleTypes: string[] = ['ContainerStatusCounts']
    export const isContainerStatusCounts = (obj?: { __typename?: any } | null): obj is ContainerStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContainerStatusCounts"')
      return ContainerStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const ContainerType_possibleTypes: string[] = ['ContainerType']
    export const isContainerType = (obj?: { __typename?: any } | null): obj is ContainerType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContainerType"')
      return ContainerType_possibleTypes.includes(obj.__typename)
    }
    


    const ContainerTypeResultPage_possibleTypes: string[] = ['ContainerTypeResultPage']
    export const isContainerTypeResultPage = (obj?: { __typename?: any } | null): obj is ContainerTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isContainerTypeResultPage"')
      return ContainerTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Coordinates_possibleTypes: string[] = ['Coordinates']
    export const isCoordinates = (obj?: { __typename?: any } | null): obj is Coordinates => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCoordinates"')
      return Coordinates_possibleTypes.includes(obj.__typename)
    }
    


    const CoreOutboxEventCounts_possibleTypes: string[] = ['CoreOutboxEventCounts']
    export const isCoreOutboxEventCounts = (obj?: { __typename?: any } | null): obj is CoreOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCoreOutboxEventCounts"')
      return CoreOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const CounterpartyGroup_possibleTypes: string[] = ['CounterpartyGroup']
    export const isCounterpartyGroup = (obj?: { __typename?: any } | null): obj is CounterpartyGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCounterpartyGroup"')
      return CounterpartyGroup_possibleTypes.includes(obj.__typename)
    }
    


    const CounterpartyGroupMember_possibleTypes: string[] = ['CounterpartyGroupMember']
    export const isCounterpartyGroupMember = (obj?: { __typename?: any } | null): obj is CounterpartyGroupMember => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCounterpartyGroupMember"')
      return CounterpartyGroupMember_possibleTypes.includes(obj.__typename)
    }
    


    const CounterpartyGroupMemberResultPage_possibleTypes: string[] = ['CounterpartyGroupMemberResultPage']
    export const isCounterpartyGroupMemberResultPage = (obj?: { __typename?: any } | null): obj is CounterpartyGroupMemberResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCounterpartyGroupMemberResultPage"')
      return CounterpartyGroupMemberResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CounterpartyGroupResultPage_possibleTypes: string[] = ['CounterpartyGroupResultPage']
    export const isCounterpartyGroupResultPage = (obj?: { __typename?: any } | null): obj is CounterpartyGroupResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCounterpartyGroupResultPage"')
      return CounterpartyGroupResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CreateConversationResult_possibleTypes: string[] = ['CreateConversationResult']
    export const isCreateConversationResult = (obj?: { __typename?: any } | null): obj is CreateConversationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateConversationResult"')
      return CreateConversationResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateFileError_possibleTypes: string[] = ['CreateFileError']
    export const isCreateFileError = (obj?: { __typename?: any } | null): obj is CreateFileError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateFileError"')
      return CreateFileError_possibleTypes.includes(obj.__typename)
    }
    


    const CreateFilePayload_possibleTypes: string[] = ['CreateFilePayload']
    export const isCreateFilePayload = (obj?: { __typename?: any } | null): obj is CreateFilePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateFilePayload"')
      return CreateFilePayload_possibleTypes.includes(obj.__typename)
    }
    


    const CreateFileResult_possibleTypes: string[] = ['CreateFileError','CreateFileSuccess']
    export const isCreateFileResult = (obj?: { __typename?: any } | null): obj is CreateFileResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateFileResult"')
      return CreateFileResult_possibleTypes.includes(obj.__typename)
    }
    


    const CreateFileSuccess_possibleTypes: string[] = ['CreateFileSuccess']
    export const isCreateFileSuccess = (obj?: { __typename?: any } | null): obj is CreateFileSuccess => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateFileSuccess"')
      return CreateFileSuccess_possibleTypes.includes(obj.__typename)
    }
    


    const CreateFilesPayload_possibleTypes: string[] = ['CreateFilesPayload']
    export const isCreateFilesPayload = (obj?: { __typename?: any } | null): obj is CreateFilesPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCreateFilesPayload"')
      return CreateFilesPayload_possibleTypes.includes(obj.__typename)
    }
    


    const CrmOutboxEventCounts_possibleTypes: string[] = ['CrmOutboxEventCounts']
    export const isCrmOutboxEventCounts = (obj?: { __typename?: any } | null): obj is CrmOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCrmOutboxEventCounts"')
      return CrmOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const CustomAttribute_possibleTypes: string[] = ['CustomAttribute']
    export const isCustomAttribute = (obj?: { __typename?: any } | null): obj is CustomAttribute => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomAttribute"')
      return CustomAttribute_possibleTypes.includes(obj.__typename)
    }
    


    const CustomPriceList_possibleTypes: string[] = ['CustomPriceList']
    export const isCustomPriceList = (obj?: { __typename?: any } | null): obj is CustomPriceList => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomPriceList"')
      return CustomPriceList_possibleTypes.includes(obj.__typename)
    }
    


    const CustomPriceListResultPage_possibleTypes: string[] = ['CustomPriceListResultPage']
    export const isCustomPriceListResultPage = (obj?: { __typename?: any } | null): obj is CustomPriceListResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomPriceListResultPage"')
      return CustomPriceListResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CustomPriceListStatusCounts_possibleTypes: string[] = ['CustomPriceListStatusCounts']
    export const isCustomPriceListStatusCounts = (obj?: { __typename?: any } | null): obj is CustomPriceListStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomPriceListStatusCounts"')
      return CustomPriceListStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerInvitation_possibleTypes: string[] = ['CustomerInvitation']
    export const isCustomerInvitation = (obj?: { __typename?: any } | null): obj is CustomerInvitation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerInvitation"')
      return CustomerInvitation_possibleTypes.includes(obj.__typename)
    }
    


    const CustomerInvitationResultPage_possibleTypes: string[] = ['CustomerInvitationResultPage']
    export const isCustomerInvitationResultPage = (obj?: { __typename?: any } | null): obj is CustomerInvitationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCustomerInvitationResultPage"')
      return CustomerInvitationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CycleCountLine_possibleTypes: string[] = ['CycleCountLine']
    export const isCycleCountLine = (obj?: { __typename?: any } | null): obj is CycleCountLine => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCycleCountLine"')
      return CycleCountLine_possibleTypes.includes(obj.__typename)
    }
    


    const CycleCountLineResultPage_possibleTypes: string[] = ['CycleCountLineResultPage']
    export const isCycleCountLineResultPage = (obj?: { __typename?: any } | null): obj is CycleCountLineResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCycleCountLineResultPage"')
      return CycleCountLineResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CycleCountSchedule_possibleTypes: string[] = ['CycleCountSchedule']
    export const isCycleCountSchedule = (obj?: { __typename?: any } | null): obj is CycleCountSchedule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCycleCountSchedule"')
      return CycleCountSchedule_possibleTypes.includes(obj.__typename)
    }
    


    const CycleCountScheduleResultPage_possibleTypes: string[] = ['CycleCountScheduleResultPage']
    export const isCycleCountScheduleResultPage = (obj?: { __typename?: any } | null): obj is CycleCountScheduleResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCycleCountScheduleResultPage"')
      return CycleCountScheduleResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const CycleCountTask_possibleTypes: string[] = ['CycleCountTask']
    export const isCycleCountTask = (obj?: { __typename?: any } | null): obj is CycleCountTask => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCycleCountTask"')
      return CycleCountTask_possibleTypes.includes(obj.__typename)
    }
    


    const CycleCountTaskResultPage_possibleTypes: string[] = ['CycleCountTaskResultPage']
    export const isCycleCountTaskResultPage = (obj?: { __typename?: any } | null): obj is CycleCountTaskResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isCycleCountTaskResultPage"')
      return CycleCountTaskResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DeductionType_possibleTypes: string[] = ['DeductionType']
    export const isDeductionType = (obj?: { __typename?: any } | null): obj is DeductionType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeductionType"')
      return DeductionType_possibleTypes.includes(obj.__typename)
    }
    


    const DeductionTypeResultPage_possibleTypes: string[] = ['DeductionTypeResultPage']
    export const isDeductionTypeResultPage = (obj?: { __typename?: any } | null): obj is DeductionTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeductionTypeResultPage"')
      return DeductionTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DefaultPhotoRequirement_possibleTypes: string[] = ['DefaultPhotoRequirement']
    export const isDefaultPhotoRequirement = (obj?: { __typename?: any } | null): obj is DefaultPhotoRequirement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDefaultPhotoRequirement"')
      return DefaultPhotoRequirement_possibleTypes.includes(obj.__typename)
    }
    


    const DefaultPriceList_possibleTypes: string[] = ['DefaultPriceList']
    export const isDefaultPriceList = (obj?: { __typename?: any } | null): obj is DefaultPriceList => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDefaultPriceList"')
      return DefaultPriceList_possibleTypes.includes(obj.__typename)
    }
    


    const DefaultPriceListResultPage_possibleTypes: string[] = ['DefaultPriceListResultPage']
    export const isDefaultPriceListResultPage = (obj?: { __typename?: any } | null): obj is DefaultPriceListResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDefaultPriceListResultPage"')
      return DefaultPriceListResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DelayNode_possibleTypes: string[] = ['DelayNode']
    export const isDelayNode = (obj?: { __typename?: any } | null): obj is DelayNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDelayNode"')
      return DelayNode_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteFileError_possibleTypes: string[] = ['DeleteFileError']
    export const isDeleteFileError = (obj?: { __typename?: any } | null): obj is DeleteFileError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteFileError"')
      return DeleteFileError_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteFilePayload_possibleTypes: string[] = ['DeleteFilePayload']
    export const isDeleteFilePayload = (obj?: { __typename?: any } | null): obj is DeleteFilePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteFilePayload"')
      return DeleteFilePayload_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteFileResult_possibleTypes: string[] = ['DeleteFileError','DeleteFileSuccess']
    export const isDeleteFileResult = (obj?: { __typename?: any } | null): obj is DeleteFileResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteFileResult"')
      return DeleteFileResult_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteFileSuccess_possibleTypes: string[] = ['DeleteFileSuccess']
    export const isDeleteFileSuccess = (obj?: { __typename?: any } | null): obj is DeleteFileSuccess => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteFileSuccess"')
      return DeleteFileSuccess_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteFilesPayload_possibleTypes: string[] = ['DeleteFilesPayload']
    export const isDeleteFilesPayload = (obj?: { __typename?: any } | null): obj is DeleteFilesPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteFilesPayload"')
      return DeleteFilesPayload_possibleTypes.includes(obj.__typename)
    }
    


    const DeleteResult_possibleTypes: string[] = ['DeleteResult']
    export const isDeleteResult = (obj?: { __typename?: any } | null): obj is DeleteResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDeleteResult"')
      return DeleteResult_possibleTypes.includes(obj.__typename)
    }
    


    const Detention_possibleTypes: string[] = ['Detention']
    export const isDetention = (obj?: { __typename?: any } | null): obj is Detention => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDetention"')
      return Detention_possibleTypes.includes(obj.__typename)
    }
    


    const DetentionResultPage_possibleTypes: string[] = ['DetentionResultPage']
    export const isDetentionResultPage = (obj?: { __typename?: any } | null): obj is DetentionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDetentionResultPage"')
      return DetentionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DoNotBuyEntry_possibleTypes: string[] = ['DoNotBuyEntry']
    export const isDoNotBuyEntry = (obj?: { __typename?: any } | null): obj is DoNotBuyEntry => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDoNotBuyEntry"')
      return DoNotBuyEntry_possibleTypes.includes(obj.__typename)
    }
    


    const DoNotBuyEntryResultPage_possibleTypes: string[] = ['DoNotBuyEntryResultPage']
    export const isDoNotBuyEntryResultPage = (obj?: { __typename?: any } | null): obj is DoNotBuyEntryResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDoNotBuyEntryResultPage"')
      return DoNotBuyEntryResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DocumentGenerationResult_possibleTypes: string[] = ['DocumentGenerationResult']
    export const isDocumentGenerationResult = (obj?: { __typename?: any } | null): obj is DocumentGenerationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDocumentGenerationResult"')
      return DocumentGenerationResult_possibleTypes.includes(obj.__typename)
    }
    


    const Driver_possibleTypes: string[] = ['Driver']
    export const isDriver = (obj?: { __typename?: any } | null): obj is Driver => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDriver"')
      return Driver_possibleTypes.includes(obj.__typename)
    }
    


    const DriverCertification_possibleTypes: string[] = ['DriverCertification']
    export const isDriverCertification = (obj?: { __typename?: any } | null): obj is DriverCertification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDriverCertification"')
      return DriverCertification_possibleTypes.includes(obj.__typename)
    }
    


    const DriverCertificationResultPage_possibleTypes: string[] = ['DriverCertificationResultPage']
    export const isDriverCertificationResultPage = (obj?: { __typename?: any } | null): obj is DriverCertificationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDriverCertificationResultPage"')
      return DriverCertificationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DriverDisplayOrder_possibleTypes: string[] = ['DriverDisplayOrder']
    export const isDriverDisplayOrder = (obj?: { __typename?: any } | null): obj is DriverDisplayOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDriverDisplayOrder"')
      return DriverDisplayOrder_possibleTypes.includes(obj.__typename)
    }
    


    const DriverDisplayOrderResultPage_possibleTypes: string[] = ['DriverDisplayOrderResultPage']
    export const isDriverDisplayOrderResultPage = (obj?: { __typename?: any } | null): obj is DriverDisplayOrderResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDriverDisplayOrderResultPage"')
      return DriverDisplayOrderResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const DriverResultPage_possibleTypes: string[] = ['DriverResultPage']
    export const isDriverResultPage = (obj?: { __typename?: any } | null): obj is DriverResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isDriverResultPage"')
      return DriverResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Edge_possibleTypes: string[] = ['Edge']
    export const isEdge = (obj?: { __typename?: any } | null): obj is Edge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEdge"')
      return Edge_possibleTypes.includes(obj.__typename)
    }
    


    const EmailActionNode_possibleTypes: string[] = ['EmailActionNode']
    export const isEmailActionNode = (obj?: { __typename?: any } | null): obj is EmailActionNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEmailActionNode"')
      return EmailActionNode_possibleTypes.includes(obj.__typename)
    }
    


    const EmailSendingResult_possibleTypes: string[] = ['EmailSendingResult']
    export const isEmailSendingResult = (obj?: { __typename?: any } | null): obj is EmailSendingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEmailSendingResult"')
      return EmailSendingResult_possibleTypes.includes(obj.__typename)
    }
    


    const EmailVerificationRequiredError_possibleTypes: string[] = ['EmailVerificationRequiredError']
    export const isEmailVerificationRequiredError = (obj?: { __typename?: any } | null): obj is EmailVerificationRequiredError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEmailVerificationRequiredError"')
      return EmailVerificationRequiredError_possibleTypes.includes(obj.__typename)
    }
    


    const EvaluatedFormula_possibleTypes: string[] = ['EvaluatedFormula']
    export const isEvaluatedFormula = (obj?: { __typename?: any } | null): obj is EvaluatedFormula => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEvaluatedFormula"')
      return EvaluatedFormula_possibleTypes.includes(obj.__typename)
    }
    


    const EvaluatedItemPricing_possibleTypes: string[] = ['EvaluatedItemPricing']
    export const isEvaluatedItemPricing = (obj?: { __typename?: any } | null): obj is EvaluatedItemPricing => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEvaluatedItemPricing"')
      return EvaluatedItemPricing_possibleTypes.includes(obj.__typename)
    }
    


    const EvaluatedTier_possibleTypes: string[] = ['EvaluatedTier']
    export const isEvaluatedTier = (obj?: { __typename?: any } | null): obj is EvaluatedTier => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isEvaluatedTier"')
      return EvaluatedTier_possibleTypes.includes(obj.__typename)
    }
    


    const ExecutionRun_possibleTypes: string[] = ['ExecutionRun']
    export const isExecutionRun = (obj?: { __typename?: any } | null): obj is ExecutionRun => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExecutionRun"')
      return ExecutionRun_possibleTypes.includes(obj.__typename)
    }
    


    const ExecutionRunResultPage_possibleTypes: string[] = ['ExecutionRunResultPage']
    export const isExecutionRunResultPage = (obj?: { __typename?: any } | null): obj is ExecutionRunResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isExecutionRunResultPage"')
      return ExecutionRunResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Facility_possibleTypes: string[] = ['Facility']
    export const isFacility = (obj?: { __typename?: any } | null): obj is Facility => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacility"')
      return Facility_possibleTypes.includes(obj.__typename)
    }
    


    const FacilityAtm_possibleTypes: string[] = ['FacilityAtm']
    export const isFacilityAtm = (obj?: { __typename?: any } | null): obj is FacilityAtm => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilityAtm"')
      return FacilityAtm_possibleTypes.includes(obj.__typename)
    }
    


    const FacilityAtmResultPage_possibleTypes: string[] = ['FacilityAtmResultPage']
    export const isFacilityAtmResultPage = (obj?: { __typename?: any } | null): obj is FacilityAtmResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilityAtmResultPage"')
      return FacilityAtmResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FacilityGeneralPreferences_possibleTypes: string[] = ['FacilityGeneralPreferences']
    export const isFacilityGeneralPreferences = (obj?: { __typename?: any } | null): obj is FacilityGeneralPreferences => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilityGeneralPreferences"')
      return FacilityGeneralPreferences_possibleTypes.includes(obj.__typename)
    }
    


    const FacilityGroup_possibleTypes: string[] = ['FacilityGroup']
    export const isFacilityGroup = (obj?: { __typename?: any } | null): obj is FacilityGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilityGroup"')
      return FacilityGroup_possibleTypes.includes(obj.__typename)
    }
    


    const FacilityGroupResultPage_possibleTypes: string[] = ['FacilityGroupResultPage']
    export const isFacilityGroupResultPage = (obj?: { __typename?: any } | null): obj is FacilityGroupResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilityGroupResultPage"')
      return FacilityGroupResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FacilityResultPage_possibleTypes: string[] = ['FacilityResultPage']
    export const isFacilityResultPage = (obj?: { __typename?: any } | null): obj is FacilityResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilityResultPage"')
      return FacilityResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FacilitySalesPreferences_possibleTypes: string[] = ['FacilitySalesPreferences']
    export const isFacilitySalesPreferences = (obj?: { __typename?: any } | null): obj is FacilitySalesPreferences => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFacilitySalesPreferences"')
      return FacilitySalesPreferences_possibleTypes.includes(obj.__typename)
    }
    


    const FieldConstraints_possibleTypes: string[] = ['FieldConstraints']
    export const isFieldConstraints = (obj?: { __typename?: any } | null): obj is FieldConstraints => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFieldConstraints"')
      return FieldConstraints_possibleTypes.includes(obj.__typename)
    }
    


    const File_possibleTypes: string[] = ['File']
    export const isFile = (obj?: { __typename?: any } | null): obj is File => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFile"')
      return File_possibleTypes.includes(obj.__typename)
    }
    


    const FileAccessURLResult_possibleTypes: string[] = ['FileAccessURLResult']
    export const isFileAccessURLResult = (obj?: { __typename?: any } | null): obj is FileAccessURLResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileAccessURLResult"')
      return FileAccessURLResult_possibleTypes.includes(obj.__typename)
    }
    


    const FileChangedEvent_possibleTypes: string[] = ['FileChangedEvent']
    export const isFileChangedEvent = (obj?: { __typename?: any } | null): obj is FileChangedEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileChangedEvent"')
      return FileChangedEvent_possibleTypes.includes(obj.__typename)
    }
    


    const FileConnection_possibleTypes: string[] = ['FileConnection']
    export const isFileConnection = (obj?: { __typename?: any } | null): obj is FileConnection => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileConnection"')
      return FileConnection_possibleTypes.includes(obj.__typename)
    }
    


    const FileEdge_possibleTypes: string[] = ['FileEdge']
    export const isFileEdge = (obj?: { __typename?: any } | null): obj is FileEdge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileEdge"')
      return FileEdge_possibleTypes.includes(obj.__typename)
    }
    


    const FileError_possibleTypes: string[] = ['FileError']
    export const isFileError = (obj?: { __typename?: any } | null): obj is FileError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileError"')
      return FileError_possibleTypes.includes(obj.__typename)
    }
    


    const FileTemplate_possibleTypes: string[] = ['FileTemplate']
    export const isFileTemplate = (obj?: { __typename?: any } | null): obj is FileTemplate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileTemplate"')
      return FileTemplate_possibleTypes.includes(obj.__typename)
    }
    


    const FileTemplateResultPage_possibleTypes: string[] = ['FileTemplateResultPage']
    export const isFileTemplateResultPage = (obj?: { __typename?: any } | null): obj is FileTemplateResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFileTemplateResultPage"')
      return FileTemplateResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FilesOutboxEventCounts_possibleTypes: string[] = ['FilesOutboxEventCounts']
    export const isFilesOutboxEventCounts = (obj?: { __typename?: any } | null): obj is FilesOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFilesOutboxEventCounts"')
      return FilesOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const FilterNode_possibleTypes: string[] = ['FilterNode']
    export const isFilterNode = (obj?: { __typename?: any } | null): obj is FilterNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFilterNode"')
      return FilterNode_possibleTypes.includes(obj.__typename)
    }
    


    const FinanceOutboxEventCounts_possibleTypes: string[] = ['FinanceOutboxEventCounts']
    export const isFinanceOutboxEventCounts = (obj?: { __typename?: any } | null): obj is FinanceOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinanceOutboxEventCounts"')
      return FinanceOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccount_possibleTypes: string[] = ['FinancialAccount']
    export const isFinancialAccount = (obj?: { __typename?: any } | null): obj is FinancialAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccount"')
      return FinancialAccount_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccountAdjustment_possibleTypes: string[] = ['FinancialAccountAdjustment']
    export const isFinancialAccountAdjustment = (obj?: { __typename?: any } | null): obj is FinancialAccountAdjustment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccountAdjustment"')
      return FinancialAccountAdjustment_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccountAdjustmentResultPage_possibleTypes: string[] = ['FinancialAccountAdjustmentResultPage']
    export const isFinancialAccountAdjustmentResultPage = (obj?: { __typename?: any } | null): obj is FinancialAccountAdjustmentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccountAdjustmentResultPage"')
      return FinancialAccountAdjustmentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccountResultPage_possibleTypes: string[] = ['FinancialAccountResultPage']
    export const isFinancialAccountResultPage = (obj?: { __typename?: any } | null): obj is FinancialAccountResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccountResultPage"')
      return FinancialAccountResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccountTransaction_possibleTypes: string[] = ['FinancialAccountTransaction']
    export const isFinancialAccountTransaction = (obj?: { __typename?: any } | null): obj is FinancialAccountTransaction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccountTransaction"')
      return FinancialAccountTransaction_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccountTransactionCounterparty_possibleTypes: string[] = ['FinancialAccountTransactionCounterparty']
    export const isFinancialAccountTransactionCounterparty = (obj?: { __typename?: any } | null): obj is FinancialAccountTransactionCounterparty => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccountTransactionCounterparty"')
      return FinancialAccountTransactionCounterparty_possibleTypes.includes(obj.__typename)
    }
    


    const FinancialAccountTransactionResultPage_possibleTypes: string[] = ['FinancialAccountTransactionResultPage']
    export const isFinancialAccountTransactionResultPage = (obj?: { __typename?: any } | null): obj is FinancialAccountTransactionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFinancialAccountTransactionResultPage"')
      return FinancialAccountTransactionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FlowValidationResult_possibleTypes: string[] = ['FlowValidationResult']
    export const isFlowValidationResult = (obj?: { __typename?: any } | null): obj is FlowValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFlowValidationResult"')
      return FlowValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const FreightCharge_possibleTypes: string[] = ['FreightCharge']
    export const isFreightCharge = (obj?: { __typename?: any } | null): obj is FreightCharge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightCharge"')
      return FreightCharge_possibleTypes.includes(obj.__typename)
    }
    


    const FreightForwarder_possibleTypes: string[] = ['FreightForwarder']
    export const isFreightForwarder = (obj?: { __typename?: any } | null): obj is FreightForwarder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightForwarder"')
      return FreightForwarder_possibleTypes.includes(obj.__typename)
    }
    


    const FreightForwarderResultPage_possibleTypes: string[] = ['FreightForwarderResultPage']
    export const isFreightForwarderResultPage = (obj?: { __typename?: any } | null): obj is FreightForwarderResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightForwarderResultPage"')
      return FreightForwarderResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLane_possibleTypes: string[] = ['FreightLane']
    export const isFreightLane = (obj?: { __typename?: any } | null): obj is FreightLane => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLane"')
      return FreightLane_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLaneCost_possibleTypes: string[] = ['FreightLaneCost']
    export const isFreightLaneCost = (obj?: { __typename?: any } | null): obj is FreightLaneCost => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLaneCost"')
      return FreightLaneCost_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLaneCostResultPage_possibleTypes: string[] = ['FreightLaneCostResultPage']
    export const isFreightLaneCostResultPage = (obj?: { __typename?: any } | null): obj is FreightLaneCostResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLaneCostResultPage"')
      return FreightLaneCostResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLaneResultPage_possibleTypes: string[] = ['FreightLaneResultPage']
    export const isFreightLaneResultPage = (obj?: { __typename?: any } | null): obj is FreightLaneResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLaneResultPage"')
      return FreightLaneResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLaneRoute_possibleTypes: string[] = ['FreightLaneRoute']
    export const isFreightLaneRoute = (obj?: { __typename?: any } | null): obj is FreightLaneRoute => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLaneRoute"')
      return FreightLaneRoute_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLaneRouteResultPage_possibleTypes: string[] = ['FreightLaneRouteResultPage']
    export const isFreightLaneRouteResultPage = (obj?: { __typename?: any } | null): obj is FreightLaneRouteResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLaneRouteResultPage"')
      return FreightLaneRouteResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLine_possibleTypes: string[] = ['FreightLine']
    export const isFreightLine = (obj?: { __typename?: any } | null): obj is FreightLine => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLine"')
      return FreightLine_possibleTypes.includes(obj.__typename)
    }
    


    const FreightLineResultPage_possibleTypes: string[] = ['FreightLineResultPage']
    export const isFreightLineResultPage = (obj?: { __typename?: any } | null): obj is FreightLineResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isFreightLineResultPage"')
      return FreightLineResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateCheckPdfPayload_possibleTypes: string[] = ['GenerateCheckPdfPayload']
    export const isGenerateCheckPdfPayload = (obj?: { __typename?: any } | null): obj is GenerateCheckPdfPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateCheckPdfPayload"')
      return GenerateCheckPdfPayload_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateDocumentResult_possibleTypes: string[] = ['GenerateDocumentResult']
    export const isGenerateDocumentResult = (obj?: { __typename?: any } | null): obj is GenerateDocumentResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateDocumentResult"')
      return GenerateDocumentResult_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateDocumentsAndSendEmailResult_possibleTypes: string[] = ['GenerateDocumentsAndSendEmailResult']
    export const isGenerateDocumentsAndSendEmailResult = (obj?: { __typename?: any } | null): obj is GenerateDocumentsAndSendEmailResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateDocumentsAndSendEmailResult"')
      return GenerateDocumentsAndSendEmailResult_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateFileAccessURLPayload_possibleTypes: string[] = ['GenerateFileAccessURLPayload']
    export const isGenerateFileAccessURLPayload = (obj?: { __typename?: any } | null): obj is GenerateFileAccessURLPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateFileAccessURLPayload"')
      return GenerateFileAccessURLPayload_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateNachaFilePayload_possibleTypes: string[] = ['GenerateNachaFilePayload']
    export const isGenerateNachaFilePayload = (obj?: { __typename?: any } | null): obj is GenerateNachaFilePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateNachaFilePayload"')
      return GenerateNachaFilePayload_possibleTypes.includes(obj.__typename)
    }
    


    const GeneratePriceListDocumentResult_possibleTypes: string[] = ['GeneratePriceListDocumentResult']
    export const isGeneratePriceListDocumentResult = (obj?: { __typename?: any } | null): obj is GeneratePriceListDocumentResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGeneratePriceListDocumentResult"')
      return GeneratePriceListDocumentResult_possibleTypes.includes(obj.__typename)
    }
    


    const GenerateWOPITokenPayload_possibleTypes: string[] = ['GenerateWOPITokenPayload']
    export const isGenerateWOPITokenPayload = (obj?: { __typename?: any } | null): obj is GenerateWOPITokenPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGenerateWOPITokenPayload"')
      return GenerateWOPITokenPayload_possibleTypes.includes(obj.__typename)
    }
    


    const GovernmentReportingConfiguration_possibleTypes: string[] = ['GovernmentReportingConfiguration']
    export const isGovernmentReportingConfiguration = (obj?: { __typename?: any } | null): obj is GovernmentReportingConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGovernmentReportingConfiguration"')
      return GovernmentReportingConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const GovernmentReportingConfigurationResultPage_possibleTypes: string[] = ['GovernmentReportingConfigurationResultPage']
    export const isGovernmentReportingConfigurationResultPage = (obj?: { __typename?: any } | null): obj is GovernmentReportingConfigurationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGovernmentReportingConfigurationResultPage"')
      return GovernmentReportingConfigurationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const GovernmentReportingFacility_possibleTypes: string[] = ['GovernmentReportingFacility']
    export const isGovernmentReportingFacility = (obj?: { __typename?: any } | null): obj is GovernmentReportingFacility => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGovernmentReportingFacility"')
      return GovernmentReportingFacility_possibleTypes.includes(obj.__typename)
    }
    


    const GovernmentReportingFacilityResultPage_possibleTypes: string[] = ['GovernmentReportingFacilityResultPage']
    export const isGovernmentReportingFacilityResultPage = (obj?: { __typename?: any } | null): obj is GovernmentReportingFacilityResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isGovernmentReportingFacilityResultPage"')
      return GovernmentReportingFacilityResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const HttpRequestActionNode_possibleTypes: string[] = ['HttpRequestActionNode']
    export const isHttpRequestActionNode = (obj?: { __typename?: any } | null): obj is HttpRequestActionNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHttpRequestActionNode"')
      return HttpRequestActionNode_possibleTypes.includes(obj.__typename)
    }
    


    const HttpWebhookTriggerConfigOutput_possibleTypes: string[] = ['HttpWebhookTriggerConfigOutput']
    export const isHttpWebhookTriggerConfigOutput = (obj?: { __typename?: any } | null): obj is HttpWebhookTriggerConfigOutput => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHttpWebhookTriggerConfigOutput"')
      return HttpWebhookTriggerConfigOutput_possibleTypes.includes(obj.__typename)
    }
    


    const HttpWebhookTriggerNode_possibleTypes: string[] = ['HttpWebhookTriggerNode']
    export const isHttpWebhookTriggerNode = (obj?: { __typename?: any } | null): obj is HttpWebhookTriggerNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isHttpWebhookTriggerNode"')
      return HttpWebhookTriggerNode_possibleTypes.includes(obj.__typename)
    }
    


    const InboundTollingAgreement_possibleTypes: string[] = ['InboundTollingAgreement']
    export const isInboundTollingAgreement = (obj?: { __typename?: any } | null): obj is InboundTollingAgreement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInboundTollingAgreement"')
      return InboundTollingAgreement_possibleTypes.includes(obj.__typename)
    }
    


    const InboundTollingAgreementResultPage_possibleTypes: string[] = ['InboundTollingAgreementResultPage']
    export const isInboundTollingAgreementResultPage = (obj?: { __typename?: any } | null): obj is InboundTollingAgreementResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInboundTollingAgreementResultPage"')
      return InboundTollingAgreementResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Integration_possibleTypes: string[] = ['Integration']
    export const isIntegration = (obj?: { __typename?: any } | null): obj is Integration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isIntegration"')
      return Integration_possibleTypes.includes(obj.__typename)
    }
    


    const InvalidCredentialsError_possibleTypes: string[] = ['InvalidCredentialsError']
    export const isInvalidCredentialsError = (obj?: { __typename?: any } | null): obj is InvalidCredentialsError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvalidCredentialsError"')
      return InvalidCredentialsError_possibleTypes.includes(obj.__typename)
    }
    


    const InvalidOneTimeCode_possibleTypes: string[] = ['InvalidOneTimeCode']
    export const isInvalidOneTimeCode = (obj?: { __typename?: any } | null): obj is InvalidOneTimeCode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvalidOneTimeCode"')
      return InvalidOneTimeCode_possibleTypes.includes(obj.__typename)
    }
    


    const InvalidSignUpInvitationError_possibleTypes: string[] = ['InvalidSignUpInvitationError']
    export const isInvalidSignUpInvitationError = (obj?: { __typename?: any } | null): obj is InvalidSignUpInvitationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvalidSignUpInvitationError"')
      return InvalidSignUpInvitationError_possibleTypes.includes(obj.__typename)
    }
    


    const InvalidUserInvitationError_possibleTypes: string[] = ['InvalidUserInvitationError']
    export const isInvalidUserInvitationError = (obj?: { __typename?: any } | null): obj is InvalidUserInvitationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvalidUserInvitationError"')
      return InvalidUserInvitationError_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryAccount_possibleTypes: string[] = ['InventoryAccount']
    export const isInventoryAccount = (obj?: { __typename?: any } | null): obj is InventoryAccount => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryAccount"')
      return InventoryAccount_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryAccountResultPage_possibleTypes: string[] = ['InventoryAccountResultPage']
    export const isInventoryAccountResultPage = (obj?: { __typename?: any } | null): obj is InventoryAccountResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryAccountResultPage"')
      return InventoryAccountResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryFacilitySettings_possibleTypes: string[] = ['InventoryFacilitySettings']
    export const isInventoryFacilitySettings = (obj?: { __typename?: any } | null): obj is InventoryFacilitySettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryFacilitySettings"')
      return InventoryFacilitySettings_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryFacilitySettingsResultPage_possibleTypes: string[] = ['InventoryFacilitySettingsResultPage']
    export const isInventoryFacilitySettingsResultPage = (obj?: { __typename?: any } | null): obj is InventoryFacilitySettingsResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryFacilitySettingsResultPage"')
      return InventoryFacilitySettingsResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLevel_possibleTypes: string[] = ['InventoryLevel']
    export const isInventoryLevel = (obj?: { __typename?: any } | null): obj is InventoryLevel => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLevel"')
      return InventoryLevel_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLevelCurrencyValue_possibleTypes: string[] = ['InventoryLevelCurrencyValue']
    export const isInventoryLevelCurrencyValue = (obj?: { __typename?: any } | null): obj is InventoryLevelCurrencyValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLevelCurrencyValue"')
      return InventoryLevelCurrencyValue_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLevelResultPage_possibleTypes: string[] = ['InventoryLevelResultPage']
    export const isInventoryLevelResultPage = (obj?: { __typename?: any } | null): obj is InventoryLevelResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLevelResultPage"')
      return InventoryLevelResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLevelStats_possibleTypes: string[] = ['InventoryLevelStats']
    export const isInventoryLevelStats = (obj?: { __typename?: any } | null): obj is InventoryLevelStats => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLevelStats"')
      return InventoryLevelStats_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLot_possibleTypes: string[] = ['InventoryLot']
    export const isInventoryLot = (obj?: { __typename?: any } | null): obj is InventoryLot => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLot"')
      return InventoryLot_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLotAllocateResult_possibleTypes: string[] = ['InventoryLotAllocateResult']
    export const isInventoryLotAllocateResult = (obj?: { __typename?: any } | null): obj is InventoryLotAllocateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLotAllocateResult"')
      return InventoryLotAllocateResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLotCreateFromMovementsResult_possibleTypes: string[] = ['InventoryLotCreateFromMovementsResult']
    export const isInventoryLotCreateFromMovementsResult = (obj?: { __typename?: any } | null): obj is InventoryLotCreateFromMovementsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLotCreateFromMovementsResult"')
      return InventoryLotCreateFromMovementsResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLotMergeResult_possibleTypes: string[] = ['InventoryLotMergeResult']
    export const isInventoryLotMergeResult = (obj?: { __typename?: any } | null): obj is InventoryLotMergeResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLotMergeResult"')
      return InventoryLotMergeResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLotResultPage_possibleTypes: string[] = ['InventoryLotResultPage']
    export const isInventoryLotResultPage = (obj?: { __typename?: any } | null): obj is InventoryLotResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLotResultPage"')
      return InventoryLotResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryLotSplitResult_possibleTypes: string[] = ['InventoryLotSplitResult']
    export const isInventoryLotSplitResult = (obj?: { __typename?: any } | null): obj is InventoryLotSplitResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryLotSplitResult"')
      return InventoryLotSplitResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryMovement_possibleTypes: string[] = ['InventoryMovement']
    export const isInventoryMovement = (obj?: { __typename?: any } | null): obj is InventoryMovement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryMovement"')
      return InventoryMovement_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryMovementHistoryResultPage_possibleTypes: string[] = ['InventoryMovementHistoryResultPage']
    export const isInventoryMovementHistoryResultPage = (obj?: { __typename?: any } | null): obj is InventoryMovementHistoryResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryMovementHistoryResultPage"')
      return InventoryMovementHistoryResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryMovementResultPage_possibleTypes: string[] = ['InventoryMovementResultPage']
    export const isInventoryMovementResultPage = (obj?: { __typename?: any } | null): obj is InventoryMovementResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryMovementResultPage"')
      return InventoryMovementResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryMovementWithHistory_possibleTypes: string[] = ['InventoryMovementWithHistory']
    export const isInventoryMovementWithHistory = (obj?: { __typename?: any } | null): obj is InventoryMovementWithHistory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryMovementWithHistory"')
      return InventoryMovementWithHistory_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryOutboxEventCounts_possibleTypes: string[] = ['InventoryOutboxEventCounts']
    export const isInventoryOutboxEventCounts = (obj?: { __typename?: any } | null): obj is InventoryOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryOutboxEventCounts"')
      return InventoryOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPeriod_possibleTypes: string[] = ['InventoryPeriod']
    export const isInventoryPeriod = (obj?: { __typename?: any } | null): obj is InventoryPeriod => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPeriod"')
      return InventoryPeriod_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPeriodBalance_possibleTypes: string[] = ['InventoryPeriodBalance']
    export const isInventoryPeriodBalance = (obj?: { __typename?: any } | null): obj is InventoryPeriodBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPeriodBalance"')
      return InventoryPeriodBalance_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPeriodBalanceResultPage_possibleTypes: string[] = ['InventoryPeriodBalanceResultPage']
    export const isInventoryPeriodBalanceResultPage = (obj?: { __typename?: any } | null): obj is InventoryPeriodBalanceResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPeriodBalanceResultPage"')
      return InventoryPeriodBalanceResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPeriodConfig_possibleTypes: string[] = ['InventoryPeriodConfig']
    export const isInventoryPeriodConfig = (obj?: { __typename?: any } | null): obj is InventoryPeriodConfig => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPeriodConfig"')
      return InventoryPeriodConfig_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPeriodConfigResultPage_possibleTypes: string[] = ['InventoryPeriodConfigResultPage']
    export const isInventoryPeriodConfigResultPage = (obj?: { __typename?: any } | null): obj is InventoryPeriodConfigResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPeriodConfigResultPage"')
      return InventoryPeriodConfigResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryPeriodResultPage_possibleTypes: string[] = ['InventoryPeriodResultPage']
    export const isInventoryPeriodResultPage = (obj?: { __typename?: any } | null): obj is InventoryPeriodResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryPeriodResultPage"')
      return InventoryPeriodResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryTag_possibleTypes: string[] = ['InventoryTag']
    export const isInventoryTag = (obj?: { __typename?: any } | null): obj is InventoryTag => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryTag"')
      return InventoryTag_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryTagAllocateResult_possibleTypes: string[] = ['InventoryTagAllocateResult']
    export const isInventoryTagAllocateResult = (obj?: { __typename?: any } | null): obj is InventoryTagAllocateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryTagAllocateResult"')
      return InventoryTagAllocateResult_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryTagResultPage_possibleTypes: string[] = ['InventoryTagResultPage']
    export const isInventoryTagResultPage = (obj?: { __typename?: any } | null): obj is InventoryTagResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryTagResultPage"')
      return InventoryTagResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryZone_possibleTypes: string[] = ['InventoryZone']
    export const isInventoryZone = (obj?: { __typename?: any } | null): obj is InventoryZone => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryZone"')
      return InventoryZone_possibleTypes.includes(obj.__typename)
    }
    


    const InventoryZoneResultPage_possibleTypes: string[] = ['InventoryZoneResultPage']
    export const isInventoryZoneResultPage = (obj?: { __typename?: any } | null): obj is InventoryZoneResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInventoryZoneResultPage"')
      return InventoryZoneResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Invoice_possibleTypes: string[] = ['Invoice']
    export const isInvoice = (obj?: { __typename?: any } | null): obj is Invoice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoice"')
      return Invoice_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceEntityReference_possibleTypes: string[] = ['InvoiceEntityReference']
    export const isInvoiceEntityReference = (obj?: { __typename?: any } | null): obj is InvoiceEntityReference => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceEntityReference"')
      return InvoiceEntityReference_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceLineItem_possibleTypes: string[] = ['InvoiceLineItem']
    export const isInvoiceLineItem = (obj?: { __typename?: any } | null): obj is InvoiceLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceLineItem"')
      return InvoiceLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const InvoicePaymentApplication_possibleTypes: string[] = ['InvoicePaymentApplication']
    export const isInvoicePaymentApplication = (obj?: { __typename?: any } | null): obj is InvoicePaymentApplication => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoicePaymentApplication"')
      return InvoicePaymentApplication_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceResultPage_possibleTypes: string[] = ['InvoiceResultPage']
    export const isInvoiceResultPage = (obj?: { __typename?: any } | null): obj is InvoiceResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceResultPage"')
      return InvoiceResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const InvoiceStatusCounts_possibleTypes: string[] = ['InvoiceStatusCounts']
    export const isInvoiceStatusCounts = (obj?: { __typename?: any } | null): obj is InvoiceStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isInvoiceStatusCounts"')
      return InvoiceStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const Item_possibleTypes: string[] = ['Item']
    export const isItem = (obj?: { __typename?: any } | null): obj is Item => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItem"')
      return Item_possibleTypes.includes(obj.__typename)
    }
    


    const ItemAlias_possibleTypes: string[] = ['ItemAlias']
    export const isItemAlias = (obj?: { __typename?: any } | null): obj is ItemAlias => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemAlias"')
      return ItemAlias_possibleTypes.includes(obj.__typename)
    }
    


    const ItemAliasResultPage_possibleTypes: string[] = ['ItemAliasResultPage']
    export const isItemAliasResultPage = (obj?: { __typename?: any } | null): obj is ItemAliasResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemAliasResultPage"')
      return ItemAliasResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ItemGroup_possibleTypes: string[] = ['ItemGroup']
    export const isItemGroup = (obj?: { __typename?: any } | null): obj is ItemGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemGroup"')
      return ItemGroup_possibleTypes.includes(obj.__typename)
    }
    


    const ItemGroupResultPage_possibleTypes: string[] = ['ItemGroupResultPage']
    export const isItemGroupResultPage = (obj?: { __typename?: any } | null): obj is ItemGroupResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemGroupResultPage"')
      return ItemGroupResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ItemMarginResult_possibleTypes: string[] = ['ItemMarginResult']
    export const isItemMarginResult = (obj?: { __typename?: any } | null): obj is ItemMarginResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemMarginResult"')
      return ItemMarginResult_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPosition_possibleTypes: string[] = ['ItemPosition']
    export const isItemPosition = (obj?: { __typename?: any } | null): obj is ItemPosition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPosition"')
      return ItemPosition_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPositionResultPage_possibleTypes: string[] = ['ItemPositionResultPage']
    export const isItemPositionResultPage = (obj?: { __typename?: any } | null): obj is ItemPositionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPositionResultPage"')
      return ItemPositionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPrice_possibleTypes: string[] = ['ItemPrice']
    export const isItemPrice = (obj?: { __typename?: any } | null): obj is ItemPrice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPrice"')
      return ItemPrice_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPriceConfiguration_possibleTypes: string[] = ['ItemPriceConfiguration']
    export const isItemPriceConfiguration = (obj?: { __typename?: any } | null): obj is ItemPriceConfiguration => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPriceConfiguration"')
      return ItemPriceConfiguration_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPriceConfigurationResultPage_possibleTypes: string[] = ['ItemPriceConfigurationResultPage']
    export const isItemPriceConfigurationResultPage = (obj?: { __typename?: any } | null): obj is ItemPriceConfigurationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPriceConfigurationResultPage"')
      return ItemPriceConfigurationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPricing_possibleTypes: string[] = ['ItemPricing']
    export const isItemPricing = (obj?: { __typename?: any } | null): obj is ItemPricing => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPricing"')
      return ItemPricing_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPricingDirtyAwareResult_possibleTypes: string[] = ['ItemPricingDirtyAwareResult']
    export const isItemPricingDirtyAwareResult = (obj?: { __typename?: any } | null): obj is ItemPricingDirtyAwareResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPricingDirtyAwareResult"')
      return ItemPricingDirtyAwareResult_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPricingResultPage_possibleTypes: string[] = ['ItemPricingResultPage']
    export const isItemPricingResultPage = (obj?: { __typename?: any } | null): obj is ItemPricingResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPricingResultPage"')
      return ItemPricingResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPricingTier_possibleTypes: string[] = ['ItemPricingTier']
    export const isItemPricingTier = (obj?: { __typename?: any } | null): obj is ItemPricingTier => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPricingTier"')
      return ItemPricingTier_possibleTypes.includes(obj.__typename)
    }
    


    const ItemPricingTierResultPage_possibleTypes: string[] = ['ItemPricingTierResultPage']
    export const isItemPricingTierResultPage = (obj?: { __typename?: any } | null): obj is ItemPricingTierResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemPricingTierResultPage"')
      return ItemPricingTierResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ItemResultPage_possibleTypes: string[] = ['ItemResultPage']
    export const isItemResultPage = (obj?: { __typename?: any } | null): obj is ItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isItemResultPage"')
      return ItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Load_possibleTypes: string[] = ['Load']
    export const isLoad = (obj?: { __typename?: any } | null): obj is Load => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoad"')
      return Load_possibleTypes.includes(obj.__typename)
    }
    


    const LoadBoard_possibleTypes: string[] = ['LoadBoard']
    export const isLoadBoard = (obj?: { __typename?: any } | null): obj is LoadBoard => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadBoard"')
      return LoadBoard_possibleTypes.includes(obj.__typename)
    }
    


    const LoadCustomerFileCreatePayload_possibleTypes: string[] = ['LoadCustomerFileCreatePayload']
    export const isLoadCustomerFileCreatePayload = (obj?: { __typename?: any } | null): obj is LoadCustomerFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadCustomerFileCreatePayload"')
      return LoadCustomerFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const LoadDeduction_possibleTypes: string[] = ['LoadDeduction']
    export const isLoadDeduction = (obj?: { __typename?: any } | null): obj is LoadDeduction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadDeduction"')
      return LoadDeduction_possibleTypes.includes(obj.__typename)
    }
    


    const LoadDeductionResultPage_possibleTypes: string[] = ['LoadDeductionResultPage']
    export const isLoadDeductionResultPage = (obj?: { __typename?: any } | null): obj is LoadDeductionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadDeductionResultPage"')
      return LoadDeductionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const LoadLineItem_possibleTypes: string[] = ['LoadLineItem']
    export const isLoadLineItem = (obj?: { __typename?: any } | null): obj is LoadLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadLineItem"')
      return LoadLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const LoadPhotoCreatePayload_possibleTypes: string[] = ['LoadPhotoCreatePayload']
    export const isLoadPhotoCreatePayload = (obj?: { __typename?: any } | null): obj is LoadPhotoCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadPhotoCreatePayload"')
      return LoadPhotoCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const LoadReconciliation_possibleTypes: string[] = ['LoadReconciliation']
    export const isLoadReconciliation = (obj?: { __typename?: any } | null): obj is LoadReconciliation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadReconciliation"')
      return LoadReconciliation_possibleTypes.includes(obj.__typename)
    }
    


    const LoadReconciliationFileCreatePayload_possibleTypes: string[] = ['LoadReconciliationFileCreatePayload']
    export const isLoadReconciliationFileCreatePayload = (obj?: { __typename?: any } | null): obj is LoadReconciliationFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadReconciliationFileCreatePayload"')
      return LoadReconciliationFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const LoadReconciliationSummary_possibleTypes: string[] = ['LoadReconciliationSummary']
    export const isLoadReconciliationSummary = (obj?: { __typename?: any } | null): obj is LoadReconciliationSummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadReconciliationSummary"')
      return LoadReconciliationSummary_possibleTypes.includes(obj.__typename)
    }
    


    const LoadReconciliationSummaryResultPage_possibleTypes: string[] = ['LoadReconciliationSummaryResultPage']
    export const isLoadReconciliationSummaryResultPage = (obj?: { __typename?: any } | null): obj is LoadReconciliationSummaryResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadReconciliationSummaryResultPage"')
      return LoadReconciliationSummaryResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const LoadRecyclerFileCreatePayload_possibleTypes: string[] = ['LoadRecyclerFileCreatePayload']
    export const isLoadRecyclerFileCreatePayload = (obj?: { __typename?: any } | null): obj is LoadRecyclerFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadRecyclerFileCreatePayload"')
      return LoadRecyclerFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const LoadResultPage_possibleTypes: string[] = ['LoadResultPage']
    export const isLoadResultPage = (obj?: { __typename?: any } | null): obj is LoadResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadResultPage"')
      return LoadResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const LoadStatusCounts_possibleTypes: string[] = ['LoadStatusCounts']
    export const isLoadStatusCounts = (obj?: { __typename?: any } | null): obj is LoadStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadStatusCounts"')
      return LoadStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const LoadUpdateResult_possibleTypes: string[] = ['LoadUpdateResult']
    export const isLoadUpdateResult = (obj?: { __typename?: any } | null): obj is LoadUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoadUpdateResult"')
      return LoadUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const Location_possibleTypes: string[] = ['Location']
    export const isLocation = (obj?: { __typename?: any } | null): obj is Location => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLocation"')
      return Location_possibleTypes.includes(obj.__typename)
    }
    


    const LocationFreightPricing_possibleTypes: string[] = ['LocationFreightPricing']
    export const isLocationFreightPricing = (obj?: { __typename?: any } | null): obj is LocationFreightPricing => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLocationFreightPricing"')
      return LocationFreightPricing_possibleTypes.includes(obj.__typename)
    }
    


    const LocationFreightPricingResultPage_possibleTypes: string[] = ['LocationFreightPricingResultPage']
    export const isLocationFreightPricingResultPage = (obj?: { __typename?: any } | null): obj is LocationFreightPricingResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLocationFreightPricingResultPage"')
      return LocationFreightPricingResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const LoopNode_possibleTypes: string[] = ['LoopNode']
    export const isLoopNode = (obj?: { __typename?: any } | null): obj is LoopNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLoopNode"')
      return LoopNode_possibleTypes.includes(obj.__typename)
    }
    


    const LotAllocation_possibleTypes: string[] = ['LotAllocation']
    export const isLotAllocation = (obj?: { __typename?: any } | null): obj is LotAllocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotAllocation"')
      return LotAllocation_possibleTypes.includes(obj.__typename)
    }
    


    const LotAllocationResultPage_possibleTypes: string[] = ['LotAllocationResultPage']
    export const isLotAllocationResultPage = (obj?: { __typename?: any } | null): obj is LotAllocationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotAllocationResultPage"')
      return LotAllocationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const LotQuantitySummary_possibleTypes: string[] = ['LotQuantitySummary']
    export const isLotQuantitySummary = (obj?: { __typename?: any } | null): obj is LotQuantitySummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotQuantitySummary"')
      return LotQuantitySummary_possibleTypes.includes(obj.__typename)
    }
    


    const LotTraceBackwardResult_possibleTypes: string[] = ['LotTraceBackwardResult']
    export const isLotTraceBackwardResult = (obj?: { __typename?: any } | null): obj is LotTraceBackwardResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotTraceBackwardResult"')
      return LotTraceBackwardResult_possibleTypes.includes(obj.__typename)
    }
    


    const LotTraceForwardResult_possibleTypes: string[] = ['LotTraceForwardResult']
    export const isLotTraceForwardResult = (obj?: { __typename?: any } | null): obj is LotTraceForwardResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotTraceForwardResult"')
      return LotTraceForwardResult_possibleTypes.includes(obj.__typename)
    }
    


    const LotTracePurchase_possibleTypes: string[] = ['LotTracePurchase']
    export const isLotTracePurchase = (obj?: { __typename?: any } | null): obj is LotTracePurchase => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotTracePurchase"')
      return LotTracePurchase_possibleTypes.includes(obj.__typename)
    }
    


    const LotTraceSale_possibleTypes: string[] = ['LotTraceSale']
    export const isLotTraceSale = (obj?: { __typename?: any } | null): obj is LotTraceSale => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotTraceSale"')
      return LotTraceSale_possibleTypes.includes(obj.__typename)
    }
    


    const LotValuation_possibleTypes: string[] = ['LotValuation']
    export const isLotValuation = (obj?: { __typename?: any } | null): obj is LotValuation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isLotValuation"')
      return LotValuation_possibleTypes.includes(obj.__typename)
    }
    


    const MfaChallenge_possibleTypes: string[] = ['MfaChallenge']
    export const isMfaChallenge = (obj?: { __typename?: any } | null): obj is MfaChallenge => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMfaChallenge"')
      return MfaChallenge_possibleTypes.includes(obj.__typename)
    }
    


    const MfaChallengeError_possibleTypes: string[] = ['MfaChallengeError']
    export const isMfaChallengeError = (obj?: { __typename?: any } | null): obj is MfaChallengeError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMfaChallengeError"')
      return MfaChallengeError_possibleTypes.includes(obj.__typename)
    }
    


    const MfaEnrollmentRequiredError_possibleTypes: string[] = ['MfaEnrollmentRequiredError']
    export const isMfaEnrollmentRequiredError = (obj?: { __typename?: any } | null): obj is MfaEnrollmentRequiredError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMfaEnrollmentRequiredError"')
      return MfaEnrollmentRequiredError_possibleTypes.includes(obj.__typename)
    }
    


    const MfaFactor_possibleTypes: string[] = ['MfaFactor']
    export const isMfaFactor = (obj?: { __typename?: any } | null): obj is MfaFactor => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMfaFactor"')
      return MfaFactor_possibleTypes.includes(obj.__typename)
    }
    


    const Money_possibleTypes: string[] = ['Money']
    export const isMoney = (obj?: { __typename?: any } | null): obj is Money => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMoney"')
      return Money_possibleTypes.includes(obj.__typename)
    }
    


    const MoveFilePayload_possibleTypes: string[] = ['MoveFilePayload']
    export const isMoveFilePayload = (obj?: { __typename?: any } | null): obj is MoveFilePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMoveFilePayload"')
      return MoveFilePayload_possibleTypes.includes(obj.__typename)
    }
    


    const MovementRunningTotals_possibleTypes: string[] = ['MovementRunningTotals']
    export const isMovementRunningTotals = (obj?: { __typename?: any } | null): obj is MovementRunningTotals => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMovementRunningTotals"')
      return MovementRunningTotals_possibleTypes.includes(obj.__typename)
    }
    


    const Mutation_possibleTypes: string[] = ['Mutation']
    export const isMutation = (obj?: { __typename?: any } | null): obj is Mutation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isMutation"')
      return Mutation_possibleTypes.includes(obj.__typename)
    }
    


    const NetPayResult_possibleTypes: string[] = ['NetPayResult']
    export const isNetPayResult = (obj?: { __typename?: any } | null): obj is NetPayResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNetPayResult"')
      return NetPayResult_possibleTypes.includes(obj.__typename)
    }
    


    const Node_possibleTypes: string[] = ['ApprovalNode','BusinessEventTriggerNode','ConditionNode','DelayNode','EmailActionNode','FilterNode','HttpRequestActionNode','HttpWebhookTriggerNode','LoopNode','ScheduleTriggerNode','SwitchNode']
    export const isNode = (obj?: { __typename?: any } | null): obj is Node => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNode"')
      return Node_possibleTypes.includes(obj.__typename)
    }
    


    const NodeExecution_possibleTypes: string[] = ['NodeExecution']
    export const isNodeExecution = (obj?: { __typename?: any } | null): obj is NodeExecution => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNodeExecution"')
      return NodeExecution_possibleTypes.includes(obj.__typename)
    }
    


    const Notification_possibleTypes: string[] = ['Notification']
    export const isNotification = (obj?: { __typename?: any } | null): obj is Notification => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotification"')
      return Notification_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationDevice_possibleTypes: string[] = ['NotificationDevice']
    export const isNotificationDevice = (obj?: { __typename?: any } | null): obj is NotificationDevice => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationDevice"')
      return NotificationDevice_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationDeviceResultPage_possibleTypes: string[] = ['NotificationDeviceResultPage']
    export const isNotificationDeviceResultPage = (obj?: { __typename?: any } | null): obj is NotificationDeviceResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationDeviceResultPage"')
      return NotificationDeviceResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationFeedEntry_possibleTypes: string[] = ['NotificationFeedEntry']
    export const isNotificationFeedEntry = (obj?: { __typename?: any } | null): obj is NotificationFeedEntry => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationFeedEntry"')
      return NotificationFeedEntry_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationFeedPage_possibleTypes: string[] = ['NotificationFeedPage']
    export const isNotificationFeedPage = (obj?: { __typename?: any } | null): obj is NotificationFeedPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationFeedPage"')
      return NotificationFeedPage_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationPreference_possibleTypes: string[] = ['NotificationPreference']
    export const isNotificationPreference = (obj?: { __typename?: any } | null): obj is NotificationPreference => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationPreference"')
      return NotificationPreference_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationPreferenceResultPage_possibleTypes: string[] = ['NotificationPreferenceResultPage']
    export const isNotificationPreferenceResultPage = (obj?: { __typename?: any } | null): obj is NotificationPreferenceResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationPreferenceResultPage"')
      return NotificationPreferenceResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationRecipient_possibleTypes: string[] = ['NotificationRecipient']
    export const isNotificationRecipient = (obj?: { __typename?: any } | null): obj is NotificationRecipient => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationRecipient"')
      return NotificationRecipient_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationRecipientResultPage_possibleTypes: string[] = ['NotificationRecipientResultPage']
    export const isNotificationRecipientResultPage = (obj?: { __typename?: any } | null): obj is NotificationRecipientResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationRecipientResultPage"')
      return NotificationRecipientResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationResultPage_possibleTypes: string[] = ['NotificationResultPage']
    export const isNotificationResultPage = (obj?: { __typename?: any } | null): obj is NotificationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationResultPage"')
      return NotificationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationType_possibleTypes: string[] = ['NotificationType']
    export const isNotificationType = (obj?: { __typename?: any } | null): obj is NotificationType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationType"')
      return NotificationType_possibleTypes.includes(obj.__typename)
    }
    


    const NotificationTypeResultPage_possibleTypes: string[] = ['NotificationTypeResultPage']
    export const isNotificationTypeResultPage = (obj?: { __typename?: any } | null): obj is NotificationTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isNotificationTypeResultPage"')
      return NotificationTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const OneTimeCodeExpired_possibleTypes: string[] = ['OneTimeCodeExpired']
    export const isOneTimeCodeExpired = (obj?: { __typename?: any } | null): obj is OneTimeCodeExpired => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOneTimeCodeExpired"')
      return OneTimeCodeExpired_possibleTypes.includes(obj.__typename)
    }
    


    const Operation_possibleTypes: string[] = ['Operation']
    export const isOperation = (obj?: { __typename?: any } | null): obj is Operation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOperation"')
      return Operation_possibleTypes.includes(obj.__typename)
    }
    


    const Organization_possibleTypes: string[] = ['Organization']
    export const isOrganization = (obj?: { __typename?: any } | null): obj is Organization => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrganization"')
      return Organization_possibleTypes.includes(obj.__typename)
    }
    


    const OrganizationResetResult_possibleTypes: string[] = ['OrganizationResetResult']
    export const isOrganizationResetResult = (obj?: { __typename?: any } | null): obj is OrganizationResetResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrganizationResetResult"')
      return OrganizationResetResult_possibleTypes.includes(obj.__typename)
    }
    


    const OrganizationResultPage_possibleTypes: string[] = ['OrganizationResultPage']
    export const isOrganizationResultPage = (obj?: { __typename?: any } | null): obj is OrganizationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrganizationResultPage"')
      return OrganizationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const OrganizationSelectionError_possibleTypes: string[] = ['OrganizationSelectionError']
    export const isOrganizationSelectionError = (obj?: { __typename?: any } | null): obj is OrganizationSelectionError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrganizationSelectionError"')
      return OrganizationSelectionError_possibleTypes.includes(obj.__typename)
    }
    


    const OrphanedBookingSalesOrderLink_possibleTypes: string[] = ['OrphanedBookingSalesOrderLink']
    export const isOrphanedBookingSalesOrderLink = (obj?: { __typename?: any } | null): obj is OrphanedBookingSalesOrderLink => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOrphanedBookingSalesOrderLink"')
      return OrphanedBookingSalesOrderLink_possibleTypes.includes(obj.__typename)
    }
    


    const OutboundTollingAgreement_possibleTypes: string[] = ['OutboundTollingAgreement']
    export const isOutboundTollingAgreement = (obj?: { __typename?: any } | null): obj is OutboundTollingAgreement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOutboundTollingAgreement"')
      return OutboundTollingAgreement_possibleTypes.includes(obj.__typename)
    }
    


    const OutboundTollingAgreementResultPage_possibleTypes: string[] = ['OutboundTollingAgreementResultPage']
    export const isOutboundTollingAgreementResultPage = (obj?: { __typename?: any } | null): obj is OutboundTollingAgreementResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOutboundTollingAgreementResultPage"')
      return OutboundTollingAgreementResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const OutboxEvent_possibleTypes: string[] = ['OutboxEvent']
    export const isOutboxEvent = (obj?: { __typename?: any } | null): obj is OutboxEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOutboxEvent"')
      return OutboxEvent_possibleTypes.includes(obj.__typename)
    }
    


    const OutboxEventMetadata_possibleTypes: string[] = ['OutboxEventMetadata']
    export const isOutboxEventMetadata = (obj?: { __typename?: any } | null): obj is OutboxEventMetadata => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOutboxEventMetadata"')
      return OutboxEventMetadata_possibleTypes.includes(obj.__typename)
    }
    


    const OutboxEventResultPage_possibleTypes: string[] = ['OutboxEventResultPage']
    export const isOutboxEventResultPage = (obj?: { __typename?: any } | null): obj is OutboxEventResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isOutboxEventResultPage"')
      return OutboxEventResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const P2PRelayInfo_possibleTypes: string[] = ['P2PRelayInfo']
    export const isP2PRelayInfo = (obj?: { __typename?: any } | null): obj is P2PRelayInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isP2PRelayInfo"')
      return P2PRelayInfo_possibleTypes.includes(obj.__typename)
    }
    


    const Page_possibleTypes: string[] = ['Page']
    export const isPage = (obj?: { __typename?: any } | null): obj is Page => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPage"')
      return Page_possibleTypes.includes(obj.__typename)
    }
    


    const PayBillResult_possibleTypes: string[] = ['PayBillResult']
    export const isPayBillResult = (obj?: { __typename?: any } | null): obj is PayBillResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayBillResult"')
      return PayBillResult_possibleTypes.includes(obj.__typename)
    }
    


    const Payment_possibleTypes: string[] = ['Payment']
    export const isPayment = (obj?: { __typename?: any } | null): obj is Payment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPayment"')
      return Payment_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentItemResult_possibleTypes: string[] = ['PaymentItemResult']
    export const isPaymentItemResult = (obj?: { __typename?: any } | null): obj is PaymentItemResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentItemResult"')
      return PaymentItemResult_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentResultPage_possibleTypes: string[] = ['PaymentResultPage']
    export const isPaymentResultPage = (obj?: { __typename?: any } | null): obj is PaymentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentResultPage"')
      return PaymentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentTermConfig_possibleTypes: string[] = ['PaymentTermConfig']
    export const isPaymentTermConfig = (obj?: { __typename?: any } | null): obj is PaymentTermConfig => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentTermConfig"')
      return PaymentTermConfig_possibleTypes.includes(obj.__typename)
    }
    


    const PaymentTermConfigResultPage_possibleTypes: string[] = ['PaymentTermConfigResultPage']
    export const isPaymentTermConfigResultPage = (obj?: { __typename?: any } | null): obj is PaymentTermConfigResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPaymentTermConfigResultPage"')
      return PaymentTermConfigResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PendingAuthenticationError_possibleTypes: string[] = ['EmailVerificationRequiredError','InvalidOneTimeCode','MfaChallengeError','MfaEnrollmentRequiredError','OneTimeCodeExpired','OrganizationSelectionError','SsoRequiredError']
    export const isPendingAuthenticationError = (obj?: { __typename?: any } | null): obj is PendingAuthenticationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPendingAuthenticationError"')
      return PendingAuthenticationError_possibleTypes.includes(obj.__typename)
    }
    


    const PeriodTrialCloseResult_possibleTypes: string[] = ['PeriodTrialCloseResult']
    export const isPeriodTrialCloseResult = (obj?: { __typename?: any } | null): obj is PeriodTrialCloseResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPeriodTrialCloseResult"')
      return PeriodTrialCloseResult_possibleTypes.includes(obj.__typename)
    }
    


    const Permission_possibleTypes: string[] = ['Permission']
    export const isPermission = (obj?: { __typename?: any } | null): obj is Permission => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPermission"')
      return Permission_possibleTypes.includes(obj.__typename)
    }
    


    const Permissions_possibleTypes: string[] = ['Permissions']
    export const isPermissions = (obj?: { __typename?: any } | null): obj is Permissions => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPermissions"')
      return Permissions_possibleTypes.includes(obj.__typename)
    }
    


    const PhotoInstruction_possibleTypes: string[] = ['PhotoInstruction']
    export const isPhotoInstruction = (obj?: { __typename?: any } | null): obj is PhotoInstruction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPhotoInstruction"')
      return PhotoInstruction_possibleTypes.includes(obj.__typename)
    }
    


    const PhotoRequirement_possibleTypes: string[] = ['PhotoRequirement']
    export const isPhotoRequirement = (obj?: { __typename?: any } | null): obj is PhotoRequirement => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPhotoRequirement"')
      return PhotoRequirement_possibleTypes.includes(obj.__typename)
    }
    


    const PlaidExchangeTokenResponse_possibleTypes: string[] = ['PlaidExchangeTokenResponse']
    export const isPlaidExchangeTokenResponse = (obj?: { __typename?: any } | null): obj is PlaidExchangeTokenResponse => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPlaidExchangeTokenResponse"')
      return PlaidExchangeTokenResponse_possibleTypes.includes(obj.__typename)
    }
    


    const PlaidItem_possibleTypes: string[] = ['PlaidItem']
    export const isPlaidItem = (obj?: { __typename?: any } | null): obj is PlaidItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPlaidItem"')
      return PlaidItem_possibleTypes.includes(obj.__typename)
    }
    


    const PlaidLinkToken_possibleTypes: string[] = ['PlaidLinkToken']
    export const isPlaidLinkToken = (obj?: { __typename?: any } | null): obj is PlaidLinkToken => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPlaidLinkToken"')
      return PlaidLinkToken_possibleTypes.includes(obj.__typename)
    }
    


    const Point_possibleTypes: string[] = ['Point']
    export const isPoint = (obj?: { __typename?: any } | null): obj is Point => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPoint"')
      return Point_possibleTypes.includes(obj.__typename)
    }
    


    const Polygon_possibleTypes: string[] = ['Polygon']
    export const isPolygon = (obj?: { __typename?: any } | null): obj is Polygon => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPolygon"')
      return Polygon_possibleTypes.includes(obj.__typename)
    }
    


    const Port_possibleTypes: string[] = ['Port']
    export const isPort = (obj?: { __typename?: any } | null): obj is Port => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPort"')
      return Port_possibleTypes.includes(obj.__typename)
    }
    


    const PortResultPage_possibleTypes: string[] = ['PortResultPage']
    export const isPortResultPage = (obj?: { __typename?: any } | null): obj is PortResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPortResultPage"')
      return PortResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Position_possibleTypes: string[] = ['Position']
    export const isPosition = (obj?: { __typename?: any } | null): obj is Position => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPosition"')
      return Position_possibleTypes.includes(obj.__typename)
    }
    


    const PositionSummaryStats_possibleTypes: string[] = ['PositionSummaryStats']
    export const isPositionSummaryStats = (obj?: { __typename?: any } | null): obj is PositionSummaryStats => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPositionSummaryStats"')
      return PositionSummaryStats_possibleTypes.includes(obj.__typename)
    }
    


    const PositivePayTemplate_possibleTypes: string[] = ['PositivePayTemplate']
    export const isPositivePayTemplate = (obj?: { __typename?: any } | null): obj is PositivePayTemplate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPositivePayTemplate"')
      return PositivePayTemplate_possibleTypes.includes(obj.__typename)
    }
    


    const PositivePayTemplateResultPage_possibleTypes: string[] = ['PositivePayTemplateResultPage']
    export const isPositivePayTemplateResultPage = (obj?: { __typename?: any } | null): obj is PositivePayTemplateResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPositivePayTemplateResultPage"')
      return PositivePayTemplateResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PresenceEvent_possibleTypes: string[] = ['PresenceEvent']
    export const isPresenceEvent = (obj?: { __typename?: any } | null): obj is PresenceEvent => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPresenceEvent"')
      return PresenceEvent_possibleTypes.includes(obj.__typename)
    }
    


    const PresenceMember_possibleTypes: string[] = ['PresenceMember']
    export const isPresenceMember = (obj?: { __typename?: any } | null): obj is PresenceMember => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPresenceMember"')
      return PresenceMember_possibleTypes.includes(obj.__typename)
    }
    


    const Printer_possibleTypes: string[] = ['Printer']
    export const isPrinter = (obj?: { __typename?: any } | null): obj is Printer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPrinter"')
      return Printer_possibleTypes.includes(obj.__typename)
    }
    


    const PrinterResultPage_possibleTypes: string[] = ['PrinterResultPage']
    export const isPrinterResultPage = (obj?: { __typename?: any } | null): obj is PrinterResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPrinterResultPage"')
      return PrinterResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessingType_possibleTypes: string[] = ['ProcessingType']
    export const isProcessingType = (obj?: { __typename?: any } | null): obj is ProcessingType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessingType"')
      return ProcessingType_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessingTypeInputItem_possibleTypes: string[] = ['ProcessingTypeInputItem']
    export const isProcessingTypeInputItem = (obj?: { __typename?: any } | null): obj is ProcessingTypeInputItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessingTypeInputItem"')
      return ProcessingTypeInputItem_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessingTypeInputItemResultPage_possibleTypes: string[] = ['ProcessingTypeInputItemResultPage']
    export const isProcessingTypeInputItemResultPage = (obj?: { __typename?: any } | null): obj is ProcessingTypeInputItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessingTypeInputItemResultPage"')
      return ProcessingTypeInputItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessingTypeOutputItem_possibleTypes: string[] = ['ProcessingTypeOutputItem']
    export const isProcessingTypeOutputItem = (obj?: { __typename?: any } | null): obj is ProcessingTypeOutputItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessingTypeOutputItem"')
      return ProcessingTypeOutputItem_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessingTypeOutputItemResultPage_possibleTypes: string[] = ['ProcessingTypeOutputItemResultPage']
    export const isProcessingTypeOutputItemResultPage = (obj?: { __typename?: any } | null): obj is ProcessingTypeOutputItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessingTypeOutputItemResultPage"')
      return ProcessingTypeOutputItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ProcessingTypeResultPage_possibleTypes: string[] = ['ProcessingTypeResultPage']
    export const isProcessingTypeResultPage = (obj?: { __typename?: any } | null): obj is ProcessingTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProcessingTypeResultPage"')
      return ProcessingTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ProvisionFacilityAccountsResult_possibleTypes: string[] = ['ProvisionFacilityAccountsResult']
    export const isProvisionFacilityAccountsResult = (obj?: { __typename?: any } | null): obj is ProvisionFacilityAccountsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isProvisionFacilityAccountsResult"')
      return ProvisionFacilityAccountsResult_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoad_possibleTypes: string[] = ['PurchaseLoad']
    export const isPurchaseLoad = (obj?: { __typename?: any } | null): obj is PurchaseLoad => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoad"')
      return PurchaseLoad_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadDeduction_possibleTypes: string[] = ['PurchaseLoadDeduction']
    export const isPurchaseLoadDeduction = (obj?: { __typename?: any } | null): obj is PurchaseLoadDeduction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadDeduction"')
      return PurchaseLoadDeduction_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadDeductionResultPage_possibleTypes: string[] = ['PurchaseLoadDeductionResultPage']
    export const isPurchaseLoadDeductionResultPage = (obj?: { __typename?: any } | null): obj is PurchaseLoadDeductionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadDeductionResultPage"')
      return PurchaseLoadDeductionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadFileCreatePayload_possibleTypes: string[] = ['PurchaseLoadFileCreatePayload']
    export const isPurchaseLoadFileCreatePayload = (obj?: { __typename?: any } | null): obj is PurchaseLoadFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadFileCreatePayload"')
      return PurchaseLoadFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadLineItem_possibleTypes: string[] = ['PurchaseLoadLineItem']
    export const isPurchaseLoadLineItem = (obj?: { __typename?: any } | null): obj is PurchaseLoadLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadLineItem"')
      return PurchaseLoadLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadLineItemResultPage_possibleTypes: string[] = ['PurchaseLoadLineItemResultPage']
    export const isPurchaseLoadLineItemResultPage = (obj?: { __typename?: any } | null): obj is PurchaseLoadLineItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadLineItemResultPage"')
      return PurchaseLoadLineItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadPayment_possibleTypes: string[] = ['PurchaseLoadPayment']
    export const isPurchaseLoadPayment = (obj?: { __typename?: any } | null): obj is PurchaseLoadPayment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadPayment"')
      return PurchaseLoadPayment_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadPaymentResultPage_possibleTypes: string[] = ['PurchaseLoadPaymentResultPage']
    export const isPurchaseLoadPaymentResultPage = (obj?: { __typename?: any } | null): obj is PurchaseLoadPaymentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadPaymentResultPage"')
      return PurchaseLoadPaymentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseLoadResultPage_possibleTypes: string[] = ['PurchaseLoadResultPage']
    export const isPurchaseLoadResultPage = (obj?: { __typename?: any } | null): obj is PurchaseLoadResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseLoadResultPage"')
      return PurchaseLoadResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrder_possibleTypes: string[] = ['PurchaseOrder']
    export const isPurchaseOrder = (obj?: { __typename?: any } | null): obj is PurchaseOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrder"')
      return PurchaseOrder_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderFileCreatePayload_possibleTypes: string[] = ['PurchaseOrderFileCreatePayload']
    export const isPurchaseOrderFileCreatePayload = (obj?: { __typename?: any } | null): obj is PurchaseOrderFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderFileCreatePayload"')
      return PurchaseOrderFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderFreight_possibleTypes: string[] = ['PurchaseOrderFreight']
    export const isPurchaseOrderFreight = (obj?: { __typename?: any } | null): obj is PurchaseOrderFreight => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderFreight"')
      return PurchaseOrderFreight_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderFreightResultPage_possibleTypes: string[] = ['PurchaseOrderFreightResultPage']
    export const isPurchaseOrderFreightResultPage = (obj?: { __typename?: any } | null): obj is PurchaseOrderFreightResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderFreightResultPage"')
      return PurchaseOrderFreightResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderLineItem_possibleTypes: string[] = ['PurchaseOrderLineItem']
    export const isPurchaseOrderLineItem = (obj?: { __typename?: any } | null): obj is PurchaseOrderLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderLineItem"')
      return PurchaseOrderLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderLineItemResultPage_possibleTypes: string[] = ['PurchaseOrderLineItemResultPage']
    export const isPurchaseOrderLineItemResultPage = (obj?: { __typename?: any } | null): obj is PurchaseOrderLineItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderLineItemResultPage"')
      return PurchaseOrderLineItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderResultPage_possibleTypes: string[] = ['PurchaseOrderResultPage']
    export const isPurchaseOrderResultPage = (obj?: { __typename?: any } | null): obj is PurchaseOrderResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderResultPage"')
      return PurchaseOrderResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const PurchaseOrderStatusCounts_possibleTypes: string[] = ['PurchaseOrderStatusCounts']
    export const isPurchaseOrderStatusCounts = (obj?: { __typename?: any } | null): obj is PurchaseOrderStatusCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isPurchaseOrderStatusCounts"')
      return PurchaseOrderStatusCounts_possibleTypes.includes(obj.__typename)
    }
    


    const Query_possibleTypes: string[] = ['Query']
    export const isQuery = (obj?: { __typename?: any } | null): obj is Query => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuery"')
      return Query_possibleTypes.includes(obj.__typename)
    }
    


    const Quote_possibleTypes: string[] = ['Quote']
    export const isQuote = (obj?: { __typename?: any } | null): obj is Quote => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuote"')
      return Quote_possibleTypes.includes(obj.__typename)
    }
    


    const QuoteLineItem_possibleTypes: string[] = ['QuoteLineItem']
    export const isQuoteLineItem = (obj?: { __typename?: any } | null): obj is QuoteLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuoteLineItem"')
      return QuoteLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const QuoteLineItemResultPage_possibleTypes: string[] = ['QuoteLineItemResultPage']
    export const isQuoteLineItemResultPage = (obj?: { __typename?: any } | null): obj is QuoteLineItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuoteLineItemResultPage"')
      return QuoteLineItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const QuoteResultPage_possibleTypes: string[] = ['QuoteResultPage']
    export const isQuoteResultPage = (obj?: { __typename?: any } | null): obj is QuoteResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isQuoteResultPage"')
      return QuoteResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ReceiveInvoiceResult_possibleTypes: string[] = ['ReceiveInvoiceResult']
    export const isReceiveInvoiceResult = (obj?: { __typename?: any } | null): obj is ReceiveInvoiceResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReceiveInvoiceResult"')
      return ReceiveInvoiceResult_possibleTypes.includes(obj.__typename)
    }
    


    const ReceivedLineItem_possibleTypes: string[] = ['ReceivedLineItem']
    export const isReceivedLineItem = (obj?: { __typename?: any } | null): obj is ReceivedLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReceivedLineItem"')
      return ReceivedLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const ReconcileCashDrawerPayload_possibleTypes: string[] = ['ReconcileCashDrawerPayload']
    export const isReconcileCashDrawerPayload = (obj?: { __typename?: any } | null): obj is ReconcileCashDrawerPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReconcileCashDrawerPayload"')
      return ReconcileCashDrawerPayload_possibleTypes.includes(obj.__typename)
    }
    


    const ReconciliationDeduction_possibleTypes: string[] = ['ReconciliationDeduction']
    export const isReconciliationDeduction = (obj?: { __typename?: any } | null): obj is ReconciliationDeduction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isReconciliationDeduction"')
      return ReconciliationDeduction_possibleTypes.includes(obj.__typename)
    }
    


    const RecurringSchedule_possibleTypes: string[] = ['RecurringSchedule']
    export const isRecurringSchedule = (obj?: { __typename?: any } | null): obj is RecurringSchedule => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRecurringSchedule"')
      return RecurringSchedule_possibleTypes.includes(obj.__typename)
    }
    


    const RemoveFileFromTemplatePayload_possibleTypes: string[] = ['RemoveFileFromTemplatePayload']
    export const isRemoveFileFromTemplatePayload = (obj?: { __typename?: any } | null): obj is RemoveFileFromTemplatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRemoveFileFromTemplatePayload"')
      return RemoveFileFromTemplatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const Role_possibleTypes: string[] = ['Role']
    export const isRole = (obj?: { __typename?: any } | null): obj is Role => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRole"')
      return Role_possibleTypes.includes(obj.__typename)
    }
    


    const RoleResultPage_possibleTypes: string[] = ['RoleResultPage']
    export const isRoleResultPage = (obj?: { __typename?: any } | null): obj is RoleResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRoleResultPage"')
      return RoleResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Route_possibleTypes: string[] = ['Route']
    export const isRoute = (obj?: { __typename?: any } | null): obj is Route => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRoute"')
      return Route_possibleTypes.includes(obj.__typename)
    }
    


    const RouteFreight_possibleTypes: string[] = ['RouteFreight']
    export const isRouteFreight = (obj?: { __typename?: any } | null): obj is RouteFreight => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteFreight"')
      return RouteFreight_possibleTypes.includes(obj.__typename)
    }
    


    const RouteFreightResultPage_possibleTypes: string[] = ['RouteFreightResultPage']
    export const isRouteFreightResultPage = (obj?: { __typename?: any } | null): obj is RouteFreightResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteFreightResultPage"')
      return RouteFreightResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const RouteLeg_possibleTypes: string[] = ['RouteLeg']
    export const isRouteLeg = (obj?: { __typename?: any } | null): obj is RouteLeg => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteLeg"')
      return RouteLeg_possibleTypes.includes(obj.__typename)
    }
    


    const RouteResultPage_possibleTypes: string[] = ['RouteResultPage']
    export const isRouteResultPage = (obj?: { __typename?: any } | null): obj is RouteResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteResultPage"')
      return RouteResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const RouteValidationOverride_possibleTypes: string[] = ['RouteValidationOverride']
    export const isRouteValidationOverride = (obj?: { __typename?: any } | null): obj is RouteValidationOverride => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteValidationOverride"')
      return RouteValidationOverride_possibleTypes.includes(obj.__typename)
    }
    


    const RouteValidationOverrideResultPage_possibleTypes: string[] = ['RouteValidationOverrideResultPage']
    export const isRouteValidationOverrideResultPage = (obj?: { __typename?: any } | null): obj is RouteValidationOverrideResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteValidationOverrideResultPage"')
      return RouteValidationOverrideResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const RouteValidationResult_possibleTypes: string[] = ['RouteValidationResult']
    export const isRouteValidationResult = (obj?: { __typename?: any } | null): obj is RouteValidationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteValidationResult"')
      return RouteValidationResult_possibleTypes.includes(obj.__typename)
    }
    


    const RouteValidationViolation_possibleTypes: string[] = ['RouteValidationViolation']
    export const isRouteValidationViolation = (obj?: { __typename?: any } | null): obj is RouteValidationViolation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isRouteValidationViolation"')
      return RouteValidationViolation_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrder_possibleTypes: string[] = ['SalesOrder']
    export const isSalesOrder = (obj?: { __typename?: any } | null): obj is SalesOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrder"')
      return SalesOrder_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderCustomerFileCreatePayload_possibleTypes: string[] = ['SalesOrderCustomerFileCreatePayload']
    export const isSalesOrderCustomerFileCreatePayload = (obj?: { __typename?: any } | null): obj is SalesOrderCustomerFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderCustomerFileCreatePayload"')
      return SalesOrderCustomerFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderFileCreatePayload_possibleTypes: string[] = ['SalesOrderFileCreatePayload']
    export const isSalesOrderFileCreatePayload = (obj?: { __typename?: any } | null): obj is SalesOrderFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderFileCreatePayload"')
      return SalesOrderFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderFreight_possibleTypes: string[] = ['SalesOrderFreight']
    export const isSalesOrderFreight = (obj?: { __typename?: any } | null): obj is SalesOrderFreight => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderFreight"')
      return SalesOrderFreight_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderFreightResultPage_possibleTypes: string[] = ['SalesOrderFreightResultPage']
    export const isSalesOrderFreightResultPage = (obj?: { __typename?: any } | null): obj is SalesOrderFreightResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderFreightResultPage"')
      return SalesOrderFreightResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderLineItem_possibleTypes: string[] = ['SalesOrderLineItem']
    export const isSalesOrderLineItem = (obj?: { __typename?: any } | null): obj is SalesOrderLineItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderLineItem"')
      return SalesOrderLineItem_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderRecyclerFileCreatePayload_possibleTypes: string[] = ['SalesOrderRecyclerFileCreatePayload']
    export const isSalesOrderRecyclerFileCreatePayload = (obj?: { __typename?: any } | null): obj is SalesOrderRecyclerFileCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderRecyclerFileCreatePayload"')
      return SalesOrderRecyclerFileCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderResultPage_possibleTypes: string[] = ['SalesOrderResultPage']
    export const isSalesOrderResultPage = (obj?: { __typename?: any } | null): obj is SalesOrderResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderResultPage"')
      return SalesOrderResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const SalesOrderUpdateResult_possibleTypes: string[] = ['SalesOrderUpdateResult']
    export const isSalesOrderUpdateResult = (obj?: { __typename?: any } | null): obj is SalesOrderUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSalesOrderUpdateResult"')
      return SalesOrderUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const Scale_possibleTypes: string[] = ['Scale']
    export const isScale = (obj?: { __typename?: any } | null): obj is Scale => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScale"')
      return Scale_possibleTypes.includes(obj.__typename)
    }
    


    const ScaleResultPage_possibleTypes: string[] = ['ScaleResultPage']
    export const isScaleResultPage = (obj?: { __typename?: any } | null): obj is ScaleResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScaleResultPage"')
      return ScaleResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Scanner_possibleTypes: string[] = ['Scanner']
    export const isScanner = (obj?: { __typename?: any } | null): obj is Scanner => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScanner"')
      return Scanner_possibleTypes.includes(obj.__typename)
    }
    


    const ScannerResultPage_possibleTypes: string[] = ['ScannerResultPage']
    export const isScannerResultPage = (obj?: { __typename?: any } | null): obj is ScannerResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScannerResultPage"')
      return ScannerResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ScheduleTriggerConfigOutput_possibleTypes: string[] = ['ScheduleTriggerConfigOutput']
    export const isScheduleTriggerConfigOutput = (obj?: { __typename?: any } | null): obj is ScheduleTriggerConfigOutput => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScheduleTriggerConfigOutput"')
      return ScheduleTriggerConfigOutput_possibleTypes.includes(obj.__typename)
    }
    


    const ScheduleTriggerNode_possibleTypes: string[] = ['ScheduleTriggerNode']
    export const isScheduleTriggerNode = (obj?: { __typename?: any } | null): obj is ScheduleTriggerNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isScheduleTriggerNode"')
      return ScheduleTriggerNode_possibleTypes.includes(obj.__typename)
    }
    


    const SemaphorToken_possibleTypes: string[] = ['SemaphorToken']
    export const isSemaphorToken = (obj?: { __typename?: any } | null): obj is SemaphorToken => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSemaphorToken"')
      return SemaphorToken_possibleTypes.includes(obj.__typename)
    }
    


    const SendPriceListNotificationResult_possibleTypes: string[] = ['SendPriceListNotificationResult']
    export const isSendPriceListNotificationResult = (obj?: { __typename?: any } | null): obj is SendPriceListNotificationResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSendPriceListNotificationResult"')
      return SendPriceListNotificationResult_possibleTypes.includes(obj.__typename)
    }
    


    const Service_possibleTypes: string[] = ['Service']
    export const isService = (obj?: { __typename?: any } | null): obj is Service => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isService"')
      return Service_possibleTypes.includes(obj.__typename)
    }
    


    const ServiceAction_possibleTypes: string[] = ['ServiceAction']
    export const isServiceAction = (obj?: { __typename?: any } | null): obj is ServiceAction => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isServiceAction"')
      return ServiceAction_possibleTypes.includes(obj.__typename)
    }
    


    const ServiceResultPage_possibleTypes: string[] = ['ServiceResultPage']
    export const isServiceResultPage = (obj?: { __typename?: any } | null): obj is ServiceResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isServiceResultPage"')
      return ServiceResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ServiceType_possibleTypes: string[] = ['ServiceType']
    export const isServiceType = (obj?: { __typename?: any } | null): obj is ServiceType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isServiceType"')
      return ServiceType_possibleTypes.includes(obj.__typename)
    }
    


    const ServiceTypeResultPage_possibleTypes: string[] = ['ServiceTypeResultPage']
    export const isServiceTypeResultPage = (obj?: { __typename?: any } | null): obj is ServiceTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isServiceTypeResultPage"')
      return ServiceTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ServiceTypeTaskDefinition_possibleTypes: string[] = ['ServiceTypeTaskDefinition']
    export const isServiceTypeTaskDefinition = (obj?: { __typename?: any } | null): obj is ServiceTypeTaskDefinition => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isServiceTypeTaskDefinition"')
      return ServiceTypeTaskDefinition_possibleTypes.includes(obj.__typename)
    }
    


    const ServiceTypeTaskDefinitionResultPage_possibleTypes: string[] = ['ServiceTypeTaskDefinitionResultPage']
    export const isServiceTypeTaskDefinitionResultPage = (obj?: { __typename?: any } | null): obj is ServiceTypeTaskDefinitionResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isServiceTypeTaskDefinitionResultPage"')
      return ServiceTypeTaskDefinitionResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const SetFileAsTemplatePayload_possibleTypes: string[] = ['SetFileAsTemplatePayload']
    export const isSetFileAsTemplatePayload = (obj?: { __typename?: any } | null): obj is SetFileAsTemplatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetFileAsTemplatePayload"')
      return SetFileAsTemplatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const SetTemplateAsDefaultPayload_possibleTypes: string[] = ['SetTemplateAsDefaultPayload']
    export const isSetTemplateAsDefaultPayload = (obj?: { __typename?: any } | null): obj is SetTemplateAsDefaultPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetTemplateAsDefaultPayload"')
      return SetTemplateAsDefaultPayload_possibleTypes.includes(obj.__typename)
    }
    


    const Setting_possibleTypes: string[] = ['Setting']
    export const isSetting = (obj?: { __typename?: any } | null): obj is Setting => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSetting"')
      return Setting_possibleTypes.includes(obj.__typename)
    }
    


    const SettingResultPage_possibleTypes: string[] = ['SettingResultPage']
    export const isSettingResultPage = (obj?: { __typename?: any } | null): obj is SettingResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSettingResultPage"')
      return SettingResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const SettingValue_possibleTypes: string[] = ['SettingValue']
    export const isSettingValue = (obj?: { __typename?: any } | null): obj is SettingValue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSettingValue"')
      return SettingValue_possibleTypes.includes(obj.__typename)
    }
    


    const SettingsGroup_possibleTypes: string[] = ['SettingsGroup']
    export const isSettingsGroup = (obj?: { __typename?: any } | null): obj is SettingsGroup => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSettingsGroup"')
      return SettingsGroup_possibleTypes.includes(obj.__typename)
    }
    


    const SettingsGroupResultPage_possibleTypes: string[] = ['SettingsGroupResultPage']
    export const isSettingsGroupResultPage = (obj?: { __typename?: any } | null): obj is SettingsGroupResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSettingsGroupResultPage"')
      return SettingsGroupResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ShareFilePayload_possibleTypes: string[] = ['ShareFilePayload']
    export const isShareFilePayload = (obj?: { __typename?: any } | null): obj is ShareFilePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShareFilePayload"')
      return ShareFilePayload_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingCarrier_possibleTypes: string[] = ['ShippingCarrier']
    export const isShippingCarrier = (obj?: { __typename?: any } | null): obj is ShippingCarrier => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingCarrier"')
      return ShippingCarrier_possibleTypes.includes(obj.__typename)
    }
    


    const ShippingCarrierResultPage_possibleTypes: string[] = ['ShippingCarrierResultPage']
    export const isShippingCarrierResultPage = (obj?: { __typename?: any } | null): obj is ShippingCarrierResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isShippingCarrierResultPage"')
      return ShippingCarrierResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Sidecar_possibleTypes: string[] = ['Sidecar']
    export const isSidecar = (obj?: { __typename?: any } | null): obj is Sidecar => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSidecar"')
      return Sidecar_possibleTypes.includes(obj.__typename)
    }
    


    const SidecarResultPage_possibleTypes: string[] = ['SidecarResultPage']
    export const isSidecarResultPage = (obj?: { __typename?: any } | null): obj is SidecarResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSidecarResultPage"')
      return SidecarResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const SidecarSettings_possibleTypes: string[] = ['SidecarSettings']
    export const isSidecarSettings = (obj?: { __typename?: any } | null): obj is SidecarSettings => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSidecarSettings"')
      return SidecarSettings_possibleTypes.includes(obj.__typename)
    }
    


    const SignUpCompleteResult_possibleTypes: string[] = ['InvalidSignUpInvitationError','SignUpCompletedResult']
    export const isSignUpCompleteResult = (obj?: { __typename?: any } | null): obj is SignUpCompleteResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSignUpCompleteResult"')
      return SignUpCompleteResult_possibleTypes.includes(obj.__typename)
    }
    


    const SignUpCompletedResult_possibleTypes: string[] = ['SignUpCompletedResult']
    export const isSignUpCompletedResult = (obj?: { __typename?: any } | null): obj is SignUpCompletedResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSignUpCompletedResult"')
      return SignUpCompletedResult_possibleTypes.includes(obj.__typename)
    }
    


    const SignUpInitiateResult_possibleTypes: string[] = ['InvalidCredentialsError','SignUpInitiatedResult']
    export const isSignUpInitiateResult = (obj?: { __typename?: any } | null): obj is SignUpInitiateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSignUpInitiateResult"')
      return SignUpInitiateResult_possibleTypes.includes(obj.__typename)
    }
    


    const SignUpInitiatedResult_possibleTypes: string[] = ['SignUpInitiatedResult']
    export const isSignUpInitiatedResult = (obj?: { __typename?: any } | null): obj is SignUpInitiatedResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSignUpInitiatedResult"')
      return SignUpInitiatedResult_possibleTypes.includes(obj.__typename)
    }
    


    const SsoRequiredError_possibleTypes: string[] = ['SsoRequiredError']
    export const isSsoRequiredError = (obj?: { __typename?: any } | null): obj is SsoRequiredError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSsoRequiredError"')
      return SsoRequiredError_possibleTypes.includes(obj.__typename)
    }
    


    const StandaloneAuthResult_possibleTypes: string[] = ['StandaloneAuthResult']
    export const isStandaloneAuthResult = (obj?: { __typename?: any } | null): obj is StandaloneAuthResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStandaloneAuthResult"')
      return StandaloneAuthResult_possibleTypes.includes(obj.__typename)
    }
    


    const StartWOPIEditingSessionPayload_possibleTypes: string[] = ['StartWOPIEditingSessionPayload']
    export const isStartWOPIEditingSessionPayload = (obj?: { __typename?: any } | null): obj is StartWOPIEditingSessionPayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStartWOPIEditingSessionPayload"')
      return StartWOPIEditingSessionPayload_possibleTypes.includes(obj.__typename)
    }
    


    const StorageQuota_possibleTypes: string[] = ['StorageQuota']
    export const isStorageQuota = (obj?: { __typename?: any } | null): obj is StorageQuota => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isStorageQuota"')
      return StorageQuota_possibleTypes.includes(obj.__typename)
    }
    


    const Subscription_possibleTypes: string[] = ['Subscription']
    export const isSubscription = (obj?: { __typename?: any } | null): obj is Subscription => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSubscription"')
      return Subscription_possibleTypes.includes(obj.__typename)
    }
    


    const SupplierPriceListAffectsMaterialsResult_possibleTypes: string[] = ['SupplierPriceListAffectsMaterialsResult']
    export const isSupplierPriceListAffectsMaterialsResult = (obj?: { __typename?: any } | null): obj is SupplierPriceListAffectsMaterialsResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSupplierPriceListAffectsMaterialsResult"')
      return SupplierPriceListAffectsMaterialsResult_possibleTypes.includes(obj.__typename)
    }
    


    const SwitchCase_possibleTypes: string[] = ['SwitchCase']
    export const isSwitchCase = (obj?: { __typename?: any } | null): obj is SwitchCase => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSwitchCase"')
      return SwitchCase_possibleTypes.includes(obj.__typename)
    }
    


    const SwitchNode_possibleTypes: string[] = ['SwitchNode']
    export const isSwitchNode = (obj?: { __typename?: any } | null): obj is SwitchNode => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isSwitchNode"')
      return SwitchNode_possibleTypes.includes(obj.__typename)
    }
    


    const TagAllocation_possibleTypes: string[] = ['TagAllocation']
    export const isTagAllocation = (obj?: { __typename?: any } | null): obj is TagAllocation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTagAllocation"')
      return TagAllocation_possibleTypes.includes(obj.__typename)
    }
    


    const TagAllocationResultPage_possibleTypes: string[] = ['TagAllocationResultPage']
    export const isTagAllocationResultPage = (obj?: { __typename?: any } | null): obj is TagAllocationResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTagAllocationResultPage"')
      return TagAllocationResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TagQuantitySummary_possibleTypes: string[] = ['TagQuantitySummary']
    export const isTagQuantitySummary = (obj?: { __typename?: any } | null): obj is TagQuantitySummary => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTagQuantitySummary"')
      return TagQuantitySummary_possibleTypes.includes(obj.__typename)
    }
    


    const TagReconciliationReport_possibleTypes: string[] = ['TagReconciliationReport']
    export const isTagReconciliationReport = (obj?: { __typename?: any } | null): obj is TagReconciliationReport => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTagReconciliationReport"')
      return TagReconciliationReport_possibleTypes.includes(obj.__typename)
    }
    


    const TalkJSConversation_possibleTypes: string[] = ['TalkJSConversation']
    export const isTalkJSConversation = (obj?: { __typename?: any } | null): obj is TalkJSConversation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTalkJSConversation"')
      return TalkJSConversation_possibleTypes.includes(obj.__typename)
    }
    


    const TalkJSConversationListResult_possibleTypes: string[] = ['TalkJSConversationListResult']
    export const isTalkJSConversationListResult = (obj?: { __typename?: any } | null): obj is TalkJSConversationListResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTalkJSConversationListResult"')
      return TalkJSConversationListResult_possibleTypes.includes(obj.__typename)
    }
    


    const TalkJSMessage_possibleTypes: string[] = ['TalkJSMessage']
    export const isTalkJSMessage = (obj?: { __typename?: any } | null): obj is TalkJSMessage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTalkJSMessage"')
      return TalkJSMessage_possibleTypes.includes(obj.__typename)
    }
    


    const TalkJSMessageRead_possibleTypes: string[] = ['TalkJSMessageRead']
    export const isTalkJSMessageRead = (obj?: { __typename?: any } | null): obj is TalkJSMessageRead => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTalkJSMessageRead"')
      return TalkJSMessageRead_possibleTypes.includes(obj.__typename)
    }
    


    const TalkJSParticipant_possibleTypes: string[] = ['TalkJSParticipant']
    export const isTalkJSParticipant = (obj?: { __typename?: any } | null): obj is TalkJSParticipant => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTalkJSParticipant"')
      return TalkJSParticipant_possibleTypes.includes(obj.__typename)
    }
    


    const Task_possibleTypes: string[] = ['Task']
    export const isTask = (obj?: { __typename?: any } | null): obj is Task => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTask"')
      return Task_possibleTypes.includes(obj.__typename)
    }
    


    const TaskPhotoCreatePayload_possibleTypes: string[] = ['TaskPhotoCreatePayload']
    export const isTaskPhotoCreatePayload = (obj?: { __typename?: any } | null): obj is TaskPhotoCreatePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTaskPhotoCreatePayload"')
      return TaskPhotoCreatePayload_possibleTypes.includes(obj.__typename)
    }
    


    const TaskResultPage_possibleTypes: string[] = ['TaskResultPage']
    export const isTaskResultPage = (obj?: { __typename?: any } | null): obj is TaskResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTaskResultPage"')
      return TaskResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TaskService_possibleTypes: string[] = ['TaskService']
    export const isTaskService = (obj?: { __typename?: any } | null): obj is TaskService => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTaskService"')
      return TaskService_possibleTypes.includes(obj.__typename)
    }
    


    const TaskServiceResultPage_possibleTypes: string[] = ['TaskServiceResultPage']
    export const isTaskServiceResultPage = (obj?: { __typename?: any } | null): obj is TaskServiceResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTaskServiceResultPage"')
      return TaskServiceResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Terminal_possibleTypes: string[] = ['Terminal']
    export const isTerminal = (obj?: { __typename?: any } | null): obj is Terminal => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTerminal"')
      return Terminal_possibleTypes.includes(obj.__typename)
    }
    


    const TicketFreight_possibleTypes: string[] = ['TicketFreight']
    export const isTicketFreight = (obj?: { __typename?: any } | null): obj is TicketFreight => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTicketFreight"')
      return TicketFreight_possibleTypes.includes(obj.__typename)
    }
    


    const TicketFreightResultPage_possibleTypes: string[] = ['TicketFreightResultPage']
    export const isTicketFreightResultPage = (obj?: { __typename?: any } | null): obj is TicketFreightResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTicketFreightResultPage"')
      return TicketFreightResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const Timestamps_possibleTypes: string[] = ['Timestamps']
    export const isTimestamps = (obj?: { __typename?: any } | null): obj is Timestamps => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTimestamps"')
      return Timestamps_possibleTypes.includes(obj.__typename)
    }
    


    const TollReceipt_possibleTypes: string[] = ['TollReceipt']
    export const isTollReceipt = (obj?: { __typename?: any } | null): obj is TollReceipt => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollReceipt"')
      return TollReceipt_possibleTypes.includes(obj.__typename)
    }
    


    const TollReceiptItem_possibleTypes: string[] = ['TollReceiptItem']
    export const isTollReceiptItem = (obj?: { __typename?: any } | null): obj is TollReceiptItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollReceiptItem"')
      return TollReceiptItem_possibleTypes.includes(obj.__typename)
    }
    


    const TollReceiptItemResultPage_possibleTypes: string[] = ['TollReceiptItemResultPage']
    export const isTollReceiptItemResultPage = (obj?: { __typename?: any } | null): obj is TollReceiptItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollReceiptItemResultPage"')
      return TollReceiptItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TollReceiptResultPage_possibleTypes: string[] = ['TollReceiptResultPage']
    export const isTollReceiptResultPage = (obj?: { __typename?: any } | null): obj is TollReceiptResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollReceiptResultPage"')
      return TollReceiptResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TollShipment_possibleTypes: string[] = ['TollShipment']
    export const isTollShipment = (obj?: { __typename?: any } | null): obj is TollShipment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollShipment"')
      return TollShipment_possibleTypes.includes(obj.__typename)
    }
    


    const TollShipmentItem_possibleTypes: string[] = ['TollShipmentItem']
    export const isTollShipmentItem = (obj?: { __typename?: any } | null): obj is TollShipmentItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollShipmentItem"')
      return TollShipmentItem_possibleTypes.includes(obj.__typename)
    }
    


    const TollShipmentItemResultPage_possibleTypes: string[] = ['TollShipmentItemResultPage']
    export const isTollShipmentItemResultPage = (obj?: { __typename?: any } | null): obj is TollShipmentItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollShipmentItemResultPage"')
      return TollShipmentItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TollShipmentResultPage_possibleTypes: string[] = ['TollShipmentResultPage']
    export const isTollShipmentResultPage = (obj?: { __typename?: any } | null): obj is TollShipmentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTollShipmentResultPage"')
      return TollShipmentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ToolCall_possibleTypes: string[] = ['ToolCall']
    export const isToolCall = (obj?: { __typename?: any } | null): obj is ToolCall => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isToolCall"')
      return ToolCall_possibleTypes.includes(obj.__typename)
    }
    


    const TotpConfig_possibleTypes: string[] = ['TotpConfig']
    export const isTotpConfig = (obj?: { __typename?: any } | null): obj is TotpConfig => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTotpConfig"')
      return TotpConfig_possibleTypes.includes(obj.__typename)
    }
    


    const TradeOutboxEventCounts_possibleTypes: string[] = ['TradeOutboxEventCounts']
    export const isTradeOutboxEventCounts = (obj?: { __typename?: any } | null): obj is TradeOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTradeOutboxEventCounts"')
      return TradeOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const Trailer_possibleTypes: string[] = ['Trailer']
    export const isTrailer = (obj?: { __typename?: any } | null): obj is Trailer => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTrailer"')
      return Trailer_possibleTypes.includes(obj.__typename)
    }
    


    const TrailerResultPage_possibleTypes: string[] = ['TrailerResultPage']
    export const isTrailerResultPage = (obj?: { __typename?: any } | null): obj is TrailerResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTrailerResultPage"')
      return TrailerResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TransportationOutboxEventCounts_possibleTypes: string[] = ['TransportationOutboxEventCounts']
    export const isTransportationOutboxEventCounts = (obj?: { __typename?: any } | null): obj is TransportationOutboxEventCounts => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransportationOutboxEventCounts"')
      return TransportationOutboxEventCounts_possibleTypes.includes(obj.__typename)
    }
    


    const TransportationType_possibleTypes: string[] = ['TransportationType']
    export const isTransportationType = (obj?: { __typename?: any } | null): obj is TransportationType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransportationType"')
      return TransportationType_possibleTypes.includes(obj.__typename)
    }
    


    const TransportationTypeResultPage_possibleTypes: string[] = ['TransportationTypeResultPage']
    export const isTransportationTypeResultPage = (obj?: { __typename?: any } | null): obj is TransportationTypeResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTransportationTypeResultPage"')
      return TransportationTypeResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const TrialCloseChecklistItem_possibleTypes: string[] = ['TrialCloseChecklistItem']
    export const isTrialCloseChecklistItem = (obj?: { __typename?: any } | null): obj is TrialCloseChecklistItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTrialCloseChecklistItem"')
      return TrialCloseChecklistItem_possibleTypes.includes(obj.__typename)
    }
    


    const TriggerConfig_possibleTypes: string[] = ['BusinessEventTriggerConfigOutput','HttpWebhookTriggerConfigOutput','ScheduleTriggerConfigOutput']
    export const isTriggerConfig = (obj?: { __typename?: any } | null): obj is TriggerConfig => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTriggerConfig"')
      return TriggerConfig_possibleTypes.includes(obj.__typename)
    }
    


    const Truck_possibleTypes: string[] = ['Truck']
    export const isTruck = (obj?: { __typename?: any } | null): obj is Truck => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTruck"')
      return Truck_possibleTypes.includes(obj.__typename)
    }
    


    const TruckLocationHistory_possibleTypes: string[] = ['TruckLocationHistory']
    export const isTruckLocationHistory = (obj?: { __typename?: any } | null): obj is TruckLocationHistory => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTruckLocationHistory"')
      return TruckLocationHistory_possibleTypes.includes(obj.__typename)
    }
    


    const TruckResultPage_possibleTypes: string[] = ['TruckResultPage']
    export const isTruckResultPage = (obj?: { __typename?: any } | null): obj is TruckResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isTruckResultPage"')
      return TruckResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const UnappliedAdvanceBalance_possibleTypes: string[] = ['UnappliedAdvanceBalance']
    export const isUnappliedAdvanceBalance = (obj?: { __typename?: any } | null): obj is UnappliedAdvanceBalance => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnappliedAdvanceBalance"')
      return UnappliedAdvanceBalance_possibleTypes.includes(obj.__typename)
    }
    


    const UnitPriceFormula_possibleTypes: string[] = ['UnitPriceFormula']
    export const isUnitPriceFormula = (obj?: { __typename?: any } | null): obj is UnitPriceFormula => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnitPriceFormula"')
      return UnitPriceFormula_possibleTypes.includes(obj.__typename)
    }
    


    const UnshareFilePayload_possibleTypes: string[] = ['UnshareFilePayload']
    export const isUnshareFilePayload = (obj?: { __typename?: any } | null): obj is UnshareFilePayload => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUnshareFilePayload"')
      return UnshareFilePayload_possibleTypes.includes(obj.__typename)
    }
    


    const UsageMetricsAggregation_possibleTypes: string[] = ['UsageMetricsAggregation']
    export const isUsageMetricsAggregation = (obj?: { __typename?: any } | null): obj is UsageMetricsAggregation => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUsageMetricsAggregation"')
      return UsageMetricsAggregation_possibleTypes.includes(obj.__typename)
    }
    


    const UsageMetricsResultPage_possibleTypes: string[] = ['UsageMetricsResultPage']
    export const isUsageMetricsResultPage = (obj?: { __typename?: any } | null): obj is UsageMetricsResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUsageMetricsResultPage"')
      return UsageMetricsResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const User_possibleTypes: string[] = ['User']
    export const isUser = (obj?: { __typename?: any } | null): obj is User => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUser"')
      return User_possibleTypes.includes(obj.__typename)
    }
    


    const UserContact_possibleTypes: string[] = ['UserContact']
    export const isUserContact = (obj?: { __typename?: any } | null): obj is UserContact => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserContact"')
      return UserContact_possibleTypes.includes(obj.__typename)
    }
    


    const UserContactsListResult_possibleTypes: string[] = ['UserContactsListResult']
    export const isUserContactsListResult = (obj?: { __typename?: any } | null): obj is UserContactsListResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserContactsListResult"')
      return UserContactsListResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserInvitationAcceptResult_possibleTypes: string[] = ['InvalidUserInvitationError','UserInvitationAcceptedResult']
    export const isUserInvitationAcceptResult = (obj?: { __typename?: any } | null): obj is UserInvitationAcceptResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserInvitationAcceptResult"')
      return UserInvitationAcceptResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserInvitationAcceptedResult_possibleTypes: string[] = ['UserInvitationAcceptedResult']
    export const isUserInvitationAcceptedResult = (obj?: { __typename?: any } | null): obj is UserInvitationAcceptedResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserInvitationAcceptedResult"')
      return UserInvitationAcceptedResult_possibleTypes.includes(obj.__typename)
    }
    


    const UserPreferences_possibleTypes: string[] = ['UserPreferences']
    export const isUserPreferences = (obj?: { __typename?: any } | null): obj is UserPreferences => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserPreferences"')
      return UserPreferences_possibleTypes.includes(obj.__typename)
    }
    


    const UserResultPage_possibleTypes: string[] = ['UserResultPage']
    export const isUserResultPage = (obj?: { __typename?: any } | null): obj is UserResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserResultPage"')
      return UserResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const UserRoleAssignment_possibleTypes: string[] = ['UserRoleAssignment']
    export const isUserRoleAssignment = (obj?: { __typename?: any } | null): obj is UserRoleAssignment => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserRoleAssignment"')
      return UserRoleAssignment_possibleTypes.includes(obj.__typename)
    }
    


    const UserRoleAssignmentResultPage_possibleTypes: string[] = ['UserRoleAssignmentResultPage']
    export const isUserRoleAssignmentResultPage = (obj?: { __typename?: any } | null): obj is UserRoleAssignmentResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isUserRoleAssignmentResultPage"')
      return UserRoleAssignmentResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ValidationIssue_possibleTypes: string[] = ['ValidationIssue']
    export const isValidationIssue = (obj?: { __typename?: any } | null): obj is ValidationIssue => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isValidationIssue"')
      return ValidationIssue_possibleTypes.includes(obj.__typename)
    }
    


    const Variable_possibleTypes: string[] = ['Variable']
    export const isVariable = (obj?: { __typename?: any } | null): obj is Variable => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVariable"')
      return Variable_possibleTypes.includes(obj.__typename)
    }
    


    const VariableResultPage_possibleTypes: string[] = ['VariableResultPage']
    export const isVariableResultPage = (obj?: { __typename?: any } | null): obj is VariableResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVariableResultPage"')
      return VariableResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const VariableUpdateResult_possibleTypes: string[] = ['VariableUpdateResult']
    export const isVariableUpdateResult = (obj?: { __typename?: any } | null): obj is VariableUpdateResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVariableUpdateResult"')
      return VariableUpdateResult_possibleTypes.includes(obj.__typename)
    }
    


    const VariableValidationError_possibleTypes: string[] = ['VariableValidationError']
    export const isVariableValidationError = (obj?: { __typename?: any } | null): obj is VariableValidationError => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVariableValidationError"')
      return VariableValidationError_possibleTypes.includes(obj.__typename)
    }
    


    const VoidBookingItemResult_possibleTypes: string[] = ['VoidBookingItemResult']
    export const isVoidBookingItemResult = (obj?: { __typename?: any } | null): obj is VoidBookingItemResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoidBookingItemResult"')
      return VoidBookingItemResult_possibleTypes.includes(obj.__typename)
    }
    


    const VoidBookingResult_possibleTypes: string[] = ['VoidBookingResult']
    export const isVoidBookingResult = (obj?: { __typename?: any } | null): obj is VoidBookingResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoidBookingResult"')
      return VoidBookingResult_possibleTypes.includes(obj.__typename)
    }
    


    const VoidSalesOrderItemResult_possibleTypes: string[] = ['VoidSalesOrderItemResult']
    export const isVoidSalesOrderItemResult = (obj?: { __typename?: any } | null): obj is VoidSalesOrderItemResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoidSalesOrderItemResult"')
      return VoidSalesOrderItemResult_possibleTypes.includes(obj.__typename)
    }
    


    const VoidSalesOrderResult_possibleTypes: string[] = ['VoidSalesOrderResult']
    export const isVoidSalesOrderResult = (obj?: { __typename?: any } | null): obj is VoidSalesOrderResult => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoidSalesOrderResult"')
      return VoidSalesOrderResult_possibleTypes.includes(obj.__typename)
    }
    


    const VoucherTemplate_possibleTypes: string[] = ['VoucherTemplate']
    export const isVoucherTemplate = (obj?: { __typename?: any } | null): obj is VoucherTemplate => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoucherTemplate"')
      return VoucherTemplate_possibleTypes.includes(obj.__typename)
    }
    


    const VoucherTemplateResultPage_possibleTypes: string[] = ['VoucherTemplateResultPage']
    export const isVoucherTemplateResultPage = (obj?: { __typename?: any } | null): obj is VoucherTemplateResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isVoucherTemplateResultPage"')
      return VoucherTemplateResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const WOPIDiscoveryInfo_possibleTypes: string[] = ['WOPIDiscoveryInfo']
    export const isWOPIDiscoveryInfo = (obj?: { __typename?: any } | null): obj is WOPIDiscoveryInfo => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWOPIDiscoveryInfo"')
      return WOPIDiscoveryInfo_possibleTypes.includes(obj.__typename)
    }
    


    const WOPIEditingSession_possibleTypes: string[] = ['WOPIEditingSession']
    export const isWOPIEditingSession = (obj?: { __typename?: any } | null): obj is WOPIEditingSession => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWOPIEditingSession"')
      return WOPIEditingSession_possibleTypes.includes(obj.__typename)
    }
    


    const WOPISupportedFileType_possibleTypes: string[] = ['WOPISupportedFileType']
    export const isWOPISupportedFileType = (obj?: { __typename?: any } | null): obj is WOPISupportedFileType => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWOPISupportedFileType"')
      return WOPISupportedFileType_possibleTypes.includes(obj.__typename)
    }
    


    const WOPIToken_possibleTypes: string[] = ['WOPIToken']
    export const isWOPIToken = (obj?: { __typename?: any } | null): obj is WOPIToken => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWOPIToken"')
      return WOPIToken_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseCredential_possibleTypes: string[] = ['WarehouseCredential']
    export const isWarehouseCredential = (obj?: { __typename?: any } | null): obj is WarehouseCredential => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseCredential"')
      return WarehouseCredential_possibleTypes.includes(obj.__typename)
    }
    


    const WarehouseCredentialResultPage_possibleTypes: string[] = ['WarehouseCredentialResultPage']
    export const isWarehouseCredentialResultPage = (obj?: { __typename?: any } | null): obj is WarehouseCredentialResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWarehouseCredentialResultPage"')
      return WarehouseCredentialResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const WebhookEndpoint_possibleTypes: string[] = ['WebhookEndpoint']
    export const isWebhookEndpoint = (obj?: { __typename?: any } | null): obj is WebhookEndpoint => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWebhookEndpoint"')
      return WebhookEndpoint_possibleTypes.includes(obj.__typename)
    }
    


    const Weight_possibleTypes: string[] = ['Weight']
    export const isWeight = (obj?: { __typename?: any } | null): obj is Weight => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWeight"')
      return Weight_possibleTypes.includes(obj.__typename)
    }
    


    const WorkOrder_possibleTypes: string[] = ['WorkOrder']
    export const isWorkOrder = (obj?: { __typename?: any } | null): obj is WorkOrder => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorkOrder"')
      return WorkOrder_possibleTypes.includes(obj.__typename)
    }
    


    const WorkOrderInputItem_possibleTypes: string[] = ['WorkOrderInputItem']
    export const isWorkOrderInputItem = (obj?: { __typename?: any } | null): obj is WorkOrderInputItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorkOrderInputItem"')
      return WorkOrderInputItem_possibleTypes.includes(obj.__typename)
    }
    


    const WorkOrderInputItemResultPage_possibleTypes: string[] = ['WorkOrderInputItemResultPage']
    export const isWorkOrderInputItemResultPage = (obj?: { __typename?: any } | null): obj is WorkOrderInputItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorkOrderInputItemResultPage"')
      return WorkOrderInputItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const WorkOrderOutputItem_possibleTypes: string[] = ['WorkOrderOutputItem']
    export const isWorkOrderOutputItem = (obj?: { __typename?: any } | null): obj is WorkOrderOutputItem => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorkOrderOutputItem"')
      return WorkOrderOutputItem_possibleTypes.includes(obj.__typename)
    }
    


    const WorkOrderOutputItemResultPage_possibleTypes: string[] = ['WorkOrderOutputItemResultPage']
    export const isWorkOrderOutputItemResultPage = (obj?: { __typename?: any } | null): obj is WorkOrderOutputItemResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorkOrderOutputItemResultPage"')
      return WorkOrderOutputItemResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const WorkOrderResultPage_possibleTypes: string[] = ['WorkOrderResultPage']
    export const isWorkOrderResultPage = (obj?: { __typename?: any } | null): obj is WorkOrderResultPage => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isWorkOrderResultPage"')
      return WorkOrderResultPage_possibleTypes.includes(obj.__typename)
    }
    


    const ZoneUtilization_possibleTypes: string[] = ['ZoneUtilization']
    export const isZoneUtilization = (obj?: { __typename?: any } | null): obj is ZoneUtilization => {
      if (!obj?.__typename) throw new Error('__typename is missing in "isZoneUtilization"')
      return ZoneUtilization_possibleTypes.includes(obj.__typename)
    }
    

export const enumAccountAddressSortOption = {
   CityAsc: 'CityAsc' as const,
   CityDesc: 'CityDesc' as const,
   CountryAsc: 'CountryAsc' as const,
   CountryDesc: 'CountryDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   IsMailingAsc: 'IsMailingAsc' as const,
   IsMailingDesc: 'IsMailingDesc' as const,
   LocationTypeAsc: 'LocationTypeAsc' as const,
   LocationTypeDesc: 'LocationTypeDesc' as const,
   StateAsc: 'StateAsc' as const,
   StateDesc: 'StateDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAccountBankDetailSortOption = {
   BankNameAsc: 'BankNameAsc' as const,
   BankNameDesc: 'BankNameDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumAccountIdentityDocumentSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DocumentTypeAsc: 'DocumentTypeAsc' as const,
   DocumentTypeDesc: 'DocumentTypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAccountIndividualDetailsSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAccountSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EmailAsc: 'EmailAsc' as const,
   EmailDesc: 'EmailDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAccountType = {
   Commercial: 'Commercial' as const,
   Individual: 'Individual' as const
}

export const enumActionType = {
   Delivery: 'Delivery' as const,
   Maintenance: 'Maintenance' as const,
   Pickup: 'Pickup' as const,
   Transfer: 'Transfer' as const
}

export const enumAddressLocationType = {
   Billing: 'Billing' as const,
   Delivery: 'Delivery' as const,
   Pickup: 'Pickup' as const,
   Shipping: 'Shipping' as const,
   Warehouse: 'Warehouse' as const
}

export const enumAddressType = {
   NonStandard: 'NonStandard' as const,
   POBox: 'POBox' as const,
   Standard: 'Standard' as const
}

export const enumAgentSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   VersionAsc: 'VersionAsc' as const,
   VersionDesc: 'VersionDesc' as const
}

export const enumAgentType = {
   Agent: 'Agent' as const,
   FileProcessor: 'FileProcessor' as const,
   SubAgent: 'SubAgent' as const
}

export const enumApprovalRequestSortOption = {
   ExpiresAtAsc: 'ExpiresAtAsc' as const,
   ExpiresAtDesc: 'ExpiresAtDesc' as const,
   RequestedAtAsc: 'RequestedAtAsc' as const,
   RequestedAtDesc: 'RequestedAtDesc' as const
}

export const enumApprovalRequestStatus = {
   Approved: 'Approved' as const,
   Expired: 'Expired' as const,
   Pending: 'Pending' as const,
   Rejected: 'Rejected' as const
}

export const enumAssetFillState = {
   Empty: 'Empty' as const,
   Full: 'Full' as const,
   Unknown: 'Unknown' as const
}

export const enumAssetLocationHistorySortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   SourceAsc: 'SourceAsc' as const,
   SourceDesc: 'SourceDesc' as const,
   TimestampAsc: 'TimestampAsc' as const,
   TimestampDesc: 'TimestampDesc' as const
}

export const enumAssetSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   FillStateAsc: 'FillStateAsc' as const,
   FillStateDesc: 'FillStateDesc' as const,
   IdentifierAsc: 'IdentifierAsc' as const,
   IdentifierDesc: 'IdentifierDesc' as const,
   LastLocationTimeAsc: 'LastLocationTimeAsc' as const,
   LastLocationTimeDesc: 'LastLocationTimeDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAssetStatus = {
   Deployed: 'Deployed' as const,
   InTransit: 'InTransit' as const,
   Inventory: 'Inventory' as const,
   OutOfOrder: 'OutOfOrder' as const
}

export const enumAssetTypeSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAssignmentStatus = {
   Accepted: 'Accepted' as const,
   Offered: 'Offered' as const,
   Rejected: 'Rejected' as const,
   Released: 'Released' as const,
   Unassigned: 'Unassigned' as const
}

export const enumAssistantAgentStreamEventType = {
   Complete: 'Complete' as const,
   ConversationTitle: 'ConversationTitle' as const,
   Error: 'Error' as const,
   Message: 'Message' as const,
   Thinking: 'Thinking' as const,
   ToolCall: 'ToolCall' as const,
   ToolResult: 'ToolResult' as const
}

export const enumAssistantAggregateType = {
   Chat: 'Chat' as const,
   ChatMessage: 'ChatMessage' as const
}

export const enumAssistantChatMessagePartType = {
   Data: 'Data' as const,
   DynamicTool: 'DynamicTool' as const,
   File: 'File' as const,
   Reasoning: 'Reasoning' as const,
   SourceDocument: 'SourceDocument' as const,
   SourceUrl: 'SourceUrl' as const,
   StepStart: 'StepStart' as const,
   Text: 'Text' as const,
   ToolCall: 'ToolCall' as const
}

export const enumAssistantChatMessageRole = {
   Assistant: 'Assistant' as const,
   System: 'System' as const,
   User: 'User' as const
}

export const enumAssistantChatSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   CreatedByAsc: 'CreatedByAsc' as const,
   CreatedByDesc: 'CreatedByDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   UpdatedByAsc: 'UpdatedByAsc' as const,
   UpdatedByDesc: 'UpdatedByDesc' as const
}

export const enumAssistantChatStatus = {
   Active: 'Active' as const,
   Archived: 'Archived' as const
}

export const enumAssistantToolCallState = {
   InputAvailable: 'InputAvailable' as const,
   InputStreaming: 'InputStreaming' as const,
   OutputAvailable: 'OutputAvailable' as const,
   OutputError: 'OutputError' as const
}

export const enumAttachmentType = {
   Image: 'Image' as const,
   Pdf: 'Pdf' as const,
   Text: 'Text' as const
}

export const enumAutomationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumAutomationStatus = {
   Active: 'Active' as const,
   Archived: 'Archived' as const,
   Draft: 'Draft' as const,
   Paused: 'Paused' as const
}

export const enumAutomationVersionSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   VersionNumberAsc: 'VersionNumberAsc' as const,
   VersionNumberDesc: 'VersionNumberDesc' as const
}

export const enumBillComplianceRule = {
   LegalHold: 'LegalHold' as const,
   TaxHold: 'TaxHold' as const
}

export const enumBillEntityReferenceType = {
   Booking: 'Booking' as const,
   InboundLoad: 'InboundLoad' as const,
   InboundLoadLineItem: 'InboundLoadLineItem' as const,
   TicketFreight: 'TicketFreight' as const
}

export const enumBillSortOption = {
   AccountAsc: 'AccountAsc' as const,
   AccountDesc: 'AccountDesc' as const,
   AmountAsc: 'AmountAsc' as const,
   AmountDesc: 'AmountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DocumentDateAsc: 'DocumentDateAsc' as const,
   DocumentDateDesc: 'DocumentDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumBillStatus = {
   Paid: 'Paid' as const,
   Pending: 'Pending' as const,
   Voided: 'Voided' as const
}

export const enumBillType = {
   Accrual: 'Accrual' as const,
   FreightBill: 'FreightBill' as const,
   InboundBill: 'InboundBill' as const,
   OutboundBill: 'OutboundBill' as const
}

export const enumBookingSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   CreatedByAsc: 'CreatedByAsc' as const,
   CreatedByDesc: 'CreatedByDesc' as const,
   CutOffDateAsc: 'CutOffDateAsc' as const,
   CutOffDateDesc: 'CutOffDateDesc' as const,
   DocumentNumberAsc: 'DocumentNumberAsc' as const,
   DocumentNumberDesc: 'DocumentNumberDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   UpdatedByAsc: 'UpdatedByAsc' as const,
   UpdatedByDesc: 'UpdatedByDesc' as const,
   VesselDepartureDateAsc: 'VesselDepartureDateAsc' as const,
   VesselDepartureDateDesc: 'VesselDepartureDateDesc' as const
}

export const enumBookingStatus = {
   Completed: 'Completed' as const,
   Draft: 'Draft' as const,
   Open: 'Open' as const,
   Shipped: 'Shipped' as const,
   Voided: 'Voided' as const
}

export const enumBrokeredOrderLineItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumBrokeredOrderSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   OrderNumberAsc: 'OrderNumberAsc' as const,
   OrderNumberDesc: 'OrderNumberDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumBrokeredOrderStatus = {
   Closed: 'Closed' as const,
   Draft: 'Draft' as const,
   Fulfilled: 'Fulfilled' as const,
   InProgress: 'InProgress' as const,
   Open: 'Open' as const,
   Voided: 'Voided' as const
}

export const enumCalculationDirection = {
   FromInputs: 'FromInputs' as const,
   FromOutputs: 'FromOutputs' as const
}

export const enumCameraSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DriverTypeAsc: 'DriverTypeAsc' as const,
   DriverTypeDesc: 'DriverTypeDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumCameraStatus = {
   Configured: 'Configured' as const,
   Discovered: 'Discovered' as const
}

export const enumCategorySortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DescriptionAsc: 'DescriptionAsc' as const,
   DescriptionDesc: 'DescriptionDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumCheckTemplateSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumComplianceCheckSortOption = {
   CheckedAtAsc: 'CheckedAtAsc' as const,
   CheckedAtDesc: 'CheckedAtDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumComplianceCheckStatus = {
   Failed: 'Failed' as const,
   Overridden: 'Overridden' as const,
   Passed: 'Passed' as const,
   Warning: 'Warning' as const
}

export const enumComplianceDispatchImageSortOption = {
   CategoryAsc: 'CategoryAsc' as const,
   CategoryDesc: 'CategoryDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumComplianceDispatchRecordSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   SubmittedAtAsc: 'SubmittedAtAsc' as const,
   SubmittedAtDesc: 'SubmittedAtDesc' as const
}

export const enumComplianceEnforcementLevel = {
   Informational: 'Informational' as const,
   Required: 'Required' as const,
   Warning: 'Warning' as const
}

export const enumComplianceFacilityRuleSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumComplianceHoldExemptionReason = {
   FrequentSeller: 'FrequentSeller' as const,
   ManuallyChecked: 'ManuallyChecked' as const,
   None: 'None' as const,
   SmallTransaction: 'SmallTransaction' as const
}

export const enumComplianceHoldSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   HoldEndAsc: 'HoldEndAsc' as const,
   HoldEndDesc: 'HoldEndDesc' as const,
   HoldStartAsc: 'HoldStartAsc' as const,
   HoldStartDesc: 'HoldStartDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumComplianceHoldStatus = {
   Active: 'Active' as const,
   Extended: 'Extended' as const,
   PoliceFlagged: 'PoliceFlagged' as const,
   Released: 'Released' as const
}

export const enumComplianceItemJurisdictionCodeSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumComplianceRuleAppliesTo = {
   Facility: 'Facility' as const,
   Item: 'Item' as const,
   Supplier: 'Supplier' as const,
   Transaction: 'Transaction' as const,
   Vehicle: 'Vehicle' as const
}

export const enumComplianceRuleCategory = {
   CatalyticConverterVehicle: 'CatalyticConverterVehicle' as const,
   CustomForm: 'CustomForm' as const,
   EnvironmentalPermit: 'EnvironmentalPermit' as const,
   IDThreshold: 'IDThreshold' as const,
   ItemRestriction: 'ItemRestriction' as const,
   JurisdictionSpecific: 'JurisdictionSpecific' as const,
   LawEnforcement: 'LawEnforcement' as const,
   PaymentRestriction: 'PaymentRestriction' as const,
   PhotoSignature: 'PhotoSignature' as const,
   RecordRetention: 'RecordRetention' as const,
   SellerIdentification: 'SellerIdentification' as const,
   TransactionLimit: 'TransactionLimit' as const,
   VehicleDocumentation: 'VehicleDocumentation' as const
}

export const enumComplianceRuleDataType = {
   Boolean: 'Boolean' as const,
   Decimal: 'Decimal' as const,
   Duration: 'Duration' as const,
   Integer: 'Integer' as const,
   Money: 'Money' as const,
   Select: 'Select' as const,
   String: 'String' as const,
   Weight: 'Weight' as const
}

export const enumComplianceRuleDefinitionSortOption = {
   CategoryAsc: 'CategoryAsc' as const,
   CategoryDesc: 'CategoryDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   RuleCodeAsc: 'RuleCodeAsc' as const,
   RuleCodeDesc: 'RuleCodeDesc' as const
}

export const enumContactSortOption = {
   AddressAsAsc: 'AddressAsAsc' as const,
   AddressAsDesc: 'AddressAsDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EmailAsc: 'EmailAsc' as const,
   EmailDesc: 'EmailDesc' as const,
   FullNameAsc: 'FullNameAsc' as const,
   FullNameDesc: 'FullNameDesc' as const,
   IsPrimaryAsc: 'IsPrimaryAsc' as const,
   IsPrimaryDesc: 'IsPrimaryDesc' as const,
   RoleAsc: 'RoleAsc' as const,
   RoleDesc: 'RoleDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumContactType = {
   external: 'external' as const,
   internal: 'internal' as const
}

export const enumContainerSortOption = {
   ArrivedAtFacilityAsc: 'ArrivedAtFacilityAsc' as const,
   ArrivedAtFacilityDesc: 'ArrivedAtFacilityDesc' as const,
   ContainerNumberAsc: 'ContainerNumberAsc' as const,
   ContainerNumberDesc: 'ContainerNumberDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   PickedUpAtAsc: 'PickedUpAtAsc' as const,
   PickedUpAtDesc: 'PickedUpAtDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumContainerStatus = {
   AtFacilityEmpty: 'AtFacilityEmpty' as const,
   AtFacilityLoaded: 'AtFacilityLoaded' as const,
   AtPort: 'AtPort' as const,
   AtPortReadyToShip: 'AtPortReadyToShip' as const,
   InTransitToFacility: 'InTransitToFacility' as const,
   InTransitToPort: 'InTransitToPort' as const,
   Shipped: 'Shipped' as const,
   Voided: 'Voided' as const
}

export const enumContainerTypeSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumCoreAggregateType = {
   Facility: 'Facility' as const,
   FacilityGroup: 'FacilityGroup' as const,
   Organization: 'Organization' as const,
   User: 'User' as const
}

export const enumCounterpartyGroupMemberSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumCounterpartyGroupSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   OperationTypeAsc: 'OperationTypeAsc' as const,
   OperationTypeDesc: 'OperationTypeDesc' as const
}

export const enumCreatorPlatform = {
   Kiosk: 'Kiosk' as const,
   Mobile: 'Mobile' as const,
   Tablet: 'Tablet' as const,
   Unknown: 'Unknown' as const,
   Web: 'Web' as const
}

export const enumCrmAggregateType = {
   Account: 'Account' as const,
   AccountAddress: 'AccountAddress' as const,
   Contact: 'Contact' as const,
   CustomerInvitation: 'CustomerInvitation' as const
}

export const enumCurrencyCode = {
   AED: 'AED' as const,
   AFN: 'AFN' as const,
   ALL: 'ALL' as const,
   AMD: 'AMD' as const,
   ANG: 'ANG' as const,
   AOA: 'AOA' as const,
   ARS: 'ARS' as const,
   AUD: 'AUD' as const,
   AWG: 'AWG' as const,
   AZN: 'AZN' as const,
   BAM: 'BAM' as const,
   BBD: 'BBD' as const,
   BDT: 'BDT' as const,
   BGN: 'BGN' as const,
   BHD: 'BHD' as const,
   BIF: 'BIF' as const,
   BMD: 'BMD' as const,
   BND: 'BND' as const,
   BOB: 'BOB' as const,
   BRL: 'BRL' as const,
   BSD: 'BSD' as const,
   BTN: 'BTN' as const,
   BWP: 'BWP' as const,
   BYN: 'BYN' as const,
   BZD: 'BZD' as const,
   CAD: 'CAD' as const,
   CDF: 'CDF' as const,
   CHF: 'CHF' as const,
   CLP: 'CLP' as const,
   CNY: 'CNY' as const,
   COP: 'COP' as const,
   CRC: 'CRC' as const,
   CUC: 'CUC' as const,
   CUP: 'CUP' as const,
   CVE: 'CVE' as const,
   CZK: 'CZK' as const,
   DJF: 'DJF' as const,
   DKK: 'DKK' as const,
   DOP: 'DOP' as const,
   DZD: 'DZD' as const,
   EGP: 'EGP' as const,
   ERN: 'ERN' as const,
   ETB: 'ETB' as const,
   EUR: 'EUR' as const,
   FJD: 'FJD' as const,
   FKP: 'FKP' as const,
   GBP: 'GBP' as const,
   GEL: 'GEL' as const,
   GHS: 'GHS' as const,
   GIP: 'GIP' as const,
   GMD: 'GMD' as const,
   GNF: 'GNF' as const,
   GTQ: 'GTQ' as const,
   GYD: 'GYD' as const,
   HKD: 'HKD' as const,
   HNL: 'HNL' as const,
   HRK: 'HRK' as const,
   HTG: 'HTG' as const,
   HUF: 'HUF' as const,
   IDR: 'IDR' as const,
   ILS: 'ILS' as const,
   INR: 'INR' as const,
   IQD: 'IQD' as const,
   IRR: 'IRR' as const,
   ISK: 'ISK' as const,
   JMD: 'JMD' as const,
   JOD: 'JOD' as const,
   JPY: 'JPY' as const,
   KES: 'KES' as const,
   KGS: 'KGS' as const,
   KHR: 'KHR' as const,
   KMF: 'KMF' as const,
   KPW: 'KPW' as const,
   KRW: 'KRW' as const,
   KWD: 'KWD' as const,
   KYD: 'KYD' as const,
   KZT: 'KZT' as const,
   LAK: 'LAK' as const,
   LBP: 'LBP' as const,
   LKR: 'LKR' as const,
   LRD: 'LRD' as const,
   LSL: 'LSL' as const,
   LYD: 'LYD' as const,
   MAD: 'MAD' as const,
   MDL: 'MDL' as const,
   MGA: 'MGA' as const,
   MKD: 'MKD' as const,
   MMK: 'MMK' as const,
   MNT: 'MNT' as const,
   MOP: 'MOP' as const,
   MRU: 'MRU' as const,
   MUR: 'MUR' as const,
   MVR: 'MVR' as const,
   MWK: 'MWK' as const,
   MXN: 'MXN' as const,
   MYR: 'MYR' as const,
   MZN: 'MZN' as const,
   NAD: 'NAD' as const,
   NEUTRAL: 'NEUTRAL' as const,
   NGN: 'NGN' as const,
   NIO: 'NIO' as const,
   NOK: 'NOK' as const,
   NPR: 'NPR' as const,
   NZD: 'NZD' as const,
   OMR: 'OMR' as const,
   PAB: 'PAB' as const,
   PEN: 'PEN' as const,
   PGK: 'PGK' as const,
   PHP: 'PHP' as const,
   PKR: 'PKR' as const,
   PLN: 'PLN' as const,
   PYG: 'PYG' as const,
   QAR: 'QAR' as const,
   RON: 'RON' as const,
   RSD: 'RSD' as const,
   RUB: 'RUB' as const,
   RWF: 'RWF' as const,
   SAR: 'SAR' as const,
   SBD: 'SBD' as const,
   SCR: 'SCR' as const,
   SDG: 'SDG' as const,
   SEK: 'SEK' as const,
   SGD: 'SGD' as const,
   SHP: 'SHP' as const,
   SLL: 'SLL' as const,
   SOS: 'SOS' as const,
   SRD: 'SRD' as const,
   SSP: 'SSP' as const,
   STN: 'STN' as const,
   SVC: 'SVC' as const,
   SYP: 'SYP' as const,
   SZL: 'SZL' as const,
   THB: 'THB' as const,
   TJS: 'TJS' as const,
   TMT: 'TMT' as const,
   TND: 'TND' as const,
   TOP: 'TOP' as const,
   TRY: 'TRY' as const,
   TTD: 'TTD' as const,
   TWD: 'TWD' as const,
   TZS: 'TZS' as const,
   UAH: 'UAH' as const,
   UGX: 'UGX' as const,
   USD: 'USD' as const,
   UYU: 'UYU' as const,
   UZS: 'UZS' as const,
   VES: 'VES' as const,
   VND: 'VND' as const,
   VUV: 'VUV' as const,
   WST: 'WST' as const,
   XAF: 'XAF' as const,
   XCD: 'XCD' as const,
   XOF: 'XOF' as const,
   XPF: 'XPF' as const,
   YER: 'YER' as const,
   ZAR: 'ZAR' as const,
   ZMW: 'ZMW' as const,
   ZWL: 'ZWL' as const
}

export const enumCustomAttributeEntityType = {
   CRMAccount: 'CRMAccount' as const,
   CRMAccountAddress: 'CRMAccountAddress' as const,
   CRMContact: 'CRMContact' as const,
   CoreFacility: 'CoreFacility' as const,
   CoreFacilityGroup: 'CoreFacilityGroup' as const,
   CoreOrganization: 'CoreOrganization' as const,
   CoreUser: 'CoreUser' as const,
   FilesFile: 'FilesFile' as const,
   FinanceFinancialAccount: 'FinanceFinancialAccount' as const,
   InventoryCategory: 'InventoryCategory' as const,
   InventoryItem: 'InventoryItem' as const,
   InventoryItemGroup: 'InventoryItemGroup' as const,
   InventoryTag: 'InventoryTag' as const,
   SalesSalesOrder: 'SalesSalesOrder' as const
}

export const enumCustomPriceListSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   OperationTypeAsc: 'OperationTypeAsc' as const,
   OperationTypeDesc: 'OperationTypeDesc' as const
}

export const enumCustomerInvitationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EmailAsc: 'EmailAsc' as const,
   EmailDesc: 'EmailDesc' as const,
   ExpiresAtAsc: 'ExpiresAtAsc' as const,
   ExpiresAtDesc: 'ExpiresAtDesc' as const,
   SentAtAsc: 'SentAtAsc' as const,
   SentAtDesc: 'SentAtDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumCycleCountFrequency = {
   Annually: 'Annually' as const,
   Daily: 'Daily' as const,
   Monthly: 'Monthly' as const,
   Quarterly: 'Quarterly' as const,
   Weekly: 'Weekly' as const
}

export const enumCycleCountLineSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumCycleCountScheduleSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   FrequencyAsc: 'FrequencyAsc' as const,
   FrequencyDesc: 'FrequencyDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumCycleCountScopeType = {
   Abc: 'Abc' as const,
   Category: 'Category' as const,
   Full: 'Full' as const,
   Value: 'Value' as const,
   Zone: 'Zone' as const
}

export const enumCycleCountTaskSortOption = {
   CountTypeAsc: 'CountTypeAsc' as const,
   CountTypeDesc: 'CountTypeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DueDateAsc: 'DueDateAsc' as const,
   DueDateDesc: 'DueDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   TaskNumberAsc: 'TaskNumberAsc' as const,
   TaskNumberDesc: 'TaskNumberDesc' as const
}

export const enumDeductionApplicationType = {
   Price: 'Price' as const,
   Weight: 'Weight' as const
}

export const enumDeductionTypeSortOption = {
   ApplicationTypeAsc: 'ApplicationTypeAsc' as const,
   ApplicationTypeDesc: 'ApplicationTypeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumDefaultPriceListSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumDelayType = {
   fixed: 'fixed' as const,
   until: 'until' as const
}

export const enumDetentionSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   StartDateAsc: 'StartDateAsc' as const,
   StartDateDesc: 'StartDateDesc' as const
}

export const enumDispatchErrorType = {
   Credentials: 'Credentials' as const,
   None: 'None' as const,
   RateLimit: 'RateLimit' as const,
   Timeout: 'Timeout' as const,
   Unknown: 'Unknown' as const,
   Validation: 'Validation' as const
}

export const enumDispatchImageCategory = {
   IDBack: 'IDBack' as const,
   IDFront: 'IDFront' as const,
   ItemPhoto: 'ItemPhoto' as const,
   ScaleTicket: 'ScaleTicket' as const,
   Signature: 'Signature' as const,
   SupplierPhoto: 'SupplierPhoto' as const,
   VehiclePhoto: 'VehiclePhoto' as const,
   VehicleTitle: 'VehicleTitle' as const
}

export const enumDispatchImageStatus = {
   Failed: 'Failed' as const,
   Pending: 'Pending' as const,
   Uploaded: 'Uploaded' as const
}

export const enumDispatchRecordStatus = {
   Failed: 'Failed' as const,
   NotReported: 'NotReported' as const,
   Processing: 'Processing' as const,
   Queued: 'Queued' as const,
   Submitted: 'Submitted' as const
}

export const enumDoNotBuyEntrySortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EffectiveFromAsc: 'EffectiveFromAsc' as const,
   EffectiveFromDesc: 'EffectiveFromDesc' as const
}

export const enumDoNotBuyOriginType = {
   Automated: 'Automated' as const,
   LawEnforcement: 'LawEnforcement' as const,
   Manual: 'Manual' as const
}

export const enumDoNotBuyStatus = {
   Active: 'Active' as const,
   Expired: 'Expired' as const,
   Removed: 'Removed' as const
}

export const enumDocumentType = {
   BillOfLading: 'BillOfLading' as const,
   BookingInvoice: 'BookingInvoice' as const,
   FullPageScaleTicket: 'FullPageScaleTicket' as const,
   FullPageWeightTicket: 'FullPageWeightTicket' as const,
   Invoice: 'Invoice' as const,
   LoadInvoice: 'LoadInvoice' as const,
   OutboundScaleTicket: 'OutboundScaleTicket' as const,
   PackingList: 'PackingList' as const,
   PurchaseOrder: 'PurchaseOrder' as const,
   SalesOrder: 'SalesOrder' as const,
   ShippingSummary: 'ShippingSummary' as const,
   ThermalScaleTicket: 'ThermalScaleTicket' as const,
   ThermalWeightTicket: 'ThermalWeightTicket' as const,
   WeightTicket: 'WeightTicket' as const
}

export const enumDriverCertificationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   ExpirationDateAsc: 'ExpirationDateAsc' as const,
   ExpirationDateDesc: 'ExpirationDateDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const
}

export const enumDriverDisplayOrderSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   RankAsc: 'RankAsc' as const,
   RankDesc: 'RankDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumDriverProgress = {
   Completed: 'Completed' as const,
   EnRoute: 'EnRoute' as const,
   Failed: 'Failed' as const,
   NotStarted: 'NotStarted' as const,
   OnSite: 'OnSite' as const
}

export const enumDriverSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   FirstNameAsc: 'FirstNameAsc' as const,
   FirstNameDesc: 'FirstNameDesc' as const,
   LastLocationTimeAsc: 'LastLocationTimeAsc' as const,
   LastLocationTimeDesc: 'LastLocationTimeDesc' as const,
   LastNameAsc: 'LastNameAsc' as const,
   LastNameDesc: 'LastNameDesc' as const,
   LicenseExpirationAsc: 'LicenseExpirationAsc' as const,
   LicenseExpirationDesc: 'LicenseExpirationDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumDriverStatus = {
   Available: 'Available' as const,
   Inactive: 'Inactive' as const,
   OffDuty: 'OffDuty' as const,
   OnBreak: 'OnBreak' as const,
   OnDuty: 'OnDuty' as const
}

export const enumDurationUnit = {
   days: 'days' as const,
   hours: 'hours' as const,
   minutes: 'minutes' as const,
   seconds: 'seconds' as const
}

export const enumExecutionRunSortOption = {
   CompletedAtAsc: 'CompletedAtAsc' as const,
   CompletedAtDesc: 'CompletedAtDesc' as const,
   StartedAtAsc: 'StartedAtAsc' as const,
   StartedAtDesc: 'StartedAtDesc' as const,
   TriggeredAtAsc: 'TriggeredAtAsc' as const,
   TriggeredAtDesc: 'TriggeredAtDesc' as const
}

export const enumExecutionStatus = {
   Cancelled: 'Cancelled' as const,
   Completed: 'Completed' as const,
   Failed: 'Failed' as const,
   Pending: 'Pending' as const,
   Running: 'Running' as const,
   WaitingApproval: 'WaitingApproval' as const
}

export const enumFacilityAtmSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumFacilityGroupSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumFacilitySortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumFieldConstraintObjectType = {
   CRMAccount: 'CRMAccount' as const,
   CRMAccountAddress: 'CRMAccountAddress' as const,
   CRMContact: 'CRMContact' as const,
   CoreFacility: 'CoreFacility' as const,
   CoreFacilityGroup: 'CoreFacilityGroup' as const,
   CoreUser: 'CoreUser' as const,
   FilesFile: 'FilesFile' as const,
   FinanceFinancialAccount: 'FinanceFinancialAccount' as const,
   InventoryCategory: 'InventoryCategory' as const,
   InventoryItem: 'InventoryItem' as const,
   InventoryItemGroup: 'InventoryItemGroup' as const,
   InventoryTag: 'InventoryTag' as const
}

export const enumFieldDataType = {
   Boolean: 'Boolean' as const,
   Date: 'Date' as const,
   DateTime: 'DateTime' as const,
   Json: 'Json' as const,
   Money: 'Money' as const,
   MultilineText: 'MultilineText' as const,
   Number: 'Number' as const,
   ObjectRef: 'ObjectRef' as const,
   Select: 'Select' as const,
   Text: 'Text' as const,
   Time: 'Time' as const,
   UUID: 'UUID' as const
}

export const enumFilePermission = {
   Delete: 'Delete' as const,
   Read: 'Read' as const,
   Write: 'Write' as const
}

export const enumFileStatus = {
   Active: 'Active' as const,
   Deleted: 'Deleted' as const,
   Expired: 'Expired' as const,
   PendingUpload: 'PendingUpload' as const
}

export const enumFileTemplateSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   CreatedByAsc: 'CreatedByAsc' as const,
   CreatedByDesc: 'CreatedByDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   UpdatedByAsc: 'UpdatedByAsc' as const,
   UpdatedByDesc: 'UpdatedByDesc' as const
}

export const enumFileTemplateType = {
   ApSettlementReport: 'ApSettlementReport' as const,
   BillAp: 'BillAp' as const,
   BillOfLading: 'BillOfLading' as const,
   BookingInvoice: 'BookingInvoice' as const,
   CheckAp: 'CheckAp' as const,
   FullPageTicket: 'FullPageTicket' as const,
   FullPageWeightTicket: 'FullPageWeightTicket' as const,
   InventoryTag: 'InventoryTag' as const,
   InvoiceAr: 'InvoiceAr' as const,
   LoadInvoice: 'LoadInvoice' as const,
   OutboundTicket: 'OutboundTicket' as const,
   PackingList: 'PackingList' as const,
   PriceList: 'PriceList' as const,
   PurchaseOrder: 'PurchaseOrder' as const,
   SalesOrder: 'SalesOrder' as const,
   ShippingSummary: 'ShippingSummary' as const,
   ThermalTicket: 'ThermalTicket' as const,
   ThermalWeightTicket: 'ThermalWeightTicket' as const
}

export const enumFileType = {
   Directory: 'Directory' as const,
   Regular: 'Regular' as const
}

export const enumFilesAggregateType = {
   File: 'File' as const
}

export const enumFinanceAggregateType = {
   Bill: 'Bill' as const,
   Invoice: 'Invoice' as const
}

export const enumFinancialAccountAdjustmentSortOption = {
   AmountAsc: 'AmountAsc' as const,
   AmountDesc: 'AmountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DateAsc: 'DateAsc' as const,
   DateDesc: 'DateDesc' as const
}

export const enumFinancialAccountSortOption = {
   BalanceAsc: 'BalanceAsc' as const,
   BalanceDesc: 'BalanceDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumFinancialAccountTransactionChannel = {
   Digital: 'Digital' as const,
   InStore: 'InStore' as const,
   Other: 'Other' as const
}

export const enumFinancialAccountTransactionCounterpartyType = {
   FinancialInstitution: 'FinancialInstitution' as const,
   IncomeSource: 'IncomeSource' as const,
   Marketplace: 'Marketplace' as const,
   Merchant: 'Merchant' as const,
   Other: 'Other' as const,
   PaymentApp: 'PaymentApp' as const,
   PaymentTerminal: 'PaymentTerminal' as const
}

export const enumFinancialAccountTransactionSortOption = {
   AmountAsc: 'AmountAsc' as const,
   AmountDesc: 'AmountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DateAsc: 'DateAsc' as const,
   DateDesc: 'DateDesc' as const,
   ReferenceAsc: 'ReferenceAsc' as const,
   ReferenceDesc: 'ReferenceDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumFinancialAccountTransactionStatus = {
   Cancelled: 'Cancelled' as const,
   Failed: 'Failed' as const,
   Pending: 'Pending' as const,
   Posted: 'Posted' as const
}

export const enumFinancialAccountTransactionType = {
   ATM: 'ATM' as const,
   Adjustment: 'Adjustment' as const,
   BankCharge: 'BankCharge' as const,
   BillPayment: 'BillPayment' as const,
   Cash: 'Cash' as const,
   Cashback: 'Cashback' as const,
   Check: 'Check' as const,
   DirectDebit: 'DirectDebit' as const,
   Interest: 'Interest' as const,
   Other: 'Other' as const,
   Purchase: 'Purchase' as const,
   StandingOrder: 'StandingOrder' as const,
   Transfer: 'Transfer' as const
}

export const enumFinancialAccountType = {
   ATM: 'ATM' as const,
   Cash: 'Cash' as const,
   Checking: 'Checking' as const,
   Savings: 'Savings' as const,
   WriteOff: 'WriteOff' as const
}

export const enumFreightForwarderSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumFreightLaneCostSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   StartDateAsc: 'StartDateAsc' as const,
   StartDateDesc: 'StartDateDesc' as const
}

export const enumFreightLaneRouteSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumFreightLaneSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   TransportationModeAsc: 'TransportationModeAsc' as const,
   TransportationModeDesc: 'TransportationModeDesc' as const
}

export const enumFreightLineSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumFreightTerm = {
   CIF: 'CIF' as const,
   CNF: 'CNF' as const,
   DDP: 'DDP' as const,
   Delivered: 'Delivered' as const,
   EXW: 'EXW' as const,
   FAS: 'FAS' as const,
   FOB: 'FOB' as const,
   PickedUp: 'PickedUp' as const
}

export const enumFreightTerms = {
   Collect: 'Collect' as const,
   Prepaid: 'Prepaid' as const,
   ThirdParty: 'ThirdParty' as const
}

export const enumGovernmentReportingConfigurationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   ServiceTypeAsc: 'ServiceTypeAsc' as const,
   ServiceTypeDesc: 'ServiceTypeDesc' as const
}

export const enumGovernmentReportingFacilitySortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumGovernmentReportingServiceType = {
   Alabama: 'Alabama' as const,
   BCPolice: 'BCPolice' as const,
   CanadaBWI: 'CanadaBWI' as const,
   Kansas: 'Kansas' as const,
   LeadsOnline: 'LeadsOnline' as const,
   LeadsOnlineCanada: 'LeadsOnlineCanada' as const,
   NMVTIS: 'NMVTIS' as const,
   OhioDPS: 'OhioDPS' as const,
   TexasOnlineMetals: 'TexasOnlineMetals' as const,
   WAPolice: 'WAPolice' as const
}

export const enumHaulerProgress = {
   Completed: 'Completed' as const,
   Failed: 'Failed' as const,
   InProgress: 'InProgress' as const,
   NotStarted: 'NotStarted' as const
}

export const enumHoldExemptionReason = {
   FrequentSeller: 'FrequentSeller' as const,
   ManuallyChecked: 'ManuallyChecked' as const,
   None: 'None' as const,
   SmallTransaction: 'SmallTransaction' as const
}

export const enumHttpMethod = {
   DELETE: 'DELETE' as const,
   GET: 'GET' as const,
   PATCH: 'PATCH' as const,
   POST: 'POST' as const,
   PUT: 'PUT' as const
}

export const enumIdentityDocumentType = {
   DriverLicense: 'DriverLicense' as const,
   MexicanMatriculaConsular: 'MexicanMatriculaConsular' as const,
   Other: 'Other' as const,
   Passport: 'Passport' as const,
   StateID: 'StateID' as const
}

export const enumInboundTollingAgreementSortOption = {
   AgreementNumberAsc: 'AgreementNumberAsc' as const,
   AgreementNumberDesc: 'AgreementNumberDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EffectiveDateAsc: 'EffectiveDateAsc' as const,
   EffectiveDateDesc: 'EffectiveDateDesc' as const,
   ExpirationDateAsc: 'ExpirationDateAsc' as const,
   ExpirationDateDesc: 'ExpirationDateDesc' as const
}

export const enumIndividualEyeColor = {
   Black: 'Black' as const,
   Blue: 'Blue' as const,
   Brown: 'Brown' as const,
   Gray: 'Gray' as const,
   Green: 'Green' as const,
   Hazel: 'Hazel' as const,
   Maroon: 'Maroon' as const,
   Multicolored: 'Multicolored' as const,
   Pink: 'Pink' as const,
   Unknown: 'Unknown' as const
}

export const enumIndividualHairColor = {
   Bald: 'Bald' as const,
   Black: 'Black' as const,
   Blond: 'Blond' as const,
   Brown: 'Brown' as const,
   Gray: 'Gray' as const,
   Green: 'Green' as const,
   Orange: 'Orange' as const,
   Pink: 'Pink' as const,
   Purple: 'Purple' as const,
   Red: 'Red' as const,
   Sandy: 'Sandy' as const,
   Unknown: 'Unknown' as const,
   White: 'White' as const
}

export const enumIndividualRace = {
   AmericanIndian: 'AmericanIndian' as const,
   Asian: 'Asian' as const,
   Black: 'Black' as const,
   Hispanic: 'Hispanic' as const,
   Unknown: 'Unknown' as const,
   White: 'White' as const
}

export const enumIndividualSex = {
   Female: 'Female' as const,
   Male: 'Male' as const
}

export const enumInventoryAccountSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   TaggingTypeAsc: 'TaggingTypeAsc' as const,
   TaggingTypeDesc: 'TaggingTypeDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumInventoryAccountType = {
   Adjustments: 'Adjustments' as const,
   AtExternalProcessor: 'AtExternalProcessor' as const,
   CustomerOwned: 'CustomerOwned' as const,
   Customers: 'Customers' as const,
   FinishedGoodsStock: 'FinishedGoodsStock' as const,
   InteryardTransfers: 'InteryardTransfers' as const,
   Production: 'Production' as const,
   Suppliers: 'Suppliers' as const,
   WorkInProgressStock: 'WorkInProgressStock' as const
}

export const enumInventoryAggregateType = {
   Category: 'Category' as const,
   InventoryTag: 'InventoryTag' as const,
   Item: 'Item' as const,
   ItemGroup: 'ItemGroup' as const
}

export const enumInventoryFacilitySettingsSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumInventoryLevelSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   FacilityAsc: 'FacilityAsc' as const,
   FacilityDesc: 'FacilityDesc' as const,
   ItemNameAsc: 'ItemNameAsc' as const,
   ItemNameDesc: 'ItemNameDesc' as const,
   QuantityAsc: 'QuantityAsc' as const,
   QuantityDesc: 'QuantityDesc' as const
}

export const enumInventoryLotSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   LotNumberAsc: 'LotNumberAsc' as const,
   LotNumberDesc: 'LotNumberDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumInventoryMovementSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   OccurredAtAsc: 'OccurredAtAsc' as const,
   OccurredAtDesc: 'OccurredAtDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumInventoryMovementStatus = {
   Canceled: 'Canceled' as const,
   Completed: 'Completed' as const,
   InTransit: 'InTransit' as const,
   Pending: 'Pending' as const
}

export const enumInventoryMovementType = {
   In: 'In' as const,
   Internal: 'Internal' as const,
   Out: 'Out' as const,
   Reset: 'Reset' as const
}

export const enumInventoryPeriodBalanceSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumInventoryPeriodConfigSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   FiscalYearStartMonthAsc: 'FiscalYearStartMonthAsc' as const,
   FiscalYearStartMonthDesc: 'FiscalYearStartMonthDesc' as const,
   PeriodTypeAsc: 'PeriodTypeAsc' as const,
   PeriodTypeDesc: 'PeriodTypeDesc' as const,
   StraddleWindowPeriodsAsc: 'StraddleWindowPeriodsAsc' as const,
   StraddleWindowPeriodsDesc: 'StraddleWindowPeriodsDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumInventoryPeriodSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EndDateAsc: 'EndDateAsc' as const,
   EndDateDesc: 'EndDateDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   StartDateAsc: 'StartDateAsc' as const,
   StartDateDesc: 'StartDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumInventoryTagSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   GeneratedAtAsc: 'GeneratedAtAsc' as const,
   GeneratedAtDesc: 'GeneratedAtDesc' as const,
   TagNumberAsc: 'TagNumberAsc' as const,
   TagNumberDesc: 'TagNumberDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumInventoryTagStatus = {
   Active: 'Active' as const,
   Cancelled: 'Cancelled' as const,
   Confirmed: 'Confirmed' as const,
   Draft: 'Draft' as const,
   InInventory: 'InInventory' as const,
   InTransfer: 'InTransfer' as const,
   Loaded: 'Loaded' as const,
   PendingPurchase: 'PendingPurchase' as const,
   Reserved: 'Reserved' as const,
   Revised: 'Revised' as const,
   Shipped: 'Shipped' as const,
   Sold: 'Sold' as const,
   Transferred: 'Transferred' as const,
   Voided: 'Voided' as const
}

export const enumInventoryTaggingType = {
   Any: 'Any' as const,
   Tagged: 'Tagged' as const,
   Untagged: 'Untagged' as const
}

export const enumInventoryTransactionType = {
   Accounting: 'Accounting' as const,
   BalanceAdjustment: 'BalanceAdjustment' as const,
   Downgrade: 'Downgrade' as const,
   PhysicalInventory: 'PhysicalInventory' as const,
   Processing: 'Processing' as const,
   Purchase: 'Purchase' as const,
   PurchaseReversion: 'PurchaseReversion' as const,
   Sale: 'Sale' as const,
   SaleReversion: 'SaleReversion' as const,
   Tagging: 'Tagging' as const,
   Transfer: 'Transfer' as const,
   TransferReversion: 'TransferReversion' as const,
   Untagging: 'Untagging' as const,
   Upgrade: 'Upgrade' as const
}

export const enumInventoryViewMode = {
   OurMaterial: 'OurMaterial' as const,
   TollingMaterial: 'TollingMaterial' as const
}

export const enumInventoryZoneSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   ZoneCodeAsc: 'ZoneCodeAsc' as const,
   ZoneCodeDesc: 'ZoneCodeDesc' as const,
   ZoneTypeAsc: 'ZoneTypeAsc' as const,
   ZoneTypeDesc: 'ZoneTypeDesc' as const
}

export const enumInvitationStatus = {
   ACCEPTED: 'ACCEPTED' as const,
   CANCELLED: 'CANCELLED' as const,
   EXPIRED: 'EXPIRED' as const,
   PENDING: 'PENDING' as const
}

export const enumInvoiceEntityReferenceType = {
   OutboundLoad: 'OutboundLoad' as const,
   OutboundLoadLineItem: 'OutboundLoadLineItem' as const
}

export const enumInvoicePricingBasis = {
   Input: 'Input' as const,
   Output: 'Output' as const
}

export const enumInvoiceSortOption = {
   AccountAsc: 'AccountAsc' as const,
   AccountDesc: 'AccountDesc' as const,
   AmountAsc: 'AmountAsc' as const,
   AmountDesc: 'AmountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DocumentDateAsc: 'DocumentDateAsc' as const,
   DocumentDateDesc: 'DocumentDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumInvoiceStatus = {
   Paid: 'Paid' as const,
   Pending: 'Pending' as const,
   ProForma: 'ProForma' as const,
   Voided: 'Voided' as const
}

export const enumInvoiceType = {
   Accrual: 'Accrual' as const,
   FreightInvoice: 'FreightInvoice' as const,
   InboundInvoice: 'InboundInvoice' as const,
   OutboundInvoice: 'OutboundInvoice' as const
}

export const enumItemAliasSortOption = {
   AliasNameAsc: 'AliasNameAsc' as const,
   AliasNameDesc: 'AliasNameDesc' as const,
   AliasTypeAsc: 'AliasTypeAsc' as const,
   AliasTypeDesc: 'AliasTypeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumItemAliasType = {
   Buy: 'Buy' as const,
   Sell: 'Sell' as const
}

export const enumItemGroupSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   NumberAsc: 'NumberAsc' as const,
   NumberDesc: 'NumberDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumItemPositionSortOption = {
   IncomingAsc: 'IncomingAsc' as const,
   IncomingDesc: 'IncomingDesc' as const,
   ItemNameAsc: 'ItemNameAsc' as const,
   ItemNameDesc: 'ItemNameDesc' as const,
   NetPositionAsc: 'NetPositionAsc' as const,
   NetPositionDesc: 'NetPositionDesc' as const,
   OutgoingAsc: 'OutgoingAsc' as const,
   OutgoingDesc: 'OutgoingDesc' as const
}

export const enumItemPriceConfigurationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumItemPricingSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   PositionAsc: 'PositionAsc' as const,
   PositionDesc: 'PositionDesc' as const,
   TiersEffectiveAtAsc: 'TiersEffectiveAtAsc' as const,
   TiersEffectiveAtDesc: 'TiersEffectiveAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumItemPricingTierSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   MaxPriceFormulaAsc: 'MaxPriceFormulaAsc' as const,
   MaxPriceFormulaDesc: 'MaxPriceFormulaDesc' as const,
   MinPriceFormulaAsc: 'MinPriceFormulaAsc' as const,
   MinPriceFormulaDesc: 'MinPriceFormulaDesc' as const,
   PositionAsc: 'PositionAsc' as const,
   PositionDesc: 'PositionDesc' as const,
   TargetPriceFormulaAsc: 'TargetPriceFormulaAsc' as const,
   TargetPriceFormulaDesc: 'TargetPriceFormulaDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   SkuAsc: 'SkuAsc' as const,
   SkuDesc: 'SkuDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumLoadDeductionSortOption = {
   ApplicationTypeAsc: 'ApplicationTypeAsc' as const,
   ApplicationTypeDesc: 'ApplicationTypeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumLoadSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   CreatedByAsc: 'CreatedByAsc' as const,
   CreatedByDesc: 'CreatedByDesc' as const,
   ExpectedShipDateAsc: 'ExpectedShipDateAsc' as const,
   ExpectedShipDateDesc: 'ExpectedShipDateDesc' as const,
   ShippedDateAsc: 'ShippedDateAsc' as const,
   ShippedDateDesc: 'ShippedDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   UpdatedByAsc: 'UpdatedByAsc' as const,
   UpdatedByDesc: 'UpdatedByDesc' as const
}

export const enumLoadStatus = {
   ContainerAtFacility: 'ContainerAtFacility' as const,
   ContainerAtPort: 'ContainerAtPort' as const,
   ContainerInTransit: 'ContainerInTransit' as const,
   ContainerLoaded: 'ContainerLoaded' as const,
   ContainerReadyToShip: 'ContainerReadyToShip' as const,
   ContainerReturning: 'ContainerReturning' as const,
   Pending: 'Pending' as const,
   Received: 'Received' as const,
   Reconciled: 'Reconciled' as const,
   Shipped: 'Shipped' as const,
   Unassigned: 'Unassigned' as const,
   Voided: 'Voided' as const
}

export const enumLocationFilterType = {
   AllLocations: 'AllLocations' as const,
   ExternalProcessors: 'ExternalProcessors' as const,
   OurFacilities: 'OurFacilities' as const
}

export const enumLocationFreightPricingSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumLocationType = {
   AccountAddress: 'AccountAddress' as const,
   Facility: 'Facility' as const
}

export const enumLotAllocationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumLotStatus = {
   Active: 'Active' as const,
   Closed: 'Closed' as const,
   Merged: 'Merged' as const
}

export const enumMfaFactorType = {
   TOTP: 'TOTP' as const
}

export const enumModelProvider = {
   Anthropic: 'Anthropic' as const,
   Cerebras: 'Cerebras' as const,
   Gemini: 'Gemini' as const,
   OpenAI: 'OpenAI' as const
}

export const enumMonthlyOccurrence = {
   Every: 'Every' as const,
   First: 'First' as const,
   Fourth: 'Fourth' as const,
   Last: 'Last' as const,
   Second: 'Second' as const,
   Third: 'Third' as const
}

export const enumNodeExecutionStatus = {
   Failed: 'Failed' as const,
   Skipped: 'Skipped' as const,
   Success: 'Success' as const
}

export const enumNodeType = {
   Approval: 'Approval' as const,
   BusinessEventTrigger: 'BusinessEventTrigger' as const,
   Condition: 'Condition' as const,
   Delay: 'Delay' as const,
   EmailAction: 'EmailAction' as const,
   Filter: 'Filter' as const,
   HttpRequestAction: 'HttpRequestAction' as const,
   HttpWebhookTrigger: 'HttpWebhookTrigger' as const,
   Loop: 'Loop' as const,
   ScheduleTrigger: 'ScheduleTrigger' as const,
   Switch: 'Switch' as const
}

export const enumNotificationDeviceSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DeviceTokenAsc: 'DeviceTokenAsc' as const,
   DeviceTokenDesc: 'DeviceTokenDesc' as const,
   PlatformAsc: 'PlatformAsc' as const,
   PlatformDesc: 'PlatformDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumNotificationPreferenceSortOption = {
   ChannelAsc: 'ChannelAsc' as const,
   ChannelDesc: 'ChannelDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotificationTypeKeyAsc: 'NotificationTypeKeyAsc' as const,
   NotificationTypeKeyDesc: 'NotificationTypeKeyDesc' as const
}

export const enumNotificationRecipientSortOption = {
   ChannelAsc: 'ChannelAsc' as const,
   ChannelDesc: 'ChannelDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   ReadAtAsc: 'ReadAtAsc' as const,
   ReadAtDesc: 'ReadAtDesc' as const,
   SeenAtAsc: 'SeenAtAsc' as const,
   SeenAtDesc: 'SeenAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumNotificationSortOption = {
   ActionLinkAsc: 'ActionLinkAsc' as const,
   ActionLinkDesc: 'ActionLinkDesc' as const,
   BodyAsc: 'BodyAsc' as const,
   BodyDesc: 'BodyDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EventIDAsc: 'EventIDAsc' as const,
   EventIDDesc: 'EventIDDesc' as const,
   NotificationTypeKeyAsc: 'NotificationTypeKeyAsc' as const,
   NotificationTypeKeyDesc: 'NotificationTypeKeyDesc' as const,
   ResourceIDAsc: 'ResourceIDAsc' as const,
   ResourceIDDesc: 'ResourceIDDesc' as const,
   ResourceTypeAsc: 'ResourceTypeAsc' as const,
   ResourceTypeDesc: 'ResourceTypeDesc' as const,
   TitleAsc: 'TitleAsc' as const,
   TitleDesc: 'TitleDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumNotificationTypeSortOption = {
   CategoryAsc: 'CategoryAsc' as const,
   CategoryDesc: 'CategoryDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   KeyAsc: 'KeyAsc' as const,
   KeyDesc: 'KeyDesc' as const
}

export const enumOperationType = {
   Brokerage: 'Brokerage' as const,
   Purchase: 'Purchase' as const,
   Sale: 'Sale' as const
}

export const enumOrganizationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumOutboundTollingAgreementSortOption = {
   AgreementNumberAsc: 'AgreementNumberAsc' as const,
   AgreementNumberDesc: 'AgreementNumberDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EffectiveDateAsc: 'EffectiveDateAsc' as const,
   EffectiveDateDesc: 'EffectiveDateDesc' as const,
   ExpirationDateAsc: 'ExpirationDateAsc' as const,
   ExpirationDateDesc: 'ExpirationDateDesc' as const
}

export const enumOutboxEventStatus = {
   DeadLetter: 'DeadLetter' as const,
   Failed: 'Failed' as const,
   Pending: 'Pending' as const,
   Processed: 'Processed' as const
}

export const enumPaymentAllocationMethod = {
   FIFO: 'FIFO' as const,
   LIFO: 'LIFO' as const,
   WeightedDistribution: 'WeightedDistribution' as const
}

export const enumPaymentApplicationType = {
   Bill: 'Bill' as const,
   Invoice: 'Invoice' as const
}

export const enumPaymentMethod = {
   ACH: 'ACH' as const,
   ATM: 'ATM' as const,
   Cash: 'Cash' as const,
   Check: 'Check' as const,
   Wire: 'Wire' as const,
   WriteOff: 'WriteOff' as const
}

export const enumPaymentSortOption = {
   AmountAsc: 'AmountAsc' as const,
   AmountDesc: 'AmountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DateAsc: 'DateAsc' as const,
   DateDesc: 'DateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumPaymentStatus = {
   Issued: 'Issued' as const,
   Posted: 'Posted' as const,
   Voided: 'Voided' as const,
   VoidedWriteOff: 'VoidedWriteOff' as const
}

export const enumPaymentTerm = {
   CAD: 'CAD' as const,
   CIA: 'CIA' as const,
   CND: 'CND' as const,
   COD: 'COD' as const,
   DueUponReceipt: 'DueUponReceipt' as const,
   EOM: 'EOM' as const,
   LOC: 'LOC' as const,
   Net5: 'Net5' as const,
   Net10: 'Net10' as const,
   Net15: 'Net15' as const,
   Net20: 'Net20' as const,
   Net30: 'Net30' as const,
   Net45: 'Net45' as const,
   Net60: 'Net60' as const,
   Net90: 'Net90' as const,
   PIA: 'PIA' as const
}

export const enumPaymentTermConfigSortOption = {
   CodeAsc: 'CodeAsc' as const,
   CodeDesc: 'CodeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumPaymentType = {
   Adjustment: 'Adjustment' as const,
   AdvanceIn: 'AdvanceIn' as const,
   AdvanceOut: 'AdvanceOut' as const,
   Bill: 'Bill' as const,
   Invoice: 'Invoice' as const,
   Netting: 'Netting' as const,
   WriteOff: 'WriteOff' as const
}

export const enumPortSortOption = {
   CountryCodeAsc: 'CountryCodeAsc' as const,
   CountryCodeDesc: 'CountryCodeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   LocationCodeAsc: 'LocationCodeAsc' as const,
   LocationCodeDesc: 'LocationCodeDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UnLocodeAsc: 'UnLocodeAsc' as const,
   UnLocodeDesc: 'UnLocodeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumPositivePayTemplateSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   TemplateNameAsc: 'TemplateNameAsc' as const,
   TemplateNameDesc: 'TemplateNameDesc' as const
}

export const enumPresenceEventType = {
   JOIN: 'JOIN' as const,
   LEAVE: 'LEAVE' as const,
   SNAPSHOT: 'SNAPSHOT' as const,
   UPDATE: 'UPDATE' as const
}

export const enumPriceListType = {
   Custom: 'Custom' as const,
   Default: 'Default' as const
}

export const enumPricingMode = {
   CRV: 'CRV' as const,
   Standard: 'Standard' as const
}

export const enumPrinterPageSize = {
   A4: 'A4' as const,
   Legal: 'Legal' as const,
   Letter: 'Letter' as const
}

export const enumPrinterRollWidth = {
   Roll58mm: 'Roll58mm' as const,
   Roll80mm: 'Roll80mm' as const
}

export const enumPrinterSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DriverTypeAsc: 'DriverTypeAsc' as const,
   DriverTypeDesc: 'DriverTypeDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   PrinterTypeAsc: 'PrinterTypeAsc' as const,
   PrinterTypeDesc: 'PrinterTypeDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumPrinterStatus = {
   Discovered: 'Discovered' as const
}

export const enumPrinterType = {
   Standard: 'Standard' as const,
   Thermal: 'Thermal' as const
}

export const enumProcessingTypeInputItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   SortOrderAsc: 'SortOrderAsc' as const,
   SortOrderDesc: 'SortOrderDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumProcessingTypeOutputItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   SortOrderAsc: 'SortOrderAsc' as const,
   SortOrderDesc: 'SortOrderDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumProcessingTypeSortOption = {
   CodeAsc: 'CodeAsc' as const,
   CodeDesc: 'CodeDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumPurchaseLineItemType = {
   CatalyticConverter: 'CatalyticConverter' as const,
   Freight: 'Freight' as const,
   Mixed: 'Mixed' as const,
   Raw: 'Raw' as const,
   Tagged: 'Tagged' as const,
   Vehicle: 'Vehicle' as const
}

export const enumPurchaseLoadDeductionSortOption = {
   ApplicationTypeAsc: 'ApplicationTypeAsc' as const,
   ApplicationTypeDesc: 'ApplicationTypeDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const
}

export const enumPurchaseLoadLineItemSortOption = {
   CatComplianceStatusAsc: 'CatComplianceStatusAsc' as const,
   CatComplianceStatusDesc: 'CatComplianceStatusDesc' as const,
   CatOemCodeAsc: 'CatOemCodeAsc' as const,
   CatOemCodeDesc: 'CatOemCodeDesc' as const,
   CatSerialNumberAsc: 'CatSerialNumberAsc' as const,
   CatSerialNumberDesc: 'CatSerialNumberDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   SettlementBasisAsc: 'SettlementBasisAsc' as const,
   SettlementBasisDesc: 'SettlementBasisDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   VehicleMakeAsc: 'VehicleMakeAsc' as const,
   VehicleMakeDesc: 'VehicleMakeDesc' as const,
   VehicleModelAsc: 'VehicleModelAsc' as const,
   VehicleModelDesc: 'VehicleModelDesc' as const,
   VehicleTitleStatusAsc: 'VehicleTitleStatusAsc' as const,
   VehicleTitleStatusDesc: 'VehicleTitleStatusDesc' as const,
   VehicleVinAsc: 'VehicleVinAsc' as const,
   VehicleVinDesc: 'VehicleVinDesc' as const,
   VehicleYearAsc: 'VehicleYearAsc' as const,
   VehicleYearDesc: 'VehicleYearDesc' as const
}

export const enumPurchaseLoadPaymentSortOption = {
   CheckMemoAsc: 'CheckMemoAsc' as const,
   CheckMemoDesc: 'CheckMemoDesc' as const,
   CheckNumberAsc: 'CheckNumberAsc' as const,
   CheckNumberDesc: 'CheckNumberDesc' as const,
   PaymentMethodAsc: 'PaymentMethodAsc' as const,
   PaymentMethodDesc: 'PaymentMethodDesc' as const,
   PaymentTermAsc: 'PaymentTermAsc' as const,
   PaymentTermDesc: 'PaymentTermDesc' as const,
   RoundingMethodAsc: 'RoundingMethodAsc' as const,
   RoundingMethodDesc: 'RoundingMethodDesc' as const,
   RoundingPrecisionAsc: 'RoundingPrecisionAsc' as const,
   RoundingPrecisionDesc: 'RoundingPrecisionDesc' as const
}

export const enumPurchaseLoadSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DocumentNumberAsc: 'DocumentNumberAsc' as const,
   DocumentNumberDesc: 'DocumentNumberDesc' as const,
   ReceivedDateAsc: 'ReceivedDateAsc' as const,
   ReceivedDateDesc: 'ReceivedDateDesc' as const
}

export const enumPurchaseLoadStatus = {
   Held: 'Held' as const,
   InventoryComplete: 'InventoryComplete' as const,
   Open: 'Open' as const,
   Paid: 'Paid' as const,
   PriceComplete: 'PriceComplete' as const,
   Voided: 'Voided' as const
}

export const enumPurchaseOrderFreightSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumPurchaseOrderLineItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumPurchaseOrderSortOption = {
   AccountAsc: 'AccountAsc' as const,
   AccountDesc: 'AccountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EndDateAsc: 'EndDateAsc' as const,
   EndDateDesc: 'EndDateDesc' as const,
   NumberAsc: 'NumberAsc' as const,
   NumberDesc: 'NumberDesc' as const,
   PaymentCurrencyAsc: 'PaymentCurrencyAsc' as const,
   PaymentCurrencyDesc: 'PaymentCurrencyDesc' as const,
   StartDateAsc: 'StartDateAsc' as const,
   StartDateDesc: 'StartDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumPurchaseOrderStatus = {
   Closed: 'Closed' as const,
   Draft: 'Draft' as const,
   Open: 'Open' as const,
   Voided: 'Voided' as const
}

export const enumQuantityCaptureMethod = {
   Automatic: 'Automatic' as const,
   Manual: 'Manual' as const
}

export const enumQuoteLineItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   PackageFormatAsc: 'PackageFormatAsc' as const,
   PackageFormatDesc: 'PackageFormatDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumQuoteSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DocumentNumberAsc: 'DocumentNumberAsc' as const,
   DocumentNumberDesc: 'DocumentNumberDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   ValidUntilAsc: 'ValidUntilAsc' as const,
   ValidUntilDesc: 'ValidUntilDesc' as const
}

export const enumQuoteStatus = {
   Accepted: 'Accepted' as const,
   Converted: 'Converted' as const,
   Draft: 'Draft' as const,
   Expired: 'Expired' as const,
   Rejected: 'Rejected' as const,
   Sent: 'Sent' as const,
   Voided: 'Voided' as const
}

export const enumQuoteType = {
   Purchase: 'Purchase' as const,
   Sales: 'Sales' as const
}

export const enumRecurrenceType = {
   Daily: 'Daily' as const,
   Monthly: 'Monthly' as const,
   Weekly: 'Weekly' as const
}

export const enumRelationshipType = {
   HAULER: 'HAULER' as const,
   OWNER: 'OWNER' as const
}

export const enumReportingUploadType = {
   Automatic: 'Automatic' as const,
   Manual: 'Manual' as const
}

export const enumRoleSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumRoleType = {
   EXTERNAL: 'EXTERNAL' as const,
   INTERNAL: 'INTERNAL' as const
}

export const enumRoundingMethod = {
   Down: 'Down' as const,
   Nearest: 'Nearest' as const,
   Up: 'Up' as const
}

export const enumRoundingPrecision = {
   Hundred: 'Hundred' as const,
   Tenth: 'Tenth' as const,
   Whole: 'Whole' as const
}

export const enumRouteFreightSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumRouteSortOption = {
   CompletedAtAsc: 'CompletedAtAsc' as const,
   CompletedAtDesc: 'CompletedAtDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   StartedAtAsc: 'StartedAtAsc' as const,
   StartedAtDesc: 'StartedAtDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumRouteStatus = {
   Active: 'Active' as const,
   Completed: 'Completed' as const,
   Failed: 'Failed' as const,
   InProgress: 'InProgress' as const,
   Paused: 'Paused' as const,
   Planned: 'Planned' as const,
   Voided: 'Voided' as const
}

export const enumRouteValidationOverrideSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumSalesItemLineType = {
   Raw: 'Raw' as const,
   Tagged: 'Tagged' as const
}

export const enumSalesLoadLineItemPhase = {
   CustomerReceived: 'CustomerReceived' as const,
   Received: 'Received' as const,
   Requested: 'Requested' as const,
   Shipped: 'Shipped' as const,
   Staged: 'Staged' as const
}

export const enumSalesOrderFreightSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumSalesOrderSortOption = {
   AccountAsc: 'AccountAsc' as const,
   AccountDesc: 'AccountDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   CreatedByAsc: 'CreatedByAsc' as const,
   CreatedByDesc: 'CreatedByDesc' as const,
   DocumentNumberAsc: 'DocumentNumberAsc' as const,
   DocumentNumberDesc: 'DocumentNumberDesc' as const,
   EndDateAsc: 'EndDateAsc' as const,
   EndDateDesc: 'EndDateDesc' as const,
   PaymentCurrencyAsc: 'PaymentCurrencyAsc' as const,
   PaymentCurrencyDesc: 'PaymentCurrencyDesc' as const,
   StartDateAsc: 'StartDateAsc' as const,
   StartDateDesc: 'StartDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const,
   UpdatedByAsc: 'UpdatedByAsc' as const,
   UpdatedByDesc: 'UpdatedByDesc' as const
}

export const enumSalesOrderStatus = {
   Draft: 'Draft' as const,
   Finished: 'Finished' as const,
   Open: 'Open' as const,
   Voided: 'Voided' as const
}

export const enumSalesOrderType = {
   Domestic: 'Domestic' as const,
   International: 'International' as const
}

export const enumScaleConnectionType = {
   Demo: 'Demo' as const,
   Serial: 'Serial' as const,
   TCP: 'TCP' as const
}

export const enumScaleFormatType = {
   Cardinal: 'Cardinal' as const,
   Condec: 'Condec' as const,
   Fairbanks: 'Fairbanks' as const,
   MettlerToledo: 'MettlerToledo' as const,
   Other: 'Other' as const,
   PEC: 'PEC' as const,
   RiceLake: 'RiceLake' as const,
   SMA: 'SMA' as const,
   Weightronix: 'Weightronix' as const
}

export const enumScaleMeasurementMode = {
   Continuous: 'Continuous' as const,
   OnDemand: 'OnDemand' as const
}

export const enumScaleSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   ScaleFormatTypeAsc: 'ScaleFormatTypeAsc' as const,
   ScaleFormatTypeDesc: 'ScaleFormatTypeDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumScaleStatus = {
   Active: 'Active' as const,
   Configured: 'Configured' as const,
   Discovered: 'Discovered' as const
}

export const enumScannerSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   DriverTypeAsc: 'DriverTypeAsc' as const,
   DriverTypeDesc: 'DriverTypeDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const
}

export const enumScannerStatus = {
   Discovered: 'Discovered' as const
}

export const enumServiceRequirement = {
   CustomerSignature: 'CustomerSignature' as const,
   Photos: 'Photos' as const,
   WeigthReceipt: 'WeigthReceipt' as const
}

export const enumServiceSortOption = {
   CompletedAtAsc: 'CompletedAtAsc' as const,
   CompletedAtDesc: 'CompletedAtDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   PriorityAsc: 'PriorityAsc' as const,
   PriorityDesc: 'PriorityDesc' as const,
   ScheduledWindowEndAsc: 'ScheduledWindowEndAsc' as const,
   ScheduledWindowEndDesc: 'ScheduledWindowEndDesc' as const,
   ScheduledWindowStartAsc: 'ScheduledWindowStartAsc' as const,
   ScheduledWindowStartDesc: 'ScheduledWindowStartDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumServiceStatus = {
   Active: 'Active' as const,
   Completed: 'Completed' as const,
   Draft: 'Draft' as const,
   Failed: 'Failed' as const,
   InProgress: 'InProgress' as const,
   Paused: 'Paused' as const,
   Planned: 'Planned' as const,
   Voided: 'Voided' as const
}

export const enumServiceTypeSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumServiceTypeTaskDefinitionSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   SequenceAsc: 'SequenceAsc' as const,
   SequenceDesc: 'SequenceDesc' as const
}

export const enumSettingScope = {
   Facility: 'Facility' as const,
   FacilityGroup: 'FacilityGroup' as const,
   Organization: 'Organization' as const,
   User: 'User' as const
}

export const enumSettingSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumSettingsGroupSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumSettlementBasis = {
   PostSort: 'PostSort' as const,
   PreSort: 'PreSort' as const
}

export const enumShippingCarrierSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumSidecarOperatingSystem = {
   Linux: 'Linux' as const,
   MacOS: 'MacOS' as const,
   Other: 'Other' as const,
   Windows: 'Windows' as const
}

export const enumSidecarSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   OperatingSystemAsc: 'OperatingSystemAsc' as const,
   OperatingSystemDesc: 'OperatingSystemDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumSidecarStatus = {
   Pending: 'Pending' as const,
   Provisioned: 'Provisioned' as const
}

export const enumSortOrder = {
   ASC: 'ASC' as const,
   DESC: 'DESC' as const
}

export const enumTagAllocationSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTagType = {
   FinishedGood: 'FinishedGood' as const,
   WorkInProgress: 'WorkInProgress' as const
}

export const enumTaggingType = {
   Any: 'Any' as const,
   Tagged: 'Tagged' as const,
   Untagged: 'Untagged' as const
}

export const enumTalkJsPeopleType = {
   external: 'external' as const,
   internal: 'internal' as const
}

export const enumTaskServiceSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumTaskSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   RoutePositionAsc: 'RoutePositionAsc' as const,
   RoutePositionDesc: 'RoutePositionDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   TypeAsc: 'TypeAsc' as const,
   TypeDesc: 'TypeDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTaskStatus = {
   Active: 'Active' as const,
   Cancelled: 'Cancelled' as const,
   Completed: 'Completed' as const,
   Failed: 'Failed' as const,
   Planned: 'Planned' as const,
   Postponed: 'Postponed' as const
}

export const enumTaskType = {
   Delivery: 'Delivery' as const,
   Empty: 'Empty' as const,
   Fill: 'Fill' as const,
   Pickup: 'Pickup' as const,
   Reposition: 'Reposition' as const
}

export const enumTicketFreightSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumTimeoutAction = {
   approve: 'approve' as const,
   reject: 'reject' as const
}

export const enumTimeoutUnit = {
   days: 'days' as const,
   hours: 'hours' as const
}

export const enumTollReceiptItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTollReceiptSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   ReceiptNumberAsc: 'ReceiptNumberAsc' as const,
   ReceiptNumberDesc: 'ReceiptNumberDesc' as const,
   ReceivedAtAsc: 'ReceivedAtAsc' as const,
   ReceivedAtDesc: 'ReceivedAtDesc' as const
}

export const enumTollReceiptStatus = {
   Cancelled: 'Cancelled' as const,
   Completed: 'Completed' as const,
   Draft: 'Draft' as const,
   Processing: 'Processing' as const,
   Received: 'Received' as const
}

export const enumTollShipmentItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTollShipmentSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   ShipmentNumberAsc: 'ShipmentNumberAsc' as const,
   ShipmentNumberDesc: 'ShipmentNumberDesc' as const,
   ShippedAtAsc: 'ShippedAtAsc' as const,
   ShippedAtDesc: 'ShippedAtDesc' as const
}

export const enumTollShipmentStatus = {
   Cancelled: 'Cancelled' as const,
   Delivered: 'Delivered' as const,
   Draft: 'Draft' as const,
   Shipped: 'Shipped' as const
}

export const enumTollingType = {
   Inbound: 'Inbound' as const,
   None: 'None' as const,
   Outbound: 'Outbound' as const
}

export const enumTradeAggregateType = {
   Booking: 'Booking' as const,
   Load: 'Load' as const,
   PurchaseOrder: 'PurchaseOrder' as const,
   SalesOrder: 'SalesOrder' as const
}

export const enumTrailerSortOption = {
   CapacityAsc: 'CapacityAsc' as const,
   CapacityDesc: 'CapacityDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   LastLocationTimeAsc: 'LastLocationTimeAsc' as const,
   LastLocationTimeDesc: 'LastLocationTimeDesc' as const,
   LicensePlateAsc: 'LicensePlateAsc' as const,
   LicensePlateDesc: 'LicensePlateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTrailerStatus = {
   Available: 'Available' as const,
   InUse: 'InUse' as const,
   Inactive: 'Inactive' as const,
   OutOfService: 'OutOfService' as const
}

export const enumTransportationAggregateType = {
   Asset: 'Asset' as const,
   ContainerType: 'ContainerType' as const,
   Driver: 'Driver' as const,
   FreightForwarder: 'FreightForwarder' as const,
   FreightLine: 'FreightLine' as const,
   Route: 'Route' as const,
   Service: 'Service' as const,
   ShippingCarrier: 'ShippingCarrier' as const,
   Trailer: 'Trailer' as const,
   TransportationType: 'TransportationType' as const,
   Truck: 'Truck' as const
}

export const enumTransportationTypeSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTriggerType = {
   BusinessEvent: 'BusinessEvent' as const,
   HttpWebhook: 'HttpWebhook' as const,
   Schedule: 'Schedule' as const
}

export const enumTruckSortOption = {
   CapacityAsc: 'CapacityAsc' as const,
   CapacityDesc: 'CapacityDesc' as const,
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   LastLocationTimeAsc: 'LastLocationTimeAsc' as const,
   LastLocationTimeDesc: 'LastLocationTimeDesc' as const,
   LicensePlateAsc: 'LicensePlateAsc' as const,
   LicensePlateDesc: 'LicensePlateDesc' as const,
   ModelAsc: 'ModelAsc' as const,
   ModelDesc: 'ModelDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumTruckStatus = {
   Available: 'Available' as const,
   InUse: 'InUse' as const,
   Inactive: 'Inactive' as const,
   OutOfService: 'OutOfService' as const
}

export const enumUnit = {
   Each: 'Each' as const,
   Grams: 'Grams' as const,
   GrossTons: 'GrossTons' as const,
   Kilograms: 'Kilograms' as const,
   LongHundredweight: 'LongHundredweight' as const,
   LongTons: 'LongTons' as const,
   Meter: 'Meter' as const,
   MetricTons: 'MetricTons' as const,
   NetTons: 'NetTons' as const,
   Ounces: 'Ounces' as const,
   Pounds: 'Pounds' as const,
   ShortHundredweight: 'ShortHundredweight' as const,
   ShortTons: 'ShortTons' as const,
   Yard: 'Yard' as const
}

export const enumUnitFamily = {
   Count: 'Count' as const,
   Length: 'Length' as const,
   Weight: 'Weight' as const
}

export const enumUnitSystem = {
   Imperial: 'Imperial' as const,
   Metric: 'Metric' as const
}

export const enumUsageMetricsSortOption = {
   ModelProviderAsc: 'ModelProviderAsc' as const,
   ModelProviderDesc: 'ModelProviderDesc' as const,
   PeriodStartAsc: 'PeriodStartAsc' as const,
   PeriodStartDesc: 'PeriodStartDesc' as const,
   TotalCostAsc: 'TotalCostAsc' as const,
   TotalCostDesc: 'TotalCostDesc' as const,
   TotalTokensAsc: 'TotalTokensAsc' as const,
   TotalTokensDesc: 'TotalTokensDesc' as const
}

export const enumUserContactsSortBy = {
   EMAIL: 'EMAIL' as const,
   FIRST_NAME: 'FIRST_NAME' as const,
   LAST_NAME: 'LAST_NAME' as const,
   ORGANIZATION_NAME: 'ORGANIZATION_NAME' as const
}

export const enumUserRoleAssignmentSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumUserSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   EmailAsc: 'EmailAsc' as const,
   EmailDesc: 'EmailDesc' as const,
   FirstNameAsc: 'FirstNameAsc' as const,
   FirstNameDesc: 'FirstNameDesc' as const,
   LastNameAsc: 'LastNameAsc' as const,
   LastNameDesc: 'LastNameDesc' as const
}

export const enumUserStatus = {
   ACTIVE: 'ACTIVE' as const,
   ARCHIVED: 'ARCHIVED' as const
}

export const enumValidationSeverity = {
   error: 'error' as const,
   warning: 'warning' as const
}

export const enumVariableSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NameAsc: 'NameAsc' as const,
   NameDesc: 'NameDesc' as const
}

export const enumViolationSeverity = {
   Error: 'Error' as const,
   Warning: 'Warning' as const
}

export const enumViolationType = {
   AssetState: 'AssetState' as const,
   CapacityExceeded: 'CapacityExceeded' as const,
   LocationConstraint: 'LocationConstraint' as const,
   ServiceIncomplete: 'ServiceIncomplete' as const,
   TaskPrecedence: 'TaskPrecedence' as const
}

export const enumVoucherTemplateSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumWopiFileAction = {
   Convert: 'Convert' as const,
   Edit: 'Edit' as const,
   EditNew: 'EditNew' as const,
   EmbedView: 'EmbedView' as const,
   GetInfo: 'GetInfo' as const,
   Present: 'Present' as const,
   PresentEmbed: 'PresentEmbed' as const,
   View: 'View' as const
}

export const enumWopiPermission = {
   Read: 'Read' as const,
   Write: 'Write' as const
}

export const enumWarehouseCredentialSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const
}

export const enumWeekday = {
   Friday: 'Friday' as const,
   Monday: 'Monday' as const,
   Saturday: 'Saturday' as const,
   Sunday: 'Sunday' as const,
   Thursday: 'Thursday' as const,
   Tuesday: 'Tuesday' as const,
   Wednesday: 'Wednesday' as const
}

export const enumWeightDisplayUnit = {
   PriceUnit: 'PriceUnit' as const,
   ScaleUnit: 'ScaleUnit' as const
}

export const enumWorkOrderInputItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumWorkOrderOutputItemSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   NotesAsc: 'NotesAsc' as const,
   NotesDesc: 'NotesDesc' as const,
   UpdatedAtAsc: 'UpdatedAtAsc' as const,
   UpdatedAtDesc: 'UpdatedAtDesc' as const
}

export const enumWorkOrderSortOption = {
   CreatedAtAsc: 'CreatedAtAsc' as const,
   CreatedAtDesc: 'CreatedAtDesc' as const,
   ScheduledStartDateAsc: 'ScheduledStartDateAsc' as const,
   ScheduledStartDateDesc: 'ScheduledStartDateDesc' as const,
   StatusAsc: 'StatusAsc' as const,
   StatusDesc: 'StatusDesc' as const,
   WorkOrderNumberAsc: 'WorkOrderNumberAsc' as const,
   WorkOrderNumberDesc: 'WorkOrderNumberDesc' as const
}

export const enumWorkOrderStatus = {
   Cancelled: 'Cancelled' as const,
   Completed: 'Completed' as const,
   Draft: 'Draft' as const,
   InProgress: 'InProgress' as const,
   Open: 'Open' as const
}

export const enumZoneStatus = {
   Active: 'Active' as const,
   Archived: 'Archived' as const,
   Closed: 'Closed' as const
}

export const enumZoneType = {
   Aisle: 'Aisle' as const,
   Bin: 'Bin' as const,
   Other: 'Other' as const,
   Shelf: 'Shelf' as const,
   Zone: 'Zone' as const
}
